/*eslint angular/no-private-call: [2,{"allow":["$$route"]}]*/

(function() {
  'use strict';
  var dev = true;
   dev = false; // commentare/scommentare questa istruzione per passare da produzione a sviluppo
  var apiBaseUrl = 'https://clyco-api.g1web.it';
  var bodyClass = 'prod';
  if ( dev ) {
    apiBaseUrl = 'https://g1api.clyco.it';
    bodyClass = 'dev';
  }
  angular.module('g1.core', [
      'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngResource',
      'ngRoute', 'ngMessages', 'mgcrea.ngStrap', 'angular-loading-bar',
      'cfp.loadingBar', 'mwl.calendar', 'datatables', 'datatables.buttons',
      'datatables.columnfilter', 'datatables.light-columnfilter',
      'authenticate.js', 'jcs-autoValidate', 'monospaced.elastic',
      'googlechart', 'angular-logger-max', 'ngFileUpload',
      'angular.bind.notifier', 'angular-toArrayFilter', 'GoogleMapsNative',
      'dndLists', 'rzModule', 'ngTagsInput', 'signature'
    ])
    .constant( 'apiBaseUrl', apiBaseUrl )
    .constant( 'bodyClass', bodyClass )
    .constant( 'pvStageNonAssegnato', 18 )
    .constant( 'pvStageAssegnato', 19 )
    .config(httpConfig)
    .config(routeConfig)
    .config(cfpLoadingBarConfig)
    .config(angularStrapConfig)
    .config(angularBootstrapCalendarConfig)
    .config(gmLibraryConfig)
    .run(dtDefaultsRun)
    .run(autoValidateRun)
    //.run(catchRefresh)
    .run( function ( $document ) {
      // textarea e campi html (g1-rich-text, contenteditable)
      $document.on( 'keydown', 'textarea, [contenteditable="true"]', function ( event ) {
        if ( ( event.ctrlKey || event.metaKey ) && event.key && event.key == 'Enter' ) { // ctrl + invio
          event.preventDefault(); // evita che il contenteditable inserisca un a capo
          angular.element( event.currentTarget ).closest( 'form' ).find( '[type="submit"]' ).trigger( 'click' );
        }
      } );
    } )
    .run(jsInit)
    .run( ['$rootScope', function ( $rootScope ) {
      var $rootScopeOn = $rootScope;
      $rootScope.env = bodyClass;
      $rootScopeOn.$on('$routeChangeSuccess', function ( event, current ) {
        var title = 'Clyco G1';
        if ( current.$$route && current.$$route.title  ) {
          title += ' - ' + current.$$route.title;
        }
        $rootScope.title = title;
      } );
    }])
    .directive('copyToClipboard', function ($alert) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          elem.on('click', function ( e ) {
            e.preventDefault();
            if (attrs.copyToClipboard) {
              navigator.clipboard.writeText(attrs.copyToClipboard);
              $alert( {
                title: 'Copia OK!',
                content: 'Testo copiato correttamente!',
                placement: 'top-left paste',
                dismissable: false,
                type: 'success',
                duration: 5,
                show: true
              } );
            }
          });
        }
      };
    } )
  ;

  //////////////////////////////////////////////////////////////////////////////
  /** configs */
  function httpConfig($httpProvider) {
    /** CORS compatibility and Session Enable */
    $httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.withCredentials = true;

    /** register my http interceptor */
    $httpProvider.interceptors.push('myHttpInterceptor');
  }

  function routeConfig($routeProvider, AuthenticateJSProvider, apiBaseUrl) {
    /** routing */
    $routeProvider
      .when('/login', {
        templateUrl: 'app/core/login/login.html',
        security: false,
        title: 'Login'
      })
      .when('/', {
        template: ' ',
        controller: 'MainController',
        controllerAs: 'main',
        security: true,
        title: 'Home'
      })
      .when('/clienti', {
        templateUrl: 'app/core/clienti/clienti.html',
        controller: 'ClientiController',
        controllerAs: 'clienti',
        security: true,
        title: 'Clienti'
      })
      .when('/clienti/dati', {
        templateUrl: 'app/core/clienti/dati-clienti.html',
        controller: 'DatiClientiController',
        controllerAs: 'datiClienti',
        security: true,
        title: 'Clienti / Dati Clienti'
      })
      .when('/clienti/:id', {
        templateUrl: 'app/core/clienti/cliente-view.html',
        controller: 'ClienteViewController',
        controllerAs: 'cw',
        security: true,
        title: 'Dettaglio Cliente'
      })
      .when('/opportunita', {
        templateUrl: 'app/core/opportunita/opportunita.html',
        controller: 'OpportunitaController',
        controllerAs: 'opportunita',
        security: true,
        title: 'Opportunità'
      })
      .when('/opportunita/progetti', {
        templateUrl: 'app/core/opportunita/progetti/progetti.html',
        controller: 'OpportunitaProgettiController',
        controllerAs: 'opc',
        security: 'COORD',
        title: 'Opportunità / Progetti'
      })
      .when('/opportunita/:id', {
        templateUrl: 'app/core/opportunita/opportunita-view.html',
        controller: 'OpportunitaViewController',
        controllerAs: 'ovc',
        security: true,
        title: 'Opportunità'
      })
      .when('/contratti', {
        templateUrl: 'app/core/contratti/contratti.html',
        controller: 'ContrattiController',
        controllerAs: 'contratti',
        security: true,
        title: 'Contratti'
      })
      .when('/appuntamenti', {
        templateUrl: 'app/core/appuntamenti/appuntamenti.html',
        controller: 'AppuntamentiController',
        controllerAs: 'appuntamenti',
        security: true,
        title: 'Appuntamenti'
      })
      .when('/appuntamenti/agenda', {
        templateUrl: 'app/core/appuntamenti/agenda.html',
        controller: 'AgendaController',
        controllerAs: 'agenda',
        security: true,
        title: 'Agenda'
      })
      .when('/reports', {
        templateUrl: 'app/core/reports/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        security: true,
        title: 'Reports'
      })
      .when('/reports/:repId', {
        templateUrl: 'app/core/reports/report.html',
        controller: 'ReportController',
        controllerAs: 'report',
        security: true,
        title: 'Reports'
      })
      .when('/reports/charts/:chartId', {
        templateUrl: 'app/core/charts/chart.html',
        controller: 'ChartController',
        controllerAs: 'chart',
        security: true,
        title: 'Grafici'
      })
      .when('/provvigioni', {
        templateUrl: 'app/core/provvigioni/provvigioni.html',
        controller: 'ProvvigioniController',
        controllerAs: 'provvigioni',
        security: true,
        title: 'Provvigioni'
      })
      .when('/provvigioni/calcola', {
        templateUrl: 'app/core/provvigioni/provvigioni-calcola.html',
        controller: 'ProvvigioniCalcolaController',
        controllerAs: 'pCalcola',
        security: true,
        title: 'Calcola Provvigioni'
      })
      .when('/provvigioni/calcolate', {
        templateUrl: 'app/core/provvigioni/provvigioni-calcolate.html',
        controller: 'ProvvigioniCalcolateController',
        controllerAs: 'pCalcolate',
        security: true,
        title: 'Provvigioni Calcolate'
      })
      .when('/promemoria', {
        templateUrl: 'app/core/promemoria/promemoria.html',
        controller: 'PromemoriaController',
        controllerAs: 'vm',
        security: true,
        title: 'Promemoria'
      })
      .when('/incomingCall/:numtel', {
        templateUrl: 'app/core/incoming-call/incoming-call.html',
        controller: 'IncomingCallController',
        controllerAs: 'icc',
        security: true,
        title: 'Chiamata in entrata'
      })
      .when('/test', {
        templateUrl: 'app/core/test/test.html',
        controller: 'TestController',
        controllerAs: 'test',
        security: false,
        title: 'Test'
      })
      .when('/404', {
        templateUrl: 'app/core/shared/404.html',
        security: false,
        title: 'Not Found'
      })
      .otherwise('/')
    ;

    /** auth interceptor config */
    AuthenticateJSProvider.setConfig({
      host: apiBaseUrl,               // your base api url
      loginUrl: '/auth/login',        // login api url (post)
      logoutUrl: '/auth/logout',      // logout api url (get)
      loggedinUrl: '/auth/loggedin',  // api to get the user profile and roles (get)

      unauthorizedPage: '/',          // url (frontend) of the unauthorized page
      targetPage: '/',                // url (frontend) of the target page on login success
      loginPage: '/login'             // url (frontend) of the login page
    });
  }

  function cfpLoadingBarConfig(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner-wrapper"><div id="loading-bar-spinner"><i class="fa fa-spinner fa-5x fa-spin text-primary"></i></div></div>';
  }

  function angularStrapConfig(
    $navbarProvider, $dropdownProvider, $tooltipProvider, $popoverProvider,
    $datepickerProvider, $timepickerProvider, $selectProvider
  ) {
    /** navbar defaults */
    angular.extend($navbarProvider.defaults, {
      strict: true
    });

    /** dropdown defaults */
    angular.extend($dropdownProvider.defaults, {
      html: true
    });

    /** tooltip defaults */
    angular.extend($tooltipProvider.defaults, {
      html: true
    });

    /** popover defaults */
    angular.extend($popoverProvider.defaults, {
      html: true
    });

    /** datepicker defaults */
    angular.extend($datepickerProvider.defaults, {
      // dateFormat: 'shortDate',
      dateFormat: 'dd/MM/yyyy',
      autoclose: true,
      startWeek: 1
    });

    /** timepicker defaults */
    angular.extend($timepickerProvider.defaults, {
      timeFormat: 'shortTime',
      length: 4,
      minuteStep: 15,
      roundDisplay: true
    });

    /** select defaults */
    angular.extend($selectProvider.defaults, {
      html: true,
      allText: 'Tutti',
      noneText: 'Nessuno',
      maxLengthHtml: 'selezionati',
      placeholder: 'Scegli delle opzioni...',
      iconCheckmark: 'fa fa-check'
    });
  }

  function angularBootstrapCalendarConfig(calendarConfig) {
    calendarConfig.showTimesOnWeekView = false;
    calendarConfig.templates.calendarMonthCellEvents = 'app/components/angular-bootstrap-calendar/calendarMonthCellEvents.html';
    calendarConfig.templates.calendarWeekView = 'app/components/angular-bootstrap-calendar/calendarWeekView.html';
  }

  function gmLibraryConfig(gmLibraryProvider) {
    gmLibraryProvider.configure({
      language: 'it',
      key: 'AIzaSyDHyWzVkYfu0O_I-wXaWlLM1p7f1suTue4'
    });
  }

  /** runs */
  function dtDefaultsRun(DTDefaultOptions) {
    DTDefaultOptions.setOption('autoWidth', false);

    DTDefaultOptions.setOption('columnDefs', [
      {
        targets: '_all',
        defaultContent: '',
        'class': 'min-width'
      }
    ]);
  }

  function autoValidateRun(defaultErrorMessageResolver, validator, g1Bootstrap3ElementModifier) {
    /** set language */
    defaultErrorMessageResolver.setI18nFileRootPath('app/core/i18n');
    defaultErrorMessageResolver.setCulture('it-it');

    /** disable styling for valid elements */
    validator.setValidElementStyling(false);

    /** replace standard bs3 modifier */
    validator.registerDomModifier(g1Bootstrap3ElementModifier.key, g1Bootstrap3ElementModifier);
    validator.setDefaultElementModifier(g1Bootstrap3ElementModifier.key);
  }

  /*
  function catchRefresh($rootScope, $document) {
    $document.on('keydown.refresh', onRefresh);

    function onRefresh(event) {
      switch (event.keyCode) {
        case 116 : //F5 button
          event.preventDefault();
          event.returnValue = false;
          event.keyCode = 0;
          $rootScope.$broadcast('document.refresh', event);
          return false;

        case 82 : //R button
          if (event.ctrlKey) { //CTRL button modifier
            event.preventDefault();
            event.returnValue = false;
            event.keyCode = 0;
            $rootScope.$broadcast('document.refresh', event);
            return false;
          }
      }
    }
  }
  */

  function jsInit($window) {
    $window.toggleHideExtra = toggleHideExtra;

    ////////////////////////////////////////////////////////////////////////////
    function toggleHideExtra(element) {
      angular.element(element).toggleClass('inner');
    }
    $window.onbeforeunload = function ( e ) {
      var richiediConferma = ( angular.element( 'form.dataForm.ng-dirty' ).length > 0 );
      if ( dev || ! richiediConferma ) {
        return;
      }
      e.cancelBubble = true;
      e.returnValue = 'Vuoi realmente abbandonare la pagina?';
      if ( e.stopPropagation ) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }

})();
(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProgettoLogUpdateController', ProgettoLogUpdateController);

  function ProgettoLogUpdateController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var progettoLogUpdateModal = $modal( {
      scope: $scope,
      templateUrl: 'progetto-log-update-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.log = {};
    vm.saveForm = saveForm;

    $scope.$on( 'updateLogProgetto', updateLogProgetto );

    ////////////////////////////////////////////////////////////////////////////
    function updateLogProgetto( event, id ) {
      api.opportunita().progetti().log( id ).get()
        .then(showModal);

      function showModal(log) {
        vm.log = log;

        progettoLogUpdateModal.$promise
          .then( progettoLogUpdateModal.show );
      }
    }

    function saveForm() {
      api.opportunita().progetti().log( vm.log.id ).update( vm.log )
        .then( progettoLogUpdateModal.hide );
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProgettoLogController', ProgettoLogController);

  function ProgettoLogController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var progettoLogModal = $modal( {
      scope: $scope,
      templateUrl: 'progetto-log-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.log = {};

    $scope.$on( 'readLogProgetto', readLogProgetto );

    ////////////////////////////////////////////////////////////////////////////
    function readLogProgetto( event, id ) {
      api.opportunita().progetti().log( id ).get()
        .then(showModal);

      function showModal( log ) {
        vm.log = log;
        progettoLogModal.$promise
          .then( progettoLogModal.show );
      }
    }
  }
})();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'RapportinoCreateController', function ( $rootScope, $modal, $scope, api ) {

    var vm = this;
    vm.rapportino = {};
    vm.action = '';

    var modalRapportino = $modal( {
      scope: $scope,
      templateUrl: 'rapportino-edit.tpl.html',
      backdrop: false,
      show: false
    } );

    $scope.$on( 'editRapportino', function ( event, idRapportino, idPostvendita ) {
      if ( idRapportino ) {
        vm.action = 'update';
        api.pv().rapportino( idRapportino ).get().then( function ( rapportino ) {
          vm.rapportino = rapportino;
          modalRapportino.show();
        } );
      } else {
        var rapportino = {};
        rapportino.idPostvendita = idPostvendita;
        vm.action = 'create';
        api.pv( idPostvendita ).attivita().list( {senzaRapportino:1} ).then( function ( attivita ) {
          rapportino.descrizioneAttivitaSvolte = '';
          for ( var i = 0; i < attivita.length; i++ ) {
            rapportino.descrizioneAttivitaSvolte += attivita[i].descrizioneAttivita + '\n';
          }
          vm.rapportino = rapportino;
          modalRapportino.show();
        } );
      }
    } );

    vm.saveForm = function () {
      if ( vm.action == 'create' ) {
        api.pv().rapportini().save( vm.rapportino ).then( function ( rapportino ) {
          $rootScope.$broadcast( 'Rapportino.updated', rapportino );
          modalRapportino.hide();
        }, setAlerts );
      } else {
        api.pv().rapportino( vm.rapportino.idRapportino ).update( vm.rapportino ).then( function ( rapportino ) {
          $rootScope.$broadcast( 'Rapportino.updated', rapportino );
          modalRapportino.hide();
        }, setAlerts );
      }
    }

    vm.createAttivitaPv = function () {
      api.pv( vm.rapportino.idPostvendita ).get().then( function ( pv ) {
        $rootScope.$broadcast( 'createAttivitaPv', pv );
      } );
    };

    function setAlerts( response ) {
      vm.alerts = {
        status: response.status,
        messages: response.data.warnings
      };
    }

  } );

} )();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'FirmaController', function ( $modal, $scope, $rootScope, $window, api, apiBaseUrl ) {
    var vm = this;
    vm.inserisciNoteCliente = false;
    vm.timestamp = Date.now();
    var modalFirma = $modal( {
      scope: $scope,
      templateUrl: 'firma.tpl.html',
      backdrop: false,
      show: false,
      height: '400px'
    } );
    angular.element( $window ).on( 'resize', function () {
      angular.element( '.signature canvas' ).css( {
        width: 'unset',
        height: 'unset'
      } );
    } );
    vm.rapportino = {
    };
    $scope.$on( 'firmaRapportino', function ( event, idRapportino ) {
      vm.idRapportino = idRapportino;
      api.pv().rapportino( idRapportino ).get().then( function ( rapportino ) {
        rapportino.previewPath = rapportino.filename.replace( 'pdf', 'png' );
        vm.rapportino.idRapportino = rapportino.idRapportino;
        vm.rapportino.idPostvendita = rapportino.idPostvendita;
        vm.rapportino.idTecnico = rapportino.idTecnico;
        vm.rapportino.noteCliente = rapportino.noteCliente;
        vm.rapportino.noteTecnico = rapportino.noteTecnico;
        vm.rapportino.filename = null;
        vm.rapportino.tipoFirma = rapportino.tipoFirma;
        vm.rapportino.firmatoCliente = rapportino.firmatoCliente;
        vm.rapportino.fileScaricatoPerFirmaAnalogica = rapportino.fileScaricatoPerFirmaAnalogica;
        vm.inserisciNoteCliente = rapportino.noteCliente != '';
        vm.inserisciNoteTecnico = false;
        modalFirma.show();
        $scope.$on( 'modal.show', function () {
          angular.element( '#rapportinoPreviewImg' ).attr( 'src', apiBaseUrl + '/tickets/rapportino-png/' + idRapportino + '?ver=' + vm.timestamp );
        } );
      } );
    } );
    vm.toggleAzioni = function () {
      vm.mostraAzioni = ! vm.mostraAzioni;
    }
    vm.scaricaPdf = function () {
      vm.rapportino.fileScaricatoPerFirmaAnalogica = 1;
      api.pv().rapportino( vm.rapportino.idRapportino ).update( vm.rapportino ).then( function ( rapportino ) {
        $rootScope.$broadcast( 'Rapportino.updated', rapportino );
        modalFirma.hide();
        $window.open( apiBaseUrl + '/tickets/rapportino-pdf/' + vm.rapportino.idRapportino + '?download=' + vm.timestamp );
      } );
    }
    vm.saveForm = function ( firma ) {
      if ( vm.rapportino.tipoFirma == 'analogica' ) {
        var file = vm.rapportino.filename;
        file.upload = api.pv().rapportino( vm.rapportino.idRapportino ).update( vm.rapportino ).then( function ( rapportino ) {
          $rootScope.$broadcast( 'Rapportino.updated', rapportino );
          modalFirma.hide();
        }, setAlerts, uploadProgress);
      } else {
        if ( vm.rapportino.tipoFirma == 'digitale' ) {
          vm.rapportino.firmaImgData = firma.dataUrl;
          vm.rapportino.fileScaricatoPerFirmaAnalogica = 0;
        }
        api.pv().rapportino( vm.rapportino.idRapportino ).update( vm.rapportino ).then( function ( rapportino ) {
          $rootScope.$broadcast( 'Rapportino.updated', rapportino );
          modalFirma.hide();
        } );
      }
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
      function uploadProgress(event) {
        file.progress = Math.min(100, parseInt(100.0 * event.loaded / event.total));
      }
    }
  } );

} )();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller('AttivitaPvController', function ( $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api ) {
    var vm = this;

    var AttivitaPvModal = $modal( {
      scope: $scope,
      templateUrl: 'attivita-pv-read-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.pv = {};
    vm.dtAttivita = {};

    $scope.$on( 'readAttivitaPv', readAttivitaPv );

    ////////////////////////////////////////////////////////////////////////////

    function readAttivitaPv( event, idPv ) {
      api
        .pv(idPv)
        .get()
        .then( function getAttivita( pv ) {
          vm.pv = pv;
          dtAttivita( idPv );
          AttivitaPvModal.$promise.then( AttivitaPvModal.show );
        } );
    }

    function dtAttivita( idPv ) {
      vm.dtAttivita.dtInstance = {};
      vm.dtAttivita.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
        .fromFnPromise( function() {
          return api.pv( idPv ).attivita().list();
        } )
        .withOption( 'pageLength', 25 )
        .withOption( 'order', [0, 'desc'] )
      );
      vm.dtAttivita.dtColumns = [
        {
          data: 'dataIns',
          title: 'Inizio',
          render: dtFactory.renders.datetime
        },
        {
          data: 'dataFine',
          title: 'Fine',
          render: dtFactory.renders.datetime
        },
        {
          data: 'durata',
          title: 'Durata'
        },
        {
          data: 'inSede',
          title: 'c/o cliente',
          render: dtFactory.renders.boolean
        },
        {
          data: 'chiusura',
          title: 'Chiusura',
          render: dtFactory.renders.boolean
        },
        {
          data: 'soggetto',
          title: 'Assegnato'
        },
        {
          data: 'descrizioneAttivita',
          title: 'Attività',
          'class': '',
          render: dtFactory.renders.longtext
        }
      ];
    }
  } );

} )();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'AttivitaEditController', function ( $rootScope, $scope, AuthenticateJS, $modal, $timeout, api ) {
    var vm = this;
    var attivitaEditModal = $modal( {
      scope: $scope,
      templateUrl: 'attivita-pv-edit-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    $scope.$on( 'modal.hide.before', function( event ) {
      if ( ! vm.closeModal && angular.element( '[name="AttivitaEditForm"]' ).is( '.ng-dirty' ) ) {
        vm.closeOnDirty = true;
        event.preventDefault();
      }
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.pv = {};
    vm.attivita = {};
    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.inSedeChange = function ( ) {
      if ( vm.attivita.inSede ) {
        vm.attivita.includiInRapportino = true;
      }
    }

    $scope.$on( 'updateAttivitaPv', updateAttivitaPv );
    $scope.$on( 'createAttivitaPv', createAttivitaPv );

    ////////////////////////////////////////////////////////////////////////////

    function updateAttivitaPv( event, idAttivita ) {
      vm.action = 'update';
      vm.closeModal = false;
      vm.closeOnDirty = false;
      api.pv().attivita().editForm().then( function ( formData ) {
        vm.formData = formData;
        api.pv().attivita( idAttivita ).get().then( function ( attivita ) {
          vm.attivita = attivita;
          api.pv( attivita.idPostvendita ).get().then( function ( pv ) {
            vm.pv = pv;
            attivitaEditModal.$promise.then( attivitaEditModal.show );
          } );
        } );
      } );
    }

    function createAttivitaPv( event, pv ) {
      vm.action = 'create';
      vm.closeModal = false;
      vm.closeOnDirty = false;
      api.pv().attivita().editForm().then( function ( formData ) {
        vm.formData = formData;
        api.pv( pv.idPostvendita ).get().then( function ( pv ) {
          vm.pv = pv;
          vm.attivita = {
            'idSoggetto' : vm.user.idAgente,
            'includiInRapportino': false,
            'dataIns' : new Date( Date.now() - 5 * 60 * 1000 ), // defaullt: 5 minuti fa
            'dataFine' : new Date( Date.now() )
          };
          attivitaEditModal.$promise.then( attivitaEditModal.show );
        } );
      } );
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      var afterSaveFn = function () {
        vm.closeModal = true;
        attivitaEditModal.hide();
        $rootScope.$broadcast( 'Pv.updated', vm.pv );
        $rootScope.$broadcast( 'Attivita.updated', vm.pv );
      }
      if ( vm.action === 'create' ) {
        api
          .pv( vm.pv.idPostvendita )
          .attivita( vm.attivita.idAttivita )
          .save( vm.attivita )
          .then( afterSaveFn, setAlerts );
      } else if ( vm.action === 'update' ) {
        api
          .pv()
          .attivita( vm.attivita.idAttivita )
          .update( vm.attivita )
          .then( afterSaveFn, setAlerts );
      }

      //////////////////////////////////////////////////////////////////////////

      function setAlerts( response ) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      attivitaEditModal.hide();
    }

    vm.copiaDataInsToDataFine = function () {
      var dataIns = new Date( vm.attivita.dataIns );
      var dataFine = new Date( vm.attivita.dataFine );
      var date = dataIns.toISOString().split('T')[0]; // data da dataIns
      var time = dataFine.toISOString().split('T')[1]; // ora da dataFine
      vm.attivita.dataFine = new Date( date + 'T' + time );
    }

  } );

} )();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProgettoReadController', ProgettoReadController)

  function ProgettoReadController(
      $rootScope, $scope, AuthenticateJS, $modal,
      DTOptionsBuilder, dtFactory, api, apiBaseUrl
    ) {
    var vm = this;
    var progettoReadModal = $modal( {
      scope: $scope,
      templateUrl: 'progetto-read-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = [];
    vm.formData = {};
    vm.cliente = {};

    vm.progettistaMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveProgettista = function () {
      api.opportunita().progetti( vm.progetto.idProgetto ).update( vm.progetto )
      .then( function () {
        vm.progettistaMode = 'view'; // ripristino modalità di visualizzazione
      } );
    }

    vm.statoProgettoMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveStatoProgetto = function () {
      api.opportunita().progetti( vm.progetto.idProgetto ).update( vm.progetto )
      .then( function () {
        vm.statoProgettoMode = 'view'; // ripristino modalità di visualizzazione
      } );
    }

    vm.faseMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveFase = function () {
      api.opportunita().progetti( vm.progetto.idProgetto ).update( vm.progetto )
      .then( function ( progetto ) {
        vm.faseMode = 'view'; // ripristino modalità di visualizzazione
        if ( progetto.finalStage ) {
          $rootScope.$broadcast( 'confermaAvanzamentoFase', progetto );
        }
      } );
    }

    vm.progetto = {};
    vm.datiMail = {};
    vm.checkEditPermission = function () {
      return vm.user.flags.gestProg;
    }

    vm.updateProgetto = api.opportunita().progetti().actions.update;
    vm.sendProgetto = api.opportunita().progetti().actions.send;
    vm.deleteProgetto = api.opportunita().progetti().actions.delete;

    vm.readCliente = api.clienti.actions.read;
    vm.readOpportunita = api.opportunita().actions.read;

    //attivita
    vm.dtAttivita = {};
    vm.attivita = [];
    vm.titleAttivita = 'Attività';

    vm.createAttivita = function ( idTipo ) {
      var attivita = angular.copy( vm.progetto );
      attivita.idTipo = idTipo; // inserimento bloccato su attività generica
      attivita.id = vm.progetto.idOpportunita; // l'oggetto che passo deve avere la stessa struttura...
      $rootScope.$broadcast( 'createAttivitaOpportunitaPerTipo', attivita );
    };
    vm.readAttivita = api.opportunita().attivita().actions.read;
    vm.updateAttivita = api.opportunita().attivita().actions.update;
    vm.deleteAttivita = api.opportunita().attivita().actions.delete;

    //allegati
    vm.dtAllegati = {};
    vm.allegati = [];
    vm.titleAllegati = 'Allegati';

    vm.createAllegato = function ( progetto ) {
      $rootScope.$broadcast( 'createAllegato', progetto );
    };
    vm.updateAllegato = api.allegati.actions.update;
    vm.deleteAllegato = api.allegati.actions.delete;

    // gestione progetto
    $scope.$on( 'readProgetto', readProgetto );
    $scope.$on( 'Progetto.updated', progettoReload ) ;

    // gestione attivita
    $scope.$watchCollection( 'prc.attivita', setTitleAttivita );
    $scope.$on( 'AttivitaOpportunita.created', dtAttivitaReload );
    $scope.$on( 'AttivitaOpportunita.updated', dtAttivitaReload );
    $scope.$on( 'AttivitaOpportunita.deleted', dtAttivitaReload );

    //gestione logs
    $scope.$on( 'LogProgetto.updated', dtLogsReload );
    $scope.$on( 'Opportunita.sended', dtAttivitaReload );

    // gestione allegati
    $scope.$watchCollection('prc.allegati', setTitleAllegati);

    $scope.$on('Allegato.created', dtAllegatiReload);
    $scope.$on('Allegato.updated', dtAllegatiReload);
    $scope.$on('Allegato.deleted', dtAllegatiReload);

    $scope.$on( 'afterAvanzamentoFaseOpportunita', function ( event, opportunita ) {
      vm.progetto.faseOpportunita = opportunita.stage;
    } );

    //attivita
    vm.dtLogs = {};
    vm.logs = [];

    vm.readLogProgetto = api.opportunita().progetti().logs.actions.read;
    vm.updateLogProgetto = api.opportunita().progetti().logs.actions.update;

    ////////////////////////////////////////////////////////////////////////////

    function generaAzioni( progetto ) {
      //gestione dati email
      vm.datiMail.oggetto = 'Progetto ' + progetto.cliente;
      vm.datiMail.cc = vm.user.contacts.email;
      if ( progetto.seguimi ) {
        api.soggetto( progetto.idAgentePIC ).get().then( function ( soggetto ) {
          if ( soggetto.email !== vm.datiMail.cc ) {
            vm.datiMail.cc += ',' + soggetto.email;
          }
        } );
      }
      //gestione azioni
      var actions = [];
      var availableActions = {
        updateProgetto: {
          text: '<i class="fa fa-pencil fa-fw"></i> Modifica',
          click: 'prc.updateProgetto( prc.progetto.idProgetto );'
        },
        sendProgetto: {
          text: '<i class="fa fa-mail-forward fa-fw"></i> Invia Mail',
          click: 'prc.sendProgetto( prc.progetto.idProgetto, prc.datiMail );'
        }
      };
      if ( vm.checkEditPermission( vm.user, progetto ) ) {
        actions.push( availableActions.updateProgetto );
        actions.push( availableActions.sendProgetto );
      }
      return actions;
    }

    function readProgetto( event, idProgetto ) {
      api.opportunita().progetti( idProgetto ).get().then( function ( progetto ) {
        vm.progetto = progetto;
        vm.azioni = generaAzioni( progetto );
        api.opportunita().progetti().editForm( {
          idProgetto: idProgetto
        } ).then( function ( formData ) {
          vm.formData = formData;
          //load tabelle
          dtAttivita( idProgetto );
          dtAllegati( idProgetto );
          dtLogs( idProgetto );
          progettoReadModal.$promise.then( progettoReadModal.show );
        } );
      } );
    }

    function progettoReload( event, progetto ) {
      vm.progetto = progetto;
      dtAttivitaReload();
      dtLogsReload();
    }

    // gestione attivita
    function dtAttivita( idProgetto ) {
      vm.dtAttivita.instance = {};
      vm.dtAttivita.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.opportunita().progetti( idProgetto ).attivita.list();
          promise.then( function ( attivita ) {
            vm.attivita = attivita;
          } );
          return promise;
        } )
        .withOption( 'order', [0, 'desc'] )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
      );
      vm.dtAttivita.columns = [
        {
          data: 'dataOraAttivita',
          title: 'Data',
          class: 'col-date-time',
          render: renderDataOra
        },
        {
          data: 'tipo',
          title: 'Tipo',
          class: 'col-categoria'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          class: ''
        },
        {
          data: 'soggetto',
          title: 'Soggetto',
          class: 'col-user-fullname'
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'col-actions text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////

      function renderDataOra(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.datetime(data, type);
          data = '<a ng-click="prc.readAttivita(\'' + row.id + '\')">' + data + '</a>';
        } else if (type === 'filter') {
          data = dtFactory.renders.datetime(data, type);
        }

        return data;
      }

      function renderActions( data ) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="prc.updateAttivita(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="prc.deleteAttivita(' + data + ')"><i class="fa fa-minus"></i></button>';
        return '<div ng-if="prc.progetto.idStatoProgetto!=\'2\'">' + upd + ' ' + del + '</div>';
      }

      function renderActionsTitle() {
        return '\
          <div ng-if="prc.progetto.idStatoProgetto==\'1\'">\
            <button\
              type="button"\
              class="btn btn-success btn-xs"\
              bs-dropdown\
              data-placement="left"><i class="fa fa-plus"></i></button>\
            <ul class="dropdown-menu" role="menu">\
              <li><a ng-click="prc.createAttivita(\'1\')">Attività generica</a></li>\
              <li><a ng-click="prc.createAttivita(\'3\')">Telefonata</a></li>\
              <li><a ng-click="prc.createAttivita(\'4\')">Email</a></li>\
            </ul>\
          </div>';
      }

    }

    function dtAttivitaReload() {
      if ( ! _.isEmpty( vm.dtAttivita.instance ) ) {
        vm.dtAttivita.instance.reloadData();
      }
    }

    function setTitleAttivita( attivita ) {
      if ( attivita ) {
        vm.titleAttivita = 'Attività';
        if ( attivita.length > 0 ) {
          vm.titleAttivita += ' <span class="badge">' + attivita.length + '</span>';
        }
      }
    }

    // gestione allegati
    function dtAllegati( idProgetto ) {
      vm.dtAllegati.instance = {};
      vm.dtAllegati.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.allegati.list( {
            idProgetto: idProgetto
          } );
          promise.then( function ( allegati ) {
            vm.allegati = allegati;
          } );
          return promise;
        } )
        .withOption( 'order', [0, 'desc'] )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
      );
      vm.dtAllegati.columns = [
        {
          data: 'dataOraIns',
          title: 'Data',
          class: 'col-date-time',
          render: dtFactory.renders.datetime
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          class: ''
        },
        {
          data: 'tipo',
          title: 'Tipo',
          class: 'col-categoria'
        },
        {
          data: 'note',
          title: 'Note Allegato',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'col-actions text-center vertical-align-middle',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////

      function renderActionsTitle() {
        return '\
          <button\
            type="button"\
            class="btn btn-success btn-xs"\
            title="Inserisci"\
            ng-if="prc.progetto.idStatoProgetto!=\'2\'"\
            ng-click="prc.createAllegato(prc.progetto)"><i class="fa fa-plus"></i> Inserisci</button>';
      }

      function renderActions( data ) {
        var actions = '';
        var prv = '<a href="' + apiBaseUrl + '/allegati/' + data + '?preview" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Anteprima"><i class="fa fa-eye"></i></a>';
        var dwn = '<a href="' + apiBaseUrl + '/allegati/' + data + '?download" target="_blank" class="btn btn-primary btn-xs" title="Scarica"><i class="fa fa-download"></i></a>';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="prc.updateAllegato(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="prc.deleteAllegato(' + data + ')"><i class="fa fa-minus"></i></button>';
        actions = prv + ' ' + dwn + '<span ng-if="prc.progetto.idStatoProgetto==\'1\'"> ' + upd + ' ' + del + '</span>';
        return actions;
      }

    }

    function dtAllegatiReload() {
      if (!_.isEmpty(vm.dtAllegati.instance)) {
        vm.dtAllegati.instance.reloadData();
      }
    }

    function setTitleAllegati( allegati ) {
      if ( allegati ) {
        if ( allegati.length > 0 ) {
          vm.titleAllegati = 'Allegati <span class="badge">' + allegati.length + '</span>';
        } else {
          vm.titleAllegati = 'Allegati';
        }
      }
    }

    function dtLogs( idProgetto ) {
      vm.dtLogs.instance = {};
      vm.dtLogs.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.opportunita().progetti().logs.list( {
            idProgetto: idProgetto
          } );
          promise.then( function ( logs ) {
            vm.logs = logs;
          } );
          return promise;
        } )
        .withOption( 'order', [0, 'desc'] )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
      );
      vm.dtLogs.columns = [
        {
          data: 'dataOraIns',
          title: 'Fino al',
          class: 'col-date-time',
          render: renderDataOra
        },
        {
          data: 'stage',
          title: 'Fase',
          class: 'col-categoria'
        },
        {
          data: 'noteLog',
          title: 'Note Storico',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          'class': 'col-actions text-center',
          orderable: false,
          searchable: false
        }
      ];

      function renderDataOra(data, type, row) {
        if ( type === 'display' ) {
          data = dtFactory.renders.datetime( data, type );
          data = '<a bs-tooltip data-title="Visualizza log" ng-click="prc.readLogProgetto(\'' + row.id + '\')">' + data + '</a>';
        } else if ( type === 'filter' ) {
          data = dtFactory.renders.datetime( data, type );
        }
        return data;
      }

      //////////////////////////////////////////////////////////////////////////

      function renderActions( data ) {
        return '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="prc.updateLogProgetto(' + data + ')"><i class="fa fa-pencil"></i></button>';
      }

    }

    function dtLogsReload() {
      if ( ! _.isEmpty( vm.dtLogs.instance ) ) {
        vm.dtLogs.instance.reloadData();
      }
    }

  }

} )();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'ProgettoEditController', function ( $rootScope, $scope, AuthenticateJS, $modal, api ) {
    var vm = this;

    var progettoEditModal = $modal( {
      scope: $scope,
      templateUrl: 'progetto-edit-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.progetto = {
      idStage: 7
    };
    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on( 'updateProgetto', updateProgetto );

    ////////////////////////////////////////////////////////////////////////////

    function updateProgetto( event, idProgetto ) {
      vm.action = 'update';
      vm.alerts = [];
      api.opportunita().progetti( idProgetto ).get().then( function ( progetto ) {
        vm.progetto = progetto;
        api.opportunita().progetti().editForm( {
          idProgetto: idProgetto
        } ).then( function ( formData ) {
          vm.formData = formData;
          progettoEditModal.$promise.then( progettoEditModal.show );
        } );
      } );
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if ( vm.action === 'update' ) {
        api.opportunita().progetti( vm.progetto.idProgetto ).update( vm.progetto ).then( function ( progetto ) {
          $rootScope.$broadcast( 'Progetto.updated', progetto );
          progettoEditModal.hide();
        }, setAlerts );
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts( response ) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      progettoEditModal.hide();
    }

  } );

} )();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaProgettiController', OpportunitaProgettiController);

  function OpportunitaProgettiController($rootScope, $scope, $filter, AuthenticateJS, $aside, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var dashboardProgettiAside = $aside( {
      scope: $scope,
      templateUrl: 'dashboard-progetti-aside.tpl.html',
      placement: 'left',
      animation: 'am-slide-left',
      container: 'body',
      backdrop: 'static',
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.activeTab = (vm.user.flags.gestProg ? 'dashboard' : 'ricerca');
    vm.dt = {
      show: false
    };
    vm.checkEditPermission = function () {
      return vm.user.flags.gestProg;
    }

    //ricerca
    vm.alerts = {};
    vm.so = searchDefaultValues();
    vm.search = search;
    vm.resetForm = resetForm;

    //dashboard
    vm.alertsK = {};
    vm.sok = {
      idProgettista: vm.user.idAgente,
      idStatoProgetto: 1
    };
    vm.sokNA = {
      idProgettista: 'NULL',
      idStatoProgetto: 1
    };
    vm.kanban = {};
    vm.kanbanSomma = 0;
    vm.kanbanTotale = 0;
    vm.kanbanFilter = '';
    vm.nonAssegnati = 0;
    vm.onDrop = onDrop;
    vm.showAside = showAside;
    vm.searchKanban = searchKanban;
    vm.resetKanban = resetKanban;
    vm.unsetFilter = unsetFilter;
    vm.toggleNonAssegnati = toggleNonAssegnati;
    vm.readProgetto = function ( idProgetto ) {
      if ( vm.user.flags.gestProg ) {
        return api.opportunita().progetti().actions.read( idProgetto );
      }
    }

    vm.readCliente = api.clienti.actions.read;
    vm.readOpportunita = api.opportunita().actions.read;
    vm.readProgetto = api.opportunita().progetti().actions.read;
    vm.updateProgetto = api.opportunita().progetti().actions.update;
    vm.deleteProgetto = api.opportunita().progetti().actions.delete;

    //carica i dati della form
    api.opportunita().progetti().searchForm().then( function ( formData ) {
      vm.formData = formData;
      //carica il kanban
      kanbanProgetti();
    } );

    //reagisci ai cambiamenti sulle opportunita
    $scope.$on( 'Progetto.updated', function ( event, progetto ) {
      dtReload();
      $rootScope.$broadcast( 'confermaAvanzamentoFase', progetto );
    } );
    $scope.$on( 'Progetto.deleted', dtReload );

    $scope.$on( 'afterAvanzamentoFaseOpportunita', function () {
      kanbanProgetti(); // ricarico tutto il kanban, sto meno...
    } );

    ////////////////////////////////////////////////////////////////////////////
    //ricerca
    function resetForm() {
      vm.dt.show = false;
      vm.alerts = {};
      vm.so = searchDefaultValues();
    }

    function search() {
      vm.alerts = {};
      vm.dt.show = true;
      if ( angular.isDefined( vm.dt.dtInstance ) ) {
        dtReload();
      } else {
        dt();
      }
    }

    function dt() {
      vm.dt.dtInstance = {};
      vm.dt.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( progettiList )
        .withOption( 'order', [[9, 'desc'],[3, 'desc']] )
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'paging', true )
        .withOption( 'searching', false )
        .withOption( 'createdRow', function ( row, data ) {
          if ( data.idProgettista == vm.user.idAgente ) {
            angular.element( row ).addClass( 'highlight' );
          }
        } )
      );
      vm.dt.dtColumns = [
        {
          data: 'idProgetto',
          title: 'ID',
          render: renderId,
          'class': 'min-width text-center'
        },
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente,
          'class': 'col-cliente'
        },
        {
          data: 'agente',
          title: 'Agente',
          render: renderAgente,
          'class': 'nowrap'
        },
        {
          data: 'dataOraIns',
          title: 'Data ins.',
          render: dtFactory.renders.date,
          'class': 'col-date nowrap'
        },
        {
          data: 'fase',
          title: 'Fase',
          'class': 'col-fase nowrap'
        },
        {
          data: 'progettista',
          title: 'Progettista',
          'class': 'nowrap'
        },
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'dataChiusura',
          title: 'Data chius.',
          render: dtFactory.renders.date,
          'class': 'col-date nowrap'
        },
        {
          data: 'valore',
          title: 'Valore'
        },
        {
          data: 'ordine',
          title: 'Ordine',
          'class': 'nowrap'
        },
        {
          data: 'idProgetto',
          title: 'Azioni',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];
    }

    function renderAgente( data, type, row ) {
      if ( type === 'display' ) {
        data = '<a bs-tooltip data-title="apri opportunita" ng-click="opc.readOpportunita(' + row.idOpportunita + ')"><i class="fa fa-external-link-square"></i></a> ' + data;
      }
      return data;
    }

    function renderCliente( data, type, row ) {
      if ( type === 'display' ) {
        data = '<a bs-tooltip data-title="apri cliente" ng-click="opc.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></a> ' + row.idCliente + '-' + data;
      }
      return data;
    }

    function renderId( data ) {
      return '<a ng-click="opc.readProgetto(' + data + ')">' + data + '</a>';
    }

    function renderActions( data ) {
      var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="opc.updateProgetto(' + data + ')"><i class="fa fa-pencil"></i></button>';
      var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="opc.deleteProgetto(' + data + ')"><i class="fa fa-minus"></i></button>';
      return upd + '&nbsp;' + del;
    }

    function progettiList() {
      var promise = api.opportunita().progetti().list( vm.so );
      promise.then( function () {
        vm.dt.show = true;
      }, setAlerts);
      return promise;

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.dt.show = false;
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    //kanban
    function kanbanProgetti() {
      //azzera alerts
      vm.alertsK = {};

      //recupera non assegnati dal server
      api.opportunita().progetti().list( vm.sokNA )
        .then( function ( progetti ) {
          vm.nonAssegnati = progetti.length;
        } );

      //crea il kanban
      vm.kanbanSomma = 0;
      vm.kanbanTotale = 0;

      angular.forEach( vm.formData.stages, function ( stage ) {
        vm.kanban[stage.value] = {
          label: stage.label,
          bgColor: stage.bgColor ? '#' + stage.bgColor : 'lightgray',
          sommaValore: 0,
          items: []
        }
      } );

      api.opportunita().progetti().list(vm.sok)
        .then(loadKanban, setAlerts);

      //////////////////////////////////////////////////////////////////////////
      function loadKanban( progetti ) {
        vm.kanbanTotale = progetti.length;
        progetti = $filter( 'orderBy' )( progetti, 'dataOraIns' );
        angular.forEach( progetti, function ( progetto ) {
          progetto.update = api.opportunita().progetti().actions.update;
          vm.kanban[progetto.idStage].items.push( progetto );
          vm.kanban[progetto.idStage].sommaValore += progetto.valore;
          vm.kanbanSomma += progetto.valore;
        } );
        vm.kanbanStages = Object.keys( vm.kanban ).length;
      }

      ////////////////////////////////////////////////////////////////////////

      function setAlerts(response) {
        vm.alertsK = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function searchKanban() {
      kanbanProgetti();
      dashboardProgettiAside.hide();
    }

    function searchDefaultValues() {
      return {
        dataRichiestaDa: '',
        dataRichiestaA: '',
        idStatoProgetto: 1,
        idProgettista: vm.user.flags.gestProg ? vm.user.idAgente : '0',
        dataChiusuraDa: '',
        dataChiusuraA: '',
        idAgentePIC: '0',
        pista: '',
        valoreDa: '',
        valoreA: ''
      }
    }

    function resetKanban() {
      vm.sok = searchDefaultValues();
      searchKanban();
    }

    function unsetFilter(filter) {
      if (filter === 'idAgentePIC') {
        vm.sok[filter] = '0'
      } else {
        delete vm.sok[filter];
      }
      kanbanProgetti();
    }

    function toggleNonAssegnati() {
      if (angular.equals(vm.sok, vm.sokNA)) {
        resetKanban()
      } else {
        angular.copy(vm.sokNA, vm.sok);
        searchKanban();
      }
    }

    function showAside() {
      dashboardProgettiAside.$promise.then(function() {
        dashboardProgettiAside.show();
      });
    }

    function onDrop( srcList, srcIndex, srcStage, targetList, targetIndex, targetStage ) {
      var item = srcList[srcIndex];
      targetList.splice( targetIndex, 0, srcList[srcIndex] );
      if ( srcList === targetList && targetIndex <= srcIndex ) {
        srcIndex++;
      }
      srcList.splice( srcIndex, 1 );
      if ( targetStage !== srcStage ) {
        item.idStage = targetStage;
        api.opportunita().progetti( item.idProgetto ).update( item );
      }
      return true;
    }

    //globali
    function dtReload() {
      if (
          angular.isDefined( vm.dt.dtInstance )
          && angular.isDefined( vm.dt.dtInstance.changeData )
        ) {
        vm.dt.dtInstance.changeData( progettiList );
      }
      kanbanProgetti();
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaLogUpdateController', OpportunitaLogUpdateController);

  function OpportunitaLogUpdateController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var opportunitaLogUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-log-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita_log = {};
    vm.saveForm = saveForm;

    $scope.$on('updateLogOpportunita', updateLogOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function updateLogOpportunita(event, idLogOpportunita) {
      api.opportunita().log(idLogOpportunita).get()
        .then(showModal);

      function showModal(opportunita_log) {
        vm.opportunita_log = opportunita_log;

        opportunitaLogUpdateModal.$promise
          .then(opportunitaLogUpdateModal.show);
      }
    }

    function saveForm() {
      api.opportunita().log(vm.opportunita_log.id).update(vm.opportunita_log)
        .then(opportunitaLogUpdateModal.hide);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaLogController', OpportunitaLogController);

  function OpportunitaLogController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var opportunitaLogModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-log-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita_log = {};

    $scope.$on('readLogOpportunita', readLogOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function readLogOpportunita(event, idLogOpportunita) {
      api.opportunita().log(idLogOpportunita).get()
        .then(showModal);

      function showModal(opportunita_log) {
        vm.opportunita_log = opportunita_log;

        opportunitaLogModal.$promise
          .then(opportunitaLogModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaAttivitaReadController', OpportunitaAttivitaReadController);

  function OpportunitaAttivitaReadController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var opportunitaAttivitaReadModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-attivita-read-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita_attivita = {};

    $scope.$on('readAttivitaOpportunita', readAttivitaOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function readAttivitaOpportunita(event, idAttivitaOpportunita) {
      api.opportunita().attivita(idAttivitaOpportunita).get()
        .then(showModal);

      function showModal(opportunita_attivita) {
        vm.opportunita_attivita = opportunita_attivita;

        opportunitaAttivitaReadModal.$promise
          .then(opportunitaAttivitaReadModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaAttivitaEditController', OpportunitaAttivitaEditController);

  function OpportunitaAttivitaEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var OpportunitaAttivitaEditModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-attivita-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita_attivita = {};
    vm.promemoria = {};
    vm.formData = {
      showPromemoria: false
    };
    vm.action = '';
    vm.alerts = [];
    vm.togglePromemoria = togglePromemoria;
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createAttivitaOpportunitaPerTipo', createAttivitaOpportunitaPerTipo);
    $scope.$on('updateAttivitaOpportunita', updateAttivitaOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function createAttivitaOpportunitaPerTipo( event, opportunita ) {
      vm.action = 'create';
      vm.alerts = [];

      //imposta i defaults
      vm.opportunita_attivita = {
        idTipo: opportunita.idTipo,
        idOpportunita: opportunita.id,
        idProgetto: opportunita.idProgetto,
        dataOraAttivita: new Date(),
        idSoggetto: vm.user.idAgente
      };
      vm.promemoria = {
        tabella: 'opportunita_attivita',
        campoId: 'IDOpportunitaAttivita',
        recordId: null,
        campoFk: 'IDOpportunita',
        dataOra: new Date(),
        flagMail: true
      };

      api.opportunita().attivita().editForm(vm.opportunita_attivita).then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        OpportunitaAttivitaEditModal.$promise
          .then(OpportunitaAttivitaEditModal.show);
      }
    }

    function updateAttivitaOpportunita(event, idAttivitaOpportunita) {
      vm.action = 'update';
      vm.alerts = [];
      api.opportunita().attivita().editForm({idAttivitaOpportunita: idAttivitaOpportunita})
        .then(getAttivitaOpportunita);

      function getAttivitaOpportunita(formData) {
        vm.formData = formData;
        api.opportunita().attivita(idAttivitaOpportunita).get()
          .then(showModal);

        function showModal(opportunita_attivita) {
          vm.opportunita_attivita = opportunita_attivita;

          OpportunitaAttivitaEditModal.$promise
            .then(OpportunitaAttivitaEditModal.show);
        }
      }
    }

    function togglePromemoria() {
      /*
      // superflua - presets già inizializzati
      vm.promemoria = {
        tabella: 'opportunita_attivita',
        campoId: 'IDOpportunitaAttivita',
        recordId: null,
        campoFk:'IDOpportunita',
        dataOra: new Date(),
        flagMail: true
      };
      */
      vm.formData.showPromemoria = !vm.formData.showPromemoria;
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (vm.action === 'create') {
        //aggiungi nel post il  moria
        if (vm.formData.showPromemoria) {
          vm.opportunita_attivita.promemoria = vm.promemoria;
        }
        api.opportunita(vm.opportunita_attivita.idOpportunita).attivita().save(vm.opportunita_attivita)
          .then(OpportunitaAttivitaEditModal.hide, setAlerts);
      } else if (vm.action === 'update') {
        api.opportunita().attivita(vm.opportunita_attivita.id).update(vm.opportunita_attivita)
          .then(OpportunitaAttivitaEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      OpportunitaAttivitaEditModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaAttivitaModalController', OpportunitaAttivitaModalController);

  function OpportunitaAttivitaModalController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var opportunitaAttivitaModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-attivita-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.dtOpportunitaAttivita = {};

    $scope.$on('listAttivitaOpportunita', listAttivitaOpportunita);

    //gestione attivita
    $scope.$on('AttivitaOpportunita.created', dtOpportunitaAttivitaReload);
    $scope.$on('AttivitaOpportunita.updated', dtOpportunitaAttivitaReload);
    $scope.$on('AttivitaOpportunita.deleted', dtOpportunitaAttivitaReload);

    ////////////////////////////////////////////////////////////////////////////
    function listAttivitaOpportunita(event, idOpportunita) {
      dtOpportunitaAttivita(idOpportunita);

      opportunitaAttivitaModal.$promise
        .then(opportunitaAttivitaModal.show);
    }

    function dtOpportunitaAttivita(idOpportunita) {
      vm.dtOpportunitaAttivita.instance = {};

      vm.dtOpportunitaAttivita.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.opportunita(idOpportunita).attivita().list)
        .withOption('dom', "tr")
        .withOption('order', [0, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtOpportunitaAttivita.columns = [
        {
          data: 'dataOraAttivita',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {data: 'tipo', title: 'Tipo'},
        {data: 'descrizione', title: 'Descrizione'},
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        }
      ];
    }

    function dtOpportunitaAttivitaReload() {
      if (!_.isEmpty(vm.dtOpportunitaAttivita.instance)) {
        vm.dtOpportunitaAttivita.instance.reloadData();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentoPrivatoEditController', AppuntamentoPrivatoEditController);

  function AppuntamentoPrivatoEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoEditModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-privato-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.activePanel = -1;
    vm.appuntamento = {};
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createAppuntamentoPrivato', createAppuntamentoPrivato);
    $scope.$on('updateAppuntamentoPrivato', updateAppuntamentoPrivato);
    $scope.$watch('aec.appuntamento.allDay', setOre);

    ////////////////////////////////////////////////////////////////////////////
    function createAppuntamentoPrivato(event, idAgente) {
      action = 'create';
      vm.alerts = [];

      vm.appuntamento = {
        idAgente: idAgente ? idAgente : vm.user.idAgente,
        privato: true,
        allDay: false,
        data: moment().startOf('day').toDate(),
        ora: moment().set({year: 1970, month: 0, date: 1, minute: 0, second: 0}).toDate(),
        dataFine: moment().startOf('day').toDate(),
        oraFine: moment().set({year: 1970, month: 0, date: 1, minute: 0, second: 0}).add(1, 'hour').toDate()
      };

      api.appuntamenti.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        appuntamentoEditModal.$promise
          .then(appuntamentoEditModal.show);
      }
    }

    function updateAppuntamentoPrivato(event, idAppuntamento) {
      action = 'update';
      vm.alerts = [];

      api.appuntamenti.editForm()
        .then(getAppuntamento);

      function getAppuntamento(formData) {
        vm.formData = formData;

        api.appuntamento(idAppuntamento).get()
          .then(showModal);

        function showModal(appuntamento) {
          vm.appuntamento = appuntamento;
          vm.appuntamento.descrizione = vm.appuntamento.cliente;

          appuntamentoEditModal.$promise
            .then(appuntamentoEditModal.show);
        }
      }
    }

    function setOre(newVal, oldVal)  {
      if (newVal !== oldVal) {
        if (newVal) {
          vm.appuntamento.ora = null;
          vm.appuntamento.oraFine = null;
        } else {
          vm.appuntamento.ora = moment().set({year: 1970, month: 0, date: 1, minute: 0, second: 0}).toDate();
          vm.appuntamento.oraFine = moment().set({year: 1970, month: 0, date: 1, minute: 0, second: 0}).add(1, 'hour').toDate();
        }
      }
    }

    function saveForm() {
      vm.alerts = []; //reset degli alert appena si clicca il pulsante

      if (action === 'create') {
        api.appuntamenti.save(vm.appuntamento)
          .then(appuntamentoEditModal.hide, setAlerts);
      } else if (action === 'update') {
        api.appuntamento(vm.appuntamento.id).update(vm.appuntamento)
          .then(appuntamentoEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      appuntamentoEditModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentoPrivatoController', AppuntamentoPrivatoController);

  function AppuntamentoPrivatoController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var appuntamentoModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-privato-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = generaAzioni();

    //appuntamento
    vm.appuntamento = {};
    vm.updateAppuntamento = api.appuntamenti.actions.updatePrivato;
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;

    //gestione appuntamento
    $scope.$on('readAppuntamentoPrivato', readAppuntamentoPrivato);
    $scope.$on('Appuntamento.updated', appuntamentoReload);
    $scope.$on('Appuntamento.deleted', closeModal);

    ////////////////////////////////////////////////////////////////////////////
    //gestione azioni
    function generaAzioni() {
      var actions = [];
      var availableActions = {
        updateAppuntamento: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'appuntamento.updateAppuntamento(appuntamento.appuntamento.id);'
        },
        deleteAppuntamento: {
          text: '<i class="fa fa-minus-square fa-fw"></i>&nbsp;Elimina',
          click: 'appuntamento.deleteAppuntamento(appuntamento.appuntamento.id);'
        }
      };

      actions.push(availableActions.updateAppuntamento);
      actions.push(availableActions.deleteAppuntamento);

      return actions;
    }

    //gestione appuntamento
    function readAppuntamentoPrivato(event, idAppuntamento) {
      api.appuntamento(idAppuntamento).get()
        .then(showModal);

      function showModal(appuntamento) {
        vm.appuntamento = appuntamento;

        appuntamentoModal.$promise
          .then(appuntamentoModal.show);
      }
    }

    function appuntamentoReload(event, appuntamento) {
      if (appuntamento.id === vm.appuntamento.id) {
        vm.appuntamento = appuntamento;
      }
    }

    function closeModal(event, appuntamento) {
      if (appuntamento.id === vm.appuntamento.id) {
        appuntamentoModal.hide();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ChangePasswordController', ChangePasswordController)
  ;

  function ChangePasswordController($timeout, $scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var changePasswordModal = $modal({
      scope: $scope,
      templateUrl: 'change-password-modal.tpl.html',
      show: false,
      onShow: function () {
        angular.element( '.togglePasswordVisibility:not(.init)' )
          .on( 'click', function ( event ) {
            var $input = angular.element( event.currentTarget ).siblings( 'input' );
            var type = $input.prop( 'type' ) == 'password' ? 'text' : 'password';
            var eyeIcon = type == 'text' ? 'fa-eye-slash' : 'fa-eye';
            $input.prop( 'type', type );
            angular.element( '.fa', event.currentTarget ).removeClass( 'fa-eye fa-eye-slash' ).addClass( eyeIcon );
          } )
          .addClass( 'init' );
      }
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.utente = {};
    vm.status = 200;
    vm.warnings = [];
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('AuthenticateJS.login', onLogin);
    $scope.$on('changePassword', changePassword);

    ////////////////////////////////////////////////////////////////////////////
    function onLogin(event, user) {
      vm.user = user;
    }

    function changePassword(event, idUtente) {
      if (vm.user.userGroup == 8) {
        vm.utente = {
          id: (angular.isDefined(idUtente) ? idUtente : vm.user.id)
        };
      } else {
        vm.utente = {
          id: vm.user.id
        };
      }
      vm.status = 200;
      vm.warnings = [];

      changePasswordModal.$promise
        .then(changePasswordModal.show);
    }

    function saveForm() {
      api.one('/auth/user', 'Utente', vm.utente.id).update(vm.utente)
        .then(passwordChanged, setWarnings);

      //////////////////////////////////////////////////////////////////////////
      function passwordChanged() {
        if (vm.user.id === vm.utente.id) {
          vm.status = 200;
          vm.warnings = [
            {
              text: 'Password cambiata con successo. Fra 3 secondi sarete sloggati',
              code: 'success_change'
            }
          ];

          $timeout(closeAndLogout, 3000);
        } else {
          changePasswordModal.hide();
        }

        ////////////////////////////////////////////////////////////////////////
        function closeAndLogout() {
          changePasswordModal.hide();

          vm.auth.logout();
        }
      }

      function setWarnings(response) {
        vm.status = response.status;
        vm.warnings = response.data.warnings;
      }
    }

    function undoForm() {
      changePasswordModal.hide();
    }
  }

})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TestController', TestController);

  function TestController($scope, $animate, api, Logger) {
    var vm = this;

    Logger.debug = true; //enable logger

    vm.showKittyPaw = false;
    vm.showKitty = showKitty;

    ////////////////////////////////////////////////////////////////////////////
    function showKitty() {
      Logger.info('show kitty');
      //activate on search soft kitty in clienti omnibox :-p
      $animate.on('removeClass', angular.element('.kittyContainer'), hideKitty);

      vm.showKittyPaw = true;
    }

    function hideKitty(element, phase) {
      if (phase === 'close') {
        $scope.$apply(function() {
          Logger.info('hide kitty');

          vm.showKittyPaw = false;

          $animate.off(angular.element('.kittyContainer'));
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TelefonateController', TelefonateController);

  function TelefonateController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var telefonateModal = $modal({
      scope: $scope,
      templateUrl: 'telefonate-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.filtro = {};
    vm.dtTelefonate = {};

    $scope.$on('readTelefonate', readTelefonate);
    vm.updateTelefonata = api.telefonate.actions.update;
    vm.deleteTelefonata = api.telefonate.actions.delete;

    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.readCliente = api.clienti.actions.read;

    //gestione telefonate
    $scope.$on('Telefonata.updated', dtTelefonateReload);
    $scope.$on('Telefonata.deleted', dtTelefonateReload);

    ////////////////////////////////////////////////////////////////////////////
    function readTelefonate(event, filtroTelefonate) {
      vm.filtro = filtroTelefonate;

      dtTelefonate(filtroTelefonate);

      telefonateModal.$promise
        .then(telefonateModal.show);
    }

    function dtTelefonate(filtroTelefonate) {
      vm.dtTelefonate.dtInstance = {};

      vm.dtTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function() {
          return api.telefonate.list(filtroTelefonate);
        })
        .withOption('pageLength', 25)
        .withOption('order', [0, 'desc'])
      );

      vm.dtTelefonate.dtColumns = [
        {
          data: 'dataOra',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {data: 'operatore', title: 'Operatore'},
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente
        },
        {data: 'motivi_descrizione', title: 'Lista'},
        {
          data: 'esito',
          title: 'Esito',
          render: renderEsito
        },
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          return '<a title="apri cliente" ng-click="tc.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderEsito(data, type, row) {
        if (type === 'display') {
          if (row.idAppuntamento !== '') {
            return data + '&nbsp;' + '<i class="fa fa-external-link" title="apri appuntamento" ng-click="tc.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
          }
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tc.updateTelefonata(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tc.deleteTelefonata(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (vm.user.userGroup >= 5) {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }
    }

    function dtTelefonateReload() {
      vm.dtTelefonate.dtInstance.reloadData();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TelefonataUpdateController', TelefonataUpdateController);

  function TelefonataUpdateController($scope, $modal, api) {
    var vm = this;

    var telefonataUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'telefonata-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.telefonata = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('updateTelefonata', updateTelefonata);

    ////////////////////////////////////////////////////////////////////////////
    function updateTelefonata(event, idTelefonata) {
      api.telefonate.editForm()
        .then(getTelefonata);

      function getTelefonata(formData) {
        vm.formData = formData;

        api.telefonata(idTelefonata).get()
          .then(showModal);

        function showModal(telefonata) {
          vm.telefonata = telefonata;

          telefonataUpdateModal.$promise
            .then(telefonataUpdateModal.show);
        }
      }
    }

    function saveForm() {
      api.telefonata(vm.telefonata.id).update(vm.telefonata)
        .then(telefonataUpdateModal.hide);
    }

    function undoForm() {
      telefonataUpdateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TelefonataCreateController', TelefonataCreateController);

  function TelefonataCreateController($scope, $filter, $modal, api) {
    var vm = this;

    var telefonataCreateModal = $modal({
      scope: $scope,
      templateUrl: 'telefonata-create-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.telefonata = {};
    vm.cliente = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createTelefonataCliente', createTelefonataCliente);

    ////////////////////////////////////////////////////////////////////////////
    function createTelefonataCliente(event, cliente) {
      vm.cliente = cliente;
      vm.telefonata = {
        idMotivo: '0',
        idOperatore: '0',
        idStatoTelefonata: '0',
        idCliente: cliente.id
      };

      api.telefonate.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        vm.formData.stati = angular.copy($filter('filter')(vm.formData.stati, {tipo: '!T'}, true));

        telefonataCreateModal.$promise
          .then(telefonataCreateModal.show);
      }
    }

    function saveForm() {
      api.cliente(vm.telefonata.idCliente)
        .telefonate.save(vm.telefonata)
        .then(telefonataCreateModal.hide);
    }

    function undoForm() {
      telefonataCreateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TelefonataController', TelefonataController);

  function TelefonataController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var telefonataModal = $modal({
      scope: $scope,
      templateUrl: 'telefonata-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.telefonata = {};

    $scope.$on('readTelefonata', readTelefonata);

    ////////////////////////////////////////////////////////////////////////////
    function readTelefonata(event, idTelefonata) {
      api.telefonata(idTelefonata).get()
        .then(showModal);

      function showModal(telefonata) {
        vm.telefonata = telefonata;

        telefonataModal.$promise
          .then(telefonataModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ConfirmedMailController', ConfirmedMailController);

  function ConfirmedMailController($scope, $filter, $modal, api) {
    var vm = this;

    var confirmedMailModal = $modal({
      scope: $scope,
      templateUrl: 'confirmed-mail-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = null;

    vm.title = '';
    vm.indirizzi = [];
    vm.allegati = [];
    vm.modelli = [];
    vm.mail = {
      indirizzo: '',
      cc: '',
      oggetto: '',
      testo: ''
    };
    vm.warnings = [];
    vm.status = 200;

    vm.confirmForm = confirmForm;
    vm.undoForm = undoForm;

    $scope.$on('inviaPresentazioneCliente', inviaPresentazioneCliente);
    $scope.$on('inviaConfermaAppuntamento', inviaConfermaAppuntamento);
    $scope.$on('inviaOpportunita', inviaOpportunita);
    $scope.$on('inviaProgetto', inviaProgetto);

    ////////////////////////////////////////////////////////////////////////////
    function inviaPresentazioneCliente(event, idCliente, datiMail) {
      resetForm();

      action = api.cliente(idCliente).sendPresentation;

      vm.title = 'Presentazione Cliente';

      api.clienti.sendmailForm({
        idCliente: idCliente
      }).then(function (formData) {
        vm.indirizzi = formData.indirizzi;
        vm.modelli = formData.modelli;
        vm.mail = {
          indirizzo: datiMail.indirizzo,
          oggetto: datiMail.oggetto || 'Presentazione',
          testo: "Gentile cliente,\n" +
            "le invio in allegato la presentazione della nostra azienda.\n" +
            "Per qualsiasi esigenza i nostri contatti sono:\n\n" +
            "Tel: 043344978\n" +
            "Email: info@clyco.it\n\n" +
            "Cordialmente,\n" +
            "Clyco Srl",
          idModello: $filter('filter')(formData.modelli, {default: 1}, true)[0]['value']
        };

        showModal();
      });
    }

    function inviaConfermaAppuntamento(event, idAppuntamento, datiMail) {
      resetForm();

      action = api.appuntamento(idAppuntamento).sendConfirm;

      vm.title = 'Conferma Appuntamento';

      api.appuntamenti.sendmailForm({
        idAppuntamento: idAppuntamento
      }).then(function (formData) {
        vm.indirizzi = formData.indirizzi;
        vm.modelli = formData.modelli;

        api.appuntamento(idAppuntamento).get().then(function (appuntamento) {
          vm.mail = {
            indirizzo: datiMail.indirizzo,
            oggetto: datiMail.oggetto || 'Conferma Appuntamento',
            testo: "Gentile cliente,\n" +
              "le invio in allegato la conferma appuntamento\n" +
              "per il giorno " + $filter('date')(appuntamento.data, 'shortDate') + " alle ore " + $filter('date')(appuntamento.ora, 'shortTime') + "\n" +
              "con il nostro consulente " + appuntamento.agenti_agente,
            idModello: $filter('filter')(formData.modelli, {default: 1}, true)[0]['value']
          };

          showModal();
        });
      });
    }

    function inviaOpportunita(event, idOpportunita, datiMail) {
      resetForm();

      action = api.opportunita(idOpportunita).send;

      vm.title = 'Opportunità';

      api.opportunita().sendmailForm({
        idOpportunita: idOpportunita
      }).then(function (formData) {
        vm.indirizzi = formData.indirizzi;
        vm.allegati = formData.allegati;
        angular.forEach( vm.allegati, function( allegato, key ) {
          if ( allegato.idProgetto ) {
            vm.allegati[key].label += ' <i class="fa fa-graduation-cap"></i>';
          }
        } );

        vm.mail = {
          indirizzo: datiMail.indirizzo,
          cc: datiMail.cc,
          oggetto: datiMail.oggetto || 'Opportunità',
          testo: '',
          'idAllegati[]': []
        };

        showModal();
      });
    }

    function inviaProgetto(event, idProgetto, datiMail) {
      resetForm();
      action = api.opportunita().progetti( idProgetto ).send;
      vm.title = 'Progetto';
      api.opportunita().progetti().sendmailForm( {
        idProgetto: idProgetto
      } ).then( function ( formData ) {
        vm.indirizzi = formData.indirizzi;
        vm.allegati = formData.allegati;
        vm.mail = {
          indirizzo: datiMail.indirizzo,
          cc: datiMail.cc,
          oggetto: datiMail.oggetto || 'Progetto',
          testo: '',
          'idAllegati[]': []
        };
        showModal();
      });
    }


    //funzioni generali
    function resetForm() {
      vm.title = '';
      vm.indirizzi = [];
      vm.allegati = [];
      vm.modelli = [];
      vm.mail = {
        indirizzo: '',
        cc: '',
        oggetto: '',
        testo: ''
      };
    }

    function setWarnings(response) {
      vm.status = response.status;
      vm.warnings = response.data.warnings;
    }

    function showModal() {
      vm.warnings = [];
      vm.status = 200;

      confirmedMailModal.$promise
        .then(confirmedMailModal.show);
    }

    function confirmForm() {
      action(vm.mail)
        .then(undoForm, setWarnings);
    }

    function undoForm() {
      action = null;
      confirmedMailModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ConfirmedDeleteController', ConfirmedDeleteController);

  function ConfirmedDeleteController($scope, $modal, $filter, api) {
    var vm = this;

    var confirmedDeleteModal = $modal({
      scope: $scope,
      templateUrl: 'confirmed-delete-modal.tpl.html',
      show: false
    });
    var action = null;

    vm.id = 0;
    vm.title = '';
    vm.conferma = '';
    vm.warnings = [];
    vm.status = 200;
    vm.enableDelete = true;
    vm.confirmForm = confirmForm;
    vm.undoForm = undoForm;

    $scope.$on('deleteAppuntamento', deleteAppuntamento);
    $scope.$on('deleteCliente', deleteCliente);
    $scope.$on('deleteClienti', deleteClienti);
    $scope.$on('deleteDatoCliente', deleteDatoCliente);
    $scope.$on('deleteReferente', deleteReferente);
    $scope.$on('deleteSede', deleteSede);
    $scope.$on('deleteContratto', deleteContratto);
    $scope.$on('deleteElenco', deleteElenco);
    $scope.$on('deleteLista', deleteLista);
    $scope.$on('deleteProvvigione', deleteProvvigione);
    $scope.$on('deleteProvvigioneCalcolata', deleteProvvigioneCalcolata);
    $scope.$on('deleteRemoveLista', deleteRemoveLista);
    $scope.$on('deleteTelefonata', deleteTelefonata);
    $scope.$on('deleteProvvigioni', deleteProvvigioni);
    $scope.$on('deleteUtente', deleteUtente);
    $scope.$on('deleteOpportunita', deleteOpportunita);
    $scope.$on('deleteProgetto', deleteProgetto);
    $scope.$on('deleteAllegato', deleteAllegato);
    $scope.$on('deleteAttivitaOpportunita', deleteAttivitaOpportunita);
    $scope.$on('deletePv', deletePv);
    $scope.$on('deleteAttivitaPv', deleteAttivitaPv);
    $scope.$on('deleteRapportini', deleteRapportini);
    $scope.$on('deletePromemoria', deletePromemoria);
    $scope.$on('deleteCopertura', deleteCopertura);

    //gestione tabelle admin
    $scope.$on('deleteStatoAppuntamento', deleteStatoAppuntamento);
    $scope.$on('deleteStatoContratto', deleteStatoContratto);
    $scope.$on('deleteStatoElenco', deleteStatoElenco);
    $scope.$on('deleteStatoTelefonata', deleteStatoTelefonata);
    $scope.$on('deleteProdotto', deleteProdotto);
    $scope.$on('deleteSoggetto', deleteSoggetto);
    $scope.$on('deleteTipoPortafoglio', deleteTipoPortafoglio);
    $scope.$on('deletePortafoglio', deletePortafoglio);
    $scope.$on('deleteSquadra', deleteSquadra);

    ////////////////////////////////////////////////////////////////////////////
    function deleteAppuntamento(event, idAppuntamento) {
      action = api.appuntamento(idAppuntamento).remove;

      vm.id = idAppuntamento;
      vm.title = 'Appuntamento';

      action()
        .then(showModal, setWarningsAppuntamento);

      function setWarningsAppuntamento(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
        vm.conferma = '';
        vm.enableDelete = (vm.warnings.length <= 0);

        confirmedDeleteModal.$promise
          .then(confirmedDeleteModal.show);
      }
    }

    function deleteCliente(event, idCliente) {
      action = api.cliente(idCliente).remove;

      vm.id = idCliente;
      vm.title = 'Cliente';

      action()
        .then(showModal, setWarnings);
    }

    function deleteClienti(event, filtro) {
      action = function (parameters) {
        angular.extend(filtro, parameters);

        return api.clienti.remove(filtro);
      };

      vm.id = 'multipli';
      vm.title = 'Clienti';

      action()
        .then(showModal, setWarnings);
    }

    function deleteDatoCliente(event, idDatoCliente) {
      action = api.clienti.dato(idDatoCliente).remove;

      vm.id = idDatoCliente;
      vm.title = 'Intervista Cliente';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteReferente(event, idReferente) {
      action = api.referente(idReferente).remove;

      vm.id = idReferente;
      vm.title = 'Referente';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteSede( event, idSede ) {
      action = api.sede( idSede ).remove;
      vm.id = idSede;
      vm.title = 'Sede';
      vm.warnings = [];
      vm.status = 200;
      showModal();
    }

    function deleteContratto(event, idContratto) {
      action = api.contratto(idContratto).remove;

      vm.id = idContratto;
      vm.title = 'Contratto';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteElenco(event, idElenco) {
      action = api.elenco(idElenco).remove;

      vm.id = idElenco;
      vm.title = 'Elenco';

      action()
        .then(showModal, setWarningsElenco);

      function setWarningsElenco(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
        vm.conferma = '';
        vm.enableDelete = (
          ($filter('filter')(response.data.warnings, {code: 'altro_agente'}, true)).length <= 0
          && ($filter('filter')(response.data.warnings, {code: 'non_in_visita'}, true)).length <= 0
        );

        confirmedDeleteModal.$promise
          .then(confirmedDeleteModal.show);
      }
    }

    function deleteLista(event, idMotivo) {
      action = api.lista(idMotivo).remove;

      vm.id = idMotivo;
      vm.title = 'Lista';

      action()
        .then(showModal, setWarningsLista);

      function setWarningsLista(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
        vm.conferma = '';
        vm.enableDelete = (vm.warnings.length <= 0);

        confirmedDeleteModal.$promise
          .then(confirmedDeleteModal.show);
      }
    }

    function deleteProvvigione(event, idProvvigione) {
      action = api.provvigione(idProvvigione).remove;

      vm.id = idProvvigione;
      vm.title = 'Provvigione';

      action()
        .then(showModal, setWarnings);
    }

    function deleteProvvigioneCalcolata(event, idProvvigioneCalcolata) {
      action = api.provvigioni.calcolata(idProvvigioneCalcolata).remove;

      vm.id = idProvvigioneCalcolata;
      vm.title = 'Provvigione Calcolata';

      action()
        .then(showModal, setWarnings);
    }

    function deleteRemoveLista(event, idMotivo, filtro) {
      // action = api.lista(idMotivo).remove_delete;
      action = function (parameters) {
        angular.extend(filtro, parameters);

        return api.lista(idMotivo).remove_delete(filtro);
      };

      vm.id = idMotivo;
      vm.title = 'clienti dalla lista';

      action()
        .then(showModal, setWarnings);
    }

    function deleteTelefonata(event, idTelefonata) {
      action = api.telefonata(idTelefonata).remove;

      vm.id = idTelefonata;
      vm.title = 'Telefonata';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteProvvigioni(event, filtro, warnings) {
      action = function (parameters) {
        angular.extend(filtro, parameters);

        return api.provvigioni.remove(filtro);
      };

      vm.id = 'multiple';
      vm.title = 'Schede Provvigioni';
      vm.warnings = warnings;
      vm.status = 417;

      showModal();
    }

    function deleteUtente(event, idUtente) {
      action = api.utente(idUtente).remove;

      vm.id = idUtente;
      vm.title = 'Utente';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteOpportunita(event, idOpportunita) {
      action = api.opportunita(idOpportunita).remove;

      vm.id = idOpportunita;
      vm.title = 'Opportunita';

      action()
        .then(showModal, setWarnings);
    }

    function deleteProgetto( event, idProgetto ) {
      action = api.opportunita().progetti( idProgetto ).remove;
      vm.id = idProgetto;
      vm.title = 'Progetto';
      action().then(showModal, setWarnings);
    }

    function deleteAllegato(event, idAllegato) {
      action = api.allegato(idAllegato).remove;

      vm.id = idAllegato;
      vm.title = 'Allegato';

      action()
        .then(showModal, setWarnings);
    }

    function deleteAttivitaOpportunita(event, idAttivitaOpportunita) {
      action = api.opportunita().attivita(idAttivitaOpportunita).remove;

      vm.id = idAttivitaOpportunita;
      vm.title = 'Attivita Opportunita';

      action()
        .then(showModal, setWarnings);
    }

    function deletePv(event, idPv) {
      action = api.pv(idPv).remove;
      vm.id = idPv;
      vm.title = 'Postvendita';
      action()
        .then(showModal, setWarnings);
    }

    function deleteAttivitaPv(event, idAttivita) {
      action = api.pv().attivita(idAttivita).remove;
      vm.id = idAttivita;
      vm.title = 'Attivita Postvendtia';
      action()
        .then(showModal, setWarnings);
    }

    function deletePromemoria(event, idPromemoria) {
      action = api.promemoria(idPromemoria).remove;

      vm.id = idPromemoria;
      vm.title = 'Promemoria';

      action()
        .then(showModal, setWarnings);
    }

    //gestione tabelle admin
    function deleteStatoAppuntamento(event, idStatoAppuntamento) {
      action = api.appuntamenti.stato(idStatoAppuntamento).remove;

      vm.id = idStatoAppuntamento;
      vm.title = 'Stato Appuntamento';

      action()
        .then(showModal, setWarningsStatoAppuntamento);

      function setWarningsStatoAppuntamento(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
        vm.conferma = '';
        vm.enableDelete = (vm.warnings.length <= 0);

        confirmedDeleteModal.$promise
          .then(confirmedDeleteModal.show);
      }
    }

    function deleteStatoContratto(event, idStatoContratto) {
      action = api.contratti.stato(idStatoContratto).remove;

      vm.id = idStatoContratto;
      vm.title = 'Stato Contratto';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteStatoElenco(event, idStatoElenco) {
      action = api.elenchi.stato(idStatoElenco).remove;

      vm.id = idStatoElenco;
      vm.title = 'Stato Elenco';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteStatoTelefonata(event, idStatoTelefonata) {
      action = api.telefonate.stato(idStatoTelefonata).remove;

      vm.id = idStatoTelefonata;
      vm.title = 'Stato Telefonata';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteProdotto(event, idProdotto) {
      action = api.prodotto(idProdotto).remove;

      vm.id = idProdotto;
      vm.title = 'Prodotto';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteSoggetto(event, idSoggetto) {
      action = api.soggetto(idSoggetto).remove;

      vm.id = idSoggetto;
      vm.title = 'Soggetto';

      action()
        .then(showModal, setWarningsSoggetto);

      function setWarningsSoggetto(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
        vm.conferma = '';
        vm.enableDelete = (vm.warnings.length <= 0);

        confirmedDeleteModal.$promise
          .then(confirmedDeleteModal.show);
      }
    }

    function deleteTipoPortafoglio(event, idTipoPortafoglio) {
      action = api.portafogli.tipo(idTipoPortafoglio).remove;

      vm.id = idTipoPortafoglio;
      vm.title = 'Tipo Portafoglio';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deletePortafoglio(event, idPortafoglio) {
      action = api.portafoglio(idPortafoglio).remove;

      vm.id = idPortafoglio;
      vm.title = 'Portafoglio';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteSquadra(event, idSquadra) {
      action = api.squadra(idSquadra).remove;

      vm.id = idSquadra;
      vm.title = 'Squadra';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    //funzioni generali
    function setWarnings(response) {
      vm.status = response.status;
      vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);

      showModal();
    }

    function showModal() {
      vm.conferma = '';
      vm.enableDelete = true;

      confirmedDeleteModal.$promise
        .then(confirmedDeleteModal.show);
    }

    function confirmForm() {
      if (vm.conferma === 'CONFERMA') {
        action({conferma: vm.conferma})
          .then(confirmedDeleteModal.hide, setPostWarnings);
      }

      function setPostWarnings(response) {
        vm.status = response.status;
        vm.warnings = $filter('filter')(response.data.warnings, {code: '!CONFERMA'}, true);
      }
    }

    function undoForm() {
      confirmedDeleteModal.hide();
    }

    function deleteCopertura(event, identificatore) {
      action = api.copertura(identificatore).remove;

      vm.id = identificatore;
      vm.title = 'Test Copertura';
      vm.warnings = [];
      vm.status = 200;

      showModal();
    }

    function deleteRapportini( event, idRapportino ) {
      action = api.pv().rapportino( idRapportino ).remove;
      vm.id = idRapportino;
      vm.title = 'Rapportino';
      action().then(showModal, setWarnings);
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ConfirmController', ConfirmController);

  function ConfirmController( $rootScope, $scope, $modal ) {

    var vm = this;
    vm.description = '';
    vm.oncloseBroadcastAction = '';

    $scope.$on( 'confirmModalShow', function ( model, data ) {
      vm.description = data.description;
      vm.broadcastAction = data.broadcastAction;
      confirmModal.show();
      if ( data.oncloseBroadcastAction ) {
        vm.oncloseBroadcastAction = data.oncloseBroadcastAction;
      }
    } );

    var confirmModal = $modal( {
      scope: $scope,
      templateUrl: 'confirm.tpl.html',
      backdrop: false,
      show: false,
      onHide: function () {
        if ( vm.oncloseBroadcastAction ) {
          $rootScope.$broadcast( vm.oncloseBroadcastAction );
        }
      }
    } );

    vm.action = function () {
      $rootScope.$broadcast( vm.broadcastAction );
      confirmModal.hide();
    }


  }

})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('CelebrateController', CelebrateController);

  function CelebrateController($scope, $animate) {
    var vm = this;

    vm.showCelebrate = false;
    vm.icon = 'fa-hand-peace-o';

    // gestisci le varie celebrazioni
    $scope.$on('Opportunita.updated', celebrateOpportunita);
    $scope.$on('Easter.egg', celebrateKitty);

    ////////////////////////////////////////////////////////////////////////////
    function celebrateOpportunita(event, opportunita) {
      if (opportunita.idStato === '2') {
        $animate.on('removeClass', angular.element('.celebrateContainer'), hideCelebrate);

        vm.icon = 'fa-hand-peace-o';
        vm.showCelebrate = true;
      }
    }

    function celebrateKitty() {
      $animate.on('removeClass', angular.element('.celebrateContainer'), hideCelebrate);

      vm.icon = 'fa-paw';
      vm.showCelebrate = true;
    }

    //funzione uguale per tutti per nascondere a fine animazione
    function hideCelebrate(element, phase) {
      if (phase === 'close') {
        $scope.$apply(function() {
          vm.showCelebrate = false;

          $animate.off(angular.element('.celebrateContainer'));
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AssegnaPVController', AssegnaPVController);

  function AssegnaPVController( $rootScope, $scope, $modal, api ) {

    var vm = this;
    vm.formData = {};
    vm.idPv = 0;
    vm.idStage = 0;
    vm.idSoggetto = '';
    
    vm.saveForm = function () {
      api.pv( vm.idPv ).get().then( function( pv ) {
        pv.idSoggetto = vm.idSoggetto;
        pv.idStage = vm.idStage;
        if ( pv.idContratti && pv.idContratti.length == 1 ) {
          pv.contratti = pv.idContratti[0]; // faccio in modo che risulti come se arrivasse da una select
        }
        api.pv( vm.idPv ).update( pv ).then( function ( pv ) {
          assegnaPvModal.hide();
          $rootScope.$broadcast( 'Pv.updated', pv );
        } );
      } );
    }

    var assegnaPvModal = $modal( {
      scope: $scope,
      templateUrl: 'assegnaPv.tpl.html',
      backdrop: false,
      show: false,
      onHide: function () {
        $rootScope.$broadcast( 'Pv.updated' );
      }
    } );

    $scope.$on( 'assegnaPvModalShow', function ( model, item ) {
      vm.idPv = item.idPostvendita;
      vm.idStage = item.idStage;
      assegnaPvModal.show();
      api.pv().editForm().then( function ( formData ) {
        vm.formData = formData;
      } );
    } );

  }

})();

(function() {
	'use strict';

	angular.module('g1.core')
		.controller('RicercaPvController', RicercaPvController);

	function RicercaPvController( $scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api ) {
		var vm = this;
		vm.auth = AuthenticateJS;
		vm.user = vm.auth.getUser();
		vm.formData = {};
		vm.alerts = {};

		vm.dtPv = {};
		vm.dtCliente = {};
		vm.dtAttivita = {};

		vm.showResults = false;
		vm.search = search;
		vm.resetForm = resetForm;
		vm.defaultSP = {
			idCliente: '',
			codice: '',
			ragsoc: '',
			codFisc: '',
			dataFrom: '',
			dataTo: '',
			dataAttivitaFrom: '',
			dataAttivitaTo: '',
			'fornitori[]': [],
			'piste[]': [],
			'categorie[]': [],
			'priorita[]': [],
			'soggetti[]': [],
			'soggetti_attivita[]': [],
			descrizione: '',
			tipo: '',
			cercaIn: '',
			inSede: '',
			tipoOutput: 'pv',
			defaultOrder: true
		};
		vm.sp = angular.copy( vm.defaultSP );

		vm.readCliente = api.clienti.actions.read;
		vm.readPv = api.pv().actions.read;
		vm.updatePv = api.pv().actions.update;
		vm.deletePv = api.pv().actions.delete;

		//reagisci ai cambiamenti sui pv
		$scope.$on( 'Pv.created', dtPvReload );
		$scope.$on( 'Pv.updated', dtPvReload );
		$scope.$on( 'Pv.deleted', pvDeleted );

		function pvDeleted() {
			dtPvReload();
		}

		function dtPvReload() {
			// ricarica solo la tabella visibile: le altre sono rimosse dall'ng-if
			var dt = { pv: vm.dtPv, cliente: vm.dtCliente, attivita: vm.dtAttivita }[ vm.tipoOutput ];
			if ( vm.showResults && dt && ! _.isEmpty( dt.dtInstance ) ) {
				dt.dtInstance.reloadData();
			}
		}

		vm.reloadPv = dtPvReload;

		//carica i dati della form
		api.pv().searchForm({contesto:'pv,realizzazioni'}).then( function ( formData ) {
			vm.formData = formData;
		} );

		////////////////////////////////////////////////////////////////////////////
		function search() {
			var showResults = false;
			for ( var i in vm.sp ) {
				if ( vm.defaultSP[i] != vm.sp[i] ) {
					showResults = true;
					break;
				}
			}
			vm.showResults = showResults;
			vm.tipoOutput = vm.sp.tipoOutput;
			if ( ! showResults ) {
				/*
				vm.alerts = {
				status: 0,
				messages: 'Specificare almeno un termine di ricerca'
				};
				*/
				return false;
			}
			switch ( vm.sp.tipoOutput ) {
				case 'pv':
					dtPv();
				break;
				case 'cliente':
					dtCliente();
				break;
				case 'attivita':
					dtAttivita();
				break;
			}
		}

		function resetForm() {
			vm.showResults = false;
			vm.alerts = {};
			vm.sp = angular.copy( vm.defaultSP );
		}

		function dtPv() {

			var getData = function () {
				var pvPromise = api.pv().list( vm.sp );
				pvPromise.then( function ( data ) {
					vm.dtPv.count = data.length;
				}, setAlerts );
				return pvPromise;
			};

			function setAlerts(response) {
				vm.showResults = false;
				vm.alerts = {
					status: response.status,
					messages: response.data.warnings
				};
			}

			if ( angular.isUndefined( vm.dtPv.dtInstance ) ) {
				vm.dtPv.dtInstance = {};
				vm.dtPv.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
					.fromFnPromise( getData )
					.withOption( 'order', [[9, 'asc'],[10, 'asc']] )
					.withOption( 'info', false )
					.withOption( 'lengthChange', false )
					.withOption( 'searching', true )
					.withOption( 'paging', true )
					.withButtons( [ {
						extend: 'excelHtml5',
						action: logExport,
						text: 'Esporta',
						className: 'btn-info btn-sm btn-separate',
						filename: 'pv',
						exportOptions: {
							orthogonal: 'filter'
						}
					}, {
						text: '<i class="fa fa-file-pdf-o fa-fw"></i>&nbsp;Report PDF',
						className: 'btn-primary btn-sm btn-separate margin-left',
						action: reportPdf
					} ] )
					.withOption( 'pageLength', 25 )
				);
				vm.dtPv.dtColumns = [
					{
						data: 'codice',
						title:'Codice',
						render: renderCodice,
						'class': 'col-codice nowrap'
					},
					{
						data: 'cliente',
						title: 'Cliente',
						render: renderCliente,
						'class': 'col-cliente'
					},
					{
						data: 'citta',
						title: 'Città',
						'class': 'col-citta'
					},
					{
						data: 'prov',
						title: 'Prov.',
						'class': 'col-prov nowrap'
					},
					{
						data: 'piste',
						title: 'Piste',
						'class': 'col-pista nowrap'
					},
					{
						data: 'categoria',
						title: 'Categoria',
						'class': 'col-categoria nowrap'
					},
					{
						data: 'stato',
						title: 'Stato'
					},
					{
						data: 'stage',
						title: 'Fase',
						'class': 'col-fase nowrap'
					},
					{
						data: 'descrizioneTicket',
						title: 'Descrizione',
						'class': 'col-descrizione nowrap preformattedText',
						render: dtFactory.renders.longtext
					},
					{
						data: 'dataApertura',
						title: 'Apertura',
						render: dtFactory.renders.datetime,
						'class': 'col-date-time nowrap'
					},
					{
						data: 'dataChiusura',
						title: 'Chiusura',
						render: dtFactory.renders.datetime,
						'class': 'col-date-time nowrap'
					/*
					},
					{
						data: 'soggetto',
						title: 'Assegnato',
						'class': 'col-user-fullname nowrap'
					*/
					},
					{
						data: 'durataAttivita',
						title: 'Durata',
						'class': 'col-time nowrap'
					},
					{
						data: 'priorita',
						title: 'Urgenza',
						render: renderPriorita,
						'class': 'col-priorita nowrap'
					},
					{
						data: 'inAssistenza',
						title: 'In assistenza',
						render: renderInAssistenza
					}
				];
			} else {
				vm.dtPv.dtInstance.changeData( getData );
			}

			//////////////////////////////////////////////////////////////////////////


			function renderCliente( data, type, row ) {
				var iconaBloccato = row.bloccato ? '<i class="fa fa-exclamation-triangle text-danger" bs-tooltip data-title="Cliente bloccato"></i>' : '';
				if ( type === 'display' ) {
					data = '<button class="btn btn-primary btn-xs" title="apri cliente" ng-click="rpc.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></button> ' + iconaBloccato + row.idCliente + '-' + data;
				}
				return data;
			}

			function renderCodice( data, type, row ) {
				if ( type === 'display' ) {
					data = '<a title="apri ' + ( row.realizzativo ? 'realizzazione' : 'postvendita' ) + '" ng-click="rpc.readPv(' + row.idPostvendita + ')">' + data + '</a>';
					if ( Date.parse( row.dataPrevChiusura ) < Date.now() ) {
						data += ' <i class="fa fa-clock-o text-danger" title="Scaduto"></i>';
					}
				}
				return data;
			}

			function renderPriorita( data, type, row ) {
				data = '<span class="priorita priorita-' + row.idPriorita + '"></span>';
				return data;
			}

			function renderInAssistenza( data ) {
				return data ? 'Sì' : 'No';
			}

		}

		function dtCliente() {

			var getData = function () {
				var pvPromise = api.pv().list( vm.sp );
				pvPromise.then( function ( data ) {
				vm.dtCliente.count = data.length;
				}, setAlerts );
				return pvPromise;
			};

			function setAlerts(response) {
				vm.showResults = false;
				vm.alerts = {
					status: response.status,
					messages: response.data.warnings
				};
			}

			if ( angular.isUndefined( vm.dtCliente.dtInstance ) ) {
				vm.dtCliente.dtInstance = {};
				vm.dtCliente.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
					.fromFnPromise( getData )
					.withOption( 'order', [[0, 'asc']] )
					.withOption( 'info', false )
					.withOption( 'lengthChange', false )
					.withOption( 'searching', true )
					.withOption( 'paging', true )
					.withButtons( [ {
						extend: 'excelHtml5',
						action: logExport,
						text: 'Esporta',
						className: 'btn-info btn-sm btn-separate',
						filename: 'pv',
						exportOptions: {
							orthogonal: 'filter'
						}
					}, {
						text: '<i class="fa fa-file-pdf-o fa-fw"></i>&nbsp;Report PDF',
						className: 'btn-primary btn-sm btn-separate margin-left',
						action: reportPdf
					} ] )
					.withOption( 'pageLength', 25 )
				);
				vm.dtCliente.dtColumns = [
					{
						data: 'idCliente',
						visible: false
					},
					{
						data: 'cliente',
						title: 'Cliente',
						render: renderCliente,
						'class': 'col-cliente'
					},
					{
						data: 'pv',
						title: 'Ticket',
						'class': 'col-pv'
					},
					{
						data: 'pvPagamento',
						title: 'a pagamento',
						'class': 'col-pv'
					},
					{
						data: 'realizzazioni',
						title: 'Realizzazioni',
						'class': 'col-realizzazioni'
					},
					{
						data: 'durataAttivita',
						title: 'Durata Attivita (hh:mm)',
						'class': 'col-ordine nowrap'
					},
					{
						data: 'durataAttivitaPagamento',
						title: 'a pagamento (hh:mm)',
						'class': 'col-ordine nowrap'
					}
				];
			} else {
				vm.dtCliente.dtInstance.changeData( getData );
			}

			//////////////////////////////////////////////////////////////////////////


			function renderCliente( data, type, row ) {
				var iconaBloccato = row.bloccato ? '<i class="fa fa-exclamation-triangle text-danger" bs-tooltip data-title="Cliente bloccato"></i>' : '';
				if ( type === 'display' ) {
					data = '<a title="apri cliente" ng-click="rpc.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></a> ' + iconaBloccato + row.idCliente + '-' + data;
				}
				return data;
			}

		}

		function dtAttivita() {

			var getData = function () {
				var pvPromise = api.pv().list( vm.sp );
				pvPromise.then( function ( data ) {
					vm.dtAttivita.count = data.length;
				}, setAlerts );
				return pvPromise;
			};

			function setAlerts(response) {
				vm.showResults = false;
				vm.alerts = {
					status: response.status,
					messages: response.data.warnings
				};
			}

			if ( angular.isUndefined( vm.dtAttivita.dtInstance ) ) {
				vm.dtAttivita.dtInstance = {};
				vm.dtAttivita.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
					.fromFnPromise( getData )
					.withOption( 'order', [[4, 'asc']] )
					.withOption( 'info', false )
					.withOption( 'lengthChange', false )
					.withOption( 'searching', true )
					.withOption( 'paging', true )
					.withButtons( [ {
						extend: 'excelHtml5',
						action: logExport,
						text: 'Esporta',
						className: 'btn-info btn-sm btn-separate',
						filename: 'pv-attivita',
						exportOptions: {
							orthogonal: 'filter'
						}
					}, {
						text: '<i class="fa fa-file-pdf-o fa-fw"></i>&nbsp;Report PDF',
						className: 'btn-primary btn-sm btn-separate margin-left',
						action: reportPdf
					} ] )
					.withOption( 'pageLength', 25 )
				);
				vm.dtAttivita.dtColumns = [
				{
					data: 'codice',
					title:'Codice',
					render: renderCodice,
					'class': 'col-codice nowrap'
				},
				{
					data: 'cliente',
					title: 'Cliente',
					render: renderCliente,
					'class': 'col-cliente'
				},
				{
					data: 'descrizioneTicket',
					title: 'Descrizione Ticket',
					'class': 'col-descrizione nowrap preformattedText',
					render: dtFactory.renders.longtext
				},
				{
					data: 'descrizioneAttivita',
					title: 'Descrizione Attivita',
					'class': 'col-descrizione nowrap preformattedText',
					render: dtFactory.renders.longtext
				},
				{
					data: 'dataInizioAttivita',
					title: 'Data Inizio',
					render: dtFactory.renders.datetime,
					'class': 'col-date-time nowrap'
				},
				{
					data: 'dataFineAttivita',
					title: 'Data Fine',
					render: dtFactory.renders.datetime,
					'class': 'col-date-time nowrap'
				},
				{
					data: 'durata',
					title: 'Durata',
					'class': 'col-time'
				},
				{
					data: 'inAssistenza',
					title: 'In assistenza',
					render: renderBoolean
				},
				{
					data: 'inSede',
					title: 'In sede',
					render: renderBoolean
				},
				{
					data: 'soggetto',
					title: 'Assegnato',
					'class': 'col-user-fullname nowrap'
				}
				];
			} else {
				vm.dtAttivita.dtInstance.changeData( getData );
			}

			//////////////////////////////////////////////////////////////////////////


			function renderCliente( data, type, row ) {
				var iconaBloccato = row.bloccato ? '<i class="fa fa-exclamation-triangle text-danger" bs-tooltip data-title="Cliente bloccato"></i>' : '';
				if ( type === 'display' ) {
				data = '<a title="apri cliente" ng-click="rpc.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></a> ' + iconaBloccato + row.idCliente + '-' + data;
				}
				return data;
			}

			function renderCodice( data, type, row ) {
				if ( type === 'display' ) {
					data = '<a title="apri ' + ( row.realizzativo ? 'realizzazione' : 'postvendita' ) + '" ng-click="rpc.readPv(' + row.idPostvendita + ')">' + data + '</a>';
					if ( Date.parse( row.dataPrevChiusura ) < Date.now() ) {
						data += ' <i class="fa fa-clock-o text-danger" title="Scaduto"></i>';
					}
				}
				return data;
			}

			function renderBoolean( data ) {
				return data ? 'Sì' : 'No';
			}

		}

		function reportPdf() {
			api.pv().reportPdf( angular.copy( vm.sp ) );
		}

		function logExport( e, dt, node, config ) {
			var data = {
				url: api.pv().url,
				numRecords: dt.data().length,
				filter: angular.copy( vm.sp )
			};
			dtFactory.logExportHtml5( data, this, e, dt, node, config );  // eslint-disable-line angular/controller-as-vm
		}

	}

} )();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ReportsController', ReportsController);

  function ReportsController(api) {
    var vm = this;

    vm.categorie = {};
    vm.getLink = getLink;

    api.reports.list()
      .then(onReportsGetSuccess);

    ////////////////////////////////////////////////////////////////////////////
    function onReportsGetSuccess(reports) {
      vm.categorie = _.groupBy(reports, function(report) {
        return report.categoria;
      });
    }

    function getLink(report) {
      var link = '';

      if (!_.isEmpty(report.link)) {
        link = report.link;
      } else if (report.categoria === 'Grafici') {
        link = '#/reports/charts/' + report.codice;
      } else {
        link = '#/reports/' + report.codice;
      }

      return link;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .directive('g1Report', g1ReportDirective);

  function g1ReportDirective() {
    return {
      restrict: 'A',
      templateUrl: 'app/core/reports/report.tpl.html',
      scope: {
        reportOptions: '=',
        reportDtOptions: '='
      },
      link: linkFn,
      controller: controllerFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, iElement, iAttrs, ctrl) {
      scope.descrizione = 'Report';
      scope.dtReport = {
        show: false
      };

      scope.$watchCollection('reportOptions', handleChanges);
      scope.$watchCollection('reportDtOptions', handleChanges);

      ctrl.getReport(iAttrs.reportId);

      //////////////////////////////////////////////////////////////////////////
      function handleChanges(newVal, oldVal) {
        if (newVal !== oldVal) {
          ctrl.getReport(iAttrs.reportId);
        }
      }
    }

    function controllerFn($scope, $q, $filter, dtFactory, DTOptionsBuilder, api) {
      var ctrl = this;

      ctrl.getReport = getReport;

      //////////////////////////////////////////////////////////////////////////
      function getReport(id) {
        $scope.dtReport.show = false;

        api.report(id).get($scope.reportOptions)
          .then(onReportGetSuccess);

        function onReportGetSuccess(reportData) {
          $scope.descrizione = reportData.descrizione;
          $scope.report = reportData.dati;

          //se ci sono già i totali estraggo la riga dei totali dal report
          if (reportData.wTotals === true) {
            var rigaTotali = $filter('filter')(reportData.dati, {idRiga: 'tot.'}, true)[0];
            $scope.report = $filter('filter')(reportData.dati, {idRiga: '!tot.'}, true);
          }

          //crea datatable
          $scope.dtReport.dtInstance = {};

          if ($scope.report.length > 0) {
            $scope.dtReport.dtColumns = [];

            angular.forEach($scope.report[0], function(value, key) {
              var columnDef = {};

              columnDef.data = key.replace('.', '\\.');

              //elabora nome campo per info sul tipo di dati
              if (key.indexOf('~') !== -1) {
                key = key.split('~');

                columnDef.title = key[0];
                columnDef.type = key[1];

                //gestione delle colonne nascoste
                if (columnDef.type === 'h') {
                  columnDef.visible = false;
                  columnDef.searchable = false;
                }

                //gestione delle colonne long text
                if (columnDef.type === 'lt') {
                  columnDef['class'] = '';
                }
              } else {
                columnDef.title = key;
              }

              //controlla se l'header è una data e convertila
              // if (moment(columnDef.title, 'YYYY-MM-DDTHH:mm:ss.000ZZ', true).isValid()) {
              if (moment(columnDef.title, 'YYYY-MM-DD', true).isValid()) {
                columnDef.title = moment(columnDef.title).format('DD-MM');
              } else if (moment(columnDef.title, 'YYYY-MM', true).isValid()) {
                columnDef.title = moment(columnDef.title).format('MMM YY');
              }

              //formattazioni
              columnDef.render = formatData;

              if (angular.isNumber(value)) {
                columnDef['class'] = 'text-right';
              }

              $scope.dtReport.dtColumns.push(columnDef);
            });
          } else {
            $scope.dtReport.dtColumns = [
              {data: null, title: 'idRiga'},
              {data: null, title: 'Nessun Risultato'}
            ];
          }

          //nascondi prima colonna
          $scope.dtReport.dtColumns[0].visible = false;
          $scope.dtReport.dtColumns[0].searchable = false;

          //crea array ordinamenti
          var orderArray = [];
          if (angular.isArray($scope.reportDtOptions.order)) {
            orderArray = $scope.reportDtOptions.order;
          } else {
            for (var i = 1; i <= reportData.staticCols; i++) {
              orderArray.push([i, 'asc']);
            }
          }

          //opzioni datable
          $scope.dtReport.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              return $q.when($scope.report);
            })
            .withOption('order', orderArray)
          );

          if ($scope.reportDtOptions.totals !== false) {
            $scope.dtReport.dtOptions
              .withOption('footerCallback', renderTotals)
            ;
          } else {
            if ($scope.report.length > 0) {
              //nascondi ultima colonna
              $scope.dtReport.dtColumns[$scope.dtReport.dtColumns.length - 1].visible = false;
              $scope.dtReport.dtColumns[$scope.dtReport.dtColumns.length - 1].searchable = false;
            }
          }

          if ($scope.reportDtOptions.paginate === false) {
            $scope.dtReport.dtOptions
              .withOption('info', false)
              .withOption('lengthChange', false)
              .withOption('searching', false)
              .withOption('paging', false)
            ;
          }

          if ($scope.reportDtOptions.compact === true) {
            $scope.dtReport.dtOptions.withOption('dom', 'rt');
          }

          //visualizza datatable
          $scope.dtReport.show = true;

          ////////////////////////////////////////////////////////////////////////
          function formatData(data, type, row, meta) {
            if (type === 'display') {
              var dataType = meta.settings.aoColumns[meta.col].type;

              switch (dataType) {
                case 'dt':
                  data = dtFactory.renders.datetime(data, type);
                  break;

                case 'd':
                  data = dtFactory.renders.date(data, type);
                  break;

                case 't':
                  data = dtFactory.renders.time(data, type);
                  break;

                case 'lt':
                  data = dtFactory.renders.longtext(data, type);
                  break;

                case 'i':
                  data = formatNumber(data, 0);
                  break;

                case 'f':
                  data = formatNumber(data, 2);
                  break;

                default:
                  //FIXME: questo non viene ancora gestito con il metodo "valore~formato"
                  if (angular.isNumber(data)) {
                    dataType = 'f'; //a default tutti a float

                    //report specifici ad integer
                    var intReports = ['esap', 'aagg', 'apgg', 'apgen', 'cprt', 'esapext', 'aaggext', 'apggext', 'opse', 'pvpr', 'pvfp'];
                    if (intReports.indexOf(id) !== -1) {
                      dataType = 'i';
                    }

                    //tipologia specifica ad integer
                    if ($scope.reportOptions.tipo === 'qta') {
                      dataType = 'i';
                    }

                    //esegui formattazione
                    switch (dataType) {
                      case 'i':
                        data = formatNumber(data, 0);
                        break;

                      case 'f':
                        data = formatNumber(data, 2);
                        break;
                    }
                  }
              }
            }

            return data;

            //////////////////////////////////////////////////////////////////////
            function formatNumber(number, decimals) {
              if (number === 0) {
                number = '';
              } else {
                number = $filter('number')(number, decimals);
              }

              return number;
            }
          }

          function renderTotals(tfoot, data) {
            /* eslint-disable angular/controller-as-vm */
            var _this = this;

            if (data.length > 1) {
              $scope.$apply(function() {
                // imposta variabile vuota per ospitare riga dei totali
                var rowTotals = [];

                // svuota footer
                var $footer = angular.element(tfoot);
                $footer.empty();

                // se la risposta contiene l'elemento "totali" usa la riga dei totali calcolata lato server
                if (angular.isObject(reportData.totali)) {
                  _this.api().columns().every(setTotaliSums);
                // se il report contiene già la riga dei totali non calcolare niente
                } else if (reportData.wTotals === true) {
                  // se esiste la riga dei totali lato server mettila nel footer
                  if(angular.isDefined(rigaTotali)) {
                    _this.api().columns().every(setSums);
                  }
                } else {
                  // calcola totali
                  _this.api().columns().every(makeSums);
                }

                //////////////////////////////////////////////////////////////////
                function makeSums(ci) {
                  if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
                    var sum = '';

                    if (ci > reportData.staticCols) { //esegui le somme
                      sum = this
                        .data()
                        .reduce(function(a,b) {
                          return a + b;
                        });
                      rowTotals[ci] = sum; //ATTENZIONE: non spostare sotto il filter
                      sum = $filter('number')(sum, 2);

                      //GESTIONE TOTALE COLONNE CALCOLATE
                      switch (id) {
                        case 'opst':
                          if ($scope.dtReport.dtColumns[ci].title === 'Conversione') {
                            var indexChiusaPositiva = _.findIndex($scope.dtReport.dtColumns, {title: 'chiusa positiva'});

                            if (indexChiusaPositiva !== -1) {
                              sum = (rowTotals[indexChiusaPositiva] / rowTotals[ci - 1]) * 100;
                              sum = $filter('number')(sum, 2);
                              sum = sum ? (sum + '%') : '';
                            }
                          }
                          break;
                      }
                    }

                    $footer.append('<th style="text-align: right;">' + sum + '</th>');
                  }
                }

                function setSums(ci) {
                  if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
                    var colonna = _this.api().column(ci).dataSrc().replace(/'/g, '\\\'');

                    $footer.append('<th style="text-align: right;">' + rigaTotali[colonna] + '</th>');
                  }
                }

                function setTotaliSums(ci) {
                  if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
                    var colonna = _this.api().column(ci).dataSrc().replace(/\\\./g, '.');
                    var sum = reportData.totali[colonna];
                    var style = angular.isNumber(sum) ? ' style="text-align: right;"' : ''; //allinea a destra solo i numeri

                    if (sum === null || angular.isUndefined(sum)) {
                      sum = '';
                    } else {
                      //stessa formattazione delle celle della colonna
                      sum = formatData(sum, 'display', null, {settings: _this.api().settings()[0], col: ci});
                    }

                    $footer.append('<th' + style + '>' + sum + '</th>');
                  }
                }
              });
            }
            /* eslint-enable angular/controller-as-vm */
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ReportController', ReportController);

  function ReportController(
    $window, $routeParams, $scope, $q, $filter, dtFactory, DTOptionsBuilder, api,
    apiBaseUrl, Logger
  ) {
    var vm = this;

    var history_sr = [];

    vm.idReport = $routeParams.repId;
    vm.descrizione = 'Report';
    vm.info = '';
    vm.sottotitolo = '';
    vm.formData = {};
    vm.sr = {};
    vm.dtReport = {
      show: false
    };
    vm.report = {};
    vm.historyBack = historyBack;
    vm.resetForm = firstSearch;
    vm.search = search;
    vm.export = exportFn;
    vm.openReport = openReport;
    vm.levelUp = levelUp;
    vm.filtraGruppi = api.prodotti.filtraGruppi;

    vm.readCliente = api.clienti.actions.read;
    vm.readContratto = api.contratti.actions.read;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.readOpportunita = api.opportunita().actions.read;
    vm.readPv = function ( idPv ) {
      return api.pv().actions.read( idPv );
    }

    //carica form del report
    api.report(vm.idReport).searchForm()
      .then(formLoaded);

    ////////////////////////////////////////////////////////////////////////////
    function formLoaded(formData) {
      vm.formData = formData;

      vm.descrizione = vm.formData.descrizione;
      vm.info = vm.formData.info;
      vm.sottotitolo = vm.formData.sottotitolo;

      //impostazioni per i report che hanno il tipoData
      if (angular.isDefined(formData.tipoData)) {
        onChangeTipoData(vm.formData.tipoData);

        $scope.$watch('report.sr.tipoData', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            onChangeTipoData(newVal);

            vm.search();
          }
        });
      }

      firstSearch();
    }

    function onChangeTipoData(tipoData) {
      var type2desc = {
        ins: 'Dichiarato',
        cnf: 'Consuntivo',
        crm: 'Attivazione'
      };

      vm.descrizione = vm.formData.descrizione + ' ' + type2desc[tipoData];

      vm.sr['idStatiContratto[]'] = setStati(vm.formData.statiContratto, tipoData);

      function setStati(stati, tipoData) {
        var idStati4tipoData = [];

        switch (tipoData) {
          case 'ins':
            idStati4tipoData = _.map($filter('filter')(stati, {gruppo: '!4 ANNULLATO'}, true), 'value');
            break;

          case 'cnf':
            angular.forEach(stati, function(value) {
              if (value.gruppo === '1 OK' || value.gruppo === '2 LAVORAZIONE') {
                idStati4tipoData.push(value.value);
              }
            });
            break;

          case 'crm':
            // idStati4tipoData = _.map($filter('filter')(stati, {gruppo: '1 OK'}, true), 'value');
            idStati4tipoData = ['3', '5', '6', '13'];
            break;
        }

        return idStati4tipoData;
      }
    }

    function historyBack() {
      $window.history.back();
    }

    function firstSearch() {
      vm.dtReport.show = false;

      vm.sr = {
        l: 0,
        dataFrom: (vm.formData.intervallo ? vm.formData.intervallo.from : undefined),
        dataTo: (vm.formData.intervallo ? vm.formData.intervallo.to : undefined),
        anno: vm.formData.anno,
        tipo: vm.formData.tipo,
        tipoDisabled: false,
        tipoData: vm.formData.tipoData,
        gb: vm.formData.gb,
        gr: vm.formData.gr,
        ass: vm.formData.ass,
        gbDisabled: false,
        fornitore: vm.formData.fornitore,
        fornitoreRequired: false,
        pista: vm.formData.pista,
        pistaRequired: false,
        sottopista: vm.formData.sottopista,
        tipoSoggetto: vm.formData.tipoSoggetto,
        ptf: vm.formData.ptf,
        tipoContratto: vm.formData.tipoContratto,
        conScadenza: '',
        pagamento: '',
        provvigioneRicorrente: '',
        valoreProvvigioni: '1',
        'idStatiContratto[]': vm.formData.idStatiContratto,
        'idGruppi[]': vm.formData.idGruppi,
        'idStatiOpportunita[]': vm.formData.idStatiOpportunita,
        'idStatiPostvendita[]': vm.formData.idStatiPostvendita,
        'idCategoriePostvendita[]': vm.formData.idCategoriePostvendita,
        'idFonti[]': vm.formData.idFonti,
        'idAgenti[]': vm.formData.idAgenti,
        contrattoObsoleto: '0'
      };

      //overload dei defaults della form dai parametri della route
      angular.forEach($routeParams, function(value, key) {
        if (angular.isDefined(vm.sr[key])) {
          vm.sr[key] = value;

          if (key === 'tipoData') {
            onChangeTipoData(value);
          }
        }
      });

      history_sr = [];

      dtReport();
    }

    function search() {
      vm.dtReport.show = false;

      dtReport();
    }

    function exportFn() {
      var exportData = angular.copy(vm.sr);
      if (_.isDate(exportData.dataFrom)) {
        exportData.dataFrom = exportData.dataFrom.toISOString();
      }
      if (_.isDate(exportData.dataTo)) {
        exportData.dataTo = exportData.dataTo.toISOString();
      }
      exportData.export = 'xlsx';

      dtFactory.exportFile(apiBaseUrl + '/reports/' + vm.idReport, exportData);
    }

    function dtReport() {
      //salva attuale stato richiesta nella history
      //history_sr[vm.sr.l] = angular.copy(vm.sr);
      history_sr[vm.sr.l] = {
        r: vm.sr.r,
        rd: vm.sr.rd,
        c: vm.sr.c,
        cd: vm.sr.cd
      };

      //impostazioni della form specifiche per report
      switch (vm.idReport) {
        case 'esap':
          vm.sr.tipoDisabled = (vm.sr.l >= 2);
          break;
      }

      //gestione disabled per switch gb
      vm.sr.gbDisabled = (vm.sr.l >= 1);

      //get report
      api.report(vm.idReport).get(vm.sr)
        .then(onReportGetSuccess);

      function onReportGetSuccess(reportData) {
        if ( vm.idReport == 'clienti' && vm.sr.l == 0 ) { // elaborazione speciale per allineare i dati al formato atteso
          var reg = [ 'FVG', 'Veneto', 'Altro' ]; // solo 3 possibilità: devo assicurarmi che ogni agente abbia un valore
          var agenti = [];
          for ( var i in reportData.dati ) { // ciclo per normalizzare
            var row = reportData.dati[i];
            if ( ! agenti[row.IDAgente] ) {
              agenti[row.IDAgente] = {
                Nome: row.agente
              };
            }
            var agente = agenti[row.IDAgente];
            agente[row.Reg] = row.numRows;
          }
          reportData.dati = [];
          var tot = {
            FVG: 0,
            Veneto: 0,
            Altro: 0
          }
          for ( i in agenti ) {
            agente = agenti[i];
            for ( var j in reg ) {
              if ( ! agente[reg[j]] ) {
                agente[reg[j]] = 0;
              }
            }
            tot.FVG += agente.FVG;
            tot.Veneto += agente.Veneto;
            tot.Altro += agente.Altro;
            reportData.dati.push( {
              idRiga: i,
              Nome: agente.Nome,
              FVG: agente.FVG,
              Veneto: agente.Veneto,
              Altro: agente.Altro,
              Tot: agente.FVG + agente.Veneto + agente.Altro
            } );
          }
          reportData.dati.push( {
            idRiga: 'tot.',
            Nome: 'Totale',
            FVG: tot.FVG,
            Veneto: tot.Veneto,
            Altro: tot.Altro,
            Tot: tot.FVG + tot.Veneto + tot.Altro
          } );
        }
        vm.report = reportData.dati;
        //se ci sono già i totali estraggo la riga dei totali dal report
        if (reportData.wTotals === true) {
          var rigaTotali = $filter('filter')(reportData.dati, {idRiga: 'tot.'}, true)[0];
          vm.report = $filter('filter')(reportData.dati, {idRiga: '!tot.'}, true);
        }

        //crea datatable
        vm.dtReport.dtInstance = {};

        if (vm.report.length > 0) {
          vm.dtReport.dtColumns = [];

          angular.forEach(vm.report[0], function(value, key) {
            var columnDef = {};

            columnDef.data = key.replace('.', '\\.');

            //elabora nome campo per info sul tipo di dati
            if (key.indexOf('~') !== -1) {
              key = key.split('~');

              columnDef.title = key[0];
              columnDef.type = key[1];

              //gestione delle colonne nascoste
              if (columnDef.type === 'h') {
                columnDef.visible = false;
                columnDef.searchable = false;
              }

              //gestione delle colonne long text
              if (columnDef.type === 'lt') {
                columnDef['class'] = '';
              }
            } else {
              columnDef.title = key;
            }

            //controlla se l'header è una data e convertila
            // if (moment(columnDef.title, 'YYYY-MM-DDTHH:mm:ss.000ZZ', true).isValid()) {
            if (moment(columnDef.title, 'YYYY-MM-DD', true).isValid()) {
              columnDef.title = moment(columnDef.title).format('DD-MM');
            } else if (moment(columnDef.title, 'YYYY-MM', true).isValid()) {
              columnDef.title = moment(columnDef.title).format('MMM YY');
            }

            //links
            if (vm.sr.l !== reportData.lMax) {
              columnDef.render = renderReportLink;
            } else {
              columnDef.render = renderModalsLink;
            }

            //overload gestione links specifico per il report Provvigioni degli agenti
            if ( vm.idReport === 'prov' &&
              vm.sr.l > 0 &&
              angular.isDefined(vm.sr.c)
            ) {
              columnDef.render = renderModalsLink;
            }

            //formattazioni
            if (angular.isNumber(value)) {
              columnDef['class'] = 'text-right';
            }

            vm.dtReport.dtColumns.push(columnDef);
          });

          //GESTIONE COLONNA CALCOLATA
          if (vm.sr.l < reportData.lMax) {
            var calculatedColumnDef = {};

            switch (vm.idReport) {
              case 'opst':
              case 'opse':
                calculatedColumnDef.title = 'Conversione';
                calculatedColumnDef.data = null;
                calculatedColumnDef.type = 'f';
                calculatedColumnDef['class'] = 'min-width text-right';

                calculatedColumnDef.render = function(data, type, row, meta) {
                  data = (row['chiusa positiva'] / row['tot.']) * 100;

                  //formattazioni
                  data = formatData(data, type, row, meta);

                  return data ? (data + '%') : '';
                };

                vm.dtReport.dtColumns.push(calculatedColumnDef);
                break;
            }
          }
        } else {
          vm.dtReport.dtColumns = [
            {data: null, title: 'idRiga'},
            {data: null, title: 'Nessun Risultato'}
          ];
        }

        //nascondi prima colonna
        vm.dtReport.dtColumns[0].visible = false;
        vm.dtReport.dtColumns[0].searchable = false;

        //crea array ordinamenti
        var orderArray = [];
        for ( i = 1; i <= reportData.staticCols; i++) {
          orderArray.push([i, 'asc']);
        }

        vm.dtReport.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return $q.when(vm.report);
          })
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-sm btn-info',
              filename: 'Report',
              exportOptions: {
                orthogonal: 'filter',
                columns: ':visible'
              }
            }
          ])
          .withOption('footerCallback', renderTotals)
          .withOption('order', orderArray)
          .withOption('pageLength', 25)
        );

        vm.dtReport.show = true;

        ////////////////////////////////////////////////////////////////////////
        function formatData(data, type, row, meta) {
          if (type === 'display'|| type === 'filter') {
            var dataType = meta.settings.aoColumns[meta.col].type;
            switch (dataType) {
              case 'dt':
                data = dtFactory.renders.datetime(data, type);
                break;

              case 'd':
                data = dtFactory.renders.date(data, type);
                break;

              case 't':
                data = dtFactory.renders.time(data, type);
                break;

              case 'lt':
                data = dtFactory.renders.longtext(data, type);
                break;

              case 'i':
                data = formatNumber(data, 0, type);
                break;

              case 'f':
                data = formatNumber(data, 2, type);
                break;

              default:
                //FIXME: questo non viene ancora gestito con il metodo "valore~formato"
                if (angular.isNumber(data)) {
                  dataType = 'f'; //a default tutti a float

                  //report specifici ad integer
                  var intReports = ['esap', 'aagg', 'apgg', 'apgen', 'cprt', 'esapext', 'aaggext', 'apggext', 'opse', 'pvpr', 'pvfp', 'clienti'];
                  if (intReports.indexOf(vm.idReport) !== -1) {
                    dataType = 'i';
                  }

                  //tipologia specifica ad integer
                  if (vm.sr.tipo === 'qta') {
                    dataType = 'i';
                  }

                  //esegui formattazione
                  switch (dataType) {
                    case 'i':
                      data = formatNumber(data, 0, type);
                      break;

                    case 'f':
                      data = formatNumber(data, 2, type);
                      break;
                  }
                }
            }
          }

          return data;

          //////////////////////////////////////////////////////////////////////
          function formatNumber(number, decimals, type) {
            if (type === 'display') {
              if (number === 0) {
                number = '';
              } else {
                number = $filter('number')(number, decimals);
              }
            }

            return number;
          }
        }

        function renderReportLink(data, type, row, meta) {
          if (meta.col > 0) {
            //formattazioni
            data = formatData(data, type, row, meta);

            //links
            var numCols = Object.keys(row).length - 1;

            if (vm.idReport === 'avtim') {
              numCols += 1;
            }

            if (meta.col < numCols) {
              if (type === 'display') {
                var api = new $.fn.dataTable.Api(meta.settings);
                var riga, rigaDesc, colonna, colonnaDesc, tmp;

                riga = row.idRiga;
                if ( riga instanceof String ) {
                  riga = riga.replace(/'/g, '\\\'');
                }
                rigaDesc = row[api.column(reportData.staticCols).dataSrc()].replace(/'/g, '\\\'');
                if (meta.col <= reportData.staticCols) {
                  data = '<a title="Apri report" ng-click="report.openReport(\'' + riga + '\', \'' + rigaDesc + '\')"><b>' + data + '</b></a>';
                } else {
                  colonna = api.column(meta.col).dataSrc().replace(/'/g, '\\\'');
                  if (colonna.indexOf('~') !== -1) {
                    //pulisci nome di colonna da eventuali aggiunte ad uso formattazione
                    colonnaDesc = colonna.split('~');
                    colonnaDesc = colonnaDesc[0];
                  } else {
                    colonnaDesc = colonna;
                  }

                  //FIXME: cercare un metodo migliore per acquisire il nome di colonna già formattato
                  //controlla se l'header è una data e convertila
                  tmp = colonnaDesc.replace('\\', ''); //WORKAROUND necessario per la presenza del 'punto' che viene escapato da DataTables
                  if (moment(tmp, 'YYYY-MM-DDTHH:mm:ss.000ZZ', true).isValid()) {
                    colonnaDesc = moment(tmp).format('DD-MM').toString();
                  }
                  data = '<a title="Apri report" ng-click="report.openReport(\'' + riga + '\', \'' + rigaDesc + '\', \'' + colonna + '\', \'' + colonnaDesc + '\')">' + data + '</a>';
                }
              }
            }
          }

          return data;
        }

        function renderModalsLink(data, type, row, meta) {
          var tmp, id, tooltip;

          //acquisisci eventuale id collegato al campo
          if (isNaN(data)) {
            tmp = data.split('~');
            if (tmp.length === 2) {
              id = tmp[1];
              data = tmp[0];
            }
          }

          //formattazioni
          data = formatData(data, type, row, meta);

          //links
          if ((type === 'display') && (typeof(id) !== 'undefined')) {
            var api = new $.fn.dataTable.Api(meta.settings);

            var columnHeader = api.column(meta.col).dataSrc();
            //pulisci l'header da eventuali aggiunte ad uso formattazione
            if (columnHeader.indexOf('~') !== -1) {
              columnHeader = columnHeader.split('~');
              columnHeader = columnHeader[0];
            }

            switch (columnHeader) {
              case 'Appuntamento':
                tooltip = '';
                if (row['noteAgente~h'] !== '') {
                  tooltip += 'NOTE AGENTE:<br>' + _.escape(row['noteAgente~h']) + '<br>';
                }
                if (row['noteOperatore~h'] !== '') {
                  tooltip += 'NOTE OPERATORE:<br>' + _.escape(row['noteOperatore~h']) + '<br>';
                }
                if (tooltip === '') {
                  tooltip = 'Apri Appuntamento';
                }

                data = '<a bs-tooltip data-container="body" data-placement="auto left" data-title="' + tooltip + '" ng-click="report.readAppuntamento(\'' + id + '\')">' + data + '</a>';
                break;

              case 'Cliente':
                data = '<a title="apri cliente" ng-click="report.readCliente(\'' + id + '\')">' + data + '</a>';
                break;

              case 'Contratto':
                data = '<a title="apri contratto" ng-click="report.readContratto(\'' + id + '\')">' + data + '</a>';
                break;

              case 'Ticket':
                id = id.split('-');
                data = '<a title="apri ticket" ng-click="report.readPv(\'' + id[1] + '\')">' + data + '</a>';
                break;

              case 'Stato Opp':
                data = '<a title="apri opportunità" ng-click="report.readOpportunita(\'' + id + '\')">' + data + '</a>';
                break;

              default:
                Logger.warn('link su ' + columnHeader + ' non gestito!!!');
            }
          }

          return data;
        }

        function renderTotals(tfoot, data) {
          /* eslint-disable angular/controller-as-vm */
          var _this = this;

          if (data.length > 1) {
            $scope.$apply(function() {
              // imposta variabile vuota per ospitare riga dei totali
              var rowTotals = [];

              // svuota footer
              var $footer = angular.element(tfoot);
              $footer.empty();

              // se il report contiene già la riga dei totali non calcolare niente
              if (reportData.wTotals === true) {
                // se esiste la riga dei totali lato server mettila nel footer
                if(angular.isDefined(rigaTotali)) {
                  _this.api().columns().every(setSums);
                }
              } else {
                // calcola totali
                _this.api().columns().every(makeSums);
              }

              //////////////////////////////////////////////////////////////////
              function makeSums(ci) {
                if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
                  var sum = '';

                  if (ci > reportData.staticCols) { //esegui le somme
                    sum = this
                      .data()
                      .reduce(function(a,b) {
                        return a + b;
                      });
                    rowTotals[ci] = sum; //ATTENZIONE: non spostare sotto il filter
                    sum = $filter('number')(sum, 2);

                    //GESTIONE TOTALE COLONNE CALCOLATE
                    switch (vm.idReport) {
                      case 'opst':
                        if (vm.dtReport.dtColumns[ci].title === 'Conversione') {
                          var indexChiusaPositiva = _.findIndex(vm.dtReport.dtColumns, {title: 'chiusa positiva'});

                          if (indexChiusaPositiva !== -1) {
                            sum = (rowTotals[indexChiusaPositiva] / rowTotals[ci - 1]) * 100;
                            sum = $filter('number')(sum, 2);
                            sum = sum ? (sum + '%') : '';
                          }
                        }
                        break;
                    }
                  }

                  $footer.append('<th style="text-align: right;">' + sum + '</th>');
                }
              }

              function setSums(ci) {
                if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
                  var colonna = _this.api().column(ci).dataSrc().replace(/'/g, '\\\'');

                  $footer.append('<th style="text-align: right;">' + rigaTotali[colonna] + '</th>');
                }
              }
            });
          }
          /* eslint-enable angular/controller-as-vm */
        }

        function logExport(e, dt, node, config) {
          var data = {
            url: apiBaseUrl + '/reports/' + vm.idReport,
            numRecords: dt.data().length,
            filter: angular.copy(vm.sr)
          };

          dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
        }
      }
    }

    function openReport(riga, rigaDesc, colonna, colonnaDesc) {
      if (typeof(colonna) !== 'undefined') {
        vm.sr.l = vm.sr.l + 1;
        vm.sr.r = riga;
        vm.sr.c = colonna;
        vm.sr.rd = rigaDesc;
        vm.sr.cd = colonnaDesc;
      } else if (typeof(riga) !== 'undefined') {
        vm.sr.l = vm.sr.l + 1;
        vm.sr.r = riga;
        vm.sr.rd = rigaDesc;
      }

      search();
    }

    function levelUp() {
      vm.sr.l = vm.sr.l - 1; //porta indietro prima il livello poi il resto
      vm.sr.r = history_sr[vm.sr.l].r;
      vm.sr.rd = history_sr[vm.sr.l].rd;
      vm.sr.c = history_sr[vm.sr.l].c;
      vm.sr.cd = history_sr[vm.sr.l].cd;

      search();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('RealizzazioniController', RealizzazioniController);

  function RealizzazioniController( $scope, $filter, AuthenticateJS, $aside, dtFactory, DTOptionsBuilder, api, $interval ) {
    var vm = this;
    var stops = [];

    var dashboardRealizzazioniAside = $aside( {
      scope: $scope,
      templateUrl: 'dashboard-realizzazioni-aside.tpl.html',
      placement: 'left',
      animation: 'am-slide-left',
      container: 'body',
      backdrop: 'static',
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.activeTab = 'dashboard';
    vm.dt = {
      show: false
    };

    //ricerca
    vm.alerts = {};
    vm.sr = searchDefaultValues();
    vm.search = search;
    vm.resetForm = resetForm;

    //dashboard
    vm.alertsK = {};
    vm.kanban = {};
    vm.kanbanFilter = '';

    vm.onDrop = onDrop;
    vm.showAside = showAside;
    vm.searchKanban = searchKanban;
    vm.resetKanban = resetKanban;
    vm.unsetFilter = unsetFilter;
    vm.readRealizzazione = function ( idRealizzazione ) {
      return api.pv().actions.read( idRealizzazione );
    }
    vm.refreshContent = dtReload;

    //imposta stop del refresh
    $scope.$on( '$destroy', stopRefresh );

    var reloadPvAutorefreshInterval = 5 * 60 * 1000; // aggiornamento automatico in 5 minuti
    var reloadPvAutorefreshTime = 0;
    var reloadPvAutorefreshTimeStep = 200;
    var reloadPvAutorefreshTimePercentage = function () {
      var perc = ( 100 * ( reloadPvAutorefreshInterval - reloadPvAutorefreshTime ) / reloadPvAutorefreshInterval );
      vm.autorefreshTimeSliderWidth = perc + '%';
      reloadPvAutorefreshTime += reloadPvAutorefreshTimeStep;
    }
    reloadPvAutorefreshTimePercentage();
    stops.push( $interval( vm.refreshContent, reloadPvAutorefreshInterval ) );
    stops.push( $interval( reloadPvAutorefreshTimePercentage, reloadPvAutorefreshTimeStep ) );

    function stopRefresh() {
      angular.forEach( stops, function ( stop ) {
        $interval.cancel( stop );
      } );
      stops = [];
    }

    vm.readCliente = api.clienti.actions.read;
    vm.readPv = api.pv().actions.read;
    vm.updatePv = api.pv().actions.update;
    vm.deletePv = api.pv().actions.delete;

    vm.realizzazioniTotali = 0;
    vm.realizzazioniAperte = 0;
    vm.realizzazioniSospese = 0;
    vm.statoDaVisualizzare = 'aperto';

    //carica i dati della form
    api.pv().searchForm( { contesto: 'realizzazioni' } ).then( function ( formData ) {
      vm.formData = formData;
      //carica il kanban
      kanbanRealizzazioni();
    } );

    $scope.$on( 'Pv.updated', dtReload );
    $scope.$on( 'Pv.deleted', dtReload );

    ////////////////////////////////////////////////////////////////////////////
    //ricerca
    function resetForm() {
      vm.dt.show = false;
      vm.alerts = {};
      vm.so = searchDefaultValues();
    }

    function search() {
      vm.alerts = {};
      vm.dt.show = true;
      if ( angular.isDefined( vm.dt.dtInstance ) ) {
        dtReload();
      } else {
        dt();
      }
    }

    function dt() {
      vm.dt.dtInstance = {};
      vm.dt.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( realizzazioniList )
        .withOption( 'order', [[5, 'asc'],[6, 'desc'],[8, 'asc']] ) // ordinamento di default: fase / ordine / data apertura
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'paging', true )
        .withOption( 'searching', false )
        .withButtons( [ {
          extend: 'excelHtml5',
          action: logExport,
          text: 'Esporta',
          className: 'btn-info btn-sm',
          filename: 'realizzazioni',
          exportOptions: {
            orthogonal: 'filter'
          }
        } ] )
      .withOption( 'createdRow', function ( row, data ) {
          if ( data.idSoggetto == vm.user.idAgente ) {
            angular.element( row ).addClass( 'highlight' );
          }
        } )
      );
      vm.dt.dtColumns = [
        {
          data: 'codice',
          title: 'Codice',
          render: renderCodice,
          'class': 'col-codice nowrap'
        },
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente,
          'class': 'col-cliente'
        },
        {
          data: 'citta',
          title: 'Città',
          'class': 'col-citta'
        },
        {
          data: 'prov',
          title: 'Prov.',
          'class': 'col-prov nowrap'
        },
        {
          data: 'pista',
          title: 'Pista',
          'class': 'col-pista nowrap'
        },
        {
          data: 'ordineStage',
          title: 'Fase',
          'class': 'col-categoria nowrap',
          render: renderStage
        },
        {
          data: 'ordine',
          visible: false
        },
        {
          data: 'descrizioneTicket',
          title: 'Descrizione',
          'class': 'col-descrizione nowrap',
          render: dtFactory.renders.longtext
        },
        {
          data: 'dataApertura',
          title: 'Apertura',
          render: dtFactory.renders.datetime,
          'class': 'col-date-time nowrap'
        },
        {
          data: 'dataInizioInstallazione',
          title: 'Installazione',
          render: renderDataInstallazione,
          'class': 'col-dataInstallazione nowrap'
        },
        {
          data: 'noteTicket',
          title: 'Note',
          'class': 'col-descrizione nowrap',
          render: dtFactory.renders.longtext
        },
        {
          data: 'soggetto',
          title: 'Assegnato',
          'class': 'col-user-fullname nowrap'
        },
        {
          data: 'durataAttivita',
          title: 'Lavorato',
          'class': 'col-time nowrap'
        }
      ];
    }

    function renderDataInstallazione( data, type, row ) {
      if ( type == 'display' ) {
        var output = data ? moment( data ).format( 'DD/MM/YYYY' ) : '';
        if ( output && row.dataFineInstallazione && ( row.dataInizioInstallazione != row.dataFineInstallazione ) ) {
          output += '-' + moment( row.dataFineInstallazione ).format( 'DD/MM/YYYY' );
        }
        return output;
      }
    }

    function renderCliente( data, type, row ) {
      if ( type === 'display' ) {
        data = '<button class="btn btn-primary btn-xs" bs-tooltip data-title="apri cliente" ng-click="pv.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></button> ' + row.idCliente + '-' + data;
      }
      return data;
    }

    function renderCodice( data, type, row ) {
      if ( type === 'display' ) {
        data = '<a title="apri ' + ( row.realizzativo ? 'realizzazione' : 'postvendita' ) + '" ng-click="rpc.readPv(' + row.idPostvendita + ')">' + data + '</a>';
        if ( Date.parse( row.dataPrevChiusura ) < Date.now() ) {
          data += ' <i class="fa fa-clock-o text-danger" title="Scaduto"></i>';
        }
      }
      return data;
    }

    function renderStage( data, type, row ) {
      if ( type == 'display' ) {
        return row.stage;
      }
      return data;
    }

    function realizzazioniList() {
      var promise = api.pv().list( vm.sr );
      promise.then( function () {
        vm.dt.show = true;
      }, setAlerts);
      return promise;

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.dt.show = false;
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    //kanban
    function kanbanRealizzazioni() {
      vm.realizzazioniTotali = 0;
      vm.realizzazioniAperte = 0;
      vm.realizzazioniSospese = 0;
      vm.alertsK = {};
      api.pv().list(vm.sr)
        .then(loadKanban, setAlerts);

      //////////////////////////////////////////////////////////////////////////
      function loadKanban( realizzazioni ) {
        vm.kanban = {};
        angular.forEach( vm.formData.stages, function ( stage ) {
          vm.kanban[stage.value] = {
            label: stage.label,
            bgColor: stage.bgColor ? '#' + stage.bgColor : 'lightgray',
            items: []
          }
        } );
        vm.realizzazioniTotali = realizzazioni.length;
        realizzazioni = $filter( 'orderBy' )( realizzazioni, 'dataOraIns' );
        angular.forEach( realizzazioni, function ( realizzazione ) {
          realizzazione.update = api.pv().actions.update;
          if ( realizzazione.idStage == 0 && vm.kanban[0] == undefined ) {
            vm.kanban[0] = {
              label: 'Fase non specificata',
              bgColor: 'lightgray',
              items: []
            }
          }
          vm.kanban[realizzazione.idStage].items.push( realizzazione );
          if ( realizzazione.stato == 'aperto' ) {
            vm.realizzazioniAperte++;
          } else {
            vm.realizzazioniSospese++;
          }
        } );
        vm.kanbanStages = Object.keys( vm.kanban ).length;
      }

      ////////////////////////////////////////////////////////////////////////

      function setAlerts(response) {
        vm.alertsK = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function searchKanban() {
      kanbanRealizzazioni();
      dashboardRealizzazioniAside.hide();
    }

    function searchDefaultValues() {
      return {
        filter: 'aperti/sospesi',
        realizzativo: true,
        datiContratti: true
      }
    }

    function resetKanban() {
      vm.sr = searchDefaultValues();
      searchKanban();
    }

    function unsetFilter(filter) {
      delete vm.sr[filter];
      kanbanRealizzazioni();
    }

    function showAside() {
      dashboardRealizzazioniAside.$promise.then(function() {
        dashboardRealizzazioniAside.show();
      });
    }

    function onDrop( srcList, srcIndex, srcStage, targetList, targetIndex, targetStage ) {
      var item = srcList[srcIndex];
      targetList.splice( targetIndex, 0, srcList[srcIndex] );
      if ( srcList === targetList && targetIndex <= srcIndex ) {
        srcIndex++;
      }
      srcList.splice( srcIndex, 1 );
      if ( targetStage !== srcStage ) {
        item.idStage = targetStage;
        api.pv( item.idPostvendita ).update( item );
      }
      return true;
    }

    //globali
    function dtReload() {
      reloadPvAutorefreshTime = 0;
      kanbanRealizzazioni();
      if ( ! _.isEmpty( vm.dt.dtInstance ) ) {
        vm.dt.dtInstance.reloadData();
      }
    }

    function logExport( e, dt, node, config ) {
      var data = {
        url: api.pv().url,
        numRecords: dt.data().length,
        filter: angular.copy( vm.sp )
      };
      dtFactory.logExportHtml5( data, this, e, dt, node, config );  // eslint-disable-line angular/controller-as-vm
    }

    vm.visualizzaRealizzazioni = function ( stato ) {
      vm.statoDaVisualizzare = stato;
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PvViewController', PvViewController);

  function PvViewController($timeout, $routeParams, AuthenticateJS, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.readPv = api.pv().actions.read;
    vm.idPv = $routeParams.id;

    $timeout(function() {
      vm.readPv(vm.idPv);
    }, 1000);
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PvReadController', PvReadController);

  function PvReadController(
      $rootScope, $scope, AuthenticateJS, $modal,
      DTOptionsBuilder, dtFactory, api, apiBaseUrl, pvStageNonAssegnato, pvStageAssegnato
    ) {
    var vm = this;
    vm.timestamp = Date.now();
    var readModal = $modal( {
      scope: $scope,
      templateUrl: 'pv-read-modal.tpl.html',
      backdrop: false,
      show: false
    } );
    vm.htmlLogAssegnazioni = '';
    vm.dataInizioInstallazioneChange = function () {
      var dataInizioInstallazione = vm.pv.dataInizioInstallazione ? moment( vm.pv.dataInizioInstallazione ).format( 'YYYY-MM-DD' ) : '';
      var dataFineInstallazione = vm.pv.dataFineInstallazione ? moment( vm.pv.dataFineInstallazione ).format( 'YYYY-MM-DD' ) : '';
      if ( dataFineInstallazione == '' || ( dataFineInstallazione == vm.dataInizioInstallazione ) ) {
        // se la data fine installazione non è specificata, o era uguale al vecchio valore della data inizio installazione...
        vm.pv.dataFineInstallazione = angular.isDefined( vm.pv.dataInizioInstallazione ) ? vm.pv.dataInizioInstallazione : vm.dataInizioInstallazione;
        // ...setto la data fine come la data di inizio
      }
      if ( vm.pv.dataInizioInstallazione != undefined ) {
        vm.dataInizioInstallazione = dataInizioInstallazione;
        // aggiorno il valore della dataInizioInstallazione per i confronti successivi
      }
    }

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = [];
    vm.formData = {};
    vm.cliente = {};

    vm.ordineMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveOrdine = function () {
      var pv = angular.copy( vm.pv );
      api.pv( vm.pv.idPostvendita ).update( pv )
      .then( function ( response ) {
        vm.ordineMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    vm.soggettoMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveSoggetto = function () {
      var pv = angular.copy( vm.pv );
      if ( pv.idStage == pvStageNonAssegnato ) {
        pv.idStage = pvStageAssegnato;
      }
      api.pv( vm.pv.idPostvendita ).update( pv ).then( function ( response ) {
        readLogAssegnazioni( pv.idPostvendita );
        vm.soggettoMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    vm.prioritaMode = 'view'; // la modalità di default è la visualizzazione
    vm.savePriorita = function () {
      var pv = angular.copy( vm.pv );
      api.pv( vm.pv.idPostvendita ).update( pv )
      .then( function ( response ) {
        vm.prioritaMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    vm.stageMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveStage = function () {
      var pv = angular.copy( vm.pv );
      if ( pv.idStage == pvStageNonAssegnato ) {
        var modalData = {
          description: 'La modifica della fase nello stato "NON ASSEGNATO" rimuoverà l\'associazione con il precedente assegnatario. Continuare?',
          broadcastAction: 'confirmedStageNonAssegnato'
        };
        $rootScope.$broadcast( 'confirmModalShow', modalData );
        vm.pvToSave = pv;
      } else {
        api.pv( pv.idPostvendita ).update( pv )
        .then( function ( response ) {
          vm.stageMode = 'view'; // ripristino modalità di visualizzazione
          setAlerts( response );
        } );
      }
    }

    vm.dataInstallazioneMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveDataInstallazione = function () {
      var pv = angular.copy( vm.pv );
      api.pv( vm.pv.idPostvendita ).update( pv )
      .then( function ( response ) {
        vm.dataInstallazioneMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    vm.noteTicketMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveNoteTicket = function () {
      var pv = angular.copy( vm.pv );
      api.pv( vm.pv.idPostvendita ).update( pv )
      .then( function ( response ) {
        vm.noteTicketMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    vm.descrizioneBreveMode = 'view'; // la modalità di default è la visualizzazione
    vm.saveDescrizioneBreve = function () {
      var pv = angular.copy( vm.pv );
      api.pv( vm.pv.idPostvendita ).update( pv )
      .then( function ( response ) {
        vm.descrizioneBreveMode = 'view'; // ripristino modalità di visualizzazione
        setAlerts( response );
      } );
    }

    // pv
    vm.pv = {};

    vm.updatePv = api.pv().actions.update;
    vm.deletePv = api.pv().actions.delete;

    vm.readCliente = api.clienti.actions.read;

    // attivita
    vm.dtAttivita = {};
    vm.attivita = [];
    vm.titleAttivitaPrefix = 'Attività';

    vm.createAttivitaPv = function ( pv ) {
      $rootScope.$broadcast('createAttivitaPv', pv);
    };

    // allegati
    vm.dtAllegati = {};
    vm.allegati = [];
    vm.titleAllegatiPrefix = 'Allegati';

    // rapportini
    vm.dtRapportini = {};
    vm.rapportini = [];
    vm.titleRapportiniPrefix = 'Rapportini';

    vm.createAllegato = function ( pv ) {
      $rootScope.$broadcast( 'createAllegato', pv );
    };
    vm.updateAllegato = api.allegati.actions.update;
    vm.deleteAllegato = api.allegati.actions.delete;

    vm.createRapportino = function () {
      api.pv().rapportini().save( {idPostvendita: vm.pv.idPostvendita} ).then( function ( rapportino ) {
        $rootScope.$broadcast( 'Rapportino.created', rapportino );
      }, setAlerts );
    }
    vm.deleteRapportino = api.pv().rapportini().actions.delete;
    vm.firmaRapportino = function ( idRapportino ) {
      $rootScope.$broadcast( 'firmaRapportino', idRapportino );
    }

    // pv
    $scope.$on('readPv', readPv);
    $scope.$on('Pv.updated', pvReload);

    // attivita
    $scope.$watchCollection('prc.attivita', setTitleAttivita);
    $scope.$on('AttivitaPv.created', dtAttivitaReload);
    $scope.$on('AttivitaPv.updated', dtAttivitaReload);
    $scope.$on('AttivitaPv.deleted', dtAttivitaReload);

    // allegati
    $scope.$watchCollection('prc.allegati', setTitleAllegati);
    $scope.$on('Allegato.created', dtAllegatiReload);
    $scope.$on('Allegato.updated', dtAllegatiReload);
    $scope.$on('Allegato.deleted', dtAllegatiReload);

    // rapportini
    $scope.$watchCollection( 'prc.rapportini', setTitleRapportini );
    $scope.$on( 'Rapportino.created', dtRapportiniReload );
    $scope.$on( 'Rapportino.updated', dtRapportiniReload );
    $scope.$on( 'Rapportino.deleted', dtRapportiniReload );

    $scope.$on( 'afterSendNotification', afterSendNotification );

    ////////////////////////////////////////////////////////////////////////////
    // azioni
    function generaAzioni() {
      var actions = [];
      var availableActions = {
        updatePv: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'prc.updatePv(prc.pv.idPostvendita);'
        },
        deletePv: {
          text: '<i class="fa fa-trash fa-fw"></i>&nbsp;Elimina',
          click: 'prc.deletePv(prc.pv.idPostvendita);'
        },
        createRapportino: {
          text: '<i class="fa fa-file-text-o fa-fw"></i>&nbsp;Crea reapportino',
          click: 'prc.createRapportino(prc.pv);'
        }

      };
      actions.push( availableActions.updatePv );
      if ( vm.inserimentoRapportino ) {
        actions.push( availableActions.editRapportino );
      }
      actions.push( availableActions.deletePv );
      return actions;
    }

    function dateFormat( date ) {
      var dateObj = new Date( date );
      var d = zeroPrefix( dateObj.getDate() );
      var m = zeroPrefix( dateObj.getMonth() + 1 );
      var y = dateObj.getFullYear();
      var h = zeroPrefix( dateObj.getHours() );
      var i = zeroPrefix( dateObj.getMinutes() );
      var output =
        d + '/' + m +'/' + y  +
        ' ' +
        h + ':' + i
      return output;
    }

    function zeroPrefix( n ) {
      return n < 10 ? ( '0' + n ) : n;
    }

    function readLogAssegnazioni( idPv ) {
      api.pv( idPv ).logAssegnazioni.list( {tipo:'soggetto'} ).then( function ( logAssegnazioni ) {
        var html = '';
        if ( logAssegnazioni.length <= 1 ) {
          html = 'Nessuna assegnazione archiviata';
        } else {
          for ( var i = 0; i < logAssegnazioni.length; i++ ) {
            var dal = logAssegnazioni[i].inizioAssegnazione == '' ? '' : dateFormat( logAssegnazioni[i].inizioAssegnazione );
            var al = logAssegnazioni[i].fineAssegnazione == '' ? '' : dateFormat( logAssegnazioni[i].fineAssegnazione );
            var dalAl = '';
            if ( dal != '' ) {
              dalAl += 'dal ' + dal;
            }
            if ( al != '' ) {
              dalAl += ' al ' + al;
            }
            html +=
              '<div class="logAssegnazioniRow">' +
                '<strong>' + logAssegnazioni[i].soggetto + '</strong><br />' +
                '<small>' +
                  dalAl +
                '</small>' +
              '</div>';
          }
        }
        vm.htmlLogAssegnazioni = html;
      } );

    }

    function contrattiInScadenza( idCliente ) {
      api.cliente( idCliente ).contratti.list( { inScadenza: 1} ).then(  function ( contrattiInScadenza ) {
        vm.contrattiInScadenza = contrattiInScadenza;
      } );
    }

    function inserimentoRapportino( pv ) {
      return pv.attivitaRapportinabili > pv.attivitaRapportinate;
    }

    // pv
    function readPv( event, idPv ) {
      readLogAssegnazioni( idPv );
      api.pv( idPv ).get().then( function( pv ) {
        var params = {};
        params.contesto = pv.realizzativo ? 'realizzazioni' : 'pv';
        vm.pv = pv;
        vm.dataInizioInstallazione = pv.dataInizioInstallazione;
        api.pv().editForm( params ).then( function ( formData ) {
          vm.formData = formData;
          // gestione attivita
          vm.updateAttivitaPv = api.pv( idPv ).attivita().actions.update;
          vm.deleteAttivitaPv = api.pv( idPv ).attivita().actions.delete;
          pv.scaduto = Date.parse( pv.dataPrevChiusura ) < Date.now();
          // rapportini
          vm.inserimentoRapportino = inserimentoRapportino( pv );
          //load azioni
          vm.azioni = generaAzioni();
          //load tabelle
          dtAttivita( idPv );
          dtAllegati( idPv );
          dtRapportini( idPv );
          contrattiInScadenza( pv.idCliente );
          readModal.$promise.then( readModal.show );
        });
      });
    }
    function pvReload( event, pv ) {
      vm.pv = pv;
    }

    // attivita
    function dtAttivita( idPv ) {
      vm.dtAttivita.instance = {};
      vm.dtAttivita.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          var promise = api.pv(idPv).attivita().list();
          promise.then(function(attivita) {
            vm.attivita = attivita;
          });
          return promise;
        })
        .withOption('order', [0, 'desc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );
      vm.dtAttivita.columns = [
        {
          data: 'dataIns',
          title: 'Data inizio',
          'class': 'col-date-time',
          render: dtFactory.renders.datetime
        },
        {
          data: 'dataFine',
          title: 'Data fine',
          'class': 'col-date-time',
          render: dtFactory.renders.datetime
        },
        {
          data: 'durata',
          'class': 'col-time',
          title: 'Durata'
        },
        {
          data: 'inSede',
          title: 'c/o cliente',
          'class': 'col-in-sede',
          render: renderInSede
        },
        {
          data: 'descrizioneAttivita',
          title: 'Attività',
          render: dtFactory.renders.longtext,
          'class': 'preformattedText'
        },
        {
          data: 'includiInRapportino',
          title: 'Rapportino',
          render: renderStatoRapportino
        },
        {
          data: 'soggetto',
          title: 'Assegnato',
          'class': 'col-user-fullname'
        },
        {
          data: 'idAttivita',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'col-actions vertical-align-middle',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////

      function renderActions( data, type, row ) {
        if ( vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          var allowEdit = ( row.idRapportino == '' );
          // posso modificare l'attività solo se non rapportinata
          var updTitle, delTitle;
          if ( allowEdit ) {
            updTitle = 'Modifica';
            delTitle = 'Elimina';
          } else {
            updTitle = delTitle = "Non è possibile modificare o eliminare questa attività perché è collegata ad un rapportino firmato";
          }
          var upd = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip title="' + updTitle + '" ng-disabled="' + ! allowEdit + '" ng-click="prc.updateAttivitaPv(' + data + ')"><i class="fa fa-pencil"></i></button>';
          var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip title="' + delTitle + '" ng-disabled="' + ! allowEdit + '" ng-click="prc.deleteAttivitaPv(' + data + ')"><i class="fa fa-minus"></i></button>';
          var output =
            '<div ng-if="prc.pv.stato!==\'chiuso\'">' +
              upd + ' ' + del +
            '</div>';
          return output;
        }
      }

      function renderInSede( data ) {
        return data ? '<i class="fa fa-check text-success"></i>' : '';
      }

      function renderStatoRapportino( data, type, row ) {
        var icon, tooltip = '';
        if ( row.attivitaNoteTecnico ) {
          icon = 'user-o';
          tooltip = 'Note tecnico in rapportino';
        } else if ( row.rapportinoFirmatoCliente ) {
          icon = 'handshake-o';
          tooltip = 'Attività collegata a rapportino firmato dal cliente';
        } else if ( row.includiInRapportino ) {
          icon = 'pencil-square-o';
          tooltip = 'Attività rapportinabile';
        }
        if ( icon ) {
          return '<i class="fa fa-' + icon + '" bs-tooltip title="' + tooltip + '"></i>'
        }
      }

      function renderActionsTitle() {
        var title = '';
        if ( vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          title = '<button type="button" class="btn btn-success btn-xs" title="Inserisci" ng-if="prc.pv.stato!==\'chiuso\'" ng-click="prc.createAttivitaPv(prc.pv)"><i class="fa fa-plus"></i></button>';
        }
        return title;
      }

    }
    function dtAttivitaReload( event, attivita ) {
      api.pv( attivita.idPostvendita ).get().then( function( pv ) { // rileggo sempre pv per aggionare il tempo calcolato dalle attività
        vm.inserimentoRapportino = inserimentoRapportino( pv );
        vm.pv = pv;
      } );
      if ( event.name != 'AttivitaPv.deleted' && attivita.chiusura ) {
        if ( ! vm.pv.realizzativo ) {
          // apertura modal notifica invio
          $rootScope.$broadcast( 'inviaNotificaPv', attivita );
        }
      }
      if ( ! _.isEmpty( vm.dtAttivita.instance ) ) {
        vm.dtAttivita.instance.reloadData();
      }
    }
    function setTitleAttivita( attivita ) {
      vm.titleAttivita = vm.titleAttivitaPrefix;
      if ( attivita && attivita.length > 0 ) {
        vm.titleAttivita += ' <span class="badge">' + attivita.length + '</span>';
      }
    }

    // allegati
    function dtAllegati(idPv) {
      vm.dtAllegati.instance = {};
      vm.dtAllegati.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.allegati.list( {
            idPostvendita: idPv
          } );
          promise.then( function ( allegati ) {
            vm.allegati = allegati;
          } );
          return promise;
        } )
        .withOption( 'order', [0, 'desc'] )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
      );
      vm.dtAllegati.columns = [
        {
          data: 'dataOraIns',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {
          data: 'descrizione',
          title: 'Descrizione'
        },
        {
          data: 'tipo',
          title: 'Tipo'
        },
        {
          data: 'note',
          title: 'Note Allegato',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'min-width text-center vertical-align-middle',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////

      function renderActionsTitle() {
        var title = '';
        if ( vm.pv.stato !== 'chiuso' && vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          title = '<button type="button" class="btn btn-success btn-xs" title="Inserisci" ng-click="prc.createAllegato(prc.pv)"><i class="fa fa-plus"></i></button>';
        }
        return title;
      }

      function renderActions( data, type, row ) {
        var actions = '';
        var prv = '<a href="' + apiBaseUrl + '/allegati/' + data + '?preview" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Anteprima"><i class="fa fa-eye"></i></a>';
        var dwn = '<a href="' + apiBaseUrl + '/allegati/' + data + '?download" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data- title="Scarica"><i class="fa fa-download"></i></a>';
        var upd = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="prc.updateAllegato(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Cancella" ng-click="prc.deleteAllegato(' + data + ')"><i class="fa fa-minus"></i></button>';
        if ( vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          actions = prv + ' ' + dwn;
          if ( ! row.tipoAllegatoServizio && vm.pv.stato !== 'chiuso' && vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
            actions += ' ' + upd + ' ' + del;
          }
        }
        return actions;
      }

    }
    function dtAllegatiReload() {
      if (!_.isEmpty(vm.dtAllegati.instance)) {
        vm.dtAllegati.instance.reloadData();
      }
    }
    function setTitleAllegati( allegati ) {
      vm.titleAllegati = vm.titleAllegatiPrefix;
      if ( allegati && allegati.length > 0 ) {
        vm.titleAllegati += ' <span class="badge">' + allegati.length + '</span>';
      }
    }

    // rapportini
    function dtRapportini( idPv ) {
      vm.dtRapportini.instance = {};
      vm.dtRapportini.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.pv().rapportini().list( {
            idPostvendita: idPv
          } );
          promise.then( function ( rapportini ) {
            vm.rapportini = rapportini;
          } );
          return promise;
        } )
        .withOption( 'order', [3, 'desc'] )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
      );
      vm.dtRapportini.columns = [
        {
          data: 'codice',
          title: 'Codice',
          'class' : ''
        },
        {
          data: 'firmatoCliente',
          title: 'Firmato',
          render: dtFactory.renders.boolean,
          'class' : ''
        },
        {
          data: 'firmatoCliente',
          title: 'Firma',
          render: renderStatoFirma
        },
        {
          data: 'dataOraIns',
          title: 'Inserimento',
          render: dtFactory.renders.datetime,
          'class' : ''
        },
        {
          data: 'dataOraMod',
          title: 'Ultima modifica',
          render: dtFactory.renders.datetime,
          'class' : ''
        },
        {
          data: 'idRapportino',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'col-actions',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////

      function renderActionsTitle() {
        var title = '';
        if ( vm.pv.stato !== 'chiuso' && vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          title = '<button type="button" class="btn btn-success btn-xs" title="Inserisci" ng-if="prc.pv.inserimentoRapportino" ng-click="prc.editRapportino(null,prc.pv)"><i class="fa fa-plus"></i></button>';
        }
        return title;
      }

      function renderActions( data, view, row ) {
        var actions = '';
        var prv = '<a href="' + apiBaseUrl + '/tickets/rapportino-pdf/' + data + '?preview=' + vm.timestamp + '" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Anteprima"><i class="fa fa-eye"></i></a>';
        var dwn = '';//'<a href="' + apiBaseUrl + '/tickets/rapportino-pdf/' + data + '?download=' + vm.timestamp + '" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Scarica"><i class="fa fa-download"></i></a>';
        var sig = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Firma rapportino" ng-click="prc.firmaRapportino(' + data + ')"><i class="fa fa-pencil-square-o"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Elimina rapportino" ng-click="prc.deleteRapportino(' + data + ')"><i class="fa fa-minus"></i></button>';
        if ( vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco' ) {
          actions = prv + ' ' + dwn;
          if ( ! row.firmatoCliente ) {
            actions += ' ' + sig;
          }
          if ( vm.pv.stato !== 'chiuso' ) {
            actions += ' ' + del;
          }
        }
        return actions;
      }

      function renderStatoFirma( data, view, row ) {
        var icon, title;
        icon = '';
        if ( row.firmatoCliente ) {
          if ( row.fileScaricatoPerFirmaAnalogica ) {
            icon = 'pencil';
            title = 'Firma analogica';
          } else {
            icon = 'desktop';
            title = 'Firma digitale';
          }
        } else if ( row.fileScaricatoPerFirmaAnalogica ) {
          icon = 'download';
          title = 'File scaricato per firma analogica';
        }
        if ( icon != '' ) {
          return '<i class="fa fa-' + icon + '" bs-tooltip data-title="' + title + '"></i>';
        }
      }

    }
    function dtRapportiniReload( event, rapportino ) {
      if ( ! _.isEmpty( vm.dtRapportini.instance ) ) {
        vm.dtRapportini.instance.reloadData( function () {
          if ( event.name =='Rapportino.created' ) { // dopo la creazione, propongo subito la maschera di firma
            vm.firmaRapportino( rapportino.idRapportino );
          }
        } );
      }
      api.pv( vm.pv.idPostvendita ).get().then( function( pv ) {
        vm.inserimentoRapportino = inserimentoRapportino( pv );
      } );
      // ricarico anche attività e allegati
      if ( ! _.isEmpty( vm.dtAttivita.instance ) ) {
        vm.dtAttivita.instance.reloadData();
      }
      if ( ! _.isEmpty( vm.dtAllegati.instance ) ) {
        vm.dtAllegati.instance.reloadData();
      }
    }
    function setTitleRapportini( rapportini ) {
      vm.titleRapportini = vm.titleRapportiniPrefix;
      if ( rapportini && rapportini.length > 0 ) {
        var cssClass = '';
        for ( var i = 0; i < rapportini.length; i++ ) {
          if ( rapportini[i].firmatoCliente ) {
            cssClass = ' badge-danger';
            break;
          }
        }
        vm.titleRapportini += ' <span class="badge' + cssClass + '">' + rapportini.length + '</span>';
      }
    }

    function afterSendNotification( event, pv ) {
      vm.pv = pv;
    }

    function setAlerts( response ) {
      if ( response.data && response.data.warnings ) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

  }

} )();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'PvEditController', function ( $rootScope, $scope, AuthenticateJS, $modal, api ) {
    var vm = this;

    var pvEditModal = $modal( {
      scope: $scope,
      templateUrl: 'pv-edit-modal.tpl.html',
      backdrop: false,
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.pv = {};
    vm.cliente = {};
    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.actualSaveForm = actualSaveForm;
    vm.undoForm = undoForm;
    vm.contrattiListParams = {
      obsoleto: false,
      fornitore: 'CLYCO'
    };
    vm.setReferente = function ( value ) {
      for ( var i in vm.formData.referenti ) {
        var referente = vm.formData.referenti[i]
        if ( referente.idReferente == value ) {
          vm.pv.nomeReferente = referente.nominativo;
          angular.element( '[ng-model="pec.pv.nomeReferente"]' ).blur();
          vm.pv.emailReferente = referente.email;
          vm.pv.telReferente = referente.tel;
          vm.pv.cellReferente = referente.cell;
          vm.pv.idReferente = referente.idReferente;
        }
      }
    };
    vm.setSedeCliente = function ( value ) {
      for ( var i in vm.formData.sediCliente ) {
        var sedeCliente = vm.formData.sediCliente[i];
        if ( sedeCliente.idSede == value ) {
          vm.pv.indirizzo = sedeCliente.indirizzo;
          if ( sedeCliente.numeroCivico ) {
            vm.pv.indirizzo += ' ' + sedeCliente.numeroCivico;
          }
          angular.element( '[ng-model="pec.pv.indirizzo"]' ).blur();
          vm.pv.prov = sedeCliente.prov;
          vm.pv.citta = sedeCliente.citta;
          vm.pv.telSede = sedeCliente.telefono;
        }
      }
    };
    vm.dataInizioInstallazione = '';
    vm.dataInizioInstallazioneChange = function () {
      var dataInizioInstallazione = vm.pv.dataInizioInstallazione ? moment( vm.pv.dataInizioInstallazione ).format( 'YYYY-MM-DD' ) : '';
      var dataFineInstallazione = vm.pv.dataFineInstallazione ? moment( vm.pv.dataFineInstallazione ).format( 'YYYY-MM-DD' ) : '';
      if ( dataFineInstallazione == '' || dataFineInstallazione == vm.dataInizioInstallazione ) {
        // se la data fine installazione non è specificata, o era uguale al vecchio valore della data inizio installazione...
        vm.pv.dataFineInstallazione = angular.isDefined( vm.pv.dataInizioInstallazione ) ? vm.pv.dataInizioInstallazione : vm.dataInizioInstallazione;
        // ...setto la data fine come la data di inizio
      }
      if ( vm.pv.dataInizioInstallazione != undefined ) {
        vm.dataInizioInstallazione = dataInizioInstallazione;
        // aggiorno il valore della dataInizioInstallazione per i confronti successivi
      }
    }
    vm.copiaDaDescrizione = function () {
      vm.pv.descrizioneTecnico = vm.pv.descrizioneTicket;
    }
    vm.cercaContrattoPerId = function ( id ) {
      var contratti = vm.formData.contratti;
      for ( var i = 0; i < contratti.length; i++ ) {
        if ( contratti[i].value == id ) {
          return contratti[i];
        }
      }
      return false;
    }
    vm.copiaDaProdotti = function () {
      var output = '';
      var contratti = vm.pv.contratti;
      for ( var i = 0; i < contratti.length; i++ ) {
        var contratto = vm.cercaContrattoPerId( contratti[i] );
        if ( contratto !== false ) {
          output += contratto.label + "\n";
        }
      }
      vm.pv.descrizioneBreve = output;
    }

    $scope.$on( 'updatePv', updatePv );
    $scope.$on( 'createPvCliente', createPvCliente );

    ////////////////////////////////////////////////////////////////////////////

    function updatePv( event, idPv ) {
      vm.action = 'update';
      vm.alerts = [];
      api.pv( idPv ).get().then( function ( pv ) {
        var contratti;
        if ( pv.realizzativo ) {
          contratti = [];
          for ( var i = 0; i < pv.contratti.length; i++ ) {
            contratti.push( pv.contratti[i].idContratto );
          }
          pv.contratti = contratti;
        } else {
          pv.idContratti = pv.idContratti.length ? parseInt( pv.idContratti[0] ) : undefined; // sui pv ho una select
        }
        pv.scaduto = Date.parse( pv.dataPrevChiusura ) < Date.now();
        vm.pv = pv;
        if ( pv.dataInizioInstallazione ) {
          vm.dataInizioInstallazione = pv.dataInizioInstallazione;
        }
        var params = {
          idCliente: vm.pv.idCliente
        };
        if ( pv.realizzativo ) {
          params.contesto = 'realizzazioni';
        }
        api.pv().editForm( params ).then( function ( formData ) {
          vm.formData = formData;
          pvEditModal.$promise.then( pvEditModal.show );
        } );
      } );
    }

    function createPvCliente( event, cliente, data ) {
      if ( data == undefined ) {
        data = {};
      }
      var tipo = data.tipo != undefined ? data.tipo : 'p';
      vm.action = 'create';
      vm.alerts = [];
      var params = {
        idCliente: cliente.id
      };
      if ( tipo == 'r' ) {
        params.contesto = 'realizzazioni';
      }
      api.pv().editForm( params ).then( function ( formData ) {
        vm.pv = {}; // resetto sempre
        vm.formData = formData;
        var categorie = [];
        for ( var i in formData.categorie ) {
          var categoria = formData.categorie[i];
          var add = ( tipo == 'p' && ! categoria.realizzativo ) || ( tipo == 'r' && categoria.realizzativo );
          if ( add ) {
            if ( categorie.length == 0 ) { // la prima è selezionata di default
              vm.pv.idCategoria = categoria.value;
            }
            categorie.push( categoria );
          }
        }
        vm.formData.categorie = categorie;
        vm.pv.cliente = cliente.ragSoc;
        vm.pv.idCliente = cliente.id;
        vm.pv.idPriorita = 1;
        vm.pv.idCategoria = 3;
        if ( tipo == 'r' ) {
          vm.pv.idStage = 12;
        }
        vm.pv.realizzativo = tipo == 'r';
        vm.pv.dataApertura = new Date(); // default: oggi
        vm.setDataPrevChiusura();
        vm.pv.idStato = 1;
        //vm.pv.idSoggetto = vm.user.idAgente;
        vm.pv.fornitore = 'CLYCO';
        if ( data.idContratti ) {
          vm.pv.idContratti = data.idContratti;
        }
        pvEditModal.$promise.then( pvEditModal.show );
      } );
    }

    function actualSaveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if ( vm.action === 'create' ) {
        api.pv().save( vm.pv ).then( function ( pv ) {
          pvEditModal.hide();
          $rootScope.$broadcast( 'Pv.updated', pv );
          if ( vm.pv.salvaReferente ) {
            $rootScope.$broadcast( 'Referente.created', pv.referente );
          }
          if ( ! pv.realizzativo ) {
            $rootScope.$broadcast( 'inviaNotificaPv', pv );
          }
        }, setAlerts );
      } else if ( vm.action === 'update' ) {
        api.pv( vm.pv.idPostvendita ).update( vm.pv ).then( function ( pv ) {
          $rootScope.$broadcast( 'Pv.updated', pv );
          if ( vm.pv.salvaReferente ) {
            $rootScope.$broadcast( 'Referente.updated', pv.referente );
          }
        pvEditModal.hide();
        }, setAlerts );
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts( response ) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function saveForm() {
      if ( vm.pv.idContratti == null ) {
        var showAlert = function () {
          angular.element( '#pv-edit-modal g1-alerts + .alert' ).slideDown();
        }
        if ( angular.element( '#pv-edit-modal g1-alerts + .alert' ).length > 0 ) {
          angular.element( '#pv-edit-modal g1-alerts + .alert' ).slideUp( function () {
            showAlert();
          } );
        } else {
          showAlert();
        }
      } else {
        actualSaveForm();
      }
    }

    function undoForm() {
      pvEditModal.hide();
    }

    vm.setDataPrevChiusura = function () {
      var datiPriorita = false;
      for ( var i = 0; i < vm.formData.priorita.length; i++ ) {
        if ( vm.formData.priorita[i].value == vm.pv.idPriorita ) {
          datiPriorita = vm.formData.priorita[i];
        }
      }
      if ( datiPriorita != false ) {
        var sla = vm.pv.realizzativo ? datiPriorita.sla_r : datiPriorita.sla;
        var dataApertura = new Date( vm.pv.dataApertura )
        vm.pv.dataPrevChiusura = new Date( dataApertura.getTime() + sla * 60 * 60 * 1000 );
      }
    }

  } );

} )();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PvController', PvController);

  function PvController( $rootScope, $scope, $filter, AuthenticateJS, $aside, dtFactory, DTOptionsBuilder, api, $interval, pvStageNonAssegnato ) {
    var vm = this;
    var stops = [];

    var dashboardPvAside = $aside( {
      scope: $scope,
      templateUrl: 'dashboard-pv-aside.tpl.html',
      placement: 'left',
      animation: 'am-slide-left',
      container: 'body',
      backdrop: 'static',
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.activeTab = 'dashboard';
    vm.dtPv = {
      show: true,
      filtered: false
    };
    vm.columnFilter = {};
    vm.reloadPv = function () {
      dtReload();
    }

    vm.soggetti = [];
    vm.filterByUser = false;
    vm.view = 'kanban';
    vm.filterPvButton = filterButton( vm.filterByUser );
    vm.viewPvButton = viewButton( vm.view );

    //ricerca
    vm.alerts = {};
    vm.sr = searchDefaultValues();

    //dashboard
    vm.alertsK = {};
    vm.kanban = {};
    vm.kanbanFilter = '';

    vm.itemToSave = {};

    vm.pvCount = 0;
    vm.onDrop = onDrop;
    vm.showAside = showAside;
    vm.searchKanban = searchKanban;
    vm.resetKanban = resetKanban;
    vm.unsetFilter = unsetFilter;
    vm.readPv = function ( idPv ) {
      return api.pv().actions.read( idPv );
    }
    vm.refreshContent = dtReload;
    vm.togglePvFilter = function () {
      vm.filterByUser = ! vm.filterByUser;
      vm.filterPvButton = filterButton( vm.filterByUser );
      vm.soggetti = vm.filterByUser ? [vm.user.idAgente] : [];
      vm.soggettiChange();
    }
    vm.togglePvView = function () {
      vm.view = ( vm.view == 'kanban' ) ? 'elenco' : 'kanban';
      vm.viewPvButton = viewButton( vm.view );
    }    
    function filterButton( filterByUser ) {
      var output = {};
      if ( filterByUser ) {
        output = {
          'icon' : 'globe',
          'label' : 'Tutti'
        }
      } else {
        output = {
          'icon' : 'filter',
          'label' : 'Miei'
        }
      }
      return output;
    }
    function viewButton( view ) {
      var output = {};
      if ( view == 'kanban' ) {
        output = {
          'icon' : 'bars',
          'label' : 'Elenco'
        }
      } else {
        output = {
          'icon' : 'bar-chart',
          'label' : 'Kanban'
        }
      }
      return output;
    }
    vm.soggettiChange = function () {
      var searchTerm = vm.soggetti.map( function ( n ) {
        return '^' + n + '$';
      } ).join( '|') ;
      vm.dtPv.dtInstance.DataTable.column( 11 ).search( searchTerm, true ).draw();
      vm.pvCount = 0;
      angular.forEach( vm.kanban, function ( stage ) {
        stage.itemsLength = 0;
        angular.forEach( stage.items, function ( item ) {
          if ( vm.soggetti.length == 0 || ( vm.soggetti.indexOf( item.idSoggetto ) > - 1 ) ) {
            stage.itemsLength++;
            vm.pvCount++;
          }
        } );
      } );

    }

    //imposta stop del refresh
    $scope.$on( '$destroy', stopRefresh );

    var reloadPvAutorefreshInterval = 5 * 60 * 1000; // aggiornamento automatico in 5 minuti
    var reloadPvAutorefreshTime = 0;
    var reloadPvAutorefreshTimeStep = 200;
    var reloadPvAutorefreshTimePercentage = function () {
      var perc = ( 100 * ( reloadPvAutorefreshInterval - reloadPvAutorefreshTime ) / reloadPvAutorefreshInterval );
      vm.autorefreshTimeSliderWidth = perc + '%';
      reloadPvAutorefreshTime += reloadPvAutorefreshTimeStep;
    }
    reloadPvAutorefreshTimePercentage();
    stops.push( $interval( vm.refreshContent, reloadPvAutorefreshInterval ) );
    stops.push( $interval( reloadPvAutorefreshTimePercentage, reloadPvAutorefreshTimeStep ) );

    function stopRefresh() {
      angular.forEach( stops, function ( stop ) {
        $interval.cancel( stop );
      } );
      stops = [];
    }

    function confirmedStageNonAssegnato() {
      api.pv( vm.itemToSave.idPostvendita ).get().then( function( pv ) {
        if ( pv.idContratti && pv.idContratti.length == 1 ) {
          vm.itemToSave.contratti = pv.idContratti[0]; // faccio in modo che risulti come se arrivasse da una select
        }
        api.pv( vm.itemToSave.idPostvendita ).update( vm.itemToSave );
        vm.itemToSave = {};
      } );
    }

    vm.readCliente = api.clienti.actions.read;
    vm.readPv = api.pv().actions.read;
    vm.updatePv = api.pv().actions.update;
    vm.deletePv = api.pv().actions.delete;

    //carica i dati della form
    api.pv().searchForm( { contesto: 'pv' } ).then( function ( formData ) {
      vm.formData = formData;
      //carica il kanban
      kanbanPv();
    } );

    $scope.$on( 'Pv.updated', dtReload );
    $scope.$on( 'Pv.deleted', dtReload );
    $scope.$on( 'confirmedStageNonAssegnato', confirmedStageNonAssegnato );
    $scope.$on( 'reloadKanbanPv', dtReload );

    ////////////////////////////////////////////////////////////////////////////

    function dtColumnFilter( data ) {
      var piste = [];
      var categorie = [];
      var soggetti = [];
      var priorita = [];
      for ( var i = 0; i < data.length; i++ ) {
        if ( piste.indexOf( data[i].pista ) == - 1 ) {
          piste.push( data[i].pista );
        }
        if ( categorie.indexOf( data[i].categoria ) == - 1 ) {
          categorie.push( data[i].categoria );
        }
        if ( soggetti.indexOf( data[i].soggetto ) == - 1 ) {
          soggetti.push( data[i].soggetto );
        }
        if ( priorita.indexOf( data[i].priorita ) == - 1 ) {
          priorita.push( data[i].priorita );
        }
      }
      piste.sort();
      categorie.sort();
      soggetti.sort();
      priorita.sort();
      var pisteValues = [];
      var categorieValues = [];
      var soggettiValues = [];
      var prioritaValues = [];
      piste.forEach( function ( value ) {
        if ( value == '' ) {
          return;
        }
        pisteValues.push( {
          label: value,
          value: value
        } );
      } );
      categorie.forEach( function ( value ) {
        categorieValues.push( {
          label: value,
          value: value
        } );
      } );
      soggetti.forEach( function ( value ) {
        soggettiValues.push( {
          label: value,
          value: value
        } );
      } );
      priorita.forEach( function ( value ) {
        prioritaValues.push( {
          label: value,
          value: value
        } );
      } );
      return {
        aoColumns: [
          {
            type: 'text' // codice
          },
          null,
          {
            type: 'text' // cliente
          },
          {
            type: 'text' // città
          },
          {
            type: 'text' // prov
          },
          {
            type: 'select', // pista
            bRegex: false,
            values: pisteValues
          },
          {
            type: 'select', // categoria
            bRegex: false,
            values: categorieValues
          },
          {
            type: 'text' // descrizione
          },
          {
            type: 'text' // apertura
          },
          {
            type: 'text' // scadenza
          },
          {
            type: 'select', // soggetto
            bRegex: false,
            values: soggettiValues
          },
          null, // lavorato
          null, // durata
          {
            type: 'select', // priorità
            bRegex: false,
            values: prioritaValues
          },
          null
        ]
      };
    }

    dtPv();

    function dtPv() {
      var getPv = function () {
        var pvPromise = api.pv().list( {
          filter: 'aperti',
          realizzativo: false
        } );
        pvPromise.then( function ( data ) {
          if ( ! _.isEmpty( vm.dtPv.dtInstance ) ) {
            vm.dtPv.dtInstance.DataTable.on( 'search.dt', function () {
              vm.dtPv.count = vm.dtPv.dtInstance.DataTable.rows( { search:'applied' } ).count();
              vm.dtPv.filtered = vm.dtPv.unfilteredCount != vm.dtPv.count;
            } );
          }
          vm.dtPv.unfilteredCount = data.length;
          vm.dtPv.count = data.length;
          vm.pvCount = data.length;
          vm.dtPv.filtered = false;
          if ( ! vm.dtPv.dtOptions || ! vm.dtPv.filterColumnsAdded ) {
            vm.dtPv.dtOptions.withColumnFilter( dtColumnFilter( data ) );
            vm.dtPv.filterColumnsAdded = true;
          }
        } );
        return pvPromise;
      };
      vm.dtPv.dtInstance = {};
      vm.dtPv.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( getPv )
        .withOption( 'order', [[15, 'desc'],[14, 'desc']] )
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', true )
        .withOption( 'paging', false )
        .withOption( 'createdRow', function ( row, data ) {
          if ( data.idSoggetto == vm.user.idAgente ) {
            angular.element( row ).addClass( 'highlight' );
          }
        } )
      );
      vm.dtPv.dtColumns = [
        {
          data: 'codice',
          title: 'Codice',
          render: renderCodice,
          'class': 'col-codice nowrap'
        },
        {
          data: 'stato',
          title: 'Stato',
          render: renderStato,
          'class': 'col-stato nowrap'
        },
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente,
          'class': 'col-cliente'
        },
        {
          data: 'citta',
          title: 'Città',
          'class': 'col-citta nowrap'
        },
        {
          data: 'prov',
          title: 'Prov.',
          'class': 'col-prov nowrap'
        },
        {
          data: 'piste',
          title: 'Pista',
          'class': 'col-pista nowrap'
        },
        {
          data: 'categoria',
          title: 'Categoria',
          'class': 'col-categoria nowrap'
        },
        {
          data: 'descrizioneTicket',
          title: 'Descrizione',
          'class': 'col-descrizione nowrap preformattedText',
          render: dtFactory.renders.longtextNoTooltip
        },
        {
          data: 'dataApertura',
          title: 'Apertura',
          render: dtFactory.renders.datetime,
          'class': 'col-date-time nowrap'
        },
        {
          data: 'dataPrevChiusura',
          title: 'Scadenza',
          render: dtFactory.renders.date,
          'class': 'col-date nowrap'
        },
        {
          data: 'soggetto',
          title: 'Assegnato',
          'class': 'col-user-fullname nowrap'
        },
        {
          data: 'idSoggetto',
          visible: false
        },
        {
          data: 'stage',
          title: 'Fase'
        },
        {
          data: 'durataAttivita',
          title: 'Lavorato',
          'class': 'col-time nowrap'
        },
        {
          data: 'durataTicket',
          title: 'Durata (gg)',
          'class': 'col-time nowrap'
        },
        {
          data: 'ordinePriorita',
          title: 'Urgenza',
          render: renderPriorita,
          'class': 'col-priorita nowrap'
        },
        {
          data: 'ordine',
          title: 'Ordine',
          'class': 'col-ordine nowrap'
        }
      ];
      vm.dtPv.show = true;
    }

    function renderCodice( data, type, row ) {
      if ( type === 'display' ) {
        return '<a bs-tooltip data-title="apri ' + ( row.realizzativo ? 'realizzazione' : 'postvendita' ) + '" ng-click="pv.readPv(' + row.idPostvendita + ')">' + data + '</a>';
      }
      return data;
    }

    function renderStato( data, type, row ) {
      if ( type === 'display' ) {
        data = '';
        if ( ! row.realizzativo ) {
          if ( row.inAssistenza ) {
            data += '<i class="fa fa-life-ring text-success" bs-tooltip data-title="In assistenza"></i>';
          } else {
            data += '<i class="fa fa-euro" bs-tooltip data-title="A pagamento"></i>';
          }
        }
        if ( row.bloccato ) {
          data += '<i class="fa fa-exclamation-triangle text-danger" bs-tooltip data-title="Cliente bloccato"></i>';
        }
        if ( Date.parse( row.dataPrevChiusura ) < Date.now() ) {
          data += '<i class="fa fa-clock-o text-danger" data-title="Ticket scaduto" bs-tooltip></i>';
        }
      }
      return data;
    }

    function renderCliente( data, type, row ) {
      if ( type === 'display' ) {
        data = '<button class="btn btn-primary btn-xs" bs-tooltip data-title="apri cliente" ng-click="pv.readCliente(' + row.idCliente + ')"><i class="fa fa-external-link-square"></i></button> ' + row.idCliente + '-' + data;
      }
      return data;
    }

    function renderPriorita( data, type, row ) {
      data = '<span class="priorita priorita-' + row.idPriorita + '"></span>';
      return data;
    }

    //kanban
    function kanbanPv() {
      vm.alertsK = {};
      api.pv().list(vm.sr)
        .then(loadKanban, setAlerts);

      //////////////////////////////////////////////////////////////////////////
      function loadKanban( pv ) {
        vm.pvCount = pv.length;
        vm.kanban = {};
        angular.forEach( vm.formData.stages, function ( stage ) {
          vm.kanban[stage.value] = {
            label: stage.label,
            bgColor: stage.bgColor ? '#' + stage.bgColor : 'lightgray',
            items: [],
            itemsLength: 0
          }
        } );
        pv = $filter( 'orderBy' )( pv, 'ordine', true );
        angular.forEach( pv, function ( pvDetail ) {
          pvDetail.update = api.pv().actions.update;
          if ( pvDetail.idStage == 0 && vm.kanban[0] == undefined ) {
            vm.kanban[0] = {
              label: 'Fase non specificata',
              bgColor: 'lightgray',
              items: []
            }
          }
          vm.kanban[pvDetail.idStage].items.push( pvDetail );
          vm.kanban[pvDetail.idStage].itemsLength++;
        } );
        vm.kanbanStages = Object.keys( vm.kanban ).length;
      }

      ////////////////////////////////////////////////////////////////////////

      function setAlerts(response) {
        vm.alertsK = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function searchKanban() {
      kanbanPv();
      dashboardPvAside.hide();
    }

    function searchDefaultValues() {
      return {
        filter: 'aperti',
        realizzativo: false
      }
    }

    function resetKanban() {
      vm.sr = searchDefaultValues();
      searchKanban();
    }

    function unsetFilter(filter) {
      delete vm.sr[filter];
      kanbanPv();
    }

    function showAside() {
      dashboardPvAside.$promise.then(function() {
        dashboardPvAside.show();
      });
    }

    function onDrop( srcList, srcIndex, srcStage, targetList, targetIndex, targetStage ) {
      var item = srcList[srcIndex];
      targetList.splice( targetIndex, 0, srcList[srcIndex] );
      if ( srcList === targetList && targetIndex <= srcIndex ) {
        srcIndex++;
      }
      srcList.splice( srcIndex, 1 );
      if ( targetStage !== srcStage ) {
        item.idStage = targetStage;
        // posso procedere, ma dovrò controllare se la fase sia "Non assegnato"
        item.contratti = item.idContratti; // faccio in modo che risulti come se arrivasse da una select
        if ( targetStage == pvStageNonAssegnato ) {
          var modalData = {
            description: 'La modifica della fase nello stato "NON ASSEGNATO" rimuoverà l\'associazione con il precedente assegnatario. Continuare?',
            broadcastAction: 'confirmedStageNonAssegnato',
            oncloseBroadcastAction: 'reloadKanbanPv'
          };
          $rootScope.$broadcast( 'confirmModalShow', modalData );
          vm.itemToSave = item;
        } else {
          if ( srcStage == pvStageNonAssegnato ) {
            $rootScope.$broadcast( 'assegnaPvModalShow', item );
          } else {
            api.pv( item.idPostvendita ).update( item );
          }
        }
      }
      return true;
    }

    //globali
    function dtReload() {
      reloadPvAutorefreshTime = 0;
      kanbanPv();
      if ( ! _.isEmpty( vm.dt ) && ! _.isEmpty( vm.dt.dtInstance ) ) {
        vm.dt.dtInstance.reloadData();
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('InviaNotificaPvController', InviaNotificaPvController);

  function InviaNotificaPvController($rootScope, $scope, AuthenticateJS, $modal, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};

    var inviaNotificaModal = $modal( {
      scope: $scope,
      templateUrl: 'invia-notifica-pv.tpl.html',
      backdrop: false,
      show: false
    } );

    $scope.$on( 'inviaNotificaPv', inviaNotificaPv );

    function inviaNotificaPv( event, model ) {
      if ( model.idAttivita == undefined ) { // arrivo da create pv
        vm.action = 'apertura';
        vm.pv = model;
        if ( vm.pv.idContratti ) {
          api.contratto( vm.pv.idContratti ).get().then( function ( contratto ) {
            vm.contratto = contratto;
            openModal();
          } );
        } else {
          openModal();
        }
      } else {
        vm.action = 'chiusura';
        vm.attivita = model;
        api.pv( model.idPostvendita ).get().then( function ( pv ) {
          //if ( pv.invioEmailApertura ) { // invio sempre...
            vm.pv = pv;
            openModal();
          //}
        } );
      }
      function openModal() {
        vm.to = vm.pv.emailReferente;
        var content = {
          'header' :
            'Gentile {ragioneSociale},\n',
          'footer' :
            '\n\n' +
            'Per qualsiasi ulteriore necessità può rivolgersi al servizio di assistenza clienti ai seguenti recapiti:\n' +
            'Tel.: 043344978\n' +
            'N. verde: 800188771\n' +
            'Email: assistenza.clienti@clyco.it\n\n' +
            'Nelle successive comunicazioni La preghiamo di fare riferimento al numero del ticket aperto: {nTicket}.\n\n' +
            'Vi ringraziamo per la preziosa collaborazione.'
        };
        if ( vm.action=='apertura' ) {
          vm.subject = 'CLYCO: Apertura caso di assistenza {nTicket}';
          vm.content =
            'a seguito di Vs. segnalazione, abbiamo aperto il seguente ticket di assistenza' + ( vm.pv.contratti && vm.pv.contratti.length ? ' per il prodotto/servizio "{prodotto}"' : '' ) + ':\n\n' +
            '{descrizioneTicket}\n\n' +
            'Il nostro personale è al lavoro per evadere la richiesta nel minor tempo possibile.'
        } else {
          vm.subject = 'CLYCO: Chiusura caso di assistenza {nTicket}';
          vm.content =
            'abbiamo concluso le attività di risoluzione della richiesta in oggetto.\n\n' +
            '{descrizioneAttivita}';
        }
        function replaceFn(x) {
          var replace = {
            '{ragioneSociale}' : vm.pv.cliente,
            '{nTicket}' : vm.pv.codice,
            '{descrizioneAttivita}' : vm.attivita ? vm.attivita.descrizioneAttivita : '',
            '{descrizioneTicket}' : vm.pv ? vm.pv.descrizioneTicket : '',
            '{prodotto}' : vm.contratto ? vm.contratto.descProdotto : ''
          }
          return replace[x] ? replace[x] : x;
        }
        var replaceRegexp = /{([^}]+)}/ig;
        vm.content =
          content.header +
          vm.content +
          content.footer;
        vm.subject = vm.subject.replace(replaceRegexp, replaceFn);
        vm.content = vm.content.replace(replaceRegexp, replaceFn);
        inviaNotificaModal.$promise.then(inviaNotificaModal.show);
      }

    }

    vm.saveForm = function () {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      var postData = {
        'action' : vm.action,
        'to' : vm.to,
        'content' : vm.content,
        'subject' : vm.subject
      }
      api.pv(vm.pv.idPostvendita).sendEmailNotification(postData)
        .then( function (pv) {
          $rootScope.$broadcast('afterSendNotification',pv);
          inviaNotificaModal.hide();
        }, setAlerts)

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

  }

})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProvvigioniCalcolateController', ProvvigioniCalcolateController);

  function ProvvigioniCalcolateController($scope, $filter, AuthenticateJS, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.searchData = {};
    vm.searchForm = {};
    vm.dt = {};
    vm.searched = false;
    vm.filtraSoggetti = filtraSoggetti;
    vm.search = search;

    //actions
    vm.readProvvigioneCalcolata = api.provvigioni.calcolate.actions.read;
    vm.deleteProvvigioneCalcolata = api.provvigioni.calcolate.actions.delete;
    vm.readCliente = api.clienti.actions.read;
    vm.readContratto = api.contratti.actions.read;

    //gestione eventi
    $scope.$on('ProvvigioneCalcolata.created', reloadData);
    $scope.$on('ProvvigioneCalcolata.updated', reloadData);
    $scope.$on('ProvvigioneCalcolata.deleted', reloadData);

    //run
    loadSearchData();

    ////////////////////////////////////////////////////////////////////////////
    function loadSearchData() {
      api.provvigioni.calcolate.searchForm().then(function(searchData) {
        vm.searchData = searchData;

        vm.searchData.dFornitori = '0';
        vm.searchData.dPiste = '0';

        vm.searchForm = {
          tipoSoggetto: '0',
          soggetto: '0',
          conferma_from: moment().startOf('year').toDate(),
          conferma_to: moment().endOf('year').startOf('day').toDate(),
          prov_from: -1,
          prov_to: -1,
          fornitore: 'CLYCO',
          pista: '0',
          prodotto: ''
        };
      });
    }

    function filtraSoggetti(soggetti) {
      if (angular.isDefined(soggetti) && angular.isDefined(vm.searchForm.tipoSoggetto)) {
        if (vm.searchForm.tipoSoggetto !== '0') {
          soggetti = $filter('filter')(soggetti, {tipoSoggetto: vm.searchForm.tipoSoggetto}, true);
        } else {
          var soggettiTmp = _.uniq(soggetti, false, 'value');
          var soggetti_tutti = soggettiTmp.shift();
          soggettiTmp = $filter('orderBy')(soggettiTmp, 'label');
          soggettiTmp.unshift(soggetti_tutti);

          soggetti = soggettiTmp;
        }
      }

      return soggetti;
    }

    function search() {
      loadDt();

      vm.searched = true;
    }

    function loadDt() {
      var searchForm = angular.copy(vm.searchForm);
      if (_.isDate(searchForm.conferma_from)) {
        searchForm.conferma_from = searchForm.conferma_from.toISOString();
      }
      if (_.isDate(searchForm.conferma_to)) {
        searchForm.conferma_to = searchForm.conferma_to.toISOString();
      }

      var ajaxRequest = {
        url: apiBaseUrl + '/provvigioni/calcolate?dt',
        data: searchForm,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        }
      };

      if (_.isEmpty(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder.newOptions()
          .withOption('ajax', ajaxRequest)
          .withDataProp('data')
          .withOption('processing', true)
          .withOption('serverSide', true)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              text: 'Esporta',
              className: 'btn-info btn-sm',
              action: exportCsv
            }
          ])
          .withOption('order', [
            [0, 'asc'],
            [1, 'asc'],
            [4, 'asc']
          ])
          .withOption('pageLength', 25)
        );

        vm.dt.columns = [
          {
            data: 'am',
            title: '<span title="Area Manager">AM</span>'
          },
          {
            data: 'agente',
            title: 'Agente'
          },
          {
            data: 'segnalatore',
            title: 'Segnalatore'
          },
          {
            data: 'cliente',
            title: 'Cliente',
            render: renderCliente
          },
          {
            data: 'ptf',
            title: 'Cluster'
          },
          {
            data: 'dataConferma',
            title: 'Data',
            render: dtFactory.renders.date
          },
          {
            data: 'codiceProdotto',
            title: 'Codice',
            render: renderContratto
          },
          {
            data: 'prodotto',
            title: 'Prodotto'
          },
          {
            data: 'qta',
            title: '<span title="Quantità">Qta</span>',
            'class': 'min-width text-right'
          },
          {
            data: 'prezzo',
            title: 'Prezzo',
            render: dtFactory.renders.currency,
            'class': 'min-width text-right'
          },
          {
            data: 'provvigione',
            title: 'Provvigione',
            render: dtFactory.renders.currency,
            'class': 'min-width text-right'
          },
          {
            data: 'ricorrente',
            title: 'Ric',
            render: renderRicorrente
          },
          {
            data: 'tipoSoggetto',
            title: 'Tipo'
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'stato',
            title: 'Stato'
          },
          {
            data: 'dataCalcolo',
            title: 'Calcolo',
            render: dtFactory.renders.date
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dt.instance.changeData(ajaxRequest);
      }

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="pCalcolate.readCliente(' + row.idCliente + ')">' + data + '</a>';
        }

        return data;
      }

      function renderContratto(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri contratto" ng-click="pCalcolate.readContratto(' + row.idContratto + ')">' + data + '</a>';
        }

        return data;
      }

      function renderRicorrente( data ) {
        return data ? 'Sì' : 'No';
      }

      function renderActions(data) {
        var actions = '';

        // var read = '<button type="button" title="Visualizza" class="btn btn-info btn-xs" ng-click="pCalcolate.readProvvigioneCalcolata(' + data + ')"><i class="fa fa-eye"></i></button>';
        var del = '<button type="button" title="Elimina" class="btn btn-danger btn-xs" ng-click="pCalcolate.deleteProvvigioneCalcolata(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = del;

        return actions;
      }

      function exportCsv(e, dt) {
        var getParams = dt.ajax.params();
        delete getParams.start;
        delete getParams.length;
        getParams.csv = true;

        var numRecords = dt.page.info().recordsDisplay;

        return dtFactory.exportFile(apiBaseUrl + '/provvigioni/calcolate', getParams, numRecords);
      }
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProvvigioniCalcolaController', ProvvigioniCalcolaController);

  function ProvvigioniCalcolaController($scope, AuthenticateJS, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.form = {};
    vm.messages = {};
    vm.results = {};
    vm.conflitti = {};
    vm.duplicati = {};
    vm.calcola = calcola;

    //actions
    vm.deleteProvvigioneCalcolata = api.provvigioni.calcolate.actions.delete;
    vm.readCliente = api.clienti.actions.read;
    vm.readContratto = api.contratti.actions.read;

    //gestione eventi
    $scope.$on('ProvvigioneCalcolata.deleted', calcola);

    //run
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadFormData() {
      api.provvigioni.searchForm({type: 'calcola'}).then(function(formData) {
        vm.formData = formData;

        vm.form = {
          conferma_from: moment().startOf('year').toDate(),
          conferma_to: moment().subtract(1, 'month').endOf('month').startOf('day').toDate(),
          positive: true,
          checksSoggetto: {
            Agente: true,
            Agenzia: false,
            Segnalatore: false,
            Telemarketing: false
          },
          provvigioniUnaTantum: true,
          provvigioniRicorrenti: true
        };

        vm.messages = {
          errors: [],
          warnings: [],
          info: []
        };

        vm.conflitti = {
          Agente: {},
          Agenzia: {},
          Segnalatore: {},
          Telemarketing: {}
        };
      });
    }

    function calcola() {
      var postData = angular.copy(vm.form);

      postData.tipoSoggetto = [];
      angular.forEach(postData.checksSoggetto, function(value, key) {
        if (value) {
          postData.tipoSoggetto.push(key);
        }
      });
      delete postData.checksSoggetto;

      //reset dei messaggi
      vm.messages = {
        errors: [],
        warnings: [],
        info: []
      };

      //reset delle dt conflitti
      vm.conflitti = {
        Agente: {},
        Agenzia: {},
        Segnalatore: {},
        Telemarketing: {}
      };

      api.provvigioni.calcola(postData)
        .then(setResults, setWarnings);

      //////////////////////////////////////////////////////////////////////////
      function setResults(results) {

        vm.results = results;

        angular.forEach(results, function(value, key) {
          if (!_.isEmpty(value['delete'])) {
            if (angular.isDefined(value['delete']['error'])) {
              vm.messages.errors.push({
                text: key + ': ' + value['delete']['error'].text
              });
            } else {
              vm.messages.info.push({
                text: key + ': cancellate ' + value['delete'].rowCount + ' righe'
              });
            }
          }

          if (!_.isEmpty(value['insert'])) {
            if (angular.isDefined(value['insert']['error'])) {
              vm.messages.errors.push({
                text: key + ': ' + value['insert']['error'].text
              });
            } else {
              vm.messages.info.push({
                text: key + ': inserite ' + value['insert'].rowCount + ' righe'
              });

              if (!_.isEmpty(value['insert']['zeroRows'])) {
                vm.messages.warnings.push({
                  text: key + ': ci sono ' + value['insert'].zeroRows + ' provvigioni con valore zero'
                });
              }
            }
          }
        })
      }

      function setWarnings(response) {
        if (angular.isDefined(response.data.warnings)) {
          vm.messages.warnings = response.data.warnings;
        }

        if (angular.isDefined(response.data.errors)) {
          vm.messages.errors = response.data.errors;
        }

        if (response.status === 500) {
          angular.forEach(response.data, function(value, key) {
            if (angular.isDefined(value['delete']['error'])) {
              vm.messages.errors.push({
                text: key + ': ' + value['delete']['error']['text']
              });
            }

            if (angular.isDefined(value['insert']['error'])) {
              vm.messages.errors.push({
                text: key + ': ' + value['insert']['error']['text']
              });

              if (value['insert']['error']['code'] === 'schede_multiple') {
                vm.duplicati[key] = dtDuplicati(value['insert']['error']['data']);
              }
            }
          })
        }

        if (response.status === 409) {
          angular.forEach(response.data, function(value, key) {
            if (!_.isEmpty(value['insert']) && angular.isArray(value['insert'])) {
              vm.messages.errors.push({
                text: key + ': Ci sono ' + value['insert'].length + ' provvigioni in conflitto in quanto già presenti per lo stesso prodotto/servizio in periodo differente'
              });

              vm.conflitti[key] = dtConflitto(value['insert']);
            }
          })
        }

        function dtConflitto(data) {
          var dt = {};

          dt.data = data;

          dt.instance = {};

          dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              return api.toPromise(data);
            })
            .withOption('order', [
              [0, 'asc'],
              [1, 'asc'],
              [4, 'asc']
            ])
            .withOption('info', false)
            .withOption('lengthChange', false)
            .withOption('searching', false)
            .withOption('paging', false)
          );

          dt.columns = [
            {data: 'squadra', title: 'Squadra'},
            {data: 'soggetto', title: 'Soggetto'},
            {
              data: 'cliente',
              title: 'Cliente',
              render: renderCliente
            },
            {data: 'ptf', title: 'Cluster'},
            {
              data: 'dataConferma',
              title: 'Data',
              render: dtFactory.renders.date
            },
            {
              data: 'codiceProdotto',
              title: 'Codice',
              render: renderContratto
            },
            {data: 'prodotto', title: 'Prodotto'},
            {
              data: 'qta',
              title: '<span title="Quantità">Qta</span>',
              'class': 'min-width text-right'
            },
            {
              data: 'prezzo',
              title: 'Prezzo',
              render: dtFactory.renders.currency,
              'class': 'min-width text-right'
            },
            {
              data: 'provvigione',
              title: 'Provvigione',
              render: dtFactory.renders.currency,
              'class': 'min-width text-right'
            },
            {data: 'fornitore', title: 'Fornitore'},
            {data: 'pista', title: 'Pista'},
            {data: 'stato', title: 'Stato'},
            {
              data: 'dataCalcolo',
              title: 'Calcolo',
              render: dtFactory.renders.date
            },
            {
              data: 'id',
              render: renderActions,
              'class': 'min-width text-center',
              orderable: false,
              searchable: false
            }
          ];

          return dt;

          //////////////////////////////////////////////////////////////////////////
          function renderCliente(data, type, row) {
            if (type === 'display') {
              data = '<a title="apri cliente" ng-click="pCalcola.readCliente(' + row.idCliente + ')">' + data + '</a>';
            }

            return data;
          }

          function renderContratto(data, type, row) {
            if (type === 'display') {
              data = '<a title="apri contratto" ng-click="pCalcola.readContratto(' + row.idContratto + ')">' + data + '</a>';
            }

            return data;
          }

          function renderActions(data) {
            return '<button type="button" title="Elimina" class="btn btn-danger btn-xs" ng-click="pCalcola.deleteProvvigioneCalcolata(' + data + ')"><i class="fa fa-minus"></i></button>';
          }
        }

        function dtDuplicati(data) {
          var dt = {};

          dt.data = data;

          dt.instance = {};

          dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              return api.toPromise(data);
            })
            .withOption('order', [
              [0, 'asc']
            ])
            .withOption('info', false)
            .withOption('lengthChange', false)
            .withOption('searching', false)
            .withOption('paging', false)
          );

          dt.columns = [
            {
              data: 'dataOrdine',
              title: 'Data Ordine',
              render: dtFactory.renders.date
            },
            {data: 'soggetto', title: 'Soggetto'},
            {data: 'fornitore', title: 'Fornitore'},
            {data: 'pista', title: 'Pista'},
            {data: 'prodotto', title: 'Prodotto'},
            {data: 'numSchede', title: 'Num. Schede'}
          ];

          return dt;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProvvigioniController', ProvvigioniController);

  function ProvvigioniController(AuthenticateJS) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProvvigioneCalcolataController', ProvvigioneCalcolataController);

  function ProvvigioneCalcolataController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var pCalcolataModal = $modal({
      scope: $scope,
      templateUrl: 'provvigione-calcolata-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.provCalc = {};

    $scope.$on('readProvvigioneCalcolata', readProvvigioneCalcolata);

    ////////////////////////////////////////////////////////////////////////////
    function readProvvigioneCalcolata(event, idProvCalc) {

      api.provvigioni.calcolata(idProvCalc).get()
        .then(showModal);

      function showModal(provCalc) {
        vm.provCalc = provCalc;

        pCalcolataModal.$promise
          .then(pCalcolataModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PromemoriaReadController', PromemoriaReadController);

  function PromemoriaReadController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var PromemoriaReadModal = $modal({
      scope: $scope,
      templateUrl: 'promemoria-read-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.promemoria = {};

    vm.updatePromemoria = updatePromemoria;
    vm.deletePromemoria = deletePromemoria;

    $scope.$on('readPromemoria', readPromemoria);

    ////////////////////////////////////////////////////////////////////////////
    function readPromemoria(event, idPromemoria) {
      api.promemoria(idPromemoria).get()
        .then(showModal);

      function showModal(promemoria) {
        vm.promemoria = promemoria;
        PromemoriaReadModal.$promise
          .then(PromemoriaReadModal.show);
      }
    }

    function updatePromemoria() {
      PromemoriaReadModal.hide();
      api.promemoria().actions.update(vm.promemoria.id);
    }

    function deletePromemoria() {
      PromemoriaReadModal.hide();
      api.promemoria().actions.delete(vm.promemoria.id);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PromemoriaEditController', PromemoriaEditController);

  function PromemoriaEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var PromemoriaEditModal = $modal({
      scope: $scope,
      templateUrl: 'promemoria-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.promemoria = [];
    vm.alerts = [];
    vm.saveForm = saveForm;

    $scope.$on('createPromemoria', createPromemoria);
    $scope.$on('updatePromemoria', updatePromemoria);

    ////////////////////////////////////////////////////////////////////////////
    function createPromemoria(event, tabellaCollegata) {
      vm.action = 'create';
      vm.alerts = [];

      //imposta i defaults
      vm.promemoria = {
        tabella: tabellaCollegata.tabella || null,
        campoId: tabellaCollegata.campoId || null,
        recordId: tabellaCollegata.recordId || null,
        campoFk: tabellaCollegata.campoFk || null,
        dataOra: new Date(),
        flagMail: true
      };

      PromemoriaEditModal.$promise
        .then(PromemoriaEditModal.show);
    }

    function updatePromemoria(event, idPromemoria) {
      vm.action = 'update';
      vm.alerts = [];

      api.promemoria(idPromemoria).get()
        .then(showModal);

      function showModal(promemoria) {
        vm.promemoria = promemoria;

        PromemoriaEditModal.$promise
          .then(PromemoriaEditModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (vm.action === 'create') {
        api.promemoria().save(vm.promemoria)
          .then(PromemoriaEditModal.hide, setAlerts);
      } else if (vm.action === 'update') {
        api.promemoria(vm.promemoria.id).update(vm.promemoria)
          .then(PromemoriaEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('PromemoriaController', PromemoriaController);

  function PromemoriaController($scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.sp = {
      tabella: '',
      completato: '-1'
    };
    vm.dtPromemoria = {
      show: false
    };
    vm.search = dtPromemoria;
    vm.resetForm = resetForm;

    vm.opportunitaRead = api.opportunita().actions.read;
    vm.clientiRead = api.clienti.actions.read;
    vm.appuntamentiRead = api.appuntamenti.actions.read;
    vm.contrattiRead = api.contratti.actions.read;

    vm.updatePromemoria = api.promemoria().actions.update;
    vm.deletePromemoria = api.promemoria().actions.delete;

    //carica i dati della form
    api.promemoria().searchForm()
      .then(function(formData) {
        vm.formData = formData;
      })
    ;

    //reagisci ai cambiamenti sui promemoria
    $scope.$on('Promemoria.created', dtPromemoriaReload);
    $scope.$on('Promemoria.updated', dtPromemoriaReload);
    $scope.$on('Promemoria.deleted', dtPromemoriaReload);

    ////////////////////////////////////////////////////////////////////////////
    function resetForm() {
      vm.dtPromemoria.show = false;
      vm.sp = {
        tabella: '',
        completato: '-1'
      };
    }

    function dtPromemoria() {
      if (_.isEmpty(vm.dtPromemoria.dtInstance)) {
        vm.dtPromemoria.dtInstance = {};

        vm.dtPromemoria.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(promemoriaList)
          .withOption('order', [
            [4, 'asc'],
            [0, 'asc']
          ])
          .withOption('createdRow', createdRow)
          .withOption('pageLength', 25)
        );

        vm.dtPromemoria.dtColumns = [
          {
            data: 'dataOra',
            title: 'Scadenza',
            render: dtFactory.renders.datetime
          },
          {
            data: 'titolo',
            title: 'Titolo',
            render: renderTitolo
          },
          {
            data: 'note',
            title: 'Descrizione',
            'class': '',
            render: dtFactory.renders.longtext
          },
          {
            data: 'flagMail',
            title: '<i class="fa fa-envelope" title="Notifica via mail"></i>',
            render: dtFactory.renders.boolean,
            'class': 'min-width text-center'
          },
          {
            data: 'completato',
            title: 'Completato',
            render: dtFactory.renders.boolean,
            'class': 'min-width text-center'
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dtPromemoria.dtInstance.changeData(promemoriaList);
      }

      vm.dtPromemoria.show = true;

      //////////////////////////////////////////////////////////////////////////
      function promemoriaList() {
        var promise = api.promemoria().list(vm.sp);
        promise.then( function ( promemoria ) {
          vm.promemoria = promemoria;
        } );
        return promise;
      }

      function renderTitolo( data, type, row ) {
        if ( type == 'display' ) {
          var ngClick = '';
          var dest = '';
          if ( row.campoFk ) { //apri il padre
            switch ( row.tabella) {
              case 'opportunita_attivita':
                ngClick = 'vm.opportunitaRead(' + row.recordFk +')';
                dest = 'opportunita';
              break;
            }
          } else { //apri record
            var funct = '';
            switch ( row.tabella ) {
              case 'clienti':
                funct = 'vm.clientiRead';
                dest = 'cliente';
              break;
              case 'ordini':
                funct = 'vm.appuntamentiRead';
                dest = 'appuntamento';
              break;
              case 'dettagli_ordini':
                funct = 'vm.contrattiRead';
                dest = 'contratto';
              break;
              case 'opportunita':
                funct = 'vm.opportunitaRead';
                dest = 'opportunita';
              break;
            }
            if ( funct != '' ) {
              ngClick = funct + '(' + row.recordId + ')';
            }
          }
          if ( ngClick != '' ) {
            data =
              '<a bs-tooltip data-title="apri ' + dest + '" ng-click="' + ngClick + '">' +
                data +
              '</a>';
          }
        }
        return data;
      }

      function createdRow(row, data) {
        /* gestione dello stile di ogni riga */
        if (data.completato) {
          angular.element(row).addClass('text-success');
        }
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="vm.updatePromemoria(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="vm.deletePromemoria(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function dtPromemoriaReload() {
      if (!_.isEmpty(vm.dtPromemoria.dtInstance)) {
        vm.dtPromemoria.dtInstance.reloadData();
      } else if ( vm.dtPromemoria.show ) {
        dtPromemoria();
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .directive('g1PromBell', g1PromBell);

  function g1PromBell() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/promemoria/g1PromBell.tpl.html',
      scope: {
        tabella: '@?',
        campoId: '@?',
        recordId: '@?',
        campoFk: '@?'
      },
      bindToController: true,
      controller: controllerFn,
      controllerAs: 'vm'
    };

    function controllerFn($window, $location, $element, $scope, AuthenticateJS, $modal, $popover, api) {
      var vm = this;

      var PromemoriaPopover = $popover($element.find('i'), {
        scope: $scope,
        templateUrl: 'promemoria-popover.tpl.html',
        trigger: 'manual',
        target: $element.find('i'),
        viewport: 'body',
        placement: 'auto bottom',
        onShow: function() {
          PromemoriaPopover.$applyPlacement();
        }
      });

      vm.auth = AuthenticateJS;
      vm.user = vm.auth.getUser();

      vm.promemoria = [];
      vm.bellAction = bellAction;
      vm.showSearch = showSearch;
      vm.showList = showList;
      vm.showCreate = showCreate;
      vm.showRead = showRead;
      vm.showUpdate = showUpdate;
      vm.showDelete = showDelete;
      vm.setComplete = setComplete;
      vm.openModal = openModal;

      //recupera da server i promemoria
      getPromemoria();

      //gestione eventi
      $scope.$on('Promemoria.created', refreshPromemoria);
      $scope.$on('Promemoria.deleted', refreshPromemoria);
      // $scope.$on('Promemoria.updated', refreshPromemoria);

      //////////////////////////////////////////////////////////////////////////
      function getPromemoria() {
        var promise = api.promemoria().list({
          tabella: vm.tabella || null,
          campoId: vm.campoId || null,
          recordId: vm.recordId || null,
          completato: 0
        });

        function dest( row ) {
          var dest = '';
          if ( row.campoFk ) { //apri il padre
            switch ( row.tabella) {
              case 'opportunita_attivita':
                dest = 'opportunita';
              break;
            }
          } else { //apri record
            switch ( row.tabella ) {
              case 'clienti':
                dest = 'cliente';
              break;
              case 'ordini':
                dest = 'appuntamento';
              break;
              case 'dettagli_ordini':
                dest = 'contratto';
              break;
              case 'opportunita':
                dest = 'opportunita';
              break;
            }
          }
          return dest;
        }
        promise.then(function(promemoria) {
          for ( var i = 0; i < promemoria.length; i++ ) {
            promemoria[i].dest = dest( promemoria[i] );
          }
          vm.promemoria = promemoria;
        });

        return promise;
      }

      function refreshPromemoria() {
        getPromemoria();
      }

      function bellAction() {
        vm.showList();
      }

      function showSearch() {
        PromemoriaPopover.hide();

        $location.path('/promemoria');
      }

      function showList() {
        getPromemoria().then(function(promemoria) {
          vm.promemoria = promemoria;
          PromemoriaPopover.toggle();
        });
      }

      function showCreate() {
        PromemoriaPopover.hide();

        api.promemoria().actions.create({
          tabella: vm.tabella || null,
          campoId: vm.campoId || null,
          recordId: vm.recordId || null,
          campoFk: vm.campoFk || null
        });
      }

      function showRead(promemoria) {
        PromemoriaPopover.hide();

        api.promemoria().actions.read(promemoria.id);
      }

      function showUpdate(promemoria) {
        PromemoriaPopover.hide();

        api.promemoria().actions.update(promemoria.id);
      }

      function showDelete(promemoria) {
        PromemoriaPopover.hide();

        var answer = $window.confirm('vuoi eliminare il promemoria?');

        if (answer) {
          api.promemoria(promemoria.id).remove({conferma: 'CONFERMA'});
        }
      }

      function setComplete(promemoria) {
        api.promemoria(promemoria.id).update(promemoria);
      }

      function openModal(promemoria) {
        PromemoriaPopover.hide();

        if (promemoria.campoFk) { //apri il padre
          switch (promemoria.tabella) {
            case 'opportunita_attivita':
              api.opportunita().actions.read(promemoria.recordFk);
          }
        } else { //apri record
          switch (promemoria.tabella) {
            case 'clienti':
              api.clienti.actions.read(promemoria.recordId);
              break;

            case 'ordini':
              api.appuntamenti.actions.read(promemoria.recordId);
              break;

            case 'dettagli_ordini':
              api.contratti.actions.read(promemoria.recordId);
              break;

            case 'opportunita':
              api.opportunita().actions.read(promemoria.recordId);
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ProdottiController', ProdottiController);

  function ProdottiController($rootScope, $scope, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var prodottiModal = $modal({
      scope: $scope,
      templateUrl: 'prodotti-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var prodotti = [];

    vm.formData = {};
    vm.sp = {
      descrizione: '',
      fornitore: '0',
      pista: '0'
    };
    vm.dtProdotti = {};
    vm.search = search;
    vm.resetForm = resetForm;
    vm.selectProdotto = selectProdotto;

    $scope.$on('searchProdotto', searchProdotto);

    ////////////////////////////////////////////////////////////////////////////
    function searchProdotto() {
      // resetta i dati della form
      resetForm();

      // carica la DT
      dtProdotti();

      // carica i dati della form e visualizza la modal
      api.prodotti.searchForm()
        .then(showModal)
      ;

      function showModal(formData) {
        vm.formData = formData;

        prodottiModal.$promise
          .then(prodottiModal.show);
      }
    }

    function search() {
      vm.dtProdotti.dtInstance.changeData(prodottiList);

      function prodottiList() {
        return api.prodotti.list(vm.sp);
      }
    }

    function resetForm() {
      vm.sp.descrizione = '';
      vm.sp.fornitore = '0';
      vm.sp.pista = '0';

      prodotti = [];
    }

    function dtProdotti() {
      vm.dtProdotti.dtInstance = {};

      vm.dtProdotti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(api.empty)
          .withOption('createdRow', getProdotti)
          .withOption('lengthChange', false)
          .withOption('searching', false)
      );

      vm.dtProdotti.dtColumns = [
        {data: 'codice', title: 'Cod'},
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'prezzoUnitario',
          title: 'Prezzo',
          render: dtFactory.renders.currency
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false,
          'class': 'min-width text-center'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        return '<button type="button" class="btn btn-success btn-xs" title="Seleziona Prodotto" ng-click="pc.selectProdotto(' + data + ')"><i class="fa fa-check"></i></button>';
      }

      function getProdotti(row, data) {
        prodotti[data.id] = data;
      }
    }

    function selectProdotto(id) {
      //nascondo la modal
      prodottiModal.hide();

      //notifico l'evento
      $rootScope.$broadcast('Prodotto.selected', prodotti[id]);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .directive('g1ProdottiSearch', g1ProdottiSearchDirective);

  function g1ProdottiSearchDirective() {
    return {
      restrict: 'A',
      templateUrl: 'app/core/prodotti/prodotti-search.tpl.html',
      scope: {
        psMode: '@',
        psAction: '&'
      },
      link: linkFn,
      controller: controllerFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, iElement, iAttrs, ctrl) {
      scope.formData = {};
      scope.sp = {
        descrizione: '',
        fornitore: 'CLYCO',
        pista: '0'
      };
      scope.prodotti = [];
      scope.dtProdotti = {
        show: false
      };
      scope.search = ctrl.search;
      scope.resetForm = ctrl.resetForm;
      scope.selectProdotto = ctrl.selectProdotto;

      //carica i dati della form
      ctrl.loadFormData();

      //gestisci il cambiamento del modo di ricerca
      scope.$watch('sp.searchMode', ctrl.onSearchModeChange);
    }

    function controllerFn($scope, dtFactory, DTOptionsBuilder, api) {
      var ctrl = this;

      ctrl.loadFormData = loadFormData;
      ctrl.search = search;
      ctrl.resetForm = resetForm;
      ctrl.selectProdotto = selectProdotto;

      //////////////////////////////////////////////////////////////////////////
      function prodottiList() {
        return api.prodotti.list($scope.sp);
      }

      function dtProdotti() {
        $scope.dtProdotti.dtInstance = {};

        $scope.dtProdotti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(prodottiList)
            .withOption('createdRow', getProdotti)
            .withOption('lengthChange', false)
            .withOption('searching', false)
        );

        if ($scope.psMode === 'insert') {
          $scope.dtProdotti.dtColumns = [
            {
              data: 'codice',
              title: 'Cod',
              'class': 'codice'
            },
            {
              data: 'descrizione',
              title: 'Descrizione',
              'class': 'descrizione'
            },
            {
              data: 'qta',
              title: 'Qta',
              render: renderQta,
              orderable: false,
              searchable: false,
              'class': 'qta'
            },
            {
              data: 'prezzoUnitario',
              title: 'Prezzo',
              render: renderPrezzoUnitario,
              orderable: false,
              searchable: false,
              'class': 'prezzo'
            },
            {
              data: null,
              title: 'Pr.Tot.',
              render: renderPrezzo,
              orderable: false,
              searchable: false,
              'class': 'prezzoTotale text-right'
            },
            {
              data: 'durataContratto',
              title: 'Durata',
              render: renderDurata,
              orderable: false,
              searchable: false,
              'class': 'prezzoTotale text-right'
            },
            {
              data: null,
              title: 'Note',
              render: renderNote,
              orderable: false,
              searchable: false,
              'class': 'note'
            },
            {
              data: 'id',
              render: renderActions,
              orderable: false,
              searchable: false,
              'class': 'min-width text-center'
            }
          ];
        } else {
          $scope.dtProdotti.dtColumns = [
            {
              data: 'codice',
              title: 'Cod'
            },
            {
              data: 'descrizione',
              title: 'Descrizione'
            },
            {
              data: 'prezzoUnitario',
              title: 'Prezzo',
              render: dtFactory.renders.currency
            },
            {
              data: 'id',
              render: renderActions,
              orderable: false,
              searchable: false,
              'class': 'min-width text-center'
            }
          ];
        }

        //////////////////////////////////////////////////////////////////////////
        function renderActions(data) {
          return '<button type="button" class="btn btn-success btn-xs" title="Inserisci Prodotto" ng-click="selectProdotto(' + data + ')"><i class="fa fa-plus"></i></button>';
        }

        function getProdotti(row, data) {
          $scope.prodotti[data.id] = data;
          $scope.prodotti[data.id].qta = 1;
          $scope.prodotti[data.id].note = '';
        }

        //only for insert mode functions
        function renderPrezzoUnitario(data, type, row) {
          if (type === 'display') {
            return '<input type="text" class="form-control input-sm text-right" size="4" ng-model="prodotti[' + row.id + '].prezzoUnitario">';
            // return '<input type="number" class="text-right" style="width: 7rem;" ng-model="prodotti[' + row.id + '].prezzoUnitario">';
          }

          return '{{prodotti[' + row.id + '].prezzoUnitario}}';
        }

        function renderQta(data, type, row) {
          if (type === 'display') {
            return '<input type="text" class="form-control input-sm text-right" size="1" ng-model="prodotti[' + row.id + '].qta">';
            //return '<input type="text" class="text-right" size="1" ng-model="prodotti[' + row.id + '].qta">';
          }

          return '{{prodotti[' + row.id + '].qta}}';
        }

        function renderPrezzo(data, type, row) {
          return '<strong>{{prodotti[' + row.id + '].qta * prodotti[' + row.id + '].prezzoUnitario | currency}}</strong>';
        }

        function renderDurata( data ) {
          if ( data != 0 ) {
            return data + ' mesi';
          }
        }

        function renderNote(data, type, row) {
          if (type === 'display') {
            return '<textarea class="form-control" style="font-size: inherit" msd-elastic="\\n" ng-model="prodotti[' + row.id + '].note"></textarea>';
            //return '<textarea rows="1" style="min-height: 22px" msd-elastic ng-model="prodotti[' + row.id + '].note"></textarea>';
          }

          return '{{prodotti[' + row.id + '].note}}';
        }
      }

      function loadFormData() {
        api.prodotti.searchForm()
          .then(function(formData) {
            $scope.formData = formData;
          })
        ;
      }

      function search() {
        if (!$scope.dtProdotti.show) {
          dtProdotti();
          $scope.dtProdotti.show = true;
        } else {
          $scope.dtProdotti.dtInstance.changeData(prodottiList);
        }
      }

      function resetForm() {
        $scope.sp.descrizione = '';
        $scope.sp.fornitore = '0';
        $scope.sp.pista = '0';

        $scope.prodotti = [];

        $scope.dtProdotti = {
          showTable: false
        };
      }

      function selectProdotto(id) {
        return $scope.psAction({prodSel: $scope.prodotti[id]});
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaViewController', OpportunitaViewController);

  function OpportunitaViewController($timeout, $routeParams, AuthenticateJS, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.readOpportunita = api.opportunita().actions.read;
    vm.idPv = $routeParams.id;

    $timeout(function() {
      vm.readOpportunita(vm.idPv);
    }, 1000);
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaReadController', OpportunitaReadController);

  function OpportunitaReadController(
    $window, $rootScope, $scope, $filter, AuthenticateJS, $modal,
    DTOptionsBuilder, dtFactory, api, apiBaseUrl
  ) {
    var vm = this;

    var readModal = $modal( {
      scope: $scope,
      templateUrl: 'opportunita-read-modal.tpl.html',
      backdrop: false,
      show: false
    } );
    var richiestaProgettazioneModal = $modal( {
      scope: $scope,
      templateUrl: 'opportunita-richiesta-progettazione-modal.tpl.html',
      backdrop: 'static',
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = [];
    vm.formData = {};
    vm.cliente = {};

    //opportunita
    vm.opportunita = {};
    vm.datiMail = {};
    vm.checkEditPermission = api.opportunita().actions.checkEditPermission;
    vm.updateOpportunita = api.opportunita().actions.update;
    vm.sendOpportunita = api.opportunita().actions.send;
    vm.changeFase = changeFase;
    vm.changeValore = changeValore;
    vm.setPercChiusura = setPercChiusura;
    vm.changeStato = changeStato;
    vm.richiestaProgettazione = richiestaProgettazione;

    vm.readCliente = api.clienti.actions.read;
    vm.readProgetto = api.opportunita().progetti().actions.read;

    //attivita
    vm.dtAttivita = {};
    vm.attivita = [];
    vm.titleAttivita = 'Attività';

    vm.createAttivita = function ( idTipo ) {
      vm.opportunita.idTipo = idTipo;
      $rootScope.$broadcast( 'createAttivitaOpportunitaPerTipo', vm.opportunita );
    };
    vm.readAttivita = api.opportunita().attivita().actions.read;
    vm.updateAttivita = api.opportunita().attivita().actions.update;
    vm.deleteAttivita = api.opportunita().attivita().actions.delete;

    vm.createAppuntamentoOpportunita = createAppuntamentoOpportunita;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.updateAppuntamento = api.appuntamenti.actions.update;
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;
    vm.rimuoviAppuntamento = rimuoviAppuntamento;

    //storico
    vm.dtStorico = {};
    vm.storico = [];

    vm.readLogOpportunita = api.opportunita().logs.actions.read;
    vm.updateLogOpportunita = api.opportunita().logs.actions.update;

    //allegati
    vm.dtAllegati = {};
    vm.allegati = [];
    vm.titleAllegati = 'Allegati';

    vm.createAllegato = function(opportunita) {
      opportunita.idOpportunita = opportunita.id; // per uniformità
      $rootScope.$broadcast('createAllegato', opportunita);
    };
    vm.updateAllegato = api.allegati.actions.update;
    vm.deleteAllegato = api.allegati.actions.delete;

    //gestione opportunita
    $scope.$on('readOpportunita', readOpportunita);
    $scope.$on('Opportunita.updated', opportunitaReload);

    //gestione attivita
    $scope.$watchCollection('orc.attivita', setTitleAttivita);

    $scope.$on('Opportunita.sended', dtAttivitaReload);

    $scope.$on('AttivitaOpportunita.created', dtAttivitaReload);
    $scope.$on('AttivitaOpportunita.updated', dtAttivitaReload);
    $scope.$on('AttivitaOpportunita.deleted', dtAttivitaReload);

    $scope.$on('Appuntamento.created', dtAttivitaReload);
    $scope.$on('Appuntamento.updated', dtAttivitaReload);
    $scope.$on('Appuntamento.deleted', dtAttivitaReload);

    //gestione storico
    $scope.$on('LogOpportunita.updated', dtStoricoReload);

    //gestione allegati
    $scope.$watchCollection('orc.allegati', setTitleAllegati);

    $scope.$on('Allegato.created', dtAllegatiReload);
    $scope.$on('Allegato.updated', dtAllegatiReload);
    $scope.$on('Allegato.deleted', dtAllegatiReload);

    ////////////////////////////////////////////////////////////////////////////
    //gestione azioni
    function generaAzioni(opportunita) {
      //gestione dati email
      vm.datiMail.oggetto = 'Opportunità ' + opportunita.cliente;
      vm.datiMail.cc = vm.user.contacts.email;

      if (opportunita.seguimi) {
        api.soggetto(opportunita.idAgentePIC).get().then(function(soggetto) {
          if (soggetto.email !== vm.datiMail.cc) {
            vm.datiMail.cc += ',' + soggetto.email;
          }
        })
      }

      //gestione azioni
      var actions = [];
      var availableActions = {
        updateOpportunita: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'orc.updateOpportunita(orc.opportunita.id);'
        },
        sendOpportunita: {
          text: '<i class="fa fa-mail-forward fa-fw"></i>&nbsp;Invia Mail',
          click: 'orc.sendOpportunita(orc.opportunita.id, orc.datiMail);'
        }
      };

      if (vm.checkEditPermission(vm.user, opportunita)) {
        actions.push(availableActions.updateOpportunita);
        actions.push(availableActions.sendOpportunita);
      }

      return actions;
    }

    //gestione opportunita
    function readOpportunita(event, idOpportunita) {
      api.opportunita(idOpportunita).get()
        .then(showModal);

      function showModal(opportunita) {
        vm.opportunita = opportunita;

        //load azioni
        vm.azioni = generaAzioni(vm.opportunita);

        //load formdata per cambio fase
        api.opportunita().editForm().then(function(formData) {
          vm.formData = formData;
        });

        //load tabelle
        dtAttivita(idOpportunita);
        dtStorico(idOpportunita);
        dtAllegati(idOpportunita);

        readModal.$promise
          .then(readModal.show);
      }
    }

    function opportunitaReload(event, opportunita) {
      vm.opportunita = opportunita;

      dtAttivitaReload();
      dtStoricoReload();
    }

    function changeFase() {
      api.opportunita(vm.opportunita.id).update(vm.opportunita)
        .then( function ( response ) {
          vm.showChangeFase = false;
          setAlerts( response );
        });
    }

    function changeValore() {
      api.opportunita(vm.opportunita.id).update(vm.opportunita)
        .then( function ( response ) {
          vm.showChangeValore = false;
          setAlerts( response );
        });
    }

    function setPercChiusura() {
      vm.opportunita.percChiusura = $filter('filter')(vm.formData.stages, {value: vm.opportunita.idStage}, true)[0].percChiusura;
    }

    function changeStato(idStato) {
      vm.opportunita.idStato = idStato;
      api.opportunita(vm.opportunita.id).update(vm.opportunita).then( function ( response ) {
        setAlerts( response );
      });
    }

    function richiestaProgettazione( isConfirmed ) {
      if ( isConfirmed == undefined ) {
        richiestaProgettazioneModal.show();
      } else if ( isConfirmed ) {
        vm.opportunita.richiestaProgettazione = true;
        api.opportunita( vm.opportunita.id ).update( vm.opportunita ).then( function ( opportunita ) {
          vm.opportunita = opportunita;
          richiestaProgettazioneModal.hide();
        } );
      }
    }

    //gestione attivita
    function dtAttivita(idOpportunita) {
      vm.dtAttivita.instance = {};

      vm.dtAttivita.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          var promise = api.opportunita(idOpportunita).attivita().list();

          promise.then(function(attivita) {
            vm.attivita = attivita;
          });

          return promise;
        })
        .withOption('dom', "tr<'row'<'col-xs-5'i><'col-xs-7'p>>")
        .withOption('order', [0, 'desc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtAttivita.columns = [
        {
          data: 'dataOraAttivita',
          title: 'Data',
          render: renderDataOra
        },
        {
          data: 'tipo',
          title: 'Tipo'
        },
        {
          data: 'descrizione',
          title: 'Descrizione'
        },
        {
          data: 'soggetto',
          title: 'Soggetto'
        },
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderDataOra(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.datetime(data, type);

          switch (row.idTipo) {
            case '2': // appuntamento
              data = '<a ng-click="orc.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
              break;

            case '1': // generica
            case '3': // telefonata
            case '4': // email
            default:
              data = '<a ng-click="orc.readAttivita(\'' + row.id + '\')">' + data + '</a>';
              if ( row.idProgetto != '' ) {
                data += '&nbsp;<i bs-tooltip data-title="Attività collegata al progetto" class="fa fa-graduation-cap"></i>';
              }
            break;
          }
        } else if (type === 'filter') {
          data = dtFactory.renders.datetime(data, type);
        }

        return data;
      }

      function renderActionsTitle() {
        return '\
          <div ng-if="orc.opportunita.idStato===1">\
            <button type="button" class="btn btn-success btn-xs" bs-dropdown data-placement="left"><i class="fa fa-plus"></i></button>\
            <ul class="dropdown-menu" role="menu">\
              <li><a ng-click="orc.createAttivita(\'1\')">Attività generica</a></li>\
              <li><a ng-click="orc.createAppuntamentoOpportunita()">Appuntamento</a></li>\
              <li><a ng-click="orc.createAttivita(\'3\')">Telefonata</a></li>\
              <li><a ng-click="orc.createAttivita(\'4\')">Email</a></li>\
            </ul>\
          </div>';
      }

      function renderActions(data, type, row) {
        var actions = '';

        var app = {
          upd: '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="orc.updateAppuntamento(' + data + ')"><i class="fa fa-pencil"></i></button>',
          del: '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Cancella" ng-click="orc.deleteAppuntamento(' + data + ')"><i class="fa fa-minus"></i></button>',
          rem: '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Rimuovi associazione appuntamento-opportunità" ng-click="orc.rimuoviAppuntamento(' + data + ')"><i class="fa fa-unlink"></i></button>'
        };
        var upd = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="orc.updateAttivita(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Cancella" ng-click="orc.deleteAttivita(' + data + ')"><i class="fa fa-minus"></i></button>';

        if ( vm.opportunita.idStato === 1 ) {
          switch (row.idTipo) {
            case 2: // appuntamento
              actions = app.rem + '&nbsp;&nbsp;' + app.upd + '&nbsp;' + app.del;
            break;
            case 1: // generica
            case 3: // telefonata
            case 4: // email
            default:
              actions = upd + '&nbsp;' + del;
          }
        }

        return actions;
      }
    }

    function dtAttivitaReload() {
      if (!_.isEmpty(vm.dtAttivita.instance)) {
        vm.dtAttivita.instance.reloadData();
      }
    }

    function setTitleAttivita(attivita) {
      if (attivita) {
        if (attivita.length > 0) {
          vm.titleAttivita = 'Attività <span class="badge">' + attivita.length + '</span>';
        } else {
          vm.titleAttivita = 'Attività';
        }
      }
    }

    function createAppuntamentoOpportunita() {
      api.cliente(vm.opportunita.idCliente).get()
        .then(function(cliente) {
          $rootScope.$broadcast('createAppuntamentoOpportunita', cliente, vm.opportunita);
        });
    }

    function rimuoviAppuntamento(idAppuntamento) {
      var risposta = $window.confirm("Vuoi rimuovere l'associazione dell'appuntamento all'opportunità?");

      if (risposta) {
        api.appuntamento(idAppuntamento).unsetOpportunita();
      }
    }

    //gestione storico
    function dtStorico(idOpportunita) {
      vm.dtStorico.instance = {};

      vm.dtStorico.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          var promise = api.opportunita(idOpportunita).logs.list();

          promise.then(function(storico) {
            vm.storico = storico;
          });

          return promise;
        })
        .withOption('dom', "tr<'row'<'col-xs-5'i><'col-xs-7'p>>")
        .withOption('order', [0, 'desc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtStorico.columns = [
        {
          data: 'dataOraIns',
          title: 'Fino al',
          render: renderDataOra
        },
        {
          data: 'stage',
          title: 'Fase'
        },
        {
          data: 'noteLog',
          title: 'Note Storico',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderDataOra(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.datetime(data, type);

          data = '<a bs-tooltip data-title="Visualizza log" ng-click="orc.readLogOpportunita(\'' + row.id + '\')">' + data + '</a>';
        } else if (type === 'filter') {
          data = dtFactory.renders.datetime(data, type);
        }

        return data;
      }

      function renderActions(data) {
        return '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="orc.updateLogOpportunita(' + data + ')"><i class="fa fa-pencil"></i></button>';
      }
    }

    function dtStoricoReload() {
      if (!_.isEmpty(vm.dtStorico.instance)) {
        vm.dtStorico.instance.reloadData();
      }
    }

    //gestione allegati
    function dtAllegati(idOpportunita) {
      vm.dtAllegati.instance = {};

      vm.dtAllegati.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          var promise = api.allegati.list({
            idOpportunita: idOpportunita
          });

          promise.then(function(allegati) {
            vm.allegati = allegati;
          });

          return promise;
        })
        .withOption('dom', "tr<'row'<'col-xs-5'i><'col-xs-7'p>>")
        .withOption('order', [0, 'desc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtAllegati.columns = [
        {
          data: 'dataOraIns',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {
          data: 'descrizione',
          title: 'Descrizione'
        },
        {
          data: 'tipo',
          title: 'Tipo',
          render: renderTipo
        },
        {
          data: 'note',
          title: 'Note Allegato',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActionsTitle() {
        var title = '';

        var ins = '<button type="button" class="btn btn-success btn-xs" bs-tooltip data-title="Inserisci allegato" ng-click="orc.createAllegato(orc.opportunita)"><i class="fa fa-plus"></i></button>';

        if ( vm.opportunita.idStato === 1 ) {
          title = ins;
        }

        return title;
      }

      function renderActions(data) {
        var actions = '';
        var prv = '<a href="' + apiBaseUrl + '/allegati/' + data + '?preview" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Anteprima"><i class="fa fa-eye"></i></a>';
        var dwn = '<a href="' + apiBaseUrl + '/allegati/' + data + '?download" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Scarica"><i class="fa fa-download"></i></a>';
        var upd = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="orc.updateAllegato(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Cancella" ng-click="orc.deleteAllegato(' + data + ')"><i class="fa fa-minus"></i></button>';

        var actionsAllegati = prv + ' ' + dwn + ' ' + upd + ' ' + del;
        if ( vm.opportunita.idStato === 1 ) {
          actions = actionsAllegati;
        }

        return actions;
      }

      function renderTipo( data, type, row ) {
        if ( row.idProgetto != '' ) {
          data += '&nbsp;<i bs-tooltip data-title="Allegato collegato al progetto" class="fa fa-graduation-cap"></i>';
        }
        return data;
      }

    }

    function dtAllegatiReload() {
      if (!_.isEmpty(vm.dtAllegati.instance)) {
        vm.dtAllegati.instance.reloadData();
      }
    }

    function setTitleAllegati(allegati) {
      if (allegati) {
        if (allegati.length > 0) {
          vm.titleAllegati = 'Allegati <span class="badge">' + allegati.length + '</span>';
        } else {
          vm.titleAllegati = 'Allegati';
        }
      }
    }

    function setAlerts( response ) {
      if ( response.data && response.data.warnings ) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaEditSegnalatoreController', OpportunitaEditSegnalatoreController);

  function OpportunitaEditSegnalatoreController($scope, $filter, AuthenticateJS, $modal, api) {
    var vm = this;

    var opportunitaEditSegnalatoreModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-edit-segnalatore-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita = {};
    vm.cliente = {};
    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createOpportunitaClienteSegnalatore', createOpportunitaCliente);
    $scope.$on('updateOpportunitaSegnalatore', updateOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function createOpportunitaCliente(event, cliente) {
      vm.action = 'create';
      vm.alerts = [];

      vm.cliente = cliente;

      api.opportunita().editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        //leggi e imposta i defaults
        vm.opportunita = {
          dataSegnalazione: moment().startOf('day'),
          idCliente: cliente.id,
          fornitore: vm.formData.defaults.fornitore,
          idFonte: vm.formData.defaults.idFonte,
          idPipeline: vm.formData.defaults.idPipeline,
          idStage: vm.formData.defaults.idStage,
          idStato: vm.formData.defaults.idStato,
          idAgenteS: vm.user.idAgente,
          valore: 1,
          percChiusura: 0
        };

        //imposta in base a formData la perc che deriva dal db
        setPercChiusura();

        opportunitaEditSegnalatoreModal.$promise
          .then(opportunitaEditSegnalatoreModal.show);
      }
    }

    function updateOpportunita(event, idOpportunita) {
      vm.action = 'update';
      vm.alerts = [];

      api.opportunita().editForm()
        .then(getOpportunita);

      function getOpportunita(formData) {
        vm.formData = formData;

        api.opportunita(idOpportunita).get()
          .then(showModal);

        function showModal(opportunita) {
          vm.opportunita = opportunita;

          opportunitaEditSegnalatoreModal.$promise
            .then(opportunitaEditSegnalatoreModal.show);
        }
      }
    }

    function setPercChiusura() {
      vm.opportunita.percChiusura = $filter('filter')(vm.formData.stages, {value: vm.opportunita.idStage}, true)[0].percChiusura;
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (vm.action === 'create') {
        api.opportunita().save(vm.opportunita)
          .then(opportunitaEditSegnalatoreModal.hide, setAlerts);
      } else if (vm.action === 'update') {
        api.opportunita(vm.opportunita.id).update(vm.opportunita)
          .then(opportunitaEditSegnalatoreModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }

    }

    function undoForm() {
      opportunitaEditSegnalatoreModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaEditController', OpportunitaEditController);

  function OpportunitaEditController($scope, $filter, AuthenticateJS, $modal, api) {
    var vm = this;

    var opportunitaEditModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.opportunita = {};
    vm.cliente = {};
    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.checkSoggettoFonte = checkSoggettoFonte;
    vm.setPercChiusura = setPercChiusura;
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createOpportunitaCliente', createOpportunitaCliente);
    $scope.$on('updateOpportunita', updateOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function createOpportunitaCliente(event, cliente) {
      vm.action = 'create';
      vm.alerts = [];

      vm.cliente = cliente;

      api.opportunita().editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        //leggi e imposta i defaults
        vm.opportunita = {
          dataSegnalazione: moment().startOf('day'),
          idCliente: cliente.id,
          fornitore: vm.formData.defaults.fornitore,
          idStato: vm.formData.defaults.idStato,
          idPipeline: vm.formData.defaults.idPipeline,
          idStage: vm.formData.defaults.idStage,
          idAgentePIC: vm.formData.defaults.idAgentePIC,
          valore: 1,
          percChiusura: 0,
          seguimi: true
        };

        //imposta in base a formData la perc che deriva dal db
        setPercChiusura();

        opportunitaEditModal.$promise
          .then(opportunitaEditModal.show);
      }
    }

    function updateOpportunita(event, idOpportunita) {
      vm.action = 'update';
      vm.alerts = [];

      api.opportunita().editForm()
        .then(getOpportunita);

      function getOpportunita(formData) {
        vm.formData = formData;

        api.opportunita(idOpportunita).get()
          .then(showModal);

        function showModal(opportunita) {
          vm.opportunita = opportunita;

          opportunitaEditModal.$promise
            .then(opportunitaEditModal.show);
        }
      }
    }

    function checkSoggettoFonte(idFonte) {
      if (angular.isDefined(idFonte) && idFonte !== '0') {
        var flagSoggetto = ($filter('filter')(vm.formData.fonti, {value: idFonte}, true))[0].soggetto;

        return flagSoggetto === '1';
      }

      return false;
    }

    function setPercChiusura() {
      vm.opportunita.percChiusura = $filter('filter')(vm.formData.stages, {value: vm.opportunita.idStage}, true)[0].percChiusura;
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (vm.action === 'create') {
        api.opportunita().save(vm.opportunita)
          .then(opportunitaEditModal.hide, setAlerts);
      } else if (vm.action === 'update') {
        api.opportunita(vm.opportunita.id).update(vm.opportunita)
          .then(opportunitaEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      opportunitaEditModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaAssociaController', OpportunitaAssociaController);

  function OpportunitaAssociaController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var associaModal = $modal({
      scope: $scope,
      templateUrl: 'opportunita-associa-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.dt = {};
    vm.appuntamento = {};
    vm.saveForm = saveForm;

    $scope.$on('associaOpportunita', associaOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function associaOpportunita(event, idAppuntamento, idCliente) {
      vm.appuntamento = {
        id: idAppuntamento
      };

      dtOpportunita(idCliente);

      associaModal.$promise
        .then(associaModal.show);
    }

    function dtOpportunita(idCliente) {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.opportunita().list({
            idAgentePIC: vm.user.flags.powerUser ? '' : vm.user.idAgente,
            idStato: '1',
            idCliente: idCliente
          })
        })
        .withDOM('tr')
        .withOption('order', [1, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dt.columns = [
        {
          data: 'id',
          render: renderCheckBox
        },
        {
          data: 'dataSegnalazione',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {data: 'fornitore', title: 'Fornitore'},
        {data: 'pista', title: 'Pista'},
        {
          data: 'valore',
          title: 'Valore',
          render: dtFactory.renders.currency
        },
        {data: 'segnalatore', title: 'Segnalatore'}
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderCheckBox(data, type) {
        if (type === 'display') {
          data = '<input type="radio" ng-model="oac.appuntamento.idOpportunita" ng-value="' + data + '">'
        }

        return data;
      }
    }

    function saveForm() {
      api.appuntamento(vm.appuntamento.id).setOpportunita(vm.appuntamento)
        .then(associaModal.hide);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OpportunitaController', OpportunitaController);

  function OpportunitaController($rootScope, $scope, $filter, AuthenticateJS, $aside, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var dashboardOpportunitaAside = $aside( {
      scope: $scope,
      templateUrl: 'dashboard-opportunita-aside.tpl.html',
      placement: 'left',
      animation: 'am-slide-left',
      container: 'body',
      backdrop: 'static',
      show: false
    } );

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.activeTab = (vm.user.flags.gestOppo ? 'dashboard' : 'ricerca');
    vm.checkEditPermission = api.opportunita().actions.checkEditPermission;

    //ricerca
    vm.alerts = {};
    vm.so = {
      idAgentePIC: (vm.user.flags.gestOppo && vm.user.userGroup <= 6) ? vm.user.idAgente : '0',
      idAgenteS: '0',
      fornitore: '',
      pista: '',
      idFonte: '0',
      idStage: '',
      idStato: '',
      fromValore: -1,
      toValore: -1,
      fromPerc: -0.01,
      toPerc: -0.01
    };
    vm.dt = {
      show: false
    };
    vm.search = search;
    vm.resetForm = resetForm;

    //dashboard
    vm.alertsK = {};
    vm.sok = {
      idAgentePIC: (vm.user.flags.gestOppo && vm.user.userGroup <= 6) ? vm.user.idAgente : '0',
      fornitore: 'CLYCO',
      pista: '',
      idStato: '1',
      fromPerc: -0.01
    };
    vm.sokNA = {
      idAgentePIC: 'NULL',
      fornitore: '',
      pista: '',
      idStato: '1',
      fromPerc: -0.01
    };
    vm.kanban = {};
    vm.kanbanSomma = 0;
    vm.kanbanTotale = 0;
    vm.kanbanFilter = '';
    vm.nonAssegnati = 0;
    vm.onDrop = onDrop;
    vm.showAside = showAside;
    vm.searchKanban = searchKanban;
    vm.resetKanban = resetKanban;
    vm.unsetFilter = unsetFilter;
    vm.toggleNonAssegnati = toggleNonAssegnati;
    vm.readProgetto = function ( idProgetto ) {
      if ( vm.user.flags.gestProg ) {
        return api.opportunita().progetti().actions.read( idProgetto );
      }
    }

    vm.readOpportunita = api.opportunita().actions.read;
    vm.updateOpportunita = api.opportunita().actions.update;
    vm.updateOpportunitaSegnalatore = function (idOpportunita) {
      $rootScope.$broadcast('updateOpportunitaSegnalatore', idOpportunita);
    };
    vm.deleteOpportunita = api.opportunita().actions.delete;

    vm.readCliente = api.clienti.actions.read;

    //carica i dati della form
    api.opportunita().searchForm().then( function ( formData ) {
      vm.formData = formData;
      //carica il kanban
      kanbanOpportunita();
    } );

    //carica la dt
    dtOpportunita();

    //reagisci ai cambiamenti sulle opportunita
    $scope.$on('Opportunita.created', OpportunitaReload);
    $scope.$on('Opportunita.updated', OpportunitaReload);
    $scope.$on('Opportunita.deleted', OpportunitaReload);

    ////////////////////////////////////////////////////////////////////////////
    //ricerca
    function resetForm() {
      vm.dt.show = false;

      vm.alerts = {};

      vm.so = {
        idAgentePIC: (vm.user.flags.gestOppo && vm.user.userGroup <= 6) ? vm.user.idAgente : '0',
        idAgenteS: '0',
        fornitore: '',
        pista: '',
        idFonte: '0',
        idStage: '',
        idStato: '',
        fromValore: -1,
        toValore: -1,
        fromPerc: -0.01,
        toPerc: -0.01
      };
    }

    function search() {
      vm.dt.show = true;

      vm.alerts = {};

      dtOpportunita();
    }

    function dtOpportunita() {
      if (angular.isUndefined(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(opportunitaList)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'Opportunita',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('order', [0, 'desc'])
        );

        vm.dt.columns = [
          {
            data: 'dataSegnalazione',
            title: 'Data',
            render: dtFactory.renders.date
          },
          {
            data: 'stato',
            title: 'Stato',
            render: renderOpportunita
          },
          {
            data: 'cliente',
            title: 'Cliente',
            render: renderCliente
          },
          {
            data: 'agentePIC',
            title: 'Agente'
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'valore',
            title: 'Valore',
            render: dtFactory.renders.currency
          },
          {
            data: 'percChiusura',
            title: 'Probabilità',
            render: dtFactory.renders.percent()
          },
          {
            data: 'dataChiusura',
            title: '<span title="Data Prevista Chiusura">Prev. Chiusura</span>',
            render: dtFactory.renders.date
          },
          {
            data: 'stage',
            title: 'Fase'
          },
          {
            data: 'fonte',
            title: 'Fonte'
          },
          {
            data: 'segnalatore',
            title: 'Segnalatore'
          },
          {
            data: 'note',
            title: 'Note',
            render: dtFactory.renders.longtext
          },
          {
            data: 'id',
            render: renderActions,
            orderable: false,
            searchable: false
          }
        ];
      } else {
        OpportunitaReload();
      }

      //////////////////////////////////////////////////////////////////////////
      function renderOpportunita(data, type, row) {
        if (type === 'display') {
          if (vm.user.flags.gestOppo) {
            data = '<a title="apri opportunita" ng-click="opportunita.readOpportunita(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="opportunita.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="opportunita.updateOpportunita(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var updS = '<button type="button" class="btn btn-warning btn-xs" ng-click="opportunita.updateOpportunitaSegnalatore(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="opportunita.deleteOpportunita(' + data + ')"><i class="fa fa-minus"></i></button>';

        switch (vm.checkEditPermission(vm.user, row)) {
          case 'segnalatore':
            actions = updS + '&nbsp;' + del;
            break;

          case 'agente':
          case 'admin':
            actions = upd + '&nbsp;' + del;
            break;
        }

        return actions;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.opportunita().url,
          numRecords: dt.data().length,
          filter: angular.copy(vm.so)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }
    }

    function opportunitaList() {
      var promise = api.opportunita().list(vm.so);

      promise.then(null, setAlerts);

      return promise;

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.dt.show = false;

        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    //kanban
    function kanbanOpportunita() {
      //azzera alerts
      vm.alertsK = {};

      //recupera non assegnati dal server
      api.opportunita().list(vm.sokNA)
        .then(function (opportunita) {
          vm.nonAssegnati = opportunita.length;
        });

      //crea il kanban
      vm.kanbanSomma = 0;
      vm.kanbanTotale = 0;

      angular.forEach(vm.formData.stages, function(stage) {
        vm.kanban[stage.value] = {
          label: stage.label,
          bgColor: stage.bgColor ? '#' + stage.bgColor : 'lightgray',
          sommaValore: 0,
          items: []
        }
      });

      api.opportunita().list(vm.sok)
        .then(loadKanban, setAlerts);

      //////////////////////////////////////////////////////////////////////////
      function loadKanban(opportunita) {
        vm.kanbanTotale = opportunita.length;

        opportunita = $filter('orderBy')(opportunita, 'dataSegnalazione');

        angular.forEach(opportunita, function(oppo) {
          //genera pulsante modifica
          oppo.update = setUpdateFn(oppo);

          vm.kanban[oppo.idStage].items.push(oppo);

          vm.kanban[oppo.idStage].sommaValore += oppo.valore;

          vm.kanbanSomma += oppo.valore;
        });

        vm.kanbanStages = Object.keys( vm.kanban ).length;

        ////////////////////////////////////////////////////////////////////////
        function setUpdateFn(oppo) {
          var fn = null;

          switch (vm.checkEditPermission(vm.user, oppo)) {
            case 'segnalatore':
              fn = vm.updateOpportunitaSegnalatore;
              break;

            case 'agente':
            case 'admin':
              fn = vm.updateOpportunita;
              break;
          }


          return fn;
        }
      }

      function setAlerts(response) {
        vm.alertsK = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function searchKanban() {
      kanbanOpportunita();

      dashboardOpportunitaAside.hide();
    }

    function resetKanban() {
      vm.sok = {
        idAgentePIC: (vm.user.flags.gestOppo && vm.user.userGroup <= 6) ? vm.user.idAgente : '0',
        fornitore: 'CLYCO',
        pista: '',
        idStato: '1',
        fromPerc: -0.01
      };

      searchKanban();
    }

    function unsetFilter(filter) {
      if (filter === 'idAgentePIC') {
        vm.sok[filter] = '0'
      } else {
        delete vm.sok[filter];
      }

      kanbanOpportunita();
    }

    function toggleNonAssegnati() {
      if (angular.equals(vm.sok, vm.sokNA)) {
        resetKanban()
      } else {
        angular.copy(vm.sokNA, vm.sok);

        searchKanban();
      }
    }

    function showAside() {
      dashboardOpportunitaAside.$promise.then(function() {
        dashboardOpportunitaAside.show();
      });
    }

    function onDrop(srcList, srcIndex, srcStage, targetList, targetIndex, targetStage) {
      var item = srcList[srcIndex];

      // Copy the item from source to target.
      targetList.splice(targetIndex, 0, srcList[srcIndex]);

      // Remove the item from the source, possibly correcting the index first.
      // We must do this immediately, otherwise ng-repeat complains about duplicates.
      if (srcList === targetList && targetIndex <= srcIndex) srcIndex++;
      srcList.splice(srcIndex, 1);

      if (targetStage !== srcStage) {
        //send to server update of stage
        item.idStage = targetStage;
        api.opportunita(item.id).update(item);
      }

      // By returning true from dnd-drop we signalize we already inserted the item.
      return true;
    }

    //globali
    function OpportunitaReload() {
      if (angular.isDefined(vm.dt.instance)) {
        if (angular.isDefined(vm.dt.instance.changeData)) {
          vm.dt.instance.changeData(opportunitaList);
        }
      }

      kanbanOpportunita();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ConfermaAvanzamentoFaseController', ConfermaAvanzamentoFaseController);

  function ConfermaAvanzamentoFaseController($rootScope, $scope, AuthenticateJS, $modal, api) {
    var vm = this;
    vm.progetto = {};
    var confermaAvanzamentoFaseModal = $modal( {
      scope: $scope,
      templateUrl: 'conferma-avanzamento-fase.tpl.html',
      backdrop: false,
      show: false
    } );
    $scope.$on( 'confermaAvanzamentoFase', function ( event, progetto ) {
      vm.progetto = progetto;
      if ( progetto.finalStage ) {
        confermaAvanzamentoFaseModal.$promise.then( confermaAvanzamentoFaseModal.show );
      }
    } );
    vm.avanzamentoFaseOpportunita = function ( progetto ) {
      var opportunita = progetto.opportunita;
      opportunita.idStage = progetto.idFinalStageOpportunita;
      api.opportunita( progetto.idOpportunita ).update( opportunita )
        .then( function ( opportunita ) {
          $rootScope.$broadcast( 'afterAvanzamentoFaseOpportunita', opportunita );
          confermaAvanzamentoFaseModal.hide();
        } );
    }

  }

})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListeOperatoreController', ListeOperatoreController);

  function ListeOperatoreController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var listeOperatoreModal = $modal({
      scope: $scope,
      templateUrl: 'liste-operatore-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.filtro = {};
    vm.dtListe = {};
    vm.dtStatiTelefonate = {
      show: false
    };

    vm.showDtStatiTelefonate = showDtStatiTelefonate;

    vm.readCliente = api.clienti.actions.read;
    vm.readClientiLista = api.liste.actions.readClienti;
    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };
    vm.readTelefonate = function(filtroTelefonate) {
      $rootScope.$broadcast('readTelefonate', filtroTelefonate);
    };

    $scope.$on('readListeOperatore', readListeOperatore);

    ////////////////////////////////////////////////////////////////////////////
    function readListeOperatore(event, filtro) {
      vm.filtro = angular.copy(filtro);

      vm.dtStatiTelefonate.show = false;

      if (angular.isUndefined(filtro.fromDate) && angular.isUndefined(filtro.toDate)) {
        dtListeFull()
      } else {
        dtListe();
      }

      listeOperatoreModal.$promise
        .then(listeOperatoreModal.show);
    }

    function dtListe() {
      vm.dtListe.dtInstance = {};

      vm.dtListe.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.operatori.telefonate.list(vm.filtro);
        })
        .withOption('order', [2, 'desc'])
      );

      vm.dtListe.dtColumns = [
        {
          data: 'motivo',
          title: 'Lista',
          'class': '',
          render: renderMotivo
        },
        {
          data: 'telefonate',
          title: 'Telefonate',
          render: renderTelefonate,
          'class': 'min-width text-right'
        },
        {
          data: 'chiamati',
          title: 'Clienti',
          render: renderClienti,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamenti',
          title: 'Appuntamentati',
          render: renderAppuntamentati,
          'class': 'min-width text-right'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderMotivo(data, type, row) {
        if (type === 'display') {
          // data = '<a title="apri zone della lista" ng-click="loc.showDtZone(\'' + row.idMotivo + '\', \'' + row.motivo + '\')">' + data + '</a>';
          data = '<a title="apri stati lista" ng-click="loc.showDtStatiTelefonate(\'' + row.idMotivo + '\', \'' + row.motivo.replace(/'/g, '\\\'') + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderTelefonate(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri telefonate" ng-click=\'loc.readTelefonate(${ filtro })\'>${ data }</a>');

            data = template({
              filtro: angular.toJson({
                idMotivo: row.idMotivo,
                motivo: _.escape(row.motivo),
                idOperatore: vm.filtro.idOperatore,
                operatore: vm.filtro.operatore,
                fromDate: vm.filtro.fromDate,
                toDate: vm.filtro.toDate
              }),
              data: data
            });
          }
        }

        return data;
      }

      function renderClienti(data, type, row) {
        if (type === 'display') {
          var filtro = angular.copy(vm.filtro);
          filtro.motivo = _.escape(row.motivo);

          data = _linkClienti('apri clienti in campagna', row.idMotivo, filtro, data);
        }

        return data;
      }

      function renderAppuntamentati(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.motivo),
            idOperatore: vm.filtro.idOperatore,
            operatore: vm.filtro.operatore,
            appuntamentati: '',
            stato: 'Appuntamentati',
            fromDate: vm.filtro.fromDate,
            toDate: vm.filtro.toDate
          };

          data = _linkClienti('apri clienti appuntamentati', row.idMotivo, filtro, data);
        }

        return data;
      }
    }

    function dtListeFull() {
      vm.dtListe.dtInstance = {};

      vm.dtListe.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.liste.list(vm.filtro);
        })
        .withOption('order', [0, 'desc'])
      );

      vm.dtListe.dtColumns = [
        {
          data: 'dataInserimento',
          title: 'data',
          render: dtFactory.renders.date
        },
        {
          data: 'descrizione',
          title: 'Motivo'
        },
        {
          data: 'tipoMotivo',
          title: 'Tipo'
        },
        {
          data: 'clienti',
          title: 'Clienti',
          render: renderClienti,
          'class': 'min-width text-right'
        },
        {
          data: 'chiamati',
          title: 'Chiamati',
          render: renderChiamati,
          'class': 'min-width text-right'
        },
        {
          data: 'aperti',
          title: '<span title="Non Lavorati">N/L</span>',
          render: renderAperti,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamentati',
          title: '<span title="Appuntamentati">App.ti</span>',
          render: renderAppuntamentati,
          'class': 'min-width text-right'
        },
        {
          data: 'resa',
          title: 'Resa',
          render: renderResa,
          'class': 'min-width text-right'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderClienti(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.descrizione),
            idOperatore: vm.filtro.idOperatore,
            operatore: vm.filtro.operatore
          };

          data = _linkClienti('apri clienti in campagna', row.id, filtro, data);
        }

        return data;
      }

      function renderChiamati(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.descrizione),
            idOperatore: vm.filtro.idOperatore,
            operatore: vm.filtro.operatore,
            chiamati: '',
            stato: 'Chiamati'
          };

          data = _linkClienti('apri clienti chiamati', row.id, filtro, data);
        }

        return data;
      }

      function renderAperti(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.descrizione),
            idOperatore: vm.filtro.idOperatore,
            operatore: vm.filtro.operatore,
            aperti: '',
            stato: 'Non Lavorati'
          };

          data = _linkClienti('apri clienti non lavorati', row.id, filtro, data);
        }

        return data;
      }

      function renderAppuntamentati(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.descrizione),
            idOperatore: vm.filtro.idOperatore,
            operatore: vm.filtro.operatore,
            appuntamentati: '',
            stato: 'Appuntamentati'
          };

          data = _linkClienti('apri clienti appuntamentati', row.id, filtro, data);
        }

        return data;
      }

      function renderResa(data, type) {
        if (type === 'display') {
          data = data + '%';
        }

        return data;
      }
    }

    function dtStatiTelefonate() {
      vm.dtStatiTelefonate.show = true;

      vm.dtStatiTelefonate.dtInstance = {};

      vm.dtStatiTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(vm.filtro.idMotivo).list(vm.filtro);
        })
        .withOption('order', [0, 'asc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtStatiTelefonate.dtColumns = [
        {data: 'idStato', title: 'ID Stato Telefonata'},
        {data: 'stato', title: 'Stato Telefonata'},
        {
          data: 'conteggio',
          title: 'Telefonate',
          'class': 'min-width text-right',
          render: renderConteggio
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderConteggio(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri telefonate" ng-click=\'loc.readTelefonate(${ filtro })\'>${ data }</a>');

            var filtro = angular.extend({}, vm.filtro, {
              idStatoTelefonata: row.idStato,
              statoTelefonata: row.stato
            });
            delete filtro.id;
            delete filtro.gb;

            data = template({
              filtro: angular.toJson(filtro),
              data: data
            });
          }
        }

        return data;
      }
    }

    function showDtStatiTelefonate(idMotivo, motivo) {
      vm.filtro.id = idMotivo;
      vm.filtro.idMotivo = idMotivo;
      vm.filtro.motivo = motivo;
      vm.filtro.gb = 'statoTelefonata';

      if (vm.dtStatiTelefonate.show === false) {
        dtStatiTelefonate();
      } else {
        vm.dtStatiTelefonate.dtInstance.reloadData();
      }
    }

    //funzioni in comune fra datatables
    function _linkClienti(title, idMotivo, filtro, data) {
      if (isNaN(data) || (data * 1) > 0) {
        var template = _.template('<a title="${ title }" ng-click=\'loc.readClientiLista("${ idMotivo }", ${ filtro })\'>${ data }</a>');

        data = template({
          title: title,
          idMotivo: idMotivo,
          filtro: angular.toJson(filtro),
          data: data
        });
      }

      return data;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('MainController', MainController);

  function MainController($location, AuthenticateJS) {
    if (AuthenticateJS.authorize('ADMIN')) {
      $location.path('/admin');
    } else if (AuthenticateJS.authorize('COORD')) {
      $location.path('/coord');
    } else if (AuthenticateJS.authorize('BO')) {
      $location.path('/bo');
    } else if (AuthenticateJS.authorize('AGENTI')) {
      $location.path('/agenti');
    } else if (AuthenticateJS.authorize('CC')) {
      $location.path('/cc');
    } else {
      $location.path('/404');
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListeController', ListeController);

  function ListeController($scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.sl = {
      tipoMotivo: '0',
      obsoleto: '-1',
      cieca: '-1',
      isExt: '-1'
    };
    vm.dtListe = {
      show: false
    };
    vm.search = search;
    vm.resetForm = resetForm;

    vm.readClientiLista = api.liste.actions.readClienti;
    vm.importLista = api.liste.actions.import;
    vm.createLista = api.liste.actions.create;
    vm.updateLista = api.liste.actions.update;
    vm.deleteLista = api.liste.actions.delete;
    vm.manageLista = api.liste.actions.manage;
    vm.assignLista = api.liste.actions.assign;
    vm.removeLista = api.liste.actions.remove;
    vm.moveLista = api.liste.actions.move;

    //carica i dati della form
    api.liste.searchForm()
      .then(function(formData) {
        vm.formData = formData;
      })
    ;

    //carica la DT
    dtListe();

    //reagisci ai cambiamenti sulle liste
    $scope.$on('Lista.created', dtListeReload);
    $scope.$on('Lista.updated', dtListeReload);
    $scope.$on('Lista.deleted', dtListeReload);

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      vm.dtListe.show = false;
      vm.dtListe.dtInstance.changeData(listeList);
      vm.dtListe.show = true;

      function listeList() {
        return api.liste.list(vm.sl);
      }
    }

    function resetForm() {
      vm.dtListe.show = false;
      vm.sl = {
        tipoMotivo: '0',
        obsoleto: '-1',
        cieca: '-1'
      };
    }

    function dtListe() {
      vm.dtListe.dtInstance = {};

      vm.dtListe.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.empty)
        .withOption('order', [0, 'desc'])
      );

      vm.dtListe.dtColumns = [
        {
          data: 'dataInserimento',
          title: 'Caricamento',
          render: dtFactory.renders.date
        },
        {
          data: 'dataApertura',
          title: 'Inizio',
          render: dtFactory.renders.date
        },
        {
          data: 'dataChiusura',
          title: 'Fine',
          render: dtFactory.renders.date
        },
        {
          data: 'id',
          title: 'ID'
        },
        {
          data: 'descrizione',
          title: 'Motivo',
          render: renderDescrizione,
          'class': ''
        },
        {
          data: 'tipoMotivo',
          title: 'Tipo'
        },
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'cieca',
          title: 'Cieca',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'clienti',
          title: 'Clienti',
          render: renderClienti,
          'class': 'min-width text-right'
        },
        {
          data: 'chiamati',
          title: 'Chiamati',
          render: renderChiamati,
          'class': 'min-width text-right'
        },
        {
          data: 'aperti',
          title: '<span title="Non Lavorati">N/L</span>',
          render: renderAperti,
          'class': 'min-width text-right'
        },
        {
          data: 'daAssegnare',
          title: '<span title="Non Assegnati">N/A</span>',
          render: renderDaAssegnare,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamentati',
          title: '<span title="Appuntamentati">App.ti</span>',
          render: renderAppuntamentati,
          'class': 'min-width text-right'
        },
        {
          data: 'resa',
          title: 'Resa',
          render: renderResa,
          'class': 'min-width text-right'
        },
        {
          data: 'id',
          title: '',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderDescrizione(data, type, row) {
        if (type === 'display') {
          data = '<a title="gestisci campagna" ng-click="liste.manageLista(' + row.id + ')">' + data + '</a>';

          if (row.resa <= 3.00) {
            data += '<i class="fa fa-meh-o text-danger larger" style="margin-left:10px;"></i>';
          } else if(row.resa >= 8.00) {
            data += '<i class="fa fa-line-chart text-success larger" style="margin-left:10px;"></i>';
          }

          if (row.cieca) {
            data += '<i class="fa fa-eye-slash larger" style="margin-left:10px;" title="Cieca"></i>';
          }

        }

        return data;
      }

      function renderClienti(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri clienti in campagna" ng-click="liste.readClientiLista(\'' + row.id + '\', {})">' + data + '</a>';
        }

        return data;
      }

      function renderChiamati(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            data = '<a title="apri clienti chiamati" ng-click="liste.readClientiLista(\'' + row.id + '\', {chiamati: \'\'})">' + data + '</a>';
          }
        }

        return data;
      }

      function renderAperti(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            data = '<a title="apri clienti non lavorati" ng-click="liste.readClientiLista(\'' + row.id + '\', {aperti: \'\'})">' + data + '</a>';
          }
        }

        return data;
      }

      function renderDaAssegnare(data, type, row) {
        if (type === 'display') {
          if (!row.obsoleto
            && (data * 1) > 0
            && vm.user.userGroup >= 5
          ) {
            data = '<a title="assegna clienti" ng-click="liste.assignLista(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderAppuntamentati(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            data = '<a title="apri clienti appuntamentati" ng-click="liste.readClientiLista(\'' + row.id + '\', {appuntamentati: \'\'})">' + data + '</a>';
          }
        }

        return data;
      }

      function renderResa(data, type) {
        if (type === 'display') {
          data = data + '%';
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="liste.updateLista(\'' + data + '\')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="liste.deleteLista(\'' + data + '\')"><i class="fa fa-minus"></i></button>';

        var gest = '' +
          '<button type="button" class="btn btn-primary btn-xs" title="Gestisci" bs-dropdown data-placement="left"><i class="fa fa-cog"></i></button>&nbsp;' + '\n' +
          '<ul class="dropdown-menu" role="menu">' + '\n' +
          '  <li><a ng-click="liste.removeLista(\'' + data + '\')"><i class="fa fa-fw fa-user-times"></i>&nbsp;Rimuovi Clienti</a></li>' + '\n' +
          '  <li><a ng-click="liste.moveLista(\'' + data + '\')"><i class="fa fa-fw fa-exchange"></i>&nbsp;Sposta Clienti</a></li>' + '\n' +
          '</ul>'
        ;

        if (vm.user.userGroup >= 5) {
          actions = upd + '&nbsp;' + gest + del;
        }

        return actions;
      }
    }

    function dtListeReload() {
      vm.dtListe.dtInstance.reloadData(null, true);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaUpdateController', ListaUpdateController);

  function ListaUpdateController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var listaUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'lista-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('updateLista', updateLista);

    ////////////////////////////////////////////////////////////////////////////
    function updateLista(event, idLista) {
      api.liste.editForm({woCitta: true})
        .then(getLista);

      function getLista(formData) {
        vm.formData = formData;

        api.lista(idLista).get()
          .then(showModal);

        function showModal(lista) {
          vm.lista = lista;

          listaUpdateModal.$promise
            .then(listaUpdateModal.show);
        }
      }
    }

    function saveForm() {
      api.lista(vm.lista.id).update(vm.lista)
        .then(listaUpdateModal.hide);
    }

    function undoForm() {
      listaUpdateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaRemoveController', ListaRemoveController);

  function ListaRemoveController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var listaRemoveModal = $modal({
      scope: $scope,
      templateUrl: 'lista-remove-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.formData = {};
    vm.sl = {};
    vm.dtClientiAssegnati = {
      show: false
    };
    vm.disableRemove = false;
    vm.search = search;
    vm.resetForm = resetForm;
    vm.remove = remove;

    $scope.$on('removeLista', removeLista);
    $scope.$on('Lista.updated', reloadDt);

    vm.deleteRemoveLista = function deleteRemoveLista(idLista, filtro) {
      $rootScope.$broadcast('deleteRemoveLista', idLista, filtro);
    };

    ////////////////////////////////////////////////////////////////////////////
    function removeLista(event, idLista) {
      api.elenchi.searchForm({
        idMotivo: idLista
      }).then(getLista);

      function getLista(formData) {
        vm.formData = formData;
        vm.sl = {
          assegnati: '-1',
          idStatoElenco: '1',
          idZona: '0',
          citta: '0'
        };

        dtClientiAssegnati(idLista);

        api.lista(idLista).get()
          .then(showModal);

        function showModal(lista) {
          vm.lista = lista;

          listaRemoveModal.$promise
            .then(listaRemoveModal.show);
        }
      }
    }

    function dtClientiAssegnati(idLista) {
      api.lista(idLista).remove_list(vm.sl)
        .then(showDt);

      function showDt(clientiAssegnati) {
        //creazione colonne
        vm.dtClientiAssegnati.dtColumns = [
          {
            data: 'operatore',
            title: 'Operatore',
            'class': ''
          }
        ];

        if (clientiAssegnati.length <= 0) {
          vm.dtClientiAssegnati.dtColumns.push({
            data: null,
            title: 'Stati',
            'class': 'min-width text-center'
          });
        } else {
          angular.forEach(clientiAssegnati[0], function(value, key) {
            if (['idOperatore', 'operatore'].indexOf(key) === -1) {
              vm.dtClientiAssegnati.dtColumns.push({
                data: key.replace('.', '\\.'),
                title: key,
                'class': 'min-width text-center'
              });
            }
          });
        }

        //configura tabella
        vm.dtClientiAssegnati.dtInstance = {};

        vm.dtClientiAssegnati.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function () {
            return clientiAssegnati.$promise;
          })
          .withOption('order', [0, 'asc'])
        );

        //visualizza tabella
        vm.dtClientiAssegnati.show = true;
      }
    }

    function search() {
      vm.dtClientiAssegnati.show = false;

      dtClientiAssegnati(vm.lista.id);

      vm.disableRemove = false;
    }

    function resetForm() {
      vm.sl = {
        assegnati: '-1',
        idStatoElenco: '1',
        idZona: '0',
        citta: '0'
      };

      search();
    }

    function remove() {
      vm.deleteRemoveLista(vm.lista.id, vm.sl);
    }

    function reloadDt() {
      if (angular.isDefined(vm.lista.id)) {
        search();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaMoveController', ListaMoveController);

  function ListaMoveController($scope, AuthenticateJS, $modal, $alert, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var listaMoveModal = $modal({
      scope: $scope,
      templateUrl: 'lista-move-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.formData = {};
    vm.sl = {};
    vm.dtClientiAssegnati = {
      show: false
    };
    vm.disableMove = true;
    vm.search = search;
    vm.resetForm = resetForm;
    vm.move = move;

    vm.readClientiLista = api.liste.actions.readClienti;

    $scope.$on('moveLista', moveLista);

    ////////////////////////////////////////////////////////////////////////////
    function moveLista(event, idLista) {
      api.elenchi.searchForm({
        idMotivo: idLista,
        soloAssegnati: ''
      }).then(getLista);

      function getLista(formData) {
        vm.formData = formData;

        vm.sl = {
          idOperatoreIn: '0',
          idStatoElenco: '1',
          idZona: '0',
          citta: '0'
        };

        dtClientiAssegnati(idLista);

        api.lista(idLista).get()
          .then(showModal);

        function showModal(lista) {
          vm.lista = lista;

          listaMoveModal.$promise
            .then(listaMoveModal.show);
        }
      }
    }

    function dtClientiAssegnati(idLista) {
      api.lista(idLista).move_list(vm.sl)
        .then(showDt);

      function showDt(clientiAssegnati) {
        //creazione colonne
        vm.dtClientiAssegnati.dtColumns = [
          {
            data: 'operatore',
            title: 'Operatore',
            'class': ''
          }
        ];

        if (clientiAssegnati.length <= 0) {
          vm.dtClientiAssegnati.dtColumns.push({
            data: null,
            title: 'Stati',
            'class': 'min-width text-center'
          });
        } else {
          angular.forEach(clientiAssegnati[0], function(value, key) {
            if (['idOperatore', 'operatore'].indexOf(key) === -1) {
              var columnDef = {};

              columnDef.data = key.replace('.', '\\.');

              //elabora nome campo per togliere eventuali ids
              if (key.indexOf('~') !== -1) {
                key = key.split('~');

                columnDef.title = key[0];
              } else {
                columnDef.title = key;
              }

              columnDef.render = renderLink;

              columnDef['class'] = 'min-width text-center'

              vm.dtClientiAssegnati.dtColumns.push(columnDef);
            }
          });
        }

        //configura tabella
        vm.dtClientiAssegnati.dtInstance = {};

        vm.dtClientiAssegnati.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function () {
            return clientiAssegnati.$promise;
          })
          .withOption('order', [0, 'asc'])
        );

        //visualizza tabella
        vm.dtClientiAssegnati.show = true;

        ////////////////////////////////////////////////////////////////////////
        function renderLink(data, type, row, meta) {
          data = data * 1; //porta a valore numerico

          if (type === 'display' && data > 0) {
            //elabora nome campo per separare descrizione da id
            var api = new $.fn.dataTable.Api(meta.settings);

            var descColonna, idColonna;
            var colonna = api.column(meta.col).dataSrc();
            if (colonna.indexOf('~') !== -1) {
              colonna = colonna.split('~');

              descColonna = colonna[0];
              idColonna = colonna[1];
            } else {
              descColonna = colonna;
              idColonna = colonna;
            }

            if (descColonna !== 'tot\\.') {
              //scrivi il link
              var template = _.template('<a title="${ title }" ng-click=\'lmc.readClientiLista("${ idMotivo }", ${ filtro })\'>${ data }</a>');

              data = template({
                title: 'apri zone clienti per stato ' + descColonna,
                idMotivo: idLista,
                filtro: angular.toJson({
                  motivo: vm.lista.descrizione,
                  idOperatore: row.idOperatore,
                  operatore: row.operatore,
                  idStatoElenco: idColonna,
                  stato: descColonna,
                  gb: 'zona'
                }),
                data: data
              });
            }
          }

          return data;
        }
      }
    }

    function search() {
      vm.dtClientiAssegnati.show = false;

      dtClientiAssegnati(vm.lista.id);

      vm.disableMove = false;
    }

    function resetForm() {
      vm.sl = {
        idOperatoreIn: '0',
        idStatoElenco: '1',
        idZona: '0',
        citta: '0'
      };

      search();
    }

    function move() {
      api.lista(vm.lista.id).move_update(vm.sl)
        .then(postMove);

      function postMove(response) {
        var successAlert = {
          title: response.rowCount + ' clienti spostati correttamente',
          type: 'success',
          container: '#lmc-alerts'
        };

        $alert(successAlert);

        reloadDt();
      }
    }

    function reloadDt() {
      if (angular.isDefined(vm.lista.id)) {
        //ricarico la form così si aggiorna lista operatoriIN
        api.elenchi.searchForm({
          idMotivo: vm.lista.id,
          soloAssegnati: ''
        }).then(getLista);
      }

      //////////////////////////////////////////////////////////////////////////
      function getLista(formData) {
        vm.formData = formData;

        //resetto la form così quando si ricarica la tabella vedo tutto
        vm.sl = {
          idOperatoreIn: '0',
          idStatoElenco: '1',
          idZona: '0',
          citta: '0'
        };

        search();

        //disabilito il pulsante sposta in modo da obbligare a rifare la ricerca
        vm.disableMove = false;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaManageController', ListaManageController);

  function ListaManageController($scope, $q, $filter, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var listaManageModal = $modal({
      scope: $scope,
      templateUrl: 'lista-manage-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.dtClientiAssegnati = {};
    vm.dtStatiLista = {};
    vm.dtStatiTelefonate = {};
    vm.dtTelefonate = {};
    vm.dtEsitoAppuntamenti= {};
    vm.dtEsitoContratti= {};
    vm.dtEsitoZone= {
      show: false
    };
    vm.showStatiTelefonate = showStatiTelefonate;
    vm.showTelefonate = showTelefonate;

    vm.readClientiLista = api.liste.actions.readClienti;
    vm.assignLista = api.liste.actions.assign;

    $scope.$on('manageLista', manageLista);
    $scope.$on('Lista.updated', clientiAssegnatiReload);

    ////////////////////////////////////////////////////////////////////////////
    function manageLista(event, idLista) {
      api.lista(idLista).get()
        .then(showModal);

      vm.dtStatiLista = {};
      vm.dtStatiTelefonate = {};
      vm.dtTelefonate = {};

      vm.dtEsitoAppuntamenti= {};
      vm.dtEsitoContratti= {};

      dtStatiLista(idLista);
      dtEsitoAppuntamenti(idLista);
      dtEsitoContratti(idLista);
      dtEsitoZone(idLista);
      if (vm.user.userGroup >= 5) {
        dtClientiAssegnati(idLista);
      }

      //////////////////////////////////////////////////////////////////////////
      function showModal(lista) {
        vm.lista = lista;

        listaManageModal.$promise
          .then(listaManageModal.show);
      }
    }

    //ANDAMENTO
    function dtStatiLista(idLista) {
      vm.dtStatiLista.dtInstance = {};

      vm.dtStatiLista.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(idLista).list({
            gb: 'statoElenco'
          });
        })
        .withOption('order', [0, 'asc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtStatiLista.dtColumns = [
        {data: 'idStato', title: 'ID'},
        {
          data: 'stato',
          title: 'Stato Elenco',
          'class': ''
        },
        {
          data: 'conteggio',
          title: 'Clienti',
          'class': 'min-width text-right',
          render: renderConteggio
        },
        {
          data: 'percentuale',
          title: '%',
          'class': 'min-width text-right',
          render: dtFactory.renders.float
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderConteggio(data, type, row) {
        if (type === 'display') {
          data = '<a href="" ng-click="lmc.showStatiTelefonate(\'' + row.idStato + '\')">' + data + '</a>';
        }

        return data;
      }
    }

    function showStatiTelefonate(idStatoElenco) {
      if (_.isEmpty(vm.dtStatiTelefonate.dtInstance)) {
        dtStatiTelefonate(vm.lista.id, idStatoElenco);
      } else {
        vm.dtStatiTelefonate.dtInstance.changeData(function () {
          return api.lista(vm.lista.id).list({
            idStatoElenco: idStatoElenco,
            gb: 'statoTelefonata'
          });
        });
      }
    }

    function dtStatiTelefonate(idLista, idStatoElenco) {
      vm.dtStatiTelefonate.dtInstance = {};

      vm.dtStatiTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(idLista).list({
            idStatoElenco: idStatoElenco,
            gb: 'statoTelefonata'
          });
        })
        .withOption('order', [0, 'asc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtStatiTelefonate.dtColumns = [
        {data: 'idStato', title: 'ID Stato Telefonata'},
        {data: 'stato', title: 'Stato Telefonata'},
        {
          data: 'conteggio',
          title: 'Telefonate',
          'class': 'min-width text-right',
          render: renderConteggio
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderConteggio(data, type, row) {
        if (type === 'display') {
          data = '<a href="" ng-click="lmc.showTelefonate(\'' + row.idStatoE + '\', \'' + row.idStato + '\')">' + data + '</a>';
        }

        return data;
      }
    }

    function showTelefonate(idStatoElenco, idStatoTelefonata) {
      if (_.isEmpty(vm.dtTelefonate.dtInstance)) {
        dtTelefonate(vm.lista.id, idStatoElenco, idStatoTelefonata);
      } else {
        vm.dtTelefonate.dtInstance.changeData(function () {
          return api.telefonate.list({
            idMotivo: vm.lista.id,
            idStatoElenco: idStatoElenco,
            idStatoTelefonata: idStatoTelefonata
          });
        });
      }
    }

    function dtTelefonate(idLista, idStatoElenco, idStatoTelefonata) {
      vm.dtTelefonate.dtInstance = {};

      vm.dtTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.telefonate.list({
            idMotivo: idLista,
            idStatoElenco: idStatoElenco,
            idStatoTelefonata: idStatoTelefonata
          });
        })
        .withOption('dom', "tr<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withOption('order', [0, 'asc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtTelefonate.dtColumns = [
        {
          data: 'dataOra',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {data: 'operatore', title: 'Operatore'},
        {data: 'cliente', title: 'Cliente'},
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        }
      ];
    }

    //ESITI
    function dtEsitoAppuntamenti(idLista) {
      vm.dtEsitoAppuntamenti.dtInstance = {};

      vm.dtEsitoAppuntamenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.list('/liste/' + idLista + '/reports/eapp', 'EappLista').list)
        .withOption('order', [0, 'asc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
        .withOption('footerCallback', renderTotals)
      );

      vm.dtEsitoAppuntamenti.dtColumns = [
        {
          data: 'esito',
          title: 'Esito'
        },
        {
          data: 'conteggio',
          title: 'Clienti',
          'class': 'min-width text-right',
          render: dtFactory.renders.integer
        },
        {
          data: 'percentuale',
          title: '%',
          'class': 'min-width text-right',
          render: dtFactory.renders.float
        }
      ];
    }

    function dtEsitoContratti(idLista) {
      vm.dtEsitoContratti.dtInstance = {};

      vm.dtEsitoContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.list('/liste/' + idLista + '/reports/ecnt', 'EcntLista').list)
        .withOption('order', [0, 'asc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
        .withOption('footerCallback', renderTotals)
      );

      vm.dtEsitoContratti.dtColumns = [
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'pezzi',
          title: 'Pezzi',
          'class': 'min-width text-right',
          render: dtFactory.renders.integer
        },
        {
          data: 'valore',
          title: 'Valore',
          'class': 'min-width text-right',
          render: dtFactory.renders.integer
        }
      ];
    }

    function dtEsitoZone(idLista) {
      vm.dtEsitoZone.show = false;

      api.list('/liste/' + idLista + '/reports/ezon', 'EzonLista').list()
        .then(showTable);

      function showTable(response) {
        vm.dtEsitoZone.dtInstance = {};

        vm.dtEsitoZone.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return $q.when(response);
          })
          .withOption('order', [0, 'asc'])
          .withOption('dom', 'tr')
          .withOption('info', false)
          .withOption('lengthChange', false)
          .withOption('searching', false)
          .withOption('paging', false)
          .withOption('footerCallback', renderTotals)
        );

        if (response.length > 0) {
          vm.dtEsitoZone.dtColumns = [];

          angular.forEach(response[0], function(value, key) {
            var columnDef = {};

            columnDef.data = key.replace('.', '\\.');
            columnDef.title = key;

            if (angular.isNumber(value)) {
              columnDef.render = dtFactory.renders.integer;
              columnDef['class'] = 'text-right';
            }

            vm.dtEsitoZone.dtColumns.push(columnDef);
          });
        } else {
          vm.dtEsitoZone.dtColumns = [
            {data: null, title: 'Nessun Risultato'}
          ];
        }

        vm.dtEsitoZone.show = true;
      }
    }

    function renderTotals(tfoot, data) {
      /* eslint-disable angular/controller-as-vm */
      var _this = this;

      if (data.length > 1) {
        $scope.$apply(function() {
          var $footer = angular.element(tfoot);
          $footer.empty();

          _this.api().columns().every(makeSums);

          function makeSums(ci) {
            if (_this.api().column(ci).visible()) { //inserisci i th solo per le colonne visibili
              var sum = '';

              if (ci > 0) { //esegui le somme
                sum = this
                  .data()
                  .reduce(function(a,b) {
                    return a + b;
                  });
                sum = $filter('number')(sum, 0);
              }

              $footer.append('<th style="text-align: right;">' + sum + '</th>');
            }
          }
        });
      }
      /* eslint-enable angular/controller-as-vm */
    }

    //GESTIONE
    function dtClientiAssegnati(idLista) {
      vm.dtClientiAssegnati.dtInstance = {};

      vm.dtClientiAssegnati.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(idLista).clienti.list({
            assegnati: '',
            gb: 'operatore'
          });
        })
        .withOption('order', [0, 'asc'])
      );

      vm.dtClientiAssegnati.dtColumns = [
        {
          data: 'operatore',
          title: 'Operatore',
          'class': ''
        },
        {
          data: 'aperti',
          title: 'Aperti',
          render: renderAperti,
          'class': 'min-width text-right'
        },
        {
          data: 'lavorati',
          title: 'Lavorati',
          render: renderLavorati,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamentati',
          title: 'Appuntamentati',
          render: renderAppuntamentati,
          'class': 'min-width text-right'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function _linkClienti(title, idMotivo, filtro, data) {
        if ((data * 1) > 0) {
          var template = _.template('<a title="${ title }" ng-click=\'sviluppoVendite.readClientiLista("${ idMotivo }", ${ filtro })\'>${ data }</a>');

          data = template({
            title: title,
            idMotivo: idMotivo,
            filtro: angular.toJson(filtro),
            data: data
          });
        }

        return data;
      }

      function renderAperti(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: vm.lista.descrizione,
            idOperatore: row.idOperatore,
            operatore: row.operatore,
            aperti: '',
            stato: 'Aperti',
            gb: 'zona'
          };

          data = _linkClienti('apri clienti in campagna', idLista, filtro, data);
        }

        return data;
      }

      function renderAppuntamentati(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: vm.lista.descrizione,
            idOperatore: row.idOperatore,
            operatore: row.operatore,
            appuntamentati: '',
            stato: 'Appuntamentati'
          };

          data = _linkClienti('apri clienti in campagna', idLista, filtro, data);
        }

        return data;
      }

      function renderLavorati(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: vm.lista.descrizione,
            idOperatore: row.idOperatore,
            operatore: row.operatore,
            lavorati: '',
            stato: 'Lavorati'
          };

          data = _linkClienti('apri clienti in campagna', idLista, filtro, data);
        }

        return data;
      }
    }

    function clientiAssegnatiReload() {
      if (angular.isDefined(vm.lista.id)) {
        api.lista(vm.lista.id).get().then(function(lista) {
          vm.lista = lista;
        });

        vm.dtClientiAssegnati.dtInstance.reloadData(null, true);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaImportController', ListaImportController);

  function ListaImportController($q, $scope, $filter, AuthenticateJS, $modal, dtFactory, DTOptionsBuilder, api, apiBaseUrl) {
    var vm = this;

    var listaImportModal = $modal({
      scope: $scope,
      templateUrl: 'lista-import-modal.tpl.html',
      backdrop: false,
      show: false,
      onHide: dropImportTable
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.sc = {};
    vm.importResults = {};
    vm.formData = {};
    vm.helps = {};
    vm.alerts = {};
    vm.enableImport = false;
    vm.enableCreate = false;
    vm.dtClienti = {};
    vm.filtraZone = filtraZone;
    vm.saveImport = saveImport;
    vm.resetForm = resetForm;
    vm.annullaImport = annullaImport;
    vm.annullaInserisci = annullaInserisci;
    vm.dropImportTable = dropImportTable;
    vm.showLista = dtClienti;
    vm.saveLista = saveLista;

    vm.readCliente = api.clienti.actions.read;

    $scope.$on('importLista', importLista);
    $scope.$watchCollection('lic.sc', onChangeSearchForm);

    ////////////////////////////////////////////////////////////////////////////
    function filtraZone(zone) {
      if (!_.isEmpty(vm.sc.gruppoZona)) {
        zone = $filter('filter')(zone, {gruppo: vm.sc.gruppoZona}, true);
      }

      return zone;
    }

    function resetForm() {
      vm.alerts = {};

      vm.lista = {
        dataApertura: moment().startOf('day').toDate(),
        dataChiusura: moment().add(1, 'months').startOf('day').toDate(),
        tipoMotivo: 'TELECOM',
        idStatoElenco: '1'
      };

      vm.sc = {
        modoImport: 'idcliente',
        'idZone[]': [],
        gruppoZona: '',
        'idPtf[]': [],
        'idPtfMob[]': [],
        'idPtfSa[]': [],
        'idPtf4[]': [],
        privacy: '0',
        opInnovatore: '>=',
        innovatore: 0
      };

      vm.enableImport = false;
      vm.enableCreate = false;

      vm.dtClienti = {};
    }

    function annullaImport() {
      vm.alerts = {};

      vm.sc.modoImport = 'idcliente'
      delete vm.sc.fileImport;
      delete vm.sc.fileImportError;
      delete vm.sc.fromTable;

      vm.enableImport = false;
    }

    function annullaInserisci() {
      vm.alerts = {};

      vm.lista = {
        dataApertura: moment().startOf('day').toDate(),
        dataChiusura: moment().add(1, 'months').startOf('day').toDate(),
        tipoMotivo: 'TELECOM',
        idStatoElenco: '1'
      };

      vm.enableCreate = false;
    }

    function dropImportTable() {
      if (!_.isEmpty(vm.sc.fromTable)) {
        api.liste.import_delete({
          tablename: vm.sc.fromTable
        }).then(annullaImport)
      }
    }

    function importLista() {
      vm.helps = {
        codfisc: 'il file deve contenere una colonna con nome `CodFisc`',
        idcliente: 'il file deve contenere una colonna con nome `IDCliente`'
      };

      //imposta i defaults
      resetForm();

      //formData
      var fdPromises = [
        api.liste.editForm(),
        api.clienti.searchForm()
      ];

      $q.all(fdPromises)
        .then(showModal);

      function showModal(forms) {
        vm.formData = angular.extend({}, forms[0], forms[1]);

        listaImportModal.$promise
          .then(listaImportModal.show);
      }
    }

    function saveImport() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      var file = vm.sc.fileImport;
      file.upload = api.liste.import({
        modoImport: vm.sc.modoImport,
        fileImport: vm.sc.fileImport
      });
      file.upload.then(uploadSuccess, uploadError, uploadProgress);

      //////////////////////////////////////////////////////////////////////////
      function uploadSuccess(xhr) {
        vm.importResults = xhr.data;

        vm.enableImport = false;

        vm.sc.fromTable = vm.importResults.nome_tabella;
        vm.sc.fileName = vm.sc.fileImport.name;

        delete vm.sc.fileImport;
        delete vm.sc.fileImportError;

        if (xhr.data.clienti_non_trovati.length > 0) {
          var cnt = xhr.data.clienti_non_trovati.length;
          var ct = xhr.data.clienti_totali;

          vm.alerts = {
            status: 200,
            messages: [
              {text: cnt + ' clienti non trovati su ' + ct + ' clienti totali. ' + (ct-cnt) + ' clienti validi'}
            ]
          };
        }
      }

      function uploadError(xhr) {
        vm.alerts = {
          status: xhr.status,
          messages: xhr.data.warnings
        };
      }

      function uploadProgress(event) {
        file.progress = Math.min(100, parseInt(100.0 * event.loaded / event.total));
      }
    }

    function onChangeSearchForm(newCollection, oldCollection) {
      if (!angular.equals(newCollection, oldCollection)) {
        vm.dtClienti = {};

        if (!_.isEmpty(newCollection.fromTable)) {
          if (newCollection.fromTable !== oldCollection.fromTable) {
            dtClienti();
          }
        }
      }
    }

    function dtClienti() {
      var sc = angular.copy(vm.sc);

      //conversione delle date in formato ISO
      if (_.isDate(sc.esc_telefonate_pos_data_from)) {
        sc.esc_telefonate_pos_data_from = sc.esc_telefonate_pos_data_from.toISOString();
      }
      if (_.isDate(sc.esc_telefonate_data_from)) {
        sc.esc_telefonate_data_from = sc.esc_telefonate_data_from.toISOString();
      }
      if (_.isDate(sc.esc_appuntamenti_data_from)) {
        sc.esc_appuntamenti_data_from = sc.esc_appuntamenti_data_from.toISOString();
      }
      if (_.isDate(sc.esc_ull_data_from)) {
        sc.esc_ull_data_from = sc.esc_ull_data_from.toISOString();
      }
      if (_.isDate(sc.esc_mnp_data_from)) {
        sc.esc_mnp_data_from = sc.esc_mnp_data_from.toISOString();
      }

      var ajaxRequest = {
        url: apiBaseUrl + '/liste/create?dt',
        data: sc,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        }
      };

      if (_.isEmpty(vm.dtClienti.instance)) {
        vm.dtClienti.instance = {};

        vm.dtClienti.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder.newOptions()
          .withOption('ajax', ajaxRequest)
          .withDataProp('data')
          .withOption('processing', true)
          .withOption('serverSide', true)
          .withOption('dom', "<'row'<'col-sm-6'Bi>><'row'<'col-sm-12'tr>><'row'<'col-sm-5'l><'col-sm-7'p>>")
          .withButtons([
            {
              text: 'Esporta',
              className: 'btn-info btn-sm',
              action: exportCsv
            }
          ])
          .withOption('searchable', false)
          .withOption('order', [1, 'asc'])
        );

        vm.dtClienti.columns = [
          {
            data: 'id',
            title: 'ID',
            type: 'num',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag. Soc.',
            'class': '',
            render: renderCliente
          },
          {data: 'cf', title: 'C.F.'},
          {
            data: 'citta',
            title: 'Città',
            render: renderCitta
          },
          {
            data: 'indirizzo',
            title: 'Indirizzo',
            render: renderIndirizzo,
            'class': ''
          },
          {
            data: 'idZona',
            title: 'Zona',
            render: renderZona
          },
          {data: 'ptf', title: 'Cluster'},
          {data: 'ptfMob', title: 'Cross'},
          {data: 'ptfSa', title: 'Segmento'},
          {
            data: 'privacy',
            title: '<span title="Privacy">P</span>',
            render: dtFactory.renders.boolean
          },
          {
            data: 'bloccato',
            title: '<span title="Bloccato">B</span>',
            render: dtFactory.renders.boolean
          },
          {
            data: 'innovatore',
            title: '<span title="Innovatore">Inn.</span>',
            render: renderInnovatore
          }
        ];
      } else {
        vm.dtClienti.instance.changeData(ajaxRequest);
      }

      ////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="lic.readCliente(' + row.id + ')">' + data + '</a>';
        }

        return data;
      }

      function renderCitta(data, type, row) {
        return row.citta + (row.prov ? ' (' + row.prov + ')' : '');
      }

      function renderIndirizzo(data, type, row) {
        return row.indirizzo + (row.civico ? ',' + row.civico : '');
      }

      function renderZona(data, type, row) {
        return row.idZona + ' (' + row.gruppoZona + ')';
      }

      function renderInnovatore(data, type) {
        if (type === 'display') {
          data = $filter('number')(data * 100, 0) + ' %';
        }

        return data;
      }

      function exportCsv(e, dt) {
        var getParams = dt.ajax.params();
        delete getParams.dt;
        getParams.csv = true;

        var numRecords = dt.page.info().recordsDisplay;

        return dtFactory.exportFile(apiBaseUrl + '/liste/create', getParams, numRecords);
      }
    }

    function saveLista(sc, lista) {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      var postData = angular.extend({}, sc, lista);

      api.liste.create_save(postData)
        .then(listaImportModal.hide, setAlerts);

      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaCreateController', ListaCreateController);

  function ListaCreateController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var listaCreateModal = $modal({
      scope: $scope,
      templateUrl: 'lista-create-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.formData = {};
    vm.alerts = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createLista', createLista);

    ////////////////////////////////////////////////////////////////////////////
    function createLista() {
      vm.alerts = {}; //reset degli alert

      vm.lista = {
        dataApertura: moment().startOf('day').toDate(),
        dataChiusura: moment().add(1, 'months').startOf('day').toDate(),
        tipoMotivo: 'TELECOM',
        idStatoElenco: '1'
      };

      api.liste.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        listaCreateModal.$promise
          .then(listaCreateModal.show);
      }
    }

    function saveForm() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      api.liste.save(vm.lista)
        .then(listaCreateModal.hide, setAlerts);

      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      listaCreateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ListaAssignController', ListaAssignController);

  function ListaAssignController($scope, $document, AuthenticateJS, $modal, $alert, DTOptionsBuilder, dtFactory, validationManager, api) {
    var vm = this;

    var listaAssignModal = $modal({
      scope: $scope,
      templateUrl: 'lista-assign-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.lista = {};
    vm.formData = {};
    vm.dtZone = {};
    vm.zone = {};

    vm.assignAll = assignAll;
    vm.dtZoneLoad = dtZoneLoad;
    vm.saveForm = saveForm;
    vm.resetForm = resetForm;
    vm.undoForm = undoForm;

    $scope.$on('assignLista', assignLista);
    $scope.$on('Lista.updated', dtZoneReload);

    $scope.$watchCollection('lac.zone', sumZone);

    ////////////////////////////////////////////////////////////////////////////
    function assignLista(event, idLista) {
      vm.dtZone = {};

      api.liste.editForm({
        idMotivo: idLista
      }).then(getLista);

      function getLista(formData) {
        vm.formData = formData;
        vm.formData.numClienti = 0;

        api.lista(idLista).get()
          .then(showModal);

        dtZoneLoad(idLista);

        function showModal(lista) {
          vm.lista = lista;

          listaAssignModal.$promise
            .then(listaAssignModal.show);
        }
      }
    }

    function dtZoneLoad(idLista) {
      vm.zone = {}; //reset oggetto che contiene le zone

      if (_.isEmpty(vm.dtZone.dtInstance)) {
        vm.dtZone.dtInstance = {};

        vm.dtZone.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function () {
            return api.lista(idLista).clienti.list({
              daAssegnare: '',
              citta: vm.lista.citta,
              gb: 'zona'
            });
          })
          .withOption('createdRow', getZone)
          .withDOM("rt<'row'<'col-xs-6'i><'col-xs-6'p>>")
          .withOption('order', [0, 'asc'])
          .withOption('lengthChange', false)
          .withOption('searching', false)
        );

        vm.dtZone.dtColumns = [
          {
            data: 'zona',
            title: 'Zona',
            'class': ''
          },
          {
            data: 'clienti',
            title: 'Num. Clienti',
            'class': 'min-width text-right',
            render: renderClienti
          },
          {
            data: 'clienti',
            render: renderFreccia,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          },
          {
            data: 'clienti',
            title: 'Assegna',
            render: renderAssegna,
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dtZone.dtInstance.reloadData(null, true);
      }

      //////////////////////////////////////////////////////////////////////////
      function getZone(row, data) {
        vm.zone[data.idZona] = 0;
      }

      function renderClienti(data, type) {
        if (type === 'display') {
          data = '<span class="fa-2x">' + data + '</span>';
        }

        return data;
      }

      function renderFreccia(data, type, row) {
        return '<i class="fa fa-fw fa-arrow-right fa-2x text-success" ng-click="lac.assignAll(' + data + ', \'' + row.idZona + '\')"></i>';
      }

      function renderAssegna(data, type, row) {
        if (type === 'display') {
          data = '<input type="number" class="form-control input-sm text-right" style="width: 7rem;" min="0" max="' + data + '" ng-model="lac.zone[\'' + row.idZona + '\']">';
        } else {
          data = '{{lac.zone[\'' + row.idZona + '\']}}';
        }

        return data;
      }
    }

    function dtZoneReload() {
      vm.resetForm();
      if ( ! _.isEmpty( vm.dtZone.instance ) ) {
        vm.dtZone.dtInstance.reloadData(null, true);
      }

      // reset form validation
      var form = $document.find("form[name='listaAssignForm']");

      if (angular.isDefined(form)) {
        validationManager.resetForm(form);
      }
    }

    function assignAll(num, idZona) {
      vm.zone[idZona] = num;
    }

    function sumZone(zone) {
      vm.formData.numClienti = _.sum(_.values(zone));
    }

    function saveForm() {
      var putData = {
        idOperatore: vm.lista.idOperatore,
        citta: vm.lista.citta,
        zone: vm.zone
      };

      api.lista(vm.lista.id).assign(putData)
        .then(postAssign);

      //////////////////////////////////////////////////////////////////////////
      function postAssign(response) {
        vm.lista.daAssegnare -=  _.sum(_.values(response.zone));

        var successAlert = {
          title: _.sum(_.values(response.zone)) + ' clienti assegnati con successo',
          type: 'success',
          container: '#lac-alerts',
          duration: 3
        };

        $alert(successAlert);
      }
    }

    function resetForm() {
      vm.lista.idOperatore = '';
      vm.formData.numClienti = 0;

      for (var prop in vm.zone) {
        if (vm.zone.hasOwnProperty(prop)) {
          vm.zone[prop] = 0;
        }
      }
    }

    function undoForm() {
      listaAssignModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ClientiListaController', ClientiListaController);

  function ClientiListaController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var clientiListaModal = $modal({
      scope: $scope,
      templateUrl: 'clienti-lista-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.filtro = {};
    vm.dtZone = {
      show: false
    };
    vm.dtClienti = {
      show: false
    };
    vm.header = '';

    vm.showDtClienti = showDtClienti;
    vm.readCliente = api.clienti.actions.read;
    vm.readTelefonateElenco = function readTelefonateElenco(idElenco, filtroElenco) {
      $rootScope.$broadcast('readTelefonateElenco', idElenco, filtroElenco);
    };
    vm.readTelefonate = function(filtroTelefonate) {
      $rootScope.$broadcast('readTelefonate', filtroTelefonate);
    };
    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };

    $scope.$on('readClientiLista', readClientiLista);

    ////////////////////////////////////////////////////////////////////////////
    function readClientiLista(event, idLista, filtroLista) {
      vm.filtro = filtroLista;
      vm.filtro.idMotivo = idLista;

      vm.dtZone.show = false;
      vm.dtClienti.show = false;

      if (vm.filtro.gb === 'zona') {
        dtZone();
      } else {
        dtClienti();
      }

      clientiListaModal.$promise
        .then(clientiListaModal.show);
    }

    function dtClienti() {
      vm.dtClienti.show = true;

      vm.dtClienti.dtInstance = {};

      vm.dtClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(vm.filtro.idMotivo).clienti.list(vm.filtro);
        })
        .withOption('order', [1, 'asc'])
      );

      vm.dtClienti.dtColumns = [
        {
          data: 'idCliente',
          title: 'ID',
          'class': '',
          render: renderCliente
        },
        {
          data: 'cliente',
          title: 'Cliente',
          'class': '',
          render: renderCliente
        },
        {
          data: 'citta',
          title: 'Città',
          'class': ''
        },
        {data: 'zona', title: 'Zona'},
        {
          data: 'chiamate',
          title: 'Chiamate',
          render: renderChiamate,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamenti',
          title: 'Appuntamenti',
          render: renderAppuntamenti,
          'class': 'min-width text-right'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="clc.readCliente(' + row.idCliente + ')">' + data + '</a>';
        }

        return data;
      }

      function renderAppuntamenti(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri appuntamenti" ng-click=\'clc.readAppuntamenti(${ filtro })\'>${ data }</a>');

            data = template({
              filtro: angular.toJson({
                idMotivo: vm.filtro.idMotivo,
                motivo: _.escape(vm.filtro.motivo),
                idOperatore: vm.filtro.idOperatore,
                operatore: vm.filtro.operatore,
                idCliente: row.idCliente,
                cliente: _.escape(row.cliente)
              }),
              data: data
            });
          }
        }

        return data;
      }

      function renderChiamate(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri telefonate" ng-click=\'clc.readTelefonate(${ filtro })\'>${ data }</a>');

            data = template({
              filtro: angular.toJson({
                idMotivo: vm.filtro.idMotivo,
                motivo: _.escape(vm.filtro.motivo),
                idOperatore: vm.filtro.idOperatore,
                operatore: vm.filtro.operatore,
                idCliente: row.idCliente,
                cliente: _.escape(row.cliente)
              }),
              data: data
            });
          }
        }

        return data;
      }
    }

    function showDtClienti(idZona, zona) {
      vm.filtro.idZona = idZona;
      vm.filtro.zona = zona;
      vm.filtro.gb = '';

      if (vm.dtClienti.show === false) {
        dtClienti();
      } else {
        vm.dtClienti.dtInstance.changeData(loadClienti);
      }

      function loadClienti() {
        return api.lista(vm.filtro.idMotivo).clienti.list(vm.filtro);
      }
    }

    function dtZone() {
      vm.dtZone.show = true;

      vm.dtZone.dtInstance = {};

      vm.dtZone.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function () {
          return api.lista(vm.filtro.idMotivo).clienti.list(vm.filtro);
        })
        .withDOM("rt<'row'<'col-xs-6'i><'col-xs-6'p>>")
        .withOption('order', [0, 'asc'])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtZone.dtColumns = [
        {data: 'zona', title: 'Zona'},
        {
          data: 'clienti',
          title: 'Clienti',
          render: renderClienti,
          'class': 'min-width text-right'
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderClienti(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            data = '<a title="apri clienti" ng-click="clc.showDtClienti(\'' + row.idZona + '\', \'' + row.zona + '\')">' + data + '</a>';
          }
        }

        return data;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('IncomingCallController', IncomingCallController);

  function IncomingCallController($q, $rootScope, $scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api, $routeParams) {
    var vm = this;
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();
    vm.alerts = {};
    vm.sc = {
      mc: 0
    };
    for ( var i in $routeParams ) {
      vm.sc[i] = $routeParams[i];
    }
    vm.dtClienti = {
      show: false
    };
    vm.readCliente = api.clienti.actions.read;
    api.clienti.list( vm.sc ).then(dtClienti, setAlerts);

    function setAlerts(response) {
      vm.dtClienti.show = false;

      vm.alerts = {
        status: response.status,
        messages: response.data.warnings
      };
    }

    function dtClienti(clienti) {
      if (_.isEmpty(vm.dtClienti.dtInstance)) {
        vm.dtClienti.dtInstance = {};

        vm.dtClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(clienti.$promise)
          .withOption( 'order', [[6, 'asc'],[1, 'asc']] )
          .withOption( 'searching', false )
          .withOption( 'paging', false )
          //.withOption('pageLength', 25)
          //.withOption('createdRow', createdRow)
        );

        /*
        if (vm.user.userGroup >= 4) {
          var buttons = [];

          buttons.push({
            extend: 'excelHtml5',
            action: logExport,
            text: 'Esporta',
            className: 'btn-info btn-sm',
            filename: 'Clienti',
            exportOptions: {
              orthogonal: 'filter'
            }
          });

          if (vm.user.userGroup == 8) {
            buttons.push({
              text: 'Cancella',
              className: 'btn-danger btn-sm',
              action: cancellaClienti
            });
          }

          vm.dtClienti.dtOptions
            .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
            .withButtons(buttons)
          ;
        }
        */

        vm.dtClienti.dtColumns = [
          {
            data: 'id',
            title: 'ID',
            type: 'num',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag. Soc.',
            'class': '',
            render: renderCliente
          },
          {
            data: 'cf',
            title: 'C.F.'
          },
          {
            data: 'citta',
            title: 'Città'
          },
          {
            data: 'prov',
            title: 'Prov.'
          },
          {
            data: 'indirizzo',
            title: 'Indirizzo',
            'class': '',
            render: renderIndirizzo
          },
          {
            data: 'ptf',
            title: 'Cluster'
          },
          {
            data: 'ptfMob',
            title: 'Cross'
          },
          {
            data: 'ptfSa',
            title: 'Segmento'
          },
          {
            data: 'agenteCognome',
            title: 'Agente',
            render: renderAgente
          },
          {
            data: 'tel',
            title: 'Tel'
          },
          {
            data: 'email',
            title: 'Email',
            visible: false
          }/*,
          {
            data: 'id',
            render: renderActions,
            orderable: false,
            searchable: false
          }*/
        ];
      } else {
        vm.dtClienti.dtInstance.changeData(clienti.$promise);
      }

      vm.dtClienti.show = true;
      if ( clienti.length == 1 ) { // se ho solo un risultato, apro la modal dell'unico cliente trovato
        vm.readCliente( clienti[0].id );
      }

      //////////////////////////////////////////////////////////////////////////
      /*
      function createdRow(row, data) {
        if (data.privacy) {
          angular.element(row).addClass('text-danger');
        }
      }

      function cancellaClienti() {
        vm.deleteClienti(vm.sc);
      }
      */

      function renderCliente(data, type, row) {
        var action = '<a title="apri cliente" ng-click="icc.readCliente(' + row.id + ')">' + data + '</a>';

        if (type === 'display') {
          if (vm.user.userGroup == 1) {
            if ((vm.user.idAgente === row.idAgente) || (vm.user.idAgente === row.lastYearIDAgente)) {
              data = action;
            } else {
              data = '<a title="apri cliente" ng-click="icc.readClienteAgente(' + row.id + ')">' + data + '</a>';
            }
          } else {
            data = action;
          }
        }

        return data;
      }

      function renderIndirizzo(data, type, row) {
        return row.indirizzo + (row.civico ? ','+row.civico : '');
      }

      function renderAgente(data, type, row) {
        return row.agenteCognome + ' ' + row.agenteNome;
      }

      /*
      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="clienti.updateCliente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="clienti.deleteCliente(' + data + ')"><i class="fa fa-minus"></i></button>';

        switch (vm.user.userGroup) {
          case 1:
            if ((vm.user.idAgente === row.idAgente) || (vm.user.idAgente === row.lastYearIDAgente)) {
              actions = upd;
            }
            break;

          case 3:
          case 4:
            actions = upd;
            break;

          case 5:
          case 6:
          case 7:
          case 8:
            actions = upd + '&nbsp;' + del;
            break;
        }

        return actions;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.clienti.url,
          numRecords: dt.data().length,
          filter: angular.extend({
            searchType: vm.searchType
          }, vm.sc)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config); // eslint-disable-line angular/controller-as-vm
      }
      */
    }

    /*
    function dtClientiReload(event, cliente) {
      if (! _.isEmpty(vm.dtClienti.dtInstance)) {
        if (vm.searchType === 'search') {
          search();
        } else if (vm.searchType === 'luckySearch') {
          luckySearch();
        }
      }

      if (event.name === 'Cliente.created') {
        vm.readCliente(cliente.id);
      }
    }
    */
  }
})();

(function() {
  'use strict';

angular.module('g1.core').
  run(function(DTDefaultOptions) {
    DTDefaultOptions.setLanguage({
      'sEmptyTable':     'Nessun dato presente nella tabella',
      'sInfo':           'da _START_ a _END_ di _TOTAL_',
      'sInfoEmpty':      'da 0 a 0 di 0',
      'sInfoFiltered':   '(filtrati da _MAX_ in totale)',
      'sInfoPostFix':    '',
      'sDecimal':        ',',
      'sThousands':      '\'',
      'sLengthMenu':     '_MENU_ elementi per pagina',
      'sLoadingRecords': 'Caricamento...',
      'sProcessing':     'Elaborazione...',
      'sSearch':         'Cerca: ',
      'sZeroRecords':    'La ricerca non ha portato alcun risultato.',
      'oPaginate': {
        'sFirst':    '<<',
        'sPrevious': '<',
        'sNext':     '>',
        'sLast':     '>>'
      },
      'oAria': {
        'sSortAscending':  ': attiva per ordinare la colonna in ordine crescente',
        'sSortDescending': ': attiva per ordinare la colonna in ordine decrescente'
      }
    });
  });
})();

(function() {
  'use strict';

angular.module('g1.core')
  .config(function(calendarConfig) {
    calendarConfig.allDateFormats.angular = {
      date: {
        hour: 'HH',
        day: 'dd MMM',
        month: 'MMMM',
        weekDay: 'EEEE',
        time: 'HH:mm',
        datetime: 'dd MMM, HH:mm'
      },
      title: {
        day: 'EEEE dd MMMM, yyyy',
        week: 'Sett. {week} di {year}',
        month: 'MMMM yyyy',
        year: 'yyyy'
      }
    };

    calendarConfig.i18nStrings = {
      eventsLabel: 'Eventi',
      timeLabel: 'Ora',
      weekNumber: 'Sett. {week}'
    };
  });
})();

(function() {
  'use strict';
  angular.module( 'g1.core' ).controller( 'CoperturaController', function ( AuthenticateJS, dtFactory, $scope, DTOptionsBuilder, api, apiBaseUrl ) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.alerts = [];
    vm.checkFromCsv = checkFromCsv;
    vm.checkFormData = {
      idSoggetto: vm.user.idAgente,
      tipoCopertura: {
        checkOF: true,
        checkFastweb: true,
        checkTIM: true,
        checkEolo: true
      }
    };
    vm.deleteCopertura = api.copertura().actions.delete;

    $scope.$on( 'Copertura.deleted', dtTCReload );
    $scope.$on( 'Copertura.created', dtTCReload );

    vm.dtTC = {};

    ////////////////////////////////////////////////////////////////////////////

    function checkFromCsv() {
      api.copertura().checkFromCsv( vm.checkFormData );
      var sel = '#checkCoperturaOutput';
      angular.element( sel + ' .alert' ).slideUp( function ( el ) {
        angular.element( el ).detach();
      } );

    }

    function dtTCReload( event ) {
      if ( vm.dtTC && vm.dtTC.dtInstance ) {
        vm.dtTC.dtInstance.reloadData();
      }
      if ( event.name == 'Copertura.created' ) {
        var sel = '#checkCoperturaOutput';
        var html =
          '<div class="alert alert-success">' +
            "Operazione lanciata correttamente; al termine il risultato dell'elaborazione ti verrà inviato via mail." +
          '</div>';
        angular.element( sel ).prepend( html );
      }
    }

    dtTC();

    function dtTC() {
      var renderFile = function ( data ) {
        if ( data ) {
          return '<a href="' + apiBaseUrl + data + '" target="_blank"><i class="fa fa-download"></i></a>';
        }
      };
      var renderAvanzamento = function ( data, type, row ) {
        return row.RigheCompletate + '/' + row.RigheTotali + ' (' + row.Errori + ')';
      };
      var renderAzioni = function ( data ) {
        return '<button type="button" class="btn btn-danger btn-xs" ng-click="cc.deleteCopertura(' + data + ')"><i class="fa fa-minus"></i></button>';
      }
      vm.dtTC.dtInstance = {};
      vm.dtTC.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.copertura().list();
          promise.then( function ( testCopertura ) {
            vm.testCopertura = testCopertura;
          } );
          return promise;
        } )
        .withOption( 'order', [[0, 'desc']] )
        .withOption( 'searching', false )
        .withOption( 'paging', false )
        .withOption( 'info', false )
      );
      vm.dtTC.dtColumns = [
        {
          data: 'Identificatore',
          title:'ID',
          'class': 'col-codice nowrap'
        },
        {
          data: 'Email',
          title: 'Email notifica'
        },
        {
          data: 'Stato',
          title: 'Stato'
        },
        {
          data: 'NomeFileSrc',
          title: 'File src',
          render: renderFile
        },
        {
          data: 'NomeFileDst',
          title: 'File dst',
          render: renderFile
        },
        {
          data: 'CheckOF',
          title: 'OF',
          render: dtFactory.renders.boolean
        },
        {
          data: 'CheckEolo',
          title: 'Eolo',
          render: dtFactory.renders.boolean
        },
        {
          data: 'CheckTIM',
          title: 'TIM',
          render: dtFactory.renders.boolean
        },
        {
          data: 'CheckFastweb',
          title: 'Fastweb',
          render: dtFactory.renders.boolean
        },
        {
          data: 'RigheTotali',
          title: 'Avanzamento <i class="fa fa-question-circle" bs-tooltip data-title="Completate/Totali (Errori)"></i>',
          render: renderAvanzamento
        },
        {
          data: 'Identificatore',
          title: 'Azioni',
          render: renderAzioni
        }
      ];
    }

  } );

} )();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ContrattoUpdateController', ContrattoUpdateController);

  function ContrattoUpdateController($scope, AuthenticateJS, $modal, api, $alert) {
    var vm = this;

    var contrattoUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'contratto-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.contratto = {};
    vm.formData = {};
    vm.dataConfermaRequired = dataConfermaRequired;
    vm.dataCrmRequired = dataCrmRequired;
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.searchProdotto = api.prodotti.actions.search;

    vm.statoContrattoChange = function () {
      vm.contrattoConfermato = ( vm.contratto.idStatoContratto == '6' );
    }
    vm.dataAttivazioneChange = function () {
      if ( ( vm.contratto.dataCrm != '' ) && ( vm.contratto.durataContratto > 0 ) ) {
        vm.contratto.dataFineContratto =
          moment( vm.contratto.dataCrm ).
          add( vm.contratto.durataContratto, 'months' ).
          subtract( 1, 'days' );
          $alert( {
            content: 'La data di fine contratto è stata modificata automaticamente in base alla data di attivazione specificata.',
            container: '#date-alerts-container',
            type: 'info',
            duration: 5,
            show: true
          } );
      } else {
        vm.contratto.dataFineContratto = moment( '2999-12-31' );
      }
    }

    $scope.$on('updateContratto', updateContratto);
    $scope.$on('Prodotto.selected', prodottoSelected);

    ////////////////////////////////////////////////////////////////////////////
    function dataConfermaRequired(statoContratto) {
      var required = true;
      var statiContratto = [1, 7];

      if (statiContratto.indexOf(parseInt(statoContratto)) !== -1){
        required = false;
      }

      return required;
    }

    function dataCrmRequired(statoContratto) {
      var required = false;
      var statiContratto = [3, 4, 5, 6, 8, 11, 13, 14];

      if (statiContratto.indexOf(parseInt(statoContratto)) !== -1) {
        required = true;
      }

      return required;
    }

    function prodottoSelected(event, prodotto) {
      vm.contratto.codiceProdotto = prodotto.codice;
      vm.contratto.descProdotto = prodotto.descrizione;
      vm.contratto.prezzoUnit = prodotto.prezzoUnitario;
      vm.contratto.conScadenza = prodotto.conScadenza;
    }

    function updateContratto(event, idContratto) {
      api.contratti.editForm( { idContratto: idContratto } )
        .then(getContratto);

      function getContratto(formData) {
        vm.formData = formData;

        api.contratto(idContratto).get()
          .then(showModal);

        function showModal(contratto) {
          vm.contratto = contratto;
          vm.statoContrattoChange();
          contrattoUpdateModal.$promise
            .then(contrattoUpdateModal.show);
        }
      }
    }

    function saveForm() {
      api.contratto(vm.contratto.id).update(vm.contratto)
        .then(contrattoUpdateModal.hide);
    }

    function undoForm() {
      contrattoUpdateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ContrattoCreateController', ContrattoCreateController);

  function ContrattoCreateController($scope, AuthenticateJS, $modal, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var contrattoCreateModal = $modal({
      scope: $scope,
      templateUrl: 'contratto-create-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.dtContratti = {};
    vm.prodottoSelected = prodottoSelected;
    vm.contratto = {};

    vm.readContratto = api.contratti.actions.read;
    vm.updateContratto = api.contratti.actions.update;
    vm.deleteContratto = api.contratti.actions.delete;

    $scope.$on('createContrattoAppuntamento', createContrattoAppuntamento);

    //gestione contratti
    $scope.$on('Contratto.created', dtContrattiReload);
    $scope.$on('Contratto.updated', dtContrattiReload);
    $scope.$on('Contratto.deleted', dtContrattiReload);

    ////////////////////////////////////////////////////////////////////////////
    function createContrattoAppuntamento(event, appuntamento) {
      vm.appuntamento = appuntamento;
      api.contratti.editForm( { idAppuntamento: appuntamento.id } )
        .then(showModal);
      function showModal( formData ) {
        vm.formData = formData;
        vm.contratto.idSede = formData.sedi[0].value; // imposto predefinito
        dtContratti(appuntamento.id);
        contrattoCreateModal.$promise
          .then(contrattoCreateModal.show);
      }
    }

    function dtContratti(idAppuntamento) {
      vm.dtContratti.dtInstance = {};

      vm.dtContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.appuntamento(idAppuntamento).contratti.list)
        .withOption('order', [
          [7, 'desc'],
          [0, 'asc']
        ])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtContratti.dtColumns = [
        {
          data: 'descrizione',
          title: 'Descrizione',
          render: renderContratto
        },
        {
          data: 'durataContratto',
          title: 'Durata',
          render: renderDurata
        },
        {
          data: 'prezzoUnit',
          title: 'Prezzo',
          render: dtFactory.renders.currency
        },
        {
          data: 'qta',
          title: 'Qta'
        },
        {
          data: 'prezzo',
          title: 'Totale',
          render: dtFactory.renders.currency
        },
        {
          data: 'stato',
          title: 'Stato'
        },
        {
          data: 'fornitore',
          title: 'Fornitore'
        },
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'dataInserimento',
          title: 'Inserimento',
          render: dtFactory.renders.date
        },
        {
          data: 'dataConferma',
          title: 'Conferma',
          render: dtFactory.renders.date
        },
        {
          data: 'dataCrm',
          title: 'Attivazione', // TODO: Sosituito 'CRM' con 'Attivazione'
          render: dtFactory.renders.date
        },
        {
          data: 'id',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderContratto(data, type, row) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="ccc.readContratto(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="ccc.updateContratto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="ccc.deleteContratto(' + data + ')"><i class="fa fa-minus"></i></button>';
        switch (vm.user.userGroup) {
          case 1:
          case 3:
          case 4:
            if (
              ( vm.appuntamento.idStatoAppuntamento == 104 ) && //se stato app POSITIVO
              ( row.idStato == 1 ) //se stato contratto INSERITO
            ) {
              actions = upd + '&nbsp;' + del;
            }
          break;

          case 5:
          case 6:
            if ( vm.appuntamento.idStatoAppuntamento == 104 ) { //se stato app POSITIVO
              actions = upd + '&nbsp;' + del;
            }
          break;

          case 7:
          case 8:
            actions = upd + '&nbsp;' + del;
          break;
        }

        return actions;
      }
    }

    function prodottoSelected(prodSel,ccc) {
      api.appuntamento(vm.appuntamento.id).contratti.save({
        idStatoContratto: '1',
        codiceProdotto: prodSel.codice,
        descProdotto: prodSel.descrizione,
        qta: prodSel.qta,
        prezzoUnit: prodSel.prezzoUnitario,
        note: prodSel.note,
        dataFineContratto: prodSel.dataFineContratto,
        idSede: ccc.contratto.idSede
      });
    }

    function dtContrattiReload(event, contratto) {
      if (event.name === 'Contratto.deleted') {
        vm.dtContratti.dtInstance.reloadData();
      } else {
        if (vm.appuntamento != undefined && contratto.idAppuntamento === vm.appuntamento.id) {
          vm.dtContratti.dtInstance.reloadData();
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ContrattoController', ContrattoController);

  function ContrattoController($rootScope, $scope, AuthenticateJS, $modal, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var contrattoModal = $modal({
      scope: $scope,
      templateUrl: 'contratto-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = [];
    vm.showProvvigioni = false;

    vm.contratto = {};
    vm.updateContratto = api.contratti.actions.update;
    vm.dtProvvigioni = {};

    vm.createPv = createPv;

    //gestione contratto
    $scope.$on('readContratto', readContratto);
    $scope.$on('Contratto.updated', contrattoReload);

    ////////////////////////////////////////////////////////////////////////////
    //gestione azioni
    function generaAzioni() {
      var actions = [];
      var availableActions = {
        updateContratto: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'contratto.updateContratto(contratto.contratto.id);'
        },
        createPvP: {
          text: '<i class="fa fa-wrench fa-fw"></i>&nbsp;Nuovo Postvendita',
          click: "contratto.createPv('p');"
        },
        createPvR: {
          text: '<i class="fa fa-wrench fa-fw"></i>&nbsp;Nuova Realizzazione',
          click: "contratto.createPv('r');"
        }
      };

      switch (vm.user.userGroup) {
        case 5:
        case 6:
        case 7:
        case 8:
          actions.push(availableActions.updateContratto);
          if (vm.contratto.postvendita) {
            actions.push(availableActions.createPvP);
          }
          if (vm.contratto.realizzativo) {
            actions.push(availableActions.createPvR);
          }
        break;
      }

      return actions;
    }

    //gestione contratto
    function readContratto(event, idContratto) {
      vm.idContratto = idContratto;
      api.contratto(idContratto).get()
        .then(showModal);

      function showModal(contratto) {
        vm.showProvvigioni = false;

        var documentazione = {
          '-1': 'N.R. - Non Richiesta',
          '1': 'OK - Consegnata',
          '0': 'KO - Non Consegnata'
        };

        contratto.documentazione = documentazione[contratto.documentazione];
        contratto.scaduto = moment( contratto.dataFineContratto ).endOf( 'day' ) < moment();
        vm.contratto = contratto;
        vm.azioni = generaAzioni();

        contrattoModal.$promise
          .then(contrattoModal.show);
      }
    }

    function contrattoReload(event, contratto) {
      if (contratto.id === vm.contratto.id) {
        vm.contratto = contratto;
      }
    }

    //gestione pv
    function createPv(tipo) {
      api.cliente(vm.contratto.idCliente).get().then(function (cliente) {
        var data = {
          tipo: tipo,
          idContratto: vm.contratto.id
        }
        $rootScope.$broadcast('createPvCliente', cliente, data);
      });
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ContrattiModalController', ContrattiModalController);

  function ContrattiModalController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var contrattiModal = $modal({
      scope: $scope,
      templateUrl: 'contratti-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.filtro = {};
    vm.dtContratti = {};

    $scope.$on('readContratti', readContratti);

    vm.readContratto = api.contratti.actions.read;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.readCliente = api.clienti.actions.read;

    ////////////////////////////////////////////////////////////////////////////
    function readContratti(event, filtroContratti) {
      vm.filtro = filtroContratti;

      dtContratti(filtroContratti);

      contrattiModal.$promise
        .then(contrattiModal.show);
    }

    function dtContratti(filtroContratti) {
      vm.dtContratti.dtInstance = {};

      vm.dtContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function() {
          return api.contratti.list(filtroContratti);
        })
      );

      vm.dtContratti.dtColumns = [
        {data: 'agente', title: 'Agente'},
        {
          data: 'ragSoc',
          title: 'Rag.Soc.',
          render: renderCliente
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          render: renderContratto
        },
        {data: 'fornitore', title: 'Fornitore'},
        {data: 'pista', title: 'Pista'},
        {
          data: 'dataInserimento',
          title: 'Inserimento',
          render: dtFactory.renders.date
        },
        {
          data: 'prezzo',
          title: 'Totale',
          render: dtFactory.renders.currency
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          return '<a title="apri cliente" ng-click="contratti.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderContratto(data, type, row) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="contratti.readContratto(\'' + row.id + '\')">' + data + '</a>' +
            '&nbsp;' +
            '<i class="fa fa-external-link" title="apri appuntamento" ng-click="contratti.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
        }

        return data;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ContrattiController', ContrattiController);

  function ContrattiController($window, $routeParams, $scope, AuthenticateJS, $alert, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.alerts = {};
    vm.sc = {
      fornitore: '',
      pista: '',
      sottopista: '',
      gruppo: '',
      teamLeader: '0',
      idAgente: '0',
      idPtf: '0',
      inScadenza: '',
      'idStato[]': [],
      documentazione: ''
    };
    if ( $routeParams.inScadenza ) { // rielaborazione se arrivo da widget in home page
      var coord = ( vm.user.userGroup == 7 );
      if ( coord ) {
        if ( $routeParams.idAgente != '' ) {
          vm.sc.teamLeader = '1 Key Account';
          vm.sc.idAgente = $routeParams.idAgente;
        }
      }
      if ( $routeParams.inScadenza == '1' ) {
        vm.sc.inScadenza =  $routeParams.inScadenza;
        vm.sc['idStato[]'] = ['6'];
        if ( $routeParams.meseAnno ) {
          var startDate = moment( '01/' + $routeParams.meseAnno, 'DD/MM/YYYY' );
          vm.sc.dataFineContratto_from = startDate.toDate();
          vm.sc.dataFineContratto_to = startDate.endOf( 'month' ).toDate();
        }
      }
    }
    vm.bec = {};
    vm.dtContratti = {};
    vm.showResults = false;
    vm.showClientiSearch = false;
    vm.search = search;
    vm.resetForm = resetForm;
    vm.checkBulkEdit = checkBulkEdit;
    vm.modificaStato = modificaStato;
    vm.filtraGruppi = api.prodotti.filtraGruppi;
    vm.isFilterActive = isFilterActive;

    vm.readContratto = api.contratti.actions.read;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.readCliente = api.clienti.actions.read;

    //carica i dati della form
    api.contratti.searchForm()
      .then(function(formData) {
        vm.formData = formData;

        if (vm.user.userGroup == 4) {
          vm.sc.teamLeader = vm.formData.teamLeaders[1].value;
        }
        if ( $routeParams.inScadenza ) { // se ricevo i parametri via querystring, effettuo automaticamente la ricerca
          vm.search();
        }
      })
    ;

    //reagisci ai cambiamenti sulla form di ricerca
    $scope.$watchCollection('contratti.sc', hideDt);

    //reagisci ai cambiamenti sui contratti
    $scope.$on('Contratti.updated', dtContrattiReload);
    $scope.$on('Contratto.created', dtContrattiReload);
    $scope.$on('Contratto.updated', dtContrattiReload);
    $scope.$on('Contratto.deleted', dtContrattiReload);

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      vm.showResults = true;

      vm.alerts = {};

      dtContratti()
    }

    function resetForm() {
      vm.showResults = false;

      vm.alerts = {};

      vm.sc = {
        fornitore: '',
        pista: '',
        sottopista: '',
        gruppo: '',
        teamLeader: '0',
        idAgente: '0',
        idPtf: '0',
        'idStato[]': [],
        documentazione: ''
      };
      vm.bec = {};
    }

    function dtContratti() {
      if (angular.isUndefined(vm.dtContratti.dtInstance)) {
        vm.dtContratti.dtInstance = {};

        vm.dtContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(contrattiList)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'Contratti',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('pageLength', 25)
          .withOption('createdRow', createdRow)
        );

        vm.dtContratti.dtColumns = [
          {
            data: 'teamLeader',
            title: 'Team Leader'
          },
          {
            data: 'idCliente',
            title: 'Id Cliente',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag.Soc.',
            render: renderCliente
          },
          {
            data: 'agente',
            title: 'Agente'
          },
          {
            data: 'operatore',
            title: 'Operatore',
            visible: false
          },
          {
            data: 'descrizione',
            title: 'Descrizione'
          },
          {
            data: 'durataContratto',
            title: 'Durata',
            render: renderDurata
          },
          {
            data: 'stato',
            title: 'Stato',
            render: renderContratto
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'dataInserimento',
            title: 'Inserimento',
            render: dtFactory.renders.date
          },
          {
            data: 'dataConferma',
            title: 'Conferma',
            render: dtFactory.renders.date
          },
          {
            data: 'dataCrm',
            title: 'Attivazione', // TODO: Sosituito 'CRM' con 'Attivazione'
            render: dtFactory.renders.date
          },
          {
            data: 'dataFineContratto',
            title: 'Fine contratto',
            render: dtFactory.renders.date
          },
          {
            data: 'prezzoUnit',
            title: 'Prezzo',
            render: dtFactory.renders.currency
          },
          {
            data: 'qta',
            title: 'Qta'
          },
          {
            data: 'prezzo',
            title: 'Totale',
            render: dtFactory.renders.currency
          },
          {
            data: 'numOrdine',
            title: 'Ordine',
            visible: false
          },
          {
            data: 'note',
            title: 'Note',
            'class': '',
            render: dtFactory.renders.longtext
          },
          {
            data: 'noteBo',
            title: 'Note Backoffice',
            visible: false
          },
          {
            data: 'noteTecniche',
            title: 'Note Tecniche',
            visible: false
          },
          {
            data: 'cf',
            title: 'Cod.Fisc.'
          },
          {
            data: 'sottopista',
            title: 'Sottopista'
          },
          {
            data: 'gruppo',
            title: 'Gruppo'
          },
          {
            data: 'documentazione',
            title: '<span title="Documentazione">Doc.</span>',
            render: dtFactory.renders.tristate
          },
          {
            data: 'tipo',
            title: '<span title="Tipologia contratto">Tipo</span>'
          },
          {
            data: 'ptf_cli_mob',
            title: 'Cross',
            visible: false
          }
        ];

        if (AuthenticateJS.authorize('AGENTI')) {
          vm.dtContratti.dtColumns[3].visible = false; //nascondi colonna agenti se AGENTI
        }
      } else {
        vm.dtContratti.dtInstance.changeData(contrattiList);
      }

      //////////////////////////////////////////////////////////////////////////
      function contrattiList() {
        var promise = api.contratti.list(vm.sc);

        promise.then(null, setAlerts);

        return promise;
      }

      function setAlerts(response) {
        vm.showResults = false;

        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }

      function createdRow(row, data) {
        // stile riga: obsoleto -> rosso; scaduto: arancione
        if ( data.obsoleto ) {
          angular.element( row ).addClass( 'text-danger' );
        } else if ( moment( data.dataFineContratto ).endOf( 'day' ) < moment() ) {
          angular.element( row ).addClass( 'text-warning' );
        }
      }

      function renderCliente(data, type, row) {
        if (type === 'display') {
          return '<a title="apri cliente" ng-click="contratti.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderContratto(data, type, row) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="contratti.readContratto(\'' + row.id + '\')">' + data + '</a>' +
            '&nbsp;' +
            '<i class="fa fa-external-link" title="apri appuntamento" ng-click="contratti.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
        }

        return data;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.contratti.url,
          numRecords: dt.data().length,
          filter: angular.copy(vm.sc)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }
    }

    function dtContrattiReload() {
      if (angular.isDefined(vm.dtContratti.dtInstance)) {
        vm.dtContratti.dtInstance.reloadData();
      }
    }

    function hideDt(newCollection, oldCollection) {
      if (newCollection !== oldCollection) {
        vm.showResults = false;
      }
    }

    function checkBulkEdit() {
      var check = false;

      if (
        vm.user.userGroup >= 4
        && vm.showResults
        && vm.sc['idStato[]'].length === 1
      ) {
        check = true;
      }

      return check;
    }

    function modificaStato() {
      var numRecords = vm.dtContratti.dtInstance.DataTable.page.info().recordsDisplay;
      var risposta = $window.confirm('Stai per modificare lo stato di ' + numRecords + ' contratti' );

      if (risposta) {
        var tableData = vm.dtContratti.dtInstance.DataTable.rows({filter: 'applied'}).data();
        // var putData = angular.extend({}, vm.sc, vm.bec);
        var putData = angular.extend({}, vm.bec, {
          ids: _.pluck(tableData, 'id')
        });

        api.contratti.update(putData)
          .then(onUpdateContratti);
      }

      //////////////////////////////////////////////////////////////////////////
      function onUpdateContratti(response) {
        $alert({
          placement: 'top',
          title: response.rowCount + ' contratti modificati',
          type: 'success',
          duration: 3
        });
      }
    }

    function isFilterActive() {
      return [
        vm.sc.idCliente,
        vm.sc.ragSoc,

        vm.sc.prov,
        vm.sc.idZona,

        vm.sc.citta,
        vm.sc.indirizzo
      ].reduce(function (acc, curVal) {
        return acc + Number(
          angular.isDefined(curVal)
          && curVal !== null
          && curVal !== ''
        );
      }, 0);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('SedeEditController', SedeEditController);

  function SedeEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var sedeEditModal = $modal({
      scope: $scope,
      templateUrl: 'sede-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.sede = {};
    vm.savedSede = {};
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.sedePrincipaleChange = sedePrincipaleChange;
    vm.confermaDeselezionaSedePrincipale = false;
    vm.disabledSubmit = false;
    vm.enableSubmit = enableSubmit;
    vm.onchangeOrariApertura = function () {
      vm.sede.dataOraAggiornamentoOrariApertura = moment();
      vm.sede.dataOraAggiornamentoOrariAperturaFormatted = formatDateTime(  vm.sede.dataOraAggiornamentoOrariApertura );
    }
    var formatDateTime = function ( dateTime ) {
      return dateTime.format( 'DD/MM/YYYY HH:mm' );
    }

    $scope.$on( 'createSede', createSede );
    $scope.$on( 'updateSede', updateSede );

    ////////////////////////////////////////////////////////////////////////////

    function createSede( event, cliente ) {
      action = 'create';
      vm.sede = {
        idCliente: cliente.id,
        indirizzo: '',
        telefono: '',
        sedePrincipale: false
      };
      vm.alerts = [];
      function showModal(formData) {
        vm.formData = formData;
        sedeEditModal.$promise
          .then(sedeEditModal.show);
      }
      showModal();
    }

    function updateSede( event, idSede ) {
      action = 'update';
      vm.alerts = [];
      function getSede() {
        api.sede(idSede).get()
          .then(showModal);
        function showModal( sede ) {
          vm.sede = sede;
          vm.savedSede = angular.copy( sede );
          if ( vm.sede.dataOraAggiornamentoOrariApertura ) {
            vm.sede.dataOraAggiornamentoOrariAperturaFormatted = formatDateTime( moment( vm.sede.dataOraAggiornamentoOrariApertura ) );
          }
          sedeEditModal.$promise
            .then( sedeEditModal.show );
        }
      }
      getSede();
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if ( action === 'create' ) {
        api.sedi.save( vm.sede )
          .then( sedeEditModal.hide, setAlerts );
      } else if ( action === 'update' ) {
        api.sede(vm.sede.idSede).update( vm.sede )
          .then(sedeEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function sedePrincipaleChange() {
      if ( vm.savedSede.sedePrincipale ) {
        vm.confermaDeselezionaSedePrincipale = ! vm.sede.sedePrincipale;
        vm.disabledSubmit = ! vm.sede.sedePrincipale;
      }
    }

    function enableSubmit() {
      vm.disabledSubmit = false;
      vm.confermaDeselezionaSedePrincipale = false;
    }

    vm.setCitta = function ( value ) {
      for ( var i in vm.formData.comuni ) {
        var comune = vm.formData.comuni[i];
        if ( comune.identificatore == value ) {
          vm.sede.citta = comune.nome;
          angular.element( '[ng-model="sec.sede.citta"]' ).blur();
          vm.sede.prov = comune.siglaProvincia;
        }
      }
    };

    vm.getComuni = function ( val ) {
      return api.sedi.editForm( { comune: val } ).then( function ( formData ) {
        vm.formData = formData;
        return formData.comuni;
      } );
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ReferenteEditController', ReferenteEditController);

  function ReferenteEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var referenteEditModal = $modal({
      scope: $scope,
      templateUrl: 'referente-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.referente = {};
    vm.savedReferente = {};
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;
    vm.referentePrincipaleChange = referentePrincipaleChange;
    vm.confermaDeselezionaReferentePrincipale = false;
    vm.disabledSubmit = false;
    vm.enableSubmit = enableSubmit;

    $scope.$on('createReferente', createReferente);
    $scope.$on('updateReferente', updateReferente);

    ////////////////////////////////////////////////////////////////////////////

    function createReferente(event, cliente) {
      action = 'create';
      vm.referente = {
        idCliente: cliente.id,
        idTipoReferente: '',
        cliente: cliente.ragSoc,
        nominativo: '',
        email: '',
        tel: '',
        referentePrincipale: false
      };
      if ( cliente.referenti.length == 0 ) {
        // se il cliente non ha referenti, impongo l'inserimento di un referente principale
        vm.referente.referentePrincipale = true;
      }
      vm.alerts = [];

      api.referenti.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;
        referenteEditModal.$promise
          .then(referenteEditModal.show);
      }
    }

    function updateReferente(event, idReferente) {
      action = 'update';
      vm.alerts = [];

      api.referenti.editForm()
        .then(getCliente);

      function getCliente(formData) {
        vm.formData = formData;

        api.referente(idReferente).get()
          .then(showModal);

        function showModal( referente ) {
          vm.referente = referente;
          vm.savedReferente = angular.copy( referente );
          referenteEditModal.$promise
            .then(referenteEditModal.show);
        }
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (action === 'create') {
        api.referenti.save(vm.referente)
          .then(referenteEditModal.hide, setAlerts);
      } else if (action === 'update') {
        api.referente(vm.referente.id).update(vm.referente)
          .then(referenteEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }

    }

    function referentePrincipaleChange() {
      if ( vm.savedReferente.referentePrincipale ) {
        vm.confermaDeselezionaReferentePrincipale = ! vm.referente.referentePrincipale;
        vm.disabledSubmit = ! vm.referente.referentePrincipale;
      }
    }

    function enableSubmit() {
      vm.disabledSubmit = false;
      vm.confermaDeselezionaReferentePrincipale = false;
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('DatoClienteEditController', DatoClienteEditController);

  function DatoClienteEditController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var datoClienteEditModal = $modal({
      scope: $scope,
      templateUrl: 'dato-cliente-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.datoCliente = {};
    vm.formData = {};
    vm.alerts = [];
    vm.saveForm = saveForm;

    $scope.$on('createDatoCliente', createDatoCliente);
    $scope.$on('updateDatoCliente', updateDatoCliente);

    ////////////////////////////////////////////////////////////////////////////
    function createDatoCliente(event, idCliente) {
      action = 'create';
      vm.datoCliente = {
        idCliente: idCliente,
        fornitore: 'CLYCO',
        pista: '',
        gruppo: '',
        sottopista: '',
        quantita: 1,
        noleggio: false,
        idUtenteInt: vm.user.id
      };
      vm.alerts = [];

      api.clienti.dati.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        datoClienteEditModal.$promise
          .then(datoClienteEditModal.show);
      }
    }

    function updateDatoCliente(event, idDatoCliente) {
      action = 'update';
      vm.alerts = [];

      api.clienti.dati.editForm()
        .then(getCliente);

      function getCliente(formData) {
        vm.formData = formData;

        api.clienti.dato(idDatoCliente).get()
          .then(showModal);

        function showModal(datoCliente) {
          vm.datoCliente = datoCliente;

          datoClienteEditModal.$promise
            .then(datoClienteEditModal.show);
        }
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (action === 'create') {
        api.cliente(vm.datoCliente.idCliente).dati.save(vm.datoCliente)
          .then(datoClienteEditModal.hide, setAlerts);
      } else if (action === 'update') {
        api.clienti.dato(vm.datoCliente.id).update(vm.datoCliente)
          .then(datoClienteEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('DatoClienteController', DatoClienteController);

  function DatoClienteController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var datoClienteModal = $modal({
      scope: $scope,
      templateUrl: 'dato-cliente-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.datoCliente = {};

    $scope.$on('readDatoCliente', readDatoCliente);

    ////////////////////////////////////////////////////////////////////////////
    function readDatoCliente(event, idDatoCliente) {
      api.clienti.dato(idDatoCliente).get()
        .then(showModal);

      function showModal(datoCliente) {
        vm.datoCliente = datoCliente;

        datoClienteModal.$promise
          .then(datoClienteModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('DatiClientiController', DatiClientiController);

  function DatiClientiController($q, $rootScope, $scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.alerts = {};
    vm.sdc = {
      mode: 'datiClienti',
      mc: 0,
      idAgente: '0',
      fornitore: '',
      pista: '',
      opQuantita: '=',
      opValore: '=',
      opValoreAssistenza: '='
    };
    vm.dtClienti = {
      show: false
    };
    vm.dtDatiClienti = {
      show: false
    };
    vm.showClientiSearch = false;
    vm.showAdvancedSearch = false;
    vm.search = search;
    vm.resetForm = resetForm;
    vm.isFilterActive = isFilterActive;

    vm.readCliente = api.clienti.actions.read;
    vm.readClienteAgente = function readClienteAgente(idCliente) {
      $rootScope.$broadcast('readClienteAgente', idCliente);
    };

    vm.readDatoCliente = api.clienti.dati.actions.read;
    vm.updateDatoCliente = api.clienti.dati.actions.update;
    vm.deleteDatoCliente = api.clienti.dati.actions.delete;

    //carica i dati della form
    var fdPromises = [
      api.clienti.searchForm(),
      api.clienti.dati.searchForm()
    ];

    $q.all(fdPromises)
      .then(loadFormaData);

    function loadFormaData(forms) {
      vm.formData = angular.extend({}, forms[0], forms[1]);
    }

    //gestisci il cambio modalità (clienti/dati clienti)
    $scope.$watch('datiClienti.sdc.mode', onChangeMode);

    //reagisci ai cambiamenti sui clienti
    $scope.$on('Cliente.created', dtClientiReload);
    $scope.$on('Cliente.updated', dtClientiReload);
    $scope.$on('Cliente.deleted', dtClientiReload);

    //reagisci ai cambiamenti sui dati dei clienti
    $scope.$on('DatoCliente.created', dtDatiClientiReload);
    $scope.$on('DatoCliente.updated', dtDatiClientiReload);
    $scope.$on('DatoCliente.deleted', dtDatiClientiReload);

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      vm.alerts = {};

      api.clienti.list(vm.sdc)
        .then(dtResults, setAlerts);
    }

    function setAlerts(response) {
      vm.dtClienti.show = false;

      vm.alerts = {
        status: response.status,
        messages: response.data.warnings
      };
    }

    function resetForm() {
      vm.dtClienti.show = false;
      vm.dtDatiClienti.show = false;

      vm.alerts = {};

      vm.sdc = {
        mode: 'datiClienti',
        mc: 0,
        idAgente: '0',

        fornitore: '',
        pista: '',
        opQuantita: '=',
        opValore: '=',
        opValoreAssistenza: '='
      };
    }

    function onChangeMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        search();
      }
    }

    function dtResults(response) {
      if (vm.sdc.mode === 'datiClienti') {
        vm.dtClienti.show = false;

        dtDatiClienti(response);
      } else {
        vm.dtDatiClienti.show = false;

        dtClienti(response);
      }
    }

    function dtClienti(clienti) {
      if (_.isEmpty(vm.dtClienti.dtInstance)) {
        vm.dtClienti.dtInstance = {};

        vm.dtClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(clienti.$promise)
          .withOption('order', [1, 'asc'])
          .withOption('pageLength', 25)
          .withOption('createdRow', createdRow)
        );

        if (vm.user.userGroup >= 4) {
          var buttons = [];

          buttons.push({
            extend: 'excelHtml5',
            action: logExport,
            text: 'Esporta',
            className: 'btn-info btn-sm',
            filename: 'Clienti',
            exportOptions: {
              orthogonal: 'filter'
            }
          });

          vm.dtClienti.dtOptions
            .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
            .withButtons(buttons)
          ;
        }

        vm.dtClienti.dtColumns = [
          {
            data: 'id',
            title: 'ID',
            type: 'num',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag. Soc.',
            'class': '',
            render: renderCliente
          },
          {data: 'cf', title: 'C.F.'},
          {data: 'citta', title: 'Città'},
          {data: 'prov', title: 'Prov.'},
          {
            data: 'indirizzo',
            title: 'Indirizzo',
            'class': '',
            render: renderIndirizzo
          },
          {data: 'ptf', title: 'Cluster'},
          {data: 'ptfMob', title: 'Cross'},
          {
            data: 'agenteCognome',
            title: 'Agente',
            render: renderAgente
          },
          {data: 'tel', title: 'Tel'},
          {
            data: 'email',
            title: 'Email',
            visible: false
          }
        ];
      } else {
        vm.dtClienti.dtInstance.changeData(clienti.$promise);
      }

      vm.dtClienti.show = true;

      //////////////////////////////////////////////////////////////////////////
      function createdRow(row, data) {
        /* gestione dello stile di ogni riga */
        if (data.privacy) {
          angular.element(row).addClass('text-danger');
        }
      }

      function renderCliente(data, type, row) {
        var action = '<a title="apri cliente" ng-click="datiClienti.readCliente(' + row.id + ')">' + data + '</a>';

        if (type === 'display') {
          if (vm.user.userGroup == 1) {
            if ((vm.user.idAgente === row.idAgente) || (vm.user.idAgente === row.lastYearIDAgente)) {
              data = action;
            } else {
              data = '<a title="apri cliente" ng-click="datiClienti.readClienteAgente(' + row.id + ')">' + data + '</a>';
            }
          } else {
            data = action;
          }
        }

        return data;
      }

      function renderIndirizzo(data, type, row) {
        return row.indirizzo + (row.civico ? ','+row.civico : '');
      }

      function renderAgente(data, type, row) {
        return row.agenteCognome + ' ' + row.agenteNome;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.clienti.url,
          numRecords: dt.data().length,
          filter: vm.sdc
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config); // eslint-disable-line angular/controller-as-vm
      }
    }

    function dtClientiReload(event, cliente) {
      if (! _.isEmpty(vm.dtClienti.dtInstance)) {
        search();
      }

      if (event.name === 'Cliente.created') {
        vm.readCliente(cliente.id);
      }
    }

    function dtDatiClienti(datiClienti) {
      if (_.isEmpty(vm.dtDatiClienti.dtInstance)) {
        vm.dtDatiClienti.dtInstance = {};

        vm.dtDatiClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(datiClienti.$promise)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>>tr<"row"<"col-xs-5"i><"col-xs-7"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'Dati Clienti',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('order', [0, 'asc'])
          .withOption('pageLength', 25)
          .withOption('createdRow', createdRow)
        );

        vm.dtDatiClienti.dtColumns = [
          {
            data: 'obsoleto',
            title: '<span title="Obsoleto">Obs.</span>',
            render: dtFactory.renders.boolean
          },
          {
            data: 'cliente',
            title: 'Cliente',
            render: renderCliente
          },
          {data: 'fornitore', title: 'Fornitore'},
          {data: 'pista', title: 'Pista'},
          {
            data: 'modello',
            title: 'Modello',
            render: renderModello
          },
          {data: 'competitor', title: 'Competitor'},
          {data: 'quantita', title: 'Quantità'},
          {
            data: 'valore',
            title: 'Valore',
            render: dtFactory.renders.currency
          },
          {
            data: 'noleggio',
            title: '<span title="Noleggio">Nol.</span>',
            render: dtFactory.renders.boolean
          },
          {
            data: 'dataInizio',
            title: 'Inizio',
            render: dtFactory.renders.date
          },
          {
            data: 'dataFine',
            title: 'Fine',
            render: dtFactory.renders.date
          },
          {
            data: 'assistenza',
            title: '<span title="Assistenza">Ass.</span>',
            render: dtFactory.renders.boolean
          },
          {
            data: 'valoreAssistenza',
            title: '<span title="Valore Assistenza">Valore Ass.</span>',
            render: dtFactory.renders.currency
          },
          {data: 'utenteIntervista', title: 'Utente'},
          {
            data: 'dataOraInt',
            title: 'Data Inserimento',
            render: dtFactory.renders.datetime
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dtDatiClienti.dtInstance.changeData(datiClienti.$promise);
      }

      vm.dtClienti.show = false;
      vm.dtDatiClienti.show = true;

      //////////////////////////////////////////////////////////////////////////
      function createdRow(row, data) {
        /* gestione dello stile di ogni riga */
        if (data.obsoleto) {
          angular.element(row).addClass('text-muted');
        }
      }

      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="datiClienti.readCliente(' + row.idCliente + ')">' + data + '</a>';
        }

        return data;
      }

      function renderModello(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri intervista" ng-click="datiClienti.readDatoCliente(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="datiClienti.updateDatoCliente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Elimina" ng-click="datiClienti.deleteDatoCliente(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (vm.user.userGroup <= 8) {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.clienti.url,
          numRecords: dt.data().length,
          filter: vm.sdc
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }
    }

    function dtDatiClientiReload() {
      if (!_.isEmpty(vm.dtDatiClienti.dtInstance)) {
        search();
      }
    }

    function isFilterActive() {
      return [
        vm.sdc.id,
        vm.sdc.ragSoc,
        vm.sdc.cf,
        vm.sdc.numtel,

        vm.sdc.citta,
        vm.sdc.idZona,
        vm.sdc.prov,
        vm.sdc.indirizzo,
        (vm.sdc.idAgente === '0' ? '' : vm.sdc.idAgente),

        vm.sdc.idPtf,
        vm.sdc.idPtfMob,
        vm.sdc.idPtfSa,
        vm.sdc.idPtf4,

        vm.sdc.innovatore,
        vm.sdc.potenziale,
        vm.sdc.relazione,

        vm.sdc.idSettore,
        vm.sdc.idClasseFatturato,

        vm.sdc.collaboratoriTot,
        vm.sdc.collaboratoriMob
      ].reduce(function (acc, curVal) {
        return acc + Number(
          angular.isDefined(curVal)
          && curVal !== null
          && curVal !== ''
        );
      }, 0);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ClientiController', ClientiController);

  function ClientiController($q, $rootScope, $scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.alerts = {};
    vm.sc = {
      mc: 0,
      idAgente: '0',
      fornitore: '',
      pista: '',
      opQuantita: '=',
      opValore: '=',
      opValoreAssistenza: '=',
      tipoSede: 'principale'
    };
    vm.dtClienti = {
      show: false
    };
    vm.showAdvancedSearch = false;
    vm.searchType = 'search';
    vm.search = search;
    vm.luckySearch = luckySearch;
    vm.resetForm = resetForm;

    vm.createCliente = api.clienti.actions.create;
    vm.readCliente = api.clienti.actions.read;
    vm.readClienteAgente = function (idCliente) {
      $rootScope.$broadcast('readClienteAgente', idCliente);
    };
    vm.updateCliente = api.clienti.actions.update;
    vm.deleteCliente = api.clienti.actions.delete;
    vm.deleteClienti = function (filtro) {
      $rootScope.$broadcast('deleteClienti', filtro);
    };

    //carica i dati della form
    api.clienti.searchForm()
      .then(function (formData) {
        vm.formData = formData;
      });

    //reagisci ai cambiamenti sui clienti
    $scope.$on('Cliente.created', dtClientiReload);
    $scope.$on('Cliente.updated', dtClientiReload);
    $scope.$on('Cliente.deleted', dtClientiReload);
    $scope.$on('Clienti.deleted', dtClientiReload);

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      vm.searchType = 'search';

      vm.alerts = {};

      //EASTER EGG
      if (vm.sc.ragSoc === 'soft kitty') {
        $rootScope.$broadcast('Easter.egg');
      }

      api.clienti.list(vm.sc)
        .then(dtClienti, setAlerts);
    }

    function luckySearch() {
      vm.searchType = 'luckySearch';

      vm.alerts = {};

      api.clienti.list({
        idZona: vm.sc.idZona,
        msf: '',
        mc: 0 //ATTENZIONE: non togliere questo perchè il server se lo aspetta sempre
      }).then(dtClienti, setAlerts);
    }

    function setAlerts(response) {
      vm.dtClienti.show = false;

      vm.alerts = {
        status: response.status,
        messages: response.data.warnings
      };
    }

    function resetForm() {
      vm.dtClienti.show = false;
      vm.dtDatiClienti.show = false;

      vm.alerts = {};

      vm.sc = {
        mc: 0,
        idAgente: '0',

        fornitore: '',
        pista: '',
        opQuantita: '=',
        opValore: '=',
        opValoreAssistenza: '='
      };
    }

    function dtClienti(clienti) {
      if (_.isEmpty(vm.dtClienti.dtInstance)) {
        vm.dtClienti.dtInstance = {};

        vm.dtClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(clienti.$promise)
          .withOption('order', [[7, 'asc'],[1, 'asc']] )
          .withOption('pageLength', 25)
          .withOption('createdRow', createdRow)
        );

        if (vm.user.userGroup >= 4) {
          var buttons = [];

          buttons.push({
            extend: 'excelHtml5',
            action: logExport,
            text: 'Esporta',
            className: 'btn-info btn-sm',
            filename: 'Clienti',
            exportOptions: {
              orthogonal: 'filter'
            }
          });

          if (vm.user.userGroup == 8) {
            buttons.push({
              text: 'Cancella',
              className: 'btn-danger btn-sm',
              action: cancellaClienti
            });
          }

          vm.dtClienti.dtOptions
            .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
            .withButtons(buttons)
          ;
        }

        vm.dtClienti.dtColumns = [
          {
            data: 'id',
            title: 'ID',
            type: 'num',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag. Soc.',
            'class': '',
            render: renderCliente
          },
          {
            data: 'cf',
            title: 'C.F.'
          },
          {
            data: 'partitaIva',
            title: 'Partita IVA'
          },
          {
            data: 'citta',
            title: 'Città'
          },
          {
            data: 'prov',
            title: 'Prov.'
          },
          {
            data: 'indirizzo',
            title: 'Indirizzo',
            'class': '',
            render: renderIndirizzo
          },
          {
            data: 'ptf',
            title: 'Cluster'
          },
          {
            data: 'ptfMob',
            title: 'Cross'
          },
          {
            data: 'ptfSa',
            title: 'Segmento'
          },
          {
            data: 'agenteCognome',
            title: 'Agente',
            render: renderAgente
          },
          {
            data: 'tel',
            title: 'Tel'
          },
          {
            data: 'email',
            title: 'Email',
            visible: false
          },
          {
            data: 'id',
            render: renderActions,
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dtClienti.dtInstance.changeData(clienti.$promise);
      }

      vm.dtClienti.show = true;

      //////////////////////////////////////////////////////////////////////////
      function createdRow(row, data) {
        /* gestione dello stile di ogni riga */
        if (data.privacy) {
          angular.element(row).addClass('text-danger');
        }
      }

      function cancellaClienti() {
        vm.deleteClienti(vm.sc);
      }

      function renderCliente(data, type, row) {
        var action = '<a title="apri cliente" ng-click="clienti.readCliente(' + row.id + ')">' + data + '</a>';

        if (type === 'display') {
          if (vm.user.userGroup == 1) {
            if ((vm.user.idAgente === row.idAgente) || (vm.user.idAgente === row.lastYearIDAgente)) {
              data = action;
            } else {
              data = '<a title="apri cliente" ng-click="clienti.readClienteAgente(' + row.id + ')">' + data + '</a>';
            }
          } else {
            data = action;
          }
        }

        return data;
      }

      function renderIndirizzo(data, type, row) {
        return row.indirizzo + (row.civico ? ','+row.civico : '');
      }

      function renderAgente(data, type, row) {
        return row.agenteCognome + ' ' + row.agenteNome;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="clienti.updateCliente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="clienti.deleteCliente(' + data + ')"><i class="fa fa-minus"></i></button>';

        switch (vm.user.userGroup) {
          case 1:
            if ((vm.user.idAgente === row.idAgente) || (vm.user.idAgente === row.lastYearIDAgente)) {
              actions = upd;
            }
            break;

          case 3:
          case 4:
            actions = upd;
            break;

          case 5:
          case 6:
          case 7:
          case 8:
            actions = upd + '&nbsp;' + del;
            break;
        }

        return actions;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.clienti.url,
          numRecords: dt.data().length,
          filter: angular.extend({
            searchType: vm.searchType
          }, vm.sc)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config); // eslint-disable-line angular/controller-as-vm
      }
    }

    function dtClientiReload(event, cliente) {
      if (! _.isEmpty(vm.dtClienti.dtInstance)) {
        if (vm.searchType === 'search') {
          search();
        } else if (vm.searchType === 'luckySearch') {
          luckySearch();
        }
      }

      if (event.name === 'Cliente.created') {
        vm.readCliente(cliente.id);
      }
    }

    vm.getComuni = function ( val ) {
      return api.clienti.editForm( { citta: val } ).then( function ( formData ) {
        vm.formData = formData;
        return formData.citta;
      } );
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ClienteViewController', ClienteViewController);

  function ClienteViewController($timeout, $routeParams, AuthenticateJS, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.readCliente = api.clienti.actions.read;
    vm.idCliente = $routeParams.id;

    $timeout(function() {
      vm.readCliente(vm.idCliente);
    }, 1000);
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ClienteEditController', ClienteEditController);

  function ClienteEditController($rootScope, $scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var clienteEditModal = $modal({
      scope: $scope,
      templateUrl: 'cliente-edit-modal.tpl.html',
      backdrop: false,
      show: false,
      onShow: function () {
        $rootScope.$broadcast('rzSliderForceRender'); //Force refresh sliders on render. Otherwise bullets are aligned at left side.
      }
    });
    vm.action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.cliente = {};
    vm.formData = {};
    vm.alerts = [];
    vm.sliderPercentuale = {
      floor: 0,
      ceil: 1,
      step: 0.10,
      precision: 2,
      showTicks: true,
      showSelectionBar: true,
      translate: function (value) {
        return (value * 100) + '%';
      },
      getSelectionBarColor: function(value) {
        if (value <= 0.25)
          return 'red';
        if (value <= 0.50)
          return 'orange';
        if (value <= 0.75)
          return 'yellow';
        return 'green';
      }
    };
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    vm.onchangeOrariApertura = function () {
      vm.cliente.sede.dataOraAggiornamentoOrariApertura = moment();
      vm.cliente.sede.dataOraAggiornamentoOrariAperturaFormatted = moment().format( 'DD/MM/YYYY' );
    }

    vm.readCliente = api.clienti.actions.read;

    $scope.$on('createCliente', createCliente);
    $scope.$on('updateCliente', updateCliente);

    ////////////////////////////////////////////////////////////////////////////
    function createCliente() {
      vm.action = 'create';
      vm.cliente = {
        innovatore: 0.5,
        potenziale: 0,
        relazione: 0,
        idSituazione: '1'
      };
      vm.alerts = [];

      api.clienti.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        clienteEditModal.$promise
          .then(clienteEditModal.show);
      }
    }

    function updateCliente(event, idCliente) {
      vm.action = 'update';
      vm.alerts = [];

      api.clienti.editForm()
        .then(getCliente);

      function getCliente(formData) {
        vm.formData = formData;

        api.cliente(idCliente).get()
          .then(showModal);

        function showModal(cliente) {
          vm.cliente = cliente;
          clienteEditModal.$promise
            .then(clienteEditModal.show);
        }
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if (vm.action === 'create') {
        api.clienti.save(vm.cliente)
          .then(clienteEditModal.hide, setAlerts);
      } else if (vm.action === 'update') {
        api.cliente(vm.cliente.id).update(vm.cliente)
          .then(clienteEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: _.filter(response.data.warnings, function(element) {
            return !(_.includes(['unique_tel', 'unique_cf'], element.code));
          })
        };

        angular.forEach(response.data.warnings, function(value) {
          if (_.includes(['unique_tel', 'unique_cf'], value.code)) {
            var splitted = value.text.split('~');

            vm.alerts[value.code] = {
              text: splitted[0],
              code: value.code,
              id: splitted[1]
            }
          }
        });
      }
    }

    function undoForm() {
      clienteEditModal.hide();
    }

  }

})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ClienteController', ClienteController);

  function ClienteController($rootScope, $scope, $filter, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    var clienteModal = $modal({
      scope: $scope,
      templateUrl: 'cliente-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.pageLength = 6;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = generaAzioni();

    vm.cliente = {};
    vm.urlParser = api.functions.urlParser;
    vm.calcolaInnovatore = calcolaInnovatore;
    vm.updateCliente = api.clienti.actions.update;
    vm.presentazioneCliente = api.clienti.actions.inviaPresentazione;

    vm.dtAppuntamenti = {};
    vm.createAppuntamento = function (cliente) {
      $rootScope.$broadcast('createAppuntamentoCliente', cliente);
    };
    vm.createAppuntamentoAgente = function (cliente) {
      $rootScope.$broadcast('createAppuntamentoClienteAgente', cliente);
    };
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.updateAppuntamento = api.appuntamenti.actions.update;
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;
    vm.esitaAppuntamento = api.appuntamenti.actions.esita;

    vm.dtTelefonate = {};
    vm.createTelefonata = function (cliente) {
      $rootScope.$broadcast('createTelefonataCliente', cliente);
    };
    vm.readTelefonata = api.telefonate.actions.read;
    vm.updateTelefonata = api.telefonate.actions.update;
    vm.deleteTelefonata = api.telefonate.actions.delete;

    vm.dtReferenti = {};
    vm.createReferente = api.cliente().referenti.actions.create;
    vm.readReferente = api.referenti.actions.read;
    vm.updateReferente = api.referenti.actions.update;
    vm.deleteReferente = api.referenti.actions.delete;

    vm.dtSedi = {};
    vm.createSede = api.cliente().sedi.actions.create;
    vm.readSede = api.sedi.actions.read;
    vm.updateSede = api.sedi.actions.update;
    vm.deleteSede = api.sedi.actions.delete;

    vm.contrattiTotaliValidi = 0;
    vm.contrattiTotaliInScadenza = 0;
    vm.contrattiTotaliScaduti = 0;
    vm.contrattiTotaliObsoleti = 0;
    vm.dtContratti = {};
    vm.contratti = [];
    vm.pisteClyco = {
      attiva: 'X',
      piste: [
        'X'
      ]
    };
    vm.filterPistaContratti = filterPistaContratti;
    vm.createContratto = function (cliente) {
      $rootScope.$broadcast('createContrattoCliente', cliente); //TODO: fare la form create contratto
    };
    vm.readContratto = api.contratti.actions.read;
    vm.updateContratto = api.contratti.actions.update;
    vm.deleteContratto = api.contratti.actions.delete;

    vm.dtElenchi = {};
    vm.createElenco = function (cliente) {
      $rootScope.$broadcast('createElencoCliente', cliente);
    };
    vm.readTelefonateElenco = function (idElenco) {
      $rootScope.$broadcast('readTelefonateElenco', idElenco);
    };
    vm.updateElenco = api.elenchi.actions.update;
    vm.deleteElenco = api.elenchi.actions.delete;

    vm.dtDatiClienti = {};
    vm.readDatoCliente = api.clienti.dati.actions.read;
    vm.createDatoCliente = api.cliente().dati.actions.create;
    vm.updateDatoCliente = api.clienti.dati.actions.update;
    vm.deleteDatoCliente = api.clienti.dati.actions.delete;

    vm.dtOpportunita = {};
    vm.opportunita = [];
    vm.titleOpportunita = 'Opportunità';
    vm.checkEditPermission = api.opportunita().actions.checkEditPermission;
    vm.readOpportunita = api.opportunita().actions.read;
    vm.createOpportunita = function (cliente) {
      $rootScope.$broadcast('createOpportunitaCliente', cliente);
    };
    vm.createOpportunitaSegnalatore = function (cliente) {
      $rootScope.$broadcast('createOpportunitaClienteSegnalatore', cliente);
    };
    vm.updateOpportunita = api.opportunita().actions.update;
    vm.updateOpportunitaSegnalatore = function (idOpportunita) {
      $rootScope.$broadcast('updateOpportunitaSegnalatore', idOpportunita);
    };
    vm.deleteOpportunita = api.opportunita().actions.delete;
    vm.listAttivitaOpportunita = function(idOpportunita) {
      $rootScope.$broadcast('listAttivitaOpportunita', idOpportunita);
    };
    vm.readProgetto = api.opportunita().progetti().actions.read;

    vm.dtPv = {};
    vm.pv = [];
    vm.titlePv = 'Postvendita';
    vm.readPv = api.pv().actions.read;
    vm.createPv = function ( cliente ) {
      $rootScope.$broadcast( 'createPvCliente', cliente );
    };
    vm.updatePv = api.pv().actions.update;
    vm.deletePv = api.pv().actions.delete;
    vm.readAttivitaPv = api.pv().actions.readAttivitaPv;

    vm.dtAllegati = {};
    vm.allegati = [];
    vm.titleAllegati = 'Allegati';
    vm.readAllegato = api.pv().actions.read;
    vm.createAllegato = function (cliente) {
      cliente.idCliente = cliente.id; // per uniformità
      $rootScope.$broadcast('createAllegato', cliente);
    };
    vm.updateAllegato = api.allegati.actions.update;
    vm.deleteAllegato = api.allegati.actions.delete;

    //gestione cliente
    $scope.$on('readCliente', readCliente);
    $scope.$on('Cliente.updated', clienteReload);

    //gestione appuntamenti
    $scope.$on('Appuntamento.created', dtAppuntamentiReload);
    $scope.$on('Appuntamento.updated', dtAppuntamentiReload);
    $scope.$on('Appuntamento.deleted', dtAppuntamentiReload);

    //gestione telefonate
    $scope.$on('Telefonata.created', dtTelefonateReload);
    $scope.$on('Telefonata.updated', dtTelefonateReload);
    $scope.$on('Telefonata.deleted', dtTelefonateReload);

    //gestione referenti
    $scope.$on('Referente.created', dtReferentiReload);
    $scope.$on('Referente.updated', dtReferentiReload);
    $scope.$on('Referente.deleted', dtReferentiReload);

    //gestione sedi
    $scope.$on( 'Sede.created', dtSediReload );
    $scope.$on( 'Sede.updated', dtSediReload );
    $scope.$on( 'Sede.deleted', dtSediReload );

    //gestione contratti
    $scope.$on('Contratto.created', dtContrattiReload);
    $scope.$on('Contratto.updated', dtContrattiReload);
    $scope.$on('Contratto.deleted', dtContrattiReload);

    //gestione elenchi
    $scope.$on('Elenco.created', dtElenchiReload);
    $scope.$on('Elenco.updated', dtElenchiReload);
    $scope.$on('Elenco.deleted', dtElenchiReload);

    //gestione intervista
    $scope.$on('DatoCliente.created', dtDatiClientiReload);
    $scope.$on('DatoCliente.updated', dtDatiClientiReload);
    $scope.$on('DatoCliente.deleted', dtDatiClientiReload);

    //gestione opportunità
    $scope.$watchCollection('cliente.opportunita', setTitleOpportunita);
    $scope.$on('Opportunita.created', dtOpportunitaReload);
    $scope.$on('Opportunita.updated', dtOpportunitaReload);
    $scope.$on('Opportunita.deleted', dtOpportunitaReload);

    //gestione pv
    $scope.$watchCollection('cliente.pv', setTitlePv);
    $scope.$on('Pv.created', dtPvReload);
    $scope.$on('Pv.updated', dtPvReload);
    $scope.$on('Pv.deleted', dtPvReload);

    //gestione allegati
    $scope.$on('Allegato.created', dtAllegatiReload);
    $scope.$on('Allegato.updated', dtAllegatiReload);
    $scope.$on('Allegato.deleted', dtAllegatiReload);

    ////////////////////////////////////////////////////////////////////////////
    //gestione azioni
    function generaAzioni() {
      var actions = [];
      var availableActions = {
        updateCliente: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'cliente.updateCliente(cliente.cliente.id);'
        },
        presentazioneCliente: {
          text: '<i class="fa fa-mail-forward fa-fw"></i>&nbsp;Invia Presentazione',
          click: 'cliente.presentazioneCliente(cliente.cliente.id, {indirizzo: cliente.cliente.email, oggetto: \'Presentazione \' + cliente.cliente.ragSoc});'
        },
        createAppuntamento: {
          text: '<i class="fa fa-clock-o fa-fw"></i>&nbsp;Nuovo Appuntamento',
          click: 'cliente.createAppuntamento(cliente.cliente);'
        },
        createAppuntamentoAgente: {
          text: '<i class="fa fa-clock-o fa-fw"></i>&nbsp;Nuovo Appuntamento',
          click: 'cliente.createAppuntamentoAgente(cliente.cliente);'
        },
        createTelefonata: {
          text: '<i class="fa fa-phone fa-fw"></i>&nbsp;Nuova Telefonata',
          click: 'cliente.createTelefonata(cliente.cliente);'
        },
        createOpportunita: {
          text: '<i class="fa fa-usd fa-fw"></i>&nbsp;Nuova Opportunità',
          click: 'cliente.createOpportunita(cliente.cliente);'
        },
        createOpportunitaSegnalatore: {
          text: '<i class="fa fa-usd fa-fw"></i>&nbsp;Segnalazione Clyco',
          click: 'cliente.createOpportunitaSegnalatore(cliente.cliente);'
        },
        createPv: {
          text: '<i class="fa fa-support fa-fw"></i>&nbsp;Nuovo Postvendita',
          click: 'cliente.createPv(cliente.cliente);'
        },
        createElenco: {
          text: '<i class="fa fa-tasks fa-fw"></i>&nbsp;Inserisci in campagna',
          click: 'cliente.createElenco(cliente.cliente);'
        }
      };
      switch ( vm.user.userGroup ) {
        case 1:
          actions.push(availableActions.updateCliente);
          actions.push(availableActions.createAppuntamentoAgente);
          actions.push(availableActions.createTelefonata);
          if (vm.user.flags.powerUser) {
            actions.push(availableActions.createElenco);
          }
          if (vm.user.flags.gestOppo) {
            actions.push(availableActions.createOpportunita);
          }
          actions.push(availableActions.presentazioneCliente);
        break;

        case 2:
        case 3:
        case 4:
          actions.push(availableActions.updateCliente);
          actions.push(availableActions.createTelefonata);
          if (vm.user.flags.powerUser) {
            actions.push(availableActions.createElenco);
          }
          actions.push(availableActions.presentazioneCliente);
        break;

        case 5:
        case 6:
        case 7:
        case 8:
          actions.push(availableActions.updateCliente);
          actions.push(availableActions.createAppuntamento);
          actions.push(availableActions.createTelefonata);
          actions.push(availableActions.createElenco);
          actions.push(availableActions.createOpportunita);
          if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
            actions.push(availableActions.createPv);
          }
          actions.push(availableActions.presentazioneCliente);
        break;
      }

      return actions;
    }

    //gestione cliente
    function readCliente(event, idCliente) {
      api.cliente(idCliente).get()
        .then(showModal);

      dtAppuntamenti(idCliente);
      dtTelefonate(idCliente);
      dtReferenti(idCliente);
      dtSedi(idCliente);
      dtContratti(idCliente);
      dtElenchi(idCliente);
      dtDatiClienti(idCliente);
      dtOpportunita(idCliente);
      dtPv(idCliente);
      dtAllegati(idCliente);

      function showModal(cliente) {
        vm.cliente = cliente;
        vm.showElencoReferenti = false;
        vm.showElencoSedi = false;
        clienteModal.$promise
          .then(clienteModal.show);
      }
    }

    function clienteReload(event, cliente) {
      if (cliente.id === vm.cliente.id) {
        vm.cliente = cliente;
        api.cliente( vm.cliente.id ).sedi.list().then( function ( sedi ) {
          vm.cliente.sedi = sedi;
        } );
        api.cliente( vm.cliente.id ).referenti.list().then( function ( referenti ) {
          vm.cliente.referenti = referenti;
        } );
      }
    }

    function calcolaInnovatore(valore) {
      var percentuale = valore * 100;
      var testo = '';

      if (percentuale <= 30.00) {
        testo = 'Conservatore'
      } else if (percentuale >= 30.01 && percentuale <= 70.00) {
        testo = 'Neutro'
      } else {
        testo = 'Innovatore'
      }

      return testo + ' (' + percentuale + '%)';
    }

    //gestione appuntamenti
    function dtAppuntamenti(idCliente) {
      vm.dtAppuntamenti.dtInstance = {};

      vm.dtAppuntamenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.cliente(idCliente).appuntamenti.list();
        })
        .withOption('order', [
          [0, 'desc'],
          [1, 'asc']
        ])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', true)
        .withOption('pageLength', vm.pageLength)
      );

      vm.dtAppuntamenti.dtColumns = [
        {
          data: 'data',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {
          data: 'ora',
          title: 'Ora',
          render: dtFactory.renders.time
        },
        {
          data: 'agenti_agente',
          title: 'Agente'
        },
        {
          data: 'stati_appuntamento_descrizione',
          title: 'Stato',
          render: renderAppuntamento
        },
        {
          data: 'operatori_operatore',
          title: 'Operatore'
        },
        {
          data: 'noteOperatore',
          title: 'Note Operatore',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'noteAgente',
          title: 'Note Agente',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];


      //////////////////////////////////////////////////////////////////////////
      function renderAppuntamento(data, type, row) {
        if (type === 'display') {
          return '<a title="apri appuntamento" ng-click="cliente.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateAppuntamento(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteAppuntamento(' + data + ')"><i class="fa fa-minus"></i></button>';
        var esita = '<button type="button" class="btn btn-warning btn-xs" title="Esita" ng-click="cliente.esitaAppuntamento(' + data + ')"><i class="fa fa-check-square-o"></i></button>';

        switch (vm.user.userGroup) {
          case 1:
            if (vm.user.idAgente === row.idAgente) {
              actions = esita;
            }
          break;

          case 3:
          case 4:
            actions = esita;
          break;

          case 2:
          case 5:
          case 6:
          case 7:
          case 8:
            actions = upd + '&nbsp;' + del;
          break;
        }

        return actions;
      }

    }

    function dtAppuntamentiReload(event, appuntamento) {
      switch (event.name) {
        case 'Appuntamento.deleted':
          if (!_.isEmpty(vm.dtAppuntamenti.dtInstance)) {
            vm.dtAppuntamenti.dtInstance.reloadData();
          }
          if (!_.isEmpty(vm.dtContratti.dtInstance)) {
            vm.dtContratti.dtInstance.reloadData();
          }
          break;

        case 'Appuntamento.updated':
          if (appuntamento.idCliente === vm.cliente.id) {

            if (!_.isEmpty(vm.dtAppuntamenti.dtInstance)) {
              vm.dtAppuntamenti.dtInstance.reloadData();
            }
            if (!_.isEmpty(vm.dtContratti.dtInstance)) {
              vm.dtContratti.dtInstance.reloadData();
            }
          }
          break;

        case 'Appuntamento.created':
        default:
          if (!_.isEmpty(vm.dtAppuntamenti.dtInstance)) {
            vm.dtAppuntamenti.dtInstance.reloadData();
          }
          break;
      }
    }

    //gestione telefonate
    function dtTelefonate(idCliente) {
      vm.dtTelefonate.dtInstance = {};

      vm.dtTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.cliente(idCliente).telefonate.list();
        })
        .withOption('order', [0, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', true)
        .withOption('pageLength', vm.pageLength)
      );

      vm.dtTelefonate.dtColumns = [
        {
          data: 'dataOra',
          title: 'Data',
          render: renderTelefonata
        },
        {
          data: 'operatore',
          title: 'Operatore'
        },
        {
          data: 'esito',
          title: 'Esito',
          render: renderEsito
        },
        {
          data: 'note',
          title: 'Note',
          'class': ''
        },
        {
          data: 'motivi_descrizione',
          title: 'Lista'
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];


      //////////////////////////////////////////////////////////////////////////
      function renderTelefonata(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.datetime(data, type);

          return '<a title="apri telefonata" ng-click="cliente.readTelefonata(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;

      }

      function renderEsito(data, type, row) {
        if (type === 'display') {
          if (row.idAppuntamento !== '') {
            return data + '&nbsp;' + '<i class="fa fa-external-link" title="apri appuntamento" ng-click="cliente.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
          }
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateTelefonata(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteTelefonata(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (vm.user.userGroup >= 5) {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }

    }

    function dtTelefonateReload(event, telefonata) {
      if (event.name === 'Telefonata.deleted') {
        vm.dtTelefonate.dtInstance.reloadData();
      } else {
        if (telefonata.idCliente === vm.cliente.id) {
          vm.dtTelefonate.dtInstance.reloadData();
        }
      }
    }

    // gestione referenti
    function dtReferenti( idCliente ) {
      vm.dtReferenti.dtInstance = {};
      vm.dtReferenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.cliente( idCliente ).referenti.list();
          promise.then( function( referenti ) {
            vm.cliente.referenti = referenti;
          } );
          return promise;
        } )
        .withOption('order', [
          [5, 'desc'],
          [0, 'asc']
        ])
        .withOption('searching', false)
        .withOption('paging', false)
        .withOption('createdRow', createdRow)
      );

      vm.dtReferenti.dtColumns = [
        {
          data: 'nominativo',
          title: 'Nominativo'
        },
        {
          data: 'email',
          title: 'Email',
          render: dtFactory.renders.email
        },
        {
          data: 'tel',
          title: 'Telefono',
          render: dtFactory.renders.phone
        },
        {
          data: 'cell',
          title: 'Cellulare',
          render: dtFactory.renders.mobile
        },
        {
          data: 'tipoReferente',
          title: 'Tipo'
        },
        {
          data: 'referentePrincipale',
          title: '<i class="fa fa-star" bs-tooltip data-title="Referente principale"></i>',
          render: renderReferentePrincipale
        },
        {
          data: 'note',
          title: 'Note',
          render: renderNote
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="cliente.createReferente(cliente.cliente)"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      function createdRow( row, data ) {
        if (data.inattivo) {
          angular.element( row ).addClass( 'line-through' );
        }
        if (data.referentePrincipale) {
          angular.element( row ).addClass( 'bold' );
        }
      }

      function renderActions( data, type, row ) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateReferente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del;
        if ( row.referentePrincipale ) {
          del = '<button type="button" class="btn btn-danger btn-xs" disabled bs-tooltip data-title="La cancellazione di un referente principale non è consentita"><i class="fa fa-minus"></i></button>';
        } else {
          del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteReferente(' + data + ')"><i class="fa fa-minus"></i></button>';
        }
        return upd + '&nbsp;' + del;
      }

      function renderReferentePrincipale( data ) {
        return data ? '<i class="fa fa-star" bs-tooltip data-title="Referente principale"></i>' : '';
      }

      function renderNote( data ) {
        if ( data != '' ) {
          return '<i class="fa fa-sticky-note" bs-tooltip data-title="' + data.replace( '"', '\\"' ) + '"></i>';
        }
      }

    }

    function dtReferentiReload(event, referente) {
      if (event.name === 'Referente.deleted') {
        vm.dtReferenti.dtInstance.reloadData();
      } else {
        if (referente.idCliente === vm.cliente.id) {
          vm.dtReferenti.dtInstance.reloadData();
        }
      }
      if ( referente.referentePrincipale ) {
        vm.cliente.referenti[0] = angular.copy(referente);
      }
    }

    // gestione sedi
    function dtSedi( idCliente ) {
      vm.dtSedi.dtInstance = {};
      vm.dtSedi.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function () {
          var promise = api.cliente( idCliente ).sedi.list();
          promise.then( function( sedi ) {
            vm.cliente.sedi = sedi;
          } );
          return promise;
        } )
        .withOption('order', [
          [1, 'desc'],
          [0, 'asc']
        ])
        .withOption('searching', false)
        .withOption('paging', false)
        .withOption('createdRow', createdRow)
      );

      vm.dtSedi.dtColumns = [
        {
          data: 'nome',
          title: 'Nome'
        },
        {
          data: 'sedePrincipale',
          title: '<i class="fa fa-star" bs-tooltip data-title="Sede principale"></i>',
          render: renderSedePrincipale
        },
        {
          data: 'indirizzo',
          title: 'Indirizzo',
          render: renderIndirizzo
        },
        {
          data: 'telefono',
          title: 'Telefono',
          render: dtFactory.renders.phone
        },
        {
          data: 'orariApertura',
          title: 'Orari',
          render: dtFactory.renders.longtextNoTooltip,
          'class' : 'col-descrizione'
        },
        {
          data: 'dataOraAggiornamentoOrariApertura',
          title: '',
          render: renderModificaOrariApertura,
          'class' : 'col-date-time'
        },
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class' : 'col-descrizione'
        },
        {
          data: 'idSede',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="cliente.createSede(cliente.cliente)"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      function createdRow( row, data ) {
        if ( data.obsoleta ) {
          angular.element( row ).addClass( 'line-through' );
        }
      }

      function renderActions( data, type, row ) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateSede(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del;
        if ( row.sedePrincipale ) {
          del = '<button type="button" class="btn btn-danger btn-xs" disabled bs-tooltip data-title="La cancellazione di una sede principale non è consentita"><i class="fa fa-minus"></i></button>';
        } else {
          del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteSede(' + data + ')"><i class="fa fa-minus"></i></button>';
        }
        var actions = upd + '&nbsp;' + del;
        return actions;
      }

      function renderIndirizzo( data, type, row ) {
        var output = data;
        if ( row.numeroCivico != '' ) {
          output += ', ' + row.numeroCivico;
        }
        if ( row.cap != '' ) {
          output += ' - ' + row.cap;
        }
        if ( row.citta != '' ) {
          output += ' ' + row.citta;
        }
        if ( row.prov != '' ) {
          output += ' (' + row.prov + ')'
        }
        if ( row.indirizzo != '' && row.cap != '' && row.citta != '' ) {
          output +=
            '\
            <a title="Apri mappa" ng-href="http://maps.google.com/?q=' + encodeURIComponent(row.indirizzo + (row.numeroCivico ? ',' + row.numeroCivico : '') + ' ' + row.citta) + ' " target="_blank">\
              <i class="fa fa-map-o"></i>\
            </a>';
        }
        return output;
      }

      function renderSedePrincipale( data ) {
        return data ? '<i class="fa fa-star" bs-tooltip data-title="Sede principale"></i>' : '';
      }

      function renderModificaOrariApertura( data, type ) {
        if ( data != '' ) {
          return 'Modifica orari:<br>' + dtFactory.renders.datetime( data, type );
        }
      }

    }

    function dtSediReload( event, sede ) {
      if ( event.name === 'Sede.deleted' ) {
        vm.dtSedi.dtInstance.reloadData();
      } else {
        if ( sede.idCliente === vm.cliente.id ) {
          vm.dtSedi.dtInstance.reloadData();
        }
      }
      if ( sede.referentePrincipale ) {
        vm.cliente.sede[0] = angular.copy( sede );
      }
    }

    //gestione contratti
    function dtContratti(idCliente) {
      vm.dtContratti.dtInstance = {};

      vm.dtContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(getContratti(idCliente))
        .withOption('order', [
          [0, 'asc'],
          [12, 'desc']
        ])
        .withOption('lengthMenu', [6, 12, 18, 24])
        .withOption('pageLength', vm.pageLength)
        .withOption('createdRow', createdRow)
      );

      vm.dtContratti.dtColumns = [
        {
          data: 'obsoleto',
          visible: false
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          render: renderContratto
        },
        {
          data: 'sede',
          title: 'Sede'
        },
        {
          data: 'durataContratto',
          title: 'Durata',
          render: renderDurata
        },
        {
          data: 'agente',
          title: 'Agente'
        },
        {
          data: 'prezzoUnit',
          title: 'Prezzo',
          render: dtFactory.renders.currency
        },
        {
          data: 'qta',
          title: 'Qta'
        },
        {
          data: 'prezzo',
          title: 'Totale',
          render: dtFactory.renders.currency
        },
        {
          data: 'stato',
          title: 'Stato'
        },
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'gruppo',
          title: 'Gruppo'
        },
        {
          data: 'dataInserimento',
          title: 'Inserimento',
          render: dtFactory.renders.date
        },
        {
          data: 'dataConferma',
          title: 'Conferma',
          render: dtFactory.renders.date
        },
        {
          data: 'dataCrm',
          title: 'Attivazione', // TODO: Sosituito 'CRM' con 'Attivazione'
          render: dtFactory.renders.date
        },
        {
          data: 'dataFineContratto',
          title: 'Data fine contratto',
          render: renderDataFineContratto
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        },
        {
          data: 'dataFineContratto',
          visible: false
        }
      ];

      function renderDataFineContratto( data, type ) {
        var output = dtFactory.renders.date( data, type );
        if ( output != '31/12/99' ) { // non mostro la data "infinita"
          return output;
        }
      }

      vm.statoContratto = function ( contratto ) {
        var output = '';
        var dataFineContratto = parseInt( moment( contratto.dataFineContratto ).format( 'YYYYMMDD' ) );
        var oggi = parseInt( moment().format( 'YYYYMMDD' ) );
        var scadenza = parseInt( moment().add( 4, 'months' ).format( 'YYYYMMDD' ) );
        if ( contratto.obsoleto ) {
          output = 'obsoleto';
        } else if ( dataFineContratto < oggi ) {
          output = 'scaduto';
        } else if ( dataFineContratto <= scadenza ) {
          output = 'inScadenza'
        } else {
          output = 'valido';
        }
        return output;
      }

      //////////////////////////////////////////////////////////////////////////
      function getContratti(idCliente) {
        return function() {
          var promise = api.cliente(idCliente).contratti.list();

          promise.then(function(contratti) {
            vm.contratti = contratti;

            //ottieni piste clyco
            var pisteFiltrate = _.uniq(_.pluck(_.filter(contratti, filterPiste), 'pista'));
            vm.contrattiTotaliValidi = 0;
            vm.contrattiTotaliScaduti = 0;
            vm.contrattiTotaliInScadenza = 0;
            vm.contrattiTotaliObsoleti = 0;
            for ( var i = 0; i < pisteFiltrate.length; i++ ) {
              var pista = pisteFiltrate[i];
              var contrattiFiltrati = _.filter( contratti, function ( el ) {
                return el.pista == pista;
              } );
              contrattiFiltrati = _.countBy( contrattiFiltrati, function ( el ) {
                return vm.statoContratto( el );
              } );
              pisteFiltrate[i] = {
                label: pista,
                contrattiObsoleti: contrattiFiltrati.obsoleto ? contrattiFiltrati.obsoleto : 0,
                contrattiInScadenza: contrattiFiltrati.inScadenza ? contrattiFiltrati.inScadenza : 0,
                contrattiScaduti: contrattiFiltrati.scaduto ? contrattiFiltrati.scaduto : 0,
                contrattiValidi: contrattiFiltrati.valido ? contrattiFiltrati.valido : 0
              };
              if ( contrattiFiltrati.obsoleti ) {
                vm.contrattiTotaliObsoleti += contrattiFiltrati.obsoleto;
              }
              if ( contrattiFiltrati.scaduto ) {
                vm.contrattiTotaliScaduti += contrattiFiltrati.scaduto;
              }
              if ( contrattiFiltrati.inScadenza ) {
                vm.contrattiTotaliInScadenza += contrattiFiltrati.inScadenza;
              }
              if ( contrattiFiltrati.valido ) {
                vm.contrattiTotaliValidi += contrattiFiltrati.valido;
              }
            }
            if ( vm.contrattiTotaliInScadenza + vm.contrattiTotaliScaduti > 0 ) {
              pisteFiltrate = pisteFiltrate.concat( [ {
                label: 'IN SCADENZA / SCADUTI',
                contrattiValidi: 0
              } ] );
            }
            vm.pisteClyco.piste = pisteFiltrate.concat( [ {
              label: 'X',
              contrattiValidi: vm.contrattiTotaliValidi
            } ] );

            function filterPiste(element) {
              if (element.fornitore === 'CLYCO') {
                return !(_.includes([8, 11], element.idStato));
              }
              return false;
            }
          });

          return promise;
        };
      }

      function createdRow(row, data) {
        // stile riga: obsoleto -> rosso; scaduto: arancione
        if ( data.obsoleto ) {
          angular.element( row ).addClass( 'text-danger' );
        } else if ( moment( data.dataFineContratto ).endOf( 'day' ) < moment() ) {
          angular.element( row ).addClass( 'text-warning' );
        }
      }

      function renderContratto( data, type, row ) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="cliente.readContratto(\'' + row.id + '\')">' + data + '</a>' +
            '&nbsp;' +
            '<i class="fa fa-external-link" title="apri appuntamento" ng-click="cliente.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
        }

        return data;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function renderActions(data, type, row) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateContratto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteContratto(' + data + ')"><i class="fa fa-minus"></i></button>';
        var actions = upd + '&nbsp;' + del;

        if (vm.user.userGroup <= 4) {
          if (row.idStato !== 1) { //se stato contratto non è INSERITO
            actions = '';
          }
        }

        return actions;
      }
    }

    function dtContrattiReload(event, contratto) {
      if (event.name === 'Contratto.deleted') {
        vm.dtContratti.dtInstance.reloadData();
      } else {
        if (contratto.idCliente === vm.cliente.id) {
          vm.dtContratti.dtInstance.reloadData();
        }
      }
    }

    function filterPistaContratti(pista) {
      var searchTerm = '';

      vm.pisteClyco.attiva = pista;
      var indexColumn = 9;
      vm.activeTab = 1;
      vm.dtContratti.dtInstance.DataTable.column( indexColumn ).search( '' ).draw();
      if ( pista === 'IN SCADENZA / SCADUTI' ) {
        vm.activeTab = 1;
        searchTerm = function ( settings, data ) {
          var contratto = {
            obsoleto: data[0] == 'true',
            dataFineContratto: data[16]
          }
          var statoContratto = vm.statoContratto( contratto )
          return statoContratto == 'inScadenza' || statoContratto == 'scaduto';
        }
        $.fn.dataTable.ext.search.push(searchTerm);
        vm.dtContratti.dtInstance.DataTable.draw();
        $.fn.dataTable.ext.search.pop();
        return;
      } else if ( pista != 'X' ) {
        vm.dtContratti.dtInstance.DataTable.column( indexColumn ).search( pista ).draw();
      }
    }

    //gestione elenchi
    function dtElenchi(idCliente) {
      vm.dtElenchi.dtInstance = {};

      vm.dtElenchi.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.cliente(idCliente).elenchi.list();
        })
        .withOption('order', [
          [5, 'asc'],
          [1, 'desc'],
          [0, 'asc']
        ])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', true)
        .withOption('pageLength', vm.pageLength)
      );

      vm.dtElenchi.dtColumns = [
        {
          data: 'motivi_descrizione',
          title: 'Lista',
          render: renderLista,
          'class': ''
        },
        {
          data: 'dataApertura',
          title: 'Data Inizio',
          render: dtFactory.renders.date
        },
        {
          data: 'dataChiusura',
          title: 'Data Fine',
          render: dtFactory.renders.date
        },
        {
          data: 'operatore',
          title: 'Operatore'
        },
        {
          data: 'statoElenco',
          title: 'Stato'
        },
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];


      //////////////////////////////////////////////////////////////////////////
      function renderLista(data, type, row) {
        if (type === 'display') {
          return '<a title="apri telefonate della lista" ng-click="cliente.readTelefonateElenco(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateElenco(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteElenco(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (vm.user.userGroup >= 5) {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }

    }

    function dtElenchiReload(event, elenco) {
      if (event.name === 'Elenco.deleted') {
        vm.dtElenchi.dtInstance.reloadData();
      } else {
        if (elenco.idCliente === vm.cliente.id) {
          vm.dtElenchi.dtInstance.reloadData();
        }
      }
    }

    //gestione intervista
    function dtDatiClienti(idCliente) {
      vm.dtDatiClienti.dtInstance = {};

      vm.dtDatiClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.cliente(idCliente).dati.list)
        .withOption('order', [0, 'asc'])
        .withOption('createdRow', createdRow)
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtDatiClienti.dtColumns = [
        {
          data: 'obsoleto',
          visible: false
        },
        {data: 'fornitore', title: 'Fornitore'},
        {data: 'pista', title: 'Pista'},
        {
          data: 'modello',
          title: 'Modello',
          render: renderModello
        },
        {data: 'competitor', title: 'Competitor'},
        {data: 'quantita', title: 'Quantità'},
        {
          data: 'valore',
          title: 'Valore',
          render: dtFactory.renders.currency
        },
        {
          data: 'noleggio',
          title: 'Noleggio',
          render: dtFactory.renders.boolean
        },
        {
          data: 'dataInizio',
          title: 'Inizio',
          render: dtFactory.renders.date
        },
        {
          data: 'dataFine',
          title: 'Fine',
          render: dtFactory.renders.date
        },
        {
          data: 'assistenza',
          title: 'Assistenza',
          render: dtFactory.renders.boolean
        },
        {
          data: 'valoreAssistenza',
          title: '<span title="Valore Assistenza">Valore Ass.</span>',
          render: dtFactory.renders.currency
        },
        {data: 'utenteIntervista', title: 'Utente'},
        {
          data: 'dataOraInt',
          title: 'Data Inserimento',
          render: dtFactory.renders.datetime
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="cliente.createDatoCliente(cliente.cliente.id)"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function createdRow(row, data) {
        /* gestione dello stile di ogni riga */
        if (data.obsoleto) {
          angular.element(row).addClass('text-muted');
        }
      }

      function renderModello(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri intervista" ng-click="cliente.readDatoCliente(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica intervista" ng-click="cliente.updateDatoCliente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Elimina intervista" ng-click="cliente.deleteDatoCliente(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function dtDatiClientiReload(event, datoCliente) {
      if (event.name === 'DatoCliente.deleted') {
        vm.dtDatiClienti.dtInstance.reloadData();
      } else {
        if (datoCliente.idCliente === vm.cliente.id) {
          vm.dtDatiClienti.dtInstance.reloadData();
        }
      }
    }

    //gestione opportunità
    function dtOpportunita(idCliente) {
      vm.dtOpportunita.dtInstance = {};

      vm.dtOpportunita.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(getOpportunita(idCliente, {
          last: ''
        }))
        .withOption('order', [0, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', true)
        .withOption('pageLength', vm.pageLength)
      );

      vm.dtOpportunita.dtColumns = [
        {
          data: 'dataSegnalazione',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {
          data: 'stato',
          title: 'Stato',
          render: renderOpportunita
        },
        {
          data: 'agentePIC',
          title: 'Agente'
        },
        {
          data: 'fornitore',
          title: 'Fornitore'
        },
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'valore',
          title: 'Valore',
          render: dtFactory.renders.currency
        },
        {
          data: 'percChiusura',
          title: 'Probabilità',
          render: dtFactory.renders.percent()
        },
        {
          data: 'dataChiusura',
          title: '<span title="Data Prevista Chiusura">Prev. Chiusura</span>',
          render: dtFactory.renders.date
        },
        {
          data: 'stage',
          title: 'Fase'
        },
        {
          data: 'idProgetto',
          title: 'Progetto',
          render: renderProgetto
        },
        {
          data: 'fonte',
          title: 'Fonte'
        },
        {
          data: 'segnalatore',
          title: 'Segnalatore'
        },
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];


      //////////////////////////////////////////////////////////////////////////
      function getOpportunita(idCliente, params) {
        return function() {
          var promise = api.cliente(idCliente).opportunita.list(params);

          promise.then(function(opportunita) {
            vm.opportunita = opportunita;
          });

          return promise;
        };
      }

      function renderOpportunita(data, type, row) {
        if (type === 'display') {
          if (vm.user.flags.gestOppo) {
            data = '<a title="apri opportunita" ng-click="cliente.readOpportunita(\'' + row.id + '\')">' + data + '</a>';
          } else {
            data = '<a title="elenca attività opportunità" ng-click="cliente.listAttivitaOpportunita(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderProgetto( data, type, row ) {
        if ( data ) {
          var output = dtFactory.renders.date( row.dataOraInvioRichiestaProgettazione, 'display' );
          if ( vm.user.flags.gestProg ) {
            output += '\
              <a href="" ng-click="cliente.readProgetto(' + data + ')" bs-tooltip data-title="Vai a progetto">\
                <i class="fa fa-external-link"></i>\
              </a>';
          }
          return output;
        }
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateOpportunita(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var updS = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateOpportunitaSegnalatore(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteOpportunita(' + data + ')"><i class="fa fa-minus"></i></button>';

        switch (vm.checkEditPermission(vm.user, row)) {
          case 'segnalatore':
            actions = updS + '&nbsp;' + del;
            break;

          case 'agente':
          case 'admin':
            actions = upd + '&nbsp;' + del;
            break;
        }

        return actions;
      }

    }

    function dtOpportunitaReload(event, opportunita) {
      if (event.name === 'Opportunita.deleted') {
        vm.dtOpportunita.dtInstance.reloadData();
      } else {
        if (opportunita.idCliente === vm.cliente.id) {
          vm.dtOpportunita.dtInstance.reloadData();
        }
      }
    }

    function setTitleOpportunita(opportunita) {
      var oppoAperte = $filter('filter')(opportunita, {idStato: 1}, true);
      var numOppoAperte = oppoAperte.length;
      if (numOppoAperte > 0) {
        vm.titleOpportunita = 'Opportunità <span class="badge">' + numOppoAperte + '</span>';
      } else {
        vm.titleOpportunita = 'Opportunità';
      }
    }

    //gestione pv
    function dtPv( idCliente ) {
      vm.dtPv.dtInstance = {};
      vm.dtPv.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
        .fromFnPromise( getPv( {
          idCliente: idCliente
        } ) )
        .withOption( 'order', [[4, 'asc'],[2, 'desc']] )
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
        .withOption( 'paging', true )
        .withOption( 'pageLength', vm.pageLength )
      );
      vm.dtPv.dtColumns = [
        {
          data: 'realizzativo',
          title: 'Tipo',
          render: renderTipo
        },
        {
          data: 'codice',
          title:'Codice',
          render: renderPv
        },
        {
          data: 'dataApertura',
          title: 'Apertura',
          render: dtFactory.renders.date
        },
        {
          data: 'dataChiusura',
          title: 'Chiusura',
          render: dtFactory.renders.date
        },
        {
          data: 'stato',
          title: 'Stato',
          render: renderAttivita
        },
        {
          data: 'soggetto',
          title: 'Assegnato'
        },
        {
          data: 'piste',
          title: 'Pista'
        },
        {
          data: 'dataPrevChiusura',
          title: '<span title="Data Prevista Chiusura">Scadenza</span>',
          render: dtFactory.renders.date
        },
        {
          data: 'descrizioneTicket',
          title: 'Descrizione',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'idPostvendita',
          title: renderTitleActions(),
          render: renderActions,
          'class': 'text-center min-width',
          orderable: false,
          searchable: false
        }
      ];
      vm.dtPv.showMore = false;
      vm.dtPv.more = more;

      function getPv(params) {
        return function() {
          var promise = api.pv().list(params);
          promise.then(function(pv) {
            vm.pv = pv;
          });
          return promise;
        };
      }

      function renderPv(data, type, row) {
        if (type === 'display') {
          if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
            data = '<a title="apri postvendita" ng-click="cliente.readPv(' + row.idPostvendita + ')">' + data + '</a>';
          }
        }
        return data;
      }

      function renderAttivita(data, type, row) {
        if (type === 'display') {
          data = '<a title="vedi attività postvendita" ng-click="cliente.readAttivitaPv(' + row.idPostvendita + ')">' + data + '</a>';
        }
        return data;
      }

      function renderTipo(data, type) {
        if (type === 'display') {
          data = data ? '<i class="fa fa-registered iconaRealizzazione" title="Realizzazione"></i>' : '<i class="fa fa-product-hunt iconaPv" title="Postvendita"></i>';
        } else {
          data = data ? 'R' : 'P';
        }
        return data;
      }

      function renderTitleActions() {
        var title = '';
        if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
          title = '<button type="button" class="btn btn-success btn-xs" title="Inserisci" ng-click="cliente.createPv(cliente.cliente)"><i class="fa fa-plus"></i></button>';
        }
        return title;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="cliente.updatePv(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="cliente.deletePv(' + data + ')"><i class="fa fa-minus"></i></button>';
        if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
          actions = upd + '&nbsp;' + del;
        }
        return actions;
      }

      function more() {
        vm.dtPv.showMore = false;
        vm.dtPv.dtOptions
          .withOption('info', true)
          .withOption('lengthChange', true)
          .withOption('searching', true)
          .withOption('paging', true);
        vm.dtPv.dtInstance.changeData(getPv({
          idCliente: idCliente
        }));
      }

    }

    function dtPvReload(event, pv) {
      if (event.name === 'Pv.deleted') {
        vm.dtPv.dtInstance.reloadData();
      } else {
        if ( pv && pv.idCliente === vm.cliente.id ) {
          vm.dtPv.dtInstance.reloadData();
        }
      }
    }

    function setTitlePv(pv) {
      var pvAperti = $filter('filter')(pv, {stato: 'aperto'}, true);
      var numPvAperti = pvAperti.length;
      vm.titlePv = 'Postvendita';
      if (numPvAperti > 0) {
        vm.titlePv += ' <span class="badge">' + numPvAperti + '</span>';
      }
    }

    //gestione allegati
    function dtAllegati(idCliente) {

      function dtColumnFilter( data ) {
        var tipi = [];
        for ( var i = 0; i < data.length; i++ ) {
          if ( tipi.indexOf( data[i].tipo ) == - 1 ) {
            tipi.push( data[i].tipo );
          }
        }
        tipi.sort();
        var tipiValues = [];
        tipi.forEach( function ( value ) {
          if ( value == '' ) {
            return;
          }
          tipiValues.push( {
            label: value,
            value: value
          } );
        } );
        return {
          aoColumns: [
            null, // data
            {
              type: 'text' // descrizione
            },
            {
              type: 'select', // tipo allegato servizio
              bRegex: false,
              values: tipiValues
            },
            {
              type: 'text' // note
            },
            null
          ]
        };
      }
      vm.dtAllegati.dtInstance = {};
      vm.dtAllegati.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(getAllegati({
          idCliente: idCliente
        }))
        .withOption( 'order', [[0, 'desc']] )
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', true )
        .withOption( 'paging', true )
        .withOption( 'pageLength', vm.pageLength )
      );
      vm.dtAllegati.dtColumns = [
        {
          data: 'dataOraIns',
          title: 'Data',
          render: dtFactory.renders.datetime,
          'class': 'col-date-time'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': 'col-descrizione nowrap'
        },
        {
          data: 'tipo',
          title: 'Tipo',
          'class': 'col-tipo nowrap'
        },
        {
          data: 'note',
          title: 'Note Documento',
          'class': 'col-descrizione nowrap',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          title: renderActionsTitle(),
          render: renderActions,
          'class': 'min-width text-center vertical-align-middle',
          orderable: false,
          searchable: false
        }
      ];

      function getAllegati(params) {
        return function() {
          var promise = api.allegati.list(params);
          promise.then( function ( data ) {
            vm.allegati = data;
            if ( ! _.isEmpty( vm.dtAllegati.dtInstance ) ) {
              vm.dtAllegati.dtInstance.DataTable.on( 'search.dt', function () {
                vm.dtAllegati.count = vm.dtAllegati.dtInstance.DataTable.rows( { search:'applied' } ).count();
                vm.dtAllegati.filtered = vm.dtAllegati.unfilteredCount != vm.dtAllegati.count;
              } );
            }
            vm.dtAllegati.unfilteredCount = data.length;
            vm.dtAllegati.count = data.length;
            vm.dtAllegati.filtered = false;
            if ( ! vm.dtAllegati.dtOptions || ! vm.dtAllegati.dtOptions.filterColumnsAdded ) {
              vm.dtAllegati.dtOptions.withColumnFilter( dtColumnFilter( data ) );
              vm.dtAllegati.filterColumnsAdded = true;
            }
          });
          return promise;
        };
      }

      function renderActionsTitle() {
        var title = '';
        if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
          title = '<button type="button" class="btn btn-success btn-xs" title="Inserisci" onclick="document.getElementById(\'creaAllegatoButton\').click()"><i class="fa fa-plus"></i></button>';
          // vedi html per capire le ragioni di questo pulsante
        }
        return title;
      }

      function renderActions( data, type, row ) {
        var prv = '<a href="' + apiBaseUrl + '/allegati/' + data + '?preview" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Anteprima"><i class="fa fa-eye"></i></a>';
        var dwn = '<a href="' + apiBaseUrl + '/allegati/' + data + '?download" target="_blank" class="btn btn-primary btn-xs" bs-tooltip data-title="Scarica"><i class="fa fa-download"></i></a>';
        var upd = '<button type="button" class="btn btn-warning btn-xs" bs-tooltip data-title="Modifica" ng-click="cliente.updateAllegato(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" bs-tooltip data-title="Cancella" ng-click="cliente.deleteAllegato(' + data + ')"><i class="fa fa-minus"></i></button>';
        var actions = prv + ' ' + dwn;
        if ( row.modificabile && vm.user.userGroup >= 5 && vm.user.userGroup <= 8 && vm.user.azienda === 'clyco') {
          actions += ' ' + upd + ' ' + del;
        }
        return actions;
      }

    }

    function dtAllegatiReload() {
      if (!_.isEmpty(vm.dtAllegati.dtInstance)) {
        vm.dtAllegati.dtInstance.reloadData();
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .directive('g1Chart', g1ChartDirective);

  function g1ChartDirective() {
    return {
      restrict: 'A',
      templateUrl: 'app/core/charts/chart.tpl.html',
      scope: {
        chartId: '@',
        chartTitle: '=',
        chartTotal: '=?',
        chartOptions: '='
      },
      link: linkFn,
      controller: controllerFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, iElement, iAttrs, ctrl) {
      scope.chartObject = {
        type: scope.chartOptions.tipo,
        displayed: false
      };
      scope.height = scope.chartOptions.height ? scope.chartOptions.height : '600px';
      scope.emptyResponse = false;
      scope.chartDt = {};

      scope.actionOnClick = ctrl.actionOnClick;
      scope.showContratti = ctrl.showContratti;
      scope.readCliente = ctrl.readCliente;
      scope.readContratto = ctrl.readContratto;

      scope.$watch('chartId', handleChanges);
      scope.$watchCollection('chartOptions', handleChanges);

      ctrl.renderChart(scope.chartId);

      //////////////////////////////////////////////////////////////////////////
      function handleChanges(newVal, oldVal) {
        if (newVal !== oldVal) {
          ctrl.renderChart(scope.chartId);
        }
      }
    }

    function controllerFn($scope, $attrs, $filter, googleChartApiPromise, dtFactory, DTOptionsBuilder, api) {
      var ctrl = this;

      ctrl.renderChart = renderChart;
      ctrl.showContratti = showContratti;

      ctrl.readCliente = api.clienti.actions.read;
      ctrl.readContratto = api.contratti.actions.read;

      //definisci funzione al click
      if (angular.isUndefined($scope.chartOptions.actionOnClick)) {
        ctrl.actionOnClick = showTable;
      } else if (angular.isFunction($scope.chartOptions.actionOnClick)) {
        ctrl.actionOnClick = $scope.chartOptions.actionOnClick;
      } else {
        ctrl.actionOnClick = null;
      }

      //////////////////////////////////////////////////////////////////////////
      function renderChart(chartId) {
        $scope.chartObject = {
          type: $scope.chartOptions.tipo,
          displayed: false
        };
        $scope.emptyResponse = false;
        $scope.chartDt = {}; // reset datatable

        googleChartApiPromise
          .then(_getData);

        function _getData(google) {
          var requestPars = angular.copy($scope.chartOptions);

          delete requestPars.height; //pulisce il setting dell'altezza in caso ci fosse

          api.chart(chartId).get(requestPars)
            .then(_drawChart);

          function _drawChart(response) {
            $scope.chartTitle = response.title.chart;
            if (angular.isDefined($scope.chartTotal)) {
              $scope.chartTotal = response.title.total + ': ' + $filter('currency')(response.data[0]['tot.'], undefined, 0);
            }

            //definisci le opzioni del grafico
            $scope.chartObject.options =  {
              title: response.title.chart,
              titlePosition: 'none',
              isStacked: "true",
              fill: 20,
              displayExactValues: true,
              vAxis: {
                title: response.title.y,
                gridlines: {
                  count: 10
                }
              },
              hAxis: {
                title: response.title.x
              }
            };

            if ($scope.chartObject.type === 'ComboChart') {
              angular.extend($scope.chartObject.options, {
                seriesType: 'bars',
                series: {
                  0: {
                    type: 'line',
                    visibleInLegend: false
                  }
                }
              });
            }

            //overload delle options con quelle definite dall'utente
            if (angular.isDefined($scope.chartOptions.chartOptions)) {
              angular.extend($scope.chartObject.options, $scope.chartOptions.chartOptions);
            }

            //imposta i dati del grafico
            if (!angular.equals(response.chart, [])) {
              $scope.chartObject.rawData = response.chart;

              var dataArray = response.chart.values;
              dataArray.unshift(response.chart.labels); //aggiungi labels in testa al dataArray
              $scope.chartObject.data = new google.visualization.arrayToDataTable(dataArray);
            } else {
              $scope.emptyResponse = true;
            }
          }
        }
      }

      function showTable(selectedItem) {
        if (angular.isUndefined(selectedItem)) { return false; } //FIXME: workaround per un problema con agc-on-select

        var chartData = $scope.chartObject.rawData;

        var requestPars = angular.copy($scope.chartOptions);
        requestPars.detail = '';
        requestPars.serie = chartData.labels[selectedItem.column];
        requestPars.x = chartData.values[selectedItem.row + 1][0];

        $scope.chartDt = {}; // reset datatable

        api.chart($scope.chartId).get(requestPars)
          .then(_drawTable);

        function _drawTable(tableData) {
          $scope.chartDt.dtInstance = {};

          switch ($scope.chartId) {
            case 'gav':
              if (tableData.data.length <= 0) {
                $scope.chartDt.dtColumns = [
                  {title: 'Nessun Dato'}
                ];
              } else {
                $scope.chartDt.dtColumns = [];

                angular.forEach(tableData.data[0], function(value, key) {
                  var columnDef = {
                    data: key.replace('.', '\\.'),
                    title: key
                  };

                  if (key === 'idRiga') {
                    columnDef.visible = false;
                  }

                  if (angular.isNumber(value)) {
                    columnDef.render = _renderLink;
                    columnDef['class'] = 'text-right';
                  }

                  this.push(columnDef);
                }, $scope.chartDt.dtColumns);
              }
              break;

            default:
              $scope.chartDt.dtColumns = [
                {
                  data: 'cliente',
                  title: 'Cliente',
                  render: _renderCliente
                },
                {
                  data: 'contratto',
                  title: 'Contratto',
                  render: _renderContratto
                },
                {
                  data: 'dataInserimento',
                  title: 'Data Inserimento',
                  render: dtFactory.renders.date
                },
                {data: 'pista', title: 'Pista'},
                {data: 'fornitore', title: 'Fornitore'},
                {data: 'stato', title: 'Stato'},
                {data: 'qta', title: 'Qta'},
                {data: 'unitario', title: 'Unitario'},
                {data: 'tot', title: 'Tot'}
              ];
          }

          $scope.chartDt.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              return tableData.$promise;
            })
            .withDataProp('data')
            .withOption('order', [0, 'asc'])
          );

          //////////////////////////////////////////////////////////////////////
          function _renderLink(data, type, row, meta) {
            var dtApi = new $.fn.dataTable.Api(meta.settings);
            var riga = row.idRiga.replace(/'/g, '\\\'');
            var colonna = dtApi.column(meta.col).dataSrc().replace(/'/g, '\\\'');

            if (meta.col > 1) {
              data = _formatNumber(data, 2);

              if (type === 'display') {
                if (meta.col < (Object.keys(row).length - 1)) {

                  if (data !== '') {
                    data = '<a title="apri contratti" ng-click="showContratti(\'' + requestPars.serie + '\', \'' + requestPars.x + '\', \'' + riga + '\', \'' + colonna + '\')">' + data + '</a>';
                  }
                } else {
                  data = '<a title="apri contratti" ng-click="showContratti(\'' + requestPars.serie + '\', \'' + requestPars.x + '\', \'' + riga + '\', null)">' + data + '</a>';
                }
              }
            }

            return data;

            ////////////////////////////////////////////////////////////////////
            function _formatNumber(number, decimals) {
              if (number === 0) {
                number = '';
              } else {
                number = $filter('number')(number, decimals);
              }

              return number;
            }
          }

        }
      }

      function showContratti(serie, x, idAgente, pista) {
        var requestPars = angular.copy($scope.chartOptions);
        requestPars.detail = 'contratti';
        requestPars.serie = serie;
        requestPars.x = x;
        requestPars.idAgente = idAgente;
        requestPars.pista = pista;

        $scope.chartDt = {}; // reset datatable

        $scope.chartDt.dtInstance = {};

        $scope.chartDt.dtColumns = [
          {
            data: 'cliente',
            title: 'Cliente',
            render: _renderCliente
          },
          {
            data: 'contratto',
            title: 'Contratto',
            render: _renderContratto
          },
          {
            data: 'dataInserimento',
            title: 'Data Inserimento',
            render: dtFactory.renders.date
          },
          {data: 'pista', title: 'Pista'},
          {data: 'fornitore', title: 'Fornitore'},
          {data: 'stato', title: 'Stato'},
          {data: 'qta', title: 'Qta'},
          {data: 'unitario', title: 'Unitario'},
          {data: 'tot', title: 'Tot'}
        ];

        $scope.chartDt.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return api.chart($scope.chartId).get(requestPars);
          })
          .withDataProp('data')
          .withOption('order', [0, 'asc'])
        );
      }

      //funzioni comuni ad entrambe le DT
      function _renderCliente(data, type, row) {
        if (type === 'display') {
          return '<a title="apri cliente" ng-click="readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }

        return data;
      }

      function _renderContratto(data, type, row) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="readContratto(\'' + row.idContratto + '\')">' + data + '</a>';
        }

        return data;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ChartController', ChartController);

  function ChartController($routeParams, $filter, api) {
    var vm = this;

    vm.id = $routeParams.chartId;
    vm.title = 'in caricamento...';
    vm.formData = {};
    vm.setStati = setStati;

    //carica form del grafico
    api.chart(vm.id).searchForm()
      .then(showChart);

    ////////////////////////////////////////////////////////////////////////////
    function showChart(formData) {
      vm.formData = formData;

      vm.options = {
        anno: vm.formData.anno,
        tipoData: vm.formData.tipoData,
        'idStati[]': vm.formData.idStati,
        tipo: vm.formData.tipo
      };
    }

    function setStati(tipoData) {
      var idStati4tipoData = [];

      switch (tipoData) {
        case 'crm':
          idStati4tipoData = _.map($filter('filter')(vm.formData.stati, {gruppo: '1 OK'}, true), 'value');
          break;

        case 'inserimento':
          idStati4tipoData = _.map($filter('filter')(vm.formData.stati, {gruppo: '!4 ANNULLATO'}, true), 'value');
          break;

        case 'conferma':
          angular.forEach(vm.formData.stati, function(value) {
            if (value.gruppo === '1 OK' || value.gruppo === '2 LAVORAZIONE') {
              idStati4tipoData.push(value.value);
            }
          });
          break;
      }

      vm.options['idStati[]'] = idStati4tipoData;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('CheckDistancesController', CheckDistancesController);

  function CheckDistancesController($scope, $filter, AuthenticateJS, $modal, gmFactory, api) {
    var vm = this;

    var checkDistancesModal = $modal({
      scope: $scope,
      templateUrl: 'check-distances-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.pre = {
      status: 0,
      messages: []
    };
    vm.post = {
      status: 0,
      messages: []
    };

    $scope.$on('checkDistances', checkDistances);

    ////////////////////////////////////////////////////////////////////////////
    function checkDistances(event, newAppuntamento) {
      vm.appuntamento = newAppuntamento;
      vm.pre = {
        status: 0,
        messages: []
      };
      vm.post = {
        status: 0,
        messages: []
      };

      var params = {
        dt_from: moment(newAppuntamento.data).startOf('day').toDate(),
        dt_to: moment(newAppuntamento.data).startOf('day').toDate(),
        idAgente: newAppuntamento.idAgente,
        noLimits: true
      };

      api.appuntamenti.list(params)
        .then(requestDistance);

      //////////////////////////////////////////////////////////////////////////
      function requestDistance(appuntamenti) {
        if (vm.appuntamento.id > 0) {
          appuntamenti = $filter('filter')(appuntamenti, {id: '!'+vm.appuntamento.id}, true);
        }

        if (appuntamenti.length <= 0) {
          vm.pre = {
            status: 417,
            messages: []
          };

          vm.pre.messages.push({
            text: 'Nessun altro appuntamento in giornata'
          });

          return false;
        }

        // elabora date degli appuntamenti
        var newAppDT = moment(newAppuntamento.data).startOf('day')
            .set('hour', moment(newAppuntamento.ora, 'HH:mm').get('hour'))
            .set('minute', moment(newAppuntamento.ora, 'HH:mm').get('minute'))
          ;
        newAppuntamento.dt = newAppDT;

        var appPre = null;
        var appPost = null;

        angular.forEach(appuntamenti, function(value) {
          var currentAppDT = moment(value.data).startOf('day')
              .set('hour', moment(value.ora, 'HH:mm').get('hour'))
              .set('minute', moment(value.ora, 'HH:mm').get('minute'))
            ;

          if (currentAppDT.isBefore(newAppDT)) {
            appPre = value;
            appPre.dt = currentAppDT
          }

          if (appPost === null && (currentAppDT.isAfter(newAppDT))) {
            appPost = value;
            appPost.dt = currentAppDT
          }
        });

        // elabora indirizzi degli appuntamenti e calcola distanze
        var newIndirizzo = newAppuntamento.indirizzo + ',' + newAppuntamento.citta + ',' + newAppuntamento.prov;
        var indirizzo = '';

        if (appPre !== null) {
          indirizzo = appPre.indirizzo + ',' + appPre.citta + ',' + appPre.prov;

          gmFactory.getDistance(indirizzo, newIndirizzo).then(function(resp) {
            var delta = calcDelta(appPre.dt, newAppuntamento.dt, resp.result.duration.value);
            var message = 'App. precedente alle ' + appPre.ora + ' a ' + appPre.citta + ': ' + resp.result.duration.text + '(' + resp.result.distance.text + ')';

            if (delta.asSeconds() < 0) {
              vm.pre.status = 409;
              vm.pre.messages.push({
                text: message + '<br>arriverà in ritardo di ' + delta.humanize()
              });
            } else {
              vm.pre.status = 200;
              vm.pre.messages.push({
                text: message + '<br>arriverà in orario'
              });
            }
          }, function() {
            vm.pre.status = 417;
            vm.pre.messages.push({
              text: 'App. precedente alle ' + appPre.ora + ' a ' + appPre.citta + ': INDIRIZZO NON RICONOSCIUTO'
            });
          });
        }

        if (appPost !== null) {
          indirizzo = appPost.indirizzo + ',' + appPost.citta + ',' + appPost.prov;

          gmFactory.getDistance(indirizzo, newIndirizzo).then(function(resp) {
            var delta = calcDelta(newAppuntamento.dt, appPost.dt, resp.result.duration.value);
            var message = 'App. successivo alle ' + appPost.ora + ' a ' + appPost.citta + ': ' + resp.result.duration.text + '(' + resp.result.distance.text + ')';

            if (delta.asSeconds() < 0) {
              vm.post.status = 409;
              vm.post.messages.push({
                text: message + '<br>arriverà in ritardo di ' + delta.humanize()
              });
            } else {
              vm.post.status = 200;
              vm.post.messages.push({
                text: message + '<br>arriverà in orario'
              });
            }
          }, function() {
            vm.post.status = 417;
            vm.post.messages.push({
              text: 'App. successivo alle ' + appPost.ora + ' a ' + appPost.citta + ': INDIRIZZO NON RICONOSCIUTO'
            });
          });
        }

        ////////////////////////////////////////////////////////////////////////
        function calcDelta(dtPre, dtPost, duration) {
          var dtPreEnd = dtPre.add(1, 'hour');
          var dt2destination = dtPreEnd.add(duration, 'seconds');

          return moment.duration(dtPost.diff(dt2destination));
        }
      }

      checkDistancesModal.$promise
        .then(checkDistancesModal.show);

    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentoUpdateController', AppuntamentoUpdateController);

  function AppuntamentoUpdateController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.setSedeCliente = function ( value ) {
      for ( var i in vm.formData.sediCliente ) {
        var sedeCliente = vm.formData.sediCliente[i];
        if ( sedeCliente.idSede == value ) {
          vm.appuntamento.indirizzo = sedeCliente.indirizzo;
          angular.element( '[ng-model="auc.appuntamento.indirizzo"]' ).blur();
          vm.appuntamento.prov = sedeCliente.prov;
          vm.appuntamento.citta = sedeCliente.citta;
          vm.appuntamento.cap = sedeCliente.cap;
        }
      }
    }

    $scope.$on('updateAppuntamento', updateAppuntamento);

    ////////////////////////////////////////////////////////////////////////////
    function updateAppuntamento(event, idAppuntamento) {
      api.appuntamento(idAppuntamento).get().then( function ( appuntamento ) {
        vm.appuntamento = appuntamento;
        api.appuntamenti.editForm({idCliente:appuntamento.idCliente}).then( function ( formData ) {
          vm.formData = formData;
          appuntamentoUpdateModal.show();
        } );
      } );
    }

    function saveForm() {
      api.appuntamento(vm.appuntamento.id).update(vm.appuntamento)
        .then(appuntamentoUpdateModal.hide);
    }

    function undoForm() {
      appuntamentoUpdateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentoCreateController', AppuntamentoCreateController);

  function AppuntamentoCreateController($scope, $filter, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoCreateModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-create-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.formData = {};
    vm.alerts = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.checkDistances = api.appuntamenti.actions.checkDistances;

    vm.setSedeCliente = function ( value ) {
      for ( var i in vm.formData.sediCliente ) {
        var sedeCliente = vm.formData.sediCliente[i];
        if ( sedeCliente.idSede == value ) {
          vm.appuntamento.indirizzo = sedeCliente.indirizzo;
          angular.element( '[ng-model="acc.appuntamento.indirizzo"]' ).blur();
          vm.appuntamento.prov = sedeCliente.prov;
          vm.appuntamento.citta = sedeCliente.citta;
          vm.appuntamento.cap = sedeCliente.cap;
        }
      }
    }

    $scope.$on('createAppuntamentoCliente', createAppuntamentoCliente);
    $scope.$on('createAppuntamentoOpportunita', createAppuntamentoOpportunita);

    ////////////////////////////////////////////////////////////////////////////
    function createAppuntamentoCliente(event, cliente) {
      vm.alerts = {}; //reset degli alert
      vm.appuntamento = {
        idOperatore: (vm.user.idAgenteT > 0) ? vm.user.idAgenteT : '',
        idSegnalatore: '87',
        idStatoAppuntamento: '103',
        idCliente: cliente.id,
        idPortafoglio: cliente.idPtf,
        cliente: cliente.ragSoc,
        tel: cliente.referenti[0].tel,
        email: cliente.referenti[0].email,
        cell: cliente.referenti[0].cell
      };

      api.appuntamenti.editForm({idCliente:cliente.id})
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;
        appuntamentoCreateModal.$promise
          .then(appuntamentoCreateModal.show);
      }
    }

    function createAppuntamentoOpportunita(event, cliente, opportunita) {
      vm.alerts = {}; //reset degli alert

      vm.appuntamento = {
        idSegnalatore: opportunita.idAgenteS || '87',
        idStatoAppuntamento: '103',
        idCliente: cliente.id,
        idPortafoglio: cliente.idPtf,
        idAgente: opportunita.idAgentePIC,
        idOpportunita: opportunita.id,
        cliente: cliente.ragSoc,
        cap: cliente.cap,
        tel: cliente.tel,
        email: cliente.email,
        cell: cliente.cell
      };

      api.appuntamenti.editForm({idCliente:cliente.id})
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;
        vm.appuntamento.idOperatore = $filter('filter')(vm.formData.operatori, {nullo: 1}, true)[0].value;

        appuntamentoCreateModal.$promise
          .then(appuntamentoCreateModal.show);
      }
    }

    function saveForm() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      api.appuntamenti.save(vm.appuntamento)
        .then(appuntamentoCreateModal.hide, setAlerts);

      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      appuntamentoCreateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentoController', AppuntamentoController);

  function AppuntamentoController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    var appuntamentoModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-modal.tpl.html',
      backdrop: false,
      show: false
    });

    var motivoUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'motivo-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.azioni = [];

    //motivo
    vm.showMotivo = showMotivo;
    vm.showFormMotivo = showFormMotivo;
    vm.assegnaMotivo = assegnaMotivo;

    //appuntamento
    vm.appuntamento = {};
    vm.urlParser = api.functions.urlParser;
    vm.updateAppuntamento = api.appuntamenti.actions.update;
    vm.esitaAppuntamento = api.appuntamenti.actions.esita;
    vm.moveAppuntamento = function moveAppuntamento(idAppuntamento) {
      $rootScope.$broadcast('moveAppuntamento', idAppuntamento);
    };
    vm.updateContattiAppuntamento = function updateContattiAppuntamento(idAppuntamento) {
      $rootScope.$broadcast('updateContattiAppuntamento', idAppuntamento);
    };
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;
    vm.confermaAppuntamento = api.appuntamenti.actions.inviaConferma;
    vm.stampaAppuntamento = stampaAppuntamento;

    //contratti
    vm.dtContratti = {};
    vm.createContrattoAppuntamento = function () {
      $rootScope.$broadcast('createContrattoAppuntamento', vm.appuntamento);
    };
    vm.readContratto = api.contratti.actions.read;
    vm.updateContratto = api.contratti.actions.update;
    vm.deleteContratto = api.contratti.actions.delete;
    vm.checkAuth = checkAuth;

    vm.showChangeStato = [];
    vm.changeStato = changeStato;
    vm.contratti = [];
    vm.fdContratti = {};

    //cliente
    vm.readCliente = api.clienti.actions.read;

    //opportunita
    vm.readOpportunita = api.opportunita().actions.read;
    vm.associaOpportunita = function associaOpportunita(idAppuntamento, idCliente) {
      $rootScope.$broadcast('associaOpportunita', idAppuntamento, idCliente);
    };

    //gestione appuntamento
    $scope.$on('readAppuntamento', readAppuntamento);
    $scope.$on('Appuntamento.updated', appuntamentoReload);
    $scope.$on('Appuntamento.deleted', closeModal);

    //gestione contratti
    $scope.$on('Contratto.created', dtContrattiReload);
    $scope.$on('Contratto.updated', dtContrattiReload);
    $scope.$on('Contratto.deleted', dtContrattiReload);

    ////////////////////////////////////////////////////////////////////////////
    //gestione azioni
    function generaAzioni() {
      var actions = [];
      var availableActions = {
        updateAppuntamento: {
          text: '<i class="fa fa-pencil fa-fw"></i>&nbsp;Modifica',
          click: 'appuntamento.updateAppuntamento(appuntamento.appuntamento.id);'
        },
        esitaAppuntamento: {
          text: '<i class="fa fa-check-square-o fa-fw"></i>&nbsp;Esita',
          click: 'appuntamento.esitaAppuntamento(appuntamento.appuntamento.id);'
        },
        moveAppuntamento: {
          text: '<i class="fa fa-clock-o fa-fw"></i>&nbsp;Sposta/Modifica',
          click: 'appuntamento.moveAppuntamento(appuntamento.appuntamento.id);'
        },
        deleteAppuntamento: {
          text: '<i class="fa fa-minus-square fa-fw"></i>&nbsp;Elimina',
          click: 'appuntamento.deleteAppuntamento(appuntamento.appuntamento.id);'
        },
        confermaAppuntamento: {
          text: '<i class="fa fa-mail-forward fa-fw"></i>&nbsp;Invia Conferma',
          click: 'appuntamento.confermaAppuntamento(appuntamento.appuntamento.id, {indirizzo: appuntamento.appuntamento.email, oggetto: \'Conferma Appuntamento \' + appuntamento.appuntamento.cliente});'
        },
        stampaAppuntamento: {
          text: '<i class="fa fa-file-pdf-o fa-fw"></i>&nbsp;Stampa',
          click: 'appuntamento.stampaAppuntamento(appuntamento.appuntamento.id);'
        },
        associaOpportunita: {
          text: '<i class="fa fa-usd fa-fw"></i>&nbsp;Associa Opportunità',
          click: 'appuntamento.associaOpportunita(appuntamento.appuntamento.id, appuntamento.appuntamento.idCliente);'
        }
      };

      switch (vm.user.userGroup) {
        case 1:
          if (vm.user.idAgente === vm.appuntamento.idAgente) {
            actions.push(availableActions.esitaAppuntamento);
            if (vm.appuntamento.idStatoAppuntamento === 103) { //se stato VISITA
              actions.push(availableActions.moveAppuntamento);
              if (vm.appuntamento.idUtenteIns === vm.user.id) {
                actions.push(availableActions.deleteAppuntamento);
              }
            }
          }
          actions.push(availableActions.stampaAppuntamento);
        break;

        case 3:
        case 4:
          actions.push(availableActions.esitaAppuntamento);
          actions.push(availableActions.stampaAppuntamento);
        break;

        case 2:
        case 5:
        case 6:
        case 7:
        case 8:
          actions.push(availableActions.updateAppuntamento);
          actions.push(availableActions.confermaAppuntamento);
          actions.push(availableActions.stampaAppuntamento);
        break;
      }

      if ( !(vm.appuntamento.idOpportunita > 0)
        && (vm.user.flags.gestOppo)
      ) {
        actions.push(availableActions.associaOpportunita);
      }

      return actions;
    }

    function stampaAppuntamento(idAppuntamento) {
      return dtFactory.exportFile(apiBaseUrl + '/appuntamenti/' + idAppuntamento + '.pdf', undefined, undefined, true);
    }

    //gestione assegnazione motivo
    function showMotivo() {
      if (vm.appuntamento.motivi_descrizione !== '') {
        return 'motivo';
      } else {
        return (vm.user.userGroup < 5) ? 'motivo' : 'bottone';
      }
    }

    function showFormMotivo() {
      api.telefonate.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        vm.appuntamento.idMotivo = '';
        vm.appuntamento.idOperatore = '';
        vm.appuntamento.noteTelefonata = 'Inserimento automatico';

        motivoUpdateModal.$promise
          .then(motivoUpdateModal.show);
      }
    }

    function assegnaMotivo() {

      api.cliente(vm.appuntamento.idCliente)
        .appuntamento(vm.appuntamento.id).motivo({
          idMotivo: vm.appuntamento.idMotivo,
          idOperatore: vm.appuntamento.idOperatore,
          noteTelefonata: vm.appuntamento.noteTelefonata
        })
        .then(onSuccessMotivo);

      function onSuccessMotivo(telefonata) {
        vm.appuntamento.motivi_descrizione = telefonata.motivi_descrizione;
        vm.appuntamento.agenti_operatore = telefonata.operatore;

        motivoUpdateModal.hide();
      }
    }

    //gestione appuntamento
    function readAppuntamento(event, idAppuntamento) {
      api.appuntamento(idAppuntamento).get()
        .then(showModal);

      function showModal(appuntamento) {
        vm.appuntamento = appuntamento;
        vm.azioni = generaAzioni();

        dtContratti(appuntamento.id);

        api.contratti.editForm()
          .then(function(formData) {
            vm.fdContratti = formData;
          });

        appuntamentoModal.$promise
          .then(appuntamentoModal.show);
      }
    }

    function appuntamentoReload(event, appuntamento) {
      if (appuntamento.id === vm.appuntamento.id) {
        vm.appuntamento = appuntamento;
      }
    }

    function closeModal(event, appuntamento) {
      if (appuntamento.id === vm.appuntamento.id) {
        appuntamentoModal.hide();
      }
    }

    //gestione contratti
    function dtContratti(idAppuntamento) {
      vm.dtContratti.dtInstance = {};

      vm.dtContratti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.appuntamento(idAppuntamento).contratti.list)
        .withOption('order', [
          [7, 'desc'],
          [0, 'asc']
        ])
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.dtContratti.dtColumns = [
        {
          data: 'descrizione',
          title: 'Descrizione',
          render: renderContratto
        },
        {
          data: 'durataContratto',
          title: 'Durata',
          render: renderDurata
        },
        {
          data: 'prezzoUnit',
          title: 'Prezzo',
          render: dtFactory.renders.currency
        },
        {
          data: 'qta',
          title: 'Qta'
        },
        {
          data: 'prezzo',
          title: 'Totale',
          render: dtFactory.renders.currency
        },
        {
          data: 'stato',
          title: 'Stato',
          render: renderStato
        },
        {
          data: 'fornitore',
          title: 'Fornitore'
        },
        {
          data: 'pista',
          title: 'Pista'
        },
        {
          data: 'dataInserimento',
          title: 'Inserimento',
          render: dtFactory.renders.date
        },
        {
          data: 'dataConferma',
          title: 'Conferma',
          render: dtFactory.renders.date
        },
        {
          data: 'dataCrm',
          title: 'Attivazione', // TODO: Sosituito 'CRM' con 'Attivazione'
          render: dtFactory.renders.date
        },
        {
          data: 'dataAnnullo',
          title: 'Annullo',
          render: dtFactory.renders.date
        },
        {
          data: 'id',
          title: renderTitleAction(),
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderContratto(data, type, row) {
        if (type === 'display') {
          return '<a title="apri contratto" ng-click="appuntamento.readContratto(\'' + row.id + '\')">' + data + '</a>';
        }

        return data;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function renderStato(data, type, row) {
        if (type === 'display') {
          if (vm.user.userGroup >= 5 && vm.user.userGroup <= 8) {
            vm.showChangeStato[row.id] = false;
            vm.contratti[row.id] = {
              id: row.id,
              idStatoContratto: row.idStato,
              codiceProdotto: row.codiceProdotto,
              prezzoUnit: row.prezzoUnit,
              qta: row.qta
            };

            return '' +
              '<span ng-if="!appuntamento.showChangeStato[' + row.id + ']">\n' +
              '  ' + data + '\n' +
              '  <button type="button" class="btn btn-xs btn-warning" ng-if="appuntamento.checkAuth()" ng-click="appuntamento.showChangeStato[' + row.id + '] = true"><i class="fa fa-pencil"></i></button>\n' +
              '</span>\n' +
              '<span ng-if="appuntamento.showChangeStato[' + row.id + ']" class="validate-group">\n' +
              '  <select ng-options="el.value as el.label for el in appuntamento.fdContratti.stati"\n' +
              '          ng-model="appuntamento.contratti[' + row.id + '].idStatoContratto" name="idStatoContratto"\n' +
              '          required>\n' +
              '  </select>\n' +
              '  <button type="button" class="btn btn-xs btn-success" ng-click="appuntamento.changeStato(' + row.id + ')"><i class="fa fa-check"></i></button>\n' +
              '  <button type="button" class="btn btn-xs btn-danger" ng-click="appuntamento.showChangeStato[' + row.id + '] = false"><i class="fa fa-times"></i></button>\n' +
              '</span>\n'
              ;
          }
        }

        return data;
      }

      function renderTitleAction() {
        var ins = '<button type="button" class="btn btn-success btn-xs" ng-click="appuntamento.createContrattoAppuntamento()"><i class="fa fa-plus"></i></button>';

        return '<span ng-if="appuntamento.checkAuth()">' + ins +'</span>';
      }

      function renderActions(data, type, row) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="appuntamento.updateContratto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="appuntamento.deleteContratto(' + data + ')"><i class="fa fa-minus"></i></button>';
        var actions = '<span ng-if="appuntamento.checkAuth()">' + upd + '&nbsp;' + del +'</span>';

        if (vm.user.userGroup <= 4) {
          if (row.idStato != 1) { //se stato contratto non è INSERITO
            actions = '';
          }
        }

        return actions;
      }
    }

    function dtContrattiReload(event, contratto) {
      if (event.name === 'Contratto.deleted') {
        vm.dtContratti.dtInstance.reloadData();
      } else {
        if (contratto.idAppuntamento === vm.appuntamento.id) {
          vm.dtContratti.dtInstance.reloadData();
        }
      }
    }

    function checkAuth() {
      var check = false;
      if (vm.user.userGroup < 8 ) { //se non admin
        if (vm.user.userGroup != 2) { //se non è cc
          if (vm.appuntamento.idStatoAppuntamento === 104) { //se stato POSITIVO
            check = true;
          }
        }
      } else {
        check = true;
      }

      return check;
    }

    function changeStato(idContratto) {
      api.contratto(idContratto).update(vm.contratti[idContratto])
        .then(function() {
          vm.showChangeStato[idContratto] = false;
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentiModalController', AppuntamentiModalController);

  function AppuntamentiModalController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var appuntamentiModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamenti-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.filtro = {};
    vm.dtAppuntamenti = {};

    $scope.$on('readAppuntamenti', readAppuntamenti);

    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.updateAppuntamento = api.appuntamenti.actions.update;
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;

    vm.readCliente = api.clienti.actions.read;

    //gestione appuntamenti
    $scope.$on('Appuntamento.updated', dtAppuntamentiReload);
    $scope.$on('Appuntamento.deleted', dtAppuntamentiReload);

    ////////////////////////////////////////////////////////////////////////////
    function readAppuntamenti(event, filtroAppuntamenti) {
      vm.filtro = filtroAppuntamenti;

      dtAppuntamenti(filtroAppuntamenti);

      appuntamentiModal.$promise
        .then(appuntamentiModal.show);
    }

    function dtAppuntamenti(filtroAppuntamenti) {
      vm.dtAppuntamenti.dtInstance = {};

      vm.dtAppuntamenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function() {
          return api.appuntamenti.list(filtroAppuntamenti);
        })
        .withOption('order', [
          [0, 'desc'],
          [1, 'asc']
        ])
      );

      vm.dtAppuntamenti.dtColumns = [
        {
          data: 'data',
          title: 'Data',
          render: renderData
        },
        {
          data: 'ora',
          title: 'Ora',
          render: renderOra
        },
        {
          data: 'cliente',
          title: 'Cliente',
          'class': '',
          render: renderCliente
        },
        {data: 'citta', title: 'Città'},
        {data: 'prov', title: 'Prov.'},
        {data: 'indirizzo', title: 'Indirizzo', 'class': ''},
        {data: 'tel', title: 'Tel'},
        {data: 'agenti_agente', title: 'Agente'},
        {data: 'operatori_operatore', title: 'Operatore'},
        {data: 'stati_appuntamento_descrizione', title: 'Stato'},
        {data: 'motivi_descrizione', title: 'Campagna'},
        {
          data: 'id',
          title: '',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //nascondi colonne in base ai filtri
      if (vm.filtro.idCliente) {
        vm.dtAppuntamenti.dtColumns[2].visible = false;
      }
      if (vm.filtro.idAgente) {
        vm.dtAppuntamenti.dtColumns[7].visible = false;
      }
      if (vm.filtro.idOperatore) {
        vm.dtAppuntamenti.dtColumns[8].visible = false;
      }
      if (
        (vm.filtro.idMotivo && angular.isNumber(vm.filtro.idMotivo))
        || vm.filtro.idMotivo === 'NESSUNO'
      ) {
        vm.dtAppuntamenti.dtColumns[10].visible = false;
      }

      //////////////////////////////////////////////////////////////////////////
      function renderData(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.date(data, type);

          if (row.privato !== '1') {
            var tooltip = '';
            if (row.noteAgente !== '') {
              tooltip += 'NOTE AGENTE:<br>' + _.escape(row.noteAgente) + '<br>';
            }
            if (row.noteOperatore !== '') {
              tooltip += 'NOTE OPERATORE:<br>' + _.escape(row.noteOperatore) + '<br>';
            }
            if (tooltip === '') {
              tooltip = 'Apri Appuntamento';
            }

            return '<a bs-tooltip data-container="body" data-placement="auto right" data-title="' + tooltip + '" ng-click="amc.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
          }
        } else if (type === 'filter') {
          data = dtFactory.renders.date(data, 'display');
        }

        return data;
      }

      function renderOra(data, type, row) {
        if (type === 'display') {
          if (row.privato !== '1') {
            return '<a title="apri appuntamento" ng-click="amc.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderCliente(data, type, row) {
        if (type === 'display') {
          if (row.privato !== '1') {
            return '<a title="apri cliente" ng-click="amc.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="amc.updateAppuntamento(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var esita = '<button type="button" class="btn btn-warning btn-xs" title="Esita" ng-click="amc.esitaAppuntamento(' + data + ')"><i class="fa fa-check-square-o"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="amc.deleteAppuntamento(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (row.privato !== '1') {
          switch (vm.user.userGroup) {
            case 1:
            case 3:
            case 4:
              actions = esita;
            break;

            case 2:
              actions = upd;
            break;

            case 5:
            case 6:
            case 7:
            case 8:
              actions = upd + '&nbsp;' + del;
            break;
          }
        }

        return actions;
      }
    }

    function dtAppuntamentiReload() {
      if (angular.isDefined(vm.dtAppuntamenti.dtInstance)) {
        vm.dtAppuntamenti.dtInstance.reloadData();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AppuntamentiController', AppuntamentiController);

  function AppuntamentiController($scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.alerts = {};
    vm.sa = {
      'idStatoAppuntamento[]': [],
      idAgente: 0,
      tipoRichiamo: 0,
      privato: false
    };
    vm.dtAppuntamenti = {};
    vm.showResults = false;
    vm.search = search;
    vm.resetForm = resetForm;

    vm.createAppuntamento = api.appuntamenti.actions.create;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.updateAppuntamento = api.appuntamenti.actions.update;
    vm.deleteAppuntamento = api.appuntamenti.actions.delete;
    vm.esitaAppuntamento = api.appuntamenti.actions.esita;

    vm.readCliente = api.clienti.actions.read;

    //carica i dati della form
    api.appuntamenti.searchForm()
      .then(function(formData) {
        vm.formData = formData;
      })
    ;

    //carica la DT
    //dtAppuntamenti();

    //reagisci ai cambiamenti sugli appuntamenti
    $scope.$on('Appuntamento.created', dtAppuntamentiReload);
    $scope.$on('Appuntamento.updated', dtAppuntamentiReload);
    $scope.$on('Appuntamento.deleted', dtAppuntamentiReload);

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      //vm.showResults = true;
      vm.alerts = {};

      api.appuntamenti.list(vm.sa).then(dtAppuntamenti, setAlerts);
      function setAlerts(response) {
        vm.showResults = false;

        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }

      /*
      vm.dtAppuntamenti.dtInstance.changeData(appuntamentiList);
      function appuntamentiList() {
        var promise = api.appuntamenti.list(vm.sa);

        promise.then(null, setAlerts);

        return promise;

        ////////////////////////////////////////////////////////////////////////
        function setAlerts(response) {
          vm.showResults = false;

          vm.alerts = {
            status: response.status,
            messages: response.data.warnings
          };
        }
      }
      */
    }

    function resetForm() {
      vm.showResults = false;

      vm.alerts = {};

      vm.sa = {
        'idStatoAppuntamento[]': [],
        idAgente: '0',
        idMotivo: ''
      };
    }

    function dtAppuntamenti(appuntamenti) {
      if (_.isEmpty(vm.dtAppuntamenti.dtInstance)) {
        vm.dtAppuntamenti.dtInstance = {};

        vm.dtAppuntamenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(appuntamenti.$promise)
//          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'Appuntamenti',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('order', [
            [0, 'desc'],
            [1, 'asc']
          ])
          .withOption('pageLength', 25)
        );

        vm.dtAppuntamenti.dtColumns = [
          {
            data: 'data',
            title: 'Data',
            render: renderData
          },
          {
            data: 'ora',
            title: 'Ora',
            render: renderOra
          },
          {
            data: 'idCliente',
            title: 'ID Cliente',
            visible: false
          },
          {
            data: 'cf',
            title: 'C.F.',
            visible: false
          },
          {
            data: 'cliente',
            title: 'Cliente',
            'class': '',
            render: renderCliente
          },
          {data: 'citta', title: 'Città'},
          {data: 'prov', title: 'Prov.'},
          {data: 'indirizzo', title: 'Indirizzo', 'class': ''},
          {data: 'tel', title: 'Tel'},
          {data: 'agenti_agente', title: 'Agente'},
          {data: 'operatori_operatore', title: 'Operatore'},
          {
            data: 'segnalatori_segnalatore',
            title: 'Segnalatore',
            visible: false
          },
          {data: 'stati_appuntamento_descrizione', title: 'Stato'},
          {data: 'motivi_descrizione', title: 'Campagna'},
          {
            data: 'noteOperatore',
            title: 'Note Operatore',
            visible: false
          },
          {
            data: 'noteAgente',
            title: 'Note Agente',
            visible: false
          },
          {
            data: 'noteRichiamo',
            title: 'Note Richiamo',
            visible: false
          },
          {
            data: 'dataOraIns',
            title: 'Data Ora Inserimento',
            render: dtFactory.renders.datetime,
            visible: false
          },
          {
            data: 'id',
            title: '',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          },
          {
            data: 'ptf',
            title: 'Ptf app.',
            visible: false
          },
          {
            data: 'ptf_cli',
            title: 'Cluster',
            visible: false
          },
          {
            data: 'ptf_cli_mob',
            title: 'Cross',
            visible: false
          }
        ];

        if (AuthenticateJS.authorize('AGENTI')) {
          vm.dtAppuntamenti.dtColumns[9].visible = false; //nascondi colonna agenti se AGENTI
        }
      } else {
        vm.dtAppuntamenti.dtInstance.changeData(appuntamenti.$promise);
      }

      vm.showResults = true;

      //////////////////////////////////////////////////////////////////////////
      function renderData(data, type, row) {
        if (type === 'display') {
          data = dtFactory.renders.date(data, type);

          if ( ! row.privato ) {
            var tooltip = '';
            if (row.noteAgente !== '') {
              tooltip += 'NOTE AGENTE:<br>' + _.escape(row.noteAgente) + '<br>';
            }
            if (row.noteOperatore !== '') {
              tooltip += 'NOTE OPERATORE:<br>' + _.escape(row.noteOperatore) + '<br>';
            }
            if (tooltip === '') {
              tooltip = 'Apri Appuntamento';
            }

            return '<a bs-tooltip data-container="body" data-placement="auto right" data-title="' + tooltip + '" ng-click="appuntamenti.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
          }
        } else if (type === 'filter') {
          data = dtFactory.renders.date(data, type);
        }

        return data;
      }

      function renderOra(data, type, row) {
        if (type === 'display') {
          if ( ! row.privato ) {
            return '<a title="apri appuntamento" ng-click="appuntamenti.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderCliente(data, type, row) {
        if (type === 'display') {
          var link = '<a title="apri cliente" ng-click="appuntamenti.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';

          if (vm.user.userGroup == 1) {
            if ( ! row.privato && vm.sa.idSegnalatore !== 1) {
              data = link;
            }
          } else {
            if ( ! row.privato ) {
              data = link;
            }
          }
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="appuntamenti.updateAppuntamento(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var esita = '<button type="button" class="btn btn-warning btn-xs" title="Esita" ng-click="appuntamenti.esitaAppuntamento(' + data + ')"><i class="fa fa-check-square-o"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="appuntamenti.deleteAppuntamento(' + data + ')"><i class="fa fa-minus"></i></button>';
        if ( ! row.privato ) {
          switch (vm.user.userGroup) {
            case 1:
              if (vm.user.idAgente === row.idAgente) {
                actions = esita;
              }
            break;

            case 3:
            case 4:
              actions = esita;
            break;

            case 2:
              actions = upd;
            break;

            case 5:
            case 6:
            case 7:
            case 8:
              actions = upd + '&nbsp;' + del;
            break;
          }
        }

        return actions;
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.appuntamenti.url,
          numRecords: dt.data().length,
          filter: angular.copy(vm.sa)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }
    }

    function dtAppuntamentiReload() {
      if (! _.isEmpty(vm.dtAppuntamenti.dtInstance)) {
        search();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AgendaController', AgendaController);

  function AgendaController($window, $q, $scope, AuthenticateJS, $alert, dtFactory, api, apiBaseUrl) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.cal = {
      view: 'week',
      viewTitle: '',
      viewDate: moment().toDate(),
      events: []
    };
    vm.formData = {};
    vm.sa = {
      dt_from: moment(vm.cal.viewDate).startOf(vm.cal.view).toDate(),
      dt_to: moment(vm.cal.viewDate).endOf(vm.cal.view).startOf('day').toDate(),
      idAgente: '-1'
    };

    vm.eventClicked = eventClicked;
    vm.printAgenda = printAgenda;
    vm.syncGcal = syncGcal;
    vm.createAppuntamentoPrivato = api.appuntamenti.actions.createPrivato;

    //carica l'agenda
    api.appuntamenti.searchForm().then(function(formData) {
      vm.formData.operatori = formData.operatori;
      vm.formData.agenti = formData.agenti;

      // aggiungi nessuno alla select agenti
      vm.formData.agenti.unshift({
        label: 'NESSUNO',
        teamLeader: '0',
        value: '-1'
      });
    }).then(function() {
      getAppuntamenti(true);
    });

    $scope.$watchGroup([
      function() {return vm.cal.viewDate;},
      function() {return vm.cal.view;},
      function() {return vm.sa.idAgente;}
    ], getAppuntamenti);

    //reagisci ai cambiamenti sugli appuntamenti
    $scope.$on('Appuntamento.created', reloadAppuntamenti);
    $scope.$on('Appuntamento.updated', reloadAppuntamenti);
    $scope.$on('Appuntamento.deleted', reloadAppuntamenti);

    ////////////////////////////////////////////////////////////////////////////
    function getAppuntamenti(newVal, oldVal) {
      if (newVal !== oldVal) {
        vm.sa.dt_from = moment(vm.cal.viewDate).startOf(vm.cal.view).toDate();
        vm.sa.dt_to = moment(vm.cal.viewDate).endOf(vm.cal.view).startOf('day').toDate();

        vm.cal.events = [];

        api.list('/agenda', 'Agenda').list(vm.sa)
          .then(createEvents);
      }

      function createEvents(appuntamenti) {
        angular.forEach(appuntamenti, function(app) {
          /** elabora descrizione e link */
          var title, onClick, ibt;

          switch (app.tabella ) {
            case 'ordini':
              if (app.privato) {
                title = app.titolo;
                onClick = api.appuntamenti.actions.readPrivato;
                ibt = false;

                if ((vm.user.userGroup > 1) && (vm.sa.idAgente === '0')) {
                  title = app.titolo + ' - ' + app.soggetto + ' - ' + app.ora;
                }
              } else {
                title = app.titolo + ' - ' + app.citta + ' - ' + app.stato;
                onClick = api.appuntamenti.actions.read;
                ibt = true;

                if ((vm.user.userGroup > 1) && (vm.sa.idAgente === '0')) {
                  title += ' - ' + app.soggetto;
                }
              }

              if (app.evidenziaAgenda === '1') {
                title = '<b><i class="fa fa-fw fa-star"></i>' + title + '</b>';
              }
              break;

            case 'promemoria':
              title = app.titolo;
              onClick = api.promemoria().actions.read;
              ibt = false;
              break;
          }

          vm.cal.events.push({
            id: app.id, //campo personalizzato
            title: title,
            color: {
              primary: app.colore1,
              secondary: app.colore2
            },
            startsAt: moment(app.startsAt).toDate(),
            endsAt: moment(app.endsAt).toDate(),
            onClick: onClick, //campo personalizzato
            draggable: false,
            resizable: false,
            incrementsBadgeTotal: ibt,
            allDay: app.allDay
          });
        });
      }
    }

    function reloadAppuntamenti() {
      getAppuntamenti(1, 0);
    }

    function eventClicked(calendarEvent) {
      calendarEvent.onClick(calendarEvent.id);
    }

    function printAgenda() {
      var getData = angular.copy(vm.sa);

      if (_.isDate(getData.dt_from)) {
        getData.dt_from = getData.dt_from.toISOString();
      }
      if (_.isDate(getData.dt_to)) {
        getData.dt_to = getData.dt_to.toISOString();
      }

      return dtFactory.exportFile(apiBaseUrl + '/appuntamenti/agenda.pdf', getData);
    }

    function syncGcal() {
      api.list('/agenti/' + vm.user.idAgente + '/gcal/sync', 'Gcal').list({
        dt_from: moment().startOf('week').startOf('day').toDate(),
        dt_to: moment().endOf('week').startOf('day').toDate()
      }).then(onSuccess, onError);

      //////////////////////////////////////////////////////////////////////////
      function onSuccess(syncResult) {
        $alert({
          placement: 'top',
          title: syncResult.length + ' appuntamenti sincronizzati.',
          type: 'success'
        });
      }

      function onError(syncError) {
        switch(syncError.status) {
          case 403:
            $alert({
              placement: 'top',
              title: 'Non autorizzato. Ripetere il sync dopo aver concesso i permessi di accesso. Fare attenzione ad avere abilitato i popup.',
              type: 'danger'
            });

            $window.open(syncError.data.auth_url);
            break;

          default:
            $alert({
              placement: 'top',
              title: 'Errore:' + syncError.data,
              type: 'danger'
            });
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AllegatoEditController', AllegatoEditController);

  function AllegatoEditController($scope, $modal, api, apiBaseUrl) {
    var vm = this;

    var allegatoEditModal = $modal({
      scope: $scope,
      templateUrl: 'allegato-edit-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.action = '';
    vm.formData = {};
    vm.alerts = [];
    vm.allegato = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.filePattern = '';

    $scope.$on('createAllegato', createAllegato);
    $scope.$on('updateAllegato', updateAllegato);

    ////////////////////////////////////////////////////////////////////////////

    function createAllegato(event, model) {
      vm.action = 'create';
      vm.alerts = [];
      vm.allegato = {
        idCliente: model.idCliente
      };
      var contesto = 'cliente';
      if ( model.idPostvendita != undefined && model.idPostvendita != '' ) {
        contesto = 'postvendita';
        vm.allegato.idPostvendita = model.idPostvendita;
      }
      if ( model.idOpportunita != undefined && model.idOpportunita != '' ) {
        contesto = 'opportunita';
        vm.allegato.idOpportunita = model.idOpportunita;
      }
      if ( model.idProgetto != undefined && model.idProgetto != '' ) {
        contesto = 'progetto';
        vm.allegato.idProgetto = model.idProgetto;
      }
      vm.filePattern = '.csv,.xls,.xlsx,.doc,docx,.pdf,.pcap,.zip,.wav,.mp3,image/*';
      api.allegati.editForm({contesto:contesto})
        .then(showModal);
      function showModal(formData) {
        vm.formData = formData;
        allegatoEditModal.$promise
          .then(allegatoEditModal.show);
      }
    }

    function updateAllegato(event, idAllegato) {
      vm.action = 'update';
      vm.alerts = [];

      api.allegati.editForm()
        .then(getAllegato);

      function getAllegato(formData) {
        vm.formData = formData;

        api.allegato(idAllegato).get()
          .then(showModal);

        function showModal(allegato) {
          vm.allegato = allegato;
          vm.allegato.mainUrl = apiBaseUrl + '/allegati/' + vm.allegato.id;
          allegatoEditModal.$promise
            .then(allegatoEditModal.show);
        }
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      if (vm.action === 'create') {
        var file = vm.allegato.fileAllegato;
        file.upload = api.allegati.save(vm.allegato)
          .then(allegatoEditModal.hide, setAlerts, uploadProgress);
      } else if (vm.action === 'update') {
        delete vm.allegato.fileAllegato;
        api.allegato(vm.allegato.id).update(vm.allegato)
          .then(allegatoEditModal.hide, setAlerts);
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }

      function uploadProgress(event) {
        file.progress = Math.min(100, parseInt(100.0 * event.loaded / event.total));
      }

    }

    function undoForm() {
      allegatoEditModal.hide();
    }

  }

})();

(function() {
  'use strict';

  angular.module('g1.coord', [
      'g1.core'
    ])
    .constant('baseRoute', '/coord')
    .config(routeConfig)

  ;

  //////////////////////////////////////////////////////////////////////////////
  function routeConfig($routeProvider, baseRoute) {
    /** routing */
    $routeProvider
      .when(baseRoute, {
        templateUrl: 'app/coord/home/home.html',
        controller: 'CoordHomeController',
        controllerAs: 'home',
        security: 'COORD',
        title: 'Home'
      })
      .when(baseRoute + '/sviluppo-vendite/liste', {
        templateUrl: 'app/core/liste/liste.html',
        controller: 'ListeController',
        controllerAs: 'liste',
        security: 'COORD',
        title: 'Sviluppo vendite / Liste'
      })
      .when(baseRoute + '/sviluppo-vendite', {
        templateUrl: 'app/coord/sviluppo-vendite/sviluppo-vendite.html',
        controller: 'CoordSviluppoVenditeController',
        controllerAs: 'sviluppoVendite',
        security: 'COORD',
        title: 'Sviluppo Vendite'
      })
      .when('/pv', {
        templateUrl: 'app/core/pv/pv.html',
        controller: 'PvController',
        controllerAs: 'pv',
        security: 'COORD',
        title: 'Ticket'
      })
      .when('/pv/realizzazioni', {
        templateUrl: 'app/core/pv/realizzazioni.html',
        controller: 'RealizzazioniController',
        controllerAs: 'rc',
        security: 'COORD',
        title: 'Realizzazioni'
      })
      .when('/pv/:id', {
        templateUrl: 'app/core/pv/pv-view.html',
        controller: 'PvViewController',
        controllerAs: 'pvc',
        security: 'COORD',
        title: 'Ticket'
      })
      .when('/ricerca/pv', {
        templateUrl: 'app/core/ricerca/pv.html',
        controller: 'RicercaPvController',
        controllerAs: 'rpc',
        security: true,
        title: 'Ricerca Ticket'
      })
      .when('/copertura', {
        templateUrl: 'app/core/copertura/copertura.html',
        controller: 'CoperturaController',
        controllerAs: 'cc',
        security: true,
        title: 'Copertura'
      })
    ;
  }
})();

(function() {
  'use strict';

  angular.module('g1.coord')
    .controller('CoordSviluppoVenditeController', CoordSviluppoVenditeController);

  function CoordSviluppoVenditeController($rootScope, $scope, AuthenticateJS, dtFactory, DTOptionsBuilder, api, apiBaseUrl) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.widgetListe = {
      liste: [],
      dt: {},
      formData: {},
      sl: {},
      submitForm: dtListeReload
    };
    vm.widgetChiamate = {
      st: {},
      chiamateOperatori: [],
      totali: {
        telefonate: 0,
        chiamati: 0,
        appuntamenti: 0,
        resaTelefonate: 0.00,
        resaChiamati: 0.00
      },
      dt: {},
      submitForm: wcSubmitForm,
      setDate: wcSetDate,
      checkActiveButton: wcCheckActiveButton
    };

    //widget campagne
    vm.readClientiLista = api.liste.actions.readClienti;
    vm.importLista = api.liste.actions.import;
    vm.createLista = api.liste.actions.create;
    vm.updateLista = api.liste.actions.update;
    vm.deleteLista = api.liste.actions.delete;
    vm.manageLista = api.liste.actions.manage;
    vm.assignLista = api.liste.actions.assign;
    vm.removeLista = api.liste.actions.remove;
    vm.moveLista = api.liste.actions.move;
    vm.exportLista = exportLista;

    //widget chiamate
    vm.readListeOperatore = function readListeOperatore(filtro) {
      $rootScope.$broadcast('readListeOperatore', filtro);
    };
    vm.readTelefonate = function(filtroTelefonate) {
      $rootScope.$broadcast('readTelefonate', filtroTelefonate);
    };
    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };

    widgetListe();
    if (vm.user.userGroup >= 5) {
      widgetChiamate();
    }

    //widget campagne
    $scope.$on('Lista.created', dtListeReload);
    $scope.$on('Lista.updated', dtListeReload);
    $scope.$on('Lista.deleted', dtListeReload);
    //widget chiamate
    $scope.$watchCollection('sviluppoVendite.widgetChiamate.chiamateOperatori', wcSumChiamate);

    ////////////////////////////////////////////////////////////////////////////
    //widget campagne
    function widgetListe() {
      api.liste.searchForm({'woAll': true}).then(function (formData) {
        vm.widgetListe.formData = formData;
      });

      vm.widgetListe.sl = {
        obsoleto: '0',
        'tipoMotivo[]': [
          'TELECOM',
          'TIM',
          'SEGNALAZIONI',
          'CLYCO',
          'RICHIAMI'
        ]
      };

      dtListe();

      //////////////////////////////////////////////////////////////////////////
      function dtListe() {
        vm.widgetListe.dt.instance = {};

        vm.widgetListe.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function () {
            var promise = api.liste.list(vm.widgetListe.sl);

            promise.then(function(response) {
              vm.widgetListe.liste = response;
            });

            return promise;
          })
          // .fromFnPromise(function() {
          //   return liste.$promise;
          // })
          .withOption('order', [0, 'desc'])
          .withOption('info', false)
          .withOption('pageLength', 25)
          .withOption('lengthChange', false)
          .withOption('searching', false)
        );

        if (vm.user.userGroup >= 5) {
          vm.widgetListe.dt.options
            .withOption('dom', "rt<'row'<'col-xs-4'B><'col-xs-8'p>>")
            .withButtons([
              {
                text: '<span title="Genera campagna da filtri">Genera</span>',
                className: 'btn-success',
                action: vm.importLista
              },
              {
                text: '<span title="Inserisci campagna vuota">Inserisci</span>',
                className: 'btn-success',
                action: vm.createLista
              }
            ])
          ;
        } else {
          vm.widgetListe.dt.options
            .withOption('dom', "rt<'row'<'col-xs-12'p>>")
          ;
        }

        vm.widgetListe.dt.columns = [
          {
            data: 'dataInserimento',
            title: 'data',
            render: dtFactory.renders.date
          },
          {
            data: 'descrizione',
            title: 'Campagna',
            render: renderDescrizione
          },
          {
            data: 'tipoMotivo',
            title: 'Tipo'
          },
          {
            data: 'clienti',
            title: 'Clienti',
            render: renderClienti,
            'class': 'min-width text-right'
          },
          {
            data: 'chiamati',
            title: 'Chiamati',
            render: renderChiamati,
            'class': 'min-width text-right'
          },
          {
            data: 'aperti',
            title: '<span title="Non Lavorati">N/L</span>',
            render: renderAperti,
            'class': 'min-width text-right'
          },
          {
            data: 'daAssegnare',
            title: '<span title="Non Assegnati">N/A</span>',
            render: renderDaAssegnare,
            'class': 'min-width text-right'
          },
          {
            data: 'appuntamentati',
            title: '<span title="Appuntamentati">App.ti</span>',
            render: renderAppuntamenti,
            'class': 'min-width text-right'
          },
          {
            data: 'resa',
            title: 'Resa',
            render: renderResa,
            'class': 'min-width text-right'
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-right',
            orderable: false,
            searchable: false
          }
        ];

        //////////////////////////////////////////////////////////////////////
        function _linkClienti(title, idMotivo, filtro, data) {
          if (isNaN(data) || (data * 1) > 0) {
            var template = _.template('<a title="${ title }" ng-click=\'sviluppoVendite.readClientiLista("${ idMotivo }", ${ filtro })\'>${ data }</a>');

            data = template({
              title: title,
              idMotivo: idMotivo,
              filtro: angular.toJson(filtro),
              data: data
            });
          }

          return data;
        }

        function renderDescrizione(data, type, row) {
          if (type === 'display') {
            data = '<a title="gestisci campagna" ng-click="sviluppoVendite.manageLista(' + row.id + ')">' + data + '</a>';

            if (row.resa <= 3.00) {
              data += '<i class="fa fa-meh-o text-danger larger" style="margin-left:10px;"></i>';
            } else if(row.resa >= 8.00) {
              data += '<i class="fa fa-line-chart text-success larger" style="margin-left:10px;"></i>';
            }

            if (row.cieca) {
              data += '<i class="fa fa-eye-slash larger" style="margin-left:10px;" title="Cieca"></i>';
            }
          }

          return data;
        }

        function renderClienti(data, type, row) {
          if (type === 'display') {
            var filtro = {
              motivo: _.escape(row.descrizione)
            };

            data = _linkClienti('apri clienti in campagna', row.id, filtro, data);
          }

          return data;
        }

        function renderChiamati(data, type, row) {
          if (type === 'display') {
            var filtro = {
              motivo: _.escape(row.descrizione),
              chiamati: '',
              stato: 'Chiamati'
            };

            data = _linkClienti('apri clienti chiamati', row.id, filtro, data);
          }

          return data;
        }

        function renderAperti(data, type, row) {
          if (type === 'display') {
            var filtro = {
              motivo: _.escape(row.descrizione),
              aperti: '',
              stato: 'Non Lavorati'
            };

            data = _linkClienti('apri clienti non lavorati', row.id, filtro, data);
          }

          return data;
        }

        function renderDaAssegnare(data, type, row) {
          if (type === 'display') {
            if ((data * 1) > 0 && vm.user.userGroup >= 5) {
              data = '<a title="assegna clienti" ng-click="sviluppoVendite.assignLista(\'' + row.id + '\')">' + data + '</a>';
            }
          }

          return data;
        }

        function renderAppuntamenti(data, type, row) {
          if (type === 'display') {
            if ((data * 1) > 0) {
              var template = _.template('<a title="apri appuntamenti" ng-click=\'sviluppoVendite.readAppuntamenti(${ filtro })\'>${ data }</a>');

              data = template({
                filtro: angular.toJson({
                  idMotivo: row.id,
                  motivo: _.escape(row.descrizione)
                }),
                data: data
              });
            }
          }

          return data;
        }

        function renderResa(data, type) {
          if (type === 'display') {
            data = data + '%';
          }

          return data;
        }

        function renderActions(data, type, row) {
          var actions = '';
          var upd = '<button type="button" class="btn btn-warning btn-xs" title="Modifica" ng-click="sviluppoVendite.updateLista(\'' + data + '\')"><i class="fa fa-pencil"></i></button>';
          var del = '<button type="button" class="btn btn-danger btn-xs" title="Cancella" ng-click="sviluppoVendite.deleteLista(\'' + data + '\')"><i class="fa fa-minus"></i></button>';

          var gest = '' +
            '<button type="button" class="btn btn-primary btn-xs" title="Gestisci" bs-dropdown data-placement="left"><i class="fa fa-cog"></i></button>&nbsp;' + '\n' +
            '<ul class="dropdown-menu" role="menu">' + '\n' +
            '  <li><a ng-click="sviluppoVendite.removeLista(\'' + data + '\')"><i class="fa fa-fw fa-user-times"></i>&nbsp;Rimuovi Clienti</a></li>' + '\n' +
            '  <li><a ng-click="sviluppoVendite.moveLista(\'' + data + '\')"><i class="fa fa-fw fa-exchange"></i>&nbsp;Sposta Clienti</a></li>' + '\n' +
            '  <li><a ng-click="sviluppoVendite.exportLista(\'' + data + '\', ' + row.clienti + ')"><i class="fa fa-fw fa-table"></i>&nbsp;Esporta</a></li>' + '\n' +
            '</ul>'
          ;

          if (vm.user.userGroup >= 5) {
            actions = upd + '&nbsp;' + gest + del;
          }

          return actions;
        }
      }
    }

    function dtListeReload() {
      vm.widgetListe.dt.instance.reloadData();
    }

    function exportLista(idLista, numClienti) {
      dtFactory.exportFile(apiBaseUrl + '/liste/' + idLista + '/clienti', {
        'export': 'xlsx'
      }, numClienti);
    }

    //widget chiamate
    function widgetChiamate() {
      vm.widgetChiamate.st = {
        fromDate: moment().startOf('day').toDate(),
        toDate: moment().startOf('day').toDate()
      };

      dtChiamate();

      //////////////////////////////////////////////////////////////////////////
      function dtChiamate() {
        vm.widgetChiamate.dt.instance = {};

        vm.widgetChiamate.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function () {
            var promise = api.operatori.telefonate.list(vm.widgetChiamate.st);

            promise.then(function(response) {
              vm.widgetChiamate.chiamateOperatori = response;
            });

            return promise;
          })
          .withOption('order', [0, 'asc'])
          .withOption('dom', "rt<'row'<'col-xs-4'i><'col-xs-8'p>>")
          .withOption('pageLength', 25)
          .withOption('lengthChange', false)
          .withOption('searching', false)
        );

        vm.widgetChiamate.dt.columns = [
          {
            data: 'operatore',
            title: 'Operatore',
            render: renderOperatore
          },
          {
            data: 'telefonate',
            title: 'Telefonate',
            render: renderTelefonate,
            'class': 'min-width text-center'
          },
          {
            data: 'chiamati',
            title: 'Clienti',
            'class': 'min-width text-center'
          },
          {
            data: 'appuntamenti',
            title: 'Appuntamenti',
            render: renderAppuntamenti,
            'class': 'min-width text-center'
          },
          {
            data: 'resaTelefonate',
            title: '<span title="Resa Telefonate">Resa Tel.</span>',
            render: renderResa,
            'class': 'min-width text-center'
          },
          {
            data: 'resaChiamati',
            title: '<span title="Resa Clienti Chiamati">Resa Clienti</span>',
            render: renderResa,
            'class': 'min-width text-center'
          },
          {
            data: 'operatore',
            render: renderActions,
            orderable: false,
            searchable: false
          }
        ];

        ////////////////////////////////////////////////////////////////////////
        function renderOperatore(data, type, row) {
          if (type === 'display') {
            var template = '<a title="dettaglio operatore" ng-click=\'sviluppoVendite.readListeOperatore(${ filtro })\'>${ data }</a>';

            if(row.resaChiamati <= 3.00) {
              template += '<i class="fa fa-meh-o text-danger larger" style="margin-left:10px;"></i>';
            } else if(row.resaChiamati >= 8.00) {
              template += '<i class="fa fa-line-chart text-success larger" style="margin-left:10px;"></i>';
            }

            template = _.template(template);


            data = template({
              filtro: angular.toJson({
                fromDate: vm.widgetChiamate.st.fromDate,
                toDate: vm.widgetChiamate.st.toDate,
                idOperatore: row.idOperatore,
                operatore: row.operatore
              }),
              data: data
            });
          }

          return data;
        }

        function renderTelefonate(data, type, row) {
          if (type === 'display') {
            if ((data * 1) > 0) {
              var template = _.template('<a title="apri telefonate" ng-click=\'sviluppoVendite.readTelefonate(${ filtro })\'>${ data }</a>');

              data = template({
                filtro: angular.toJson({
                  fromDate: vm.widgetChiamate.st.fromDate,
                  toDate: vm.widgetChiamate.st.toDate,
                  idOperatore: row.idOperatore,
                  operatore: row.operatore
                }),
                data: data
              });
            }
          }

          return data;
        }

        function renderAppuntamenti(data, type, row) {
          if (type === 'display') {
            if ((data * 1) > 0) {
              var template = _.template('<a title="apri appuntamenti" ng-click=\'sviluppoVendite.readAppuntamenti(${ filtro })\'>${ data }</a>');

              data = template({
                filtro: angular.toJson({
                  fromDate: vm.widgetChiamate.st.fromDate,
                  toDate: vm.widgetChiamate.st.toDate,
                  idOperatore: row.idOperatore,
                  operatore: row.operatore,
                  idMotivo: 'TUTTI'
                }),
                data: data
              });
            }
          }

          return data;
        }

        function renderResa(data, type) {
          if (type === 'display') {
            data = data + '%';
          }

          return data;
        }

        function renderActions(data, type, row) {
          var template = _.template('<button type="button" class="btn btn-primary btn-xs" title="campagne attive" ng-click=\'sviluppoVendite.readListeOperatore(${ filtro })\'><i class="fa fa-cog"></i></button>');

          data = template({
            filtro: angular.toJson({
              idOperatore: row.idOperatore,
              operatore: row.operatore,
              obsoleto: '0'
            })
          });

          return data;
        }
      }
    }

    function wcSubmitForm() {
      vm.widgetChiamate.dt.instance.reloadData(null, true);
    }

    function wcSetDate(period) {
      switch (period) {
        case 'month': //oggi - 30gg
          vm.widgetChiamate.st.fromDate = moment().subtract(1, 'month')
            .startOf('day').toDate();
          vm.widgetChiamate.st.toDate = moment()
            .startOf('day').toDate();
          break;

        case 'week': //oggi - 7gg
          vm.widgetChiamate.st.fromDate = moment().subtract(1, 'week')
            .startOf('day').toDate();
          vm.widgetChiamate.st.toDate = moment()
            .startOf('day').toDate();
          break;

        case 'now': //jshint ignore:line
        default:
          vm.widgetChiamate.st.fromDate = moment()
            .startOf('day').toDate();
          vm.widgetChiamate.st.toDate = moment()
            .startOf('day').toDate();
          break;
      }

      vm.widgetChiamate.submitForm();
    }

    function wcSumChiamate(chiamateOperatori) {
      vm.widgetChiamate.totali.telefonate = _.sum(_.pluck(chiamateOperatori, 'telefonate'));
      vm.widgetChiamate.totali.chiamati = _.sum(_.pluck(chiamateOperatori, 'chiamati'));
      vm.widgetChiamate.totali.appuntamenti = _.sum(_.pluck(chiamateOperatori, 'appuntamenti'));

      if (vm.widgetChiamate.totali.telefonate > 0) {
        vm.widgetChiamate.totali.resaTelefonate = _.round((vm.widgetChiamate.totali.appuntamenti / vm.widgetChiamate.totali.telefonate) * 100, 2);
      }
      if (vm.widgetChiamate.totali.chiamati > 0) {
        vm.widgetChiamate.totali.resaChiamati = _.round((vm.widgetChiamate.totali.appuntamenti / vm.widgetChiamate.totali.chiamati) * 100, 2);
      }
    }

    function wcCheckActiveButton(period) {
      switch (period) {
        case 'month': //oggi - 30gg
          return (
            moment(vm.widgetChiamate.st.fromDate).isSame(moment().subtract(1, 'month'), 'day')
            &&
            moment(vm.widgetChiamate.st.toDate).isSame(moment(), 'day')
          );

        case 'week': //oggi - 7gg
          return (
            moment(vm.widgetChiamate.st.fromDate).isSame(moment().subtract(1, 'week'), 'day')
            &&
            moment(vm.widgetChiamate.st.toDate).isSame(moment(), 'day')
          );

        case 'now': //jshint ignore:line
        default:
          return (
            moment(vm.widgetChiamate.st.fromDate).isSame(moment(), 'day')
            &&
            moment(vm.widgetChiamate.st.toDate).isSame(moment(), 'day')
          );
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('OmniboxController', OmniboxController);

  function OmniboxController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var omniboxModal = $modal({
      scope: $scope,
      templateUrl: 'omnibox-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.dtClienti = {};
    vm.readCliente = api.clienti.actions.read;
    vm.updateCliente = api.clienti.actions.update;
    vm.deleteCliente = api.clienti.actions.delete;

    $scope.$on('searchOmnibox', searchOmnibox);

    $scope.$on('Cliente.created', dtClientiReload);
    $scope.$on('Cliente.updated', dtClientiReload);
    $scope.$on('Cliente.deleted', dtClientiReload);

    ////////////////////////////////////////////////////////////////////////////
    //gestione ricerca
    function searchOmnibox(event, omnibox) {
      vm.formData = omnibox;

      vm.dtClienti = {};
      dtClienti();

      omniboxModal.$promise
        .then(omniboxModal.show);
    }

    //gestione clienti
    function dtClienti() {
      api.clienti.list({
        omnibox: {
          searchTerm: vm.formData.searchTerm,
          selected: vm.formData.selected
        }
      }).then(renderDt);

      function renderDt(clienti) {
        if (clienti.length === 1) {
          vm.readCliente(clienti[0].id);
          omniboxModal.hide();
          return;
        }

        vm.dtClienti.dtInstance = {};

        vm.dtClienti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return clienti.$promise;
          })
          .withOption('order', [[4, 'asc'],[1, 'asc']] )
          .withOption('lengthChange', false)
          .withOption('searching', false)
          .withOption('createdRow', createdRow)
        );

        vm.dtClienti.dtColumns = [
          {
            data: 'id',
            title: 'ID',
            type: 'num',
            render: renderCliente
          },
          {
            data: 'ragSoc',
            title: 'Rag. Soc.',
            'class': '',
            render: renderCliente
          },
          {
            data: 'citta',
            title: 'Città',
            render: renderCitta
          },
          {
            data: 'indirizzo',
            title: 'Indirizzo',
            'class': '',
            render: renderIndirizzo
          },
          {
            data: 'ptf',
            title: 'Cluster'
          },
          {
            data: 'agenteCognome',
            title: 'Agente',
            render: renderAgente
          },
          {
            data: 'tel',
            title: 'Tel'
          }
        ];

        //////////////////////////////////////////////////////////////////////////
        function createdRow(row, data) {
          /* gestione dello stile di ogni riga */
          if (data.privacy) {
            angular.element(row).addClass('text-danger');
          }
        }

        function renderCliente(data, type, row) {
          if (type === 'display') {
            return '<a title="apri cliente" ng-click="omnibox.readCliente(' + row.id + ')">' + data + '</a>';
          }

          return data;
        }

        function renderIndirizzo(data, type, row) {
          return row.indirizzo + (row.civico ? ','+row.civico : '');
        }

        function renderCitta(data, type, row) {
          return row.citta + (row.prov ? ' ('+row.prov+')' : '');
        }

        function renderAgente(data, type, row) {
          return row.agenteCognome + ' ' + row.agenteNome;
        }
      }
    }

    function dtClientiReload() {
      if (!_.isEmpty(vm.dtClienti.dtInstance)) {
        vm.dtClienti.dtInstance.reloadData();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.coord')
    .controller('CoordHomeController', CoordHomeController);

  function CoordHomeController(
    $rootScope, $scope, $filter, $interval, AuthenticateJS, dtFactory, DTOptionsBuilder, api, $window
  ) {
    var vm = this;
    var stops = [];

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.q = '?';
    vm.qValues = [];
    vm.totaleRicorrente = 0;
    vm.giorni = {};
    vm.responseAvanzamenti = {};
    vm.clyco = {
      piste: [],
      totale: {},
      warnings: [],
      img: ''
    };

    vm.chartAvanzamento = {};
    vm.chartOpportunita = {};
    vm.bckdReport = null;
    vm.cngpReport = null;
    vm.pvReport = null;
    vm.pvFormData = {};
    vm.pvDashboard = api.pv().actions.dashboard;

    //widget campagne
    vm.dtCampagne = {};
    vm.readClientiLista = api.liste.actions.readClienti;
    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };
    vm.readContratti = function(filtroContratti) {
      $rootScope.$broadcast('readContratti', filtroContratti);
    };

    //widget opportunita
    vm.dtProgetti = {};
    vm.contrattiInScadenza = [];
    vm.readClientiLista = api.liste.actions.readClienti;
    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };
    vm.readContratti = function(filtroContratti) {
      $rootScope.$broadcast('readContratti', filtroContratti);
    };

    vm.canoniRicorrenti = function () {
      $window.location = '/#/reports/cnrm';
    }

    //omnibox
    vm.omnibox = {
      searchTerm: '',
      selected: [
        'idCliente',
        'ragSoc',
        'cf',
        'piva',
        'tel',
        'cell',
        'email',
        'referente'
      ],
      options: [
        {value:'idCliente',label:'<i class=\"fa fa-fw fa-id-card\"></i> ID'},
        {value:'ragSoc',label:'<i class=\"fa fa-fw fa-user\"></i> Ragione Sociale'},
        {value:'cf',label:'<i class=\"fa fa-fw fa-address-card\"></i> C.F.'},
        {value:'piva',label:'<i class=\"fa fa-fw fa-address-card\"></i> P.IVA'},
        {value:'tel',label:'<i class=\"fa fa-fw fa-phone\"></i> Telefono'},
        {value:'cell',label:'<i class=\"fa fa-fw fa-mobile-phone\"></i> Cellulare'},
        {value:'email',label:'<i class=\"fa fa-fw fa-envelope\"></i> Email'},
        {value:'referente',label:'<i class=\"fa fa-fw fa-user\"></i> Referente'}
      ]
    };
    vm.searchOmnibox = searchOmnibox;

    //carica avanzamenti
    avanzamenti();
    stops.push($interval(avanzamenti, 1000 * 60 * 10));

    chartAvanzamento();
    stops.push($interval(chartAvanzamento, 1000 * 60 * 10));

    chartOpportunita();
    stops.push($interval(chartOpportunita, 1000 * 60 * 10));

    //carica widget campagna
    dtCampagne();

    //carica widget progetti
    dtProgetti();

    //carica widget contratti in scadenza
    loadContrattiInScadenza();

    //carica report bckd
    api.report('bckd').searchForm()
      .then(bckdFormLoaded);

    //carica report cngp
    api.report('cngp').searchForm()
      .then(cngpFormLoaded);

    //carica reports pv
    api.report('pvfp').searchForm().then( function ( formData ) {
      vm.pvFormData = formData;
      pvFormLoaded();
    } );

    //imposta stop del refresh
    $scope.$on('$destroy', stopRefresh);

    ////////////////////////////////////////////////////////////////////////////
    function avanzamenti() {
      api.list('/coord', 'CoordHome').get()
        .then(setAvanzamenti);

      function setAvanzamenti(response) {
        //salvo la response per usarla in seguito
        vm.responseAvanzamenti = response;

        //imposta numero q
        vm.q = moment(response.q.start).quarter();

        vm.totaleRicorrente = 0; // resetto per evitare che le somme si sommino
        // imposta valori per Q e totale
        vm.qValues = response.qValues;
        for ( var i in response.qValues ) {
          vm.totaleRicorrente += response.qValues[i].ricorrente;
        }

        //calcolo percentuali dei giorni
        response.giorni.perc = percentual(response.giorni.adv, response.giorni.obj);
        response.giorni.status = getStatus(response.giorni.perc, true);
        vm.giorni = response.giorni;

        //calcolo avanzamenti
        vm.clyco.totale = response.clyco.totale;

        vm.clyco.piste = setPiste(response.clyco.piste, vm.giorni.perc, vm.clyco.totale.adv);

        //impostazione dei warnings
        vm.clyco.warnings = response.clyco.warnings;

        //calcolo stati globali
        vm.clyco.totale.perc = percentual(vm.clyco.totale.adv, vm.clyco.totale.obj);
        vm.clyco.totale.status = getStatus(vm.clyco.totale.perc);
        vm.clyco.img = getImg(percentual(vm.clyco.totale.perc, vm.giorni.perc));
      }
      ////////////////////////////////////////////////////////////////////////
      function setPiste(piste, giorniPerc, totale) {
        angular.forEach(piste, function(value, key) {
          piste[key].perc = percentual(piste[key].adv, totale);
          piste[key].status = getStatus(percentual(piste[key].perc, giorniPerc));
        });

        return piste;
      }

      function percentual(n, tot) {
        return (n / tot) * 100;
      }

      function getStatus(perc, reverse) {
        var status = '';
        var classes = ['danger', 'default', 'success'];

        if (perc <= 33.3) {
          status = classes[reverse ? 2 : 0];
        } else if ((perc > 33.3) && (perc <= 66.6)) {
          status = classes[reverse ? 1 : 1];
        } else {
          status = classes[reverse ? 0 : 2];
        }

        return status;
      }

      function getImg(perc) {
        if (perc <= 25) {
          return 1;
        } else if ((perc > 25) && (perc <= 50)) {
          return 2;
        } else if ((perc > 50) && (perc <= 75)) {
          return 3;
        } else if ((perc > 75) && (perc <= 99)) {
          return 4;
        } else {
          return 5;
        }
      }
    }

    function chartAvanzamento() {
      vm.chartAvanzamento.setStati = setStati;

      vm.chartAvanzamento.id = 'gav';
      vm.chartAvanzamento.title = 'in caricamento...';
      vm.chartAvanzamento.total = '0';

      api.chart(vm.chartAvanzamento.id).searchForm()
        .then(showChart);

      function showChart(formData) {
        vm.chartAvanzamento.formData = formData;
        vm.chartAvanzamento.options = {
          height: '400px',
          anno: vm.chartAvanzamento.formData.anno,
          tipoData: vm.chartAvanzamento.formData.tipoData,
          'idStati[]': vm.chartAvanzamento.formData.idStati,
          tipo: vm.chartAvanzamento.formData.tipo
        };

      }

      function setStati(tipoData) {
        var idStati4tipoData = [];

        switch (tipoData) {
          case 'crm':
            // idStati4tipoData = _.map($filter('filter')(vm.chartAvanzamento.formData.stati, {gruppo: '1 OK'}, true), 'value');
            idStati4tipoData = ['3', '5', '6', '13'];
            break;

          case 'inserimento':
            idStati4tipoData = _.map($filter('filter')(vm.chartAvanzamento.formData.stati, {gruppo: '!4 ANNULLATO'}, true), 'value');
            break;

          case 'conferma':
            angular.forEach(vm.chartAvanzamento.formData.stati, function(value) {
              if (value.gruppo === '1 OK' || value.gruppo === '2 LAVORAZIONE') {
                idStati4tipoData.push(value.value);
              }
            });
            break;
        }

        vm.chartAvanzamento.options['idStati[]'] = idStati4tipoData;
      }
    }

    function chartOpportunita() {
      vm.chartOpportunita.id = 'goppo';
      vm.chartOpportunita.title = 'in caricamento...';
      vm.chartOpportunita.total = '0';

      api.chart(vm.chartOpportunita.id).searchForm()
        .then(showChart);

      function showChart(formData) {
        vm.chartOpportunita.formData = formData;
        vm.chartOpportunita.options = {
          height: '400px',
          dataFrom: vm.chartOpportunita.formData.dataFrom,
          dataTo: vm.chartOpportunita.formData.dataTo,
          tipo: vm.chartOpportunita.formData.tipo,
          actionOnClick: null
        };
      }
    }

    function dtCampagne() {
      vm.dtCampagne.dtInstance = {};

      vm.dtCampagne.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.list('/liste/reports/wchc', 'WchcListe').list)
        .withOption('order', [1, 'desc'])
        .withOption('dom', 'tr')
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtCampagne.dtColumns = [
        {data: 'descrizione', title: 'Campagna'},
        {
          data: 'clienti',
          title: 'Clienti',
          render: renderClienti,
          'class': 'min-width text-right'
        },
        {
          data: 'appuntamentati',
          title: 'Appuntamenti',
          render: renderAppuntamenti,
          'class': 'min-width text-right'
        },
        {
          data: 'vendite',
          title: 'Vendite',
          render: renderContratti,
          'class': 'min-width text-center'
        }
      ];

      //////////////////////////////////////////////////////////////////////
      function _linkClienti(title, idMotivo, filtro, data) {
        if (isNaN(data) || (data * 1) > 0) {
          var template = _.template('<a title="${ title }" ng-click=\'home.readClientiLista("${ idMotivo }", ${ filtro })\'>${ data }</a>');

          data = template({
            title: title,
            idMotivo: idMotivo,
            filtro: angular.toJson(filtro),
            data: data
          });
        }

        return data;
      }

      function renderClienti(data, type, row) {
        if (type === 'display') {
          var filtro = {
            motivo: _.escape(row.descrizione)
          };

          data = _linkClienti('apri clienti in campagna', row.id, filtro, data);
        }

        return data;
      }

      function renderAppuntamenti(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri appuntamenti" ng-click=\'home.readAppuntamenti(${ filtro })\'>${ data }</a>');

            data = template({
              filtro: angular.toJson({
                idMotivo: row.id,
                motivo: _.escape(row.descrizione)
              }),
              data: data
            });
          }
        }

        return data;
      }

      function renderContratti(data, type, row) {
        if (type === 'display') {
          if ((data * 1) > 0) {
            var template = _.template('<a title="apri contratti" ng-click=\'home.readContratti(${ filtro })\'>${ data }</a>');

            data = template({
              filtro: angular.toJson({
                idMotivo: row.id,
                motivo: _.escape(row.descrizione)
              }),
              data: data
            });
          }
        }

        return data;
      }
    }

    function dtProgetti() {
      var getData = function () {
        var promise = api.list( '/liste/reports/prog', 'progListe' ).list();

        return promise;
      }
      vm.dtProgetti.dtInstance = {};
      vm.dtProgetti.dtOptions = dtFactory.addDefaultOptions( $scope, DTOptionsBuilder
        .fromFnPromise( getData )
        .withOption( 'order', [0, 'desc'] )
        .withOption( 'dom', 'tr' )
        .withOption( 'info', false )
        .withOption( 'lengthChange', false )
        .withOption( 'searching', false )
        .withOption( 'paging', false )
      );
      vm.dtProgetti.dtColumns = [
        {
          data: 'pista',
          title: 'Pista',
          class: 'col-pista'
        },
        {
          data: 'aperti',
          title: 'Aperti',
          class: 'col-progetti-aperti',
          render: renderAperti
        },
        {
          data: 'chiusi',
          title: 'Chiusi',
          class: 'col-numeric'
        },
        {
          data: 'totale',
          title: 'Totale',
          class: 'col-numeric'
        }
      ];
      function renderAperti( data, type, row ) {
        var output = '';
        angular.forEach( row.stage, function ( value ) {
          if ( value.progettiAperti > 0 ) {
            output += '<span class="progettiAperti" bs-tooltip data-title="' + value.fase + '">' + value.progettiAperti + '</span>';
          }
        } );
        return output;
      }
    }

    function loadContrattiInScadenza() {
      var promise = api.list( '/liste/reports/cntrsc', 'cntrscListe' ).list();
      promise.then( function ( data ) {
        for ( var i in data[0] ) {
          if ( typeof data[0][i] == 'object' ) {
            vm.contrattiInScadenza.push( data[0][i] );
          }
        }
      } );
    }

    function bckdFormLoaded(formData) {
      loadbckd();
      stops.push($interval(loadbckd, 1000 * 60 * 10));

      function loadbckd() {
        vm.bckdReport = {
          options: {
            l: 0,
            dataFrom: formData.intervallo.from,
            dataTo: formData.intervallo.to,
            fornitore: formData.fornitore,
            tipo: formData.tipo,
            'idStatiContratto[]': formData.idStatiContratto
          },
          dtOptions: {
            paginate: false,
            compact: true
          }
        };
      }
    }

    function cngpFormLoaded(formData) {
      loadcngp();
      stops.push($interval(loadcngp, 1000 * 60 * 10));

      function loadcngp() {
        vm.cngpReport = {
          options: {
            l: 0,
            dataFrom: formData.intervallo.from,
            dataTo: formData.intervallo.to,
            fornitore: formData.fornitore,
            tipoData: formData.tipoData,
            'idStatiContratto[]': formData.idStatiContratto
          },
          dtOptions: {
            totals: false,
            paginate: false,
            compact: true,
            order: [
              [1, 'desc']
            ]
          }
        };
      }
    }

    function pvFormLoaded() {
      loadPv();
      stops.push($interval(loadPv, 1000 * 60 * 10));

      function loadPv() {
        var idAgenti = [];
        if (vm.user.flags.powerUser) {
          idAgenti = [];
        } else {
          idAgenti = [vm.user.idAgente];
        }
        vm.pvReport = {
          options: {
            l: 0,
            dataFrom: vm.pvFormData.intervallo.from,
            dataTo: vm.pvFormData.intervallo.to,
            tipo: '',
            'idAgenti[]': idAgenti,
            gb: 'pri'
          },
          dtOptions: {
            paginate: false,
            compact: true
          }
        };
        vm.pvReport_pv = {
          options: {
            l: 0,
            dataFrom: vm.pvFormData.intervallo.from,
            dataTo: vm.pvFormData.intervallo.to,
            tipo: 'pv',
            'idAgenti[]': idAgenti,
            gb: 'pri'
          },
          dtOptions: {
            paginate: false,
            compact: true
          }
        };
        vm.pvReport_real = {
          options: {
            l: 0,
            dataFrom: vm.pvFormData.intervallo.from,
            dataTo: vm.pvFormData.intervallo.to,
            tipo: 'real',
            'idAgenti[]': idAgenti,
            gb: 'pri'
          },
          dtOptions: {
            paginate: false,
            compact: true
          }
        };
      }
    }

    function searchOmnibox() {
      $rootScope.$broadcast('searchOmnibox', vm.omnibox);
    }

    function stopRefresh() {
      angular.forEach(stops, function(stop) {
        $interval.cancel(stop);
      });

      stops = [];
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('TelefonateElencoController', TelefonateElencoController);

  function TelefonateElencoController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var telefonateElencoModal = $modal({
      scope: $scope,
      templateUrl: 'telefonate-elenco-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.elenco = {};
    vm.filtro = {};
    vm.dtTelefonate = {};

    $scope.$on('readTelefonateElenco', readTelefonateElenco);
    vm.updateTelefonata = api.telefonate.actions.update;
    vm.deleteTelefonata = api.telefonate.actions.delete;

    vm.readAppuntamento = api.appuntamenti.actions.read;

    //gestione telefonate
    $scope.$on('Telefonata.updated', dtTelefonateReload);
    $scope.$on('Telefonata.deleted', dtTelefonateReload);

    ////////////////////////////////////////////////////////////////////////////
    function readTelefonateElenco(event, idElenco, filtroElenco) {
      vm.filtro = filtroElenco;

      api.elenco(idElenco).get()
        .then(showModal);

      dtTelefonate(idElenco, filtroElenco);

      function showModal(elenco) {
        vm.elenco = elenco;

        telefonateElencoModal.$promise
          .then(telefonateElencoModal.show);
      }
    }

    function dtTelefonate(idElenco, filtroElenco) {
      vm.dtTelefonate.dtInstance = {};

      vm.dtTelefonate.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise( function() {
          return api.elenco(idElenco).telefonate.list(filtroElenco);
        })
        .withOption('order', [0, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtTelefonate.dtColumns = [
        {
          data: 'dataOra',
          title: 'Data',
          render: dtFactory.renders.datetime
        },
        {data: 'operatore', title: 'Operatore'},
        {
          data: 'esito',
          title: 'Esito',
          render: renderEsito
        },
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderEsito(data, type, row) {
        if (type === 'display') {
          if (row.idAppuntamento !== '') {
            return data + '&nbsp;' + '<i class="fa fa-external-link" title="apri appuntamento" ng-click="tec.readAppuntamento(\'' + row.idAppuntamento + '\')"></i>';
          }
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tec.updateTelefonata(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tec.deleteTelefonata(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (vm.user.userGroup >= 5) {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }
    }

    function dtTelefonateReload(event, telefonata) {
      if (event.name === 'Telefonata.deleted') {
        vm.dtTelefonate.dtInstance.reloadData();
      } else {
        if (telefonata.idElenco === vm.elenco.id) {
          vm.dtTelefonate.dtInstance.reloadData();
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ElencoUpdateController', ElencoUpdateController);

  function ElencoUpdateController($scope, $modal, api) {
    var vm = this;

    var elencoUpdateModal = $modal({
      scope: $scope,
      templateUrl: 'elenco-update-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.elenco = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('updateElenco', updateElenco);

    ////////////////////////////////////////////////////////////////////////////
    function updateElenco(event, idElenco) {
      api.elenchi.editForm()
        .then(getElenco);

      function getElenco(formData) {
        vm.formData = formData;

        api.elenco(idElenco).get()
          .then(showModal);

        function showModal(elenco) {
          vm.elenco = elenco;

          elencoUpdateModal.$promise
            .then(elencoUpdateModal.show);
        }
      }
    }

    function saveForm() {
      api.elenco(vm.elenco.id).update(vm.elenco)
        .then(elencoUpdateModal.hide);
    }

    function undoForm() {
      elencoUpdateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('ElencoCreateController', ElencoCreateController);

  function ElencoCreateController($scope, $modal, api) {
    var vm = this;

    var elencoCreateModal = $modal({
      scope: $scope,
      templateUrl: 'elenco-create-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.elenco = {};
    vm.cliente = {};
    vm.formData = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    $scope.$on('createElencoCliente', createElencoCliente);

    ////////////////////////////////////////////////////////////////////////////
    function createElencoCliente(event, cliente) {
      vm.cliente = cliente;
      vm.elenco = {
        idMotivo: '0',
        idOperatore: '0',
        idStatoElenco: '1',
        idCliente: cliente.id
      };

      api.elenchi.editForm({
        idCliente: cliente.id
      }).then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        elencoCreateModal.$promise
          .then(elencoCreateModal.show);
      }
    }

    function saveForm() {
      api.cliente(vm.elenco.idCliente)
        .elenchi.save(vm.elenco)
        .then(elencoCreateModal.hide);
    }

    function undoForm() {
      elencoCreateModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .factory('WTAPI', WildixWtapiFactory);

  function WildixWtapiFactory($window) {
    if(!$window.WTAPI){
      // If wtapi is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }

    return $window.WTAPI;
  }
})();

(function() {
  'use strict';
  angular.module('g1', [
      'g1.core',
      'g1.admin',
      'g1.coord',
      'g1.bo',
      'g1.agenti',
      'g1.cc'
    ]);
})();

(function() {
  'use strict';

  angular.module('g1')
    .directive('g1Alerts', g1Alerts);

  function g1Alerts() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/widgets/g1Alerts.tpl.html',
      scope: {
        status: '@',
        messages: '='
      },
      link: linkFn
    };

    function linkFn(scope) {
      scope.$watch('status', statusWatcher);

      function statusWatcher(status) {
        switch (status) {
          case '200':
            scope.type = 'success';
            break;

          case '500':
          case '409':
          case '413':
            scope.type = 'danger';
            break;

          case '417':
            scope.type = 'warning';
            break;

          default:
            scope.type = 'info';
            break;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .constant('progressConfig', {
      animate: true,
      max: 100
    })
    .controller('ProgressController', ProgressController)
    .directive('progress', progress)
    .directive('bar', bar)
    .directive('progressbar', progressbar)
  ;

  function ProgressController($attrs, progressConfig) {
    var vm = this,
      animate = angular.isDefined($attrs.animate) ? vm.$parent.$eval($attrs.animate) : progressConfig.animate;

    vm.bars = [];
    vm.max = angular.isDefined($attrs.max) ? vm.$parent.$eval($attrs.max) : progressConfig.max;

    vm.addBar = function (bar, element) {
      if (!animate) {
        element.css({'transition': 'none'});
      }

      vm.bars.push(bar);

      bar.$watch('value', function (value) {
        bar.percent = +(100 * value / vm.max).toFixed(2);
      });

      bar.$on('$destroy', function () {
        element = null;
        vm.removeBar(bar);
      });
    };

    vm.removeBar = function (bar) {
      vm.bars.splice(vm.bars.indexOf(bar), 1);
    };
  }

  function progress() {
    return {
      restrict: 'EA',
      replace: true,
      transclude: true,
      controller: 'ProgressController',
      require: 'progress',
      scope: {},
      templateUrl: 'app/components/progressbar/progress.html'
    };
  }

  function bar() {
    return {
      restrict: 'EA',
      replace: true,
      transclude: true,
      require: '^progress',
      scope: {
        value: '=',
        type: '@'
      },
      templateUrl: 'app/components/progressbar/bar.html',
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, element);
      }
    };
  }

  function progressbar() {
    return {
      restrict: 'EA',
      replace: true,
      transclude: true,
      controller: 'ProgressController',
      scope: {
        value: '=',
        type: '@'
      },
      templateUrl: 'app/components/progressbar/progressbar.html',
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, angular.element(element.children()[0]));
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .directive('percent', percent);

  function percent() {
    return {
      require: 'ngModel',
      scope: {
        precision: '@'
      },
      link: linkFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, element, attrs, ctrl) {
      if (!ctrl) return;

      //calculate precision
      if (angular.isUndefined(scope.precision)) {
        scope.precision = 0;
      } else {
        scope.precision = parseInt(scope.precision);
      }
      if (scope.precision < 0) {
        scope.precision = 0;
      }

      //parsers/formatters
      ctrl.$parsers.push(p);
      ctrl.$formatters.unshift(f);

      //validators
      if (angular.isDefined(ctrl.$validators.min)) {
        var parentMinValidator = ctrl.$validators.min;
        ctrl.$validators.min = minValidator;
      }
      if (angular.isDefined(ctrl.$validators.max)) {
        var parentMaxValidator = ctrl.$validators.max;
        ctrl.$validators.max = maxValidator;
      }

      //////////////////////////////////////////////////////////////////////////
      function p(viewValue) {
        var precision = parseInt(scope.precision);

        return parseFloat(
          (parseFloat(viewValue) / 100).toFixed(precision + 2)
        );
      }

      function f(modelValue){
        var precision = parseInt(scope.precision);

        return (parseFloat(modelValue) * 100).toFixed(precision);
      }

      function minValidator(modelValue, viewValue) {
        return parentMinValidator(viewValue);
      }

      function maxValidator(modelValue, viewValue) {
        return parentMaxValidator(viewValue);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .directive('numeric', numeric);

  function numeric() {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {},
      link: linkFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, element, attrs, ctrl) {
      if (!ctrl) return;

      //validators
      ctrl.$validators.numeric = numericFn;

      //////////////////////////////////////////////////////////////////////////
      function numericFn(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || /^\d+$/.test(viewValue);
      }
    }
  }
})();

(function() {
  'use strict';
  angular.module( 'g1' ).directive( 'greaterThanOrEqualTo', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        otherModelValue: '=greaterThanOrEqualTo',
        comparedFieldLabel: '@gtComparedFieldLabel',
        fieldType: '@gtFieldType',
        fieldName: '@gtFieldName'
      },
      link: function ( scope, element, attributes, ctrl ) {
        ctrl.$validators.greaterThanOrEqualTo = function ( modelValue ) {
          var value = modelValue;
          var cmpValue = scope.otherModelValue;
          if ( ! value || ! cmpValue ) {
            return true; // procedo solo se il campo ha un valore
          }
          if ( scope.fieldType && value && cmpValue ) {
            if ( scope.fieldType == 'datetime' ) {
              value = new Date( value ).getTime();
              cmpValue = new Date( cmpValue ).getTime();
            } else if ( scope.fieldType == 'date' ) {
              value = parseInt( moment( value ).format( 'YYYYMMDD' ) );
              cmpValue = parseInt( moment( cmpValue ).format( 'YYYYMMDD' ) );
            }
          }
          return value >= cmpValue;
        };
        scope.$watch( 'otherModelValue', function () {
          ctrl.$validate();
        } );
      }
    }
  } );
})();

(function() {
  'use strict';
  angular.module( 'g1' ).directive( 'greaterThan', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        otherModelValue: '=greaterThan',
        comparedFieldLabel: '@gtComparedFieldLabel',
        fieldType: '@gtFieldType'
      },
      link: function ( scope, element, attributes, ctrl ) {
        ctrl.$validators.greaterThan = function ( modelValue ) {
          var value = modelValue;
          var cmpValue = scope.otherModelValue;
          if ( scope.fieldType && scope.fieldType == 'datetime' && value && cmpValue ) {
            value = new Date( value ).getTime();
            cmpValue = new Date( cmpValue ).getTime();
          }
          return value > cmpValue;
        };
        scope.$watch( 'otherModelValue', function () {
          ctrl.$validate();
        } );
      }
    }
  } );  
})();

(function() {
  'use strict';

  angular.module('g1')
    .directive('equalTo', equalTo);

    function equalTo() {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          otherModelValue: '=equalTo',
          comparedFieldLabel: '@etComparedFieldLabel',
          fieldType: '@etFieldType'
        },
        link: linkFn
      };

      function linkFn(scope, element, attributes, ctrl) {

        ctrl.$validators.equalTo = function(modelValue) {
          var value = modelValue;
          var cmpValue = scope.otherModelValue;
          if (scope.fieldType&&scope.fieldType=='date'&&value&&cmpValue) {
            value = datetime2isoDate(value);
            cmpValue = datetime2isoDate(cmpValue);
          }
          return value == cmpValue;
        };
        scope.$watch('otherModelValue', function() {
          ctrl.$validate();
        });
      }
    }

    function datetime2isoDate(datetime) {
      return new Date(datetime).toISOString().split('T')[0];
    }

})();

(function() {
  'use strict';

  angular.module('g1')
    .directive('decimal', decimal);

  function decimal() {
    return {
      require: 'ngModel',
      scope: {
        precision: '@'
      },
      link: linkFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, element, attrs, ctrl) {
      if (!ctrl) return;

      //calculate precision
      if (angular.isUndefined(scope.precision)) {
        scope.precision = 2;
      } else {
        scope.precision = parseInt(scope.precision);
      }
      if (scope.precision < 0) {
        scope.precision = 0;
      }

      //parsers/formatters
      ctrl.$parsers.push(p);
      ctrl.$formatters.unshift(f);

      //////////////////////////////////////////////////////////////////////////
      function p(viewValue) {
        var precision = parseInt(scope.precision);

        return parseFloat(
          parseFloat(viewValue).toFixed(precision)
        );
      }

      function f(modelValue){
        var precision = parseInt(scope.precision);

        return parseFloat(modelValue).toFixed(precision);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .controller('NavbarController', NavbarController);

  function NavbarController($rootScope, $scope, $location, $filter, AuthenticateJS, $alert, bodyClass) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = null;

    vm.collapse = true;
    vm.changePassword = function() {
      vm.collapse = true;
      $rootScope.$broadcast('changePassword');
    };

    $scope.$on('AuthenticateJS.login', onLogin);
    $scope.$on('AuthenticateJS.logout', onLogout);

    $scope.$on('$routeChangeSuccess', function() {
      vm.collapse = true;
    });

    angular.element( 'body' ).addClass( bodyClass );

    vm.auth.check();

    ////////////////////////////////////////////////////////////////////////////
    function onLogin(event, user) {
      vm.user = user;

      if (vm.user.scadenza != '') {
        var daysDiff = moment.parseZone(vm.user.scadenza).diff(moment(), 'days');

        if (daysDiff <= 15) {
          var template = '\
            <div role="alert" class="alert container-fluid" ng-class="[type ? \'alert-\' + type : null]">\
              <button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button>\
              <span ng-if="title">\
                <strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span>\
              </span>\
              <span ng-if="!title" ng-bind-html="content"></span>\
            </div>\
          ';
          $alert({
            placement: 'top',
            title: 'Password in scadenza.',
            content: 'Cambiarla entro il ' + $filter('date')(vm.user.scadenza, 'short'),
            type: 'danger',
            template: template,
            ngClass: 'scadenzaPassword'
          });
          angular.element( 'body' ).addClass( 'hasExpiredPasswordAlert' );
        }
      }
    }

    function onLogout() {
      vm.user = null;
      $location.path('/login');
    }
  }
})();

(function() {
  'use strict';

  /* global interact:false */

  angular.module('g1')
    .directive('iDraggable', iDraggable)
    .directive('iResizable', iResizable)
  ;

  function iDraggable() {
    return {
      restrict: 'A',
      link: linkIDraggable
    };

    function linkIDraggable(scope, element, attrs) {
      var handle;
      var x = 0;
      var y = 0;

      if (!attrs.iDraggableHandle) {
        handle = element[0];
      }	else {
        handle = (element[0].querySelectorAll(attrs.iDraggableHandle))[0];
      }

      if(!handle) {
        throw 'draggable directive needs a valid handle attribute';
      }

      interact(handle)
        .ignoreFrom('input, button, a, *[ng-click]')
        .draggable({
          inertia: true,
          onmove: onDragMove
        })
      ;

      function onDragMove(event) {
        x += event.dx;
        y += event.dy;

        element[0].style.webkitTransform = element[0].style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      }
    }
  }

  function iResizable() {
    return {
      restrict: 'A',
      link: linkIResizable
    };

    function linkIResizable(scope, element) {
      var isModal = false;
      var modal = {};

      if (element.hasClass('modal-dialog')) {
        isModal = true;

        modal.content = (element[0].querySelectorAll('.modal-content'))[0];
        modal.body = (element[0].querySelectorAll('.modal-body'))[0];

        modal.body.style.overflow = 'auto';
        //modal.body.style.overflowY = 'auto';
      }

      interact(element[0])
        .ignoreFrom('input, button, a, *[ng-click]')
        .resizable({
          edges: {
            top: false,
            left: false,
            bottom: true,
            right: true
          },
          onmove: onResizeMove
        })
      ;

      function onResizeMove(event) {
        // update the element's style
        element[0].style.width = parseFloat(interact.getElementRect(element[0]).width) + event.dx + 'px';
        element[0].style.height = parseFloat(interact.getElementRect(element[0]).height) + event.dy + 'px';

        //update modal size
        if (isModal) {
          modal.content.style.width = parseFloat(interact.getElementRect(modal.content).width) + event.dx + 'px';
          modal.content.style.height = parseFloat(interact.getElementRect(modal.content).height) + event.dy + 'px';

          modal.body.style.width = parseFloat(interact.getElementRect(modal.body).width) + event.dx  + 'px';
          modal.body.style.height = parseFloat(interact.getElementRect(modal.body).height) + event.dy  + 'px';
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .factory('gmFactory', gmFactory);

  function gmFactory($q, gmLibrary) {
    var factory = {
      gms: {},
      getDistance: getDistanceFn
    };

    //load Google Maps Library
    gmLibrary.load().then(function() {
      gmLibrary.populate(factory.gms);
    });

    return factory;

    ////////////////////////////////////////////////////////////////////////////
    function getDistanceFn(origin, destination) {
      return $q(function(resolve, reject) {
        var maps = factory.gms.google.maps;
        var service = new maps.DistanceMatrixService();

        service.getDistanceMatrix({
          origins: [origin],
          destinations: [destination],
          travelMode: maps.TravelMode.DRIVING
        }, callback);

        function callback(response, status) {
          var resultSet = {};

          if (status === maps.DistanceMatrixStatus.OK) {
            resultSet.origin = response.originAddresses[0];
            resultSet.destination = response.destinationAddresses[0];
            resultSet.result = response.rows[0].elements[0];

            if (resultSet.result.status === maps.DistanceMatrixElementStatus.OK) {
              resolve(resultSet);
            }
          }

          reject(response);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .filter('urlEncode', urlEncode);

  function urlEncode($window) {
    return $window.encodeURIComponent;
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .filter( 'nl2br', nl2br );

  function nl2br() {
    return function (text) {
      if (typeof text === 'undefined') {
        return text;
      }
      return text.replace(/\n/g, '<br>');
    };
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .factory('dtFactory', dtFactory);

  function dtFactory($window, $q, $compile, $filter, DTOptionsBuilder, api) {
    var factory = {
      addDefaultOptions: addDefaultOptionsFn,
      exportFile: exportFileFn,
      logExportHtml5: logExportHtml5Fn,
      renders: {
        date: isoDateTime2date,
        time: isoDateTime2time,
        datetime: isoDateTime2dateTime,
        integer: formatInteger,
        float: formatFloat,
        currency: float2currency,
        percent: float2percent,
        longtext: hideExtra,
        longtextNoTooltip: hideExtra,
        email: renderEmail,
        phone: renderPhone,
        mobile: renderMobile,
        boolean: boolean2check,
        tristate: tristate2check
      }
    };

    factory.defaultColumnDefs = (function () {
      return [
        {targets: '_all', defaultContent: ''},
        {targets: 'dt-date', render: factory.renders.date},
        {targets: 'dt-time', render: factory.renders.time},
        {targets: 'dt-datetime', render: factory.renders.datetime},
        {targets: 'dt-currency', render: factory.renders.currency},
        {targets: 'dt-longtext', render: factory.renders.longtext},
        {targets: 'dt-boolean', render: factory.renders.boolean}
      ];
    })();

    return factory;

    ////////////////////////////////////////////////////////////////////////////
    function addDefaultOptionsFn($scope, dtOptions) {
      var headerCompiled = false; //variabile usata per non compilare l'header più di una volta

      if ($.isEmptyObject(dtOptions)) { //se le options non sono inizializzate
        dtOptions = DTOptionsBuilder
          .fromFnPromise(function() {
            return $q.when([]); //ritorna una promise vuota
          })
        ;
      }

      // recupera le callback originali se presenti
      var _originalCreatedRow = dtOptions.hasOwnProperty('createdRow') ? dtOptions.createdRow : null;
      var _originalHeaderCallback = dtOptions.hasOwnProperty('headerCallback') ? dtOptions.headerCallback : null;

      return dtOptions
        .withOption('createdRow', _createdRow)
        .withOption('headerCallback', _headerCallback)
      ;

      function _createdRow(row, data, dataIndex) {
        if (angular.isFunction(_originalCreatedRow)) {
          _originalCreatedRow(row, data, dataIndex);
        }

        _compile4bind(row);
      }

      function _headerCallback(thead, data, start, end, display) {
        angular.element(thead).find('th').removeClass('min-width'); //FIXME: workaround per rimuovere dai TH la classe impostata con columnDefs per poter fare overload sui TD

        if (angular.isFunction(_originalHeaderCallback)) {
          _originalHeaderCallback(thead, data, start, end, display);
        }

        if (!headerCompiled) {
          headerCompiled = true;

          _compile4bind(thead);
        }
      }

      function _compile4bind(element) {
        //ricompilazione del contenuto per far funzionare i bind con angular
        $compile(angular.element(element).contents())($scope);
      }
    }

    function exportFileFn(url, getData, numRecords, noLog) {
      if (noLog !== true) {
        api.exportLogs.save({
          url: url,
          numRecords: angular.isDefined(numRecords) ? numRecords : '-1',
          filter: getData
        });
      }

      if (angular.isDefined(getData)) {
        var qs = $.param(getData);

        url = url + '?' + qs;
      }

      $window.open(url, '_self');
    }

    function logExportHtml5Fn(data, self, e, dt, node, config) {
      api.exportLogs.save(data);

      $.fn.dataTable.ext.buttons.excelHtml5.action.call(self, e, dt, node, config);
    }

    /* renders */
    function isoDateTime2date(data, type) {
      if (type === 'display' || type === 'filter') {
        return $filter('date')(data, 'shortDate');
      }

      return data;
    }

    function isoDateTime2time(data, type) {
      if (type === 'display' || type === 'filter') {
        return $filter('date')(data, 'shortTime');
      }

      return data;
    }

    function isoDateTime2dateTime(data, type) {
      if (type === 'display' || type === 'filter') {
        return $filter('date')(data, 'short');
      }

      return data;
    }

    function formatInteger(data, type) {
      if (type === 'display') {
        return $filter('number')(data, 0);
      }

      return data;
    }

    function formatFloat(data, type) {
      if (type === 'display') {
        return $filter('number')(data, 2);
      }

      return data;
    }

    function float2currency(data, type) {
      if (type === 'display') {
        return $filter('currency')(data);
      }

      return data;
    }

    function float2percent(precision) {
      if (angular.isUndefined(precision)) {
        precision = 0;
      }

      return function _float2percent(data, type) {
        if (type === 'display') {
          return $filter('number')((data * 100), precision) + '%';
        }

        return data;
      }
    }

	function hideExtra(data, type) {
      if ((type === 'display') && (data !== null)) {
        var html = '' +
            '<div class="hideextra outer">' +
            '	<div class="hideextra inner" onclick="toggleHideExtra(this)">' +
            '		' + data +
            '	</div>' +
            '</div>'
          ;
        return html;
      }

      return data;
    }

    function renderEmail( data, type ) {
      if ( !_.isEmpty( data ) && ( type === 'display' ) ) {
        var html = '\
          <span class="datoCliente">\
            <a href="mailto:' + data + '">\
              <i class="fa fa-envelope"></i> \
              <i class="fa fa-copy" copy-to-clipboard="' + data + '"></i>' +
            data + '\
            </a>\
          </span>';
        return html;
      }
      return data;
    }

    function renderPhone( data, type ) {
      if ( !_.isEmpty( data ) && ( type === 'display' ) ) {
        var html = '\
          <span class="datoCliente">\
            <a href="tel:' + data + '">\
              <i class="fa fa-phone"></i> \
              <i class="fa fa-copy" copy-to-clipboard="' + data + '"></i>' +
            data + '\
            </a>\
          </span>';
        return html;
      }
      return data;
    }

    function renderMobile( data, type ) {
      if ( !_.isEmpty( data ) && ( type === 'display' ) ) {
        var html = '\
          <span class="datoCliente">\
            <a href="tel:' + data + '">\
              <i class="fa fa-mobile"></i> \
              <i class="fa fa-copy" copy-to-clipboard="' + data + '"></i>' +
            data + '\
            </a>\
          </span>';
        return html;
      }
      return data;
    }

    function boolean2check(data, type) {
      if (type === 'display') {
        data = data ?
          '<i class="fa fa-check-square-o"></i>' :
          '<i class="fa fa-square-o"></i>'
          ;
      } else if (type === 'filter') {
        data = data ? 1 : 0;
      }

      return data;
    }

    function tristate2check(data, type) {
      if (type === 'display') {
        switch (data) {
          case 0:
          case '0':
            data = '<i class="fa fa-square-o"></i>';
            break;

          case 1:
          case '1':
            data = '<i class="fa fa-check-square-o"></i>';
            break;

          default:
            data = '';
        }
      } else if (type === 'filter') {
        switch (data) {
          case 0:
          case '0':
            data = 0;
            break;

          case 1:
          case '1':
            data = 1;
            break;

          default:
            data = null;
        }
      }

      return data;
    }
  }
})();

/* eslint-disable */
/*
 * File:        jquery.dataTables.columnFilter.js
 * Version:     1.5.6
 * Author:      Jovan Popovic
 * Modified:    Valentino Deotto, 29/09/2016
 *
 * Copyright 2011-2014 Jovan Popovic, all rights reserved.
 *
 * This source file is free software, under either the GPL v2 license or a
 * BSD style license, as supplied with this software.
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.
 *
 * Parameters:"
 * @sPlaceHolder                 String      Place where inline filtering function should be placed ("tfoot", "thead:before", "thead:after"). Default is "tfoot"
 * @sRangeSeparator              String      Separator that will be used when range values are sent to the server-side. Default value is "~".
 * @sRangeFormat                 string      Default format of the From ... to ... range inputs. Default is From {from} to {to}
 * @aoColumns                    Array       Array of the filter settings that will be applied on the columns
 */
(function ($) {
  $.fn.columnFilter = function (options) {

    var asInitVals, i, label, th;

    //var sTableId = "table";
    var sRangeFormat = "From {from} to {to}";
    //Array of the functions that will override sSearch_ parameters
    var afnSearch_ = [];
    var aiCustomSearch_Indexes = [];

    // var oFunctionTimeout = null;

    var fnOnFiltered = function () { };

    function _fnGetColumnValues(oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty) {
      ///<summary>
      ///Return values in the column
      ///</summary>
      ///<param name="oSettings" type="Object">DataTables settings</param>
      ///<param name="iColumn" type="int">Id of the column</param>
      ///<param name="bUnique" type="bool">Return only distinct values</param>
      ///<param name="bFiltered" type="bool">Return values only from the filtered rows</param>
      ///<param name="bIgnoreEmpty" type="bool">Ignore empty cells</param>

      // check that we have a column id
      if (typeof iColumn == "undefined") return [];

      // by default we only wany unique data
      if (typeof bUnique == "undefined") bUnique = true;

      // by default we do want to only look at filtered data
      if (typeof bFiltered == "undefined") bFiltered = true;

      // by default we do not wany to include empty values
      if (typeof bIgnoreEmpty == "undefined") bIgnoreEmpty = true;

      // list of rows which we're going to loop through
      var aiRows;

      // use only filtered rows
      if (bFiltered == true) aiRows = oSettings.aiDisplay;
      // use all rows
      else aiRows = oSettings.aiDisplayMaster; // all row numbers

      // set up data array
      var asResultData = [];

      for (var i = 0, c = aiRows.length; i < c; i++) {
        var iRow = aiRows[i];
        var aData = oTable.fnGetData(iRow);
        var sValue = aData[iColumn];

        // ignore empty values?
        if (bIgnoreEmpty == true && sValue.length == 0) continue;

        // ignore unique values?
        else if (bUnique == true && jQuery.inArray(sValue, asResultData) > -1) continue;

        // else push the value onto the result data array
        else asResultData.push(sValue);
      }

      return asResultData.sort();
    }

    function _fnColumnIndex(iColumnIndex) {
      if (properties.bUseColVis)
        return iColumnIndex;
      else
        return oTable.fnSettings().oApi._fnVisibleToColumnIndex(oTable.fnSettings(), iColumnIndex);
      //return iColumnIndex;
      //return oTable.fnSettings().oApi._fnColumnIndexToVisible(oTable.fnSettings(), iColumnIndex);
    }

    function _fnRegExpEscape( sText ) {
      return sText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }

    function fnCreateInput(oTable, regex, smart, bIsNumber, iFilterLength, iMaxLenght) {
      var sCSSClass = "text_filter form-control input-sm";
      if (bIsNumber)
        sCSSClass = "number_filter form-control input-sm";

      label = label.replace(/(^\s*)|(\s*$)/g, "");
      var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
      var search_init = 'search_init ';
      var inputvalue = label;
      if (currentFilter != '' && currentFilter != '^') {
        if (bIsNumber && currentFilter.charAt(0) == '^')
          inputvalue = currentFilter.substr(1); //ignore trailing ^
        else
          inputvalue = currentFilter;
        search_init = '';
      }

      var input = $('<input type="text" class="' + search_init + sCSSClass + '" value="' + inputvalue + '" rel="' + i + '" size="' + label.length + '"/>');
      if (iMaxLenght != undefined && iMaxLenght != -1) {
        input.attr('maxlength', iMaxLenght);
      }
      th.html(input);
      if (bIsNumber)
        th.wrapInner('<span class="filter_column filter_number" />');
      else
        th.wrapInner('<span class="filter_column filter_text" />');

      asInitVals[i] = label;
      var index = i;

      if (bIsNumber && !oTable.fnSettings().oFeatures.bServerSide) {
        input.keyup(function () {
          /* Filter on the column all numbers that starts with the entered value */
          oTable.fnFilter('^' + this.value, _fnColumnIndex(index), true, false); //Issue 37
          fnOnFiltered();
        });
      } else {
        input.keyup(function () {
          if (oTable.fnSettings().oFeatures.bServerSide && iFilterLength != 0) {
            //If filter length is set in the server-side processing mode
            //Check has the user entered at least iFilterLength new characters

            // var currentFilter = oTable.fnSettings().aoPreSearchCols[index].sSearch;
            var iLastFilterLength = $(this).data("dt-iLastFilterLength");
            if (typeof iLastFilterLength == "undefined")
              iLastFilterLength = 0;
            var iCurrentFilterLength = this.value.length;
            if (Math.abs(iCurrentFilterLength - iLastFilterLength) < iFilterLength
            //&& currentFilter.length == 0 //Why this?
            ) {
              //Cancel the filtering
              return;
            }
            else {
              //Remember the current filter length
              $(this).data("dt-iLastFilterLength", iCurrentFilterLength);
            }
          }
          /* Filter on the column (the index) of this element */
          oTable.fnFilter(this.value, _fnColumnIndex(index), regex, smart); //Issue 37
          fnOnFiltered();
        });
      }

      input.focus(function () {
        if ($(this).hasClass("search_init")) {
          $(this).removeClass("search_init");
          this.value = "";
        }
      });
      input.blur(function () {
        if (this.value == "") {
          $(this).addClass("search_init");
          this.value = asInitVals[index];
        }
      });
    }

    function fnCreateRangeInput(oTable) {

      //var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
      th.html(_fnRangeLabelPart(0));
      var sFromId = oTable.attr("id") + '_range_from_' + i;
      var from = $('<input type="text" class="number_range_filter form-control input-sm" id="' + sFromId + '" rel="' + i + '"/>');
      th.append(from);
      th.append(_fnRangeLabelPart(1));
      var sToId = oTable.attr("id") + '_range_to_' + i;
      var to = $('<input type="text" class="number_range_filter form-control input-sm" id="' + sToId + '" rel="' + i + '"/>');
      th.append(to);
      th.append(_fnRangeLabelPart(2));
      th.wrapInner('<span class="filter_column filter_number_range form-control input-sm" />');
      var index = i;
      aiCustomSearch_Indexes.push(i);



      //------------start range filtering function


      /* 	Custom filtering function which will filter data in column four between two values
       *	Author: 	Allan Jardine, Modified by Jovan Popovic
       */
      //$.fn.dataTableExt.afnFiltering.push(
      oTable.dataTableExt.afnFiltering.push(
        function (oSettings, aData) {
          if (oTable.attr("id") != oSettings.sTableId)
            return true;
          // Try to handle missing nodes more gracefully
          if (document.getElementById(sFromId) == null)
            return true;
          var iMin = document.getElementById(sFromId).value * 1;
          var iMax = document.getElementById(sToId).value * 1;
          var iValue = aData[_fnColumnIndex(index)] == "-" ? 0 : aData[_fnColumnIndex(index)] * 1;
          if (iMin == "" && iMax == "") {
            return true;
          }
          else if (iMin == "" && iValue <= iMax) {
            return true;
          }
          else if (iMin <= iValue && "" == iMax) {
            return true;
          }
          else if (iMin <= iValue && iValue <= iMax) {
            return true;
          }
          return false;
        }
      );
      //------------end range filtering function



      $('#' + sFromId + ',#' + sToId, th).keyup(function () {

        var iMin = document.getElementById(sFromId).value * 1;
        var iMax = document.getElementById(sToId).value * 1;
        if (iMin != 0 && iMax != 0 && iMin > iMax)
          return;

        oTable.fnDraw();
        fnOnFiltered();
      });


    }

    function fnCreateDateRangeInput(oTable) {

      var aoFragments = sRangeFormat.split(/[}{]/);

      th.html("");
      //th.html(_fnRangeLabelPart(0));
      var sFromId = oTable.attr("id") + '_range_from_' + i;
      var from = $('<input type="text" class="date_range_filter form-control input-sm" id="' + sFromId + '" rel="' + i + '"/>');
      from.datepicker();
      //th.append(from);
      //th.append(_fnRangeLabelPart(1));
      var sToId = oTable.attr("id") + '_range_to_' + i;
      var to = $('<input type="text" class="date_range_filter form-control input-sm" id="' + sToId + '" rel="' + i + '"/>');
      //th.append(to);
      //th.append(_fnRangeLabelPart(2));

      for (var ti = 0; ti < aoFragments.length; ti++) {

        if (aoFragments[ti] == properties.sDateFromToken) {
          th.append(from);
        } else {
          if (aoFragments[ti] == properties.sDateToToken) {
            th.append(to);
          } else {
            th.append(aoFragments[ti]);
          }
        }


      }


      th.wrapInner('<span class="filter_column filter_date_range" />');
      to.datepicker();
      var index = i;
      aiCustomSearch_Indexes.push(i);


      //------------start date range filtering function

      //$.fn.dataTableExt.afnFiltering.push(
      oTable.dataTableExt.afnFiltering.push(
        function (oSettings, aData) {
          if (oTable.attr("id") != oSettings.sTableId)
            return true;

          var dStartDate = from.datepicker("getDate");

          var dEndDate = to.datepicker("getDate");

          if (dStartDate == null && dEndDate == null) {
            return true;
          }

          var dCellDate = null;
          try {
            if (aData[_fnColumnIndex(index)] == null || aData[_fnColumnIndex(index)] == "")
              return false;
            dCellDate = $.datepicker.parseDate($.datepicker.regional[""].dateFormat, aData[_fnColumnIndex(index)]);
          } catch (ex) {
            return false;
          }
          if (dCellDate == null)
            return false;


          if (dStartDate == null && dCellDate <= dEndDate) {
            return true;
          }
          else if (dStartDate <= dCellDate && dEndDate == null) {
            return true;
          }
          else if (dStartDate <= dCellDate && dCellDate <= dEndDate) {
            return true;
          }
          return false;
        }
      );
      //------------end date range filtering function

      $('#' + sFromId + ',#' + sToId, th).change(function () {
        oTable.fnDraw();
        fnOnFiltered();
      });


    }

    function fnCreateColumnSelect(oTable, aData, iColumn, nTh, sLabel, bRegex, oSelected, bMultiselect) {
      if (aData == null)
        aData = _fnGetColumnValues(oTable.fnSettings(), iColumn, true, false, true);
      var index = iColumn;
      var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
      if (currentFilter == null || currentFilter == "")//Issue 81
        currentFilter = oSelected;

      var r = '<select class="search_init select_filter form-control input-sm" rel="' + i + '"><option value="" class="search_init">' + sLabel + '</option>';
      if(bMultiselect) {
        r = '<select class="search_init select_filter form-control input-sm" rel="' + i + '" multiple>';
      }

      var iLen = aData.length;
      for (var j = 0; j < iLen; j++) {
        var selected = '';

        if (typeof (aData[j]) != 'object') {
          if (escape(aData[j]) == currentFilter
            || escape(aData[j]) == escape(currentFilter)
          )
            selected = 'selected ';
          r += '<option ' + selected + ' value="' + escape(aData[j]) + '">' + aData[j] + '</option>';
        } else {
          if (bRegex) {
            //Do not escape values if they are explicitely set to avoid escaping special characters in the regexp
            if (aData[j].value == currentFilter) selected = 'selected ';
            r += '<option ' + selected + 'value="' + aData[j].value + '">' + aData[j].label + '</option>';
          } else {
            if (escape(aData[j].value) == currentFilter) selected = 'selected ';
            r += '<option ' + selected + 'value="' + escape(aData[j].value) + '">' + aData[j].label + '</option>';
          }
        }
      }

      var select = $(r + '</select>');
      nTh.html(select);
      nTh.wrapInner('<span class="filter_column filter_select" />');

      if(bMultiselect) {
        select.change(function () {
          if ($(this).val() != "") {
            $(this).removeClass("search_init");
          } else {
            $(this).addClass("search_init");
          }
          var selectedOptions = $(this).val();
          var asEscapedFilters = [];
          var re = '';
          if(selectedOptions==null || selectedOptions==[]){
            re = '^(.*)$';
          } else {
            $.each( selectedOptions, function( i, sFilter ) {
              asEscapedFilters.push( _fnRegExpEscape( sFilter ) );
            } );
            re = '^(' + asEscapedFilters.join('|') + ')$';
          }

          oTable.fnFilter( re, index, true, false );
        });
      } else {
        select.change(function () {
          //var val = $(this).val();
          if ($(this).val() != "") {
            $(this).removeClass("search_init");
          } else {
            $(this).addClass("search_init");
          }
          if (bRegex)
            oTable.fnFilter($(this).val(), iColumn, bRegex); //Issue 41
          else
            oTable.fnFilter(unescape($(this).val()), iColumn); //Issue 25
          fnOnFiltered();
        });
        if (currentFilter != null && currentFilter != "")//Issue 81
          oTable.fnFilter(unescape(currentFilter), iColumn);
      }
    }

    function fnCreateSelect(oTable, aData, bRegex, oSelected, bMultiselect) {
      var oSettings = oTable.fnSettings();
      if ( (aData == null || typeof(aData) == 'function' ) && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
        // Add a function to the draw callback, which will check for the Ajax data having
        // been loaded. Use a closure for the individual column elements that are used to
        // built the column filter, since 'i' and 'th' (etc) are locally "global".
        oSettings.aoDrawCallback.push({
          "fn": (function (iColumn, nTh, sLabel) {
            return function (oSettings) {
              // Only rebuild the select on the second draw - i.e. when the Ajax
              // data has been loaded.
              if (oSettings.iDraw == 2 && oSettings.sAjaxSource != null && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
                return fnCreateColumnSelect(oTable, aData && aData(oSettings.aoData, oSettings), _fnColumnIndex(iColumn), nTh, sLabel, bRegex, oSelected, bMultiselect); //Issue 37
              }
            };
          })(i, th, label),
          "sName": "column_filter_" + i
        });
      }
      // Regardless of the Ajax state, build the select on first pass
      fnCreateColumnSelect(oTable, typeof(aData) == 'function' ? null: aData, _fnColumnIndex(i), th, label, bRegex, oSelected, bMultiselect); //Issue 37

    }

    function fnCreateDropdown(aData) {
      var index = i;
      var r = '<div class="dropdown select_filter form-control input-sm"><a class="dropdown-toggle" data-toggle="dropdown" href="#">' + label + '<b class="caret"></b></a><ul class="dropdown-menu" role="menu"><li data-value=""><a>Show All</a></li>', j, iLen = aData.length;

      for (j = 0; j < iLen; j++) {
        r += '<li data-value="' + aData[j] + '"><a>' + aData[j] + '</a></li>';
      }
      var select = $(r + '</ul></div>');
      th.html(select);
      th.wrapInner('<span class="filterColumn filter_select" />');
      select.find('li').click(function () {
        oTable.fnFilter($(this).data('value'), index);
      });
    }

    function fnCreateCheckbox(oTable, aData) {

      if (aData == null)
        aData = _fnGetColumnValues(oTable.fnSettings(), i, true, true, true);
      var index = i;

      var r = '', j, iLen = aData.length;

      //clean the string
      var localLabel = label.replace('%', 'Perc').replace("&", "AND").replace("$", "DOL").replace("£", "STERL").replace("@", "AT").replace(/\s/g, "_");
      localLabel = localLabel.replace(/[^a-zA-Z 0-9]+/g, '');
      //clean the string

      //button label override
      var labelBtn = label;
      if (properties.sFilterButtonText != null || properties.sFilterButtonText != undefined) {
        labelBtn = properties.sFilterButtonText;
      }

      var relativeDivWidthToggleSize = 10;
      var numRow = 12; //numero di checkbox per colonna
      var numCol = Math.floor(iLen / numRow);
      if (iLen % numRow > 0) {
        numCol = numCol + 1;
      }
      //count how many column should be generated and split the div size
      var divWidth = 100 / numCol - 2;

      var divWidthToggle = relativeDivWidthToggleSize * numCol;

      if (numCol == 1) {
        divWidth = 20;
      }

      var divRowDef = '<div style="float:left; min-width: ' + divWidth + '%; " >';
      var divClose = '</div>';

      var uniqueId = oTable.attr("id") + localLabel;
      var buttonId = "chkBtnOpen" + uniqueId;
      var checkToggleDiv = uniqueId + "-flt-toggle";
      r += '<button id="' + buttonId + '" class="checkbox_filter btn btn-default" > ' + labelBtn + '</button>'; //filter button witch open dialog
      r += '<div id="' + checkToggleDiv + '" '
        + 'title="' + label + '" '
        + 'rel="' + i + '" '
        + 'class="toggle-check ui-widget-content ui-corner-all"  style="width: ' + (divWidthToggle) + '%; " >'; //dialog div
      //r+= '<div align="center" style="margin-top: 5px; "> <button id="'+buttonId+'Reset" class="checkbox_filter" > reset </button> </div>'; //reset button and its div
      r += divRowDef;

      for (j = 0; j < iLen; j++) {

        //if last check close div
        if (j % numRow == 0 && j != 0) {
          r += divClose + divRowDef;
        }

        var sLabel = aData[j];
        var sValue = aData[j];

        if (typeof (aData[j]) == 'object') {
          sLabel = aData[j].label;
          sValue = aData[j].value;
        }

        //check button
        r += '<input class="search_init checkbox_filter btn btn-default" type="checkbox" id= "' + uniqueId + '_cb_' + sValue + '" name= "' + localLabel + '" value="' + sValue + '" >' + sLabel + '<br/>';

        var checkbox = $(r);
        th.html(checkbox);
        th.wrapInner('<span class="filter_column filter_checkbox" />');
        //on every checkbox selection
        checkbox.change(function () {

          var search = '';
          var or = '|'; //var for select checks in 'or' into the regex
          var resSize = $('input:checkbox[name="' + localLabel + '"]:checked').size();
          $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index) {

            //search = search + ' ' + $(this).val();
            //concatenation for selected checks in or
            if ((index == 0 && resSize == 1)
              || (index != 0 && index == resSize - 1)) {
              or = '';
            }
            //trim
            search = search.replace(/^\s+|\s+$/g, "");
            search = search + $(this).val() + or;
            or = '|';

          });


          if (search != "") {
            $('input:checkbox[name="' + localLabel + '"]').removeClass("search_init");
          } else {
            $('input:checkbox[name="' + localLabel + '"]').addClass("search_init");
          }
          /* Old code for setting search_init CSS class on checkboxes if any of them is checked
           for (var jj = 0; jj < iLen; jj++) {
           if (search != "") {
           $('#' + aData[jj]).removeClass("search_init");
           } else {
           $('#' + aData[jj]).addClass("search_init");
           }
           }
           */

          //execute search
          oTable.fnFilter(search, index, true, false);
          fnOnFiltered();
        });
      }

      //filter button
      $('#' + buttonId).button();
      //dialog
      $('#' + checkToggleDiv).dialog({
        //height: 140,
        autoOpen: false,
        //show: "blind",
        hide: "blind",
        buttons: [{
          text: "Reset",
          click: function () {
            //$('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
            $('input:checkbox[name="' + localLabel + '"]:checked').each(function () {
              $(this).attr('checked', false);
              $(this).addClass("search_init");
            });
            oTable.fnFilter('', index, true, false);
            fnOnFiltered();
            return false;
          }
        },
          {
            text: "Close",
            click: function () { $(this).dialog("close"); }
          }
        ]
      });


      $('#' + buttonId).click(function () {

        $('#' + checkToggleDiv).dialog('open');
        var target = $(this);
        $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
          at: 'bottom',
          of: target
        });

        return false;
      });

      var fnOnFilteredCurrent = fnOnFiltered;

      fnOnFiltered = function () {
        var target = $('#' + buttonId);
        $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
          at: 'bottom',
          of: target
        });
        fnOnFilteredCurrent();
      };
      //reset
      /*
       $('#'+buttonId+"Reset").button();
       $('#'+buttonId+"Reset").click(function(){
       $('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
       $('input:checkbox[name="'+localLabel+'"]:checked').each(function(index3) {
       $(this).attr('checked', false);
       $(this).addClass("search_init");
       });
       oTable.fnFilter('', index, true, false);
       return false;
       });
       */
    }

    function _fnRangeLabelPart(iPlace) {
      switch (iPlace) {
        case 0:
          return sRangeFormat.substring(0, sRangeFormat.indexOf("{from}"));
        case 1:
          return sRangeFormat.substring(sRangeFormat.indexOf("{from}") + 6, sRangeFormat.indexOf("{to}"));
        default:
          return sRangeFormat.substring(sRangeFormat.indexOf("{to}") + 4);
      }
    }


    var oTable = this;

    var defaults = {
      sPlaceHolder: "foot",
      sRangeSeparator: "~",
      iFilteringDelay: 500,
      aoColumns: null,
      sRangeFormat: "From {from} to {to}",
      sDateFromToken: "from",
      sDateToToken: "to"
    };

    var properties = $.extend(defaults, options);

    return this.each(function () {

      if (!oTable.fnSettings().oFeatures.bFilter)
        return;
      asInitVals = [];

      var aoFilterCells = oTable.fnSettings().aoFooter[0];

      var oHost = oTable.fnSettings().nTFoot; //Before fix for ColVis
      var sFilterRow = "tr"; //Before fix for ColVis
      var tr = {};

      if (properties.sPlaceHolder == "head:after") {
        tr = $("tr:first", oTable.fnSettings().nTHead).detach();
        //tr.appendTo($(oTable.fnSettings().nTHead));
        if (oTable.fnSettings().bSortCellsTop) {
          tr.prependTo($(oTable.fnSettings().nTHead));
          //tr.appendTo($("thead", oTable));
          aoFilterCells = oTable.fnSettings().aoHeader[1];
        }
        else {
          tr.appendTo($(oTable.fnSettings().nTHead));
          //tr.prependTo($("thead", oTable));
          aoFilterCells = oTable.fnSettings().aoHeader[0];
        }

        sFilterRow = "tr:last";
        oHost = oTable.fnSettings().nTHead;

      } else if (properties.sPlaceHolder == "head:before") {

        if (oTable.fnSettings().bSortCellsTop) {
          tr = $("tr:first", oTable.fnSettings().nTHead).detach();
          tr.appendTo($(oTable.fnSettings().nTHead));
          aoFilterCells = oTable.fnSettings().aoHeader[1];
        } else {
          aoFilterCells = oTable.fnSettings().aoHeader[0];
        }
        /*else {
         //tr.prependTo($("thead", oTable));
         sFilterRow = "tr:first";
         }*/

        sFilterRow = "tr:first";

        oHost = oTable.fnSettings().nTHead;


      }

      //$(sFilterRow + " th", oHost).each(function (index) {//bug with ColVis
      $(aoFilterCells).each(function (index) {//fix for ColVis
        i = index;
        var aoColumn = { type: "text",
          bRegex: false,
          bSmart: true,
          iMaxLenght: -1,
          iFilterLength: 0
        };
        if (properties.aoColumns != null) {
          if (properties.aoColumns.length < i || properties.aoColumns[i] == null)
            return;
          aoColumn = properties.aoColumns[i];
        }
        //label = $(this).text(); //Before fix for ColVis
        label = $($(this)[0].cell).text(); //Fix for ColVis
        if (aoColumn.sSelector == null) {
          //th = $($(this)[0]);//Before fix for ColVis
          th = $($(this)[0].cell); //Fix for ColVis
        }
        else {
          th = $(aoColumn.sSelector);
          if (th.length == 0)
            th = $($(this)[0].cell);
        }

        if (aoColumn != null) {
          if (aoColumn.sRangeFormat != null)
            sRangeFormat = aoColumn.sRangeFormat;
          else
            sRangeFormat = properties.sRangeFormat;
          switch (aoColumn.type) {
            case "null":
              break;
            case "number":
              fnCreateInput(oTable, true, false, true, aoColumn.iFilterLength, aoColumn.iMaxLenght);
              break;
            case "select":
              if (aoColumn.bRegex != true)
                aoColumn.bRegex = false;
              fnCreateSelect(oTable, aoColumn.values, aoColumn.bRegex, aoColumn.selected, aoColumn.multiple);
              break;
            case "number-range":
              fnCreateRangeInput(oTable);
              break;
            case "date-range":
              fnCreateDateRangeInput(oTable);
              break;
            case "checkbox":
              fnCreateCheckbox(oTable, aoColumn.values);
              break;
            case "twitter-dropdown":
            case "dropdown":
              fnCreateDropdown(aoColumn.values);
              break;
            case "text":
            default:
              bRegex = (aoColumn.bRegex == null ? false : aoColumn.bRegex);
              bSmart = (aoColumn.bSmart == null ? false : aoColumn.bSmart);
              fnCreateInput(oTable, bRegex, bSmart, false, aoColumn.iFilterLength, aoColumn.iMaxLenght);
              break;

          }
        }
      });

      for (var j = 0; j < aiCustomSearch_Indexes.length; j++) {
        //var index = aiCustomSearch_Indexes[j];
        var fnSearch_ = function () {
          var id = oTable.attr("id");
          return $("#" + id + "_range_from_" + aiCustomSearch_Indexes[j]).val() + properties.sRangeSeparator + $("#" + id + "_range_to_" + aiCustomSearch_Indexes[j]).val()
        };
        afnSearch_.push(fnSearch_);
      }

      if (oTable.fnSettings().oFeatures.bServerSide) {

        var fnServerDataOriginal = oTable.fnSettings().fnServerData;

        oTable.fnSettings().fnServerData = function (sSource, aoData, fnCallback) {

          for (var j = 0; j < aiCustomSearch_Indexes.length; j++) {
            var index = aiCustomSearch_Indexes[j];

            for (var k = 0; k < aoData.length; k++) {
              if (aoData[k].name == "sSearch_" + index)
                aoData[k].value = afnSearch_[j]();
            }
          }
          aoData.push({ "name": "sRangeSeparator", "value": properties.sRangeSeparator });

          if (fnServerDataOriginal != null) {
            try {
              fnServerDataOriginal(sSource, aoData, fnCallback, oTable.fnSettings()); //TODO: See Issue 18
            } catch (ex) {
              fnServerDataOriginal(sSource, aoData, fnCallback);
            }
          }
          else {
            $.getJSON(sSource, aoData, function (json) {
              fnCallback(json)
            });
          }
        };

      }

    });

  };
})(jQuery);

/* eslint-disable */
/*!
 * @author Thomas <thansen@solire.fr>
 * @licence CC BY-NC 4.0 http://creativecommons.org/licenses/by-nc/4.0/
 *
 * A light filter column pluggin for jquery.dataTables#1.10
 */
(function(window, document) {
  var factory = function($, dataTable) {
    'use strict';

    var
      /**
       * Create a new Column instance
       *
       * @param {DataTable} dataTable       The DataTables object
       * @param {integer}   index           The index of the column
       * @param {DataTable} dataTableColumn The DataTables Column object
       * @param {object}    options         The columnfilter options for this column
       *
       * @returns {Column}
       */
      Column = function(dataTable, index, dataTableColumn, options) {
        var
          self = this,
          defaultOptions,
          methods = [
            'dom',
            'bindEvents',
            'request'
          ]
          ;

        if (options.html in ColumnFilter.filter) {
          defaultOptions = $.extend({}, ColumnFilter.filter[options.html]);
        } else {
          defaultOptions = {};
        }
        self.options = $.extend({}, defaultOptions, options);

        $.each(methods, function(ii, method){
          if (method in self.options) {
            self[method] = self.options[method];
          }
        })

        self.dataTable = dataTable;
        self.dataTableColumn = dataTableColumn;
        self.index = index;
      },
      /**
       * Create a new ColumnFilter instance
       *
       * @param {DataTable} dataTable The DataTables object
       * @param {object}    options   The columnfilter options
       *
       * @returns {ColumnFilter}
       */
      ColumnFilter = function(dataTable, options) {
        var self = this;

        self.columns = [];
        self.dataTable = null;
        self.init(dataTable, options);
      }
      ;

    Column.prototype = {
      /**
       * Build the form DOM elements
       *
       * @param {type} th The th element where to put the elements
       *
       * @returns {jQuery}
       */
      dom: function(th){},
      /**
       * Binds event to the DOM elements
       *
       * @returns {void}
       */
      bindEvents: function(){},
      /**
       * Return the searched string
       *
       * @returns {string}
       */
      request: function(){},
      /**
       * Trigger the datatable search with the request
       *
       * @returns {void}
       */
      search: function(regex){
        var self  = this,
          regex = regex || false;

        self
          .dataTableColumn
          .search(self.request(),regex)
          .draw()
        ;
      }
    }

    ColumnFilter.prototype = {
      /**
       * Initialize the filter pluggin
       *
       * @param {DataTable} dataTable
       * @param {object}    options
       *
       * @returns {void}
       */
      init: function(dataTable, options){
        var
          self = this,
          tr
          ;

        self.dataTable = dataTable;

        tr = $('<tr>').appendTo(self.dataTable.table().header());

        self.dataTable.columns().eq(0).each(function(index){
          var
            className = self.dataTable.column(index).header().className,
            never = className.match(/\bnever\b/),
            columnOptions,
            column,
            th
            ;

          if (never && ('responsive' in self.dataTable)) {
            return;
          }

          if (!self.dataTable.column(index).visible()){
            return;
          }

          columnOptions = index in options ? options[index] : {};
          column = new Column(
            self.dataTable,
            index,
            self.dataTable.column(index),
            columnOptions
          );
          th = $('<th>').appendTo(tr);
          self.columns.push(column);

          column.dom(th);
          column.bindEvents();
        });

        // Hide and Show column filter th according to datatable build-in columns visibility
        $(self.dataTable.table().node()).on('column-visibility.dt', function (e, settings, column, state) {
          if (state) {
            $('th', tr).eq(column).show()
          } else {
            $('th', tr).eq(column).hide()
          }
        });
      },
      /**
       * Add a custom filter
       *
       * @param {string} name
       * @param {object} filter
       *
       * @returns {void}
       */
      addFilter: function(name, filter){
        ColumnFilter.filter[name] = filter;
      }
    };

    /**
     * Default Column configuration
     */
    ColumnFilter.default = {
      type: 'input'
    };

    ColumnFilter.filter = {
      input: {
        /**
         * Build the form DOM elements
         *
         * @param {type} th The th element where to put the elements
         *
         * @returns {jQuery}
         */
        dom: function(th){
          var self = this;

          self.elements = $('<input>', {
            type: self.options.type || 'text'
          }).appendTo(th);


          $.each(self.options.attr, function(key, value){
            self.elements.attr(key,value);
          })

          if (typeof self.options.width !== 'undefined') {
            self.elements.css('width', self.options.width);
          } else {
            self.elements.css('width', '100%');
          }

          return self.elements;
        },
        /**
         * Binds event to the DOM elements
         *
         * @returns {void}
         */
        bindEvents: function(){
          var
            self = this,
            time = 200,
            regex = false,
            timeOutId = 0
            ;

          if ('time' in self.options) {
            time = self.options.time;
          }

          if ('regex' in self.options){
            regex = self.options.regex;
          }

          self.elements.keyup(function(){
            clearTimeout(timeOutId);
            timeOutId = window.setTimeout(function(){
              self.search(regex);
            }, time);
          });
        },
        /**
         * Return the searched string
         *
         * @returns {string}
         */
        request: function(){
          var self = this;

          return self.elements.val();
        }
      },
      select: {
        dom: function(th){
          var self = this, select;

          select = $('<select>');
          select.addClass(self.options.cssClass);

          if(self.options.values.length == 0){
            $('<option>').appendTo(select);
          }

          $.each(self.options.values, function(ii, value){
            $('<option>').val(value.value).text(value.label).appendTo(select);
          });

          self.elements = select.appendTo(th);

          if (typeof self.options.width !== 'undefined') {
            self.elements.css('width', self.options.width);
          } else {
            self.elements.css('width', '100%');
          }

          return self.elements;
        },
        bindEvents: function(){
          var self = this;

          self.elements.on('change', function(){
            self.search();
          });
        },
        request: function(){
          var self = this;
          return self.elements.val();
        }
      },
      range: {
        separator: '~',
        /**
         * Build the form DOM elements
         *
         * @param {type} th The th element where to put the elements
         *
         * @returns {jQuery}
         */
        dom: function(th){
          var self = this;

          self.elements = $('<input>', {
            type: self.options.type || 'text'
          }).add($('<input>', {
            type: self.options.type || 'text'
          })).appendTo(th);

          if (typeof self.options.width !== 'undefined') {
            self.elements.css('width', self.options.width);
          } else {
            self.elements.css('width', '50%');
          }

          return self.elements;
        },
        /**
         * Binds event to the DOM elements
         *
         * @returns {void}
         */
        bindEvents: function(){
          var self = this;

          self.elements.change(function(){
            self.search();
          });
        },
        /**
         * Return the searched string
         *
         * @returns {string}
         */
        request: function(){
          var
            self = this,
            request = []
            ;

          self.elements.each(function(){
            request.push($(this).val());
          });

          return request.join(self.options.separator);
        }
      }
    };

    $.fn.dataTable.ColumnFilter = ColumnFilter;
    $.fn.DataTable.ColumnFilter = ColumnFilter;

    return ColumnFilter;
  };

  // Define as an AMD module if possible
  if (typeof define === 'function' && define.amd) {
    define(['jquery', 'datatables'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'), require('datatables'));
  } else if (jQuery && !jQuery.fn.dataTable.ColumnFilter) {
    // Otherwise simply initialise as normal, stopping multiple evaluation
    factory(jQuery, jQuery.fn.dataTable);
  }
})(window, document);

(function() {
  'use strict';

  angular.module('g1')
    .directive('checkboxIndeterminate', checkboxIndeterminate);

  function checkboxIndeterminate() {
    return {
      require: '?ngModel',
      link: linkFn
    };

    ////////////////////////////////////////////////////////////////////////////
    function linkFn(scope, el, attrs, ctrl) {
      var truthy = true;
      var falsy = false;
      var nully = null;

      ctrl.$formatters = [];
      ctrl.$parsers = [];
      ctrl.$render = render;

      el.bind('click', bindOnClick);

      //////////////////////////////////////////////////////////////////////////
      function render() {
        var d = ctrl.$viewValue;
        el.data('checked', d);
        switch(d){
          case truthy:
            el.prop('indeterminate', false);
            el.prop('checked', true);
            break;
          case falsy:
            el.prop('indeterminate', false);
            el.prop('checked', false);
            break;
          default:
            el.prop('indeterminate', true);
        }
      }

      function bindOnClick() {
        var d;
        switch(el.data('checked')){
          case falsy:
            d = truthy;
            break;
          case truthy:
            d = nully;
            break;
          default:
            d = falsy;
        }
        ctrl.$setViewValue(d);
        scope.$apply(ctrl.$render);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1')
    .factory('g1Bootstrap3ElementModifier', g1Bootstrap3ElementModifier);

  function g1Bootstrap3ElementModifier($log) {
    var reset = function (el) {
        angular.forEach(el.find('span'), function (spanEl) {
          spanEl = angular.element(spanEl);
          if (spanEl.hasClass('error-msg') || spanEl.hasClass('form-control-feedback') || spanEl.hasClass('control-feedback')) {
            spanEl.remove();
          }
        });

        el.removeClass('has-success has-error has-feedback');
      },
      findWithClassElementAsc = function (el, klass) {
        var returnEl,
          parent = el;
        for (var i = 0; i <= 10; i += 1) {
          if (angular.isDefined(parent) && parent.hasClass(klass)) {
            returnEl = parent;
            break;
          } else if (angular.isDefined(parent)) {
            parent = parent.parent();
          }
        }

        return returnEl;
      },

      findWithClassElementDesc = function (el, klass) {
        var child;
        for (var i = 0; i < el.children.length; i += 1) {
          child = el.children[i];
          if (angular.isDefined(child) && angular.element(child).hasClass(klass)) {
            break;
          } else if (angular.isDefined(child.children)) {
            child = findWithClassElementDesc(child, klass);
            if (child.length > 0) {
              break;
            }
          }
        }

        return angular.element(child);
      },

      //VD: modificata funzione per catturare eventuali input fuori dai form-group standard
      findFormGroupElement = function (el) {
        var vg = findWithClassElementAsc(el, 'validate-group');

        return (vg ? vg : findWithClassElementAsc(el, 'form-group'));
      },

      findInputGroupElement = function (el) {
        return findWithClassElementDesc(el, 'input-group');
      },

      insertAfter = function (referenceNode, newNode) {
        referenceNode[0].parentNode.insertBefore(newNode[0], referenceNode[0].nextSibling);
      },

      /**
       * @ngdoc property
       * @name bootstrap3ElementModifier#addValidationStateIcons
       * @propertyOf bootstrap3ElementModifier
       * @returns {bool} True if an state icon will be added to the element in the valid and invalid control
       * states.  The default is false.
       */
      addValidationStateIcons = false,

      /**
       * @ngdoc function
       * @name bootstrap3ElementModifier#enableValidationStateIcons
       * @methodOf bootstrap3ElementModifier
       *
       * @description
       * Makes an element appear invalid by apply an icon to the input element.
       *
       * @param {bool} enable - True to enable the icon otherwise false.
       */
      enableValidationStateIcons = function (enable) {
        addValidationStateIcons = enable;
      },

      /**
       * @ngdoc function
       * @name bootstrap3ElementModifier#makeValid
       * @methodOf bootstrap3ElementModifier
       *
       * @description
       * Makes an element appear valid by apply bootstrap 3 specific styles and child elements. If the service
       * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
       * See: http://getbootstrap.com/css/#forms-control-validation
       *
       * @param {Element} el - The input control element that is the target of the validation.
       */
      makeValid = function (el) {
        var frmGroupEl = findFormGroupElement(el),
          inputGroupEl;

        if (frmGroupEl) {
          reset(frmGroupEl);
          inputGroupEl = findInputGroupElement(frmGroupEl[0]);
          frmGroupEl.addClass('has-success ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
          if (addValidationStateIcons) {
            var iconElText = '<span class="form-control-feedback"><i class="fa fa-check"></i></span>'; //VD: BS Glyphicon -> Font Awesome
            if (inputGroupEl.length > 0) {
              iconElText = iconElText.replace('form-', '');
              iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
            }

            insertAfter(el, angular.element(iconElText));
          }
        } else {
          $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group or validate-group class'); //VD: add validate-group
        }
      },

      /**
       * @ngdoc function
       * @name bootstrap3ElementModifier#makeInvalid
       * @methodOf bootstrap3ElementModifier
       *
       * @description
       * Makes an element appear invalid by apply bootstrap 3 specific styles and child elements. If the service
       * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
       * See: http://getbootstrap.com/css/#forms-control-validation
       *
       * @param {Element} el - The input control element that is the target of the validation.
       */
      makeInvalid = function (el, errorMsg) {
        var frmGroupEl = findFormGroupElement(el),
          helpTextEl = angular.element('<span class="help-block has-error error-msg">' + errorMsg + '</span>'),
          inputGroupEl;

        if (frmGroupEl) {
          reset(frmGroupEl);
          inputGroupEl = findInputGroupElement(frmGroupEl[0]);
          frmGroupEl.addClass('has-error ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
          insertAfter(inputGroupEl.length > 0 ? inputGroupEl : getCorrectElementToPlaceErrorElementAfter(el), helpTextEl);
          if (addValidationStateIcons) {
            var iconElText = '<span class="form-control-feedback"><i class="fa fa-times"></i></span>'; //VD: BS Glyphicon -> Font Awesome
            if (inputGroupEl.length > 0) {
              iconElText = iconElText.replace('form-', '');
              iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
            }

            insertAfter(getCorrectElementToPlaceErrorElementAfter(el), angular.element(iconElText));
          }
        } else {
          $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group or validate-group class'); //VD: add validate-group
        }
      },

      getCorrectElementToPlaceErrorElementAfter = function (el) {
        var correctEl = el,
          elType = el[0].type ? el[0].type.toLowerCase() : '';

        if ((elType === 'checkbox' || elType === 'radio') && el.parent()[0].nodeName.toLowerCase() === 'label') {
          correctEl = el.parent();
        }

        return correctEl;
      },

      /**
       * @ngdoc function
       * @name bootstrap3ElementModifier#makeDefault
       * @methodOf bootstrap3ElementModifier
       *
       * @description
       * Makes an element appear in its default visual state by apply bootstrap 3 specific styles and child elements.
       *
       * @param {Element} el - The input control element that is the target of the validation.
       */
      makeDefault = function (el) {
        var frmGroupEl = findFormGroupElement(el);
        if (frmGroupEl) {
          reset(frmGroupEl);
        } else {
          $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group or validate-group class'); //VD: add validate-group
        }
      },

      waitForAsyncValidators = function (el) {
        var frmGroupEl = findFormGroupElement(el),
          inputGroupEl;

        if (frmGroupEl) {
          reset(frmGroupEl);
          inputGroupEl = findInputGroupElement(frmGroupEl[0]);
          frmGroupEl.addClass('has-feedback ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
          if (addValidationStateIcons) {
            var iconElText = '<span class="form-control-feedback"><i class="fa fa-repeat fa-spin"></i></span>'; //VD: BS Glyphicon -> Font Awesome
            if (inputGroupEl.length > 0) {
              iconElText = iconElText.replace('form-', '');
              iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
            }

            insertAfter(el, angular.element(iconElText));
          }
        } else {
          $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group or validate-group class'); //VD: add validate-group
        }
      };

    return {
      makeValid: makeValid,
      makeInvalid: makeInvalid,
      makeDefault: makeDefault,
      waitForAsyncValidators: waitForAsyncValidators,
      enableValidationStateIcons: enableValidationStateIcons,
      key: 'g1bs3' //VD: nome modificato
    };
  }
})();

(function() {
  'use strict';

  angular.module('g1.cc', [
      'g1.core'
    ])
    .config(routeConfig)
  ;

  //////////////////////////////////////////////////////////////////////////////
  function routeConfig($routeProvider) {
    /** routing */
    $routeProvider
      .when('/cc', {
        templateUrl: 'app/cc/home/home.html',
        controller: 'CcHomeController',
        controllerAs: 'home',
        security: 'CC',
        title: 'Home'
      })
      .when('/cc/campagne', {
        templateUrl: 'app/cc/campagne/campagne.html',
        controller: 'CcCampagneController',
        controllerAs: 'campagne',
        security: 'CC',
        title: 'Campagne'
      })
      .when('/cc/campagne/:id', {
        templateUrl: 'app/cc/campagne/campagna.html',
        controller: 'CcCampagnaController',
        controllerAs: 'campagna',
        security: 'CC',
        title: 'Campagne'
      })
    ;
  }
})();

(function() {
  'use strict';

  angular.module('g1.cc')
    .controller('CcHomeController', CcHomeController);

  function CcHomeController($rootScope, $scope, $interval, AuthenticateJS, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //widget clienti
    vm.widgetClienti = {
      clienti: [],
      dt: {},
      sc: {
        omnibox: {
          searchTerm: '',
          selected: [
            'idCliente',
            'ragSoc',
            'cf',
            'piva',
            'tel',
            'cell',
            'email',
            'referente'
          ]
        }
      },
      alerts: {}
    };

    vm.readCliente = api.clienti.actions.read;

    widgetClienti();

    //widget avanzamenti
    vm.widgetAvanzamenti = {
      now: new Date(),
      q: moment().quarter(),
      giorni: {},
      avanzamento: {},
      imgAvanzamento: ''
    };

    widgetAvanzamenti();
    var stopAvanzamenti = $interval(widgetAvanzamenti, 1000 * 60 * 10);

    //widget appuntamenti
    vm.widgetAppuntamenti = {
      dt_from: moment().subtract(3, 'months').startOf('day').toDate(),
      dt_to: moment().subtract(1, 'day').startOf('day').toDate(),
      appuntamenti: [],
      dt: {}
    };

    vm.readAppuntamenti = function(filtroAppuntamenti) {
      $rootScope.$broadcast('readAppuntamenti', filtroAppuntamenti);
    };

    widgetAppuntamenti();
    var stopAppuntamenti = $interval(widgetAppuntamenti, 1000 * 60 * 10);

    //all widgets
    $scope.$on('$destroy', stopRefresh);

    ////////////////////////////////////////////////////////////////////////////
    function widgetClienti() {
      vm.widgetClienti.search = getClienti;

      vm.widgetClienti.dt.options = DTOptionsBuilder.newOptions()
        .withOption('order', [1, 'asc'])
        .withOption('dom', "rt<'row'<'col-xs-5'i><'col-xs-7'p>>")
        .withOption('pageLength', 10)
        .withOption('lengthChange', false)
        .withOption('searching', false)
      ;

      //////////////////////////////////////////////////////////////////////////
      function getClienti() {
        vm.widgetClienti.alerts = {}; //reset degli alerts

        var promise = api.clienti.list(vm.widgetClienti.sc);

        promise.then(setClienti, setAlerts);

        return promise;

        ////////////////////////////////////////////////////////////////////////
        function setClienti(clienti) {
          vm.widgetClienti.clienti = clienti;

          if (clienti.length === 1) {
            vm.readCliente(clienti[0].id);
          }
        }

        function setAlerts(response) {
          vm.widgetClienti.alerts = {
            status: response.status,
            messages: response.data.warnings
          };
        }
      }
    }

    function widgetAvanzamenti() {
      api.list('/cc', 'CallCenterHome').get()
        .then(setAvanzamenti);

      function setAvanzamenti(response) {
        //calcolo percentuali e stati
        response.giorni.perc = percentual(response.giorni.adv, response.giorni.obj);
        response.giorni.status = getStatus(response.giorni.perc, true);

        response.appMese.perc = percentual(response.appMese.adv, response.appMese.obj);
        response.appMese.status = getStatus(response.appMese.perc);

        //assegnazione dati alla view
        vm.widgetAvanzamenti.giorni = response.giorni;
        vm.widgetAvanzamenti.avanzamento = response.appMese;
        vm.widgetAvanzamenti.imgAvanzamento = getImg(percentual(response.appMese.perc, response.giorni.perc));

        ////////////////////////////////////////////////////////////////////////
        function percentual(n, tot) {
          return (n / tot) * 100;
        }

        function getStatus(perc, reverse) {
          var status = '';
          var classes = ['danger', 'warning', 'success'];

          if (perc <= 33.3) {
            status = classes[reverse ? 2 : 0];
          } else if ((perc > 33.3) && (perc <= 66.6)) {
            status = classes[reverse ? 1 : 1];
          } else {
            status = classes[reverse ? 0 : 2];
          }

          return status;
        }

        function getImg(perc) {
          var img = '/assets/images/tartaruga_lepre/tartaruga_lepre{num}.png';

          if (perc <= 33.3) {
            img = img.replace('{num}', '1');
          } else if ((perc > 33.3) && (perc <= 66.6)) {
            img = img.replace('{num}', '2');
          } else {
            img = img.replace('{num}', '3');
          }

          return img;
        }
      }
    }

    function widgetAppuntamenti() {
      api.operatore(vm.user.idAgenteT).appuntamenti.list({
        gb: 'agente',
        dt_from: vm.widgetAppuntamenti.dt_from,
        dt_to: vm.widgetAppuntamenti.dt_to
      }).then(dtAppuntamenti);

      //////////////////////////////////////////////////////////////////////////
      function dtAppuntamenti(appuntamenti) {
        vm.widgetAppuntamenti.appuntamenti = appuntamenti;

        if (appuntamenti.length > 0) {
          vm.widgetAppuntamenti.dt.instance = {};

          vm.widgetAppuntamenti.dt.columns = [];
          angular.forEach(appuntamenti[0], function(value, key) {
            var columnDef = {};

            columnDef.data = key.replace('.', '\\.');

            //elabora nome campo per togliere eventuali ids
            if (key.indexOf('~') !== -1) {
              key = key.split('~');

              columnDef.title = key[0];
            } else {
              columnDef.title = key;
            }

            columnDef.render = renderLink;

            vm.widgetAppuntamenti.dt.columns.push(columnDef);
          });

          //nascondi prima colonna
          vm.widgetAppuntamenti.dt.columns[0].visible = false;
          vm.widgetAppuntamenti.dt.columns[0].searchable = false;

          vm.widgetAppuntamenti.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              return appuntamenti.$promise;
            })
            .withOption('order', [1, 'asc'])
            .withOption('dom', "rt<'row'<'col-xs-5'i><'col-xs-7'p>>")
            .withOption('pageLength', 10)
            .withOption('lengthChange', false)
            .withOption('searching', false)
          );
        }

        ////////////////////////////////////////////////////////////////////////
        function renderLink(data, type, row, meta) {
          if (meta.col > 1) { //salta prima e seconda colonna
            data = data * 1; //porta a valore numerico

            if (meta.col < (Object.keys(row).length - 1)) { //tutto fino a ultima colonna
              if (type === 'display' && data > 0) {
                //elabora nome campo per separare descrizione da id
                var api = new $.fn.dataTable.Api(meta.settings);

                var descColonna, idColonna;
                var colonna = api.column(meta.col).dataSrc();
                if (colonna.indexOf('~') !== -1) {
                  colonna = colonna.split('~');

                  descColonna = colonna[0];
                  idColonna = colonna[1];
                } else {
                  descColonna = colonna;
                  idColonna = colonna;
                }

                //scrivi il link
                var template = _.template('<a title="apri appuntamenti" ng-click=\'home.readAppuntamenti(${ filtro })\'>${ data }</a>');

                data = template({
                  filtro: angular.toJson({
                    idOperatore: vm.user.idAgenteT,
                    dt_from: vm.widgetAppuntamenti.dt_from,
                    dt_to: vm.widgetAppuntamenti.dt_to,
                    idStatoAppuntamento: idColonna,
                    statoAppuntamento: descColonna,
                    agente: row.agente,
                    idAgente: row.idAgente
                  }),
                  data: data
                });
              }
            }
          }

          return data;
        }

      }
    }

    function stopRefresh() {
      if (angular.isDefined(stopAvanzamenti)) {
        $interval.cancel(stopAvanzamenti);
        stopAvanzamenti = undefined;
      }

      if (angular.isDefined(stopAppuntamenti)) {
        $interval.cancel(stopAppuntamenti);
        stopAppuntamenti = undefined;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.cc')
    .controller('CcCampagneController', CcCampagneController);

  function CcCampagneController($routeParams, $scope, AuthenticateJS, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.rp = $routeParams;

    vm.widgetListe = {
      formData: {},
      filtro: {},
      showSearch: false,
      liste: [],
      dt: {}
    };

    vm.widgetAttese = {
      dt: {},
      period: vm.rp.period || 'scadute'
    };

    //widget campagne
    vm.readClientiLista = api.liste.actions.readClienti;
    //widget attese
    vm.readCliente = api.clienti.actions.read;

    widgetListe();
    widgetAttese();

    //widget campagne
    $scope.$on('Lista.created', dtListeReload);
    $scope.$on('Lista.updated', dtListeReload);
    $scope.$on('Lista.deleted', dtListeReload);
    //widget attese

    ////////////////////////////////////////////////////////////////////////////
    //widget campagne
    function widgetListe() {
      vm.widgetListe.search = getListe;
      vm.widgetListe.toggleSearch = toggleSearch;

      api.elenchi.searchForm({
        woAllZone: '1'
      }).then(dtListe);

      //////////////////////////////////////////////////////////////////////////
      function toggleSearch() {
        //reset dei campi avanzati
        vm.widgetListe.filtro.via = '';
        vm.widgetListe.filtro.cliente = '';
        vm.widgetListe.filtro.idCliente = '';

        vm.widgetListe.showSearch = !vm.widgetListe.showSearch;
      }

      function getListe() {
        var promise = api.liste.list({
          idOperatore: vm.user.idAgenteT,
          obsoleto: '0',
          privacy: '0',
          'idZona[]': vm.widgetListe.filtro.idZona,
          citta: vm.widgetListe.filtro.citta,
          aperti: vm.widgetListe.filtro.aperti,
          via: vm.widgetListe.filtro.via,
          cliente: vm.widgetListe.filtro.cliente,
          idCliente: vm.widgetListe.filtro.idCliente
        });

        promise.then(function (liste) {
          vm.widgetListe.liste = liste;
        });

        return promise;
      }

      function dtListe(formData) {
        vm.widgetListe.formData = formData;

        vm.widgetListe.filtro = {
          idZona: [],
          citta: '',
          aperti: '1',
          via: '',
          cliente: '',
          idCliente: ''
        };

        getListe();

        vm.widgetListe.dt.options = DTOptionsBuilder.newOptions()
          .withOption('order', [0, 'desc'])
          .withOption('dom', "tr<'row'<'col-xs-5'i><'col-xs-7'p>>")
          .withOption('pageLength', 10)
          .withOption('lengthChange', false)
          .withOption('searching', false)
        ;

        vm.widgetListe.dt.columnDefs = dtFactory.defaultColumnDefs.concat([
          {
            targets: -1,
            orderable: false,
            searchable: false
          }
        ]);

        vm.widgetListe.dt.getFiltro = getFiltro;
        vm.widgetListe.dt.linkAttivita = linkAttivita;

        //////////////////////////////////////////////////////////////////////
        function getFiltro(row, filter) {
          if (angular.isUndefined(filter)) { filter = {}; }

          var filtro = {
            motivo: row.descrizione,
            idOperatore: vm.user.idAgenteT,
            operatore: vm.user.username,
            privacy: '0',
            idZona: vm.widgetListe.filtro.idZona,
            citta: vm.widgetListe.filtro.citta,
            via: vm.widgetListe.filtro.via,
            cliente: vm.widgetListe.filtro.cliente,
            idCliente: vm.widgetListe.filtro.idCliente
          };

          filtro = angular.extend(filtro, filter);

          if (vm.widgetListe.filtro.idZona === []) {
            filtro.gb = 'zona';
          }

          return filtro;
        }

        function linkAttivita(idMotivo) {
          var href = '#/cc/campagne/' + idMotivo + '?';

          href += 'aperti=' + vm.widgetListe.filtro.aperti;
          angular.forEach(vm.widgetListe.filtro.idZona, function(idZona) {
            href += '&idZona[]=' + idZona;
          });
          href += '&citta=' + vm.widgetListe.filtro.citta;
          href += '&via=' + vm.widgetListe.filtro.via;
          href += '&cliente=' + vm.widgetListe.filtro.cliente;
          href += '&idCliente=' + vm.widgetListe.filtro.idCliente;

          return href;
        }
      }
    }

    function dtListeReload() {
      vm.widgetListe.search();
    }

    //widget attese
    function widgetAttese() {
      vm.widgetAttese.dt.instance = {};

      vm.widgetAttese.dt.columns = [
        {
          data: 'dataRichiamo',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {
          data: 'oraRichiamo',
          title: 'Ora',
          render: dtFactory.renders.time
        },
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente
        },
        {
          data: 'priorita',
          title: '<span title="Priorità">P</span>',
          render: renderPriorita,
          'class': 'min-width text-center'
        },
        {data: 'motivo', title: 'Campagna'},
        {
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      vm.widgetAttese.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(getAttese(vm.widgetAttese.period))
        .withOption('order', [
          [0, 'asc'],
          [1, 'desc'],
          [2, 'asc']
        ])
        .withOption('dom', "<'row'<'col-xs-4'l><'col-xs-4 text-center'B><'col-xs-4'f>r>t<'row'<'col-xs-6'i><'col-xs-6'p>>")
        .withButtons([
          {
            text: 'Scadute',
            className: 'btn-warning btn-sm',
            action: getAttese('scadute')
          },
          {
            text: 'Oggi',
            className: 'btn-info btn-sm',
            action: getAttese('oggi')
          },
          {
            text: 'Future',
            className: 'btn-success btn-sm',
            action: getAttese('future')
          }
        ])
      );

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="campagne.readCliente(' + row.idCliente + ')">' + data + '</a>';
        }

        return data;
      }

      function renderPriorita(data, type) {
        if (type === 'display') {
          switch (data) {
            case -1: //bassa
              data = '<i class="fa fa-fw fa-arrow-down larger text-success"></i>';
              break;

            case 1: //alta
              data = '<i class="fa fa-fw fa-arrow-up larger text-danger"></i>';
              break;

            default:
              data = '';
          }
        }

        return data;
      }

      function renderActions(data, type, row) {
        return '<a ng-href="#/cc/campagne/' + row.idMotivo + '?idCliente=' + row.idCliente + '&privacy=&period=' + vm.widgetAttese.period + '"><button type="button" class="btn btn-primary btn-xs">Chiama</button></a>';
      }

      function getAttese(period) {
        var from, to;

        switch (period) {
          case 'scadute':
            from = '';
            to = moment().subtract(1, 'day').startOf('day').toDate();
            break;

          case 'future':
            from = moment().add(1, 'day').startOf('day').toDate();
            to = '';
            break;

          case 'oggi':
          default:
            from = moment().startOf('day').toDate();
            to = moment().startOf('day').toDate();
        }

        return loadData;

        ////////////////////////////////////////////////////////////////////////
        function loadData() {
          var promise = api.operatore(vm.user.idAgenteT).elenchi.list({
            attesa: '',
            recall_from: from,
            recall_to: to
          });

          vm.widgetAttese.period = period;

          if (_.isEmpty(vm.widgetAttese.dt.instance)) {
            return promise;
          } else {
            vm.widgetAttese.dt.instance.changeData(promise)
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.cc')
    .controller('CcCampagnaController', CcCampagnaController);

  function CcCampagnaController(
    $routeParams, $rootScope, $scope, $q, $filter, $location, $window, AuthenticateJS,
    $modal, DTOptionsBuilder, dtFactory, api
  ) {
    var vm = this;

    var gestisciChiamataModal = $modal({
      scope: $scope,
      templateUrl: 'gestisci-chiamata.tpl.html',
      backdrop: 'static',
      show: false
    });

    var chiudiAttivitaModal = $modal({
      scope: $scope,
      templateUrl: 'chiudi-attivita.tpl.html',
      backdrop: 'static',
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.rp = $routeParams;

    vm.clienti = [];
    vm.cliente = {};
    vm.currentCliente = 0;

    vm.widgetTelefonate = {
      dt: {},
      telefonate: undefined,
      filtro: {last: ''}
    };

    vm.widgetAppuntamenti = {
      dt: {},
      appuntamenti: undefined,
      filtro: {last: ''}
    };

    vm.widgetDettagli = {
      activeTab: 0,
      dtContratti: {},
      contratti: undefined,
      filtro: {last: ''}
    };

    vm.nextCliente = nextCliente;
    vm.prevCliente = prevCliente;
    vm.toggleMore = toggleMore;
    vm.callDisabled = callDisabled;
    vm.callCliente = callCliente;
    vm.undoCallCliente = undoCallCliente;
    vm.closeCallCliente = closeCallCliente;
    vm.showCloseActivity = showCloseActivity;

    vm.updateCliente = api.clienti.actions.update;
    vm.presentazioneCliente = api.clienti.actions.inviaPresentazione;
    vm.confermaAppuntamento = api.appuntamenti.actions.inviaConferma;
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.readContratto = api.contratti.actions.read;

    //modal telefonata
    vm.alerts = {};
    vm.formData = {};
    vm.telefonata = {};
    vm.saveForm = saveForm;
    vm.undoForm = undoForm;

    vm.checkDistances = api.appuntamenti.actions.checkDistances;

    //modal chiudi attività
    vm.closeActivity = closeActivity;
    vm.undoCloseActivity = undoCloseActivity;

    //gestione dell'uscita dall'attività
    vm.exitConfirmed = false;

    $scope.$on('document.refresh', onExit);
    $scope.$on('$locationChangeStart', onExit);

    //imposta formData
    var promises = [];
    promises.push(api.telefonate.editForm());
    promises.push(api.appuntamenti.editForm());

    $q.all(promises).then(function(formsData) {
      vm.formData = angular.copy(formsData[0]);
      vm.formData.agenti = formsData[1].agenti;
      vm.formData.citta = formsData[1].citta;
      vm.formData.minDate = moment().subtract(1, 'days').startOf('day').toDate();
    });

    //carica la lista clienti
    api.lista(vm.rp.id).clienti.list({
      idOperatore: vm.user.idAgenteT,
      aperti: vm.rp.aperti || '',
      'idZona[]': vm.rp['idZona[]'] || '',
      citta: vm.rp.citta || '',
      idCliente: vm.rp.idCliente || '0',
      stato: 'Non Lavorati',
      privacy: (angular.isDefined(vm.rp.privacy) ? vm.rp.privacy : '0'),
      via: vm.rp.via || '',
      cliente: vm.rp.cliente || ''
    }).then(caricaClienti);

    //gestisci gli eventi per cui fare il refresh dei dati
    $scope.$on('Cliente.update', clienteUpdated);

    ////////////////////////////////////////////////////////////////////////////
    //gestione eventi
    function onExit(event, newUrl) {
      switch (event.name) {
        case '$locationChangeStart':
          if (!vm.exitConfirmed) {
            event.preventDefault();
            vm.newUrl = newUrl;
            showCloseActivity();
          }
          break;

        case 'document.refresh':
          showCloseActivity();
          break;
      }
    }

    function clienteUpdated(event, cliente) {
      angular.extend(vm.cliente, cliente);
    }

    function dtTelefonateReload(newCollection, oldCollection) {
      if (!angular.equals(newCollection, oldCollection)) {
        vm.widgetTelefonate.telefonate = undefined;
        api.cliente(vm.cliente.id).telefonate.list(vm.widgetTelefonate.filtro)
          .then(setTelefonate);
      }

      function setTelefonate(telefonate) {
        vm.widgetTelefonate.telefonate = telefonate;
      }
    }

    function dtAppuntamentiReload(newCollection, oldCollection) {
      if (!angular.equals(newCollection, oldCollection)) {
        vm.widgetAppuntamenti.appuntamenti = undefined;
        api.cliente(vm.cliente.id).appuntamenti.list(vm.widgetAppuntamenti.filtro)
          .then(setAppuntamenti);
      }

      function setAppuntamenti(appuntamenti) {
        vm.widgetAppuntamenti.appuntamenti = appuntamenti;
      }
    }

    function dtContrattiReload(newCollection, oldCollection) {
      if (!angular.equals(newCollection, oldCollection)) {
        vm.widgetDettagli.contratti = undefined;
        api.cliente(vm.cliente.id).contratti.list(vm.widgetDettagli.filtroContratti)
          .then(setContratti);
      }

      function setContratti(contratti) {
        vm.widgetDettagli.contratti = contratti;
      }
    }

    //carica elenco clienti
    function caricaClienti(clienti) {
      //se non esistono clienti esci
      if (clienti.length <= 0) {
        vm.closeActivity();

        return false;
      }

      vm.clienti = $filter('orderBy')(clienti, ['+cliente']);

      $scope.$watch('campagna.currentCliente', caricaSchedaCliente);
      $scope.$watchCollection('campagna.widgetTelefonate.filtro', dtTelefonateReload);
      $scope.$watchCollection('campagna.widgetAppuntamenti.filtro', dtAppuntamentiReload);
      $scope.$watchCollection('campagna.widgetDettagli.filtroContratti', dtContrattiReload);
    }

    //gestione scheda cliente
    function caricaSchedaCliente() {
      var idCliente = vm.clienti[vm.currentCliente].idCliente;

      //imposta stato iniziale chiamata del cliente
      if (angular.isUndefined(vm.clienti[vm.currentCliente].callStatus)) {
        vm.clienti[vm.currentCliente].callStatus = 'aperto'; //stato definitivo chiamata
      }

      //cliente
      api.cliente(idCliente).get()
        .then(setCliente);

      //telefonate cliente
      vm.widgetTelefonate.filtro = {last: ''};
      if (vm.clienti[vm.currentCliente].cieca) {
        vm.widgetTelefonate.filtro.fromDate = moment().startOf('day').toDate();
      }
      vm.widgetTelefonate.telefonate = undefined;
      api.cliente(idCliente).telefonate.list(vm.widgetTelefonate.filtro)
        .then(setTelefonate);

      //appuntamenti cliente
      vm.widgetAppuntamenti.filtro = {last: ''};
      vm.widgetAppuntamenti.appuntamenti = undefined;
      api.cliente(idCliente).appuntamenti.list(vm.widgetAppuntamenti.filtro)
        .then(setAppuntamenti);

      //contratti cliente
      vm.widgetDettagli.filtroContratti = {last: ''};
      vm.widgetDettagli.contratti = undefined;
      api.cliente(idCliente).contratti.list(vm.widgetDettagli.filtroContratti)
        .then(setContratti);

      //////////////////////////////////////////////////////////////////////////
      function setCliente(cliente) {
        vm.cliente = cliente;

        vm.cliente.inCall = false;
        vm.cliente.callStatus = ''; //stato temporaneo chiamata

        gestisciChiamataModal.hide(); //nascondi modal a prescindere
      }

      function setTelefonate(telefonate) {
        vm.widgetTelefonate.dt.options = DTOptionsBuilder.newOptions()
          .withOption('order', [0, 'desc'])
          .withOption('dom', "rt")
          // .withOption('pageLength', 10)
          .withOption('lengthChange', false)
          .withOption('searching', false)
          .withOption('info', false)
          .withOption('paging', false)
        ;

        vm.widgetTelefonate.dt.columnDefs = dtFactory.defaultColumnDefs;

        vm.widgetTelefonate.telefonate = telefonate;
      }

      function setAppuntamenti(appuntamenti) {
        vm.widgetAppuntamenti.dt.options = DTOptionsBuilder.newOptions()
          .withOption('order', [0, 'desc'])
          .withOption('dom', "rt")
          // .withOption('pageLength', 10)
          .withOption('lengthChange', false)
          .withOption('searching', false)
          .withOption('info', false)
          .withOption('paging', false)
        ;

        vm.widgetAppuntamenti.dt.columnDefs = dtFactory.defaultColumnDefs;

        vm.widgetAppuntamenti.appuntamenti = appuntamenti;
      }

      function setContratti(contratti) {
        vm.widgetDettagli.dtContratti.options = DTOptionsBuilder.newOptions()
          .withOption('order', [0, 'desc'])
          .withOption('dom', "rt")
          // .withOption('pageLength', 10)
          .withOption('lengthChange', false)
          .withOption('searching', false)
          .withOption('info', false)
          .withOption('paging', false)
        ;

        vm.widgetDettagli.dtContratti.columnDefs = dtFactory.defaultColumnDefs;

        vm.widgetDettagli.contratti = contratti;
      }
    }

    function nextCliente() {
      if (vm.currentCliente < (vm.clienti.length - 1)) {
        vm.currentCliente++;
      }
    }

    function prevCliente() {
      if (vm.currentCliente > 0) {
        vm.currentCliente--;
      }
    }

    function toggleMore(obj) {
      if (_.isEmpty(obj.filtro)) {
        obj.filtro = {
          last: ''
        };
      } else {
        obj.filtro = {};
      }
    }

    //gestione chiamata
    function callDisabled() {
      return (vm.cliente.inCall !== false || vm.clienti[vm.currentCliente].callStatus !== 'aperto');
    }

    function callCliente(number) {
      vm.cliente.inCall = number;
    }

    function undoCallCliente() {
      vm.cliente.inCall = false;
    }

    function closeCallCliente(status) {
      vm.cliente.callStatus = status;

      //defaults della form
      var filtriStati = {negativo: 'N', richiama: 'R', appuntamento: 'T', positivo: 'C'};
      vm.formData.statiFiltrati = $filter('filter')(vm.formData.stati, filtriStati[status], true);

      vm.telefonata = {
        idElenco: vm.clienti[vm.currentCliente].idElenco,
        idCliente: vm.cliente.id,
        idStatoTelefonata: (vm.formData.statiFiltrati[0].value ? vm.formData.statiFiltrati[0].value : '0'),
        idStatoElenco: (vm.formData.statiFiltrati[0].idStatoElenco ? vm.formData.statiFiltrati[0].idStatoElenco : '0')
      };

      if (status === 'richiama') {
        vm.telefonata.priorita = 0;
      }

      if (status === 'appuntamento') {
        vm.telefonata.idStatoTelefonata = '31';
        vm.telefonata.idStatoElenco = '5';

        vm.telefonata.idAgente = '';
        vm.telefonata.cliente = vm.cliente.ragSoc;
        vm.telefonata.idPortafoglio = vm.cliente.idPtf;
        vm.telefonata.indirizzo = vm.cliente.indirizzo;
        vm.telefonata.cap = vm.cliente.cap;
        vm.telefonata.citta = vm.cliente.citta;
        vm.telefonata.prov = vm.cliente.prov;
        vm.telefonata.tel = vm.cliente.tel;
        vm.telefonata.email = vm.cliente.email;
      }

      //resetto gli alerts
      vm.alerts = {};

      //visualizza modal
      gestisciChiamataModal.$promise
        .then(gestisciChiamataModal.show);
    }

    function showCloseActivity() {
      vm.exitConfirmed = false;

      chiudiAttivitaModal.$promise
        .then(chiudiAttivitaModal.show);
    }

    //modal telefonata
    function saveForm() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      api.operatore(vm.user.idAgenteT).telefonate.save(vm.telefonata)
        .then(closeModal, setAlerts);

      function closeModal(telefonata) {
        //imposto lo stato definitivo chiamata
        vm.clienti[vm.currentCliente].callStatus = vm.cliente.callStatus;

        //nascondo la modal
        gestisciChiamataModal.hide();

        //apro la modal di invio conferma appuntamento
        if (vm.cliente.callStatus === 'appuntamento') {
          //fare MOLTA attenzione che vm.telefonata e telefonata NON sono la stessa cosa qui
         vm.confermaAppuntamento(telefonata.idAppuntamento, {
            indirizzo: vm.telefonata.email,
            oggetto: 'Conferma Appuntamento ' + vm.telefonata.cliente
          });
        }

        //avanzo di cliente
        nextCliente();
      }

      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    function undoForm() {
      gestisciChiamataModal.hide();

      vm.telefonata = {};
    }

    //modal chiudi attività
    function closeActivity() {
      chiudiAttivitaModal.hide();

      vm.exitConfirmed = true;
      if (angular.isUndefined(vm.newUrl)) {
        $location.path('/cc/campagne');
      } else {
        $window.location.href = vm.newUrl;
      }
    }

    function undoCloseActivity() {
      vm.exitConfirmed = false;
      delete vm.newUrl;

      chiudiAttivitaModal.hide();
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.bo', [
      'g1.core'
    ])
    .config(routeConfig)
  ;

  //////////////////////////////////////////////////////////////////////////////
  function routeConfig($routeProvider) {
    /** routing */
    $routeProvider
      .when('/bo', {
        templateUrl: 'app/bo/home/home.html',
        controller: 'BoHomeController',
        controllerAs: 'home',
        security: 'BO',
        title: 'Home'
      })
    ;
  }
})();

(function() {
  'use strict';

  angular.module('g1.bo')
    .controller('BoHomeController', BoHomeController);

  function BoHomeController() {
    var vm = this;

    vm.xxx = 'test';
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('RicercaProvvigioniController', RicercaProvvigioniController);

  function RicercaProvvigioniController($scope, $filter, AuthenticateJS, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.searchData = {};
    vm.searchForm = {};
    vm.dt = {};
    vm.searched = false;
    vm.search = search;

    //actions
    vm.readProvvigioneCalcolata = api.provvigioni.calcolate.actions.read;
    vm.deleteProvvigioneCalcolata = api.provvigioni.calcolate.actions.delete;
    vm.readCliente = api.clienti.actions.read;
    vm.readContratto = api.contratti.actions.read;

    //gestione eventi
    $scope.$on('ProvvigioneCalcolata.created', reloadData);
    $scope.$on('ProvvigioneCalcolata.updated', reloadData);
    $scope.$on('ProvvigioneCalcolata.deleted', reloadData);

    //run
    loadSearchData();

    ////////////////////////////////////////////////////////////////////////////
    function loadSearchData() {
      api.provvigioni.calcolate.searchForm().then( function ( searchData ) {
        vm.searchData = searchData;

        vm.searchData.dPiste = '0';

        vm.searchForm = {
          conferma_from: moment().startOf('year').toDate(),
          conferma_to: moment().endOf('year').startOf('day').toDate(),
          fornitore: 'CLYCO',
          pista: '0'
        };
      });
    }

    function search() {
      loadDt();

      vm.searched = true;
    }

    function loadDt() {
      var searchForm = angular.copy(vm.searchForm);
      if (_.isDate(searchForm.conferma_from)) {
        searchForm.conferma_from = searchForm.conferma_from.toISOString();
      }
      if (_.isDate(searchForm.conferma_to)) {
        searchForm.conferma_to = searchForm.conferma_to.toISOString();
      }

      var ajaxRequest = {
        url: apiBaseUrl + '/provvigioni/calcolate?dt',
        data: searchForm,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        }
      };

      if (_.isEmpty(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder.newOptions()
          .withOption('ajax', ajaxRequest)
          .withDataProp('data')
          .withOption('processing', true)
          .withOption('serverSide', true)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              text: 'Esporta',
              className: 'btn-info btn-sm',
              action: exportCsv
            }
          ])
          .withOption('order', [
            [0, 'asc'],
            [1, 'asc'],
            [4, 'asc']
          ])
          .withOption('pageLength', 25)
        );

        vm.dt.columns = [
          {
            data: 'segnalatore',
            title: 'Segnalatore'
          },
          {
            data: 'cliente',
            title: 'Cliente',
            render: renderCliente
          },
          {
            data: 'ptf',
            title: 'Cluster'
          },
          {
            data: 'dataConferma',
            title: 'Data',
            render: dtFactory.renders.date
          },
          {
            data: 'codiceProdotto',
            title: 'Codice',
            render: renderContratto
          },
          {
            data: 'prodotto',
            title: 'Prodotto'
          },
          {
            data: 'qta',
            title: '<span title="Quantità">Qta</span>',
            'class': 'min-width text-right'
          },
          {
            data: 'prezzo',
            title: 'Prezzo',
            render: dtFactory.renders.currency,
            'class': 'min-width text-right'
          },
          {
            data: 'provvigione',
            title: 'Provvigione',
            render: dtFactory.renders.currency,
            'class': 'min-width text-right'
          },
          {
            data: 'ricorrente',
            title: 'Ric',
            render: renderRicorrente
          },
          {
            data: 'tipoSoggetto',
            title: 'Tipo'
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'stato',
            title: 'Stato'
          },
          {
            data: 'dataCalcolo',
            title: 'Calcolo',
            render: dtFactory.renders.date
          }
        ];
      } else {
        vm.dt.instance.changeData(ajaxRequest);
      }

      //////////////////////////////////////////////////////////////////////////
      function renderCliente(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri cliente" ng-click="rpc.readCliente(' + row.idCliente + ')">' + data + '</a>';
        }

        return data;
      }

      function renderContratto(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri contratto" ng-click="rpc.readContratto(' + row.idContratto + ')">' + data + '</a>';
        }

        return data;
      }

      function renderRicorrente( data ) {
        return data ? 'Sì' : 'No';
      }

      function exportCsv(e, dt) {
        var getParams = dt.ajax.params();
        delete getParams.start;
        delete getParams.length;
        getParams.csv = true;

        var numRecords = dt.page.info().recordsDisplay;

        return dtFactory.exportFile(apiBaseUrl + '/provvigioni/calcolate', getParams, numRecords);
      }
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti', [
      'g1.core'
    ])
    .constant('baseRoute', '/agenti')
    .config(routeConfig)
  ;

  //////////////////////////////////////////////////////////////////////////////
  function routeConfig($routeProvider, baseRoute) {
    /** routing */
    $routeProvider
      .when(baseRoute, {
        templateUrl: 'app/agenti/home/home.html',
        controller: 'AgentiHomeController',
        controllerAs: 'home',
        security: 'AGENTI',
        title: 'Home'
      })
      .when('/ricerca/provvigioni', {
        templateUrl: 'app/agenti/ricerca/provvigioni.html',
        controller: 'RicercaProvvigioniController',
        controllerAs: 'rpc',
        security: 'AGENTI',
        title: 'Ricerca Provvigioni'
      })
    ;
  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti')
    .controller('AgentiHomeController', AgentiHomeController);

  function AgentiHomeController($window, $scope, $filter, AuthenticateJS, $alert, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var dtDom = 'trp';
    var dtAppuntamenti = {
      dtColumns: [
        {
          data: 'data',
          title: 'Data',
          render: renderData
        },
        {
          data: 'ora',
          title: 'Ora',
          render: renderOra
        },
        {
          data: 'cliente',
          title: 'Cliente',
          'class': '',
          render: renderCliente
        },
        {
          data: 'citta',
          title: 'Città',
          'class': '',
          render: renderCitta
        },
        {
          data: 'indirizzo',
          title: 'Indirizzo'
        },
        {
          data: 'tel',
          title: 'Tel'
        },
        {
          data: 'stati_appuntamento_descrizione',
          title: 'Stato'
        },
        {
          data: 'id',
          title: '',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ]
    };

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.q = '?';
    vm.qValues = [];
    vm.totaleRicorrente = 0;
    vm.now = new Date();
    vm.giorni = {};
    vm.piste = [];
    vm.warningsPiste = [];
    vm.avanzamento = {
      adv: 0,
      obj: 0,
      perc: 0,
      status: 'info',
      img: ''
    };

    vm.chartAvanzamento = {};
    vm.chartOpportunita = {};
    vm.appuntamentiOggi = {
      dataApp: moment().startOf('day').toDate(),
      dt: {},
      changeDataApp: changeDataApp,
      syncGcal: syncGcal
    };
    vm.dtAppuntamentiVisita = {};
    vm.dtOpportunitaAperte = {};
    vm.contrattiInScadenza = [];

    //gestione dei links
    vm.readAppuntamento = api.appuntamenti.actions.read;
    vm.esitaAppuntamento = api.appuntamenti.actions.esita;
    vm.readCliente = api.clienti.actions.read;

    //carica avanzamenti
    avanzamenti();
    chartAvanzamento();
    chartOpportunita();

    //carica appuntamenti
    dtAppuntamentiOggi();
    dtAppuntamentiVisita();
    dtOpportunitaAperte();

    //gestione appuntamenti
    $scope.$on('Appuntamento.created', updateDtAppuntamenti);
    $scope.$on('Appuntamento.updated', updateDtAppuntamenti);
    $scope.$on('Appuntamento.deleted', updateDtAppuntamenti);

    ////////////////////////////////////////////////////////////////////////////
    function avanzamenti() {
      api.list('/agenti', 'AgentiHome').get()
        .then(setAvanzamenti);

      function setAvanzamenti(response) {
        //imposta numero q
        vm.q = moment(response.q.start).quarter();

        // imposta valori per Q e totale
        vm.qValues = response.qValues;
        for ( var i in response.qValues ) {
          vm.totaleRicorrente += response.qValues[i].ricorrente;
        }

        //calcolo percentuali dei giorni
        response.giorni.perc = percentual(response.giorni.adv, response.giorni.obj);
        response.giorni.status = getStatus(response.giorni.perc, true);
        vm.giorni = response.giorni;

        //calcolo avanzamenti
        vm.avanzamento = response.totale;

        vm.piste = setPiste(response.piste, vm.giorni.perc, vm.avanzamento.adv);

        //impostazione dei warnings
        vm.warningsPiste = response.warnings;

        //calcolo stati globali
        vm.avanzamento.perc = percentual(vm.avanzamento.adv, vm.avanzamento.obj);
        vm.avanzamento.status = getStatus(vm.avanzamento.perc);
        vm.avanzamento.img = getImg(percentual(vm.avanzamento.perc, vm.giorni.perc));

        ////////////////////////////////////////////////////////////////////////
        function setPiste(piste, giorniPerc, totale) {
          angular.forEach(piste, function(value, key) {
            piste[key].perc = percentual(piste[key].adv, totale);
            piste[key].status = getStatus(percentual(piste[key].perc, giorniPerc));
          });

          return piste;
        }

        function percentual(n, tot) {
          return (n / tot) * 100;
        }

        function getStatus(perc, reverse) {
          var status = '';
          var classes = ['danger', 'default', 'success'];

          if (perc <= 33.3) {
            status = classes[reverse ? 2 : 0];
          } else if ((perc > 33.3) && (perc <= 66.6)) {
            status = classes[reverse ? 1 : 1];
          } else {
            status = classes[reverse ? 0 : 2];
          }

          return status;
        }

        function getImg(perc) {
          if (perc <= 33.3) {
            return 1;
          } else if ((perc > 33.3) && (perc <= 66.6)) {
            return 3;
          } else {
            return 5;
          }
        }
      }
    }

    // grafici
    function chartAvanzamento() {
      vm.chartAvanzamento.setStati = setStati;

      vm.chartAvanzamento.id = 'gav';
      vm.chartAvanzamento.title = 'in caricamento...';
      vm.chartAvanzamento.total = '0';

      api.chart(vm.chartAvanzamento.id).searchForm()
        .then(showChart);

      function showChart(formData) {
        vm.chartAvanzamento.formData = formData;

        vm.chartAvanzamento.options = {
          height: '400px',
          anno: vm.chartAvanzamento.formData.anno,
          tipoData: vm.chartAvanzamento.formData.tipoData,
          'idStati[]': vm.chartAvanzamento.formData.idStati,
          tipo: vm.chartAvanzamento.formData.tipo
        };
      }

      function setStati(tipoData) {
        var idStati4tipoData = [];

        switch (tipoData) {
          case 'crm':
            idStati4tipoData = _.map($filter('filter')(vm.chartAvanzamento.formData.stati, {gruppo: '1 OK'}, true), 'value');
            break;

          case 'inserimento':
            idStati4tipoData = _.map($filter('filter')(vm.chartAvanzamento.formData.stati, {gruppo: '!4 ANNULLATO'}, true), 'value');
            break;

          case 'conferma':
            angular.forEach(vm.chartAvanzamento.formData.stati, function(value) {
              if (value.gruppo === '1 OK' || value.gruppo === '2 LAVORAZIONE') {
                idStati4tipoData.push(value.value);
              }
            });
            break;
        }

        vm.chartAvanzamento.options['idStati[]'] = idStati4tipoData;
      }
    }

    function chartOpportunita() {
      vm.chartOpportunita.id = 'goppo';
      vm.chartOpportunita.title = 'in caricamento...';
      vm.chartOpportunita.total = '0';

      api.chart(vm.chartOpportunita.id).searchForm()
        .then(showChart);

      function showChart(formData) {
        vm.chartOpportunita.formData = formData;

        vm.chartOpportunita.options = {
          height: '400px',
          dataFrom: vm.chartOpportunita.formData.dataFrom,
          dataTo: vm.chartOpportunita.formData.dataTo,
          tipo: vm.chartOpportunita.formData.tipo,
          actionOnClick: null
        };
      }
    }

    //gestione tabelle appuntamenti
    function dtAppuntamentiOggi() {
      vm.appuntamentiOggi.dt.instance = {};

      vm.appuntamentiOggi.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.appuntamenti.list({
            dt_from: vm.appuntamentiOggi.dataApp,
            dt_to: vm.appuntamentiOggi.dataApp
          });
        })
        .withOption('order', [
          [0, 'desc'],
          [1, 'asc']
        ])
        .withOption('dom', dtDom)
        .withOption('info', false)
        .withOption('pageLength', 5)
        .withOption('lengthChange', false)
        .withOption('searching', false)
      );

      vm.appuntamentiOggi.dt.columns = angular.copy(dtAppuntamenti.dtColumns);
    }

    function changeDataApp(direction) {
      switch (direction) {
        case 'next':
          vm.appuntamentiOggi.dataApp = moment(vm.appuntamentiOggi.dataApp).add(1, 'day').toDate();
          break;

        case 'prev':
          vm.appuntamentiOggi.dataApp = moment(vm.appuntamentiOggi.dataApp).subtract(1, 'day').toDate();
          break;

        case 'today':
        default:
          vm.appuntamentiOggi.dataApp = moment().startOf('day').toDate();
          break;
      }

      vm.appuntamentiOggi.dt.instance.reloadData(null, true);
    }

    function syncGcal() {
      api.list('/agenti/' + vm.user.idAgente + '/gcal/sync', 'Gcal').list({
        dt_from: moment().startOf('week').startOf('day').toDate(),
        dt_to: moment().endOf('week').startOf('day').toDate()
      }).then(onSuccess, onError);

      //////////////////////////////////////////////////////////////////////////
      function onSuccess(syncResult) {
        $alert({
          placement: 'top',
          title: syncResult.length + ' appuntamenti sincronizzati.',
          type: 'success'
        });
      }

      function onError(syncError) {
        switch(syncError.status) {
          case 403:
            $alert({
              placement: 'top',
              title: 'Non autorizzato. Ripetere il sync dopo aver concesso i permessi di accesso. Fare attenzione ad avere abilitato i popup.',
              type: 'danger'
            });

            $window.open(syncError.data.auth_url);
            break;

          default:
            $alert({
              placement: 'top',
              title: 'Errore:' + syncError.data,
              type: 'danger'
            });
        }
      }
    }

    function dtAppuntamentiVisita() {
      vm.dtAppuntamentiVisita.dtInstance = {};

      vm.dtAppuntamentiVisita.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return api.appuntamenti.list({
              dt_from: moment().subtract(6, 'months').startOf('day').toDate(),
              dt_to: moment().subtract(1, 'days').startOf('day').toDate(),
              idStatoAppuntamento: '103'
            });
          })
          .withOption('order', [
            [0, 'asc'],
            [1, 'asc']
          ])
          .withOption('dom', dtDom)
          .withOption('info', false)
          .withOption('pageLength', 5)
          .withOption('lengthChange', false)
          .withOption('searching', false)
      );

      vm.dtAppuntamentiVisita.dtColumns = angular.copy(dtAppuntamenti.dtColumns);
      vm.dtAppuntamentiVisita.dtColumns[5].visible =  false;
      vm.dtAppuntamentiVisita.dtColumns[6].visible =  false;
      vm.dtAppuntamentiVisita.dtColumns[7].visible =  false;
    }

    function dtOpportunitaAperte() {
      vm.dtOpportunitaAperte.dtInstance = {};

      vm.dtOpportunitaAperte.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return api.opportunita().list( {
              idStato: 1
            } );
          })
          .withOption('order', [
            [0, 'asc'],
            [1, 'asc']
          ])
          .withOption('dom', dtDom)
          .withOption('info', false)
          .withOption('pageLength', 5)
          .withOption('lengthChange', false)
          .withOption('searching', false)
      );
      vm.dtOpportunitaAperte.dtColumns = [
        {
          data: 'dataSegnalazione',
          title: 'Data',
          render: dtFactory.renders.date,
          class: 'data'
        },
        {
          data: 'cliente',
          title: 'Cliente',
          render: renderCliente,
          class: 'cliente'
        },
        {
          data: 'pista',
          title: 'Pista',
          class: 'pista'
        },
        {
          data: 'valore',
          title: 'Valore',
          class: 'valore'
        },
        {
          data: 'percChiusura',
          title: 'Prob.',
          render: dtFactory.renders.percent(),
          class: 'percChiusura'
        },
        {
          data: 'stage',
          title: 'Fase',
          class: 'fase'
        }
      ];

    }

    //carica widget contratti in scadenza
    loadContrattiInScadenza();

    //funzioni shared fra le tre tabelle appuntamenti
    function updateDtAppuntamenti() {
      vm.appuntamentiOggi.dt.instance.reloadData(null, true);
      vm.dtAppuntamentiVisita.dtInstance.reloadData(null, true);
    }

    function renderData(data, type, row) {
      if (type === 'display') {
        data = dtFactory.renders.date(data, type);

        if (row.privato !== '1') {
          return '<a title="apri appuntamento" ng-click="home.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
        }
      }

      return data;
    }

    function renderOra(data, type, row) {
      if (type === 'display') {
        if (row.privato !== '1') {
          return '<a title="apri appuntamento" ng-click="home.readAppuntamento(\'' + row.id + '\')">' + data + '</a>';
        }
      }

      return data;
    }

    function renderCliente(data, type, row) {
      if (type === 'display') {
        if (row.privato !== '1') {
          var dataTooltip = data.replace( '"', '\\"' );
          return '<a title="' + dataTooltip + '" bs-tooltip ng-click="home.readCliente(\'' + row.idCliente + '\')">' + data + '</a>';
        }
      }

      return data;
    }

    function renderCitta(data, type, row) {
      if (type === 'display') {
        return data + '(' + row.prov + ')';
      }

      return data;
    }

    function renderActions(data) {
      return '<button type="button" class="btn btn-warning btn-xs" title="Esita" ng-click="home.esitaAppuntamento(' + data + ')"><i class="fa fa-check-square-o"></i></button>';
    }

    function loadContrattiInScadenza() {
      var promise = api.list( '/liste/reports/cntrsc', 'cntrscListe' ).list();
      promise.then( function ( data ) {
        for ( var i in data[0] ) {
          if ( typeof data[0][i] == 'object' ) {
            vm.contrattiInScadenza.push( data[0][i] );
          }
        }
      } );
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti')
    .controller('ClienteAgenteController', ClienteAgenteController);

  function ClienteAgenteController($rootScope, $scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var clienteAgenteModal = $modal({
      scope: $scope,
      templateUrl: 'cliente-agente-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.cliente = {};
    vm.calcolaInnovatore = calcolaInnovatore;
    vm.showElencoReferenti = false;

    //appuntamenti
    vm.dtAppuntamenti = {};
    vm.createAppuntamentoAgente = function createAppuntamentoAgente(cliente) {
      $rootScope.$broadcast('createAppuntamentoClienteAgente', cliente);
    };

    //opportunità
    vm.dtOpportunita = {};
    vm.checkEditPermission = api.opportunita().actions.checkEditPermission;
    vm.readOpportunita = api.opportunita().actions.read;
    vm.createOpportunitaSegnalatore = function createOpportunitaSegnalatore(cliente) {
      $rootScope.$broadcast('createOpportunitaClienteSegnalatore', cliente);
    };
    vm.updateOpportunitaSegnalatore = function updateOpportunitaSegnalatore(idOpportunita) {
      $rootScope.$broadcast('updateOpportunitaSegnalatore', idOpportunita);
    };
    vm.deleteOpportunita = api.opportunita().actions.delete;

    vm.dtReferenti = {};
    vm.referenti = [];
    vm.createReferente = api.cliente().referenti.actions.create;
    vm.readReferente = api.referenti.actions.read;
    vm.updateReferente = api.referenti.actions.update;
    vm.deleteReferente = api.referenti.actions.delete;

    //gestione cliente
    $scope.$on('readClienteAgente', readClienteAgente);

    //gestione appuntamenti
    $scope.$on('Appuntamento.created', dtAppuntamentiReload);

    //gestione opportunità
    $scope.$on('Opportunita.created', dtOpportunitaReload);
    $scope.$on('Opportunita.updated', dtOpportunitaReload);
    $scope.$on('Opportunita.deleted', dtOpportunitaReload);

    //gestione referenti
    $scope.$on('Referente.created', dtReferentiReload);
    $scope.$on('Referente.updated', dtReferentiReload);
    $scope.$on('Referente.deleted', dtReferentiReload);

    //gestione cliente
    function readClienteAgente(event, idCliente) {
      api.cliente(idCliente).get()
        .then(showModal);

      dtAppuntamenti(idCliente);
      dtOpportunita(idCliente);
      dtReferenti(idCliente);

      function showModal(cliente) {
        vm.cliente = cliente;

        clienteAgenteModal.$promise
          .then(clienteAgenteModal.show);
      }
    }

    function calcolaInnovatore(valore) {
      var percentuale = valore * 100;
      var testo = '';

      if (percentuale <= 30.00) {
        testo = 'Conservatore'
      } else if (percentuale >= 30.01 && percentuale <= 70.00) {
        testo = 'Neutro'
      } else {
        testo = 'Innovatore'
      }

      return testo + ' (' + percentuale + '%)';
    }

    //gestione appuntamenti
    function dtAppuntamenti(idCliente) {
      vm.dtAppuntamenti.dtInstance = {};

      vm.dtAppuntamenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.cliente(idCliente).appuntamenti.list({
            last: ''
          });
        })
        .withOption('dom', 'tr')
        .withOption('order', [
          [0, 'desc'],
          [1, 'asc']
        ])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtAppuntamenti.dtColumns = [
        {
          data: 'data',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {
          data: 'ora',
          title: 'Ora',
          render: dtFactory.renders.time
        },
        {
          data: 'agenti_agente',
          title: 'Agente',
          'class': ''
        },
        {
          data: 'operatori_operatore',
          title: 'Operatore',
          'class': ''
        },
        {data: 'stati_appuntamento_descrizione', title: 'Stato'}
      ];
    }

    function dtAppuntamentiReload() {
      if (angular.isDefined(vm.dtAppuntamenti.dtInstance)) {
        vm.dtAppuntamenti.dtInstance.reloadData();
      }
    }

    //gestione opportunità
    function dtOpportunita(idCliente) {
      vm.dtOpportunita.dtInstance = {};

      vm.dtOpportunita.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.cliente(idCliente).opportunita.list({
            last: ''
          });
        })
        .withOption('dom', 'tr')
        .withOption('order', [0, 'desc'])
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('searching', false)
        .withOption('paging', false)
      );

      vm.dtOpportunita.dtColumns = [
        {
          data: 'dataSegnalazione',
          title: 'Data',
          render: dtFactory.renders.date
        },
        {data: 'agentePIC', title: 'Agente'},
        {data: 'fornitore', title: 'Fornitore'},
        {data: 'pista', title: 'Pista'},
        {
          data: 'valore',
          title: 'Valore',
          render: dtFactory.renders.currency
        },
        {
          data: 'percChiusura',
          title: 'Probabilità',
          render: dtFactory.renders.percent()
        },
        {
          data: 'dataChiusura',
          title: '<span title="Data Prevista Chiusura">Prev. Chiusura</span>',
          render: dtFactory.renders.date
        },
        {
          data: 'stato',
          title: 'Stato',
          render: renderOpportunita
        },
        {data: 'stage', title: 'Fase'},
        {data: 'fonte', title: 'Fonte'},
        {
          data: 'note',
          title: 'Note',
          'class': '',
          render: dtFactory.renders.longtext
        },
        {
          data: 'id',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      vm.dtOpportunita.showMore = true;
      vm.dtOpportunita.more = more;

      //////////////////////////////////////////////////////////////////////////
      function renderOpportunita(data, type, row) {
        if (type === 'display') {
          if (vm.user.flags.gestOppo) {
            data = '<a title="apri opportunita" ng-click="cliente.readOpportunita(\'' + row.id + '\')">' + data + '</a>';
          }
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateOpportunita(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var updS = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateOpportunitaSegnalatore(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteOpportunita(' + data + ')"><i class="fa fa-minus"></i></button>';

        switch (vm.checkEditPermission(vm.user, row)) {
          case 'segnalatore':
            actions = updS + '&nbsp;' + del;
            break;

          case 'agente':
          case 'admin':
            actions = upd + '&nbsp;' + del;
            break;
        }

        return actions;
      }

      function more() {
        vm.dtOpportunita.showMore = false;

        vm.dtOpportunita.dtOptions
          .withOption('info', true)
          .withOption('lengthChange', true)
          .withOption('searching', true)
          .withOption('paging', true)
        ;

        vm.dtOpportunita.dtInstance.changeData(api.cliente(idCliente).opportunita.list);
      }
    }

    function dtOpportunitaReload(event, opportunita) {
      if (event.name === 'Opportunita.deleted') {
        vm.dtOpportunita.dtInstance.reloadData();
      } else {
        if (opportunita.idCliente === vm.cliente.id) {
          vm.dtOpportunita.dtInstance.reloadData();
        }
      }
    }

    function dtReferenti(idCliente) {
      vm.dtReferenti.dtInstance = {};
      vm.dtReferenti.dtOptions = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(getReferenti(idCliente))
        /*
        .withOption('order', [
          [0, 'desc'],
          [1, 'asc']
        ])
        */
        .withOption('searching', false)
        .withOption('paging', false)
        .withOption('createdRow', createdRow)
      );

      vm.dtReferenti.dtColumns = [
        {
          data: 'nominativo',
          title: 'Nominativo'
        },
        {
          data: 'email',
          title: 'Email'
        },
        {
          data: 'tel',
          title: 'Telefono'
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="cliente.createReferente(cliente.cliente)"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          orderable: false,
          searchable: false
        }
      ];

      function getReferenti(idCliente) {
        var promise = api.cliente(idCliente).referenti.list();
        promise.then(function(referenti) {
          vm.referenti = referenti;
        });
        return promise;
      }

      function createdRow( row, data ) {
        if (data.inattivo) {
          angular.element( row ).addClass( 'line-through' );
        }
        if (data.referentePrincipale) {
          angular.element( row ).addClass( 'bold' );
        }
      }

      function renderActions( data ) {
        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="cliente.updateReferente(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="cliente.deleteReferente(' + data + ')"><i class="fa fa-minus"></i></button>';
        var actions = upd + '&nbsp;' + del;
        return actions;
      }

    }

    function dtReferentiReload( event, referente ) {
      if ( vm.dtReferenti.dtInstance ) {
        if ( event.name === 'Referente.deleted' ) {
          vm.dtReferenti.dtInstance.reloadData();
        } else {
          if ( referente.idCliente === vm.cliente.id ) {
            vm.dtReferenti.dtInstance.reloadData();
          }
        }
      }
    }


  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti')
    .controller('AppuntamentoUpdateContattiController', AppuntamentoUpdateContattiController);

  function AppuntamentoUpdateContattiController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoUpdateContattiModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-update-contatti-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.saveForm = saveForm;

    $scope.$on('updateContattiAppuntamento', updateContattiAppuntamento);

    ////////////////////////////////////////////////////////////////////////////
    function updateContattiAppuntamento(event, idAppuntamento) {
      api.appuntamento(idAppuntamento).get()
        .then(showModal);

      function showModal(appuntamento) {
        vm.appuntamento = appuntamento;

        appuntamentoUpdateContattiModal.$promise
          .then(appuntamentoUpdateContattiModal.show);
      }
    }

    function saveForm() {
      api.appuntamento(vm.appuntamento.id).update(vm.appuntamento)
        .then(appuntamentoUpdateContattiModal.hide);
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti')
    .controller('AppuntamentoEsitaController', AppuntamentoEsitaController);

  function AppuntamentoEsitaController($rootScope, $scope, $q, $filter, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoEsitaModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-esita-modal.tpl.html',
      backdrop: false,
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.questionario = {};
    vm.formData = {};

    vm.saveForm = saveForm;
    vm.undoForm = undoForm;
    vm.checkStatoAppuntamento = checkStatoAppuntamento;

    $scope.$on('esitaAppuntamento', esitaAppuntamento);

    ////////////////////////////////////////////////////////////////////////////
    function esitaAppuntamento(event, idAppuntamento) {
      api.appuntamenti.editForm()
        .then(getAppuntamento);

      function getAppuntamento(formData) {
        vm.formData = formData;

        api.appuntamento(idAppuntamento).get()
          .then(showModal);

        function showModal(appuntamento) {
          vm.appuntamento = appuntamento;

          appuntamentoEsitaModal.$promise
            .then(appuntamentoEsitaModal.show);
        }
      }
    }

    function saveForm() {
      api.appuntamento(vm.appuntamento.id)
        .update(vm.appuntamento)
        .then(afterEsitaAppuntamento);

      function afterEsitaAppuntamento(appuntamento) {
        appuntamentoEsitaModal.hide();

        if (appuntamento.idStatoAppuntamento === '104') { //app positivo
          vm.appuntamento = appuntamento;
          $rootScope.$broadcast('createContrattoAppuntamento', vm.appuntamento);
        }
      }
    }

    function undoForm() {
      appuntamentoEsitaModal.hide();
    }

    function checkStatoAppuntamento() {
      var check = true;

      if (vm.user.userGroup < 8) {
        if (
          (vm.appuntamento.idStatoAppuntamento === '109') || //se stato 'RIFISSATO'
          ((vm.appuntamento.idStatoAppuntamento === '104') && (vm.appuntamento.nContratti > 0)) //o se stato 'POSITIVO' e ci sono contratti
        ) {
          check = false;
        }
      }

      return check;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.agenti')
    .controller('AppuntamentoEditAgenteController', AppuntamentoEditAgenteController);

  function AppuntamentoEditAgenteController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var appuntamentoEditAgenteModal = $modal({
      scope: $scope,
      templateUrl: 'appuntamento-edit-agente-modal.tpl.html',
      backdrop: false,
      show: false
    });
    var action = '';

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.appuntamento = {};
    vm.formData = {};
    vm.alerts = {};
    vm.saveForm = saveForm;
    vm.checkDistances = api.appuntamenti.actions.checkDistances;

    $scope.$on('createAppuntamentoClienteAgente', createAppuntamentoClienteAgente);
    $scope.$on('moveAppuntamento', moveAppuntamento);

    ////////////////////////////////////////////////////////////////////////////
    function createAppuntamentoClienteAgente(event, cliente) {
      action = 'create';
      vm.alerts = {}; //reset degli alert

      vm.appuntamento = {
        idAgente: vm.user.idAgente,
        idCliente: cliente.id,
        idPortafoglio: cliente.idPtf,
        cliente: cliente.ragSoc,
        indirizzo: cliente.indirizzo,
        citta: cliente.citta,
        prov: cliente.prov,
        cap: cliente.cap,
        tel: cliente.tel,
        email: cliente.email,
        cell: cliente.cell
      };

      api.appuntamenti.editForm()
        .then(showModal);

      function showModal(formData) {
        vm.formData = formData;

        appuntamentoEditAgenteModal.$promise
          .then(appuntamentoEditAgenteModal.show);
      }
    }

    function moveAppuntamento(event, idAppuntamento) {
      action = 'update';
      vm.alerts = {}; //reset degli alert

      api.appuntamenti.editForm()
        .then(getAppuntamento);

      function getAppuntamento(formData) {
        vm.formData = formData;

        api.appuntamento(idAppuntamento).get()
          .then(showModal);

        function showModal(appuntamento) {
          vm.appuntamento = appuntamento;

          appuntamentoEditAgenteModal.$promise
            .then(appuntamentoEditAgenteModal.show);
        }
      }
    }

    function saveForm() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante

      if (action === 'create') {
        api.appuntamenti.save(vm.appuntamento)
          .then(appuntamentoEditAgenteModal.hide, setAlerts);
      } else if (action === 'update') {
        api.appuntamento(vm.appuntamento.id).update(vm.appuntamento)
          .then(appuntamentoEditAgenteModal.hide, setAlerts);
      }



      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin', [
    'g1.core'
  ])
    .constant('baseRoute', '/admin')
    .config(routeConfig)
  ;

  //////////////////////////////////////////////////////////////////////////////
  function routeConfig($routeProvider, baseRoute) {
    /** routing */
    $routeProvider
      .when(baseRoute, {
        templateUrl: 'app/admin/home/home.html',
        controller: 'AdminHomeController',
        controllerAs: 'admin',
        security: 'ADMIN',
        title: 'Home'
      })
      .when(baseRoute + '/soggetti', {
        templateUrl: 'app/admin/soggetti/soggetti.html',
        controller: 'AdminSoggettiController',
        controllerAs: 'soggetti',
        security: 'ADMIN',
        title: 'Soggetti'
      })
      .when(baseRoute + '/provvigioni/schede', {
        templateUrl: 'app/admin/provvigioni/provvigioni-schede.html',
        controller: 'AdminProvvigioniSchedeController',
        controllerAs: 'pSchede',
        security: 'ADMIN',
        title: 'Provvigioni / Schede'
      })
      .when(baseRoute + '/provvigioni/copia', {
        templateUrl: 'app/admin/provvigioni/provvigioni-copia.html',
        controller: 'AdminProvvigioniCopiaController',
        controllerAs: 'pCopia',
        security: 'ADMIN',
        title: 'Provvigioni / Copia'
      })
      .when(baseRoute + '/tabelle', {
        templateUrl: 'app/admin/tabelle/tabelle.html',
        controller: 'AdminTabelleController',
        controllerAs: 'tabelle',
        security: 'ADMIN',
        title: 'Tabelle'
      })
      .when(baseRoute + '/tabelle/:name', {
        templateUrl: function templateUrlTabella(routeParams) {
          return 'app/admin/tabelle/' + routeParams.name + '.html';
        },
        security: 'ADMIN',
        title: 'Tabelle'
      })
      .when(baseRoute + '/procedure/importa-clienti', {
        templateUrl: 'app/admin/procedure/importa-clienti.html',
        controller: 'AdminImportaClientiController',
        controllerAs: 'impCli',
        security: 'ADMIN',
        title: 'Procedure / Importa Clienti'
      })
      .when(baseRoute + '/procedure/provvigioni-schede-doppie', {
        templateUrl: 'app/admin/procedure/provvigioni-schede-doppie.html',
        controller: 'AdminProvvigioniSchedeDoppieController',
        controllerAs: 'psd',
        security: 'ADMIN',
        title: 'Procedure / Controllo Doppioni Provvigioni'
      })
      .when(baseRoute + '/procedure/incompleti', {
        templateUrl: 'app/admin/procedure/incompleti.html',
        controller: 'AdminIncompletiController',
        controllerAs: 'incompleti',
        security: 'ADMIN',
        title: 'Procedure / Incompleti'
      })
    ;
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminTipiPortafoglioController', AdminTipiPortafoglioController);

  function AdminTipiPortafoglioController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'tipi-portafoglio-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.tipoPortafoglio = {};
    vm.alerts = [];

    vm.createTipoPortafoglio = createTipoPortafoglio;
    vm.updateTipoPortafoglio = updateTipoPortafoglio;
    vm.deleteTipoPortafoglio = api.portafogli.tipi.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('TipoPortafoglio.created', reloadData);
    $scope.$on('TipoPortafoglio.updated', reloadData);
    $scope.$on('TipoPortafoglio.deleted', reloadData);

    //run
    loadDt();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.portafogli.tipi.list)
        .withOption('order', [0, 'asc'])
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'attivo',
          title: 'Attivo',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'nPort',
          title: '<span title="Numero Portafoglio">Num.Port.</span>',
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createTipoPortafoglio()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateTipoPortafoglio(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteTipoPortafoglio(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);
    }

    function createTipoPortafoglio() {
      vm.action = 'create';
      vm.tipoPortafoglio = {};
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateTipoPortafoglio(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.portafogli.tipo(id).get()
        .then(showModal);

      function showModal(tipoPortafoglio) {
        vm.tipoPortafoglio = tipoPortafoglio;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.portafogli.tipi
            .save(vm.tipoPortafoglio)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.portafogli.tipo(vm.tipoPortafoglio.id)
            .update(vm.tipoPortafoglio)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminTabelleController', AdminTabelleController);

  function AdminTabelleController(api) {
    var vm = this;

    vm.tabelle = {};

    api.tabelle.list()
      .then(loadTabelle);

    ////////////////////////////////////////////////////////////////////////////
    function loadTabelle(tabelle) {
      vm.tabelle = tabelle;
    }
  }
})();


(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminStatiTelefonataController', AdminStatiTelefonataController);

  function AdminStatiTelefonataController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'stati-telefonata-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      descrizioneSupplementare: '(nc)'
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.formData = {};
    vm.statoTelefonata = {};
    vm.alerts = [];

    vm.createStatoTelefonata = createStatoTelefonata;
    vm.updateStatoTelefonata = updateStatoTelefonata;
    vm.deleteStatoTelefonata = api.telefonate.stati.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('StatoTelefonata.created', reloadData);
    $scope.$on('StatoTelefonata.updated', reloadData);
    $scope.$on('StatoTelefonata.deleted', reloadData);

    //run
    loadDt();
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.telefonate.stati.list)
        .withOption('order', [0, 'asc'])
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'priorita',
          title: 'Priorita',
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'descrizioneSupplementare',
          title: '<span title="Descrizione Supplementare">Desc. Suppl.</span>',
          'class': ''
        },
        {
          data: 'descrizioneStatoElenco',
          title: 'Stato Elenco',
          'class': ''
        },
        {data: 'descrizioneTipo', title: 'Tipo'},
        {
          data: 'contattoUtile',
          title: '<span title="Contatto Utile">C.U.</span>',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {data: 'gruppo', title: 'Gruppo'},
        {data: 'libero', title: 'Libero'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createStatoTelefonata()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateStatoTelefonata(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteStatoTelefonata(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function loadFormData() {
      api.telefonate.stati.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);

      //ricarica i dati della form
      loadFormData();
    }

    function createStatoTelefonata() {
      vm.action = 'create';
      vm.statoTelefonata = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateStatoTelefonata(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.telefonate.stato(id).get()
        .then(showModal);

      function showModal(statoTelefonata) {
        vm.statoTelefonata = statoTelefonata;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.telefonate.stati
            .save(vm.statoTelefonata)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.telefonate.stato(vm.statoTelefonata.id)
            .update(vm.statoTelefonata)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminStatiElencoController', AdminStatiElencoController);

  function AdminStatiElencoController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'stati-elenco-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      descrizioneSupplementare: '(nc)'
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.formData = {};
    vm.statoElenco = {};
    vm.alerts = [];

    vm.createStatoElenco = createStatoElenco;
    vm.updateStatoElenco = updateStatoElenco;
    vm.deleteStatoElenco = api.elenchi.stati.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('StatoElenco.created', reloadData);
    $scope.$on('StatoElenco.updated', reloadData);
    $scope.$on('StatoElenco.deleted', reloadData);

    //run
    loadDt();
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.elenchi.stati.list)
        .withOption('order', [0, 'asc'])
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'descrizioneSupplementare',
          title: '<span title="Descrizione Supplementare">Desc. Suppl.</span>',
          'class': ''
        },
        {data: 'descrizioneTipo', title: 'Tipo'},
        {data: 'gruppo', title: 'Gruppo'},
        {data: 'libero', title: 'Libero'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createStatoElenco()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateStatoElenco(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteStatoElenco(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function loadFormData() {
      api.elenchi.stati.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);

      //ricarica i dati della form
      loadFormData();
    }

    function createStatoElenco() {
      vm.action = 'create';
      vm.statoElenco = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateStatoElenco(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.elenchi.stato(id).get()
        .then(showModal);

      function showModal(statoElenco) {
        vm.statoElenco = statoElenco;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.elenchi.stati
            .save(vm.statoElenco)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.elenchi.stato(vm.statoElenco.id)
            .update(vm.statoElenco)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminStatiContrattoController', AdminStatiContrattoController);

  function AdminStatiContrattoController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'stati-contratto-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      descrizioneSupplementare: '(nc)'
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.formData = {};
    vm.statoContratto = {};
    vm.alerts = [];

    vm.createStatoContratto = createStatoContratto;
    vm.updateStatoContratto = updateStatoContratto;
    vm.deleteStatoContratto = api.contratti.stati.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('StatoContratto.created', reloadData);
    $scope.$on('StatoContratto.updated', reloadData);
    $scope.$on('StatoContratto.deleted', reloadData);

    //run
    loadDt();
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.contratti.stati.list)
        .withOption('order', [0, 'asc'])
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'priorita',
          title: 'Priorita',
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'descrizioneSupplementare',
          title: '<span title="Usato in report dettaglio backlog">Desc. Suppl.</span>',
          'class': ''
        },
        {data: 'descrizioneTipo', title: 'Tipo'},
        {data: 'gruppo', title: 'Gruppo'},
        {
          data: 'realizzativo',
          title: 'Realizzativo',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'postvendita',
          title: 'Postvendita',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {data: 'libero', title: 'Libero'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createStatoContratto()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateStatoContratto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteStatoContratto(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function loadFormData() {
      api.contratti.stati.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);

      //ricarica i dati della form
      loadFormData();
    }

    function createStatoContratto() {
      vm.action = 'create';
      vm.statoContratto = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateStatoContratto(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.contratti.stato(id).get()
        .then(showModal);

      function showModal(statoContratto) {
        vm.statoContratto = statoContratto;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.contratti.stati
            .save(vm.statoContratto)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.contratti.stato(vm.statoContratto.id)
            .update(vm.statoContratto)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminStatiAppuntamentoController', AdminStatiAppuntamentoController);

  function AdminStatiAppuntamentoController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'stati-appuntamento-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      descrizioneSupplementare: '(nc)'
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.formData = {};
    vm.statoAppuntamento = {};
    vm.alerts = [];

    vm.createStatoAppuntamento = createStatoAppuntamento;
    vm.updateStatoAppuntamento = updateStatoAppuntamento;
    vm.deleteStatoAppuntamento = api.appuntamenti.stati.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('StatoAppuntamento.created', reloadData);
    $scope.$on('StatoAppuntamento.updated', reloadData);
    $scope.$on('StatoAppuntamento.deleted', reloadData);

    //run
    loadDt();
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.appuntamenti.stati.list)
        .withOption('order', [0, 'asc'])
        .withColumnFilter({
          aoColumns: [
            null,
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            {type: 'text'},
            null,
            {type: 'text'},
            null,
            null,
            null,
            null
          ]
        })
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'descrizioneSupplementare',
          title: '<span title="Descrizione Supplementare">Desc. Suppl.</span>',
          'class': ''
        },
        {data: 'descrizioneTipo', title: 'Tipo'},
        {
          data: 'colore1',
          title: '<span title="Colore primario">Colore prim.</span>',
          render: renderColor
        },
        {
          data: 'colore2',
          title: '<span title="Colore secondario">Colore sec.</span>',
          render: renderColor
        },
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createStatoAppuntamento()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderColor(data, type) {
        if (type === 'display') {
          data = '<div style="height: 2rem; width: 4rem; background-color: ' + data + '"></div>';
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateStatoAppuntamento(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteStatoAppuntamento(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function loadFormData() {
      api.appuntamenti.stati.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);

      //ricarica i dati della form
      loadFormData();
    }

    function createStatoAppuntamento() {
      vm.action = 'create';
      vm.statoAppuntamento = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateStatoAppuntamento(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.appuntamenti.stato(id).get()
        .then(showModal);

      function showModal(statoAppuntamento) {
        vm.statoAppuntamento = statoAppuntamento;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.appuntamenti.stati
            .save(vm.statoAppuntamento)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.appuntamenti.stato(vm.statoAppuntamento.id)
            .update(vm.statoAppuntamento)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminSquadreController', AdminSquadreController);

  function AdminSquadreController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'squadra-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.squadra = {};
    vm.alerts = [];

    vm.createSquadra = createSquadra;
    vm.updateSquadra = updateSquadra;
    vm.deleteSquadra = api.squadre.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('Squadra.created', reloadData);
    $scope.$on('Squadra.updated', reloadData);
    $scope.$on('Squadra.deleted', reloadData);

    //run
    loadDt();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.squadre.list)
        .withOption('order', [0, 'asc'])
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createSquadra()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateSquadra(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteSquadra(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);
    }

    function createSquadra() {
      vm.action = 'create';
      vm.squadra = {};
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateSquadra(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.squadra(id).get()
        .then(showModal);

      function showModal(squadra) {
        vm.squadra = squadra;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.squadre
            .save(vm.squadra)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.squadra(vm.squadra.id)
            .update(vm.squadra)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminProdottiController', AdminProdottiController);

  function AdminProdottiController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'prodotti-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var readModal = $modal({
      scope: $scope,
      templateUrl: 'prodotti-read-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {};

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};

    //ricerca
    vm.sp = {
      tbl: '',
      opPrezzo: '>=',
      prezzo: 0,
      durataContratto: 0,
      disabilitato: '',
      invisibileAgenti: '',
      conScadenza: '',
      pagamento: '',
      fornitore: '',
      pista: '',
      sottopista: '',
      gruppo: '',
      dFornitori: '0',
      dPiste: '0',
      dSottopiste: '0',
      dGruppi: '0'
    };
    vm.dt = {};
    vm.filtraGruppi = api.prodotti.filtraGruppi;

    //forms
    vm.action = '';
    vm.prodotto = {};
    vm.alerts = [];

    vm.createProdotto = createProdotto;
    vm.readProdotto = readProdotto;
    vm.updateProdotto = updateProdotto;
    vm.deleteProdotto = api.prodotti.actions.delete;

    vm.resetSF = resetSF;
    vm.searchForm = loadDt;
    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('Prodotto.created', reloadData);
    $scope.$on('Prodotto.updated', reloadData);
    $scope.$on('Prodotto.deleted', reloadData);

    //run
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadFormData() {
      api.prodotti.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function loadDt() {
      if (_.isEmpty(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return api.prodotti.list(vm.sp);
          })
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'Prodotti',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('order', [3, 'asc'])
        );

        vm.dt.columns = [
          {
            data: 'id',
            title: 'Id'
          },
          {
            data: 'disabilitato',
            title: '<span title="Disabilitato">Dis.</span>',
            render: dtFactory.renders.boolean,
            'class': 'min-width text-center'
          },
          {
            data: 'invisibileAgenti',
            title: '<span title="Non visibile agli agenti">N.V.A.</span>',
            render: dtFactory.renders.boolean,
            'class': 'min-width text-center'
          },
          {
            data: 'codice',
            title: 'Codice',
            render: renderCodice
          },
          {
            data: 'descrizione',
            title: 'Descrizione'
          },
          {
            data: 'durataContratto',
            title: 'Durata',
            render: renderDurata
          },
          {
            data: 'descrizioneEstesa',
            title: 'Descrizione Estesa',
            render: dtFactory.renders.longtext
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'gruppo',
            title: 'Gruppo'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'sottopista',
            title: 'Sottopista'
          },
          {
            data: 'prezzo',
            title: 'Prezzo',
            'class': 'min-width text-right',
            render: dtFactory.renders.currency
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dt.instance.reloadData(null, true);
      }

      function renderCodice( data, type, row ) {
        var output =
          '<a ng-click="tabella.readProdotto(' + row.id + ')">' + data + '</a>';
        return output;
      }

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updateProdotto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deleteProdotto(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function logExport(e, dt, node, config) {
        var data = {
          url: api.prodotti.url,
          numRecords: dt.data().length,
          filter: angular.copy(vm.sp)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }
    }

    function reloadData() {
      //ricarica tabella
      if (angular.isDefined(vm.dt.instance)) {
        vm.dt.instance.reloadData(null, true);
      }

      //ricarica i dati della form
      loadFormData();
    }

    function resetSF() {
      //ricarica i dati della form
      loadFormData();

      vm.sp = {
        tbl: '',
        opPrezzo: '>=',
        prezzo: 0,
        durataContratto: 0,
        disabilitato: '',
        invisibileAgenti: '',
        conScadenza: '',
        pagamento: '',
        fornitore: '',
        pista: '',
        sottopista: '',
        gruppo: '',
        dFornitori: '0',
        dPiste: '0',
        dSottopiste: '0',
        dGruppi: '0'
      };

      vm.dt = {};
    }

    function createProdotto() {
      vm.action = 'create';
      vm.prodotto = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateProdotto(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.prodotto(id).get()
        .then(showModal);

      function showModal(prodotto) {
        vm.prodotto = prodotto;
        editModal.$promise
          .then(editModal.show);
      }
    }

    function readProdotto(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.prodotto(id).get()
        .then(showModal);

      function showModal(prodotto) {
        vm.prodotto = prodotto;
        readModal.$promise
          .then(readModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if ( ! vm.prodotto.conScadenza ) {
        // mi assicuro che se il prodotto non ha un valore significativo per il campo conScadenza, abbia 0 come valore per durata contratto
        vm.prodotto.durataContratto = 0;
      }
      switch (vm.action) {
        case 'create':
          api.prodotti
            .save(vm.prodotto)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.prodotto(vm.prodotto.id)
            .update(vm.prodotto)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminPortafogliController', AdminPortafogliController);

  function AdminPortafogliController($scope, AuthenticateJS, $modal, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'portafogli-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    //forms
    vm.action = '';
    vm.formData = {};
    vm.portafoglio = {};
    vm.alerts = [];

    vm.createPortafoglio = createPortafoglio;
    vm.updatePortafoglio = updatePortafoglio;
    vm.deletePortafoglio = api.portafogli.actions.delete;

    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('Portafoglio.created', reloadData);
    $scope.$on('Portafoglio.updated', reloadData);
    $scope.$on('Portafoglio.deleted', reloadData);

    //run
    loadDt();
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.portafogli.list)
        .withOption('order', [0, 'asc'])
        .withColumnFilter({
          aoColumns: [
            null,
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            null,
            {type: 'text'},
            null,
            null
          ]
        })
      );

      vm.dt.columns = [
        {data: 'id', title: 'ID'},
        {
          data: 'evidenziaAgenda',
          title: '<span title="Evidenzia in agenda">Evid. Ag.</span>',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'obsoleto',
          title: 'Obsoleto',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'descrizione',
          title: 'Descrizione',
          'class': ''
        },
        {data: 'tipo', title: 'Tipo'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext,
          'class': ''
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="tabella.createPortafoglio()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="tabella.updatePortafoglio(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="tabella.deletePortafoglio(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }
    }

    function loadFormData() {
      api.portafogli.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function reloadData() {
      //ricarica tabella
      vm.dt.instance.reloadData(null, true);

      //ricarica i dati della form
      loadFormData();
    }

    function createPortafoglio() {
      vm.action = 'create';
      vm.portafoglio = {};
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updatePortafoglio(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.portafoglio(id).get()
        .then(showModal);

      function showModal(portafoglio) {
        vm.portafoglio = portafoglio;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.portafogli
            .save(vm.portafoglio)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.portafoglio(vm.portafoglio.id)
            .update(vm.portafoglio)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminSoggettoEditController', AdminSoggettoEditController)
    .directive('fieldExist', fieldExistDirective)
  ;

  function AdminSoggettoEditController($scope, AuthenticateJS, $modal, $filter, api) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'soggetto-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      codice: 'AG',
      tipo: 'Agente'
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //forms
    vm.action = '';
    vm.formData = {};
    vm.soggetto = {};
    vm.alerts = [];

    vm.setCodice = setCodice;
    vm.saveForm = saveForm;

    //gestione eventi
    $scope.$on('createSoggetto', createSoggetto);
    $scope.$on('updateSoggetto', updateSoggetto);

    //run
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadFormData() {
      api.soggetti.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function createSoggetto() {
      vm.action = 'create';
      vm.soggetto = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateSoggetto(event, idSoggetto) {
      vm.action = 'update';
      vm.alerts = [];

      api.soggetto(idSoggetto).get()
        .then(showModal);

      function showModal(soggetto) {
        vm.soggetto = soggetto;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function setCodice(tipo) {
      if (vm.action === 'create') {
        vm.soggetto.codice = $filter('filter')(vm.formData.tipi, {label: tipo}, true)[0].value;
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit

      switch (vm.action) {
        case 'create':
          api.soggetti
            .save(vm.soggetto)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.soggetto(vm.soggetto.id)
            .update(vm.soggetto)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }

  function fieldExistDirective($q, api) {
    return {
      require: 'ngModel',
      scope: {
        field: '@fieldExist',
        oldValue: '@oldValue'
      },
      link: linkFn
    };

    function linkFn(scope, element, attributes, ctrl) {
      ctrl.$asyncValidators.fieldExist = function(modelValue, viewValue) {
        var params = {};
        params[scope.field] = viewValue;

        if (angular.isDefined(scope.oldValue) && scope.oldValue !== '') {
          params.oldValue = scope.oldValue;
        }

        return api.soggetti.existCheck(params)
          .then(function() {
            return $q.reject();
          }, function() {
            return true;
          });
      };
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminSoggettoController', AdminSoggettoController);

  function AdminSoggettoController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var readModal = $modal({
      scope: $scope,
      templateUrl: 'soggetto-read-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.soggetto = {};

    vm.updateSoggetto = api.soggetti.actions.update;

    //gestione eventi
    $scope.$on('readSoggetto', readSoggetto);
    $scope.$on('Soggetto.updated', refreshSoggetto);

    ////////////////////////////////////////////////////////////////////////////
    function readSoggetto(event, idSoggetto) {
      api.soggetto(idSoggetto).get()
        .then(showModal);

      function showModal(soggetto) {
        vm.soggetto = soggetto;

        readModal.$promise
          .then(readModal.show);
      }
    }

    function refreshSoggetto(event, soggetto) {
      if (soggetto.id === vm.soggetto.id) {
        vm.soggetto = soggetto;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminSoggettiController', AdminSoggettiController);

  function AdminSoggettiController($scope, AuthenticateJS, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.dt = {};

    vm.readSoggetto = api.soggetti.actions.read;
    vm.createSoggetto = api.soggetti.actions.create;
    vm.updateSoggetto = api.soggetti.actions.update;
    vm.deleteSoggetto = api.soggetti.actions.delete;
    vm.changePassword = api.soggetti.actions.changePassword;

    //gestione eventi
    $scope.$on('Soggetto.created', reloadData);
    $scope.$on('Soggetto.updated', reloadData);
    $scope.$on('Soggetto.deleted', reloadData);

    //run
    loadDt();

    ////////////////////////////////////////////////////////////////////////////
    function loadDt() {
      vm.dt.instance = {};

      vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(api.soggetti.list)
        .withOption('order', [
          [3, 'asc'],
          [4, 'asc']
        ])
        .withColumnFilter({
          aoColumns: [
            null,
            null,
            {type: 'text'},
            {type: 'text'},
            {type: 'text'},
            {type: 'text'},
            {type: 'text'},
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            {
              type: 'select',
              bRegex: false,
              values: [
                {value: 1, label: 'Vero'},
                {value: 0, label: 'Falso'}
              ]
            },
            null,
            null
          ]
        })
      );

      vm.dt.columns = [
        {
          data: 'id',
          title: 'ID',
          render: renderSoggetto
        },
        {
          data: 'codice',
          title: 'Codice',
          render: renderSoggetto
        },
        {
          data: 'username',
          title: 'Nome Utente',
          render: renderSoggetto
        },
        {
          data: 'cognome',
          title: 'Cognome',
          render: renderSoggetto
        },
        {
          data: 'nome',
          title: 'Nome',
          render: renderSoggetto
        },
        {data: 'tipo', title: 'Tipo'},
        {data: 'azienda', title: 'Azienda'},
        {
          data: 'segnalatore',
          title: 'Segnalatore',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'disabilitato',
          title: 'Disabilitato',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'nullo',
          title: 'Nullo',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'login',
          title: 'Login',
          render: dtFactory.renders.boolean,
          'class': 'min-width text-center'
        },
        {
          data: 'obbiettivo',
          title: 'Obbiettivo',
          render: dtFactory.renders.currency,
          'class': 'min-width text-right'
        },
        {
          data: 'id',
          title: '<button type="button" class="btn btn-success btn-xs" ng-click="soggetti.createSoggetto()"><i class="fa fa-plus"></i></button>',
          render: renderActions,
          'class': 'min-width text-center',
          orderable: false,
          searchable: false
        }
      ];

      //////////////////////////////////////////////////////////////////////////
      function renderSoggetto(data, type, row) {
        if (type === 'display') {
          data = '<a title="apri soggetto" ng-click="soggetti.readSoggetto(' + row.id + ')">' + data + '</a>';
        }

        return data;
      }

      function renderActions(data, type, row) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="soggetti.updateSoggetto(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var pwd = '<button type="button" class="btn btn-info btn-xs" ng-click="soggetti.changePassword(\'' + row.username + '\')"><i class="fa fa-key"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="soggetti.deleteSoggetto(' + data + ')"><i class="fa fa-minus"></i></button>';

        if (row.login) {
          actions = upd + '&nbsp;' + pwd + '&nbsp;' + del;
        } else {
          actions = upd + '&nbsp;' + del;
        }

        return actions;
      }
    }

    function reloadData() {
      if (!_.isEmpty(vm.dt.instance)) {
        vm.dt.instance.reloadData(null, true);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminProvvigioniSchedeController', AdminProvvigioniSchedeController);

  function AdminProvvigioniSchedeController($window, $rootScope, $scope, $filter, AuthenticateJS, $modal, $alert, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    var editModal = $modal({
      scope: $scope,
      templateUrl: 'provvigioni-edit-modal.tpl.html',
      backdrop: 'static',
      show: false
    });
    var formDefaults = {
      tipoSoggetto: 'Agente',
      idAgente: '327',
      dataInizio: moment().startOf('day').toDate(),
      dataFine: moment().endOf('year').startOf('day').toDate(),
      percentuale: true,
      valore: false,
      scaVal: 0,
      scaPerc: 0
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.searchData = {};
    vm.searchForm = {};
    vm.dt = {};
    vm.searched = false;
    vm.filtraSoggetti = filtraSoggetti;
    vm.search = search;
    vm.spostaDate = spostaDate;
    vm.cancella = cancella;

    //forms
    vm.action = '';
    vm.formData = {};
    vm.provvigione = {};
    vm.alerts = [];

    vm.readProvvigione = api.provvigioni.actions.read;
    vm.createProvvigione = createProvvigione;
    vm.updateProvvigione = updateProvvigione;
    vm.deleteProvvigione = api.provvigioni.actions.delete;

    vm.setOpzioneCalcolo = setOpzioneCalcolo;
    vm.saveForm = saveForm;
    vm.codiceProdottoChange = function () {
      var prodotti = vm.formData.prodotti;
      for ( var i = 0; i < prodotti.length; i++ ) {
        if ( prodotti[i].value == vm.provvigione.codiceProdotto ) {
          vm.provvigione.conScadenza = prodotti[i].conScadenza;
          vm.provvigione.ricorrente = prodotti[i].conScadenza; // se il prodotto ha durata, potrebbe avere una provvigione ricorrente (di default presumo che ce l'abbia)
          break; // trovato, esco dal ciclo
        }
      }
    }
    //gestione eventi
    $scope.$on('Provvigione.created', reloadData);
    $scope.$on('Provvigione.updated', reloadData);
    $scope.$on('Provvigione.deleted', reloadData);
    $scope.$on('Provvigioni.deleted', onDeleteProvvigioni);

    //run
    loadSearchData();

    ////////////////////////////////////////////////////////////////////////////
    function loadSearchData() {
      api.provvigioni.searchForm().then(function(searchData) {
        vm.searchData = searchData;

        vm.searchData.dFornitori = '0';
        vm.searchData.dPiste = '0';

        vm.searchForm = {
          tipoSoggetto: '0',
          'soggetti[]': [],
          opInizio: '<=',
          inizio: moment().startOf('day').toDate(),
          opFine: '>=',
          fine: moment().startOf('day').toDate(),
          fornitore: '0',
          pista: '0',
          prodotto: '',
          tipoData: 'dataInizio'
        };
      });

      // loadDt();
      loadFormData();
    }

    function filtraSoggetti(soggetti) {
      if (angular.isDefined(soggetti) && angular.isDefined(vm.searchForm.tipoSoggetto)) {
        if (vm.searchForm.tipoSoggetto !== '0') {
          soggetti = $filter('filter')(soggetti, {tipoSoggetto: vm.searchForm.tipoSoggetto}, true);
        } else {
          soggetti = $filter('orderBy')(_.uniq(soggetti, false, 'value'), 'label');
        }
      }

      return soggetti;
    }

    function search() {
      loadDt();
      loadFormData();

      vm.searched = true;
    }

    function spostaDate() {
      var numRecords = vm.dt.instance.DataTable.page.info().recordsDisplay;
      var risposta = $window.confirm('Stai per modificare ' + vm.searchForm.tipoData + ' di ' + numRecords + ' schede' );

      if (risposta) {
        //add search parameter
        var form = angular.copy(vm.searchForm);
        var getParams = vm.dt.instance.DataTable.ajax.params();
        form['search[value]'] = getParams.search.value;

        api.provvigioni.update(form)
          .then(onUpdateProvvigioni);
      }

      //////////////////////////////////////////////////////////////////////////
      function onUpdateProvvigioni(response) {
        $alert({
          placement: 'top',
          title: response.rowCount + ' schede modificate',
          type: 'success',
          duration: 3
        });
      }
    }

    function cancella() {
      var numRecords = vm.dt.instance.DataTable.page.info().recordsDisplay;
      var messaggi = [
        {
          text: 'ATTENZIONE! Verranno eliminate ' + numRecords + ' schede provvigionali',
          code: 'massive_delete'
        }
      ];

      //add search parameter
      var form = angular.copy(vm.searchForm);
      var getParams = vm.dt.instance.DataTable.ajax.params();
      form['search[value]'] = getParams.search.value;

      $rootScope.$broadcast('deleteProvvigioni', form, messaggi);
    }

    function onDeleteProvvigioni(event, response) {
      $alert({
        placement: 'top',
        title: response.rowCount + ' schede cancellate',
        type: 'success',
        duration: 3
      });

      reloadData();
    }

    function loadFormData() {
      api.provvigioni.editForm().then(function(formData) {
        vm.formData = formData;
      });
    }

    function loadDt() {
      var searchForm = angular.copy(vm.searchForm);
      if (_.isDate(searchForm.inizio)) {
        searchForm.inizio = searchForm.inizio.toISOString();
      }
      if (_.isDate(searchForm.fine)) {
        searchForm.fine = searchForm.fine.toISOString();
      }

      var ajaxRequest = {
        url: apiBaseUrl + '/provvigioni?dt',
        data: searchForm,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        }
      };

      if (_.isEmpty(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder.newOptions()
          .withOption('ajax', ajaxRequest)
          .withDataProp('data')
          .withOption('processing', true)
          .withOption('serverSide', true)
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              text: 'Esporta',
              className: 'btn-info btn-sm',
              action: exportCsv
            }
          ])
          .withOption('order', [
            [6, 'asc'],
            [0, 'desc']
          ])
          .withOption('pageLength', 25)
        );

        vm.dt.columns = [
          {
            data: 'id',
            title: 'ID',
            render: renderId
          },
          {
            data: 'dataInizio',
            title: 'Inizio',
            render: dtFactory.renders.date
          },
          {
            data: 'dataFine',
            title: 'Fine',
            render: dtFactory.renders.date
          },
          {
            data: 'fornitore',
            title: 'Fornitore'
          },
          {
            data: 'pista',
            title: 'Pista'
          },
          {
            data: 'codiceProdotto',
            title: 'Prodotto'
          },
          {
            data: 'prodotto',
            title: 'Descrizione'
          },
          {
            data: 'durataContratto',
            title: 'Durata',
            render: renderDurata
          },
          {
            data: 'soggetto',
            title: 'Soggetto'
          },
          {
            data: 'tipoSoggetto',
            title: 'Tipo soggetto'
          },
          {
            title: '<span title="Opzione di calcolo">Calc.</span>',
            render: renderOpzioneCalcolo,
            'class': 'min-width text-center'
          },
          {
            data: 'scaPerc',
            title: '<span data-title="Percentuale" bs-tooltip>Perc.</span>',
            render: renderPercentuale,
            'class': 'min-width text-right'
          },
          {
            data: 'scaVal',
            title: '<span data-title="Valore" bs-tooltip>Val.</span>',
            render: renderValore,
            'class': 'min-width text-right'
          },
          {
            data: 'scaPerc2',
            title: '<span data-title="Percentuale applicata dal secondo anno in poi" bs-tooltip>Perc. (2)</span>',
            render: renderPercentuale,
            'class': 'min-width text-right'
          },
          {
            data: 'scaVal2',
            title: '<span data-title="Valore applicato dl secondo anno in poi" bs-tooltip>Val. (2)</span>',
            render: renderValore,
            'class': 'min-width text-right'
          },
          {
            data: 'id',
            render: renderActions,
            'class': 'min-width text-center',
            orderable: false,
            searchable: false
          }
        ];
      } else {
        vm.dt.instance.changeData(ajaxRequest);
      }

      //////////////////////////////////////////////////////////////////////////
      function renderId(data, type) {
        if (type === 'display') {
          data = '<a title="apri scheda provvigione" ng-click="pSchede.readProvvigione(' + data + ')">' + data + '</a>';
        }

        return data;
      }

      function renderOpzioneCalcolo(data, type, row) {
        data = '';

        data += row.percentuale ? '<span title="percentuale">&nbsp;&percnt;</span>' : '';
        data += row.valore ? '<span title="valore">&nbsp;&euro;</span>' : '';

        return data;
      }

      function renderDurata( data ) {
        if ( data != 0 ) {
          return data + ' mesi';
        }
      }

      function renderPercentuale(data, type) {
        if (type === 'display') {
          if (data == 0) {
            data = '';
          } else {
            data = $filter('number')(data * 100, 3) + ' %';
          }
        }

        return data;
      }

      function renderValore(data, type) {
        if (type === 'display') {
          if (data == 0) {
            data = '';
          } else {
            data = $filter('currency')(data);
          }
        }

        return data;
      }

      function renderActions(data) {
        var actions = '';

        var upd = '<button type="button" class="btn btn-warning btn-xs" ng-click="pSchede.updateProvvigione(' + data + ')"><i class="fa fa-pencil"></i></button>';
        var del = '<button type="button" class="btn btn-danger btn-xs" ng-click="pSchede.deleteProvvigione(' + data + ')"><i class="fa fa-minus"></i></button>';

        actions = upd + '&nbsp;' + del;

        return actions;
      }

      function exportCsv(e, dt) {
        var getParams = dt.ajax.params();
        delete getParams.start;
        delete getParams.length;
        getParams.csv = true;

        var numRecords = dt.page.info().recordsDisplay;

        return dtFactory.exportFile(apiBaseUrl + '/provvigioni?dt', getParams, numRecords);
      }
    }

    function reloadData() {
      if (!_.isEmpty(vm.dt.instance)) {
        //ricarica tabella
        vm.dt.instance.reloadData(null, true);
      }

      //ricarica i dati della form
      loadFormData();
    }

    //forms
    function createProvvigione() {
      vm.action = 'create';
      vm.provvigione = angular.copy(formDefaults);
      vm.alerts = [];

      editModal.$promise
        .then(editModal.show);
    }

    function updateProvvigione(id) {
      vm.action = 'update';
      vm.alerts = [];

      api.provvigione(id).get()
        .then(showModal);

      function showModal(provvigione) {
        vm.provvigione = provvigione;
        vm.tipoSoggetto = $filter('filter')(vm.formData.soggetti, {value: vm.provvigione.idAgente}, true)[0].tipoSoggetto;

        editModal.$promise
          .then(editModal.show);
      }
    }

    function setOpzioneCalcolo(modo) {
      if (modo === 'percentuale') {
        vm.provvigione.valore = false;
      } else if (modo === 'valore') {
        vm.provvigione.percentuale = false;
      } else {
        vm.provvigione.percentuale = false;
        vm.provvigione.valore = false;
      }
    }

    function saveForm() {
      vm.alerts = []; //reset immediato degli alerts ad ogni submit
      if ( ! vm.provvigione.ricorrente ) {
        // mi assicuro che se la scheda non ha un valore significativo per il campo ricorrente, abbia 0 come valore per la provvigione del secondo anno
        vm.provvigione.scaPerc2 = 0;
        vm.provvigione.scaVal2 = 0;
      }
      switch (vm.action) {
        case 'create':
          api.provvigioni
            .save(vm.provvigione)
            .then(editModal.hide, setAlerts);
          break;

        case 'update':
          api.provvigione(vm.provvigione.id)
            .update(vm.provvigione)
            .then(editModal.hide, setAlerts);
          break;
      }

      //////////////////////////////////////////////////////////////////////////
      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .controller('AdminProvvigioniSchedaController', AdminProvvigioniSchedaController);

  function AdminProvvigioniSchedaController($scope, AuthenticateJS, $modal, api) {
    var vm = this;

    var pSchedaModal = $modal({
      scope: $scope,
      templateUrl: 'provvigioni-read-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.provvigione = {};

    $scope.$on('readProvvigione', readProvvigione);

    ////////////////////////////////////////////////////////////////////////////
    function readProvvigione(event, id) {
      api.provvigione(id).get()
        .then(showModal);

      function showModal(provvigione) {
        vm.provvigione = provvigione;

        pSchedaModal.$promise
          .then(pSchedaModal.show);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminProvvigioniCopiaController', AdminProvvigioniCopiaController);

  function AdminProvvigioniCopiaController($scope, $filter, $q, AuthenticateJS, DTOptionsBuilder, dtFactory, api, apiBaseUrl) {
    var vm = this;

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.formData = {};
    vm.sf = {};
    vm.enableCopia = false;
    vm.messages = [];
    vm.dtSchede = {};
    vm.dtRisultati = {};

    vm.filtraSoggetti = filtraSoggetti;
    vm.filtraProdotti = filtraProdotti;
    vm.resetForm = resetForm;
    vm.search = search;
    vm.copia = copia;

    vm.readProvvigione = api.provvigioni.actions.read;

    $scope.$watchCollection('pCopia.sf', disableCopia);

    //run
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function loadFormData() {
      api.provvigioni.searchForm({type: 'copia'}).then(function(formData) {
        formData.tipiSoggetto.shift(); //rimuovi TUTTI da tipi soggetto

        vm.formData = formData;

        vm.sf = {
          tipoSoggetto: 'Agente',
          'toSoggetti[]': [],
          fornitore: '',
          pista: '',
          'prodotti[]': [],
          opInizio: '>=',
          opFine: '>='
        }
      });
    }

    function filtraSoggetti(soggetti) {
      return $filter('filter')(soggetti, {tipoSoggetto: vm.sf.tipoSoggetto, value: '!' + vm.sf.soggetto}, true);
    }

    function filtraProdotti(prodotti) {
      return $filter('filter')(prodotti, {fornitore: vm.sf.fornitore, pista: vm.sf.pista}, true);
    }

    function disableCopia(newSf, oldSf) {
      if (newSf !== oldSf) {
        vm.enableCopia = false;
      }
    }

    function resetForm() {
      vm.enableCopia = false;

      vm.sf = {
        tipoSoggetto: 'Agente',
        'toSoggetti[]': [],
        fornitore: '',
        pista: '',
        'prodotti[]': [],
        opInizio: '<=',
        opFine: '>='
      };

      vm.messages = [];
      vm.dtSchede = {};
      vm.dtRisultati = {};
    }

    function search() {
      vm.dtRisultati = {};
      vm.enableCopia = true;

      dtSchede();

      //////////////////////////////////////////////////////////////////////////
      function dtSchede() {
        var sf = angular.copy(vm.sf);
        if (_.isDate(sf.inizio)) {
          sf.inizio = sf.inizio.toISOString();
        }
        if (_.isDate(sf.fine)) {
          sf.fine = sf.fine.toISOString();
        }

        var ajaxRequest = {
          url: apiBaseUrl + '/provvigioni?dt',
          data: sf,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          }
        };

        if (_.isEmpty(vm.dtSchede.instance)) {
          vm.dtSchede.instance = {};

          vm.dtSchede.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder.newOptions()
            .withOption('ajax', ajaxRequest)
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('order', [0, 'desc'])
            .withOption('pageLength', 25)
            .withOption('searching', false)
            .withOption('drawCallback', drawCallback)
          );

          vm.dtSchede.columns = [
            {
              data: 'id',
              title: 'ID',
              render: renderId
            },
            {
              data: 'dataInizio',
              title: 'Inizio',
              render: dtFactory.renders.date
            },
            {
              data: 'dataFine',
              title: 'Fine',
              render: dtFactory.renders.date
            },
            {data: 'fornitore', title: 'Fornitore'},
            {data: 'pista', title: 'Pista'},
            {data: 'codiceProdotto', title: 'Prodotto'},
            {data: 'soggetto', title: 'Soggetto'},
            {data: 'tipoSoggetto', title: 'Tipo soggetto'},
            {
              title: '<span title="Opzione di calcolo">Calc.</span>',
              render: renderOpzioneCalcolo,
              'class': 'min-width text-center'
            },
            {
              data: 'scaPerc',
              title: '<span data-title="Percentuale" bs-tooltip>Perc.</span>',
              render: renderPercentuale,
              'class': 'min-width text-right'
            },
            {
              data: 'scaVal',
              title: '<span data-title="Valore" bs-tooltip>Val.</span>',
              render: renderValore,
              'class': 'min-width text-right'
            },
            {
              data: 'scaPerc2',
              title: '<span data-title="Percentuale applicata dal secondo anno in poi" bs-tooltip>Perc. (2)</span>',
              render: renderPercentuale,
              'class': 'min-width text-right'
            },
            {
              data: 'scaVal2',
              title: '<span data-title="Valore applicato dl secondo anno in poi" bs-tooltip>Val. (2)</span>',
              render: renderValore,
              'class': 'min-width text-right'
            }
          ];
        } else {
          vm.dtSchede.instance.changeData(ajaxRequest);
        }

        //////////////////////////////////////////////////////////////////////////
        function drawCallback(settings) {
          $scope.$apply(function() {
            var soggetto = $filter('filter')(vm.formData.soggetti, {value: vm.sf.soggetto}, true)[0].label;

            var soggetti = '';
            angular.forEach(vm.sf['toSoggetti[]'], function(value) {
              soggetti += $filter('filter')(vm.formData.soggetti, {value: value}, true)[0].label + ',';
            });
            soggetti = _.trimRight(soggetti, ',');

            vm.messages = [
              {text: 'Copia ' + settings._iRecordsDisplay + ' schede da ' + soggetto + ' a ' + soggetti}
            ];
          });
        }
      }
    }

    function copia() {
      //reset dei dati
      vm.messages = [];
      vm.dtSchede = {};

      dtRisultati();

      //////////////////////////////////////////////////////////////////////////
      function dtRisultati() {
        if (_.isEmpty(vm.dtRisultati.instance)) {
          vm.dtRisultati.instance = {};

          vm.dtRisultati.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
            .fromFnPromise(function() {
              var defer = $q.defer();

              api.provvigioni.copia(vm.sf).then(function(provvigioni) {
                vm.messages = provvigioni.messages;
                vm.enableCopia = false;

                defer.resolve(provvigioni.data);
              });

              return defer.promise;
            })
            .withOption('order', [6, 'asc'])
            .withOption('pageLength', 25)
          );

          vm.dtRisultati.columns = [
            {
              data: 'idProvvigioneFrom',
              title: 'ID Origine',
              render: renderId
            },
            {
              data: 'dataInizio',
              title: 'Inizio',
              render: dtFactory.renders.date
            },
            {
              data: 'dataFine',
              title: 'Fine',
              render: dtFactory.renders.date
            },
            {
              data: 'fornitore',
              title: 'Fornitore'
            },
            {
              data: 'pista',
              title: 'Pista'
            },
            {
              data: 'codiceProdotto',
              title: 'Prodotto'
            },
            {
              data: 'soggetto',
              title: 'Destinatario'
            },
            {
              title: '<span title="Opzione di calcolo">Calc.</span>',
              render: renderOpzioneCalcolo,
              'class': 'min-width text-center'
            },
            {
              data: 'scaPerc',
              title: '<span title="Percentuale">Perc.</span>',
              render: renderPercentuale,
              'class': 'min-width text-right'
            },
            {
              data: 'scaVal',
              title: '<span title="Valore">Val.</span>',
              render: renderValore,
              'class': 'min-width text-right'
            },
            {
              data: 'scaPerc2',
              title: '<span data-title="Percentuale applicata dal secondo anno in poi" bs-tooltip>Perc. (2)</span>',
              render: renderPercentuale,
              'class': 'min-width text-right'
            },
            {
              data: 'scaVal2',
              title: '<span data-title="Valore applicato dl secondo anno in poi">Val. (2)</span>',
              render: renderValore,
              'class': 'min-width text-right'
            },
            {
              data: 'idProvvigioneTo',
              title: 'ID Conflitto',
              render: renderId,
              'class': 'min-width text-right'
            }
          ];
        } else {
          vm.dtRisultati.instance.reloadData();
        }
      }
    }

    //funzioni comuni alle due tabelle
    function renderId(data, type) {
      if (type === 'display') {
        data = '<a title="apri scheda provvigione" ng-click="pCopia.readProvvigione(' + data + ')">' + data + '</a>';
      }

      return data;
    }

    function renderOpzioneCalcolo(data, type, row) {
      data = '';

      data += row.percentuale ? '<span title="percentuale">&nbsp;&percnt;</span>' : '';
      data += row.valore ? '<span title="valore">&nbsp;&euro;</span>' : '';

      return data;
    }

    function renderPercentuale(data, type) {
      if (type === 'display') {
        if (data == 0) {
          data = '';
        } else {
          data = $filter('number')(data * 100, 4) + ' %';
        }
      }

      return data;
    }

    function renderValore(data, type) {
      if (type === 'display') {
        if (data == 0) {
          data = '';
        } else {
          data = $filter('currency')(data);
        }
      }

      return data;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminProvvigioniSchedeDoppieController', AdminProvvigioniSchedeDoppieController);

  function AdminProvvigioniSchedeDoppieController($scope, AuthenticateJS, DTOptionsBuilder, dtFactory, api) {
    var vm = this;

    var formDefaults = {
      inizioMese: moment().startOf('year').format('M'),
      inizioAnno: moment().format('YYYY'),
      fineMese: moment().endOf('year').format('M'),
      fineAnno: moment().format('YYYY')
    };

    //user
    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    //datatable
    vm.searchForm = angular.copy(formDefaults);
    vm.formData = {};
    vm.dt = {};
    vm.searched = false;
    vm.search = loadDt;
    vm.reset = resetForm;

    //load formData
    vm.formData.mesi = [
      {label: 'Gennaio', value: '1'},
      {label: 'Febbraio', value: '2'},
      {label: 'Marzo', value: '3'},
      {label: 'Aprile', value: '4'},
      {label: 'Maggio', value: '5'},
      {label: 'Giugno', value: '6'},
      {label: 'Luglio', value: '7'},
      {label: 'Agosto', value: '8'},
      {label: 'Settembre', value: '9'},
      {label: 'Ottobre', value: '10'},
      {label: 'Novembre', value: '11'},
      {label: 'Dicembre', value: '12'}
    ];

    var currentYear = parseInt(moment().format('YYYY'));
    vm.formData.anni = [
      {label: (currentYear - 1).toString(), value: (currentYear - 1).toString()},
      {label: currentYear.toString(), value: currentYear.toString()},
      {label: (currentYear + 1).toString(), value: (currentYear + 1).toString()}
    ];
    ////////////////////////////////////////////////////////////////////////////
    function resetForm() {
      vm.searchForm = angular.copy(formDefaults);
      vm.searched = false;
    }

    function loadDt() {
      if (_.isEmpty(vm.dt.instance)) {
        vm.dt.instance = {};

        vm.dt.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
          .fromFnPromise(function() {
            return api.provvigioni.doppie(vm.searchForm);
          })
          .withOption('dom', '<"row"<"col-xs-6"Bl><"col-xs-6"f>r>t<"row"<"col-xs-6"i><"col-xs-6"p>>')
          .withButtons([
            {
              extend: 'excelHtml5',
              action: logExport,
              text: 'Esporta',
              className: 'btn-info btn-sm',
              filename: 'ProvvigioniDoppie',
              exportOptions: {
                orthogonal: 'filter'
              }
            }
          ])
          .withOption('order', [
            [0, 'asc']
          ])
          .withOption('pageLength', 25)
        );

        vm.dt.columns = [
          {data: 'soggetto', title: 'Soggetto'},
          {data: 'fornitore', title: 'Fornitore'},
          {data: 'pista', title: 'Pista'},
          {data: 'prodotto', title: 'Prodotto'},
          {data: 'numSchede', title: 'Num. Schede'}
        ];
      } else {
        vm.dt.instance.reloadData();
      }

      vm.searched = true;
      //////////////////////////////////////////////////////////////////////////
      function logExport(e, dt, node, config) {
        var data = {
          url: api.provvigioni.url + '/doppie',
          numRecords: dt.data().length,
          filter: angular.copy(vm.searchForm)
        };

        dtFactory.logExportHtml5(data, this, e, dt, node, config);  // eslint-disable-line angular/controller-as-vm
      }

    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminIncompletiController', AdminIncompletiController);

  function AdminIncompletiController($filter, api) {
    var vm = this;

    vm.formData = {};
    vm.si = {
      teamLeader: '0'
    };
    vm.showResults = false;
    vm.incompleti = [];
    vm.message = '';
    vm.selectedAll = false;

    vm.search = search;
    vm.sendEmails = sendEmails;
    vm.checkAll = checkAll;
    vm.setSelectedAll = setSelectedAll;

    // carica i dati della form
    api.incompleti.searchForm()
      .then(function(formData) {
        vm.formData = formData;
      })
    ;

    ////////////////////////////////////////////////////////////////////////////
    function search() {
      api.incompleti.get(vm.si)
        .then(showTable);

      function showTable(incompleti) {
        vm.message = incompleti.message; //imposta messaggio
        vm.selectedAll = false; //resetta checkall

        //aggiungi status e checkbox e assegna array incompleti
        angular.forEach(incompleti.agenti, function(value, key) {
          incompleti.agenti[key].checked = false;
          incompleti.agenti[key].status = 'In attesa di invio...';
        });
        vm.incompleti = incompleti.agenti;

        //visualizza tabella
        vm.showResults = true;
      }
    }

    function sendEmails() {
      angular.forEach(vm.incompleti, function(value, key) {
        //reset status
        vm.incompleti[key].status = 'In attesa di invio...';

        if (vm.incompleti[key].checked !== false) {
          //aggiungi messaggio
          vm.incompleti[key].message = vm.message;

          //invia mail
          api.incompleti.save(vm.incompleti[key])
            .then(mailSent, mailError);
        }
      });

      //////////////////////////////////////////////////////////////////////////
      function mailSent(response) {
        var element = _.find(vm.incompleti, 'idAgente', response.idAgente); //cerca per id agente
        element.status = '<span class="text-success">Mail inviata</span>'; //imposta stato
        element.checked = false; //togli il check
      }

      function mailError(error) {
        var element = _.find(vm.incompleti, 'idAgente', error.data.idAgente); //cerca per id agente

        //crea la stringa dei warnings
        var warnings = '';
        angular.forEach(error.data.warnings, function(value) {
          warnings += value.text + '<br>';
        });
        warnings = _.trimRight(warnings, '<br>');

        element.status = '<span class="text-danger">' + warnings + '</span>'; //imposta stato
      }
    }

    function checkAll() {
      angular.forEach(vm.incompleti, function(value, key) {
        vm.incompleti[key].checked = vm.selectedAll;
      });
    }

    function setSelectedAll() {
      var countChecks = 0;
      var totalChecks = vm.incompleti.length;

      angular.forEach(vm.incompleti, function(value, key) {
        if (vm.incompleti[key].checked) {
          countChecks++;
        }
      });

      return countChecks >= totalChecks;
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminImportaClientiController', AdminImportaClientiController);

  function AdminImportaClientiController($scope, AuthenticateJS, $filter, $modal, dtFactory, DTOptionsBuilder, api) {
    var vm = this;

    var ptf4CreateModal = $modal({
      scope: $scope,
      templateUrl: 'ptf4-create-modal.tpl.html',
      backdrop: 'static',
      show: false
    });

    vm.auth = AuthenticateJS;
    vm.user = vm.auth.getUser();

    vm.ic = {};
    vm.formData = {};
    vm.importResults = {};
    vm.alerts = {};
    vm.dtInvalidi = {};
    vm.dtDoppi = {};
    vm.dtLinea = {
      selected: {},
      selectAll: false
    };
    vm.clientiInseribili = 0;
    vm.show = {
      invalidi: false,
      doppi: false
    };
    vm.importa = importa;
    vm.dropImportTable = dropImportTable;
    vm.save = save;

    //gestione del cambio selezione sui checkbox
    $scope.$watchCollection('impCli.dtLinea.selected', onChangeSelected);

    //gestione dell'uscita dall'attività
    $scope.$on('document.refresh', onExit);
    $scope.$on('$locationChangeStart', onExit);

    //insert ptf4 modal
    vm.cf = {
      alerts: {}
    };
    vm.portafoglio = {};
    vm.showPtf4 = showPtf4;
    vm.savePtf4 = savePtf4;

    //carica i dati della form
    loadFormData();

    ////////////////////////////////////////////////////////////////////////////
    function dropImportTable() {
      if (!_.isEmpty(vm.importResults.nome_tabella)) {
        api.clienti.import_delete({
          tablename: vm.importResults.nome_tabella
        }).then(annullaImport);
      }
    }

    function onExit(event) {
      switch (event.name) {
        case '$locationChangeStart':
          vm.dropImportTable();
          break;

        case 'document.refresh':
          vm.dropImportTable();
          break;
      }
    }

    function onChangeSelected(newSelected) {
      var countSelected = 0;

      angular.forEach(newSelected, function(value) {
        if (value === true) {
          countSelected++;
        }
      });

      vm.clientiInseribili = parseInt(vm.importResults.clienti_inseribili) + countSelected;
    }

    function loadFormData() {
      api.clienti.importForm()
        .then(function(formData) {
          vm.formData = formData;
        })
      ;
    }

    function annullaImport() {
      vm.ic = {};
      vm.importResults = {};
      vm.alerts = {};
      vm.dtInvalidi = {};
      vm.dtDoppi = {};
      vm.dtLinea = {
        selected: {},
        selectAll: false
      };
    }

    function importa() {
      vm.alerts = {}; //reset degli alert appena si clicca il pulsante
      vm.importResults = {}; //reset dei risultati appena si clicca il pulsante

      var file = vm.ic.fileImport;
      file.upload = api.clienti.import_file({
        idPtf4: vm.ic.idPtf4,
        fileImport: vm.ic.fileImport
      });
      file.upload.then(uploadSuccess, uploadError, uploadProgress);

      //////////////////////////////////////////////////////////////////////////
      function uploadSuccess(xhr) {
        vm.importResults = xhr.data;

        vm.clientiInseribili = parseInt(vm.importResults.clienti_inseribili);

        if (vm.importResults.clienti_invalidi.length > 0) {
          createDt(vm.dtInvalidi, vm.importResults.clienti_invalidi);
        }
        if (vm.importResults.clienti_doppi.length > 0) {
          createDt(vm.dtDoppi, vm.importResults.clienti_doppi);
        }
        if (vm.importResults.clienti_linea.length > 0) {
          createDtLinea(vm.dtLinea, vm.importResults.clienti_linea);
        }
      }

      function uploadError(xhr) {
        vm.alerts = {
          status: xhr.status,
          messages: xhr.data.warnings
        };
      }

      function uploadProgress(event) {
        file.progress = Math.min(100, parseInt(100.0 * event.loaded / event.total));
      }
    }

    function createDt(dtObj, records) {
      dtObj.instance = {};

      dtObj.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.toPromise(records);
        })
        .withOption('dom', "tr<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withOption('order', [1, 'asc'])
      );

      dtObj.columns = [
        {data: 'codfisc', title: 'CF'},
        {data: 'ragsoc', title: 'Rag.Soc.'},
        {data: 'indirizzo', title: 'Indirizzo'},
        {data: 'citta', title: 'Città'},
        {data: 'prov', title: 'Prov.'},
        {data: 'cap', title: 'CAP'},
        {data: 'tel', title: 'Telefono'},
        {data: 'idportafoglio', title: 'Cluster'},
        {data: 'idportafoglio2', title: 'Cross'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext
        }
      ];
    }

    function createDtLinea(dtObj, records) {
      dtObj.toggleAll = toggleAll;
      dtObj.toggleOne = toggleOne;

      dtObj.instance = {};

      dtObj.options = dtFactory.addDefaultOptions($scope, DTOptionsBuilder
        .fromFnPromise(function() {
          return api.toPromise(records);
        })
        .withOption('order', [1, 'asc'])
      );

      dtObj.columns = [
        {
          title: '<input type="checkbox" ng-model="impCli.dtLinea.selectAll" ng-click="impCli.dtLinea.toggleAll(impCli.dtLinea.selectAll, impCli.dtLinea.selected)">',
          render: renderCheckboxes,
          searchable: false,
          sortable: false
        },
        {data: 'codfisc', title: 'CF'},
        {data: 'ragsoc', title: 'Rag.Soc.'},
        {data: 'indirizzo', title: 'Indirizzo'},
        {data: 'citta', title: 'Città'},
        {data: 'prov', title: 'Prov.'},
        {data: 'cap', title: 'CAP'},
        {data: 'tel', title: 'Telefono'},
        {data: 'idportafoglio', title: 'Cluster'},
        {data: 'idportafoglio2', title: 'Cross'},
        {
          data: 'note',
          title: 'Note',
          render: dtFactory.renders.longtext
        }
      ];

      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      function renderCheckboxes(data, type, row) {
        dtObj.selected[row.IDimport] = false;

        return '<input type="checkbox" ng-model="impCli.dtLinea.selected[' + row.IDimport + ']" ng-click="impCli.dtLinea.toggleOne(impCli.dtLinea.selected)">';
      }

      function toggleAll (selectAll, selectedItems) {
        for (var id in selectedItems) {
          if (selectedItems.hasOwnProperty(id)) {
            selectedItems[id] = selectAll;
          }
        }
      }

      function toggleOne (selectedItems) {
        for (var id in selectedItems) {
          if (selectedItems.hasOwnProperty(id)) {
            if(!selectedItems[id]) {
              dtObj.selectAll = false;
              return;
            }
          }
        }

        dtObj.selectAll = true;
      }
    }

    function save() {
      var postData = {
        fromTable: vm.importResults.nome_tabella,
        idPtf4: vm.ic.idPtf4,
        selected: vm.dtLinea.selected
      };

      annullaImport(); //reset dei dati dopo aver salvato quelli necessari all'import definitivo

      api.clienti.import_save(postData)
        .then(onSuccess, setAlerts);

      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      function onSuccess(response) {
        vm.alerts = {
          status: 200,
          messages: [
            {text: 'Sono stati inseriti ' + response.clienti_inseriti + ' clienti'}
          ]
        }
      }

      function setAlerts(response) {
        vm.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }

    //insert ptf4 modal
    function showPtf4() {
      vm.portafoglio = {
        idTipoPortafoglio: 4
      };
      vm.cf = {
        alerts: {}
      };

      ptf4CreateModal.$promise
        .then(ptf4CreateModal.show);
    }

    function savePtf4() {
      vm.cf.alerts = {};  //reset degli alert appena si clicca il pulsante

      api.portafogli
        .save(vm.portafoglio)
        .then(reloadSelectPtf, setAlerts);

      //////////////////////////////////////////////////////////////////////////
      function reloadSelectPtf(portafoglio) {
        vm.ic.idPtf4 = String(portafoglio.id);

        loadFormData();

        ptf4CreateModal.hide();
      }

      function setAlerts(response) {
        vm.cf.alerts = {
          status: response.status,
          messages: response.data.warnings
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.admin')
    .controller('AdminHomeController', AdminHomeController);

  function AdminHomeController() {
    var vm = this;

    vm.xxx = 'test';
  }
})();


(function() {
  'use strict';

  angular.module('g1.core')
    .factory('myHttpInterceptor', myHttpInterceptor);

  function myHttpInterceptor($q, $injector, $location, $log) {
    var factory = {
      responseError: responseError
    };
    return factory;

    ////////////////////////////////////////////////////////////////////////////
    function responseError(rejection) {
      //FIXME: using injector workaround for circular dependency
      var $modal = $injector.get('$modal');
      var $alert = $injector.get('$alert');
      var AuthenticateJS = $injector.get('AuthenticateJS');

      switch (rejection.status) {
        case 401:
          AuthenticateJS.logout()
            .then(function () {
              $location.path('/login');
            })
          ;
          break;

        case 404:
          offlineAlert('Richiesta ' + rejection.config.method + ' a "' + rejection.config.url + '" non valida.', 5);
          $log.warn('SERVER OFFLINE');
          break;

        case 500:
          if (typeof(rejection.data.error) !== 'undefined') {
            $log.error(rejection.data.error);

            var errorModal = {
              title: 'Errore ' + rejection.data.error.code,
              content: rejection.data.error.text,
              show: true
            };

            $modal(errorModal);
          }
          break;

        case 503:
          offlineAlert('Il server risulta offline.');
          $log.warn('DB SERVER OFFLINE');
          break;
      }

      return $q.reject(rejection);

      //////////////////////////////////////////////////////////////////////////
      function offlineAlert(message, duration) {
        duration = angular.isUndefined(duration) ? 3 : duration;

        var errorAlert = {
          placement: 'top',
          title: message + ' Contattare un amministratore.',
          type: 'danger',
          duration: duration
        };

        $alert(errorAlert);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('g1.core')
    .factory('api', api);

  function api($window, $document, $rootScope, $q, $http, $resource, $filter, Upload, apiBaseUrl) {
    var List = ListClass;
    var One = OneClass;
    var apiFactory = {
      empty: function emptyFn() {return $q.when([]);},
      toPromise: function toPromise(data) {return $q.when(data);},
      list: listFn,
      one: oneFn,
      allegati: Allegati(),
      allegato: Allegato,
      appuntamenti: Appuntamenti(),
      appuntamento: Appuntamento,
      chart: Chart,
      cliente: Cliente,
      clienti: Clienti(),
      contratti: Contratti(),
      contratto: Contratto,
      elenchi: Elenchi(),
      elenco: Elenco,
      exportLogs: new List('/export_logs', 'ExportLog'),
      functions: new Functions(),
      incompleti: new List('/coord/incompleti', 'Incompleto'),
      lista: Lista,
      liste: Liste(),
      modelli: Modelli(),
      modello: Modello,
      operatore: Operatore,
      operatori: Operatori(),
      opportunita: Opportunita,
      portafogli: Portafogli(),
      portafoglio: Portafoglio,
      pv: Pv,
      prodotti: Prodotti(),
      prodotto: Prodotto,
      promemoria: Promemoria,
      provvigioni: Provvigioni(),
      provvigione: Provvigione,
      referenti: Referenti(),
      referente: Referente,
      report: Report,
      reports: new List('/reports', 'Reports'),
      sedi: Sedi(),
      sede: Sede,
      soggetti: Soggetti(),
      soggetto: Soggetto,
      squadre: new List('/squadre', 'Squadra'),
      squadra: Squadra,
      tabelle: new List('/tabelle', 'Tabella'),
      telefonata: Telefonata,
      telefonate: Telefonate(),
      copertura: Copertura
    };
    return apiFactory;

    ////////////////////////////////////////////////////////////////////////////
    // transformResponse per le chiamate con responseType 'arraybuffer': se il backend risponde
    // con un json (es. errore 500) lo decodifica, così l'interceptor trova rejection.data.error
    function decodeJsonError(data, headersGetter) {
      var contentType = headersGetter('Content-Type') || '';

      if (data && contentType.indexOf('application/json') !== -1) {
        try {
          return angular.fromJson(new $window.TextDecoder('utf-8').decode(new $window.Uint8Array(data)));
        } catch (e) {
          return data;
        }
      }

      return data;
    }

    // salva sul client un file ricevuto via $http
    function downloadFile(data, mimeType, filename) {
      var blobUrl = $window.URL.createObjectURL(new $window.Blob([data], {type: mimeType}));
      var link = $document[0].createElement('a');

      link.href = blobUrl;
      link.download = filename;
      $document[0].body.appendChild(link);
      link.click();
      $document[0].body.removeChild(link);

      $window.setTimeout(function () {
        $window.URL.revokeObjectURL(blobUrl);
      }, 1000);
    }

    function ListClass(baseRoute, name) {
      var self = this;

      this.url = apiBaseUrl + baseRoute;
      this.resource = resourceFn;
      this.actions = {
        'search': function() { $rootScope.$broadcast('search' + name); },
        'create': function() { $rootScope.$broadcast('create' + name); },
        'read': function(id) { $rootScope.$broadcast('read' + name, id); },
        'update': function(id) { $rootScope.$broadcast('update' + name, id); },
        'delete': function(id) { $rootScope.$broadcast('delete' + name, id); }
      };
      this.list = listFn;
      this.get = getFn;
      this.searchForm = searchFormFn;
      this.editForm = editFormFn;
      this.save = saveFn;

      function resourceFn() {
        return $resource(self.url, null, {
          'searchForm': {method: 'GET', url: self.url + '/forms/search'},
          'editForm': {method: 'GET', url: self.url + '/forms/edit'}
        });
      }

      function listFn(params) {
        return self.resource().query(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.listed', data);
        }
      }

      function getFn(params) {
        return self.resource().get(params).$promise;
      }

      function searchFormFn(params) {
        return self.resource().searchForm(params).$promise;
      }

      function editFormFn(params) {
        return self.resource().editForm(params).$promise;
      }

      function saveFn(postData) {
        return self.resource().save(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.created', data);
        }
      }
    }

    function OneClass(baseRoute, name, id) {
      var self = this;
      this.url = apiBaseUrl + baseRoute + '/:id';
      this.id = id;
      this.resource = resourceFn;
      this.list = listFn;
      this.get = getFn;
      this.update = updateFn;
      this.remove = removeFn;

      function resourceFn() {
        return $resource(self.url, {id: '@id'}, {
          'update': {method: 'PUT'}
        });
      }

      function listFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: self.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = self.id;
        }

        return self.resource().query(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.listed', data);
        }
      }

      function getFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: self.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = self.id;
        }

        return self.resource().get(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.getted', data);
        }
      }

      function updateFn(putData) {
        if (typeof(putData) === 'undefined') {
          putData = {id: self.id};
        } else if (angular.isObject(putData) && !putData.hasOwnProperty('id')) {
          putData.id = self.id;
        }

        return self.resource().update(putData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.updated', data);
        }
      }

      function removeFn(deleteData) {
        if (typeof(deleteData) === 'undefined') {
          deleteData = {id: self.id};
        } else if (angular.isObject(deleteData) && !deleteData.hasOwnProperty('id')) {
          deleteData.id = self.id;
        }

        return self.resource().delete(deleteData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast(name + '.deleted', data);
        }
      }
    }

    function listFn(baseRoute, name) {
      return new List(baseRoute, name);
    }

    function oneFn(baseRoute, name, id) {
      return new One(baseRoute, name, id);
    }

    function Allegati() {
      var allegati = new List('/allegati', 'Allegato');

      allegati.save = saveFn;

      return allegati;
      //////////////////////////////////////////////////////////////////////
      function saveFn(postData) {
        return Upload.upload({
          url: allegati.url,
          data: postData
        }).then(broadcastFn);

        function broadcastFn(data) {
          $rootScope.$broadcast('Allegato.created', data);
        }
      }
    }

    function Allegato(id) {
      return new One('/allegati', 'Allegato', id);
    }

    function Appuntamenti() {
      var appuntamenti = new List('/appuntamenti', 'Appuntamento');

      appuntamenti.actions.esita = function(id) { $rootScope.$broadcast('esitaAppuntamento', id); };
      appuntamenti.actions.inviaConferma = function(id, datiMail) { $rootScope.$broadcast('inviaConfermaAppuntamento', id, datiMail); };
      appuntamenti.actions.checkDistances = function(newAppuntamento) { $rootScope.$broadcast('checkDistances', newAppuntamento); };
      appuntamenti.actions.createPrivato = function(idAgente) { $rootScope.$broadcast('createAppuntamentoPrivato', idAgente); };
      appuntamenti.actions.readPrivato = function(id) { $rootScope.$broadcast('readAppuntamentoPrivato', id); };
      appuntamenti.actions.updatePrivato = function(id) { $rootScope.$broadcast('updateAppuntamentoPrivato', id); };

      appuntamenti.resource = resourceFn;
      appuntamenti.sendmailForm = sendmailForm;

      appuntamenti.stati = AppuntamentiStati();
      appuntamenti.stato = function StatoAppuntamento(id) { return new One('/appuntamenti/stati', 'StatoAppuntamento', id); };

      return appuntamenti;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(appuntamenti.url, null, {
          'searchForm': {method: 'GET', url: appuntamenti.url + '/forms/search'},
          'editForm': {method: 'GET', url: appuntamenti.url + '/forms/edit'},
          'sendmailForm': {method: 'GET', url: appuntamenti.url + '/forms/sendmail'}
        });
      }

      function sendmailForm(params) {
        return appuntamenti.resource().sendmailForm(params).$promise;
      }

      function AppuntamentiStati() {
        var appuntamentiStati = new List('/appuntamenti/stati', 'StatoAppuntamento');

        appuntamentiStati.colori = coloriFn;

        return appuntamentiStati;

        function coloriFn() {
          var defer = $q.defer();

          appuntamentiStati.resource().query({
            obsoleto: 0
          }).$promise.then(onSuccess, onError);

          return defer.promise;

          //////////////////////////////////////////////////////////////////////
          function onSuccess(as) {
            var colori = {};

            angular.forEach(as, function(record) {
              if (record['colore1'] !== '' && record['colore2'] !== '') {
                colori[record['id']] = {
                  primary: record['colore1'],
                  secondary: record['colore2']
                }
              } else {
                colori[record['id']] = {}
              }
            });

            defer.resolve(colori);
          }

          function onError(error) {
            defer.reject(error);
          }
        }
      }
    }

    function Appuntamento(id) {
      var appuntamento = new One('/appuntamenti', 'Appuntamento', id);

      appuntamento.resource = resourceFn;
      appuntamento.sendConfirm = sendConfirmFn;
      appuntamento.setOpportunita = setOpportunitaFn;
      appuntamento.unsetOpportunita = unsetOpportunitaFn;

      appuntamento.contratti = new List('/appuntamenti/' + id + '/contratti', 'Contratto');
      appuntamento.telefonate = new List('/appuntamenti/' + id + '/telefonate', 'Telefonata');

      return appuntamento;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(appuntamento.url, {id: '@id'}, {
          'update': {method: 'PUT'},
          'sendConfirm': {method: 'POST', url: appuntamento.url + '/send-confirm'},
          'setOpportunita': {method: 'POST', url: appuntamento.url + '/opportunita'},
          'unsetOpportunita': {method: 'DELETE', url: appuntamento.url + '/opportunita'}
        });
      }

      function sendConfirmFn(postData) {
        if (typeof(postData) === 'undefined') {
          postData = {id: appuntamento.id};
        } else if (angular.isObject(postData) && !postData.hasOwnProperty('id')) {
          postData.id = appuntamento.id;
        }

        return appuntamento.resource().sendConfirm(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Appuntamento.confirmed', data);
        }
      }

      function setOpportunitaFn(postData) {
        if (typeof(postData) === 'undefined') {
          postData = {id: appuntamento.id};
        } else if (angular.isObject(postData) && !postData.hasOwnProperty('id')) {
          postData.id = appuntamento.id;
        }

        return appuntamento.resource().setOpportunita(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Appuntamento.updated', data);
        }
      }

      function unsetOpportunitaFn(deleteData) {
        if (typeof(deleteData) === 'undefined') {
          deleteData = {id: appuntamento.id};
        } else if (angular.isObject(deleteData) && !deleteData.hasOwnProperty('id')) {
          deleteData.id = appuntamento.id;
        }

        return appuntamento.resource().unsetOpportunita(deleteData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Appuntamento.updated', data);
        }
      }
    }

    function Chart(id) {
      var chart = new One('/charts', 'Chart', id);

      chart.resource = resourceFn;
      chart.searchForm = searchFormFn;

      return chart;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(chart.url, {id: '@id'}, {
          'update': {method: 'PUT'},
          'searchForm': {method: 'GET', url: chart.url + '/forms/search'}
        });
      }

      function searchFormFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: chart.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = chart.id;
        }

        return chart.resource().searchForm(params).$promise;
      }
    }

    function Cliente(id) {
      var cliente = new One('/clienti', 'Cliente', id);

      cliente.resource = resourceFn;
      cliente.sendPresentation = sendPresentationFn;

      cliente.appuntamenti = new List('/clienti/' + id + '/appuntamenti', 'Appuntamento');
      cliente.appuntamento =  function(idAppuntamento) { return new AppuntamentoCliente(id, idAppuntamento); };
      cliente.referenti = Referenti(id);
      cliente.sedi = Sedi(id);
      cliente.contratti = new List('/clienti/' + id + '/contratti', 'Contratto');
      cliente.dati = DatiCliente(id);
      cliente.elenchi = new List('/clienti/' + id + '/elenchi', 'Elenco');
      cliente.telefonate = new List('/clienti/' + id + '/telefonate', 'Telefonata');
      cliente.opportunita = new List('/clienti/' + id + '/opportunita', 'Opportunita');
      cliente.postvendita = new Pv(id);

      return cliente;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(cliente.url, {id: '@id'}, {
          'update': {method: 'PUT'},
          'sendPresentation': {method: 'POST', url: cliente.url + '/send-presentation'}
        });
      }

      function sendPresentationFn(postData) {
        if (typeof(postData) === 'undefined') {
          postData = {id: cliente.id};
        } else if (angular.isObject(postData) && !postData.hasOwnProperty('id')) {
          postData.id = cliente.id;
        }

        return cliente.resource().sendPresentation(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Cliente.presented', data);
        }
      }

      function DatiCliente(idCliente) {
        var dati = new List('/clienti/' + idCliente + '/dati', 'DatoCliente');

        dati.actions.create = function(idCliente) { $rootScope.$broadcast('createDatoCliente', idCliente); };

        return dati;
      }

      function Referenti( idCliente ) {
        var referenti = new List( '/clienti/' + idCliente + '/referenti', 'Referente' );
        referenti.actions.create = function ( idCliente ) {
          $rootScope.$broadcast( 'createReferente', idCliente );
        };
        return referenti;
      }

      function Sedi( idCliente ) {
        var sedi = new List( '/clienti/' + idCliente + '/sedi', 'Sede' );
        sedi.actions.create = function ( idCliente ) {
          $rootScope.$broadcast( 'createSede', idCliente );
        };
        return sedi;
      }

      function AppuntamentoCliente(idCliente, idAppuntamento) {
        var appuntamento = new One('/clienti/' + idCliente + '/appuntamenti', 'Appuntamento', idAppuntamento);

        appuntamento.resource = resourceFn;
        appuntamento.motivo = motivoFn;

        function resourceFn() {
          return $resource(appuntamento.url, {id: '@id'}, {
            'motivo': {method: 'POST', url: appuntamento.url + '/motivo'}
          });
        }

        function motivoFn(postData) {
          return appuntamento.resource().motivo({id: appuntamento.id}, postData, broadcastFn).$promise;

          function broadcastFn(data) {
            $rootScope.$broadcast('Appuntamento.motivo', data);
          }
        }

        return appuntamento;
      }
    }

    function Clienti() {
      var clienti = new List('/clienti', 'Cliente');

      clienti.actions.inviaPresentazione = function(id, datiMail) { $rootScope.$broadcast('inviaPresentazioneCliente', id, datiMail); };

      clienti.resource = resourceFn;
      clienti.remove = removeFn;
      clienti.importForm = importFormFn;
      clienti.sendmailForm = sendmailForm;
      clienti.import_file = importFileFn;
      clienti.import_save = importSaveFn;
      clienti.import_delete = importDeleteFn;

      clienti.dati = new List('/clienti/dati', 'DatoCliente');
      clienti.dato = function Dato(idDato) { return new One('/clienti/dati', 'DatoCliente', idDato); };

      function resourceFn() {
        return $resource(clienti.url, null, {
          'searchForm': {method: 'GET', url: clienti.url + '/forms/search'},
          'editForm': {method: 'GET', url: clienti.url + '/forms/edit'},
          'importForm': {method: 'GET', url: clienti.url + '/forms/import'},
          'sendmailForm': {method: 'GET', url: clienti.url + '/forms/sendmail'},
          'import_save': {method: 'POST', url: clienti.url + '/import'},
          'import_delete': {method: 'DELETE', url: clienti.url + '/import/:tablename'}
        });
      }

      function removeFn(deleteData) {
        return clienti.resource().delete(deleteData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Clienti.deleted', data);
        }
      }

      function importFormFn(params) {
        return clienti.resource().importForm(params).$promise;
      }

      function sendmailForm(params) {
        return clienti.resource().sendmailForm(params).$promise;
      }

      function importFileFn(postData) {
        return Upload.upload({
          url: clienti.url + '/import',
          data: postData
        });
      }

      function importDeleteFn(params) {
        return clienti.resource().import_delete(params).$promise;
      }

      function importSaveFn(postData) {
        return clienti.resource().import_save(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Clienti.created', data);
        }
      }

      return clienti;
    }

    function Contratti() {
      var contratti = new List('/contratti', 'Contratto');

      contratti.resource = resourceFn;
      contratti.update = updateFn;

      contratti.stati = new List('/contratti/stati', 'StatoContratto');
      contratti.stato = function StatoContratto(id) { return new One('/contratti/stati', 'StatoContratto', id); };

      return contratti;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(contratti.url, null, {
          'searchForm': {method: 'GET', url: contratti.url + '/forms/search'},
          'editForm': {method: 'GET', url: contratti.url + '/forms/edit'},
          'update': {method: 'PUT'}
        });
      }

      function updateFn(putData) {
        return contratti.resource().update(putData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Contratti.updated', data);
        }
      }
    }

    function Contratto(id) {
      return new One('/contratti', 'Contratto', id);
    }

    function Copertura( id ) {
      if (typeof id !== 'undefined') {
        return new One('/copertura', 'Copertura', id);
      } else {
        var output = new List( '/copertura', 'Copertura' );
        output.checkFromCsv = function ( postData ) {
          return Upload.upload( {
            url: output.url + '/check_from_csv',
            data: postData
          } ).then( function ( data ) {
            $rootScope.$broadcast( 'Copertura.created', data);
          } );
        }
      }
      return output;
    }

    function Elenchi() {
      var elenchi = new List('/elenchi', 'Elenco');

      elenchi.stati = new List('/elenchi/stati', 'StatoElenco');
      elenchi.stato = function StatoContratto(id) { return new One('/elenchi/stati', 'StatoElenco', id); };

      return elenchi;
    }

    function Elenco(id) {
      var elenco = new One('/elenchi', 'Elenco', id);

      elenco.telefonate = new List('/elenchi/' + id + '/telefonate', 'Telefonata');

      return elenco;
    }

    function Functions() {
      this.urlParser = urlParserFn;

      function urlParserFn(url) {
        if (_.isEmpty(url) || _.startsWith(url, 'http://') || _.startsWith(url, 'https://')) {
          return url;
        } else {
          return 'http://' + url;
        }
      }
    }

    function Lista(id) {
      var lista = new One('/liste', 'Lista', id);

      lista.clienti = new List('/liste/' + id + '/clienti', 'Cliente');
      lista.resource = resourceFn;
      lista.assign = assignFn;
      lista.remove_list = removeListFn;
      lista.remove_delete = removeDeleteFn;
      lista.move_list = moveListFn;
      lista.move_update = moveUpdateFn;

      return lista;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(lista.url, {id: '@id'}, {
          'update': {method: 'PUT'},
          'assign': {method: 'PUT', url: lista.url + '/assign'},
          'remove_list': {method: 'GET', isArray: true, url: lista.url + '/remove'},
          'remove_delete': {method: 'DELETE', url: lista.url + '/remove'},
          'move_list': {method: 'GET', isArray: true, url: lista.url + '/move'},
          'move_update': {method: 'PUT', url: lista.url + '/move'}
        });
      }

      function assignFn(putData) {
        if (typeof(putData) === 'undefined') {
          putData = {id: lista.id};
        } else if (angular.isObject(putData) && !putData.hasOwnProperty('id')) {
          putData.id = lista.id;
        }

        return lista.resource().assign(putData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.updated', data);
        }
      }

      function removeListFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: lista.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = lista.id;
        }

        return lista.resource().remove_list(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.listed', data);
        }
      }

      function removeDeleteFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: lista.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = lista.id;
        }

        return lista.resource().remove_delete(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.updated', data);
        }
      }

      function moveListFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: lista.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = lista.id;
        }

        return lista.resource().move_list(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.listed', data);
        }
      }

      function moveUpdateFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: lista.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = lista.id;
        }

        return lista.resource().move_update(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.updated', data);
        }
      }
    }

    function Liste() {
      var liste = new List('/liste', 'Lista');

      liste.actions.import = function() { $rootScope.$broadcast('importLista'); };
      liste.actions.manage = function(id) { $rootScope.$broadcast('manageLista', id); };
      liste.actions.assign = function(id) { $rootScope.$broadcast('assignLista', id); };
      liste.actions.remove = function(id) { $rootScope.$broadcast('removeLista', id); };
      liste.actions.move = function(id) { $rootScope.$broadcast('moveLista', id); };
      liste.actions.readClienti = function(id, filtro) {
        $rootScope.$broadcast('readClientiLista', id, filtro);
      };

      liste.resource = resourceFn;
      liste.import = importFn;
      liste.import_delete = importDeleteFn;
      liste.create_list = createListFn;
      liste.create_save = createSaveFn;

      return liste;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(liste.url, null, {
          'searchForm': {method: 'GET', url: liste.url + '/forms/search'},
          'editForm': {method: 'GET', url: liste.url + '/forms/edit'},
          'import_delete': {method: 'DELETE', url: liste.url + '/import/:tablename'},
          'create_list': {method: 'GET', isArray: true, url: liste.url + '/create'},
          'create_save': {method: 'POST', url: liste.url + '/create'}
        });
      }

      function importFn(postData) {
        return Upload.upload({
          url: liste.url + '/import',
          data: postData
        });
      }

      function importDeleteFn(params) {
        return liste.resource().import_delete(params).$promise;
      }

      function createListFn(params) {
        return liste.resource().create_list(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.listed', data);
        }
      }

      function createSaveFn(postData) {
        return liste.resource().create_save(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Lista.created', data);
        }
      }
    }

    function Modelli() {
      var modelli = new List('/modelli', 'Modello');

      modelli.save = saveFn;

      return modelli;
      //////////////////////////////////////////////////////////////////////
      function saveFn(postData) {
        return Upload.upload({
          url: modelli.url,
          data: postData
        }).then(broadcastFn);

        function broadcastFn(data) {
          $rootScope.$broadcast('Modello.created', data);
        }
      }
    }

    function Modello(id) {
      return new One('/modelli', 'Modello', id);
    }

    function Operatore(id) {
      var operatore = new One('/operatori', 'Operatore', id);

      operatore.elenchi = new List('/operatori/' + id + '/elenchi', 'Elenco');
      operatore.telefonate = new List('/operatori/' + id + '/telefonate', 'Telefonata');
      operatore.appuntamenti = new List('/operatori/' + id + '/appuntamenti', 'Appuntamento');

      return operatore;
    }

    function Operatori() {
      var operatori = new List('/operatori', 'Operatore');

      operatori.telefonate = new List('/operatori/telefonate', 'Telefonata');

      return operatori;
    }

    // attenzione che questa funzione gestisce sia List che One...
    function Opportunita(id) {
      // se c'è il parametro id esegui la versione One oppure esegui la versione List
      if (typeof id !== 'undefined') {
        return opportunita_one(id);
      } else {
        return opportunita_list();
      }

      //////////////////////////////////////////////////////////////////////////
      function opportunita_list() {
        var opportunita = new List('/opportunita', 'Opportunita');

        opportunita.actions.checkEditPermission = checkEditPermission;
        opportunita.actions.send = function( id, datiMail ) {
          $rootScope.$broadcast('inviaOpportunita', id, datiMail);
        };

        opportunita.resource = resourceFn;
        opportunita.sendmailForm = sendmailForm;

        opportunita.attivita = Attivita('/opportunita/attivita');
        opportunita.logs = new List('/opportunita/logs', 'LogOpportunita');
        opportunita.log = function ( id ) {
          return new One( '/opportunita/logs', 'LogOpportunita', id );
        }

        opportunita.progetti = function ( id ) {
          var progetti;
          if ( typeof id !== 'undefined' ) {
            progetti = new One( '/opportunita/progetti', 'Progetto', id );
            progetti.attivita = new List( '/opportunita/progetti/' + id + '/attivita', 'AttivitaProgetto' );
            progetti.resource = function () {
              return $resource( progetti.url, {id: '@id'}, {
                'update': {method: 'PUT'},
                'send': {method: 'POST', url: progetti.url + '/send'}
              } );
            }
            progetti.send = function ( postData ) {
              if ( typeof( postData ) === 'undefined') {
                postData = {
                  idProgetto: id
                };
              } else if ( angular.isObject( postData ) && ! postData.hasOwnProperty( 'id' ) ) {
                postData.id = id;
              }
              return progetti.resource().send( postData, function () {
                $rootScope.$broadcast( 'Opportunita.sended', postData );
              } ).$promise; // mi rifaccio al metodo di opportunità
            }
          } else {
            progetti = new List( '/opportunita/progetti', 'Progetto' );
            progetti.logs = new List( '/opportunita/progetti/logs', 'LogProgetto' );
            progetti.actions.send = function ( id, datiMail ) {
              $rootScope.$broadcast( 'inviaProgetto', id, datiMail );
            };
            progetti.resource = function () {
              return $resource(progetti.url, null, {
                'searchForm': {method: 'GET', url: progetti.url + '/forms/search'},
                'editForm': {method: 'GET', url: progetti.url + '/forms/edit'},
                'sendmailForm': {method: 'GET', url: progetti.url + '/forms/sendmail'}
              } );
            }
            progetti.sendmailForm = function ( params ) {
              return progetti.resource().sendmailForm( params ).$promise;
            }
            progetti.log = function ( id ) {
              return new One( '/opportunita/progetti/log', 'LogProgetto', id );
            };
          }
          return progetti;
        }

        return opportunita;

        ////////////////////////////////////////////////////////////////////////
        function checkEditPermission(user, opportunita) {
          var check = false;

          if (user.flags.gestOppo) {
            if (user.userGroup == 1) {
              if (opportunita.idAgentePIC === user.idAgente) {
                check = 'agente'
              }
            } else {
              check = 'admin'
            }
          }

          return check;
        }

        function resourceFn() {
          return $resource(opportunita.url, null, {
            'searchForm': {method: 'GET', url: opportunita.url + '/forms/search'},
            'editForm': {method: 'GET', url: opportunita.url + '/forms/edit'},
            'sendmailForm': {method: 'GET', url: opportunita.url + '/forms/sendmail'}
          });
        }

        function sendmailForm(params) {
          return opportunita.resource().sendmailForm(params).$promise;
        }
      }

      function opportunita_one(id) {
        var opportunita = new One('/opportunita', 'Opportunita', id);

        opportunita.resource = resourceFn;
        opportunita.send = sendFn;

        opportunita.allegati = new List('/opportunita/' + id + '/allegati', 'Allegato');
        opportunita.attivita = Attivita('/opportunita/' + id + '/attivita');
        opportunita.contratti = new List('/opportunita/' + id + '/contratti', 'Contratto');
        opportunita.logs = new List('/opportunita/' + id + '/logs', 'LogOpportunita');

        return opportunita;

        ////////////////////////////////////////////////////////////////////////
        function resourceFn() {
          return $resource(opportunita.url, {id: '@id'}, {
            'update': {method: 'PUT'},
            'send': {method: 'POST', url: opportunita.url + '/send'}
          });
        }

        function sendFn(postData) {
          if (typeof(postData) === 'undefined') {
            postData = {id: opportunita.id};
          } else if (angular.isObject(postData) && !postData.hasOwnProperty('id')) {
            postData.id = opportunita.id;
          }

          return opportunita.resource().send(postData, broadcastFn).$promise;

          function broadcastFn(data) {
            $rootScope.$broadcast('Opportunita.sended', data);
          }
        }
      }

      // attenzione che questa funzione gestisce sia List che One...
      function Attivita(url) {
        return function AttivitaFn(id) {
          // se c'è il parametro id esegui la versione One oppure esegui la versione List
          if (typeof id !== 'undefined') {
            return new One(url, 'AttivitaOpportunita', id);
          } else {
            return new List(url, 'AttivitaOpportunita');
          }
        };
      }

    }

    function Portafogli() {
      var portafogli = new List('/portafogli', 'Portafoglio');

      portafogli.tipi = new List('/portafogli/tipi', 'TipoPortafoglio');
      portafogli.tipo = function TipoPortafoglio(id) { return new One('/portafogli/tipi', 'TipoPortafoglio', id); };

      return portafogli;
    }

    function Portafoglio(id) {
      return new One('/portafogli', 'Portafoglio', id);
    }

    // attenzione che questa funzione gestisce sia List che One...
    function Pv(id) {
      // se c'è il parametro id esegui la versione One oppure esegui la versione List
      if (typeof id !== 'undefined') {
        return one(id);
      } else {
        return list();
      }

      function list() {
        var pv = new List('/tickets', 'Pv');
        pv.attivita = Attivita('/tickets/attivita');
        pv.actions.readAttivitaPv = function (id) {
          $rootScope.$broadcast('readAttivitaPv', id);
        };
        pv.actions.dashboard = function() {
          location.href = '/#/pv';
        };
        pv.rapportini = function () {
          return new List( '/tickets/rapportini', 'Rapportini' );
        }
        pv.rapportino = function ( idRapportino ) {
          var rapportino = new One( '/tickets/rapportino', 'Rapportino', idRapportino );
          rapportino.update = function (putData) {
            if (typeof(putData) === 'undefined') {
              putData = {id: self.id};
            } else if (angular.isObject(putData) && !putData.hasOwnProperty('id')) {
              putData.id = self.id;
            }
            rapportino.url = rapportino.url.replace( ':id', idRapportino );
            return Upload.upload({
              url: rapportino.url,
              data: putData
            }).then(broadcastFn);
            function broadcastFn(data) {
              $rootScope.$broadcast('Rapportino.updated', data);
            }
          }
          return rapportino;
        }

        pv.reportPdf = reportPdfFn;

        return pv;

        //////////////////////////////////////////////////////////////////////////
        // genera il report PDF dei ticket filtrati: il backend restituisce direttamente il file, che viene scaricato
        // (la chiamata passa da $http, così parte la loading bar e gli errori sono gestiti dall'interceptor)
        function reportPdfFn(params) {
          return $http.get(pv.url + '/report-pdf', {
            params: params,
            responseType: 'arraybuffer',
            transformResponse: decodeJsonError
          }).then(function (response) {
            downloadFile(response.data, 'application/pdf', 'report-' + params.tipoOutput + '.pdf');
            return response;
          });
        }
      }

      function one( idPv ) {
        var pv = new One( '/tickets', 'Pv', idPv );
        pv.attivita = Attivita('/tickets/' + idPv + '/attivita');
        pv.allegati = new List('/tickets/' + idPv + '/allegati', 'Allegato');
        pv.logAssegnazioni = new List('/tickets/' + idPv + '/logs', 'Assegnazione');

        pv.resource = resourceFn;
        pv.sendEmailNotification = sendEmailNotificationFn;

        function resourceFn() {
          return $resource(pv.url, {id: '@id'}, {
            'update': {
              method: 'PUT'
            },
            'sendEmailNotification': {
              method: 'POST',
              url: pv.url + '/send_email_notification'
            }
          });
        }

        function sendEmailNotificationFn(postData) {
          return pv.resource().sendEmailNotification({id: pv.id}, postData, broadcastFn).$promise;
          function broadcastFn(data) {
            $rootScope.$broadcast('Pv.sendEmailNotification', data);
          }
        }
        return pv;
      }

      // attenzione che questa funzione gestisce sia List che One...
      function Attivita(url) {
        return function AttivitaFn(id) {
          // se c'è il parametro id esegui la versione One oppure esegui la versione List
          if (typeof id !== 'undefined') {
            var output = new One(url, 'AttivitaPv', id);
            output.resource = function () {
              return $resource(output.url, {id: '@id'}, {
                'update': {method: 'PUT',url: apiBaseUrl + url + '/' + id},
                'send': {method: 'POST', url: output.url + '/send'}
              });
            };
            return output;
          } else {
            return new List(url, 'AttivitaPv');
          }
        };
      }

    }

    function Prodotti() {
      var prodotti = new List('/prodotti', 'Prodotto');

      prodotti.filtraGruppi = filtraGruppiFn;

      return prodotti;

      //////////////////////////////////////////////////////////////////////////
      function filtraGruppiFn(gruppi, fornitore, pista) {
        if (angular.isDefined(fornitore) && !_.isEmpty(fornitore)) {
          gruppi = $filter('filter')(gruppi, {fornitore: fornitore}, true);
        }

        if (angular.isDefined(pista) && !_.isEmpty(pista)) {
          gruppi = $filter('filter')(gruppi, {pista: pista}, true);
        }

        gruppi = $filter('orderBy')(gruppi, 'label');
        gruppi = _.uniq(gruppi, true, 'label');

        return gruppi;
      }
    }

    function Prodotto(id) {
      return new One('/prodotti', 'Prodotto', id);
    }

    // attenzione che questa funzione gestisce sia List che One...
    function Promemoria(id) {
      // se c'è il parametro id esegui la versione One oppure esegui la versione List
      if (typeof id !== 'undefined') {
        return promemoria_one(id);
      } else {
        return promemoria_list();
      }

      //////////////////////////////////////////////////////////////////////////
      function promemoria_list() {
        var promemoria = new List('/promemoria', 'Promemoria');

        promemoria.actions.create = function(tabellaCollegata) { $rootScope.$broadcast('createPromemoria', tabellaCollegata); };

        return promemoria;
      }

      function promemoria_one(id) {
        return new One('/promemoria', 'Promemoria', id);
      }
    }

    function Provvigioni() {
      var provvigioni = new List('/provvigioni', 'Provvigione');

      provvigioni.resource = resourceFn;
      provvigioni.doppie = doppieFn;
      provvigioni.calcola = calcolaFn;
      provvigioni.copia = copiaFn;
      provvigioni.update = updateFn;
      provvigioni.remove = removeFn;

      provvigioni.calcolate = new List('/provvigioni/calcolate', 'ProvvigioneCalcolata');
      provvigioni.calcolata = function ProvvigioneCalcolata(id) { return new One('/provvigioni/calcolate', 'ProvvigioneCalcolata', id); };

      return provvigioni;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(provvigioni.url, null, {
          'searchForm': {method: 'GET', url: provvigioni.url + '/forms/search'},
          'editForm': {method: 'GET', url: provvigioni.url + '/forms/edit'},
          'doppie': {method: 'GET', isArray: true, url: provvigioni.url + '/doppie'},
          'calcola': {method: 'POST', url: provvigioni.url + '/calcola'},
          'copia': {method: 'POST', url: provvigioni.url + '/copia'},
          'update': {method: 'PUT'}
        });
      }

      function doppieFn(params) {
        return provvigioni.resource().doppie(params, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Provvigione.listed', data);
        }
      }

      function calcolaFn(postData) {
        return provvigioni.resource().calcola(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Provvigione.calculated', data);
        }
      }

      function copiaFn(postData) {
        return provvigioni.resource().copia(postData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Provvigione.copied', data);
        }
      }

      function updateFn(putData) {
        return provvigioni.resource().update(putData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Provvigione.updated', data);
        }
      }

      function removeFn(deleteData) {
        return provvigioni.resource().delete(deleteData, broadcastFn).$promise;

        function broadcastFn(data) {
          $rootScope.$broadcast('Provvigioni.deleted', data);
        }
      }
    }

    function Provvigione(id) {
      return new One('/provvigioni', 'Provvigione', id);
    }

    function Referenti() {
      var referenti = new List('/referenti', 'Referente');

      return referenti;

    }

    function Referente(id) {
      return new One('/referenti', 'Referente', id);
    }

    function Report(id) {
      var report = new One('/reports', 'Report', id);

      report.resource = resourceFn;
      report.searchForm = searchFormFn;

      return report;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(report.url, {id: '@id'}, {
          'update': {method: 'PUT'},
          'searchForm': {method: 'GET', url: report.url + '/forms/search'}
        });
      }

      function searchFormFn(params) {
        if (typeof(params) === 'undefined') {
          params = {id: report.id};
        } else if (angular.isObject(params) && !params.hasOwnProperty('id')) {
          params.id = report.id;
        }

        return report.resource().searchForm(params).$promise;
      }
    }

    function Sedi() {
      var sedi = new List('/sedi', 'Sede');
      return sedi;
    }

    function Sede( id ) {
      return new One( '/sedi', 'Sede', id );
    }

    function Soggetti() {
      var soggetti = new List('/soggetti', 'Soggetto');

      soggetti.actions.changePassword = function(idUtente) { $rootScope.$broadcast('changePassword', idUtente); };

      soggetti.resource = resourceFn;
      soggetti.existCheck = existCheckFn;

      return soggetti;

      //////////////////////////////////////////////////////////////////////////
      function resourceFn() {
        return $resource(soggetti.url, null, {
          'searchForm': {method: 'GET', url: soggetti.url + '/forms/search'},
          'editForm': {method: 'GET', url: soggetti.url + '/forms/edit'},
          'existCheck': {method: 'GET', url: soggetti.url + '/checks/exist'}
        });
      }

      function existCheckFn(params) {
        return soggetti.resource().existCheck(params).$promise;
      }
    }

    function Soggetto(id) {
      return new One('/soggetti', 'Soggetto', id);
    }

    function Squadra(id) {
      return new One('/squadre', 'Squadra', id);
    }

    function Telefonata(id) {
      return new One('/telefonate', 'Telefonata', id);
    }

    function Telefonate() {
      var telefonate = new List('/telefonate', 'Telefonata');

      telefonate.operatori = new List('/telefonate/operatori', 'Operatore');
      telefonate.stati = new List('/telefonate/stati', 'StatoTelefonata');
      telefonate.stato = function StatoContratto(id) { return new One('/telefonate/stati', 'StatoTelefonata', id); };

      return telefonate;
    }

  }

})();

angular.module("g1").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/procedure/importa-clienti.html","<script type=text/ng-template id=info-popover-import-clienti.tpl.html><div class=\"popover\" tabindex=\"-1\" style=\"max-width: inherit\">\n    <div class=\"arrow\"></div>\n    <h3 class=\"popover-title\">Informazioni sul file da importare</h3>\n    <div class=\"popover-content\">\n      <ul>\n        <li>Il file deve essere di tipo <b>Excel</b> o <b>CSV</b></li>\n        <li>Deve contenere i seguenti campi: <b>codfisc,ragsoc,indirizzo,citta,prov,cap,tel,note,idportafoglio,idportafoglio2</b></li>\n        <li>i campi obbligatori sono: <b>codfisc,ragsoc,citta,prov,tel</b></li>\n        <li><b>codfisc</b> deve essere di 16 caratteri</li>\n        <li><b>ragsoc</b> non deve superare i 100 caratteri</li>\n        <li><b>prov</b> deve essere di 2 caratteri</li>\n        <li><b>tel</b> deve essere composto solo da numeri o altrimenti essere 0 (zero)</li>\n        <li>\n          <b>idportafoglio</b>,<b>idportafoglio2</b> se vuoti verranno valorizzati come NC,<br>\n          se errati il record verrà scartato\n        </li>\n        <li>In caso di CF multipli verrà inserito il primo record e gli altri andranno a scarto</li>\n        <li>I clienti con CF già presente nel gestionale non verranno importati</li>\n        <li>\n          I clienti con numero di telefono già presente nel gestionale non verranno importati<br>\n          a meno che non vengano selezionati per forzarne l\'importazione\n        </li>\n      </ul>\n    </div>\n  </div></script><div class=container-fluid><div class=page-header><h2>Importa Clienti <i class=\"fa fa-info-circle text-primary\" title=Informazioni data-template-url=info-popover-import-clienti.tpl.html data-placement=bottom data-container=.page-header data-auto-close=true bs-popover></i></h2></div><form name=impCli.form class=form-horizontal ng-submit=impCli.importa() novalidate><div class=row><div class=col-md-6><fieldset ng-disabled=impCli.importResults.nome_tabella><div class=form-group><label class=\"control-label col-xs-2\" title=\"Seleziona File\">File</label><div class=col-xs-10><input type=file class=form-control ngf-select ngf-model-invalid=impCli.ic.fileImportError ngf-accept=text/csv ngf-pattern=\"\'.csv,.xls,.xlsx\'\" ng-model=impCli.ic.fileImport name=fileImport pattern-err-type=filePattern required><div ng-if=\"impCli.ic.fileImport.progress >= 0\"><br><progressbar value=impCli.ic.fileImport.progress type=info style=\"margin-bottom: 0\">{{impCli.ic.fileImport.progress | number:0}}%</progressbar></div></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Portafoglio 4\">Ptf 4</label><div class=col-xs-8><select class=form-control ng-options=\"el.value as el.label for el in impCli.formData.ptf4\" ng-model=impCli.ic.idPtf4 name=idPtf4 required><option value=\"\"></option></select></div><div class=col-xs-2><button type=button class=\"form-control btn btn-success\" ng-click=impCli.showPtf4()><i class=\"fa fa-fw fa-plus\" title=\"Inserisci nuovo Ptf4\"></i></button></div></div></fieldset><div class=form-group><div class=\"col-xs-12 text-center\" ng-if=!impCli.importResults.nome_tabella><button type=submit class=\"btn btn-success\" title=Importa><i class=\"fa fa-fw fa-upload\"></i>&nbsp;Importa</button></div><div class=\"col-xs-12 text-center\" ng-if=impCli.importResults.nome_tabella><button type=reset class=\"btn btn-danger\" title=Resetta ng-click=impCli.dropImportTable()>Annulla</button></div></div></div></div></form><!-- messaggi di warning/errore --><div class=row ng-if=\"impCli.alerts.messages.length > 0\"><div class=col-xs-12><g1-alerts data-status={{impCli.alerts.status}} data-messages=impCli.alerts.messages></g1-alerts></div></div><div class=well ng-show=\"impCli.importResults.clienti_totali > 0\"><!-- record inseriti --><div class=row style=\"margin-bottom: 15px\"><div class=\"col-xs-12 text-center\"><h4 class=text-success>Verranno inseriti {{impCli.clientiInseribili}} clienti su {{impCli.importResults.clienti_totali}} record</h4></div></div><!-- tabella scartati --><div class=row style=\"margin-bottom: 15px\" ng-if=\"impCli.importResults.clienti_invalidi.length > 0\"><div class=\"col-xs-12 table-responsive\"><button class=\"btn btn-danger\" ng-click=\"impCli.show.invalidi = !impCli.show.invalidi\">clienti non importati per violazione regole import <span class=badge>{{impCli.importResults.clienti_invalidi.length}}</span></button><div ng-show=impCli.show.invalidi><table datatable dt-options=::impCli.dtInvalidi.options dt-columns=::impCli.dtInvalidi.columns dt-instance=impCli.dtInvalidi.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div><!-- tabella doppi --><div class=row style=\"margin-bottom: 15px\" ng-if=\"impCli.importResults.clienti_doppi.length > 0\"><div class=\"col-xs-12 table-responsive\"><button class=\"btn btn-warning\" ng-click=\"impCli.show.doppi = !impCli.show.doppi\">clienti non importati perchè già presenti (verifica per codice fiscale) <span class=badge>{{impCli.importResults.clienti_doppi.length}}</span></button><div ng-show=impCli.show.doppi><table datatable dt-options=::impCli.dtDoppi.options dt-columns=::impCli.dtDoppi.columns dt-instance=impCli.dtDoppi.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div><!-- tabella linea --><div class=row style=\"margin-bottom: 15px\" ng-if=\"impCli.importResults.clienti_linea.length > 0\"><div class=\"col-xs-12 table-responsive\"><h4 class=text-warning>clienti con numero di tel già presente in db<br><small class=text-muted>Selezionare quelli che si vogliono comunque importare forzatamente</small></h4><table datatable dt-options=::impCli.dtLinea.options dt-columns=::impCli.dtLinea.columns dt-instance=impCli.dtLinea.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div><div class=row style=\"margin-bottom: 15px\"><button class=\"btn btn-success\" ng-click=impCli.save()>Salva</button></div></div><br></div><!-- modal create ptf4 --><script type=text/ng-template id=ptf4-create-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"impCli.createPtfForm\" class=\"form-horizontal\" ng-submit=\"impCli.savePtf4()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                Inserisci nuovo Ptf4\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"impCli.portafoglio.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"impCli.portafoglio.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{impCli.cf.alerts.status}}\" data-messages=\"impCli.cf.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/procedure/incompleti.html","<div class=container-fluid><form role=form name=search_incompleti class=form-horizontal><div class=form-group><label class=\"control-label col-xs-2\">Team Leader</label><div class=col-xs-8><select class=form-control ng-options=\"el.value as el.label for el in incompleti.formData.teamLeaders\" ng-model=incompleti.si.teamLeader name=teamLeader></select></div><div class=col-xs-2><button type=submit class=\"form-control btn btn-info\" title=Filtra ng-click=incompleti.search()><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div ng-show=\"incompleti.showResults && (incompleti.incompleti.length > 0)\"><div class=row><div class=\"col-xs-12 g1-panel\"><table class=\"table table-hover\"><thead><tr><th><input type=checkbox title=\"Seleziona Tutti\" ng-model=incompleti.selectedAll ng-checked=incompleti.setSelectedAll() ng-click=incompleti.checkAll()></th><th>Agente</th><th>Stato</th></tr></thead><tbody><tr ng-repeat=\"row in incompleti.incompleti\"><td class=min-width><input type=checkbox ng-model=row.checked></td><td>{{row.agente}}</td><td class=min-width ng-bind-html=row.status></td></tr></tbody></table></div></div><br><div class=row><div class=\"col-xs-12 text-center\"><label class=control-label>Testo della mail</label><textarea class=form-control rows=5 ng-model=incompleti.message>\n          {{incompleti.incompleti.message}}\n        </textarea></div></div><br><div class=row><div class=\"col-xs-offset-10 col-xs-2\"><button type=button class=\"form-control btn btn-success\" ng-click=incompleti.sendEmails()>Invia</button></div></div></div><div class=row ng-show=\"incompleti.showResults && (incompleti.incompleti.length <= 0)\"><div class=\"col-xs-12 text-center\"><h4>Nessun Agente Trovato</h4></div></div></div>");
$templateCache.put("app/admin/procedure/provvigioni-schede-doppie.html","<div ng-include=\"\'app/admin/provvigioni/provvigioni-scheda.html\'\"></div><div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid><div class=page-header><h2>Verifica Doppioni Schede Provvigioni<br><small class=text-muted>Inserisci il periodo nel quale effettuare la verifica</small></h2></div><form name=psd.sf class=form-horizontal ng-submit=psd.search() novalidate><div class=row><div class=\"col-xs-12 col-md-4\"><div class=form-group><label class=\"control-label col-md-2\">Inizio</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in psd.formData.mesi\" ng-model=psd.searchForm.inizioMese name=inizioMese required></select></div><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in psd.formData.anni\" ng-model=psd.searchForm.inizioAnno name=inizioAnno required></select></div></div></div><div class=\"col-xs-12 col-md-4\"><div class=form-group><label class=\"control-label col-md-2\">Fine</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in psd.formData.mesi\" ng-model=psd.searchForm.fineMese name=fineMese required></select></div><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in psd.formData.anni\" ng-model=psd.searchForm.fineAnno name=fineAnno required></select></div></div></div><div class=\"col-xs-12 col-md-4 text-right\"><button type=reset class=\"btn btn-warning\" title=Resetta ng-click=psd.reset()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row ng-if=psd.searched><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::psd.dt.options dt-columns=::psd.dt.columns dt-instance=psd.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div>");
$templateCache.put("app/admin/provvigioni/provvigioni-copia.html","<div ng-include=\"\'app/admin/provvigioni/provvigioni-scheda.html\'\"></div><div class=container-fluid><div class=page-header><h2><a href=#/provvigioni title=\"Torna a gestione provvigioni\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> Copia Schede Provvigioni <i class=\"fa fa-info-circle text-primary\" title=Informazioni data-content=\"Verranno copiate tutte le schede provvigionali per i prodotti NON esistenti per il soggetto destinatario.<br>Per eventuali schede provvigionali di prodotti già esistenti verranno prese in considerazione le date di validità e verranno copiate solo le schede con date non sovrapposte.\" data-placement=bottom data-container=.page-header data-auto-close=true bs-popover></i></h2></div><form name=pCopia.searchForm class=form-horizontal ng-submit=pCopia.search() novalidate><div class=row><div class=\"col-xs-12 col-lg-10\"><div class=form-group><label class=\"control-label col-md-2\">Tipo Soggetto</label><div class=\"col-md-2 validate-group\"><select class=form-control ng-options=\"el.value as el.label for el in pCopia.formData.tipiSoggetto\" ng-model=pCopia.sf.tipoSoggetto name=tipoSoggetto ng-change=\"pCopia.sf.soggetto = \'\'; pCopia.sf[\'toSoggetti[]\'] = [];\"></select></div><label class=\"control-label col-md-2\" title=\"soggetto da cui copiare le schede\">Origine</label><div class=\"col-md-2 validate-group has-warning\"><select class=form-control ng-options=\"el.value as el.label for el in pCopia.formData.soggetti | filter:{tipoSoggetto: pCopia.sf.tipoSoggetto}:true\" ng-model=pCopia.sf.soggetto name=soggetto ng-change=\"pCopia.sf[\'toSoggetti[]\'] = [];\" required></select></div><label class=\"control-label col-md-2\" title=\"soggetti su cui copiare le schede\">Destinatari</label><div class=\"col-md-2 validate-group has-warning\"><button type=button class=\"form-control btn btn-default\" ng-model=\"pCopia.sf[\'toSoggetti[]\']\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=\"form[name=\'pCopia.searchForm\']\" data-placeholder=Scegli... bs-options=\"el.value as el.label for el in pCopia.filtraSoggetti(pCopia.formData.soggetti)\" required>Destinatari <span class=caret></span></button></div></div><div class=form-group><label class=\"control-label col-md-2\">Fornitore</label><div class=\"col-md-2 validate-group\"><select class=form-control ng-options=\"el.value as el.label for el in pCopia.formData.fornitori\" ng-model=pCopia.sf.fornitore name=fornitore ng-change=\"pCopia.sf[\'prodotti[]\'] = []\"><option value=\"\">TUTTI</option></select></div><label class=\"control-label col-md-2\">Pista</label><div class=\"col-md-2 validate-group\"><select class=form-control ng-options=\"el.value as el.label for el in pCopia.formData.piste | filter:{fornitore: pCopia.sf.fornitore}:true\" ng-model=pCopia.sf.pista name=pista ng-change=\"pCopia.sf[\'prodotti[]\'] = []\"><option value=\"\">TUTTE</option></select></div><label class=\"control-label col-md-2\">Prodotti</label><div class=\"col-md-2 validate-group\"><button type=button class=\"form-control btn btn-default\" ng-model=\"pCopia.sf[\'prodotti[]\']\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=\"form[name=\'pCopia.searchForm\']\" data-placeholder=Scegli... bs-options=\"el.value as el.label for el in pCopia.filtraProdotti(pCopia.formData.prodotti)\">Prodotti <span class=caret></span></button></div></div><div class=form-group><label class=\"control-label col-xs-12 col-sm-2\">Inizio</label><div class=\"col-xs-12 col-sm-2\"><div class=row><div class=col-xs-5><select class=form-control ng-model=pCopia.sf.opInizio><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-7><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCopia.sf.inizio name=inizio bs-datepicker></div></div></div><label class=\"control-label col-xs-3 col-sm-2\">Fine</label><div class=\"col-xs-9 col-sm-2\"><div class=row><div class=col-xs-5><select class=form-control ng-model=pCopia.sf.opFine><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-7><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCopia.sf.fine name=fine bs-datepicker></div></div></div><label class=\"control-label col-sm-2\">Provv. Ricorrente</label><div class=col-sm-2><select class=form-control ng-model=pCopia.sf.pagamento name=pagamento><option value=\"\">Tutti</option><option value=\"una tantum\">Una Tantum</option><option value=ricorrente>Ricorrente</option></select></div></div><div class=form-group><div class=\"col-xs-offset-5 col-xs-2\"><button ng-if=pCopia.enableCopia type=button class=\"form-control btn btn-danger\" title=Esegui ng-click=pCopia.copia()>ESEGUI</button></div><div class=\"col-xs-5 text-right\"><button type=reset class=\"btn btn-warning\" title=Resetta ng-click=pCopia.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></div></div></form><div class=g1-panel ng-if=pCopia.dtSchede.instance><div class=row><div class=\"col-xs-12 table-responsive\"><g1-alerts data-status=200 data-messages=pCopia.messages></g1-alerts><table datatable dt-options=::pCopia.dtSchede.options dt-columns=::pCopia.dtSchede.columns dt-instance=pCopia.dtSchede.instance class=\"table table-hover table-condensed\"></table></div></div></div><div class=g1-panel ng-if=pCopia.dtRisultati.instance><div class=row><div class=\"col-xs-12 table-responsive\"><g1-alerts data-status=200 data-messages=pCopia.messages.info></g1-alerts><g1-alerts data-status=417 data-messages=pCopia.messages.warnings></g1-alerts><h4>Elenco delle schede non copiate per conflitti</h4><table datatable dt-options=::pCopia.dtRisultati.options dt-columns=::pCopia.dtRisultati.columns dt-instance=pCopia.dtRisultati.instance class=\"table table-hover table-condensed\"></table></div></div></div></div>");
$templateCache.put("app/admin/provvigioni/provvigioni-scheda.html","<script type=text/ng-template id=provvigioni-read-modal.tpl.html ng-controller=\"AdminProvvigioniSchedaController as pScheda\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{pScheda.provvigione.id}} - {{pScheda.provvigione.codiceProdotto}} - {{pScheda.provvigione.codiceSoggetto}} - {{pScheda.provvigione.tipoSoggetto}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>{{pScheda.provvigione.tipoSoggetto}}:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              {{pScheda.provvigione.soggetto}}\n              <small class=\"text-muted\">{{pScheda.provvigione.codiceSoggetto}}</small>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Prodotto:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              {{pScheda.provvigione.codiceProdotto}}\n              <small class=\"text-muted\">{{pScheda.provvigione.prodotto}}</small>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Inizio:</label></div>\n            <div class=\"col-xs-2 text-left\">{{pScheda.provvigione.dataInizio | date:\'shortDate\'}}</div>\n\n            <div class=\"col-xs-2 text-right\"><label>Fine:</label></div>\n            <div class=\"col-xs-2 text-left\">{{pScheda.provvigione.dataFine | date:\'shortDate\'}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Calcola:</label></div>\n            <div class=\"col-xs-2 text-left\">\n              {{pScheda.provvigione.percentuale ? \' percentuale\' : \'\'}}\n              {{pScheda.provvigione.valore ? \' valore\' : \'\'}}\n            </div>\n\n            <div class=\"col-xs-8\">\n              <label>Provvigione ricorrente:</label>\n              <span ng-if=\"pScheda.provvigione.ricorrente\">Sì</span>\n              <span ng-if=\"!pScheda.provvigione.ricorrente\">No</span>\n            </div>\n\n            <!-- provvigione percentuale -->\n            <div class=\"col-sm-2 col-xs-6 text-right\" ng-if=\"pScheda.provvigione.percentuale\">\n              <label>Percentuale:</label>\n            </div>\n            <div class=\"col-xs-6 col-sm-10 text-left\" ng-if=\"pScheda.provvigione.percentuale\">\n              <span ng-if=\"!pScheda.provvigione.conScadenza\">\n                {{(pScheda.provvigione.scaPerc * 100) | number:3}}&nbsp;%\n              </span>\n              <div class=\"row\" ng-if=\"pScheda.provvigione.conScadenza\">\n                <div class=\"col-sm-3\">\n                  1&deg; anno: {{(pScheda.provvigione.scaPerc * 100) | number:3}}&nbsp;%\n                </div>\n                <div class=\"col-sm-3\">\n                  Dal 2&deg; anno: {{(pScheda.provvigione.scaPerc2 * 100) | number:3}}&nbsp;%\n                </div>\n              </div>\n            </div>\n\n            <!-- provvigione valore -->\n            <div class=\"col-xs-2 text-right\" ng-if=\"pScheda.provvigione.valore\">\n              <label>Valore:</label>\n            </div>\n            <div class=\"col-xs-4 text-left\" ng-if=\"pScheda.provvigione.valore\">\n              <span ng-if=\"!pScheda.provvigione.conScadenza\">\n                {{pScheda.provvigione.scaVal | currency}}\n              </span>\n              <div class=\"row\" ng-if=\"pScheda.provvigione.conScadenza\">\n                <div class=\"col-sm-3\">\n                  1&deg; anno: {{pScheda.provvigione.scaVal2 | currency}}\n                </div>\n                <div class=\"col-sm-3\">\n                  Dal 2&deg; anno: {{pScheda.provvigione.scaVal2 | currency}}\n                </div>\n              </div>\n            </div>\n\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Note:</label></div>\n            <div class=\"col-xs-10 text-left\">{{pScheda.provvigione.note}}</div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"pScheda.user.userGroup > 4 && pScheda.user.userGroup < 9\">\n                <small>\n                  Inserito:{{pScheda.provvigione.idUtenteIns}} - {{pScheda.provvigione.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{pScheda.provvigione.idUtenteMod}} - {{pScheda.provvigione.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/provvigioni/provvigioni-schede.html","<div ng-include=\"\'app/admin/provvigioni/provvigioni-scheda.html\'\"></div><div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid><div class=page-header><h2><a href=#/provvigioni title=\"Torna a gestione provvigioni\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> Schede Provvigioni</h2></div><form name=pSchede.sf class=form-horizontal ng-submit=pSchede.search() novalidate><div class=row><div class=col-md-6><div class=form-group><div class=row><label class=\"control-label col-md-2\">Soggetto</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-2\"><select class=form-control ng-options=\"el.value as el.label for el in pSchede.searchData.tipiSoggetto\" ng-change=\"pSchede.searchForm[\'soggetti[]\'] = []\" ng-model=pSchede.searchForm.tipoSoggetto name=tipoSoggetto></select></div><div class=\"col-xs-6 col-md-3\"><button type=button class=\"form-control btn btn-default\" ng-model=\"pSchede.searchForm[\'soggetti[]\']\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=\"form[name=\'pSchede.sf\']\" data-placeholder=TUTTI data-placement=bottom-right bs-options=\"el.value as el.label for el in pSchede.filtraSoggetti(pSchede.searchData.soggetti)\">Soggetti <span class=caret></span></button></div></div></div><div class=form-group><div class=row><label class=\"control-label col-md-2\">Inizio</label><div class=col-md-2><select class=form-control ng-model=pSchede.searchForm.opInizio><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-md-2><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pSchede.searchForm.inizio name=inizio bs-datepicker data-placement=bottom-right></div><label class=\"control-label col-md-2\">Fine</label><div class=col-md-2><select class=form-control ng-model=pSchede.searchForm.opFine><option value=\"&lt;=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\"&gt;=\">&gt;&equals;</option></select></div><div class=col-md-2><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pSchede.searchForm.fine name=fine bs-datepicker data-placement=bottom-right></div></div></div><div class=form-group><div class=row><label class=\"control-label col-md-2\">Prodotto</label><div class=col-md-4><input type=text class=form-control ng-model=pSchede.searchForm.prodotto name=prodotto></div><label class=\"control-label col-md-2\">Con scadenza</label><div class=col-md-4><select class=form-control ng-model=pSchede.searchForm.conScadenza name=conScadenza><option value=\"\">Tutti</option><option value=1>CON scadenza</option><option value=0>SENZA scadenza</option></select></div></div></div><div class=form-group><div class=row><label class=\"control-label col-md-2\">Pagamento</label><div class=col-md-4><select class=form-control ng-model=pSchede.searchForm.pagamento name=pagamento><option value=\"\">Tutti</option><option value=\"una tantum\">Una Tantum</option><option value=ricorrente>Ricorrente</option></select></div><label class=\"control-label col-md-2\">Provv. Ricorrente</label><div class=col-md-4><select class=form-control ng-model=pSchede.searchForm.provvigioneRicorrente name=provvigioneRicorrente><option value=\"\">Tutti</option><option value=1>Ricorrente</option><option value=0>NON ricorrente</option></select></div></div></div></div><div class=col-md-6><div class=form-group><label class=\"control-label col-md-2\">Fornitore</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in pSchede.searchData.fornitori | filter:{disabilitato: pSchede.searchData.dFornitori} | orderBy:\'label\'\" ng-model=pSchede.searchForm.fornitore name=fornitore></select></div><div class=\"checkbox col-md-5\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=pSchede.searchData.dFornitori name=dFornitori ng-change=\"pSchede.searchForm.fornitore = \'0\'\"> <b>&nbsp;Disabilitati</b></label></div></div><div class=form-group><label class=\"control-label col-md-2\">Pista</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in pSchede.searchData.piste | filter:{disabilitato: pSchede.searchData.dPiste} | orderBy:\'label\'\" ng-model=pSchede.searchForm.pista name=pista></select></div><div class=\"checkbox col-md-5\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=pSchede.searchData.dPiste name=dPiste ng-change=\"pSchede.searchForm.pista = \'0\'\"> <b>&nbsp;Disabilitati</b></label></div></div></div></div><div class=form-group><div class=\"col-xs-12 text-right\"><button type=button class=\"btn btn-success\" title=\"Nuova Scheda Provvigionale\" ng-click=pSchede.createProvvigione()><i class=\"fa fa-fw fa-plus\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row ng-if=pSchede.searched><div class=\"col-xs-12 col-sm-8\"><form name=pSchede.sdf class=form-inline ng-submit=pSchede.spostaDate() novalidate><div class=form-group><span>Sposta&nbsp;</span><div class=\"validate-group inline-block\"><select class=form-control ng-model=pSchede.searchForm.tipoData name=tipoData required><option value=dataInizio>Data Inizio</option><option value=dataFine>Data Fine</option></select></div><span>&nbsp;A&nbsp;</span><div class=\"validate-group inline-block\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pSchede.searchForm.nuovaData name=nuovaData bs-datepicker data-placement=bottom-right required></div><button type=submit class=\"btn btn-danger\">Esegui</button></div></form></div><div class=\"col-xs-12 col-sm-4 text-center\"><button type=button class=\"btn btn-danger\" ng-click=pSchede.cancella()>Cancella Schede</button></div></div><div class=row ng-if=pSchede.searched><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::pSchede.dt.options dt-columns=::pSchede.dt.columns dt-instance=pSchede.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=provvigioni-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <form name=\"pSchede.editForm\" class=\"form-horizontal\" ng-submit=\"pSchede.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{pSchede.provvigione.id || \'Nuova scheda provvigionale\'}}\n                <span ng-if=\"pSchede.provvigione.codiceProdotto\">- {{pSchede.provvigione.codiceProdotto}}</span>\n                <span ng-if=\"pSchede.provvigione.codiceSoggetto\">- {{pSchede.provvigione.codiceSoggetto}}</span>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-3 col-md-2\">Prodotto</label>\n\n              <div class=\"col-sm-4 col-md-5\">\n                <input type=\"text\" class=\"form-control\"\n                  bs-typeahead bs-options=\"el.value as el.value for el in pSchede.formData.prodotti\"\n                  ng-model=\"pSchede.provvigione.codiceProdotto\" name=\"codiceProdotto\"\n                  ng-change=\"pSchede.codiceProdottoChange()\"\n                  required>\n              </div>\n\n              <div class=\"col-sm-5\">\n                <p class=\"form-control-static\">{{pSchede.provvigione.codiceProdotto ? (pSchede.formData.prodotti | filter:{value: pSchede.provvigione.codiceProdotto}:true)[0].prodotto : \'\'}}</p>\n              </div>\n\n              <div class=\"col-md-10 col-md-offset-2\" ng-if=\"pSchede.provvigione.conScadenza==1\">\n                <div class=\"alert alert-warning margin-top\">\n                  Prodotto con scadenza: è possibile impostare una provvigione ricorrente.\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"form-group\" style=\"margin-bottom: 0\">\n              <label class=\"control-label col-sm-3 col-md-2\">Soggetto</label>\n\n              <div class=\"col-sm-4 col-md-5\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in pSchede.formData.tipiSoggetto\"\n                  ng-change=\"pSchede.provvigione.idAgente = (pSchede.formData.soggetti | filter:{tipoSoggetto: pSchede.provvigione.tipoSoggetto}:true)[0].value\"\n                  ng-model=\"pSchede.provvigione.tipoSoggetto\" name=\"tipoSoggetto\">\n                </select>\n                <span class=\"help-block\">Tipo</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in pSchede.formData.soggetti | filter:{tipoSoggetto: pSchede.provvigione.tipoSoggetto}:true\"\n                  ng-model=\"pSchede.provvigione.idAgente\" name=\"idAgente\"\n                  ng-change=\"pSchede.provvigione.codiceSoggetto = (pSchede.formData.soggetti | filter:{value: pSchede.provvigione.idAgente}:true)[0].codiceSoggetto\"\n                  required>\n                </select>\n                <span class=\"help-block\">{{pSchede.provvigione.tipoSoggetto}}</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\" style=\"margin-bottom: 0\">\n              <label class=\"control-label col-sm-3 col-md-2\">Date</label>\n\n              <div class=\"col-sm-4 col-md-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"pSchede.provvigione.dataInizio\" name=\"dataInizio\"\n                  bs-datepicker\n                  required>\n                <span class=\"help-block\">Inizio</span>\n              </div>\n              <div class=\"col-sm-offset-1 col-sm-4 col-md-offset-0 col-md-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"pSchede.provvigione.dataFine\" name=\"dataFine\"\n                  bs-datepicker\n                  required>\n                <span class=\"help-block\">Fine</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-6 col-sm-offset-3 col-sm-2 col-md-offset-2\">\n                <label>\n                  <input type=\"radio\" ng-value=\"true\"\n                    ng-model=\"pSchede.provvigione.percentuale\" name=\"opzioneCalcolo\"\n                    ng-change=\"pSchede.setOpzioneCalcolo(\'percentuale\')\">&nbsp;Percentuale\n                </label>\n              </div>\n              <div class=\"col-xs-6 col-sm-2\">\n                <label>\n                  <input type=\"radio\" ng-value=\"true\"\n                    ng-model=\"pSchede.provvigione.valore\" name=\"opzioneCalcolo\"\n                    ng-change=\"pSchede.setOpzioneCalcolo(\'valore\')\">&nbsp;Valore\n                </label>\n              </div>\n\n              <div class=\"col-sm-5 col-sm-offset-1\">\n                <label>\n                  <input\n                    type=\"checkbox\"\n                    ng-model=\"pSchede.provvigione.ricorrente\"\n                    name=\"ricorrente\"\n                    ng-disabled=\"!pSchede.provvigione.conScadenza\">\n                  Ricorrente\n                </label>\n              </div>\n\n            </div>\n\n            <!-- provvigione percentuale -->\n            <div ng-if=\"pSchede.provvigione.percentuale\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-3 col-md-2\">Percentuale</label>\n\n                <div class=\"col-sm-4 col-md-5 validate-group has-warning\">\n                  <div class=\"input-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"pSchede.provvigione.scaPerc\" name=\"scaPerc\"\n                      percent precision=\"1\" step=\"1\" min=\"0\" max=\"100\"\n                      required>\n                    <span class=\"input-group-addon\">%</span>\n                  </div>\n                  <span class=\"help-block\" ng-if=\"pSchede.provvigione.conScadenza==1\">Per il primo anno</span>\n                </div>\n\n                <div class=\"col-sm-4 col-md-5 validate-group has-warning\"\n                  ng-if=\"pSchede.provvigione.conScadenza==1\">\n                  <div class=\"input-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"pSchede.provvigione.scaPerc2\" name=\"scaPerc2\"\n                      ng-disabled=\"!pSchede.provvigione.ricorrente\"\n                      percent precision=\"1\" step=\"1\"\n                      ng-required=\"pSchede.provvigione.ricorrente\">\n                    <span class=\"input-group-addon\">%</span>\n                  </div>\n                  <span class=\"help-block\">Dal secondo anno in poi</span>\n                </div>\n\n              </div>\n            </div>\n\n            <!-- provvigione valore -->\n            <div ng-if=\"pSchede.provvigione.valore\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-3 col-md-2\">Valore</label>\n\n                <div class=\"col-sm-4 col-md-5 validate-group has-warning\">\n                  <div class=\"input-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"pSchede.provvigione.scaVal\" name=\"scaVal\"\n                      decimal step=\"0.01\" max=\"999999\" required>\n                    <span class=\"input-group-addon\">&euro;</span>\n                  </div>\n                  <span class=\"help-block\" ng-if=\"pSchede.provvigione.conScadenza==1\">Per il primo anno</span>\n                </div>\n\n                <div class=\"col-sm-4 col-md-5 validate-group has-warning\">\n                  <div class=\"input-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"pSchede.provvigione.scaVal2\" name=\"scaVal2\"\n                      decimal step=\"0.01\" max=\"999999\" ng-required=\"pSchede.provvigione.ricorrente\">\n                    <span class=\"input-group-addon\">&euro;</span>\n                  </div>\n                  <span class=\"help-block\">Dal secondo anno in poi</span>\n                </div>\n\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3 col-md-2\">Note</label>\n              <div class=\"col-sm-9 col-md-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"pSchede.provvigione.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{pSchede.alerts.status}}\" data-messages=\"pSchede.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/home/home.html","<div class=container-fluid><div class=row><div class=col-xs-12>Home Admin</div></div></div>");
$templateCache.put("app/admin/tabelle/portafogli.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminPortafogliController as tabella\"><div class=row><div class=col-xs-12><h2>Portafogli</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed table-responsive\"><tfoot><tr><th></th><th title=\"Evidenzia in agenda\">Evid. Ag.</th><th>Obsoleto</th><th></th><th>Tipo</th><th></th><th></th></tr></tfoot></table></div></div></div><!-- modal edit --><script type=text/ng-template id=portafogli-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.portafoglio.id || \'0\'}} - {{tabella.portafoglio.descrizione || \'Nuovo Portafoglio\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.portafoglio.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.tipi\"\n                        ng-model=\"tabella.portafoglio.idTipoPortafoglio\" name=\"idTipoPortafoglio\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.portafoglio.evidenziaAgenda\" name=\"evidenziaAgenda\">\n                  Evidenzia in agenda\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.portafoglio.obsoleto\" name=\"obsoleto\">\n                  Obsoleto\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.portafoglio.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/prodotti.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminProdottiController as tabella\"><div class=row><div class=col-xs-12><h2>Prodotti</h2></div></div><form role=form name=search_prodotti class=form-horizontal ng-submit=tabella.searchForm()><div class=row><div class=col-md-6><div class=form-group><label class=\"control-label col-sm-2\" title=descrizione/codice>Descrizione</label><div class=col-sm-10><input type=text class=form-control ng-model=tabella.sp.descrizione name=descrizione></div></div><div class=form-group><label class=\"control-label col-xs-12 col-sm-2\">Prezzo</label><div class=\"col-xs-5 col-sm-3\"><select class=form-control ng-model=tabella.sp.opPrezzo><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=\"col-xs-offset-1 col-xs-6 col-sm-offset-1 col-sm-3\"><input type=number class=form-control ng-model=tabella.sp.prezzo name=prezzo step=0 min=0></div></div><div class=form-group><label class=\"control-label col-sm-2\">Disabilitato</label><div class=col-sm-3><select class=form-control ng-model=tabella.sp.disabilitato name=disabilitato><option value=\"\">Tutti</option><option value=0>No</option><option value=1>Si</option></select></div></div><div class=form-group><label class=\"control-label col-sm-2\" title=\"non visibile agli agenti\">N.V.A.</label><div class=col-sm-3><select class=form-control ng-model=tabella.sp.invisibileAgenti name=invisibileAgenti><option value=\"\">Tutti</option><option value=0>Visibile</option><option value=1>Non visibile</option></select></div></div><div class=form-group><label class=\"control-label col-sm-2\" title=\"Con Scadenza\">Con Scadenza</label><div class=col-sm-3><select class=form-control ng-model=tabella.sp.conScadenza name=conScadenza><option value=\"\">Tutti</option><option value=1>CON scadenza</option><option value=0>SENZA scadenza</option></select></div></div><div class=form-group><label class=\"control-label col-sm-2\">Pagamento</label><div class=col-sm-3><select class=form-control ng-model=tabella.sp.pagamento name=pagamento><option value=\"\">Tutti</option><option value=\"una tantum\">Una Tantum</option><option value=ricorrente>Ricorrente</option></select></div></div></div><div class=col-md-6><div class=form-group><label class=\"control-label col-sm-2\">Fornitore</label><div class=col-sm-6><select class=form-control ng-options=\"el.value as el.label for el in tabella.formData.fornitori\n                | filter:{disabilitato: tabella.sp.dFornitori}\n                | orderBy:\'label\'\" ng-model=tabella.sp.fornitore name=fornitore><option value=\"\">TUTTI</option></select></div><div class=\"checkbox col-sm-4\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=tabella.sp.dFornitori name=dFornitori ng-change=\"tabella.sp.fornitore = \'\'\"> <b>&nbsp;Disabilitati</b></label></div></div><div class=form-group><label class=\"control-label col-sm-2\">Pista</label><div class=col-sm-6><select class=form-control ng-options=\"el.value as el.label for el in tabella.formData.piste\n                | filter:{disabilitato: tabella.sp.dPiste}\n                | filter:{fornitore: tabella.sp.fornitore}:true\n                | orderBy:\'label\'\" ng-model=tabella.sp.pista name=pista><option value=\"\">TUTTE</option></select></div><div class=\"checkbox col-sm-4\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=tabella.sp.dPiste name=dPiste ng-change=\"tabella.sp.pista = \'\'\"> <strong>&nbsp;Disabilitati</strong></label></div></div><div class=form-group><label class=\"control-label col-sm-2\">Sottopista</label><div class=col-sm-6><select class=form-control ng-options=\"el.value as el.label for el in tabella.formData.sottopiste\n                | filter:{disabilitato: tabella.sp.dSottopiste}\n                | filter:{fornitore: tabella.sp.fornitore, pista: tabella.sp.pista}:true\n                | orderBy:\'label\'\" ng-model=tabella.sp.sottopista name=sottopista><option value=\"\">TUTTE</option></select></div><div class=\"checkbox col-sm-4\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=tabella.sp.dSottopiste name=dSottopiste ng-change=\"tabella.sp.sottopista = \'\'\"> <strong>&nbsp;Disabilitati</strong></label></div></div><div class=form-group><label class=\"control-label col-sm-2\">Gruppo</label><div class=col-sm-6><select class=form-control ng-options=\"el.value as el.label for el in tabella.filtraGruppi(tabella.formData.gruppi, tabella.sp.fornitore, tabella.sp.pista)\n                | filter:{disabilitato: tabella.sp.dGruppi}\" ng-model=tabella.sp.gruppo name=gruppo><option value=\"\">TUTTI</option></select></div><div class=\"checkbox col-sm-4\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=tabella.sp.dGruppi name=dGruppi ng-change=\"tabella.sp.gruppo = \'\'\"> <strong>&nbsp;Disabilitati</strong></label></div></div></div></div><div class=row><div class=\"col-xs-12 text-right\"><button type=button class=\"btn btn-success\" title=\"Nuovo Prodotto\" ng-click=tabella.createProdotto()><i class=\"fa fa-fw fa-plus\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=reset class=\"btn btn-warning\" title=Resetta ng-click=tabella.resetSF()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row ng-if=tabella.dt.instance><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=prodotti-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.prodotto.id || \'0\'}} - {{tabella.prodotto.codice || \'Nuovo Prodotto\'}}{{tabella.prodotto.descrizione ? \' - \' + tabella.prodotto.descrizione : \'\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Codice</label>\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"tabella.prodotto.codice\" name=\"codice\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"tabella.prodotto.descrizione\" name=\"descrizione\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Descrizione Estesa</label>\n              <div class=\"col-sm-6\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"tabella.prodotto.descrizioneEstesa\" name=\"descrizioneEstesa\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Fornitore</label>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Fornitore...\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-options=\"el.value as el.label for el in tabella.formData.fornitori | filter:{disabilitato: \'0\'}:true | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.fornitore\" name=\"fornitore\">\n              </div>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in tabella.formData.fornitori | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.fornitore\" name=\"fornitore\">\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Gruppo</label>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Gruppo...\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-options=\"el.value as el.label for el in tabella.formData.gruppi | filter:{disabilitato: \'0\'}:true | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.gruppo\" name=\"gruppo\">\n              </div>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in tabella.formData.gruppi | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.gruppo\" name=\"gruppo\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Pista</label>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Pista...\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-options=\"el.value as el.label for el in tabella.formData.piste | filter:{disabilitato: \'0\'}:true | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.pista\" name=\"pista\">\n              </div>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in tabella.formData.piste | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.pista\" name=\"pista\">\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Sottopista</label>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Sottopista...\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-options=\"el.value as el.label for el in tabella.formData.sottopiste | filter:{disabilitato: \'0\'}:true | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.sottopista\" name=\"sottopista\">\n              </div>\n              <div class=\"col-sm-4\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in tabella.formData.sottopiste | orderBy:\'label\'\"\n                  ng-model=\"tabella.prodotto.sottopista\" name=\"sottopista\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Prezzo</label>\n              <div class=\"col-sm-4\">\n                <input type=\"number\" class=\"form-control\"\n                  ng-model=\"tabella.prodotto.prezzo\" name=\"prezzo\"\n                  min=\"0\" step=\"any\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-4 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                    ng-model=\"tabella.prodotto.conScadenza\" name=\"conScadenza\">\n                  Con scadenza\n                </label>\n              </div>\n              <label class=\"control-label col-sm-2\">Durata contratto</label>\n              <div class=\"col-sm-4\">\n                <div class=\"input-group\">\n                  <input type=\"number\" class=\"form-control\"\n                    ng-model=\"tabella.prodotto.durataContratto\" name=\"durataContratto\"\n                    ng-disabled=\"!tabella.prodotto.conScadenza\"\n                    min=\"0\" max=\"120\" step=\"1\">\n                  <span class=\"input-group-addon\">mesi (0 = infinito)</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Pagamento</label>\n              <div class=\"col-sm-4\">\n                <select class=\"form-control\"\n                  ng-model=\"tabella.prodotto.pagamento\" name=\"pagamento\" required>\n                  <option value=\"\">Scegli il pagamento</option>\n                  <option value=\"una tantum\">Una Tantum</option>\n                  <option value=\"ricorrente\">Ricorrente</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                    ng-model=\"tabella.prodotto.disabilitato\" name=\"disabilitato\">\n                  Disabilitato\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                    ng-model=\"tabella.prodotto.invisibileAgenti\" name=\"invisibileAgenti\">\n                  Non visibile dagli agenti\n                </label>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script><script type=text/ng-template id=prodotti-read-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.prodotto.id}} - {{tabella.prodotto.codice}}{{tabella.prodotto.descrizione ? \' - \' + tabella.prodotto.descrizione : \'\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <span class=\"text-right col-sm-2\">Codice</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.codice}}\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <span class=\"text-right col-sm-2\">Descrizione</span>\n              <div class=\"col-sm-6\">\n                {{tabella.prodotto.descrizione}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <span class=\"text-right col-sm-2\">Descrizione Estesa</span>\n              <div class=\"col-sm-6\">\n                {{tabella.prodotto.descrizioneEstesa}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <span class=\"text-right col-sm-2\">Fornitore</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.fornitore}}\n              </div>\n\n              <span class=\"text-right col-sm-2\">Gruppo</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.gruppo}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <span class=\"text-right col-sm-2\">Pista</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.pista}}\n              </div>\n\n              <span class=\"text-right col-sm-2\">Sottopista</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.sottopista}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <span class=\"text-right col-sm-2\">Prezzo</span>\n              <div class=\"col-sm-4\">\n                {{tabella.prodotto.prezzo}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-4\">\n                <i class=\"fa fa-square-o\" ng-if=\"!tabella.prodotto.conScadenza\"></i>\n                <i class=\"fa fa-check-square\" ng-if=\"tabella.prodotto.conScadenza\"></i>\n                Con scadenza\n                <span nog-if=\"tabella.prodotto.conScadenza&&(tabella.prodotto.durataContratto>0)\">\n                  ({{tabella.prodotto.durataContratto}} mesi)\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10\">\n                {{tabella.prodotto.pagamento}}\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10\">\n                <i class=\"fa fa-square-o\" ng-if=\"!tabella.prodotto.disabilitato\"></i>\n                <i class=\"fa fa-check-square\" ng-if=\"tabella.prodotto.disabilitato\"></i>\n                Disabilitato\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10\">\n                <i class=\"fa fa-square-o\" ng-if=\"!tabella.prodotto.invisibileAgenti\"></i>\n                <i class=\"fa fa-check-square\" ng-if=\"tabella.prodotto.invisibileAgenti\"></i>\n                Non visibile dagli agenti\n              </div>\n            </div>\n\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/squadre.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminSquadreController as tabella\"><div class=row><div class=col-xs-12><h2>Squadre</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed table-responsive\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=squadra-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.squadra.id || \'0\'}} - {{tabella.squadra.descrizione || \'Nuova Squadra\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.squadra.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/stati-appuntamento.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminStatiAppuntamentoController as tabella\"><div class=row><div class=col-xs-12><h2>Stati Appuntamento</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed\"><tfoot><tr><th></th><th>Obsoleto</th><th>Descrizione</th><th></th><th>Tipo</th><th></th><th></th><th></th><th></th></tr></tfoot></table></div></div></div><!-- modal edit --><script type=text/ng-template id=stati-appuntamento-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.statoAppuntamento.id || \'0\'}} - {{tabella.statoAppuntamento.descrizione || \'Nuovo Stato Appuntamento\'}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoAppuntamento.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione Supplementare</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoAppuntamento.descrizioneSupplementare\" name=\"descrizioneSupplementare\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.tipi\"\n                        ng-model=\"tabella.statoAppuntamento.tipo\" name=\"tipo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Colore</label>\n\n              <div class=\"col-xs-4 col-sm-3 text-center\">\n                <div class=\"input-group\">\n                  <input type=\"color\" class=\"form-control\"\n                         ng-model=\"tabella.statoAppuntamento.colore1\" name=\"colore1\">\n\n                  <span class=\"input-group-addon\" title=\"Resetta colore 1\" ng-click=\"tabella.statoAppuntamento.colore1 = \'\'\">\n                    <i class=\"fa fa-fw fa-undo\"></i>\n                  </span>\n                </div>\n\n                <span class=\"help-block\" ng-class=\"{\n                  \'bg-danger\': !tabella.statoAppuntamento.colore1\n                }\">Primario</span>\n              </div>\n\n              <div class=\"col-xs-4 col-sm-3 text-center\">\n                <div class=\"input-group\">\n                  <input type=\"color\" class=\"form-control\"\n                         ng-model=\"tabella.statoAppuntamento.colore2\" name=\"colore2\">\n\n                  <span class=\"input-group-addon\" title=\"Resetta colore 2\" ng-click=\"tabella.statoAppuntamento.colore2 = \'\'\">\n                    <i class=\"fa fa-fw fa-undo\"></i>\n                  </span>\n                </div>\n\n                <span class=\"help-block\" ng-class=\"{\n                  \'bg-danger\': !tabella.statoAppuntamento.colore2\n                }\">Secondario</span>\n              </div>\n\n              <div class=\"col-xs-2 text-center\">\n                <i class=\"fa fa-2x fa-info-circle text-primary\" title=\"Informazioni\"\n                   data-content=\"Il colore primario viene usato per il pallino nella vista mese dell\'agenda<br><br>il colore secondario viene usato per lo sfondo dell\'evento in vista settimana e/o giorno.<br><br>Se evidenziato in rosso il colore non è impostato.<br><br>l\'agenda per funzionare correttamente necessita di entrambi i colori.\"\n                   data-placement=\"bottom\" data-container=\".modal-body\" data-auto-close=\"true\"\n                   bs-popover></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.statoAppuntamento.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-4 col-sm-2\">Obsoleto</label>\n              <div class=\"col-xs-8 col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoAppuntamento.obsoleto\" name=\"obsoleto\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/stati-contratto.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminStatiContrattoController as tabella\"><div class=row><div class=col-xs-12><h2>Stati Contratto</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=stati-contratto-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.statoContratto.id || \'0\'}} - {{tabella.statoContratto.descrizione || \'Nuovo Stato Contratto\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoContratto.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione Supplementare</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoContratto.descrizioneSupplementare\" name=\"descrizioneSupplementare\"\n                       required>\n                <span class=\"help-block\">Usato in report dettaglio backlog</span>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.tipi\"\n                        ng-model=\"tabella.statoContratto.tipo\" name=\"tipo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Priorità</label>\n              <div class=\"col-sm-2\">\n                <input type=\"number\" class=\"form-control\"\n                       ng-model=\"tabella.statoContratto.priorita\" name=\"priorita\"\n                       min=\"1\" required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Gruppo</label>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Gruppo...\"\n                       bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                       bs-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                       ng-model=\"tabella.statoContratto.gruppo\" name=\"gruppo\"\n                       required>\n              </div>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                        ng-model=\"tabella.statoContratto.gruppo\" name=\"gruppo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Libero</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoContratto.libero\" name=\"libero\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.statoContratto.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-5 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoContratto.realizzativo\" name=\"realizzativo\">\n                  &nbsp;Realizzativo\n                </label>\n              </div>\n\n              <div class=\"col-sm-5 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoContratto.postvendita\" name=\"postvendita\">\n                  &nbsp;Postvendita\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Obsoleto</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoContratto.obsoleto\" name=\"obsoleto\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/stati-elenco.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminStatiElencoController as tabella\"><div class=row><div class=col-xs-12><h2>Stati Elenco</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=stati-elenco-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.statoElenco.id || \'0\'}} - {{tabella.statoElenco.descrizione || \'Nuovo Stato Elenco\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoElenco.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione Supplementare</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoElenco.descrizioneSupplementare\" name=\"descrizioneSupplementare\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.tipi\"\n                        ng-model=\"tabella.statoElenco.tipo\" name=\"tipo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Gruppo</label>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Gruppo...\"\n                       bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                       bs-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                       ng-model=\"tabella.statoElenco.gruppo\" name=\"gruppo\"\n                       required>\n              </div>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                        ng-model=\"tabella.statoElenco.gruppo\" name=\"gruppo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Libero</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoElenco.libero\" name=\"libero\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.statoElenco.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Obsoleto</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoElenco.obsoleto\" name=\"obsoleto\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/stati-telefonata.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminStatiTelefonataController as tabella\"><div class=row><div class=col-xs-12><h2>Stati Telefonata</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed table-responsive\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=stati-telefonata-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.statoTelefonata.id || \'0\'}} - {{tabella.statoTelefonata.descrizione || \'Nuovo Stato Telefonata\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoTelefonata.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione Supplementare</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoTelefonata.descrizioneSupplementare\" name=\"descrizioneSupplementare\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.tipi\"\n                        ng-model=\"tabella.statoTelefonata.tipo\" name=\"tipo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Stato Elenco</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.statiElenco\"\n                        ng-model=\"tabella.statoTelefonata.idStatoElenco\" name=\"idStatoElenco\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Priorità</label>\n              <div class=\"col-sm-2\">\n                <input type=\"number\" class=\"form-control\"\n                       ng-model=\"tabella.statoTelefonata.priorita\" name=\"priorita\"\n                       min=\"1\" required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatto utile</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoTelefonata.contattoUtile\" name=\"contattoUtile\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Gruppo</label>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'create\'\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Seleziona Gruppo...\"\n                       bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                       bs-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                       ng-model=\"tabella.statoTelefonata.gruppo\" name=\"gruppo\">\n              </div>\n              <div class=\"col-sm-10\" ng-if=\"tabella.action === \'update\'\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tabella.formData.gruppi\"\n                        ng-model=\"tabella.statoTelefonata.gruppo\" name=\"gruppo\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Libero</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.statoTelefonata.libero\" name=\"libero\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.statoTelefonata.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Obsoleto</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.statoTelefonata.obsoleto\" name=\"obsoleto\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/tabelle/tabelle.html","<div class=container-fluid><div class=row><div class=col-xs-12><div class=list-group><a class=list-group-item ng-repeat=\"tabella in tabelle.tabelle\" ng-href=#/admin/tabelle/{{tabella.codice}}><b>{{tabella.descrizione}}</b></a></div></div></div></div>");
$templateCache.put("app/admin/tabelle/tipi-portafoglio.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div class=container-fluid ng-controller=\"AdminTipiPortafoglioController as tabella\"><div class=row><div class=col-xs-12><h2>Tipi Portafoglio</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::tabella.dt.options dt-columns=::tabella.dt.columns dt-instance=tabella.dt.instance class=\"table table-hover table-condensed table-responsive\"></table></div></div></div><!-- modal edit --><script type=text/ng-template id=tipi-portafoglio-edit-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"tabella.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"tabella.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tabella.tipoPortafoglio.id || \'0\'}} - {{tabella.tipoPortafoglio.descrizione || \'Nuovo Tipo Portafoglio\'}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"tabella.tipoPortafoglio.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\" title=\"Numero Portafoglio\">Num.Port.</label>\n              <div class=\"col-sm-2\">\n                <input type=\"number\" class=\"form-control\"\n                       ng-model=\"tabella.tipoPortafoglio.nPort\" name=\"nPort\"\n                       min=\"1\" required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Attivo</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"tabella.tipoPortafoglio.attivo\" name=\"attivo\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"tabella.tipoPortafoglio.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{tabella.alerts.status}}\" data-messages=\"tabella.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/agenti/appuntamenti/appuntamento-edit-agente.html","<script type=text/ng-template id=appuntamento-edit-agente-modal.tpl.html ng-controller=\"AppuntamentoEditAgenteController as aeac\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoEditAgenteForm\" class=\"form-horizontal dataForm\" ng-submit=\"aeac.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{aeac.appuntamento.id ? \'\' : \'Nuovo Appuntamento\'}} {{aeac.appuntamento.data | date:\'shortDate\'}} {{aeac.appuntamento.ora | date:\'shortTime\'}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                {{aeac.appuntamento.cliente}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Orario</label>\n              <div class=\"clearfix visible-xs-block\"></div>\n\n              <div class=\"col-xs-5 col-sm-4 col-md-3 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"aeac.appuntamento.data\" name=\"data\"\n                       bs-datepicker\n                       required>\n                <span class=\"help-block\">Data</span>\n              </div>\n\n              <div class=\"col-xs-5 col-sm-3 col-md-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"hh:mm\"\n                       ng-model=\"aeac.appuntamento.ora\" name=\"ora\"\n                       bs-timepicker\n                       required>\n                <span class=\"help-block\">Ora</span>\n              </div>\n\n              <div class=\"col-xs-2\">\n                <button type=\"button\" class=\"btn btn-info\" title=\"Controlla Distanze\" ng-click=\"aeac.checkDistances(aeac.appuntamento)\">\n                  <i class=\"fa fa-map-signs\" style=\"font-size: 1.5em\"></i>\n                </button>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-7 col-md-5\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"aeac.appuntamento.noteOperatore\" name=\"noteOperatore\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Indirizzo</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.indirizzo\" name=\"indirizzo\">\n                <span class=\"help-block\">Via</span>\n              </div>\n\n              <div class=\"col-sm-offset-2 col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.cap\" name=\"cap\">\n                <span class=\"help-block\">CAP</span>\n              </div>\n\n              <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\"\n                       bs-typeahead bs-options=\"el.value as el.value for el in aeac.formData.citta\"\n                       ng-model=\"aeac.appuntamento.citta\" name=\"citta\">\n                <span class=\"help-block\">Citt&agrave;</span>\n              </div>\n\n              <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.prov\" name=\"prov\">\n                <span class=\"help-block\">Prov.</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatti</label>\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.tel\" name=\"tel\">\n                <span class=\"help-block\">Telefono</span>\n              </div>\n\n              <div class=\"col-sm-4 validate-group\">\n                <input type=\"email\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.email\" name=\"email\">\n                <span class=\"help-block\">Email</span>\n              </div>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aeac.appuntamento.cell\" name=\"cell\">\n                <span class=\"help-block\">Cellulare</span>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"aeac.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{aeac.alerts.status}}\" data-messages=\"aeac.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/agenti/appuntamenti/appuntamento-esita.html","<script type=text/ng-template id=appuntamento-esita-modal.tpl.html ng-controller=\"AppuntamentoEsitaController as aec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoEsitaForm\" class=\"form-horizontal dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{aec.appuntamento.data | date:\'shortDate\'}}&nbsp;{{aec.appuntamento.ora | date:\'shortTime\'}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{aec.appuntamento.cliente}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{(aec.formData.stati | filter:{value: aec.appuntamento.idStatoAppuntamento}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note Operatore</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\" readonly>\n                  {{aec.appuntamento.noteOperatore}}\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\" ng-if=\"aec.checkStatoAppuntamento()\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in aec.formData.stati\"\n                        ng-model=\"aec.appuntamento.idStatoAppuntamento\" name=\"idStatoAppuntamento\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <!-- Se lo stato NON È rifissare -->\n            <div class=\"form-group has-warning\" ng-if=\"aec.appuntamento.idStatoAppuntamento != 106\">\n              <label class=\"control-label col-sm-2\">Note Agente</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"aec.appuntamento.noteAgente\" name=\"noteAgente\"\n                          required>\n                </textarea>\n              </div>\n            </div>\n\n            <!-- Se lo stato È rifissare -->\n            <span ng-if=\"aec.appuntamento.idStatoAppuntamento == 106\">\n              <div class=\"form-group has-warning\">\n                <label class=\"control-label col-sm-2\">Data Richiamo</label>\n                <div class=\"col-sm-5\">\n                  <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                         ng-model=\"aec.appuntamento.dataRichiamo\" name=\"dataRichiamo\"\n                         bs-datepicker\n                         required>\n                </div>\n              </div>\n\n              <div class=\"form-group has-warning\">\n                <label class=\"control-label col-sm-2\">Note Richiamo</label>\n                <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"aec.appuntamento.noteRichiamo\" name=\"noteRichiamo\"\n                            required>\n                  </textarea>\n                </div>\n              </div>\n            </span>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\" ng-if=\"aec.appuntamento.idStatoAppuntamento != \'104\'\">Salva</button>\n            <button type=\"submit\" class=\"btn btn-success\" ng-if=\"aec.appuntamento.idStatoAppuntamento == \'104\'\">Avanti</button> <!-- se stato POSITIVO vai all\'inserimento contratti -->\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"aec.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/agenti/appuntamenti/appuntamento-update-contatti.html","<script type=text/ng-template id=appuntamento-update-contatti-modal.tpl.html ng-controller=\"AppuntamentoUpdateContattiController as aucc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoUpdateContattiForm\" class=\"form-horizontal dataForm\" ng-submit=\"aucc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title\">\n              <div class=\"row\">\n                <div class=\"col-xs-6 text-left\">\n                  <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                  {{aucc.appuntamento.id}}\n                </div>\n\n                <div class=\"col-xs-6 text-right\">\n                  {{aucc.appuntamento.data | date:\'shortDate\'}} {{aucc.appuntamento.ora | date:\'shortTime\'}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-12 text-center\">\n                  {{aucc.appuntamento.cliente}}\n                </div>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-3\">Telefono</label>\n              <div class=\"col-xs-9\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aucc.appuntamento.tel\" name=\"tel\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-3\">Email</label>\n              <div class=\"col-xs-9\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aucc.appuntamento.email\" name=\"email\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-3\">Cellulare</label>\n              <div class=\"col-xs-9 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aucc.appuntamento.cell\" name=\"cell\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/agenti/clienti/cliente-agente.html","<script type=text/ng-template id=cliente-agente-modal.tpl.html ng-controller=\"ClienteAgenteController as cliente\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12 col-sm-6 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{cliente.cliente.id}} - {{cliente.cliente.ragSoc}}\n            </div>\n            <div class=\"col-xs-12 col-sm-6 text-right\">\n              {{cliente.cliente.agenteCognome}}&nbsp;{{cliente.cliente.agenteNome}}&nbsp;\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-4 text-left text-primary\" title=\"Cluster\"><h5>{{cliente.cliente.ptf}}</h5></div>\n            <div class=\"col-xs-4 text-center text-primary\" title=\"Cross\"><h5>{{cliente.cliente.ptfMob}}</h5></div>\n            <div class=\"col-xs-4 text-right text-primary\" title=\"Segmento\"><h5>{{cliente.cliente.ptfSa}}</h5></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Codice fiscale:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\"><span>{{cliente.cliente.cf}}</span></div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Partita Iva:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\"><span>{{cliente.cliente.piva}}</span></div>\n              </div>\n              <div ng-if=\"cliente.referenti[0]\">\n                <div class=\"row\">\n                  <div class=\"col-xs-2 col-md-4 text-right\"><label>Referente principale:</label></div>\n                  <div class=\"col-xs-10 col-md-8 text-left\">\n                    {{cliente.referenti[0].nominativo}}\n                    <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"cliente.showElencoReferenti = !cliente.showElencoReferenti\"><i class=\"fa fa-wrench\"></i></button>\n                  </div>\n                  <div ng-if=\"cliente.referenti[0].tel\" class=\"col-xs-2 col-md-4 text-right\"><label>Tel:</label></div>\n                  <div ng-if=\"cliente.referenti[0].tel\" class=\"col-xs-10 col-md-8 text-left\">\n                    <a href=\"tel:{{cliente.referenti[0].tel}}\">{{cliente.referenti[0].tel}} <i class=\"fa fa-phone\"></i></a>\n                  </div>\n                  <div ng-if=\"cliente.referenti[0].cell\" class=\"col-xs-2 col-md-4 text-right\"><label>Tel:</label></div>\n                  <div ng-if=\"cliente.referenti[0].cell\" class=\"col-xs-10 col-md-8 text-left\">\n                    <a href=\"tel:{{cliente.referenti[0].cell}}\">{{cliente.referenti[0].cell}} <i class=\"fa fa-phone\"></i></a>\n                  </div>\n                  <div class=\"col-xs-2 col-md-4 text-right\"><label>Email:</label></div>\n                  <div class=\"col-xs-10 col-md-8 text-left\" ng-class=\"cliente.referenti[0].privacyEmail ? \'text-danger\' : \'text-success\'\">\n                    <span ng-attr-title=\"{{cliente.referenti[0].privacyEmail ? \'non accetta mail per privacy\' : \'\'}}\">{{cliente.referenti[0].email}}</span>\n                    <a ng-if=\"cliente.referenti[0].email\"\n                      ng-href=\"mailto:{{cliente.referenti[0].email}}\" target=\"_blank\" title=\"Invia mail\">\n                      <i class=\"fa fa-envelope fa-fw\" style=\"font-size: 1.2em\"></i>\n                    </a>\n                  </div>\n                </div>\n              </div>\n              <div ng-if=\"! cliente.referenti[0]\">\n                <div class=\"row\">\n                  <div class=\"col-xs-2 col-md-4 text-right\"><label>Referenti</label></div>\n                  <div class=\"col-xs-10 col-md-8 text-left\">\n                    <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"cliente.showElencoReferenti = !cliente.showElencoReferenti\"><i class=\"fa fa-wrench\"></i></button>\n                  </div>\n                </div>\n              </div>\n              <div ng-show=\"cliente.showElencoReferenti\">\n                <table id=\"cliente_referenti\" datatable\n                  dt-options=\"::cliente.dtReferenti.dtOptions\"\n                  dt-columns=\"::cliente.dtReferenti.dtColumns\"\n                  dt-instance=\"cliente.dtReferenti.dtInstance\"\n                  class=\"table table-hover\">\n                </table>\n              </div>\n            </div>\n            <div class=\"col-md-6\">\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Indirizzo:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  {{cliente.cliente.sedi[0].indirizzo + (cliente.cliente.sedi[0].numeroCivico ? \',\'+cliente.cliente.sedi[0].numeroCivico : \'\')}}<br>\n                  {{cliente.cliente.sedi[0].cap}}&nbsp;-&nbsp;{{cliente.cliente.sedi[0].citta}}&nbsp;({{cliente.cliente.sedi[0].prov}})\n                  <a title=\"Apri mappa\" ng-href=\"http://maps.google.com/?q={{(cliente.cliente.indirizzo + (cliente.cliente.sedi[0].civico ? \',\' + cliente.cliente.sedi[0].civico : \'\') + \' \' + cliente.cliente.sedi[0].citta) | urlEncode}}\" target=\"_blank\">\n                    <i class=\"fa fa-map-o\"></i>\n                  </a>\n                  <span ng-if=\"cliente.cliente.sedi[0].telefono!=\'\'\">\n                    <br><a href=\"tel:{{cliente.cliente.sedi[0].telefono}}\">{{cliente.cliente.sedi[0].telefono}} <i class=\"fa fa-phone\"></i></a>\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Zona:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\"><span>{{cliente.cliente.zona}}&nbsp;({{cliente.cliente.idZona}})</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Privacy:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span ng-class=\"cliente.cliente.privacy ? \'text-danger\' : \'text-success\'\">\n                    {{cliente.cliente.privacy ? \'Richiesta Privacy\' : \'Libero\'}}\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Sito:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <a ng-href=\"http://{{cliente.cliente.sito}}\" target=\"_blank\">{{cliente.cliente.sito}}</a>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Note:</label></div>\n            <div class=\"col-xs-10 text-left\"><span>{{cliente.cliente.note}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Tipo:</label></div>\n            <div class=\"col-xs-10 text-left\"><span>{{cliente.calcolaInnovatore(cliente.cliente.innovatore)}}</span></div>\n          </div>\n\n          <hr>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 text-center\">\n              <button class=\"btn btn-success\" ng-click=\"cliente.createAppuntamentoAgente(cliente.cliente)\">Nuovo Appuntamento</button>\n              &nbsp;\n              <button class=\"btn btn-success\" ng-click=\"cliente.createOpportunitaSegnalatore(cliente.cliente)\">Segnalazione Clyco</button>\n            </div>\n          </div>\n\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <div bs-tabs\n                   bs-active-pane=\"cliente.activeTab\"\n                   ng-init=\"cliente.activeTab = 0\">\n\n                <div data-title=\"Appuntamenti\" bs-pane>\n                  <table id=\"cliente_agente_appuntamenti\" datatable\n                         dt-options=\"cliente.dtAppuntamenti.dtOptions\"\n                         dt-columns=\"::cliente.dtAppuntamenti.dtColumns\"\n                         dt-instance=\"cliente.dtAppuntamenti.dtInstance\"\n                         class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"Opportunità\" bs-pane>\n                  <table id=\"cliente_agente_opportunita\" datatable\n                         dt-options=\"cliente.dtOpportunita.dtOptions\"\n                         dt-columns=\"::cliente.dtOpportunita.dtColumns\"\n                         dt-instance=\"cliente.dtOpportunita.dtInstance\"\n                         class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/soggetti/soggetti.html","<div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div ng-include=\"\'app/admin/soggetti/soggetto-view.html\'\"></div><div ng-include=\"\'app/admin/soggetti/soggetto-edit.html\'\"></div><div class=container-fluid ng-controller=\"AdminSoggettiController as soggetti\"><div class=row><div class=col-xs-12><h2>Soggetti</h2></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::soggetti.dt.options dt-columns=::soggetti.dt.columns dt-instance=soggetti.dt.instance class=\"table table-hover table-condensed\"><tfoot><tr><th></th><th></th><th>Utente</th><th>Cognome</th><th>Nome</th><th>Tipo</th><th>Azienda</th><th>Segnalatore</th><th>Disabilitato</th><th>Nullo</th><th>Login</th><th></th><th></th></tr></tfoot></table></div></div></div>");
$templateCache.put("app/admin/soggetti/soggetto-edit.html","<script type=text/ng-template id=soggetto-edit-modal.tpl.html ng-controller=\"AdminSoggettoEditController as sec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <form name=\"sec.editForm\" class=\"form-horizontal dataForm\" ng-submit=\"sec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{sec.soggetto.id || \'0\'}}\n                {{sec.soggetto.username ? \'(\'+sec.soggetto.username+\')\' : \'\'}}\n              </div>\n\n              <div class=\"col-xs-4 text-center\">\n                {{sec.soggetto.codice || \'\'}}\n              </div>\n\n              <div class=\"col-xs-4 text-right\">\n                {{sec.soggetto.cognome + sec.soggetto.nome ? (sec.soggetto.cognome + \' \' + sec.soggetto.nome) : \'Nuovo Soggetto\'}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Identità</label>\n\n              <div class=\"col-sm-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.codice\" ng-model-options=\"{updateOn: \'blur\'}\" name=\"codice\"\n                       required field-exist=\"codice\" old-value=\"{{sec.soggetto.codice}}\" minlength=\"3\">\n                <span class=\"help-block\">Codice</span>\n              </div>\n\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.cognome\" name=\"cognome\"\n                       required>\n                <span class=\"help-block\">Cognome</span>\n              </div>\n\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.nome\" name=\"nome\"\n                       required>\n                <span class=\"help-block\">Nome</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Gruppo</label>\n\n              <div class=\"col-sm-5 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.label as el.label for el in sec.formData.tipi\"\n                        ng-model=\"sec.soggetto.tipo\" name=\"tipo\"\n                        ng-change=\"sec.setCodice(sec.soggetto.tipo)\"\n                        required>\n                </select>\n                <span class=\"help-block\">Tipo</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.titolo\" name=\"titolo\">\n                <span class=\"help-block\">Titolo</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Sezione</label>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.azienda\" name=\"Azienda\">\n                <span class=\"help-block\">Azienda</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in sec.formData.areaManagers\"\n                        ng-model=\"sec.soggetto.AM\" name=\"AM\">\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">Squadra</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatti</label>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"email\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.email\" name=\"email\">\n                <span class=\"help-block\">Email</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"email\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.emailCC\" name=\"emailCC\">\n                <span class=\"help-block\">Email CC</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-5 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.tel\" name=\"tel\">\n                <span class=\"help-block\">Telefono</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.cell\" name=\"cell\">\n                <span class=\"help-block\">Cellulare</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Luoghi</label>\n\n              <div class=\"col-sm-5 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"sec.soggetto.zona\" name=\"zona\">\n                <span class=\"help-block\">Zona</span>\n              </div>\n\n              <div class=\"col-sm-5 validate-group\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in sec.formData.ccs\"\n                        ng-model=\"sec.soggetto.CC\" name=\"CC\">\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">CallCenter</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Obbiettivo</label>\n\n              <div class=\"col-sm-4 validate-group\">\n                <div class=\"input-group\">\n                  <input type=\"number\" class=\"form-control\"\n                         ng-model=\"sec.soggetto.obbiettivo\" name=\"obbiettivo\"\n                         decimal step=\"1\" max=\"999999\">\n                  <span class=\"input-group-addon\">&euro;</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"sec.soggetto.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Flags</label>\n\n              <div class=\"col-xs-12 col-sm-3 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"sec.soggetto.segnalatore\" name=\"segnalatore\">&nbsp;Segnalatore\n                </label>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-3 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"sec.soggetto.nullo\" name=\"nullo\">&nbsp;Nullo\n                </label>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-3 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"sec.soggetto.disabilitato\" name=\"disabilitato\">&nbsp;Disabilitato\n                </label>\n              </div>\n            </div>\n\n            <!-- PARTE UTENTE -->\n            <fieldset>\n              <legend class=\"checkbox-inline validate-group\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"sec.soggetto.login\" name=\"login\">&nbsp;Login\n                </label>\n              </legend>\n              <br>\n\n              <div ng-if=\"sec.soggetto.login\">\n                <div class=\"form-group\" ng-if=\"!sec.soggetto.havePassword\">\n                  <label class=\"control-label col-sm-2\">Utente</label>\n                  <div class=\"col-sm-4 validate-group has-warning\">\n                    <input type=\"text\" class=\"form-control\"\n                           ng-model=\"sec.soggetto.username\" ng-model-options=\"{updateOn: \'blur\'}\" name=\"username\"\n                           required field-exist=\"username\">\n                  </div>\n\n                  <label class=\"control-label col-sm-2\">Password</label>\n                  <div class=\"col-sm-4 validate-group has-warning\">\n                    <input type=\"text\" class=\"form-control\"\n                           ng-model=\"sec.soggetto.newPassword\" name=\"newPassword\"\n                           required>\n                  </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"sec.soggetto.havePassword\">\n                  <label class=\"control-label col-sm-2\">Utente</label>\n                  <div class=\"col-sm-3\">\n                    <p class=\"form-control-static\">{{sec.soggetto.username}}</p>\n                  </div>\n\n                  <label class=\"control-label col-sm-4\">Scadenza&nbsp;Password</label>\n                  <div class=\"col-sm-3 validate-group has-warning\">\n                    <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                           ng-model=\"sec.soggetto.scadenza\" name=\"scadenza\"\n                           bs-datepicker\n                           required>\n                  </div>\n                </div>\n\n                <div class=\"form-group has-warning\">\n                  <label class=\"control-label col-sm-2\">Gruppo</label>\n                  <div class=\"col-sm-10\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in sec.formData.gruppi\"\n                            ng-model=\"sec.soggetto.idGruppo\" name=\"idGruppo\"\n                            required>\n                    </select>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label class=\"control-label col-sm-2\">Caposquadra</label>\n\n                  <div class=\"col-sm-5\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in sec.formData.areaManagers\"\n                            ng-model=\"sec.soggetto.gruppoAM\" name=\"gruppoAM\">\n                      <option value=\"\"></option>\n                    </select>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-12 col-sm-2\">Flags</label>\n\n                  <div class=\"col-xs-12 col-sm-4 checkbox\">\n                    <label>\n                      <input type=\"checkbox\"\n                             ng-model=\"sec.soggetto.amministratore\" name=\"amministratore\">&nbsp;Amministratore\n                    </label>\n                  </div>\n\n                  <div class=\"col-xs-12 col-sm-4 checkbox\">\n                    <label>\n                      <input type=\"checkbox\"\n                             ng-model=\"sec.soggetto.powerUser\" name=\"powerUser\">&nbsp;PowerUser\n                    </label>\n                  </div>\n\n                  <div class=\"col-xs-12 col-sm-offset-2 col-sm-4 checkbox\">\n                    <label>\n                      <input type=\"checkbox\"\n                             ng-model=\"sec.soggetto.gestOppo\" name=\"gestOppo\">&nbsp;Gestisci&nbsp;Opportunità\n                    </label>\n                  </div>\n\n                  <div class=\"col-xs-12 col-sm-4 checkbox\">\n                    <label>\n                      <input type=\"checkbox\"\n                             ng-model=\"sec.soggetto.gestProm\" name=\"gestProm\">&nbsp;Gestisci&nbsp;Promemoria\n                    </label>\n                  </div>\n                </div>\n              </div>\n            </fieldset>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{sec.alerts.status}}\" data-messages=\"sec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/admin/soggetti/soggetto-view.html","<script type=text/ng-template id=soggetto-read-modal.tpl.html ng-controller=\"AdminSoggettoController as soggetto\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-4 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{soggetto.soggetto.id}}\n            </div>\n\n            <div class=\"col-xs-4 text-center\">\n              {{soggetto.soggetto.codice}}\n            </div>\n\n            <div class=\"col-xs-4 text-right\">\n              {{soggetto.soggetto.cognome + \' \' + soggetto.soggetto.nome}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Tipo</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.tipo}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Titolo</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.titolo}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Squadra</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.AM}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Email</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.email}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Email CC</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.emailCC}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Telefono</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.tel}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Cellulare</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.cell}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Zona</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.zona}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>CallCenter</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.CC}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Note</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.note}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Segnalatore</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.segnalatore ? \'SI\' : \'NO\'}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Nullo</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.nullo ? \'SI\' : \'NO\'}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4\"><label>Disabilitato</label></div>\n            <div class=\"col-xs-8\">{{soggetto.soggetto.disabilitato ? \'SI\' : \'NO\'}}</div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-warning\" ng-click=\"soggetto.updateSoggetto(soggetto.soggetto.id)\">Modifica</button>\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/agenti/home/home.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row><div class=\"col-md-8 flex-col\"><div class=g1-panel><div class=row><div class=\"col-xs-12 col-sm-10 text-left\"><h2 class=margin-top-8>Appuntamenti&nbsp;del&nbsp; <button class=\"btn btn-primary\" ng-click=\"home.appuntamentiOggi.changeDataApp(\'prev\')\" title=\"Indietro di 1 gg\">&lt;</button> <button class=\"btn btn-primary\" ng-click=\"home.appuntamentiOggi.changeDataApp(\'today\')\" title=\"Torna ad oggi\">{{home.appuntamentiOggi.dataApp | date:\'shortDate\'}}</button> <button class=\"btn btn-primary\" ng-click=\"home.appuntamentiOggi.changeDataApp(\'next\')\" title=\"Avanti di 1 gg\">&gt;</button></h2></div><div class=\"col-xs-12 col-sm-2 text-right\"><h2 class=margin-top-8><button class=\"btn btn-default\" ng-click=home.appuntamentiOggi.syncGcal() title=\"Sincronizza settimana attuale con Google Calendar\">Gcal&nbsp;<i class=\"fa fa-refresh\"></i></button></h2></div></div><div class=panel-body ng-show=\"home.appuntamentiOggi.dt.instance.DataTable.data().count() <= 0\"><div class=row><div class=\"col-xs-12 text-center text-muted\"><i class=\"fa fa-frown-o\" style=\"font-size: 8rem\"></i><br><span style=\"font-size: 4rem\">Nessun appuntamento</span></div></div></div><div class=table-responsive ng-show=\"home.appuntamentiOggi.dt.instance.DataTable.data().count() > 0\"><table datatable dt-options=::home.appuntamentiOggi.dt.options dt-columns=home.appuntamentiOggi.dt.columns dt-instance=home.appuntamentiOggi.dt.instance class=\"table table-condensed\" style=\"margin-bottom: 0\"></table></div></div><div class=\"g1-panel contrattiInScadenzaAgente\"><h2>Contratti in scadenza <a href=\"#/contratti?inScadenza=1\" bs-tooltip data-title=\"Vai a sezione\"><i class=\"fa fa-external-link\"></i></a></h2><table class=table><thead><tr><th></th><th class=text-center ng-repeat=\"row in home.contrattiInScadenza\">{{row.meseAnno}}</th></tr></thead><tbody><tr><th>Mese</th><th class=text-center ng-repeat=\"row in home.contrattiInScadenza\"><a href=\"#/contratti?inScadenza=1&meseAnno={{row.meseAnno}}\">{{row.contrattiInScadenza}}</a></th></tr></tbody></table></div></div><!-- Avanzamenti --><div class=\"col-md-4 flex-col\"><div class=g1-panel><table class=table-condensed style=\"width: 100%\"><tbody><tr><!-- Giorni --><td class=min-width><b>Giorni</b></td><td>{{home.giorni.adv | number:0}}&nbsp;/&nbsp;<span class=text-{{home.giorni.status}}><b>{{home.giorni.obj | number:0}}</b></span></td><!-- Q --><td rowspan=2 class=\"text-center q-logo\"><span class=text-primary style=\"font-size: 4rem\">Q{{home.q}}</span></td></tr><!-- Avanzamento Globale --><tr><td colspan=2 title=\"Media avanzamento piste FONIA FX, FONIA MB e VALORE\"><progressbar value=home.avanzamento.perc type={{home.avanzamento.status}} style=\"margin-bottom: 0\">{{home.avanzamento.perc | number:1}}%</progressbar></td></tr></tbody></table><div class=row><!-- Tabella --><div class=\"col-sm-9 col-md-12 table-responsive\"><table class=table style=\"margin-bottom: 5px\"><tbody><tr ng-repeat=\"pista in home.piste\"><td class=text-primary>{{pista.id}}</td><td class=text-right>{{pista.adv | currency:\'€\':0}}</td><td class=text-center>{{pista.perc | number:1}}%</td></tr></tbody></table><div class=\"text-center larger\" style=\"margin-bottom: 15px\">Obiettivo trimestrale: <b>{{home.avanzamento.obj | currency:\'€\':0}}</b></div></div><!-- Immagine --><div class=\"col-sm-3 col-md-12 text-center margin-top margin-bottom\"><!-- verticale --> <img class=\"hidden-xs hidden-md hidden-lg image-autosize\" style=\"max-height: 185px\" ng-src=\"{{home.avanzamento.img ? \'/assets/images/orso_toro/orso_toro\' + home.avanzamento.img + \'v.png\': \'//:0\'}}\"><!-- orizzontale --> <img class=\"hidden-sm image-autosize\" style=\"max-height: 150px\" ng-src=\"{{home.avanzamento.img ? \'/assets/images/orso_toro/orso_toro\' + home.avanzamento.img + \'.png\': \'//:0\'}}\"></div><div class=\"col-sm-3 col-md-12 text-center margin-top margin-bottom\"><h4>Canoni ricorrenti</h4><ul class=qValues><li ng-repeat=\"qValues in home.qValues track by $index\" ng-class=\"qValues.activeQ ? \'activeQ\' : \'\'\"><strong>Q{{$index + 1 }}</strong><br>{{qValues.ricorrente | currency:\'€\':0}}</li><li><strong>Totale<br>{{home.totaleRicorrente | currency:\'€\':0}}</strong></li></ul></div></div><!-- Warnings --><div class=row style=\"margin-bottom: -20px; margin-top: 5px\" ng-if=home.warningsPiste.length><div class=\"col-xs-12 flex-col\"><g1-alerts data-status=417 data-messages=home.warningsPiste></g1-alerts></div></div></div></div></div><!-- APPUNTAMENTI --><div class=row><!-- Appuntamenti in visita --><div class=\"col-md-6 flex-col widgetHome\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2 class=margin-top-8>Appuntamenti in visita</h2></div><div class=\"col-xs-6 text-right\"><span class=badge>{{home.dtAppuntamentiVisita.dtInstance.DataTable.data().count()}}</span></div></div><div class=table-responsive><table datatable dt-options=::home.dtAppuntamentiVisita.dtOptions dt-columns=home.dtAppuntamentiVisita.dtColumns dt-instance=home.dtAppuntamentiVisita.dtInstance class=\"table table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div><!-- opportunità --><div class=\"col-md-6 flex-col opportunitaAgenteHome widgetHome\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2 class=margin-top-8>Opportunità aperte</h2></div><div class=\"col-xs-6 text-right\"><span class=badge>{{home.dtOpportunitaAperte.dtInstance.DataTable.data().count()}}</span></div></div><div class=table-responsive><table datatable dt-options=::home.dtOpportunitaAperte.dtOptions dt-columns=home.dtOpportunitaAperte.dtColumns dt-instance=home.dtOpportunitaAperte.dtInstance class=\"table table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div></div><!-- GRAFICI --><div class=row><!-- Grafico Opportunità --><div class=\"col-md-6 flex-col\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2>{{home.chartOpportunita.title}}</h2></div><div class=\"col-xs-6 text-right\"><h2>{{home.chartOpportunita.total}}</h2></div></div><div class=panel-body><form role=form name=search_chartAvanzamento class=form-inline><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartOpportunita.formData.tipi><label class=radio-inline><input type=radio value=ComboChart ng-model=home.chartOpportunita.options.tipo name=tipo>&nbsp;Grafico a colonne</label><label class=radio-inline><input type=radio value=PieChart ng-model=home.chartOpportunita.options.tipo name=tipo>&nbsp;Grafico a torta</label></div></form><div class=row><div class=col-xs-12 ng-if=home.chartOpportunita.options><div g1-chart chart-id={{home.chartOpportunita.id}} chart-options=home.chartOpportunita.options chart-title=home.chartOpportunita.title chart-total=home.chartOpportunita.total></div></div></div></div></div></div><!-- Grafico Avanzamento --><div class=\"col-md-6 flex-col\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2>{{home.chartAvanzamento.title}}</h2></div><div class=\"col-xs-6 text-right\"><h2>{{home.chartAvanzamento.total}}</h2></div></div><div class=panel-body><form role=form name=search_chartAvanzamento class=form-inline><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.anni><label class=control-label>Anno</label><select class=form-control ng-options=\"el.value as el.label for el in home.chartAvanzamento.formData.anni\" ng-model=home.chartAvanzamento.options.anno name=anno></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.tipiData><label class=control-label>Data</label><select class=form-control ng-options=\"el.value as el.label for el in home.chartAvanzamento.formData.tipiData\" ng-change=home.chartAvanzamento.setStati(home.chartAvanzamento.options.tipoData) ng-model=home.chartAvanzamento.options.tipoData name=tipoData></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.stati><label class=control-label>Stati</label><button type=button class=\"btn btn-default\" ng-model=\"home.chartAvanzamento.options[\'idStati[]\']\" ng-model-options=\"{updateOn: \'blur\'}\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 bs-options=\"el.value as el.label for el in home.chartAvanzamento.formData.stati\">Stati <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.tipi><label class=radio-inline><input type=radio value=ComboChart ng-model=home.chartAvanzamento.options.tipo name=tipo>&nbsp;Grafico a colonne</label><label class=radio-inline><input type=radio value=PieChart ng-model=home.chartAvanzamento.options.tipo name=tipo>&nbsp;Grafico a torta</label></div></form><div class=row><div class=col-xs-12 ng-if=home.chartAvanzamento.options><div g1-chart chart-id={{home.chartAvanzamento.id}} chart-options=home.chartAvanzamento.options chart-title=home.chartAvanzamento.title chart-total=home.chartAvanzamento.total></div></div></div></div></div></div></div><br></div>");
$templateCache.put("app/agenti/ricerca/provvigioni.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div ng-include=\"\'app/core/provvigioni/provvigione-calcolata.html\'\"></div><div class=container-fluid><div class=page-header><h2>Ricerca Provvigioni Agente</h2></div><form name=rpc.sf class=form-horizontal ng-submit=rpc.search() novalidate><div class=row><div class=col-md-6><div class=form-group><label class=\"control-label col-md-2\">Fornitore</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in rpc.searchData.fornitori | orderBy:\'label\'\" ng-model=rpc.searchForm.fornitore name=fornitore></select></div></div><div class=form-group><label class=\"control-label col-md-2\">Pista</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in rpc.searchData.piste | filter:{fornitore: rpc.searchForm.fornitore} | filter:{disabilitato:rpc.searchData.dPiste} | orderBy:\'value\'\" ng-model=rpc.searchForm.pista name=pista></select></div><div class=\"checkbox col-md-5\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=rpc.searchData.dPiste name=dPiste ng-change=\"rpc.searchForm.pista = \'0\'\"> <b>&nbsp;Disabilitati</b></label></div></div><div class=form-group><label class=\"control-label col-md-2\">Data</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=rpc.searchForm.conferma_from name=conferma_from bs-datepicker data-max-date={{rpc.searchForm.conferma_to}}> <span class=help-block>Da</span></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=rpc.searchForm.conferma_to name=conferma_to bs-datepicker data-min-date={{rpc.searchForm.conferma_from}}> <span class=help-block>A</span></div></div><div class=form-group><label class=\"control-label col-md-2\">Provv. Ric.</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><select class=form-control ng-model=rpc.searchForm.ricorrente name=ricorrente><option value=\"\">Tutti</option><option value=1>Ricorrente</option><option value=0>NON ricorrente</option></select></div></div></div></div><div class=form-group><div class=\"col-xs-12 text-right\"><button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row ng-if=rpc.searched><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::rpc.dt.options dt-columns=::rpc.dt.columns dt-instance=rpc.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div>");
$templateCache.put("app/bo/home/home.html","<div class=container-fluid><div class=row><div class=col-xs-12>Home del bo</div></div></div>");
$templateCache.put("app/cc/campagne/campagna.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><div class=row><div class=\"col-xs-4 text-left\"><strong>{{campagna.clienti[campagna.currentCliente].motivo}}</strong></div><div class=\"col-xs-4 text-center\"><strong><span ng-if=\"campagna.rp.idZona > 0\">{{campagna.cliente.zona}}&nbsp;</span> <span ng-if=\"campagna.rp.citta != \'\'\">{{campagna.cliente.citta}}&nbsp;</span></strong></div><div class=\"col-xs-4 text-right\"><span class=\"badge badge-important\"><i class=\"fa fa-fw fa-caret-left\" ng-click=campagna.prevCliente()></i> {{campagna.currentCliente + 1 }} di {{campagna.clienti.length}} <i class=\"fa fa-fw fa-caret-right\" ng-click=campagna.nextCliente()></i></span></div></div><div class=row style=\"margin-top: 15px\" ng-if=\"(campagna.rp.via + campagna.rp.cliente + campagna.rp.idCliente) != \'\'\"><div class=\"col-xs-4 text-left\"><strong><span ng-if=\"campagna.rp.via != \'\'\">{{campagna.rp.via}}</span></strong></div><div class=\"col-xs-4 text-center\"><strong><span ng-if=\"campagna.rp.cliente != \'\'\">{{campagna.rp.cliente}}</span></strong></div><div class=\"col-xs-4 text-right\"><strong><span ng-if=\"campagna.rp.idCliente != \'\'\">{{campagna.rp.idCliente}}</span></strong></div></div></h3></div><div class=panel-body><div class=\"row bg-info\" style=\"margin-top: -15px\"><div class=\"col-xs-4 text-left\"><h5 style=\"display: inline-block\">{{campagna.cliente.id}} - {{campagna.cliente.ragSoc}}</h5><button type=button class=\"btn btn-xs btn-warning\" ng-click=campagna.updateCliente(campagna.cliente.id)><i class=\"fa fa-pencil\"></i>&nbsp;Modifica</button></div><div class=\"col-xs-4 text-center\"><h5>{{campagna.cliente.agenteCognome}}&nbsp;{{campagna.cliente.agenteNome}}</h5></div><div class=\"col-xs-4 text-right\"><h5>{{campagna.cliente.ptf}} - {{campagna.cliente.ptfMob}} - {{campagna.cliente.ptfSa}}</h5></div></div><div class=row><div class=\"col-md-6 form-horizontal\"><div class=row style=\"margin-top: 10px\"><div class=\"col-xs-2 text-right\"><label>Indirizzo:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.indirizzo + (campagna.cliente.civico ? \',\' + campagna.cliente.civico : \'\')}} &nbsp;/&nbsp; {{campagna.cliente.cap}}&nbsp;-&nbsp;{{campagna.cliente.citta}}&nbsp;({{campagna.cliente.prov}}) </span><a title=\"Apri mappa\" ng-href=\"http://maps.google.com/?q={{(campagna.cliente.indirizzo + (campagna.cliente.civico ? \',\' + campagna.cliente.civico : \'\') + \' \' + campagna.cliente.citta) | urlEncode}}\" target=_blank><i class=\"fa fa-map-o\"></i></a></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>Zona:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.zona}}&nbsp;({{campagna.cliente.idZona}})</span></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>CF/P.IVA:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.cf}}</span></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>Email:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.email}}</span> <span ng-if=campagna.cliente.email><a ng-href=mailto:{{campagna.cliente.email}} target=_blank title=\"Invia mail\"><i class=\"fa fa-envelope fa-fw\" style=\"font-size: 1.2em\"></i> </a><a href=\"\" title=\"Invia presentazione\" ng-click=\"campagna.presentazioneCliente(campagna.cliente.id, {indirizzo: campagna.cliente.email, oggetto: \'Presentazione \' + campagna.cliente.ragSoc})\"><i class=\"fa fa-mail-forward fa-fw\" style=\"font-size: 1.2em\"></i></a></span></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>Referente:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.referente}}</span></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>Privacy:</label></div><div class=\"col-xs-10 text-left\"><span ng-class=\"campagna.cliente.privacy ? \'text-danger\' : \'text-success\'\">{{campagna.cliente.privacy ? \'Richiesta Privacy\' : \'Libero\'}}</span></div></div><div class=row><div class=\"col-xs-2 text-right\"><label>Note:</label></div><div class=\"col-xs-10 text-left\"><span>{{campagna.cliente.note}}</span></div></div><div class=row ng-if=campagna.cliente.tel1><div class=\"col-xs-2 text-right\"><label class=control-label>Tel 1:</label></div><div class=\"col-xs-10 text-left\"><p class=form-control-static>{{campagna.cliente.tel1}} <button type=button class=\"btn btn-xs btn-primary\" ng-disabled=\"\n                              campagna.cliente.inCall !== false\n                              || campagna.clienti[campagna.currentCliente].callStatus !== \'aperto\'\n                            \" ng-click=campagna.callCliente(campagna.cliente.tel1)><i class=\"fa fa-phone fa-fw\"></i>Chiama</button></p></div></div><div class=row ng-if=campagna.cliente.tel2><div class=\"col-xs-2 text-right\"><label class=control-label>Tel 2:</label></div><div class=\"col-xs-10 text-left\"><p class=form-control-static>{{campagna.cliente.tel2}} <button type=button class=\"btn btn-xs btn-primary\" ng-disabled=\"\n                              campagna.cliente.inCall !== false\n                              || campagna.clienti[campagna.currentCliente].callStatus !== \'aperto\'\n                            \" ng-click=campagna.callCliente(campagna.cliente.tel2)><i class=\"fa fa-phone fa-fw\"></i>Chiama</button></p></div></div><div class=row ng-if=campagna.cliente.cell1><div class=\"col-xs-2 text-right\"><label class=control-label>Cell 1:</label></div><div class=\"col-xs-10 text-left\"><p class=form-control-static>{{campagna.cliente.cell1}} <button type=button class=\"btn btn-xs btn-primary\" ng-disabled=\"\n                              campagna.cliente.inCall !== false\n                              || campagna.clienti[campagna.currentCliente].callStatus !== \'aperto\'\n                            \" ng-click=campagna.callCliente(campagna.cliente.cell1)><i class=\"fa fa-mobile fa-fw\"></i>Chiama</button></p></div></div><div class=row ng-if=campagna.cliente.cell2><div class=\"col-xs-2 text-right\"><label class=control-label>Cell 2:</label></div><div class=\"col-xs-10 text-left\"><p class=form-control-static>{{campagna.cliente.cell2}} <button type=button class=\"btn btn-xs btn-primary\" ng-disabled=\"\n                              campagna.cliente.inCall !== false\n                              || campagna.clienti[campagna.currentCliente].callStatus !== \'aperto\'\n                            \" ng-click=campagna.callCliente(campagna.cliente.cell2)><i class=\"fa fa-mobile fa-fw\"></i>Chiama</button></p></div></div><!-- gestione chiamata --><div class=row ng-if=\"\n                     campagna.cliente.inCall !== false\n                     && campagna.clienti[campagna.currentCliente].callStatus === \'aperto\'\n                   \"><div class=\"col-xs-12 text-center\"><h4>Chiamata in corso a {{campagna.cliente.inCall}}&nbsp; <button type=button class=\"btn btn-xs\" title=\"Annulla Chiamata\" ng-click=campagna.undoCallCliente()><i class=\"fa fa-fw fa-undo\"></i></button></h4></div><div class=col-xs-3><button type=button class=\"form-control btn btn-danger\" ng-click=\"campagna.closeCallCliente(\'negativo\')\">Negativo</button></div><div class=col-xs-3><button type=button class=\"form-control btn btn-warning\" ng-click=\"campagna.closeCallCliente(\'richiama\')\">Richiama</button></div><div class=col-xs-3><button type=button class=\"form-control btn btn-success\" ng-click=\"campagna.closeCallCliente(\'appuntamento\')\">Appuntamento</button></div><div class=col-xs-3><button type=button class=\"form-control btn btn-info\" ng-click=\"campagna.closeCallCliente(\'positivo\')\">Positivo</button></div></div><!-- se lo stato definitivo non è aperto visualizzo lo stato attuale --><div class=row ng-if=\"campagna.clienti[campagna.currentCliente].callStatus !== \'aperto\'\"><div class=\"col-xs-offset-4 col-xs-4\"><button type=button class=\"btn btn-block\" ng-class=\"{\n                            \'btn-danger\': campagna.clienti[campagna.currentCliente].callStatus == \'negativo\',\n                            \'btn-warning\': campagna.clienti[campagna.currentCliente].callStatus == \'richiama\',\n                            \'btn-success\': campagna.clienti[campagna.currentCliente].callStatus == \'appuntamento\',\n                            \'btn-info\': campagna.clienti[campagna.currentCliente].callStatus == \'positivo\'\n                          }\" disabled>{{campagna.clienti[campagna.currentCliente].callStatus | uppercase}}</button></div></div></div><div class=col-md-6><h4>Telefonate</h4><div class=\"text-center text-muted\" ng-if=\"campagna.widgetTelefonate.telefonate.length <= 0\"><h1>Nessuna telefonata</h1></div><div class=table-responsive ng-if=\"campagna.widgetTelefonate.telefonate.length > 0\"><table datatable=ng dt-options=campagna.widgetTelefonate.dt.options dt-column-defs=::campagna.widgetTelefonate.dt.columnDefs class=\"table table-hover table-condensed\"><thead><tr><th class=\"min-width dt-datetime\">Data</th><th class=min-width>Operatore</th><th class=min-width>Esito</th><th class=dt-longtext>Note</th></tr></thead><tbody><tr ng-repeat=\"telefonata in ::campagna.widgetTelefonate.telefonate\"><td class=min-width>{{telefonata.dataOra}}</td><td class=min-width>{{telefonata.operatore}}</td><td class=min-width>{{telefonata.esito}} <span ng-if=telefonata.idAppuntamento>&nbsp;<i class=\"fa fa-external-link\" title=\"apri appuntamento\" ng-click=campagna.readAppuntamento(telefonata.idAppuntamento)></i></span></td><td>{{telefonata.note}}</td></tr></tbody><tfoot><tr><td colspan=4 class=text-right><button type=button class=\"btn btn-info btn-xs\" ng-click=campagna.toggleMore(campagna.widgetTelefonate);><i class=\"fa fa-fw\" ng-class=\"{\n                             \'fa-plus\': campagna.widgetTelefonate.filtro.last == \'\',\n                             \'fa-minus\': campagna.widgetTelefonate.filtro.last == undefined,\n                           }\"></i>&nbsp;Altre...</button></td></tr></tfoot></table></div></div></div><hr><div class=row><div class=col-md-6><h4>Appuntamenti</h4><div class=\"text-center text-muted\" ng-if=\"campagna.widgetAppuntamenti.appuntamenti.length <= 0\"><h1>Nessun Appuntamento</h1></div><div class=table-responsive ng-if=\"campagna.widgetAppuntamenti.appuntamenti.length > 0\"><table datatable=ng dt-options=campagna.widgetAppuntamenti.dt.options dt-column-defs=::campagna.widgetAppuntamenti.dt.columnDefs class=\"table table-hover table-condensed\"><thead><tr><th class=\"dt-date min-width\">Data</th><th class=\"dt-time min-width\">Ora</th><th class=min-width>Agente</th><th class=min-width>Stato</th><th ng-if=!campagna.clienti[campagna.currentCliente].cieca class=dt-longtext>Note Agente</th></tr></thead><tbody><tr ng-repeat=\"appuntamento in ::campagna.widgetAppuntamenti.appuntamenti\"><td class=min-width>{{appuntamento.data}}</td><td class=min-width>{{appuntamento.ora}}</td><td class=min-width>{{appuntamento.agenti_agente}}</td><td class=min-width><a ng-if=!campagna.clienti[campagna.currentCliente].cieca title=\"apri appuntamento\" ng-click=campagna.readAppuntamento(appuntamento.id)>{{appuntamento.stati_appuntamento_descrizione}} </a><span ng-if=campagna.clienti[campagna.currentCliente].cieca>{{appuntamento.stati_appuntamento_descrizione}}</span></td><td ng-if=!campagna.clienti[campagna.currentCliente].cieca>{{appuntamento.noteAgente}}</td></tr></tbody><tfoot><tr><td ng-attr-colspan=\"{{!campagna.clienti[campagna.currentCliente].cieca ? 5 : 4}}\" class=text-right><button type=button class=\"btn btn-info btn-xs\" ng-click=campagna.toggleMore(campagna.widgetAppuntamenti);><i class=\"fa fa-fw\" ng-class=\"{\n                             \'fa-plus\': campagna.widgetAppuntamenti.filtro.last == \'\',\n                             \'fa-minus\': campagna.widgetAppuntamenti.filtro.last == undefined,\n                           }\"></i>&nbsp;Altri...</button></td></tr></tfoot></table></div></div><div class=col-md-6><div bs-tabs bs-active-pane=campagna.widgetDettagli.activeTab ng-init=\"campagna.widgetDettagli.activeTab = 0\"><div data-title=\"<b>Contratti</b>\" bs-pane><div class=\"text-center text-muted\" ng-if=\"campagna.widgetDettagli.contratti.length <= 0\"><h1>Nessun contratto</h1></div><div class=table-responsive ng-if=\"campagna.widgetDettagli.contratti.length > 0\"><table datatable=ng dt-options=campagna.widgetDettagli.dtContratti.options dt-column-defs=::campagna.widgetDettagli.dtContratti.columnDefs class=\"table table-hover table-condensed\"><thead><tr><th>Descrizione</th><!--<th class=\"dt-currency min-width\">Prezzo</th>--><!--<th class=\"min-width\">Qta</th>--><!--<th class=\"dt-currency min-width\">Totale</th>--><th class=min-width>Stato</th><th class=min-width>Fornitore</th><th class=min-width>Pista</th><th class=\"dt-date min-width\">Inserimento</th><th class=\"dt-date min-width\">Conferma</th><th class=\"dt-date min-width\">Attivazione</th><!-- TODO: Sosituito \'CRM\' con \'Attivazione\' --></tr></thead><tbody><tr ng-repeat=\"contratto in ::campagna.widgetDettagli.contratti\"><td><a title=\"Apri Contratto\" ng-click=campagna.readContratto(contratto.id)>{{contratto.descrizione}}</a></td><!--<td class=\"min-width\">{{contratto.prezzoUnit}}</td>--><!--<td class=\"min-width\">{{contratto.qta}}</td>--><!--<td class=\"min-width\">{{contratto.prezzo}}</td>--><td class=min-width>{{contratto.stato}}</td><td class=min-width>{{contratto.fornitore}}</td><td class=min-width>{{contratto.pista}}</td><td class=min-width>{{contratto.dataInserimento}}</td><td class=min-width>{{contratto.dataConferma}}</td><td class=min-width>{{contratto.dataCrm}}</td></tr></tbody><tfoot><tr><td colspan=7 class=text-right><button type=button class=\"btn btn-info btn-xs\" ng-click=campagna.toggleMore(campagna.widgetDettagli);><i class=\"fa fa-fw\" ng-class=\"{\n                             \'fa-plus\': campagna.widgetDettagli.filtro.last == \'\',\n                             \'fa-minus\': campagna.widgetDettagli.filtro.last == undefined,\n                           }\"></i>&nbsp;Altri...</button></td></tr></tfoot></table></div></div></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-offset-4 col-xs-4\"><button type=button class=\"btn btn-danger btn-block\" ng-click=campagna.closeActivity()><h3>TERMINA ATTIVITÀ</h3></button></div></div></div><!-- modal gestisci chiamata --><script type=text/ng-template id=gestisci-chiamata.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\">\n      <div class=\"modal-content\">\n        <form name=\"TelefonataCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"campagna.saveForm()\" novalidate>\n          <div class=\"modal-header\" ng-class=\"{\n            \'bg-danger\': campagna.cliente.callStatus == \'negativo\',\n            \'bg-warning\': campagna.cliente.callStatus == \'richiama\',\n            \'bg-success\': campagna.cliente.callStatus == \'appuntamento\',\n            \'bg-info\': campagna.cliente.callStatus == \'positivo\'\n          }\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-8 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{campagna.cliente.ragSoc}}\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                {{campagna.cliente.callStatus | uppercase}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group\" ng-if=\"campagna.cliente.callStatus === \'appuntamento\'\">\n              <label class=\"control-label col-sm-2\">Agente</label>\n              <div class=\"col-sm-5\">\n                <select class=\"form-control has-warning\"\n                        ng-options=\"el.value as el.label for el in campagna.formData.agenti\"\n                        ng-model=\"campagna.telefonata.idAgente\" name=\"idAgente\"\n                        required>\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"[\'appuntamento\', \'richiama\'].includes(campagna.cliente.callStatus)\">\n              <label class=\"control-label col-sm-2\">Data</label>\n\n              <div class=\"col-xs-5 col-sm-4 col-md-3 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"campagna.telefonata.data\" name=\"data\"\n                       bs-datepicker data-min-date=\"today\"\n                       required>\n              </div>\n\n              <div class=\"col-xs-5 col-sm-3 col-md-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"hh:mm\"\n                       ng-model=\"campagna.telefonata.ora\" name=\"ora\"\n                       bs-timepicker\n                       required>\n              </div>\n\n              <div class=\"col-xs-2\">\n                <button ng-if=\"campagna.cliente.callStatus === \'appuntamento\'\"\n                        type=\"button\" class=\"btn btn-info\" title=\"Controlla Distanze\" ng-click=\"campagna.checkDistances(campagna.telefonata)\">\n                  <i class=\"fa fa-map-signs\" style=\"font-size: 1.5em\"></i>\n                </button>\n              </div>\n            </div>\n\n            <div ng-if=\"campagna.cliente.callStatus === \'richiama\'\">\n<!--\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\" title=\"Note Richiamo\">Note Ric.</label>\n                <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"campagna.telefonata.noteRichiamo\" name=\"noteRichiamo\">\n                </textarea>\n                </div>\n              </div>\n-->\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Priorità</label>\n                <div class=\"col-sm-10\">\n                  <div class=\"btn-group\"\n                       bs-radio-group\n                       ng-model=\"campagna.telefonata.priorita\">\n                    <label class=\"btn btn-default\"><input type=\"radio\" value=\"-1\">Bassa</label>\n                    <label class=\"btn btn-default\"><input type=\"radio\" value=\"0\">Normale</label>\n                    <label class=\"btn btn-default\"><input type=\"radio\" value=\"1\">Alta</label>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\" title=\"Note Telefonata\">Note Tel.</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"campagna.telefonata.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"campagna.cliente.callStatus !== \'appuntamento\'\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in campagna.formData.statiFiltrati\"\n                        ng-model=\"campagna.telefonata.idStatoTelefonata\" name=\"idStatoTelefonata\"\n                        ng-change=\"campagna.telefonata.idStatoElenco = (campagna.formData.statiFiltrati | filter:{value: campagna.telefonata.idStatoTelefonata}:true)[0].idStatoElenco\"\n                        required>\n                </select>\n              </div>\n              <div class=\"col-sm-5\">\n                <p class=\"form-control-static\">{{(campagna.formData.statiFiltrati | filter:{value: campagna.telefonata.idStatoTelefonata}:true)[0].descrizioneStatoElenco}}</p>\n              </div>\n            </div>\n\n            <div ng-if=\"campagna.cliente.callStatus === \'appuntamento\'\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Indirizzo</label>\n                <div class=\"col-sm-10\">\n                  <input type=\"text\" class=\"form-control\"\n                         ng-model=\"campagna.telefonata.indirizzo\" name=\"indirizzo\">\n                  <span class=\"help-block\">Via</span>\n                </div>\n                <div class=\"col-sm-offset-2 col-sm-2\">\n                  <input type=\"text\" class=\"form-control\"\n                         ng-model=\"campagna.telefonata.cap\" name=\"cap\">\n                  <span class=\"help-block\">CAP</span>\n                </div>\n                <div class=\"col-sm-6\">\n                  <input type=\"text\" class=\"form-control\"\n                         bs-typeahead bs-options=\"el.value as el.value for el in campagna.formData.citta\"\n                         ng-model=\"campagna.telefonata.citta\" name=\"citta\">\n                  <span class=\"help-block\">Citt&agrave;</span>\n                </div>\n                <div class=\"col-sm-2\">\n                  <input type=\"text\" class=\"form-control\"\n                         ng-model=\"campagna.telefonata.prov\" name=\"prov\">\n                  <span class=\"help-block\">Prov.</span>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Contatti</label>\n                <div class=\"col-sm-4 validate-group\">\n                  <input type=\"text\" class=\"form-control\"\n                         ng-model=\"campagna.telefonata.tel\" name=\"tel\">\n                  <span class=\"help-block\">Telefono</span>\n                </div>\n                <div class=\"col-sm-6 validate-group\">\n                  <input type=\"email\" class=\"form-control\"\n                         ng-model=\"campagna.telefonata.email\" name=\"email\">\n                  <span class=\"help-block\">Email</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{campagna.alerts.status}}\" data-messages=\"campagna.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"campagna.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script><!-- modal chiudi attività --><script type=text/ng-template id=chiudi-attivita.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-sm\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-danger\">\n          <h4 class=\"modal-title\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              <span>Termina Attività</span>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body text-center\">\n          <h4>Sei davvero sicuro di volere terminare l\'attività?</h4>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"form-group\">\n            <div class=\"col-xs-12 text-center\">\n              <button type=\"submit\" class=\"btn btn-success\" ng-click=\"campagna.closeActivity()\">Procedi</button>\n              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"campagna.undoCloseActivity()\">Annulla</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/cc/campagne/campagne.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row><div class=col-xs-12><div class=g1-panel><div class=row><div class=\"col-xs-8 text-left\"><h2 class=margin-top-8>Campagne Assegnate</h2></div><div class=\"col-xs-4 text-right\"><span class=badge>{{campagne.widgetListe.liste.length}}</span></div></div><div class=panel-body><form role=form name=search_liste class=form-horizontal ng-submit=campagne.widgetListe.search()><div class=form-group><label class=\"control-label col-xs-2 col-md-1\">Zone</label><div class=\"col-xs-10 col-md-2 validate-group\" style=\"margin-bottom: 15px\"><button type=button class=\"form-control btn btn-default\" ng-model=campagne.widgetListe.filtro.idZona name=idZona bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_liste\']\" bs-options=\"el.value as el.label for el in campagne.widgetListe.formData.zone\">Zone <span class=caret></span></button></div><label class=\"control-label col-xs-2 col-md-1\">Città</label><div class=\"col-xs-10 col-md-3 validate-group\" style=\"margin-bottom: 15px\"><input type=text class=form-control bs-typeahead data-limit=5 bs-options=\"el.value as el.value for el in campagne.widgetListe.formData.citta\" ng-model=campagne.widgetListe.filtro.citta name=citta></div><label class=\"control-label col-xs-2 col-md-1\">Tipo</label><div class=\"col-xs-10 col-md-2 validate-group\" style=\"margin-bottom: 15px\"><select class=form-control ng-model=campagne.widgetListe.filtro.aperti name=aperti><option value=1>Aperti</option><option value=8>Attese</option><option value=\"\">Entrambi</option></select></div><div class=\"col-xs-12 col-md-2 text-right\"><button class=\"btn btn-primary\" type=button title=\"Apri ricerca avanzata\" ng-click=campagne.widgetListe.toggleSearch()><i class=\"fa fa-fw\" ng-class=\"{\n                    \'fa-caret-down\': !campagne.widgetListe.showSearch,\n                    \'fa-caret-up\': campagne.widgetListe.showSearch\n                  }\"></i></button> &nbsp; <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div><div class=form-group ng-if=campagne.widgetListe.showSearch><label class=\"control-label col-xs-2 col-md-1\">Via</label><div class=\"col-xs-10 col-md-2 validate-group\" style=\"margin-bottom: 15px\"><input type=text class=form-control ng-model=campagne.widgetListe.filtro.via name=via></div><label class=\"control-label col-xs-2 col-md-1\" title=\"Ragione Sociale\">Rag.Soc.</label><div class=\"col-xs-10 col-md-3 validate-group\" style=\"margin-bottom: 15px\"><input type=text class=form-control ng-model=campagne.widgetListe.filtro.cliente name=cliente></div><label class=\"control-label col-xs-2 col-md-1\" title=\"ID Cliente\">ID Cli.</label><div class=\"col-xs-10 col-md-2 validate-group\" style=\"margin-bottom: 15px\"><input type=text class=form-control ng-model=campagne.widgetListe.filtro.idCliente name=idCliente></div></div></form><div class=row><div class=\"col-xs-12 text-center text-muted\" ng-if=\"campagne.widgetListe.liste.length <= 0\"><i class=\"fa fa-frown-o\" style=\"font-size: 8rem\"></i><br><span style=\"font-size: 4rem\">Nessuna campagna</span></div><div class=\"col-xs-12 table-responsive\" ng-if=\"campagne.widgetListe.liste.length > 0\" bind-notifier=\"{bindliste: campagne.widgetListe.liste}\"><table datatable=ng dt-options=::campagne.widgetListe.dt.options dt-column-defs=::campagne.widgetListe.dt.columnDefs class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"><thead><tr><th class=dt-date>Data</th><th>Campagna</th><th>Tipo</th><th class=\"min-width text-right\"><span title=\"Non Lavorati\">N/L</span></th><th class=\"min-width text-right\">Chiamati</th><th class=\"min-width text-right\"><span title=Appuntamentati>App.ti</span></th><th class=\"min-width text-right\">Clienti</th><th class=\"min-width text-right\">Resa</th><th class=\"min-width text-center\"></th></tr></thead><tbody><tr ng-repeat=\"lista in :bindliste:campagne.widgetListe.liste\"><td>{{lista.dataInserimento}}</td><td>{{lista.descrizione}} <i class=\"fa larger\" style=\"margin-left: 10px\" ng-class=\"{\n                         \'fa-meh-o text-danger\': lista.resa <= 3.00,\n                         \'fa-line-chart text-success\': lista.resa >= 8.00\n                       }\"></i> <i ng-if=lista.cieca class=\"fa larger fa-eye-slash\" style=\"margin-left: 10px\" title=cieca></i></td><td>{{lista.tipoMotivo}}</td><td class=\"min-width text-right\"><a ng-if=\"lista.aperti > 0\" title=\"apri clienti non lavorati\" ng-click=\"campagne.readClientiLista(lista.id, campagne.widgetListe.dt.getFiltro(lista, {aperti: campagne.widgetListe.filtro.aperti, stato: \'Non Lavorati\'}))\">{{lista.aperti}} </a><span ng-if=\"lista.aperti <= 0\">{{lista.aperti}}</span></td><td class=\"min-width text-right\"><a ng-if=\"lista.chiamati > 0\" title=\"apri clienti chiamati\" ng-click=\"campagne.readClientiLista(lista.id, campagne.widgetListe.dt.getFiltro(lista, {chiamati: \'\', stato: \'Chiamati\'}))\">{{lista.chiamati}} </a><span ng-if=\"lista.chiamati <= 0\">{{lista.chiamati}}</span></td><td class=\"min-width text-right\"><a ng-if=\"lista.appuntamentati > 0\" title=\"apri clienti appuntamentati\" ng-click=\"campagne.readClientiLista(lista.id, campagne.widgetListe.dt.getFiltro(lista, {appuntamentati: \'\', stato: \'Appuntamentati\'}))\">{{lista.appuntamentati}} </a><span ng-if=\"lista.appuntamentati <= 0\">{{lista.appuntamentati}}</span></td><td class=\"min-width text-right\"><a ng-if=\"lista.clienti > 0\" title=\"apri clienti\" ng-click=\"campagne.readClientiLista(lista.id, campagne.widgetListe.dt.getFiltro(lista))\">{{lista.clienti}} </a><span ng-if=\"lista.clienti <= 0\">{{lista.clienti}}</span></td><td class=\"min-width text-right\">{{lista.resa}}%</td><td class=\"min-width text-center\"><a href={{campagne.widgetListe.dt.linkAttivita(lista.id)}}><button type=button class=\"btn btn-primary btn-xs\">Inizia Attività</button></a></td></tr></tbody></table></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=g1-panel><div class=row><div class=\"col-xs-8 text-left\"><h2 class=margin-top-8>Attese {{campagne.widgetAttese.period}}</h2></div><div class=\"col-xs-4 text-right\"><span class=badge>{{campagne.widgetAttese.dt.instance.DataTable.data().count()}}</span></div></div><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::campagne.widgetAttese.dt.options dt-columns=::campagne.widgetAttese.dt.columns dt-instance=campagne.widgetAttese.dt.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div></div></div><br></div>");
$templateCache.put("app/cc/home/home.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row><!-- Ricerca clienti --><div class=\"col-md-8 flex-col\"><div class=g1-panel><h2>Ricerca Clienti</h2><div class=panel-body><form role=form name=home.widgetClienti.searchForm class=form-horizontal ng-submit=home.widgetClienti.search()><div class=form-group><div class=col-xs-12><div class=input-group><input type=text class=form-control placeholder=Cerca... ng-model=home.widgetClienti.sc.omnibox.searchTerm ng-keyup=\"$event.keyCode == 13 && home.widgetClienti.search()\"> <span class=input-group-btn><button class=\"btn btn-info\" type=submit title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></span></div></div></div></form><br><div class=row><div class=\"col-xs-12 table-responsive\" ng-if=\"home.widgetClienti.clienti.length > 0\" bind-notifier=\"{bindclienti: home.widgetClienti.clienti}\"><table datatable=ng dt-options=::home.widgetClienti.dt.options class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"><thead><tr><th>ID</th><th><span title=\"Ragione Sociale\">Rag.Soc.</span></th><th>Città</th><!--<th>Indirizzo</th>--><th>Ptf</th><th>Agente</th><th>Tel</th></tr></thead><tbody><tr ng-repeat=\"cliente in :bindclienti:home.widgetClienti.clienti\"><td><a title=\"apri cliente\" ng-click=home.readCliente(cliente.id)>{{cliente.id}}</a></td><td><a title=\"apri cliente\" ng-click=home.readCliente(cliente.id)>{{cliente.ragSoc}}</a></td><td>{{cliente.citta + (cliente.prov ? \' (\' + cliente.prov + \')\' : \'\')}}</td><!--<td>{{cliente.indirizzo + (cliente.civico ? \',\' + cliente.civico : \'\')}}</td>--><td>{{cliente.ptf}}</td><td>{{cliente.agenteCognome + \' \' + cliente.agenteNome}}</td><td>{{cliente.tel}}</td></tr></tbody></table></div><div class=col-xs-12 ng-if=home.widgetClienti.alerts><g1-alerts data-status={{home.widgetClienti.alerts.status}} data-messages=home.widgetClienti.alerts.messages></g1-alerts></div></div></div></div></div><!-- Q --><div class=\"col-md-4 flex-col\"><div class=g1-panel><table class=\"table table-condensed\"><tbody><tr><td rowspan=4 class=\"text-center q-logo text-primary\"><span style=\"font-size: 6rem\">Q{{home.widgetAvanzamenti.q}}</span><br><span style=\"font-size: 2rem\">{{home.widgetAvanzamenti.now | date:\'MMMM\'}}</span></td><td style=\"border-top: none\"><b>Appuntamenti nel mese</b></td><td class=text-right style=\"border-top: none\">{{home.widgetAvanzamenti.avanzamento.adv | number:0}}</td><td class=\"text-right text-{{home.widgetAvanzamenti.avanzamento.status}}\" style=\"border-top: none\"><b>{{home.widgetAvanzamenti.avanzamento.obj | number:0}}</b></td></tr><tr><td><b>Media App/gg</b></td><td class=text-right>{{home.widgetAvanzamenti.avanzamento.adv / home.widgetAvanzamenti.giorni.adv | number:2}}</td><td>&nbsp;</td><!-- placeholder --></tr><tr><td><b>Giorni</b></td><td class=text-right>{{home.widgetAvanzamenti.giorni.adv | number:0}}</td><td class=\"text-right text-{{home.widgetAvanzamenti.giorni.status}}\"><b>{{home.widgetAvanzamenti.giorni.obj | number:0}}</b></td></tr><tr><td colspan=3><progressbar value=home.widgetAvanzamenti.avanzamento.perc type=\"\'info\'\" style=\"margin-bottom: 0\">{{home.widgetAvanzamenti.avanzamento.perc | number:1}}%</progressbar></td></tr></tbody></table><br><!-- Stato generale --> <img ng-src=\"{{home.widgetAvanzamenti.imgAvanzamento || \'//:0\'}}\" style=\"width: 100%\"></div></div></div><!-- esito apps --><div class=row><div class=col-xs-12><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2 class=margin-top-8>Esito appuntamenti fissati dal {{home.widgetAppuntamenti.dt_from | date:\'shortDate\'}} al {{home.widgetAppuntamenti.dt_to | date:\'shortDate\'}}</h2></div><div class=\"col-xs-6 text-right\"><span class=badge>{{home.widgetAppuntamenti.appuntamenti.length}}</span></div></div><div ng-if=\"home.widgetAppuntamenti.appuntamenti.length > 0\" class=table-responsive><table datatable dt-options=home.widgetAppuntamenti.dt.options dt-columns=home.widgetAppuntamenti.dt.columns dt-instance=home.widgetAppuntamenti.dt.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div></div></div>");
$templateCache.put("app/components/angular-bootstrap-calendar/calendarMonthCellEvents.html","<div class=events-list ng-show=\"day.events.length > 0\"><a ng-repeat=\"event in day.events | orderBy:\'startsAt\' track by event.calendarEventId\" href=javascript:; ng-click=\"$event.stopPropagation(); vm.onEventClick({calendarEvent: event})\" class=\"pull-left event\" ng-class=event.cssClass ng-style=\"{backgroundColor: event.color.primary}\" ng-mousedown=$event.stopPropagation() ng-mouseenter=\"vm.highlightEvent(event, true)\" ng-mouseleave=\"vm.highlightEvent(event, false)\" data-container=body bs-tooltip data-title=\"{{vm.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml}}\" mwl-draggable=\"event.draggable === true\" drop-data=\"{event: event, draggedFromDate: day.date.toDate()}\" auto-scroll=vm.draggableAutoScroll></a></div>");
$templateCache.put("app/components/angular-bootstrap-calendar/calendarWeekView.html","<div class=cal-week-box ng-class=\"[{\'cal-day-box\': vm.showTimes}, \'cal-grid-\' + vm.view.days.length]\"><div class=\"cal-row-fluid cal-row-head\" mwl-element-dimensions=vm.dayColumnDimensions><div class=cal-cell1 ng-repeat=\"day in vm.view.days track by $index\" ng-class=\"{\n        \'cal-day-weekend\': day.isWeekend,\n        \'cal-day-past\': day.isPast,\n        \'cal-day-today\': day.isToday,\n        \'cal-day-future\': day.isFuture}\" mwl-droppable on-drop=\"vm.eventDropped(dropData.event, day.date)\"><span ng-bind=day.weekDayLabel></span><br><small><span data-cal-date ng-click=vm.calendarCtrl.dateClicked(day.date) class=pointer ng-bind=day.dayLabel></span></small></div></div><div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.showTimes ? (vm.dayViewHeight + \'px\') : \'auto\'}\"><mwl-calendar-hour-list day-view-start=vm.dayViewStart day-view-end=vm.dayViewEnd day-view-split=vm.dayViewSplit day-width=\"(vm.dayColumnDimensions.width - 60) / vm.view.days.length\" view-date=vm.viewDate on-timespan-click=vm.onTimespanClick on-date-range-select=vm.onDateRangeSelect custom-template-urls=vm.customTemplateUrls cell-modifier=vm.cellModifier template-scope=vm.templateScope view=week ng-if=vm.showTimes></mwl-calendar-hour-list><div class=row ng-repeat=\"row in vm.view.eventRows track by $index\"><div class=col-xs-12><div class=cal-row-fluid><div ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\" ng-class=\"\'cal-cell\' + (vm.showTimes ? 1 : eventRow.span) + (vm.showTimes ? \'\' : \' cal-offset\' + eventRow.offset)\" ng-style=\"{\n              top: vm.showTimes ? ((eventRow.top) + \'px\') : \'auto\',\n              position: vm.showTimes ? \'absolute\' : \'inherit\',\n              width: vm.showTimes ? ((vm.dayColumnDimensions.width - 60) / vm.view.days.length + \'px\') : \'\',\n              left: vm.showTimes ? (((vm.dayColumnDimensions.width - 60) / vm.view.days.length) * eventRow.offset) + 15 + \'px\' : \'\'\n            }\"><div class=day-highlight ng-class=\"[eventRow.event.cssClass, !vm.showTimes && eventRow.startsBeforeWeek ? \'\' : \'border-left-rounded\', !vm.showTimes && eventRow.endsAfterWeek ? \'\' : \'border-right-rounded\']\" ng-style=\"{backgroundColor: eventRow.event.color.secondary}\" data-event-class mwl-draggable=\"eventRow.event.draggable === true\" axis=\"vm.showTimes ? \'xy\' : \'x\'\" snap-grid=\"vm.showTimes ? {x: (vm.dayColumnDimensions.width - 60) / vm.view.days.length, y: vm.dayViewEventChunkSize || 30} : {x: vm.dayColumnDimensions.width / vm.view.days.length}\" auto-scroll=vm.draggableAutoScroll on-drag=\"vm.tempTimeChanged(eventRow.event, y / 30)\" on-drag-end=\"vm.weekDragged(eventRow.event, x / ((vm.dayColumnDimensions.width - (vm.showTimes ? 60 : 0)) / vm.view.days.length), y / 30)\" mwl-resizable=\"eventRow.event.resizable === true && eventRow.event.endsAt && !vm.showTimes\" resize-edges=\"{left: true, right: true}\" on-resize-end=\"vm.weekResized(eventRow.event, edge, x / ((vm.dayColumnDimensions.width - (vm.showTimes ? 60 : 0)) / vm.view.days.length))\"><strong ng-bind=\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:\'time\':true\" ng-hide=vm.showTimes></strong> <a href=javascript:; ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\" class=event-item ng-bind-html=\"vm.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\" bs-tooltip data-title=\"{{vm.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml}}\" data-placement=bottom data-container=body></a> <a href=javascript:; class=event-item-action ng-class=action.cssClass ng-repeat=\"action in eventRow.event.actions track by $index\" ng-bind-html=\"action.label | calendarTrustAsHtml\" ng-click=\"action.onClick({calendarEvent: eventRow.event})\"></a></div></div></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div ng-include=\"\'app/core/utenti/changePassword.html\'\"></div><nav class=\"navbar navbar-static-top navbar-default\" ng-controller=\"NavbarController as navbar\" bs-navbar><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=#/ ><img src=/assets/images/logoClycoBianco.png alt=\"Clyco Srl\"> <i class=\"fa fa-home\"></i> G1 </a><button class=\"navbar-toggle collapsed\" type=button ng-click=\"navbar.collapse = !navbar.collapse\" ng-if=navbar.user><span class=sr-only>Apri Chiudi Navigazione</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=navbar-collapse ng-class=\"{\'collapse\': navbar.collapse}\" ng-if=navbar.user><ul class=\"nav navbar-nav\" ng-if=\"navbar.auth.authorize(\'ADMIN\')\"><li data-match-route=/clienti><a ng-href=#/clienti>Clienti</a></li><li data-match-route=/opportunita><a ng-href=#/opportunita>Opportunità</a></li><li data-match-route=/contratti><a ng-href=#/contratti>Contratti</a></li><li data-match-route=/appuntamenti><a ng-href=#/appuntamenti>Appuntamenti</a></li><li data-match-route=/appuntamenti/agenda><a ng-href=#/appuntamenti/agenda>Agenda</a></li><li data-match-route=/reports.*><a ng-href=#/reports>Reports</a></li><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown>Gestione <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/admin/tabelle.*><a ng-href=#/admin/tabelle>Tabelle</a></li><li data-match-route=/provvigioni.*><a ng-href=#/provvigioni>Provvigioni</a></li><li role=separator class=divider></li><li data-match-route=/admin/soggetti><a ng-href=#/admin/soggetti>Soggetti</a></li><li data-match-route=/admin/tabelle/squadre><a ng-href=#/admin/tabelle/squadre>Squadre</a></li></ul></li><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown>Procedure <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/admin/procedure.*><a ng-href=#/admin/procedure/importa-clienti>Importa Clienti</a></li><li data-match-route=/admin/procedure.*><a ng-href=#/admin/procedure/provvigioni-schede-doppie>Provvigioni: Controllo Doppioni</a></li><li data-match-route=/admin/procedure.*><a ng-href=#/admin/procedure/incompleti>Invio Mail Incompleti</a></li></ul></li></ul><ul class=\"nav navbar-nav\" ng-if=\"navbar.auth.authorize(\'COORD\')\"><li data-match-route=/clienti><a ng-href=#/clienti>Aziende</a></li><li class=dropdown ng-if=navbar.user.flags.gestProg><a href=\"\" class=dropdown-toggle bs-dropdown data-placement=bottom-right>Opportunità <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/opportunita><a ng-href=#/opportunita>Opportunità</a></li><li data-match-route=/opportunita/progetti><a ng-href=#/opportunita/progetti>Progetti</a></li></ul></li><li data-match-route=/opportunita ng-if=!navbar.user.flags.gestProg><a ng-href=#/opportunita>Opportunità</a></li><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown data-placement=bottom-right>Ricerca <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/contratti><a ng-href=#/contratti>Contratti</a></li><li data-match-route=/appuntamenti><a ng-href=#/appuntamenti>Appuntamenti</a></li><li data-match-route=/clienti/dati><a ng-href=#/clienti/dati>Interviste</a></li><li data-match-route=/ricerca/pv><a ng-href=#/ricerca/pv>Ticket</a></li></ul></li><li data-match-route=/appuntamenti/agenda><a ng-href=#/appuntamenti/agenda>Agenda</a></li><li data-match-route=/reports.*><a ng-href=#/reports>Reports</a></li><li ng-if=\"[5,7,8].indexOf(navbar.user.userGroup) > -1\" data-match-route=/coord/sviluppo-vendite.*><a ng-href=#/coord/sviluppo-vendite>Campagne</a></li><!--\n        <li ng-if=\"navbar.user.userGroup == 7\" data-match-route=\"/provvigioni.*\"><a ng-href=\"#/provvigioni\">Provvigioni</a></li>\n        --><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown data-placement=bottom-right>Ticket <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/pv><a ng-href=#/pv>Ticket</a></li><li data-match-route=/pv/realizzazioni><a ng-href=#/pv/realizzazioni>Realizzazioni</a></li></ul></li><li ng-if=\"navbar.user.userGroup == 7\" data-match-route=/copertura><a ng-href=#/copertura>Copertura</a></li></ul><ul class=\"nav navbar-nav\" ng-if=\"navbar.auth.authorize(\'BO\')\"></ul><ul class=\"nav navbar-nav\" ng-if=\"navbar.auth.authorize(\'AGENTI\')\"><li data-match-route=/clienti><a ng-href=#/clienti>Aziende</a></li><li data-match-route=/opportunita><a ng-href=#/opportunita>Opportunità</a></li><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown data-placement=bottom-right>Ricerca <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li data-match-route=/contratti><a ng-href=#/contratti>Contratti</a></li><li data-match-route=/ricerca/provvigioni><a ng-href=#/ricerca/provvigioni>Provvigioni</a></li></ul></li><li data-match-route=/appuntamenti><a ng-href=#/appuntamenti>Appuntamenti</a></li><li data-match-route=/appuntamenti/agenda><a ng-href=#/appuntamenti/agenda>Agenda</a></li><li data-match-route=/reports.*><a ng-href=#/reports>Reports</a></li></ul><ul class=\"nav navbar-nav\" ng-if=\"navbar.auth.authorize(\'CC\')\"><li data-match-route=/clienti><a ng-href=#/clienti>Clienti</a></li><li data-match-route=/cc/campagne.*><a ng-href=#/cc/campagne>Campagne</a></li><li data-match-route=/appuntamenti><a ng-href=#/appuntamenti>Appuntamenti</a></li><li data-match-route=/appuntamenti/agenda><a ng-href=#/appuntamenti/agenda>Agenda</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li><p class=navbar-text><g1-prom-bell></g1-prom-bell></p></li><li class=dropdown><a href=\"\" class=dropdown-toggle bs-dropdown data-placement=bottom-right><span class=user-description>{{navbar.user.username}}</span> <i class=\"fa fa-user fa-fw\"></i> <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=navbar.changePassword() id=btnChangePassword><i class=\"fa fa-key fa-fw\"></i> Cambia Password</a></li><li class=divider></li><li><a href=\"\" ng-click=navbar.auth.logout()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/components/progressbar/bar.html","<div class=progress-bar ng-class=\"type && \'progress-bar-\' + type\" role=progressbar aria-valuenow={{value}} aria-valuemin=0 aria-valuemax={{max}} ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");
$templateCache.put("app/components/progressbar/progress.html","<div class=progress ng-transclude></div>");
$templateCache.put("app/components/progressbar/progressbar.html","<div class=progress><div class=progress-bar ng-class=\"type && \'progress-bar-\' + type\" role=progressbar aria-valuenow={{value}} aria-valuemin=0 aria-valuemax={{max}} ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div></div>");
$templateCache.put("app/components/widgets/g1Alerts.tpl.html","<div class=alert ng-class=\"\'alert-\' + type\" ng-repeat=\"msg in messages\"><span ng-bind-html=msg.text></span></div>");
$templateCache.put("app/coord/elenchi/elenco-create.html","<script type=text/ng-template id=elenco-create-modal.tpl.html ng-controller=\"ElencoCreateController as ecc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"ElencoCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"ecc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{((ecc.formData.liste | filter:{value: ecc.elenco.idMotivo}:true)[0].dataApertura) | date:\'shortDate\'}} -> {{((ecc.formData.liste | filter:{value: ecc.elenco.idMotivo}:true)[0].dataChiusura) | date:\'shortDate\'}}\n              </div>\n              <div class=\"col-xs-4 text-center\">\n                {{ecc.cliente.ragSoc}}\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                {{(ecc.formData.operatori | filter:{value: ecc.elenco.idOperatore}:true)[0].label}}<br>\n                {{(ecc.formData.stati | filter:{value: ecc.elenco.idStatoElenco}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Lista</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in ecc.formData.liste\"\n                        ng-model=\"ecc.elenco.idMotivo\" name=\"idMotivo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in ecc.formData.operatori\"\n                        ng-model=\"ecc.elenco.idOperatore\" name=\"idOperatore\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in ecc.formData.stati\"\n                        ng-model=\"ecc.elenco.idStatoElenco\" name=\"idStatoElenco\"\n                        required>\n                  <option value=\"0\"></option>\n                </select>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"ecc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/coord/elenchi/elenco-update.html","<script type=text/ng-template id=elenco-update-modal.tpl.html ng-controller=\"ElencoUpdateController as euc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"ElencoUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"euc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{euc.elenco.dataApertura | date:\'shortDate\'}} -> {{euc.elenco.dataChiusura | date:\'shortDate\'}}\n              </div>\n              <div class=\"col-xs-4 text-center\">\n                {{euc.elenco.cliente}}\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                {{(euc.formData.operatori | filter:{value: euc.elenco.idOperatore}:true)[0].label}}<br>\n                {{(euc.formData.stati | filter:{value: euc.elenco.idStatoElenco}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in euc.formData.stati\"\n                        ng-model=\"euc.elenco.idStatoElenco\" name=\"idStatoElenco\"\n                        required>\n                  <option value=\"0\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in euc.formData.operatori\"\n                        ng-model=\"euc.elenco.idOperatore\" name=\"idOperatore\"\n                        required>\n                </select>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"euc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/coord/elenchi/telefonate-elenco.html","<script type=text/ng-template id=telefonate-elenco-modal.tpl.html ng-controller=\"TelefonateElencoController as tec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Telefonate a {{tec.elenco.cliente}} in {{tec.elenco.motivi_descrizione}}\n              <span ng-if=\"tec.filtro.fromDate || tec.filtro.toDate\">\n                <br>\n                {{tec.filtro.fromDate ? \'dal \' + (tec.filtro.fromDate | date:\'shortDate\') + \' \' : \'\'}}\n                {{tec.filtro.toDate ? \'al \' + (tec.filtro.toDate | date:\'shortDate\') + \' \' : \'\'}}\n              </span>\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"tec.dtTelefonate.dtOptions\"\n                     dt-columns=\"::tec.dtTelefonate.dtColumns\"\n                     dt-instance=\"tec.dtTelefonate.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/coord/home/home.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div ng-include=\"\'app/coord/home/omnibox.html\'\"></div><div class=container-fluid><!-- OMNIBOX --><div class=row><div class=\"col-xs-12 col-md-4\"><div class=input-group><input type=text class=form-control placeholder=Cerca... ng-model=home.omnibox.searchTerm ng-keyup=\"$event.keyCode == 13 && home.searchOmnibox()\"> <span class=input-group-btn><button class=\"btn btn-info\" type=button ng-click=home.searchOmnibox()><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-xs-12 col-md-5\"><button type=button class=\"btn btn-default\" data-ng-model=home.omnibox.selected bs-select data-multiple=1 data-all-none-buttons=true data-max-length=2 data-bs-options=\"icon.value as icon.label for icon in home.omnibox.options\">Action <span class=caret></span></button></div><div class=\"col-xs-12 col-md-3\"><div class=\"well well-sm text-center\"><span class=\"text-primary pull-left\" style=\"font-size: 2rem; margin-top: -4px\">Q{{home.q}} </span>GIORNI {{home.giorni.adv}} / {{home.giorni.obj}} <span class=\"badge badge-{{home.giorni.status}} pull-right badge-padded\">{{home.giorni.perc | number:1}}%</span></div></div></div><!-- AVANZAMENTI --><div class=row><!-- CLYCO --><div class=\"col-md-5 flex-col\"><div class=g1-panel><h2>Avanzamento <a href=#/reports/avae bs-tooltip data-title=\"Apri Report\"><i class=\"fa fa-external-link\"></i> </a><span class=pull-right>Q{{home.q}}</span></h2><div class=row><!-- Tabella --><div class=\"col-sm-9 table-responsive\"><table class=table style=\"margin-bottom: 0\"><tbody><tr ng-repeat=\"pista in home.clyco.piste\"><td class=text-primary>{{pista.id}}</td><td class=text-right>{{pista.adv | currency:\'€\':0}}</td><td class=text-center>{{pista.perc | number:1}}%</td></tr></tbody></table></div><!-- Immagine e obiettivo --><div class=\"col-sm-3 text-center\"><div>Obiettivo<br><b class=larger>{{home.clyco.totale.obj | currency:\'€\':0}}</b></div><!-- verticale --> <img class=\"hidden-xs image-autosize\" style=\"max-height: 185px\" ng-src=\"{{home.clyco.img ? \'/assets/images/orso_toro/orso_toro\' + home.clyco.img + \'v.png\': \'//:0\'}}\"><!-- orizzontale --> <img class=\"hidden-sm hidden-md hidden-lg image-autosize\" style=\"max-height: 150px\" ng-src=\"{{home.clyco.img ? \'/assets/images/orso_toro/orso_toro\' + home.clyco.img + \'.png\': \'//:0\'}}\"><!-- percentuale --><div class=\"label label-{{home.clyco.totale.status}}\" style=\"display: block\"><span class=large>{{home.clyco.totale.perc | number:1}}%</span></div></div></div><div class=\"text-center margin-top margin-bottom\" ng-click=home.canoniRicorrenti()><h4>Canoni ricorrenti</h4><ul class=qValues><li ng-repeat=\"qValues in home.qValues track by $index\" ng-class=\"qValues.activeQ ? \'activeQ\' : \'\'\"><strong>Q{{$index + 1}}</strong><br>{{qValues.ricorrente | currency:\'€\':0}}</li><li><strong>Totale<br>{{home.totaleRicorrente | currency:\'€\':0}}</strong></li></ul></div><!-- Warnings --><div class=row ng-if=home.clyco.warnings.length><div class=\"col-xs-12 flex-col\"><g1-alerts data-status=417 data-messages=home.clyco.warnings></g1-alerts></div></div></div></div><!-- BACKLOG --><div class=\"col-md-7 flex-col\"><div class=g1-panel><h2>Backlog <a href=#/reports/bckd bs-tooltip data-title=\"Apri Report\"><i class=\"fa fa-external-link\"></i></a></h2><div class=table-responsive ng-if=home.bckdReport g1-report report-id=bckd report-options=home.bckdReport.options report-dt-options=home.bckdReport.dtOptions></div></div><div class=g1-panel><h2>Contratti in scadenza <a href=\"#/contratti?inScadenza=1\" bs-tooltip data-title=\"Vai a sezione\"><i class=\"fa fa-external-link\"></i></a></h2><table class=table><thead><tr><th></th><th class=text-center ng-repeat=\"row in home.contrattiInScadenza\">{{row.agente}}</th></tr></thead><tbody><tr><th>Contratti</th><th class=text-center ng-repeat=\"row in home.contrattiInScadenza\"><a href=\"#/contratti?inScadenza=1&idAgente={{row.idAgente}}\">{{row.contrattiInScadenza}}</a></th></tr></tbody></table></div></div></div><!-- Campagne & Opportunità --><div class=row><div class=\"col-md-5 flex-col\"><div class=g1-panel><h2>Campagne</h2><div class=table-responsive><table datatable dt-options=home.dtCampagne.dtOptions dt-columns=::home.dtCampagne.dtColumns dt-instance=home.dtCampagne.dtInstance class=\"table table-hover\"></table></div></div><div class=g1-panel><h2>Progetti <a href=#/opportunita/progetti bs-tooltip data-title=\"Vai a sezione\"><i class=\"fa fa-external-link\"></i></a></h2><div class=table-responsive><table datatable dt-options=home.dtProgetti.dtOptions dt-columns=::home.dtProgetti.dtColumns dt-instance=home.dtProgetti.dtInstance class=\"table table-hover\"></table></div></div></div><div class=\"col-md-7 flex-col\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2>{{home.chartOpportunita.title}} <a href=#/reports/oppo bs-tooltip data-title=\"Apri Report\"><i class=\"fa fa-external-link\"></i></a></h2></div><div class=\"col-xs-6 text-right\"><h2>{{home.chartOpportunita.total}}</h2></div></div><div class=panel-body><form role=form name=search_chartAvanzamento class=form-inline><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartOpportunita.formData.tipi><label class=radio-inline><input type=radio value=ComboChart ng-model=home.chartOpportunita.options.tipo name=tipo>&nbsp;Grafico a colonne</label><label class=radio-inline><input type=radio value=PieChart ng-model=home.chartOpportunita.options.tipo name=tipo>&nbsp;Grafico a torta</label></div></form><div class=row><div class=col-xs-12 ng-if=home.chartOpportunita.options><div g1-chart chart-id={{home.chartOpportunita.id}} chart-options=home.chartOpportunita.options chart-title=home.chartOpportunita.title chart-total=home.chartOpportunita.total></div></div></div></div></div></div></div><!-- Contratti, Postvendita & avanzamento --><div class=row><div class=\"col-md-5 flex-col\"><div class=g1-panel><h2>Contratti per giorno <a href=#/reports/cngp bs-tooltip data-title=\"Apri Report\"><i class=\"fa fa-external-link\"></i></a></h2><div class=table-responsive ng-if=home.cngpReport g1-report report-id=cngp report-options=home.cngpReport.options report-dt-options=home.cngpReport.dtOptions></div></div><div class=g1-panel><h2><div class=row><div class=\"col-xs-6 text-left\">Attività tecnica <a ng-href=\"#/reports/pvfp?gb=pri{{!home.user.flags.powerUser ? \'&idAgenti[]=\' + home.user.idAgente : \'\'}}\" bs-tooltip data-title=\"Apri Report\"><i class=\"fa fa-external-link\"></i></a></div><div class=\"col-xs-6 text-right\"><small><a href=/#pv target=_blank>Dashboard</a></small></div></div></h2><div class=row ng-if=home.pvReport><div class=col-xs-12><div bs-tabs bs-active-pane=pv.activeTab ng-init=\"pv.activeTab = 0\"><div data-title=Postvendita bs-pane><div class=\"table-responsive margin-top\" g1-report report-id=pvfp report-options=home.pvReport_pv.options report-dt-options=home.pvReport_pv.dtOptions></div></div><div data-title=Realizzazioni bs-pane><div class=\"table-responsive margin-top\" g1-report report-id=pvfp report-options=home.pvReport_real.options report-dt-options=home.pvReport_real.dtOptions></div></div></div></div></div></div></div><div class=\"col-md-7 flex-col\"><div class=g1-panel><div class=row><div class=\"col-xs-6 text-left\"><h2>{{home.chartAvanzamento.title}}</h2></div><div class=\"col-xs-6 text-right\"><h2>{{home.chartAvanzamento.total}}</h2></div></div><div class=panel-body><form role=form name=search_chartAvanzamento class=form-inline><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.anni><label class=control-label>Anno</label><select class=form-control ng-options=\"el.value as el.label for el in home.chartAvanzamento.formData.anni\" ng-model=home.chartAvanzamento.options.anno name=anno></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.tipiData><label class=control-label>Data</label><select class=form-control ng-options=\"el.value as el.label for el in home.chartAvanzamento.formData.tipiData\" ng-change=home.chartAvanzamento.setStati(home.chartAvanzamento.options.tipoData) ng-model=home.chartAvanzamento.options.tipoData name=tipoData></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.stati><label class=control-label>Stati</label><button type=button class=\"btn btn-default\" ng-model=\"home.chartAvanzamento.options[\'idStati[]\']\" ng-model-options=\"{updateOn: \'blur\'}\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 bs-options=\"el.value as el.label for el in home.chartAvanzamento.formData.stati\">Stati <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=home.chartAvanzamento.formData.tipi><label class=radio-inline><input type=radio value=ComboChart ng-model=home.chartAvanzamento.options.tipo name=tipo>&nbsp;Grafico a colonne</label><label class=radio-inline><input type=radio value=PieChart ng-model=home.chartAvanzamento.options.tipo name=tipo>&nbsp;Grafico a torta</label></div></form><div class=row><div class=col-xs-12 ng-if=home.chartAvanzamento.options><div g1-chart chart-id={{home.chartAvanzamento.id}} chart-options=home.chartAvanzamento.options chart-title=home.chartAvanzamento.title chart-total=home.chartAvanzamento.total></div></div></div></div></div></div></div><br></div>");
$templateCache.put("app/coord/home/omnibox.html","<script type=text/ng-template id=omnibox-modal.tpl.html ng-controller=\"OmniboxController as omnibox\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Ricerca rapida clienti\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12\" ng-if=\"omnibox.dtClienti.dtInstance\">\n              <table datatable\n                dt-options=\"::omnibox.dtClienti.dtOptions\"\n                dt-columns=\"::omnibox.dtClienti.dtColumns\"\n                dt-instance=\"omnibox.dtClienti.dtInstance\"\n                class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/coord/sviluppo-vendite/sviluppo-vendite.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row ng-if=\"sviluppoVendite.user.userGroup >= 5\"><div class=col-xs-12><div class=g1-panel><div class=panel-body><form name=sviluppoVendite.chiamateForm class=form-horizontal ng-submit=sviluppoVendite.widgetChiamate.submitForm()><div class=form-group><div class=\"col-xs-12 col-md-4 text-center\" style=\"margin-bottom: 15px\"><button type=button class=btn ng-click=\"sviluppoVendite.widgetChiamate.setDate(\'now\')\" ng-class=\"{\n                          \'btn-info\': !sviluppoVendite.widgetChiamate.checkActiveButton(\'now\'),\n                          \'btn-primary\': sviluppoVendite.widgetChiamate.checkActiveButton(\'now\')\n                        }\">Oggi</button> <span style=\"margin-right: 1em\"></span> <button type=button class=btn ng-click=\"sviluppoVendite.widgetChiamate.setDate(\'week\')\" ng-class=\"{\n                          \'btn-info\': !sviluppoVendite.widgetChiamate.checkActiveButton(\'week\'),\n                          \'btn-primary\': sviluppoVendite.widgetChiamate.checkActiveButton(\'week\')\n                        }\">Settimana</button> <span style=\"margin-right: 1em\"></span> <button type=button class=btn ng-click=\"sviluppoVendite.widgetChiamate.setDate(\'month\')\" ng-class=\"{\n                          \'btn-info\': !sviluppoVendite.widgetChiamate.checkActiveButton(\'month\'),\n                          \'btn-primary\': sviluppoVendite.widgetChiamate.checkActiveButton(\'month\')\n                        }\">Mese</button></div><div class=\"col-xs-6 col-md-2 validate-group\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=sviluppoVendite.widgetChiamate.st.fromDate name=fromDate bs-datepicker data-max-date={{sviluppoVendite.widgetChiamate.st.toDate}} required></div><div class=\"col-xs-6 col-md-2 validate-group\" style=\"margin-bottom: 15px\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=sviluppoVendite.widgetChiamate.st.toDate name=toDate bs-datepicker data-min-date={{sviluppoVendite.widgetChiamate.st.fromDate}} required></div><div class=\"col-xs-2 col-md-1 text-right\" style=\"margin-bottom: 15px\"><span class=visible-xs-inline style=\"margin-left: 15px\"></span> <button type=submit class=\"btn btn-info\"><i class=\"fa fa-search\"></i></button></div></div></form><div class=row><div class=\"col-sm-8 flex-col text-center text-muted\" style=\"justify-content: center\" ng-show=\"sviluppoVendite.widgetChiamate.chiamateOperatori.length <= 0\"><i class=\"fa fa-frown-o\" style=\"font-size: 8rem\"></i><br><span style=\"font-size: 4rem\">Nessuna Attività</span></div><div class=\"col-sm-8 table-responsive\" ng-show=\"sviluppoVendite.widgetChiamate.chiamateOperatori.length > 0\"><table datatable dt-options=::sviluppoVendite.widgetChiamate.dt.options dt-columns=::sviluppoVendite.widgetChiamate.dt.columns dt-instance=sviluppoVendite.widgetChiamate.dt.instance class=\"table table-hover table-condensed\"></table></div><div class=\"col-sm-4 flex-col larger\" style=\"justify-content: center\"><br><div class=text-center><p class=large>Appuntamenti<br>Da&nbsp;Campagne<br><a ng-href=\"\" ng-click=\"sviluppoVendite.readAppuntamenti({\n                    fromDate:sviluppoVendite.widgetChiamate.st.fromDate,\n                    toDate: sviluppoVendite.widgetChiamate.st.toDate,\n                    idMotivo: \'TUTTI\'\n                  })\"><span class=large>{{sviluppoVendite.widgetChiamate.totali.appuntamenti}}</span></a></p></div><div class=text-center><p>Telefonate<br><a ng-href=\"\" ng-click=\"sviluppoVendite.readListeOperatore({\n                    fromDate:sviluppoVendite.widgetChiamate.st.fromDate,\n                    toDate: sviluppoVendite.widgetChiamate.st.toDate,\n                    idOperatore: 0\n                  })\">{{sviluppoVendite.widgetChiamate.totali.telefonate}}&nbsp;({{sviluppoVendite.widgetChiamate.totali.resaTelefonate}}&nbsp;%)</a></p></div><div class=text-center><p>Clienti Chiamati<br><a ng-href=\"\" ng-click=\"sviluppoVendite.readListeOperatore({\n                    fromDate:sviluppoVendite.widgetChiamate.st.fromDate,\n                    toDate: sviluppoVendite.widgetChiamate.st.toDate,\n                    idOperatore: 0\n                  })\">{{sviluppoVendite.widgetChiamate.totali.chiamati}}&nbsp;({{sviluppoVendite.widgetChiamate.totali.resaChiamati}}&nbsp;%)</a></p></div><div class=text-center><p><a ng-href=\"\" ng-click=\"sviluppoVendite.readAppuntamenti({\n                    fromDate:sviluppoVendite.widgetChiamate.st.fromDate,\n                    toDate: sviluppoVendite.widgetChiamate.st.toDate,\n                    idMotivo: \'NESSUNO\'\n                  })\">Appuntamenti<br>In&nbsp;Autonomia</a></p></div></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=g1-panel><div class=row><div class=\"col-xs-4 text-left\"><h2 class=margin-top-8>Campagne in corso <a href=#/coord/sviluppo-vendite/liste><button type=button class=\"btn btn-info btn-xs\" title=\"Apri ricerca campagne\"><i class=\"fa fa-search\"></i></button></a></h2></div><div class=\"col-xs-4 text-center\"><button type=button class=\"btn btn-default\" ng-model=\"sviluppoVendite.widgetListe.sl[\'tipoMotivo[]\']\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 bs-options=\"el.value as el.label for el in sviluppoVendite.widgetListe.formData.tipi\">Action <span class=caret></span></button> <button type=submit class=\"btn btn-info\" title=Filtra ng-click=sviluppoVendite.widgetListe.submitForm()><i class=\"fa fa-search\"></i></button></div><div class=\"col-xs-4 text-right\"><span class=badge>{{sviluppoVendite.widgetListe.liste.length}}</span></div></div><div class=panel-body ng-show=\"sviluppoVendite.widgetListe.liste.length <= 0\"><div class=row><div class=\"col-xs-12 text-center text-muted\"><i class=\"fa fa-frown-o\" style=\"font-size: 8rem\"></i><br><span style=\"font-size: 4rem\">Nessuna campagna</span></div></div><div class=row><div class=col-xs-12><div class=btn-group ng-if=\"sviluppoVendite.user.userGroup >= 5\"><button type=button class=\"btn btn-success\" title=\"Genera campagna da filtri\" ng-click=sviluppoVendite.importLista()>Genera</button> <button type=button class=\"btn btn-success\" title=\"Inserisci campagna vuota\" ng-click=sviluppoVendite.createLista()>Inserisci</button></div></div></div></div><div class=row ng-show=\"sviluppoVendite.widgetListe.liste.length > 0\"><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::sviluppoVendite.widgetListe.dt.options dt-columns=::sviluppoVendite.widgetListe.dt.columns dt-instance=sviluppoVendite.widgetListe.dt.instance class=\"table table-hover table-condensed\" style=\"margin-bottom: 0\"></table></div></div></div></div></div><br></div>");
$templateCache.put("app/core/allegati/allegato-edit.html","<script type=text/ng-template id=allegato-edit-modal.tpl.html ng-controller=\"AllegatoEditController as aec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"ListaImportForm\" class=\"form-horizontal dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{aec.action === \'create\' ? \'Inserisci\' : \'Modifica\'}} Allegato\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n\n            <div class=\"panel-body\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Descrizione</label>\n                <div class=\"col-sm-10 has-warning\">\n                  <input type=\"text\" class=\"form-control\"\n                    ng-model=\"aec.allegato.descrizione\" name=\"descrizione\"\n                    required>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Tipo</label>\n                <div class=\"col-sm-10 has-warning\">\n                  <select class=\"form-control\"\n                    ng-options=\"el.value as el.label for el in aec.formData.tipi\"\n                    ng-model=\"aec.allegato.idTipoAllegato\" name=\"idTipoAllegato\"\n                    required>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-xs-12 col-sm-2\">File</label>\n\n                <!-- file in inserimento -->\n                <div ng-if=\"aec.action === \'create\'\">\n                  <div class=\"col-xs-10 col-sm-8 has-warning\">\n                    <input type=\"file\" class=\"form-control\" ngf-select\n                      ngf-pattern=\"\'.csv,.xls,.xlsx,.doc,.docx,.pcap,.pdf,.txt,.zip,image/*\'\"\n                      pattern-err-type=\"filePattern\" ngf-max-size=\"50MB\"\n                      ng-model=\"aec.allegato.fileAllegato\" name=\"fileAllegato\">\n\n                    <div ng-show=\"aec.allegato.fileAllegato.progress >= 0\">\n                      <br>\n                      <progressbar value=\"aec.allegato.fileAllegato.progress\" type=\"info\" style=\"margin-bottom: 0;\">\n                        {{aec.allegato.fileAllegato.progress | number:0}}%\n                      </progressbar>\n                    </div>\n                  </div>\n\n                  <div class=\"col-xs-2 text-center\">\n                    <i class=\"fa fa-2x fa-info-circle text-primary\" title=\"Informazioni\"\n                      data-content=\"i tipi di allegato permessi sono csv, Excel, Word, PDF, pcap, zip ed immagini fino ad un max di 20MB\"\n                      data-placement=\"left\" data-auto-close=\"true\"\n                      bs-popover></i>\n                  </div>\n                </div>\n\n                <!-- file in modifica -->\n                <div class=\"col-sm-10\" ng-if=\"aec.action === \'update\'\">\n                  <p class=\"form-control-static\">\n                    <a ng-href=\"{{aec.allegato.mainUrl}}?preview\" target=\"_blank\" class=\"btn btn-primary btn-xs\" bs-tooltip data-title=\"Anteprima\"><i class=\"fa fa-eye\"></i> Anteprima</a>\n                    <a ng-href=\"{{aec.allegato.mainUrl}}?download\" target=\"_blank\" class=\"btn btn-primary btn-xs\" bs-tooltip data-title=\"Scarica\"><i class=\"fa fa-download\"></i> Scarica</a>\n                  </p>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Note</label>\n                <div class=\"col-sm-10\">\n                  <textarea rows=\"2\" class=\"form-control\"\n                            ng-model=\"aec.allegato.note\" name=\"note\">\n                  </textarea>\n                </div>\n              </div>\n            </div>\n            <!-- messaggi di warning/errore -->\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{aec.alerts.status}}\" data-messages=\"aec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"aec.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/agenda.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=\"container-fluid g1-panel\"><div class=row><div class=\"col-xs-4 text-left\"><a ng-href=\"\" ng-click=agenda.createAppuntamentoPrivato(agenda.sa.idAgente) title=\"Inserisci appuntamento privato in agenda\"><i class=\"fa fa-calendar-plus-o\"></i> Appuntamento&nbsp;Privato</a></div><div class=\"col-xs-4 text-center\"><h2>{{agenda.cal.viewTitle}}</h2></div><div class=\"col-xs-4 text-right\"><a ng-if=\"agenda.user.idAgente != \'\'\" ng-href=\"\" ng-click=agenda.syncGcal() title=\"Sincronizza settimana attuale con Google Calendar\">Sync con Gcal</a></div></div><div class=row><div class=\"col-sm-4 text-center\"><div class=btn-group><button class=\"btn btn-primary\" mwl-date-modifier date=agenda.cal.viewDate decrement=agenda.cal.view>&Lt;</button> <button class=\"btn btn-default\" mwl-date-modifier date=agenda.cal.viewDate set-to-today>Oggi</button> <button class=\"btn btn-primary\" mwl-date-modifier date=agenda.cal.viewDate increment=agenda.cal.view>&Gt;</button></div></div><br class=visible-xs><div class=\"col-sm-4 text-center form-inline\"><div class=form-group ng-if=\"!agenda.auth.authorize(\'AGENTI\')\"><select class=form-control ng-options=\"el.value as el.label for el in agenda.formData.agenti\" ng-model=agenda.sa.idAgente name=idAgente></select><button type=button class=\"form-control btn btn-info\" ng-disabled=\"agenda.sa.idAgente <= 0\" ng-attr-title=\"{{ agenda.sa.idAgente <= 0 ? \'Scegli un agente\' : \'Stampa Agenda\'}}\" ng-click=agenda.printAgenda()><i class=\"fa fa-fw fa-print\"></i></button><br class=visible-xs></div><div class=form-group ng-if=\"agenda.auth.authorize(\'AGENTI\')\"><button type=button class=\"btn btn-info\" title=\"Stampa Agenda\" ng-click=agenda.printAgenda()><i class=\"fa fa-fw fa-print\"></i>&nbsp;Stampa</button></div></div><div class=\"col-sm-4 text-center\"><div class=btn-group ng-model=agenda.cal.view bs-radio-group><!--<label class=\"btn btn-primary\"><input type=\"radio\" value=\"year\">Anno</label>--><label class=\"btn btn-primary\"><input type=radio value=month>Mese</label><label class=\"btn btn-primary\"><input type=radio value=week>Settimana</label><label class=\"btn btn-primary\"><input type=radio value=day>Giorno</label></div></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-xs-offset-1 col-xs-10\"><mwl-calendar view=agenda.cal.view view-title=agenda.cal.viewTitle view-date=agenda.cal.viewDate events=agenda.cal.events on-event-click=agenda.eventClicked(calendarEvent) day-view-start=08:00 day-view-end=18:59></mwl-calendar></div></div></div>");
$templateCache.put("app/core/appuntamenti/appuntamenti-modal.html","<script type=text/ng-template id=appuntamenti-modal.tpl.html ng-controller=\"AppuntamentiModalController as amc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Appuntamenti\n              {{amc.filtro.statoAppuntamento ? \' in \' + amc.filtro.statoAppuntamento : \'\'}}\n              {{amc.filtro.motivo ? \' in \' + amc.filtro.motivo : \'\'}}\n              {{amc.filtro.agente ? \' di \' + amc.filtro.agente : \'\'}}\n              {{amc.filtro.cliente ? \' di \' + amc.filtro.cliente : \'\'}}\n              {{amc.filtro.operatore ? \' di \' + amc.filtro.operatore : \'\'}}\n              <span ng-if=\"amc.filtro.dt_from || amc.filtro.dt_to\">\n                <br>\n                {{amc.filtro.dt_from ? \' Dal \' + (amc.filtro.dt_from | date:\'shortDate\'): \'\'}}\n                {{amc.filtro.dt_to ? \' al \' + (amc.filtro.dt_to | date:\'shortDate\'): \'\'}}\n              </span>\n              <span ng-if=\"amc.filtro.fromDate || amc.filtro.toDate\">\n                <br>\n                {{amc.filtro.fromDate ? \' Dal \' + (amc.filtro.fromDate | date:\'shortDate\'): \'\'}}\n                {{amc.filtro.toDate ? \' al \' + (amc.filtro.toDate | date:\'shortDate\'): \'\'}}\n              </span>\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::amc.dtAppuntamenti.dtOptions\"\n                     dt-columns=\"::amc.dtAppuntamenti.dtColumns\"\n                     dt-instance=\"amc.dtAppuntamenti.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/appuntamenti.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_appuntamenti\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><h2 class=text-primary>Ricerca Appuntamenti</h2><form role=form name=search_appuntamenti class=form-horizontal ng-submit=appuntamenti.search()><div class=row><div class=\"col-sm-6 col-lg-5\"><div class=form-group><label class=\"control-label col-xs-2\" title=\"Data Appuntamento\">Data App.</label><div class=\"col-xs-5 validate-group\"><input type=text placeholder=Da class=form-control ng-model=appuntamenti.sa.dt_from name=dt_from bs-datepicker data-max-date={{appuntamenti.sa.dt_to}}></div><div class=\"col-xs-5 validate-group\"><input type=text placeholder=A class=form-control ng-model=appuntamenti.sa.dt_to name=dt_to bs-datepicker data-placement=bottom-right data-min-date={{appuntamenti.sa.dt_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Rag.Soc.</label><div class=col-xs-10><input type=input class=form-control ng-model=appuntamenti.sa.ragSoc name=ragSoc></div></div><div class=form-group><label class=\"control-label col-xs-2\">Città</label><div class=col-xs-10><input type=text class=form-control bs-typeahead bs-options=\"el.value as el.value for el in appuntamenti.formData.citta\" ng-model=appuntamenti.sa.citta name=citta></div></div><div class=form-group><label class=\"control-label col-xs-2\">Note</label><div class=col-xs-10><input type=text class=form-control ng-model=appuntamenti.sa.note name=note></div></div><div class=form-group ng-if=\"appuntamenti.user.userGroup > 1\"><label class=\"control-label col-xs-2\">Agente</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in appuntamenti.formData.agenti\" ng-model=appuntamenti.sa.idAgente name=idAgente></select></div></div><div class=form-group ng-if=\"appuntamenti.user.userGroup > 1 && appuntamenti.user.userGroup < 10\"><label class=\"control-label col-xs-2\">Segnalatore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in appuntamenti.formData.segnalatori\" ng-model=appuntamenti.sa.idSegnalatore name=idSegnalatore><option value=\"\">TUTTI</option></select></div></div><div class=form-group ng-if=\"appuntamenti.user.userGroup == 1\"><div class=\"checkbox col-xs-offset-0 col-xs-12 col-sm-offset-2 col-sm-10\"><label><input type=checkbox ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-model=appuntamenti.sa.idSegnalatore name=idSegnalatore> <b>&nbsp;Ricerca appuntamenti segnalati</b></label></div></div></div><div class=\"col-sm-6 col-lg-5\"><div class=form-group><label class=\"control-label col-xs-2\">Stato</label><div class=col-xs-10><button type=button class=\"btn btn-default\" ng-model=\"appuntamenti.sa[\'idStatoAppuntamento[]\']\" bs-select data-multiple=1 data-max-length=3 data-all-none-buttons=1 data-container=\"form[name=\'search_appuntamenti\']\" bs-options=\"el.value as el.label for el in appuntamenti.formData.stati\">Action <span class=caret></span></button></div></div><div class=form-group ng-if=\"appuntamenti.user.userGroup < 10\"><label class=\"control-label col-xs-2\">Ptf</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in appuntamenti.formData.ptf\" ng-model=appuntamenti.sa.idPtf name=idPtf><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Zona</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in appuntamenti.formData.zone\" ng-model=appuntamenti.sa.idZona name=idZona><option value=\"\"></option></select></div></div><div class=form-group ng-if=\"appuntamenti.user.userGroup < 10\"><label class=\"control-label col-xs-2\">Campagna</label><div class=col-xs-10><input type=text class=form-control bs-typeahead bs-options=\"el.value as el.label for el in appuntamenti.formData.campagne\" ng-model=appuntamenti.sa.idMotivo name=idMotivo></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Data Inserimento Appuntamento\">Data Ins.</label><div class=\"col-xs-5 validate-group\"><input type=text placeholder=Da class=form-control ng-model=appuntamenti.sa.fromDate name=fromDate bs-datepicker data-max-date={{appuntamenti.sa.toDate}}></div><div class=\"col-xs-5 validate-group\"><input type=text placeholder=A class=form-control ng-model=appuntamenti.sa.toDate name=toDate bs-datepicker data-placement=bottom-right data-min-date={{appuntamenti.sa.fromDate}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Operatore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in appuntamenti.formData.operatori\" ng-model=appuntamenti.sa.idOperatore name=idOperatore><option value=\"\">TUTTI</option></select></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-lg-5 validate-group\" ng-if=\"[\'5\',\'7\',\'8\'].indexOf(appuntamenti.user.userGroup) > -1\"><div class=checkbox><label><input type=checkbox ng-change=\"appuntamenti.sa.tipoRichiamo = \'0\'\" ng-model=appuntamenti.sa.nonAperti name=nonAperti> <b>&nbsp;Escludi aperti in campagne</b></label></div><span ng-if=appuntamenti.sa.nonAperti><label class=control-label>Considera:&nbsp;&nbsp;</label><div class=radio-inline><label style=\"font-weight: normal\"><input type=radio ng-model=appuntamenti.sa.tipoRichiamo name=tipoRichiamo value=0>Tutte le campagne</label></div><div class=radio-inline><label style=\"font-weight: normal\"><input type=radio ng-model=appuntamenti.sa.tipoRichiamo name=tipoRichiamo value=1>Solo richiamo</label></div></span></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-12 col-sm-6 col-lg-5 text-right\"><span style=\"margin-right: 1em\"></span> <button type=reset class=\"btn btn-warning\" title=Resetta ng-click=appuntamenti.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row><div class=col-xs-12 style=\"margin-top: 15px\"><g1-alerts data-status={{appuntamenti.alerts.status}} data-messages=appuntamenti.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=appuntamenti.showResults><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=appuntamenti.dtAppuntamenti.dtOptions dt-columns=::appuntamenti.dtAppuntamenti.dtColumns dt-instance=appuntamenti.dtAppuntamenti.dtInstance class=\"table table-hover\"></table></div></div></div><br></div>");
$templateCache.put("app/core/appuntamenti/appuntamento-create.html","<script type=text/ng-template id=appuntamento-create-modal.tpl.html ng-controller=\"AppuntamentoCreateController as acc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"acc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                Nuovo Appuntamento {{acc.appuntamento.data | date:\'shortDate\'}} {{acc.appuntamento.ora | date:\'shortTime\'}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{acc.appuntamento.cliente}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{(acc.formData.stati | filter:{value: acc.appuntamento.idStatoAppuntamento}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Agente</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in acc.formData.agenti\"\n                  ng-model=\"acc.appuntamento.idAgente\" name=\"idAgente\"\n                  required>\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Orario</label>\n              <div class=\"clearfix visible-xs-block\"></div>\n\n              <div class=\"col-xs-5 col-sm-4 col-md-3 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"acc.appuntamento.data\" name=\"data\"\n                  bs-datepicker\n                  required>\n                <span class=\"help-block\">Data</span>\n              </div>\n\n              <div class=\"col-xs-5 col-sm-3 col-md-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"hh:mm\"\n                  ng-model=\"acc.appuntamento.ora\" name=\"ora\"\n                  bs-timepicker\n                  required>\n                <span class=\"help-block\">Ora</span>\n              </div>\n\n              <div class=\"col-xs-2\">\n                <button type=\"button\" class=\"btn btn-info\" title=\"Controlla Distanze\" ng-click=\"acc.checkDistances(acc.appuntamento)\">\n                  <i class=\"fa fa-map-signs\" style=\"font-size: 1.5em\"></i>\n                </button>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"acc.user.userGroup < 9\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in acc.formData.stati\"\n                  ng-model=\"acc.appuntamento.idStatoAppuntamento\" name=\"idStatoAppuntamento\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-5\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.noteOperatore\" name=\"noteOperatore\">\n                </textarea>\n                <span class=\"help-block\">Note Operatore</span>\n              </div>\n              <div class=\"col-sm-5\" ng-if=\"acc.user.userGroup < 9\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.noteAgente\" name=\"noteAgente\">\n                </textarea>\n                <span class=\"help-block\">Note Agente</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"acc.appuntamento.idCliente == \'\'\">\n              <label class=\"control-label col-sm-2\">Cliente</label>\n              <div class=\"col-sm-4 has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.cliente\" name=\"cliente\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2 cursorPointer\" for=\"sedeCliente\">Indirizzo <i class=\"fa fa-address-book\"></i></label>\n              <div class=\"col-sm-10\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"acc.appuntamento.indirizzo\"\n                  name=\"indirizzo\"\n                  id=\"sedeCliente\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-on-select=\"acc.setSedeCliente\"\n                  bs-options=\"el.idSede as ( el.nome ? el.nome : ( el.indirizzo ? ( el.indirizzo + \' - \' + el.citta + \' (\' + el.prov + \')\' ) : \'\' ) ) for el in acc.formData.sediCliente\"\n                  data-placement=\"bottom-left\"\n                  required>\n                <span class=\"help-block\">Indirizzo</span>\n              </div>\n              <div class=\"col-sm-offset-2 col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.cap\" name=\"cap\">\n                <span class=\"help-block\">CAP</span>\n              </div>\n              <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.citta\" name=\"citta\">\n                <span class=\"help-block\">Citt&agrave;</span>\n              </div>\n              <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.prov\" name=\"prov\">\n                <span class=\"help-block\">Prov.</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatti</label>\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.tel\" name=\"tel\">\n                <span class=\"help-block\">Telefono</span>\n              </div>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"email\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.email\" name=\"email\">\n                <span class=\"help-block\">Email</span>\n              </div>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"acc.appuntamento.cell\" name=\"cell\">\n                <span class=\"help-block\">Cellulare</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"acc.user.userGroup < 9\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in acc.formData.operatori\"\n                  ng-model=\"acc.appuntamento.idOperatore\" name=\"idOperatore\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"acc.user.userGroup < 9\">\n              <label class=\"control-label col-sm-2\">Segnalatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in acc.formData.segnalatori\"\n                  ng-model=\"acc.appuntamento.idSegnalatore\" name=\"idSegnalatore\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"acc.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{acc.alerts.status}}\" data-messages=\"acc.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"acc.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/appuntamento-update.html","<script type=text/ng-template id=appuntamento-update-modal.tpl.html ng-controller=\"AppuntamentoUpdateController as auc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"auc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{auc.appuntamento.data | date:\'shortDate\'}}&nbsp;{{auc.appuntamento.ora | date:\'shortTime\'}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{auc.appuntamento.cliente}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{(auc.formData.stati | filter:{value: auc.appuntamento.idStatoAppuntamento}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Agente</label>\n              <div class=\"col-sm-5\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in auc.formData.agenti\"\n                  ng-model=\"auc.appuntamento.idAgente\" name=\"idAgente\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Orario</label>\n              <div class=\"col-xs-6 col-sm-4 col-md-3 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"auc.appuntamento.data\" name=\"data\"\n                  bs-datepicker\n                  required>\n                <span class=\"help-block\">Data</span>\n              </div>\n              <div class=\"col-xs-6 col-sm-3 col-md-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"hh:mm\"\n                  ng-model=\"auc.appuntamento.ora\" name=\"ora\"\n                  bs-timepicker\n                  required>\n                <span class=\"help-block\">Ora</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in auc.formData.stati\"\n                  ng-model=\"auc.appuntamento.idStatoAppuntamento\" name=\"idStatoAppuntamento\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-5\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.noteOperatore\" name=\"noteOperatore\"></textarea>\n                <span class=\"help-block\">Note Operatore</span>\n              </div>\n              <div class=\"col-sm-5\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.noteAgente\" name=\"noteAgente\"\n                  ng-disabled=\"auc.user.userGroup == 2\"></textarea>\n                <span class=\"help-block\">Note Agente</span>\n              </div>\n            </div>\n\n            <!-- Se lo stato È rifissare -->\n            <span ng-if=\"auc.appuntamento.idStatoAppuntamento == 106\">\n              <div class=\"form-group has-warning\">\n                <label class=\"control-label col-sm-2\">Data Richiamo</label>\n                <div class=\"col-sm-5\">\n                  <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aa\"\n                    ng-model=\"auc.appuntamento.dataRichiamo\" name=\"dataRichiamo\"\n                    bs-datepicker\n                    required>\n                </div>\n              </div>\n\n              <div class=\"form-group has-warning\">\n                <label class=\"control-label col-sm-2\">Note Richiamo</label>\n                <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                    ng-model=\"auc.appuntamento.noteRichiamo\" name=\"noteRichiamo\"\n                    required>\n                  </textarea>\n                </div>\n              </div>\n            </span>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Cliente</label>\n              <div class=\"col-sm-10 has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.cliente\" name=\"cliente\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2 cursorPointer\" for=\"sedeCliente\">Indirizzo <i class=\"fa fa-address-book\"></i></label>\n              <div class=\"col-sm-10\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"auc.appuntamento.indirizzo\"\n                  name=\"indirizzo\"\n                  id=\"sedeCliente\"\n                  bs-typeahead data-min-length=\"0\" data-limit=\"10\" data-auto-select=\"true\"\n                  bs-on-select=\"auc.setSedeCliente\"\n                  bs-options=\"el.idSede as ( el.nome ? el.nome : ( el.indirizzo ? ( el.indirizzo + \' - \' + el.citta + \' (\' + el.prov + \')\' ) : \'\' ) ) for el in auc.formData.sediCliente\"\n                  data-placement=\"bottom-left\"\n                  required>\n                <span class=\"help-block\">Via</span>\n              </div>\n\n              <div class=\"col-sm-offset-2 col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.cap\" name=\"cap\">\n                <span class=\"help-block\">CAP</span>\n              </div>\n\n              <div class=\"col-sm-6\">\n                <input type=\"text\" class=\"form-control\"\n                  bs-typeahead bs-options=\"el.value as el.value for el in auc.formData.citta\"\n                  ng-model=\"auc.appuntamento.citta\" name=\"citta\">\n                <span class=\"help-block\">Citt&agrave;</span>\n              </div>\n\n              <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.prov\" name=\"prov\">\n                <span class=\"help-block\">Prov.</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatti</label>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.tel\" name=\"tel\">\n                <span class=\"help-block\">Telefono</span>\n              </div>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"email\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.email\" name=\"email\">\n                <span class=\"help-block\">Email</span>\n              </div>\n\n              <div class=\"col-sm-3 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"auc.appuntamento.cell\" name=\"cell\">\n                <span class=\"help-block\">Cellulare</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in auc.formData.operatori\"\n                  ng-model=\"auc.appuntamento.idOperatore\" name=\"idOperatore\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Segnalatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in auc.formData.segnalatori\"\n                  ng-model=\"auc.appuntamento.idSegnalatore\" name=\"idSegnalatore\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Cluster</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in auc.formData.ptf\"\n                  ng-model=\"auc.appuntamento.idPtf\" name=\"idPtf\"\n                  required>\n                </select>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"auc.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/appuntamento.html","<div ng-include=\"\'app/core/opportunita/opportunita-associa.html\'\"></div><script type=text/ng-template id=appuntamento-modal.tpl.html ng-controller=\"AppuntamentoController as appuntamento\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-9 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{appuntamento.appuntamento.data | date:\'shortDate\'}}&nbsp;{{appuntamento.appuntamento.ora | date:\'shortTime\'}}\n              {{appuntamento.appuntamento.stati_appuntamento_descrizione}}\n            </div>\n\n            <div class=\"col-xs-3 text-right\">\n              <g1-prom-bell\n                tabella=\"ordini\"\n                campo-id=\"IDOrdine\"\n                record-id=\"{{appuntamento.appuntamento.id}}\">\n              </g1-prom-bell>\n\n              <button ng-if=\"appuntamento.azioni.length > 0\"\n                      type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                      bs-dropdown=\"appuntamento.azioni\"\n                      data-placement=\"bottom-right\">\n                Azioni&nbsp;<span class=\"caret\"></span>\n              </button>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 text-left text-primary\">\n              <a ng-click=\"appuntamento.readCliente(appuntamento.appuntamento.idCliente)\">\n                <h5>{{appuntamento.appuntamento.idCliente}}&nbsp;-&nbsp;{{appuntamento.appuntamento.cliente}}</h5>\n              </a>\n            </div>\n            <div class=\"col-xs-6 text-right text-primary\"><h5>{{appuntamento.appuntamento.agenti_agente}}</h5></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Tel:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span>{{appuntamento.appuntamento.tel}}</span>\n                  <a ng-if=\"appuntamento.appuntamento.tel\"\n                     ng-href=\"tel:{{appuntamento.appuntamento.tel}}\" target=\"_blank\" title=\"Telefona\">\n                    <i class=\"fa fa-phone fa-fw\" style=\"font-size: 1.2em\"></i>\n                  </a>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Cell:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span>{{appuntamento.appuntamento.cell}}</span>\n                  <a ng-if=\"appuntamento.appuntamento.cell\"\n                     ng-href=\"tel:{{appuntamento.appuntamento.cell}}\" target=\"_blank\" title=\"Telefona\">\n                    <i class=\"fa fa-mobile fa-fw\" style=\"font-size: 1.2em\"></i>\n                  </a>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Email:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span>{{appuntamento.appuntamento.email}}</span>\n                  <a ng-if=\"appuntamento.appuntamento.email\"\n                     ng-href=\"mailto:{{appuntamento.appuntamento.email}}\" target=\"_blank\" title=\"Invia mail\">\n                    <i class=\"fa fa-envelope fa-fw\" style=\"font-size: 1.2em\"></i>\n                  </a>\n                </div>\n              </div>\n\n              <div class=\"row\"ng-if=\"appuntamento.user.userGroup == 1\">\n                <div class=\"col-xs-offset-2 col-xs-10 col-md-offset-4 col-md-8 text-left\">\n                  <a href=\"\" ng-click=\"appuntamento.updateContattiAppuntamento(appuntamento.appuntamento.id)\">Modifica Contatti</a>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Ptf:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span>{{appuntamento.appuntamento.ptf}}</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-6\">\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Indirizzo:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <span>\n                    {{appuntamento.appuntamento.indirizzo}}<br>\n                    {{appuntamento.appuntamento.citta}}\n                  </span>\n                  <a title=\"Apri mappa\" ng-href=\"http://maps.google.com/?q={{(appuntamento.appuntamento.indirizzo + \' \' + appuntamento.appuntamento.citta) | urlEncode}}\" target=\"_blank\">\n                    <i class=\"fa fa-map-o\"></i>\n                  </a>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Zona:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\"><span>{{appuntamento.appuntamento.clienti_zona}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Sito:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\">\n                  <a ng-href=\"{{appuntamento.urlParser(appuntamento.appuntamento.clienti_sito)}}\" target=\"_blank\">{{appuntamento.appuntamento.clienti_sito}}</a>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-2 col-md-4 text-right\"><label>Segnalatore:</label></div>\n                <div class=\"col-xs-10 col-md-8 text-left\"><span>{{appuntamento.appuntamento.agenti_segnalatore}}</span></div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Note Agente:</label></div>\n            <div class=\"col-xs-10 text-left\"><span>{{appuntamento.appuntamento.noteAgente}}</span></div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.user.userGroup < 9\">\n            <div class=\"col-xs-2 text-right\"><label>Campagna:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              <span ng-if=\"appuntamento.showMotivo() === \'motivo\'\">\n                {{appuntamento.appuntamento.motivi_descrizione}}\n              </span>\n\n              <span ng-if=\"appuntamento.showMotivo() === \'bottone\'\">\n                <button class=\"btn btn-warning btn-xs\" title=\"Assegna Motivo\" ng-click=\"appuntamento.showFormMotivo()\">Assegna</button>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.appuntamento.idOpportunita\">\n            <div class=\"col-xs-2 text-right\"><label>Opportunità:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              <a href=\"\" ng-click=\"appuntamento.readOpportunita(appuntamento.appuntamento.idOpportunita)\">{{appuntamento.appuntamento.opportunita_pista}}</a>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.user.userGroup >= 9\">\n            <div class=\"col-xs-2 text-right\"><label>Campagna:</label></div>\n            <div class=\"col-xs-10 text-left\">{{appuntamento.appuntamento.motivi_descrizione}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Operatore:</label></div>\n            <div class=\"col-xs-10 col-sm-10 col-md-2 text-left\"><span>{{appuntamento.appuntamento.agenti_operatore}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-2 text-right\"><label>Note Operatore:</label></div>\n            <div class=\"col-xs-10 col-sm-10 col-md-6 text-left\"><span>{{appuntamento.appuntamento.noteOperatore}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Data richiamo:</label></div>\n            <div class=\"col-xs-10 col-sm-10 col-md-2 text-left\"><span>{{appuntamento.appuntamento.dataRichiamo | date:\'shortDate\'}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-2 text-right\"><label>Note richiamo:</label></div>\n            <div class=\"col-xs-10 col-sm-10 col-md-6 text-left\"><span>{{appuntamento.appuntamento.noteRichiamo}}</span></div>\n          </div>\n\n          <hr>\n\n          <div class=\"row\" ng-if=\"appuntamento.user.userGroup < 9\">\n            <div class=\"col-xs-12\">\n              <div bs-tabs\n                   bs-active-pane=\"appuntamento.activeTab\"\n                   ng-init=\"appuntamento.activeTab = 0\">\n                <div data-title=\"Contratti\" bs-pane>\n                  <table datatable\n                         dt-options=\"::appuntamento.dtContratti.dtOptions\"\n                         dt-columns=\"::appuntamento.dtContratti.dtColumns\"\n                         dt-instance=\"appuntamento.dtContratti.dtInstance\"\n                         class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"appuntamento.user.userGroup > 4 && appuntamento.user.userGroup < 9\">\n                <small>\n                  Inserito:{{appuntamento.appuntamento.idUtenteIns}} - {{appuntamento.appuntamento.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{appuntamento.appuntamento.idUtenteMod}} - {{appuntamento.appuntamento.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script><!-- modal update motivo --><script type=text/ng-template id=motivo-update-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"appuntamento.motivoUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"appuntamento.assegnaMotivo()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title\">\n              Assegna a campagna\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in appuntamento.formData.operatori\"\n                        ng-model=\"appuntamento.appuntamento.idOperatore\" name=\"idOperatore\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group has-warning\">\n              <label class=\"control-label col-sm-2\">Campagna</label>\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in appuntamento.formData.liste\"\n                        ng-model=\"appuntamento.appuntamento.idMotivo\" name=\"idMotivo\"\n                        required>\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"appuntamento.appuntamento.noteTelefonata\" name=\"noteTelefonata\">\n                </textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/check-distances.html","<script type=text/ng-template id=check-distances-modal.tpl.html ng-controller=\"CheckDistancesController as cdc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-info\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-1\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n            </div>\n            <div class=\"col-xs-11 text-center\">\n              Appuntamento&nbsp;in<br>\n              {{cdc.appuntamento.indirizzo}}, {{cdc.appuntamento.citta}}, {{cdc.appuntamento.prov}}\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\" ng-if=\"cdc.pre.messages.length > 0\">\n            <div class=\"col-xs-12\">\n              <g1-alerts data-status=\"{{cdc.pre.status}}\" data-messages=\"cdc.pre.messages\"></g1-alerts>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"cdc.post.messages.length > 0\">\n            <div class=\"col-xs-12\">\n              <g1-alerts data-status=\"{{cdc.post.status}}\" data-messages=\"cdc.post.messages\"></g1-alerts>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/charts/chart.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=\"container-fluid g1-panel\" style=\"width: 99%\"><div class=page-header><h2><a href=#/reports title=\"Torna a reports\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> Grafico {{chart.title}}</h2></div><form role=form name=search_charts class=form-inline><div class=\"form-group input-group-sm spacer-1-right\" ng-if=chart.formData.anni><label class=control-label>Anno</label><select class=form-control ng-options=\"el.value as el.label for el in chart.formData.anni\" ng-model=chart.options.anno name=anno></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=chart.formData.tipiData><label class=control-label>Data</label><select class=form-control ng-options=\"el.value as el.label for el in chart.formData.tipiData\" ng-change=chart.setStati(chart.options.tipoData) ng-model=chart.options.tipoData name=tipoData></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=chart.formData.stati><label class=control-label>Stati</label><button type=button class=\"btn btn-default\" ng-model=\"chart.options[\'idStati[]\']\" ng-model-options=\"{updateOn: \'blur\'}\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 bs-options=\"el.value as el.label for el in chart.formData.stati\">Stati <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=chart.formData.tipi><label class=radio-inline ng-repeat=\"tipo in chart.formData.tipi\"><input type=radio ng-value=tipo.value ng-model=chart.options.tipo name=tipo>&nbsp;{{tipo.label}}</label></div></form><div class=row ng-if=chart.options><div class=col-xs-12><div g1-chart chart-id={{chart.id}} chart-options=chart.options chart-title=chart.title></div></div></div></div>");
$templateCache.put("app/core/charts/chart.tpl.html","<div ng-if=chartObject.data ng-style=\"{\n       \'height\': height,\n       \'width\': \'100%\'\n     }\" google-chart chart=chartObject agc-on-select=actionOnClick(selectedItem)></div><div ng-if=emptyResponse class=\"text-center text-muted\"><i class=\"fa fa-frown-o\" style=\"font-size: 8rem\"></i><br><span style=\"font-size: 4rem\">Nessun&nbsp;dato</span></div><div class=table-responsive ng-if=chartDt.dtInstance><table datatable dt-options=chartDt.dtOptions dt-columns=chartDt.dtColumns dt-instance=chartDt.dtInstance class=\"table table-hover\"></table></div>");
$templateCache.put("app/core/clienti/cliente-edit.html","<script type=text/ng-template id=cliente-edit-modal.tpl.html ng-controller=\"ClienteEditController as cec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"clienteEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"cec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{cec.cliente.id || \'Nuovo Cliente\'}} - {{cec.cliente.ragSoc}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                <span ng-if=\"cec.cliente.idAgente\">\n                  {{(cec.formData.agenti | filter:{value: cec.cliente.idAgente}:true)[0].label}}\n                </span>\n                <button type=\"submit\" class=\"btn btn-success btn-xs\">Salva</button>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group has-warning\" ng-if=\"cec.user.userGroup > 2\">\n              <label class=\"control-label col-sm-2\">Rag.Soc.:</label>\n              <div class=\"col-sm-8\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"cec.cliente.ragSoc\" name=\"ragSoc\" required>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cec.user.userGroup > 2\">\n              <label class=\"control-label col-sm-2\">CF/P.IVA</label>\n              <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"cec.cliente.cf\" name=\"cf\">\n                <span class=\"help-block\">Codice Fiscale</span>\n              </div>\n              <div class=\"col-sm-2\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"cec.cliente.piva\" name=\"piva\">\n                <span class=\"help-block\">Partita Iva</span>\n              </div>\n\n              <div class=\"col-sm-1 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                    ng-model=\"cec.cliente.privacy\">\n                  <b ng-class=\"{\n                      \'text-success\': !cec.cliente.privacy,\n                      \'text-danger\': cec.cliente.privacy,\n                    }\">\n                    &nbsp;Privacy\n                  </b>\n                </label>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Situazione</label>\n              <div class=\"col-sm-3 has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in cec.formData.situazioni\"\n                  ng-model=\"cec.cliente.idSituazione\" name=\"idSituazione\" required>\n                </select>\n              </div>\n            </div>\n            <div ng-if=\"cec.action == \'create\'\">\n              <div class=\"form-group\" ng-if=\"cec.user.userGroup > 1\">\n                <label class=\"control-label col-sm-2\">Sede</label>\n                <div class=\"col-sm-3\">\n                  <input type=\"text\" placeholder=\"Indirizzo\" class=\"form-control\"\n                    ng-model=\"cec.cliente.sede.indirizzo\" name=\"sede[indirizzo]\">\n                  <span class=\"help-block\">Indirizzo</span>\n                </div>\n                <div class=\"col-sm-1\">\n                  <input type=\"text\" placeholder=\"N. civico\" class=\"form-control\"\n                    ng-model=\"cec.cliente.sede.numeroCivico\" name=\"sede[numeroCivico]\">\n                  <span class=\"help-block\">N. civico</span>\n                </div>\n                <div class=\"col-sm-1\">\n                  <input type=\"text\" placeholder=\"CAP\" class=\"form-control\"\n                    ng-model=\"cec.cliente.sede.cap\" name=\"sede[cap]\">\n                  <span class=\"help-block\">CAP</span>\n                </div>\n                <div class=\"col-sm-2\">\n                  <input type=\"text\" placeholder=\"Città\" class=\"form-control\"\n                    bs-typeahead bs-options=\"el.value as el.value for el in cec.formData.citta\"\n                    ng-model=\"cec.cliente.sede.citta\" name=\"sede[citta]\">\n                  <span class=\"help-block\">Città</span>\n                </div>\n                <div class=\"col-sm-1\">\n                  <input type=\"text\" placeholder=\"Prov.\" class=\"form-control\"\n                    ng-model=\"cec.cliente.sede.prov\" name=\"sede[prov]\">\n                  <span class=\"help-block\">Prov</span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Referente</label>\n                <div class=\"col-sm-3 validate-group\">\n                  <input type=\"text\" class=\"form-control pull-right\"\n                    ng-model=\"cec.cliente.referente.nominativo\" name=\"referente[nominativo]\">\n                  <span class=\"help-block\">Nominativo</span>\n                </div>\n                <div class=\"col-sm-2 validate-group\">\n                  <input type=\"tel\" class=\"form-control pull-right\" name=\"referente[tel]\"\n                    ng-model=\"cec.cliente.referente.tel\"\n                    numeric>\n                  <span class=\"help-block\">Telefono</span>\n                </div>\n                <div class=\"col-sm-2 validate-group\">\n                  <input type=\"tel\" class=\"form-control pull-right\" name=\"referente[cell]\"\n                    ng-model=\"cec.cliente.referente.cell\"\n                    numeric>\n                  <span class=\"help-block\">Cellulare</span>\n                </div>\n                <div class=\"col-sm-3\">\n                  <div class=\"input-group validate-group\">\n                    <input type=\"email\"class=\"form-control\" name=\"referente[email]\"\n                     ng-model=\"cec.cliente.referente.email\">\n                    <span class=\"input-group-addon\">\n                      <input type=\"checkbox\" title=\"Se spuntato l\'indirizzo non verrà usato per il mailing\"\n                        ng-model=\"cec.cliente.referente.privacyEmail\" name=\"referente[privacyEmail]\">\n                    </span>\n                  </div>\n                  <span class=\"help-block\">Email</span>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">\n                  Note<br class=\"hidden-xs\">\n                  Referente\n                </label>\n                <div class=\"col-sm-10\">\n                  <textarea class=\"form-control\" rows=\"4\" name=\"referente[note]\"\n                    ng-model=\"cec.cliente.referente.note\"></textarea>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cec.user.userGroup > 2\">\n              <label class=\"control-label col-sm-2\">Agente</label>\n              <div class=\"col-sm-4\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in cec.formData.agenti\"\n                  ng-model=\"cec.cliente.idAgente\" name=\"idAgente\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cec.user.userGroup > 2\">\n              <label class=\"control-label col-sm-2\">Portafogli</label>\n              <div class=\"col-sm-5 col-lg-3 validate-group has-warning\">\n                <select class=\"form-control pull-right\"\n                  ng-options=\"el.value as el.label for el in cec.formData.ptf\"\n                  ng-model=\"cec.cliente.idPtf\" name=\"idPtf\"\n                  required>\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">Cluster</span>\n              </div>\n\n              <div class=\"col-sm-5 col-lg-2 validate-group\">\n                <select class=\"form-control pull-right\"\n                  ng-options=\"el.value as el.label for el in cec.formData.ptf_mob\"\n                  ng-model=\"cec.cliente.idPtfMob\" name=\"idPtfMob\">\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">Cross</span>\n              </div>\n\n              <div class=\"col-sm-offset-2 col-sm-5 col-lg-offset-0 col-lg-2 validate-group\">\n                <select class=\"form-control pull-right\"\n                  ng-options=\"el.value as el.label for el in cec.formData.ptf_sa\"\n                  ng-model=\"cec.cliente.idPtfSa\" name=\"idPtfSa\">\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">Segmento</span>\n              </div>\n\n              <div class=\"col-sm-5 col-lg-3 validate-group\">\n                <select class=\"form-control pull-right\"\n                  ng-options=\"el.value as el.label for el in cec.formData.ptf4\"\n                  ng-model=\"cec.cliente.idPtf4\" name=\"idPtf4\">\n                  <option value=\"\"></option>\n                </select>\n                <span class=\"help-block\">Ptf&nbsp;4</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cec.user.userGroup == 1\">\n              <label class=\"control-label col-sm-2\">Ptf. Agenzia</label>\n              <div class=\"col-sm-3\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in cec.formData.ptf_sa\"\n                  ng-model=\"cec.cliente.idPtfSa\" name=\"idPtfSa\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"well\">\n              <div class=\"row\">\n\n                <div class=\"col-sm-6 col-md-4\">\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-6\">Sito</label>\n                      <div class=\"col-sm-6\">\n                        <input type=\"text\" class=\"form-control\"\n                          ng-model=\"cec.cliente.sito\" name=\"sito\">\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\" ng-if=\"cec.action == \'create\'\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-6\">\n                        Orari di apertura<br>\n                        <small ng-if=\"cec.cliente.sede.dataOraAggiornamentoOrariApertura\">(Ultima modifica: {{cec.cliente.sede.dataOraAggiornamentoOrariAperturaFormatted}})</small>\n                      </label>\n                      <div class=\"col-sm-6\">\n                        <input type=\"hidden\" name=\"dataOraAggiornamentoOrariApertura\" ng-model=\"cec.cliente.sede.dataOraAggiornamentoOrariApertura\">\n                        <textarea\n                          name=\"orariApertura\"\n                          class=\"form-control\"\n                          ng-model=\"cec.cliente.sede.orariApertura\"\n                          rows=\"6\"\n                          ng-change=\"cec.onchangeOrariApertura()\"></textarea>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-sm-6 col-md-4\">\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\" title=\"0% = Conservatore, 100% = Innovatore\">Tipo</label>\n                      <div class=\"col-sm-8\">\n                        <rzslider\n                          rz-slider-model=\"cec.cliente.innovatore\"\n                          rz-slider-options=\"cec.sliderPercentuale\">\n                        </rzslider>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\">Potenziale</label>\n                      <div class=\"col-sm-8\">\n                        <rzslider\n                          rz-slider-model=\"cec.cliente.potenziale\"\n                          rz-slider-options=\"cec.sliderPercentuale\">\n                        </rzslider>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\">Relazione</label>\n                      <div class=\"col-sm-8\">\n                        <rzslider\n                          rz-slider-model=\"cec.cliente.relazione\"\n                          rz-slider-options=\"cec.sliderPercentuale\">\n                        </rzslider>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-sm-6 col-md-4\">\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\" title=\"Collaboratori totali\">Collaboratori</label>\n                      <div class=\"col-sm-6\">\n                        <input type=\"number\" class=\"form-control\"\n                          ng-model=\"cec.cliente.collaboratoriTot\" name=\"collaboratoriTot\"\n                          step=\"0\" min=\"0\">\n                        </div>\n                      </div>\n                    </div>\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\" title=\"Collaboratori in mobilità sul totale\">Di cui mobili</label>\n                      <div class=\"col-sm-6\">\n                        <input type=\"number\" class=\"form-control\"\n                          ng-model=\"cec.cliente.collaboratoriMob\" name=\"collaboratoriMob\"\n                          step=\"0\" min=\"0\">\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\">Settore</label>\n                      <div class=\"col-sm-6\">\n                        <select class=\"form-control\"\n                          ng-options=\"el.value as el.label for el in cec.formData.settori\"\n                          ng-model=\"cec.cliente.idSettore\" name=\"idSettore\">\n                          <option value=\"\"></option>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <div class=\"row\">\n                      <label class=\"control-label col-sm-3\">Fatturato</label>\n                      <div class=\"col-sm-6\">\n                        <select class=\"form-control\"\n                          ng-options=\"el.value as el.label for el in cec.formData.classiFatturato\"\n                          ng-model=\"cec.cliente.idClasseFatturato\" name=\"idClasseFatturato\">\n                          <option value=\"\"></option>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea class=\"form-control\" ng-model=\"cec.cliente.note\" rows=\"4\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{cec.alerts.status}}\" data-messages=\"cec.alerts.messages\"></g1-alerts>\n\n                <div class=\"alert alert-warning\" ng-if=\"cec.alerts.unique_tel\">\n                  <a title=\"Apri Cliente\" ng-click=\"cec.readCliente(cec.alerts.unique_tel.id)\">{{cec.alerts.unique_tel.text}}</a>, Salvare comunque?&nbsp;&nbsp;&nbsp;\n                  <a ng-click=\"cec.cliente.forceSave = 1; cec.saveForm()\">Si</a>&nbsp;/&nbsp;<a ng-click=\"cec.undoForm()\">No</a>\n                </div>\n\n                <div class=\"alert alert-danger\" ng-if=\"cec.alerts.unique_cf\">\n                  <a title=\"Apri Cliente\" ng-click=\"cec.readCliente(cec.alerts.unique_cf.id)\">{{cec.alerts.unique_cf.text}}</a>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">\n              <i class=\"fa fa-save\"></i> <span>Salva</span>\n            </button>\n            <button type=\"reset\" class=\"btn btn-danger\" ng-click=\"cec.undoForm()\">\n              <i class=\"fa fa-times\"></i> <span>Annulla</span>\n            </button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/clienti/cliente-view.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid></div>");
$templateCache.put("app/core/clienti/cliente.html","<script type=text/ng-template id=cliente-modal.tpl.html ng-controller=\"ClienteController as cliente\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-handle\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-handle\"></div>\n\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-6 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              <i ng-if=\"cliente.cliente.idSituazione == 2\" class=\"fa fa-exclamation-triangle fa-fw\" style=\"font-size: 1.2em; color: red;\" title=\"{{cliente.cliente.situazioneCliente}}\"></i>\n              {{cliente.cliente.id}}&nbsp;-&nbsp;{{cliente.cliente.ragSoc}}\n              <span ng-if=\"cliente.cliente.idAgente\">\n                &nbsp;-&nbsp;{{cliente.cliente.agenteCognome}}&nbsp;{{cliente.cliente.agenteNome}}\n              </span>\n            </div>\n\n            <div class=\"col-xs-6 text-right\">\n              <g1-prom-bell\n                tabella=\"clienti\"\n                campo-id=\"IDCliente\"\n                record-id=\"{{cliente.cliente.id}}\">\n              </g1-prom-bell>\n              <button ng-if=\"cliente.azioni.length > 0\"\n                type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                bs-dropdown=\"cliente.azioni\"\n                data-placement=\"bottom-right\">\n                Azioni&nbsp;<span class=\"caret\"></span>\n              </button>\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div>\n            <span class=\"label label-primary\" bs-tooltip data-container=\"body\" data-title=\"Cluster azienda\">{{cliente.cliente.ptf}}</span>\n            <span class=\"label label-primary\" bs-tooltip data-container=\"body\" data-title=\"Cross\">{{cliente.cliente.ptfMob}}</span>\n            <span class=\"label label-primary\" bs-tooltip data-container=\"body\" data-title=\"Segmento cliente\">{{cliente.cliente.ptfSa}}</span>\n            <span class=\"label label-primary\" bs-tooltip data-container=\"body\" data-title=\"Origine del dato\">{{cliente.cliente.ptf4}}</span>\n            <span class=\"label label-info tagLabel\" ng-repeat=\"tag in cliente.cliente.tags\">{{tag.tag}}</span>\n          </div>\n          <div class=\"row margin-top\">\n            <div class=\"col-md-8\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n\n                  <div class=\"row\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Codice fiscale:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.cf}}</span></div>\n                  </div>\n\n                  <div class=\"row\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Partita Iva:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.piva}}</span></div>\n                  </div>\n\n                  <div ng-if=\"cliente.cliente.referenti[0]\">\n                    <div class=\"row\">\n\n                      <div ng-if=\"cliente.cliente.referenti[0].tel\" class=\"col-xs-3 col-sm-4 text-right\"><label>Tel:</label></div>\n                      <div ng-if=\"cliente.cliente.referenti[0].tel\" class=\"col-xs-9 col-sm-8 text-left datoCliente\">\n                        <a href=\"tel:{{cliente.cliente.referenti[0].tel}}\">\n                          <i class=\"fa fa-phone\"></i>\n                          <i class=\"fa fa-copy\" copy-to-clipboard=\"{{cliente.cliente.referenti[0].tel}}\"></i>\n                          {{cliente.cliente.referenti[0].tel}}\n                        </a>\n                      </div>\n\n                      <div ng-if=\"cliente.cliente.referenti[0].cell\" class=\"col-xs-3 col-sm-4 text-right\"><label>Cell:</label></div>\n                      <div ng-if=\"cliente.cliente.referenti[0].cell\" class=\"col-xs-9 col-sm-8 text-left datoCliente\">\n                        <a href=\"tel:{{cliente.cliente.referenti[0].cell}}\">\n                          <i class=\"fa fa-mobile\"></i>\n                          <i class=\"fa fa-copy\" copy-to-clipboard=\"{{cliente.cliente.referenti[0].cell}}\"></i>\n                          {{cliente.cliente.referenti[0].cell}}\n                        </a>\n                      </div>\n\n                      <div class=\"col-xs-3 col-sm-4 text-right\"><label>Email:</label></div>\n                      <div class=\"col-xs-9 col-sm-8 text-left datoCliente\" ng-class=\"cliente.cliente.referenti[0].privacyEmail == true ? \'text-danger\' : \'text-success\'\">\n                        <a ng-if=\"cliente.cliente.referenti[0].email\"\n                          ng-href=\"mailto:{{cliente.cliente.referenti[0].email}}\" target=\"_blank\" title=\"Invia mail\">\n                          <i class=\"fa fa-envelope fa-fw\"></i>\n                          <i class=\"fa fa-copy\" copy-to-clipboard=\"{{cliente.cliente.referenti[0].email}}\"></i>\n                        </a>\n                        <span ng-attr-title=\"{{cliente.cliente.referenti[0].privacyEmail ? \'non accetta mail per privacy\' : \'\'}}\">{{cliente.cliente.referenti[0].email}}</span>\n                      </div>\n\n                      <div class=\"col-xs-3 col-sm-4 text-right\"><label>Referente:</label></div>\n                      <div class=\"col-xs-9 col-sm-8 text-left\">\n                        {{cliente.cliente.referenti[0].nominativo}}\n                        <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"cliente.showElencoReferenti=!cliente.showElencoReferenti;cliente.showElencoSedi=false;\">Gestione contatti</button>\n                      </div>\n\n                    </div>\n                  </div>\n\n                  <div ng-if=\"! cliente.cliente.referenti[0]\">\n                    <div class=\"row\">\n                      <div class=\"col-xs-3 col-sm-4 text-right\"><label>Referenti</label></div>\n                      <div class=\"col-xs-9 col-sm-8 text-left\">\n                        <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"cliente.showElencoReferenti=!cliente.showElencoReferenti;cliente.showElencoSedi=false;\">Gestione contatti</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class=\"col-md-6\">\n\n                  <div class=\"row\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Sito:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\">\n                      <a ng-href=\"{{cliente.urlParser(cliente.cliente.sito)}}\" target=\"_blank\">{{cliente.cliente.sito}}</a>\n                    </div>\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Privacy:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\">\n                      <span ng-class=\"cliente.cliente.privacy ? \'text-danger\' : \'text-success\'\">\n                        {{cliente.cliente.privacy ? \'Richiesta Privacy\' : \'Libero\'}}\n                      </span>\n                    </div>\n                  </div>\n\n\n                  <div class=\"row\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Sede principale:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\">\n                      <span>\n                        <strong ng-if=\"cliente.cliente.sedi[0].nome\">{{cliente.cliente.sedi[0].nome}}<br></strong>\n                        {{cliente.cliente.sedi[0].indirizzo + (cliente.cliente.sedi[0].numeroCivico ? \',\'+cliente.cliente.sedi[0].numeroCivico : \'\')}}<br>\n                        {{cliente.cliente.sedi[0].cap}}&nbsp;-&nbsp;{{cliente.cliente.sedi[0].citta}}&nbsp;({{cliente.cliente.sedi[0].prov}})\n                        <a title=\"Apri mappa\" ng-href=\"http://maps.google.com/?q={{(cliente.cliente.indirizzo + (cliente.cliente.sedi[0].civico ? \',\' + cliente.cliente.sedi[0].civico : \'\') + \' \' + cliente.cliente.sedi[0].citta) | urlEncode}}\" target=\"_blank\">\n                          <i class=\"fa fa-map-o\"></i>\n                        </a>\n                        <span ng-if=\"cliente.cliente.sedi[0].telefono!=\'\'\" class=\"datoCliente\">\n                          <br>\n                          <a href=\"tel:{{cliente.cliente.sedi[0].telefono}}\">\n                            <i class=\"fa fa-phone\"></i>\n                            <i class=\"fa fa-copy\" copy-to-clipboard=\"{{cliente.cliente.sedi[0].telefono}}\"></i>\n                            {{cliente.cliente.sedi[0].telefono}}\n                          </a>\n                        </span>\n                      </span>\n                    </div>\n                  </div>\n\n                  <div class=\"row\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\"><label>Zona:</label></div>\n                    <div class=\"col-xs-9 col-sm-8 text-left\">\n                      <span>{{cliente.cliente.sedi[0].idZona}}&nbsp;({{cliente.cliente.sedi[0].desZona}})</span>\n                    </div>\n                  </div>\n\n                  <div class=\"row\" ng-if=\"cliente.cliente.sedi[0].orariApertura\">\n                    <div class=\"col-xs-3 col-sm-4 text-right\">\n                      <label>\n                        Orari di apertura:<br />\n                        <small>(Ultima modifica: {{cliente.cliente.sedi[0].dataOraAggiornamentoOrariApertura | date: \'shortDate\'}})</small>\n                      </label>\n                    </div>\n                    <div class=\"col-xs-9 col-sm-8 text-left preformattedText\">{{cliente.cliente.sedi[0].orariApertura}}</div>\n                  </div>\n\n                  <div class=\"row\">\n                    <div class=\"col-sm-offset-4 col-xs-offset-3 col-xs-9 col-sm-8 margin-bottom\">\n                      <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"cliente.showElencoSedi=!cliente.showElencoSedi;cliente.showElencoReferenti=false;\">Gestione sedi</button>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n              <div class=\"row\" ng-show=\"cliente.showElencoReferenti\">\n                <div class=\"col-xs-offset-2 col-xs-10\">\n                  <table id=\"cliente_referenti\" datatable\n                    dt-options=\"::cliente.dtReferenti.dtOptions\"\n                    dt-columns=\"::cliente.dtReferenti.dtColumns\"\n                    dt-instance=\"cliente.dtReferenti.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n\n              <div class=\"row\" ng-show=\"cliente.showElencoSedi\">\n                <div class=\"col-xs-offset-2 col-xs-10\">\n                  <table id=\"cliente_sedi\" datatable\n                    dt-options=\"::cliente.dtSedi.dtOptions\"\n                    dt-columns=\"::cliente.dtSedi.dtColumns\"\n                    dt-instance=\"cliente.dtSedi.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n\n              <div class=\"row margin-top margin-bottom\" ng-if=\"cliente.cliente.note\">\n                <div class=\"col-xs-2 text-right\"><label>Note:</label></div>\n                <div class=\"col-xs-10 text-left preformattedText\">{{cliente.cliente.note}}</div>\n              </div>\n            </div>\n\n            <div class=\"col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Tipo:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.calcolaInnovatore(cliente.cliente.innovatore)}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Potenziale:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.potenziale * 100}}%</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Relazione:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.relazione * 100}}%</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Collaboratori:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.collaboratoriTot}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Di cui mobili:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.collaboratoriMob}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><strong>Settore:</strong></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.settore}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-3 col-sm-4 text-right\"><label>Fatturato:</label></div>\n                <div class=\"col-xs-9 col-sm-8 text-left\"><span>{{cliente.cliente.classeFatturato}}</span></div>\n              </div>\n            </div>\n          </div>\n\n          <!-- piste clyco -->\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-6 col-md-4\">\n              <div class=\"alert alert-warning\" ng-if=\"cliente.contrattiTotaliInScadenza>0\">\n                <strong>Attenzione:</strong> questo cliente ha dei contratti in scadenza\n              </div>\n              <div class=\"alert alert-danger\" ng-if=\"cliente.contrattiTotaliScaduti>0\" >\n                <strong>Attenzione:</strong> questo cliente ha dei contratti scaduti\n              </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-6 col-md-4 text-center margin-top\" ng-if=\"cliente.pisteClyco.piste.length > 1\">\n              <label>Contratti Piste Clyco:&nbsp;&nbsp;</label>\n              <span ng-repeat=\"pistaClyco in cliente.pisteClyco.piste\"\n                title=\"clicca per filtrare i contratti\"\n                class=\"badge\" ng-class=\"{\n                  \'alert-info\': pistaClyco.label == cliente.pisteClyco.attiva,\n                  \'alert-warning\': pistaClyco.contrattiInScadenza > 0 && pistaClyco.label != cliente.pisteClyco.attiva,\n                  \'alert-danger\': pistaClyco.contrattiValidi == 0 && pistaClyco.contrattiInScadenza == 0 && pistaClyco.label != cliente.pisteClyco.attiva\n                }\"\n                ng-click=\"cliente.filterPistaContratti(pistaClyco.label)\">{{pistaClyco.label}}\n              </span>\n            </div>\n          </div>\n\n          <hr>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <div bs-tabs\n                bs-active-pane=\"cliente.activeTab\"\n                ng-init=\"cliente.activeTab = 0\">\n                <div data-title=\"Appuntamenti\" bs-pane>\n                  <table id=\"cliente_appuntamenti\" datatable\n                    dt-options=\"cliente.dtAppuntamenti.dtOptions\"\n                    dt-columns=\"::cliente.dtAppuntamenti.dtColumns\"\n                    dt-instance=\"cliente.dtAppuntamenti.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                  <a class=\"pull-right\"\n                     ng-if=\"cliente.dtAppuntamenti.showMore\"\n                     ng-click=\"cliente.dtAppuntamenti.more()\">\n                    Altri...\n                  </a>\n                </div>\n\n                <div data-title=\"Contratti\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_contratti\" datatable\n                    dt-options=\"::cliente.dtContratti.dtOptions\"\n                    dt-columns=\"::cliente.dtContratti.dtColumns\"\n                    dt-instance=\"cliente.dtContratti.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"Telefonate\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_telefonate\" datatable\n                    dt-options=\"cliente.dtTelefonate.dtOptions\"\n                    dt-columns=\"::cliente.dtTelefonate.dtColumns\"\n                    dt-instance=\"cliente.dtTelefonate.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                  <a class=\"pull-right\"\n                     ng-if=\"cliente.dtTelefonate.showMore\"\n                     ng-click=\"cliente.dtTelefonate.more()\">\n                    Altre...\n                  </a>\n                </div>\n\n                <div data-title=\"Campagne\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_elenchi\" datatable\n                    dt-options=\"cliente.dtElenchi.dtOptions\"\n                    dt-columns=\"::cliente.dtElenchi.dtColumns\"\n                    dt-instance=\"cliente.dtElenchi.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                  <a class=\"pull-right\"\n                     ng-if=\"cliente.dtElenchi.showMore\"\n                     ng-click=\"cliente.dtElenchi.more()\">\n                    Altre...\n                  </a>\n                </div>\n\n                <div data-title=\"Intervista\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_dati_clienti\" datatable\n                    dt-options=\"::cliente.dtDatiClienti.dtOptions\"\n                    dt-columns=\"::cliente.dtDatiClienti.dtColumns\"\n                    dt-instance=\"cliente.dtDatiClienti.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"{{cliente.titleOpportunita}}\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_opportunita\" datatable\n                    dt-options=\"cliente.dtOpportunita.dtOptions\"\n                    dt-columns=\"::cliente.dtOpportunita.dtColumns\"\n                    dt-instance=\"cliente.dtOpportunita.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                  <a class=\"pull-right\"\n                    ng-if=\"cliente.dtOpportunita.showMore\"\n                    ng-click=\"cliente.dtOpportunita.more()\">\n                    Altre...\n                  </a>\n                </div>\n\n                <div data-title=\"{{cliente.titlePv}}\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <table id=\"cliente_postvendita\" datatable\n                    dt-options=\"cliente.dtPv.dtOptions\"\n                    dt-columns=\"::cliente.dtPv.dtColumns\"\n                    dt-instance=\"cliente.dtPv.dtInstance\"\n                    class=\"table table-hover\">\n                  </table>\n                  <a class=\"pull-right\"\n                    ng-if=\"cliente.dtPv.showMore\"\n                    ng-click=\"cliente.dtPv.more()\">\n                    Altre...\n                  </a>\n                </div>\n\n                <div data-title=\"Documenti\" bs-pane ng-if=\"cliente.user.userGroup < 9\">\n                  <button type=\"button\" style=\"display:none\" id=\"creaAllegatoButton\" ng-click=\"cliente.createAllegato(cliente.cliente)\"></button>\n                  <!--\n                  note di Gian: il pulsante qui sopra esiste solo per ovviare ad un bug che non sono riuscito a risolvere in altra maniera.\n                  Il pulsante all\'interno della datatable qui sotto non fa altro che triggerare il click del pulsante qui sopra.\n                  Se messo all\'interno della datatable direttamente, il pulsante sopra funziona solo all\'interno del primo cliente, non dei successivi.\n                  Fa schifo come soluzione, ma intanto funziona. Da migliorare sicuramente con più tempo.\n                  -->\n                  <table id=\"cliente_allegati\" datatable\n                    dt-options=\"cliente.dtAllegati.dtOptions\"\n                    dt-columns=\"::cliente.dtAllegati.dtColumns\"\n                    dt-instance=\"cliente.dtAllegati.dtInstance\"\n                    class=\"table table-hover\">\n                    <tfoot>\n                      <tr>\n                        <th></th>\n                        <th>Descrizione</th>\n                        <th>Tipo</th>\n                        <th>Note Documento</th>\n                        <th></th>\n                      </tr>\n                    </tfoot>\n                  </table>\n                  <a class=\"pull-right\"\n                    ng-if=\"cliente.dtAllegati.showMore\"\n                    ng-click=\"cliente.dtAllegati.more()\">\n                    Altre...\n                  </a>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"cliente.user.userGroup > 4 && cliente.user.userGroup < 9\">\n                <small>\n                  Inserito:{{cliente.cliente.idUtenteIns}} - {{cliente.cliente.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{cliente.cliente.idUtenteMod}} - {{cliente.cliente.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/clienti/clienti.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_clienti\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><form role=form name=search_clienti class=form-horizontal><!-- form ricerca clienti--><div class=row><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">ID</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.id name=id></div></div><div class=form-group><label class=\"control-label col-xs-2\">Rag.Soc.</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.ragSoc name=ragSoc></div></div><div class=form-group><label class=\"control-label col-xs-2\">C.F.</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.cf name=cf></div></div><div class=form-group><label class=\"control-label col-xs-2\">Num.Tel.</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.numtel name=numtel></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Città</label><div class=col-xs-10><input type=text class=form-control bs-typeahead data-min-length=3 data-limit=1000 data-auto-select=true bs-options=\"el.value as el.value for el in clienti.getComuni($viewValue,true)\" ng-model=clienti.sc.citta name=citta></div></div><div class=form-group><label class=\"control-label col-xs-2\">Zona</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.zone\" ng-model=clienti.sc.idZona name=idZona><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=Provincia>Prov.</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.prov name=prov></div></div><div class=form-group><label class=\"control-label col-xs-2\">Indirizzo</label><div class=col-xs-10><input type=text class=form-control ng-model=clienti.sc.indirizzo name=indirizzo></div></div><div class=form-group><label class=\"control-label col-xs-2\">Tipo sede</label><div class=col-xs-10><div class=btn-group ng-model=clienti.sc.tipoSede bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'principale\'\"> Principale</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'nonPrincipale\'\"> Non principale</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'tutte\'\"> Tutte</label></div></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group ng-if=\"!clienti.auth.authorize(\'AGENTI\')\"><label class=\"control-label col-xs-2\">Agente</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.agenti\" ng-model=clienti.sc.idAgente name=idAgente></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Cluster</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.ptf\" ng-model=clienti.sc.idPtf name=idPtf><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Cross</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.ptf_mob\" ng-model=clienti.sc.idPtfMob name=idPtfMob><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Segmento</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.ptf_sa\" ng-model=clienti.sc.idPtfSa name=idPtfSa><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Ptf&nbsp;4</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.ptf4\" ng-model=clienti.sc.idPtf4 name=idPtf4><option value=\"\"></option></select></div></div><div class=text-right><button type=button class=\"btn btn-xs btn-primary\" ng-attr-title=\"{{clienti.showAdvancedSearch ? \'chiudi\' : \'apri\'}} ricerca avanzata cliente\" ng-click=\"clienti.showAdvancedSearch = !clienti.showAdvancedSearch\"><i class=\"fa fa-fw\" ng-class=\"{\n              \'fa-caret-down\': !clienti.showAdvancedSearch,\n              \'fa-caret-up\': clienti.showAdvancedSearch\n            }\"></i>Altro...</button></div></div></div><!-- form ricerca avanzata clienti --><div class=\"row well\" ng-show=clienti.showAdvancedSearch><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=Innovatore/Conservatore>Tipo</label><div class=col-xs-5><select class=form-control ng-model=clienti.sc.opInnovatore><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=clienti.sc.innovatore name=innovatore percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div><div class=form-group><label class=\"control-label col-xs-2\">Potenziale</label><div class=col-xs-5><select class=form-control ng-model=clienti.sc.opPotenziale><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=clienti.sc.potenziale name=potenziale percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div><div class=form-group><label class=\"control-label col-xs-2\">Relazione</label><div class=col-xs-5><select class=form-control ng-model=clienti.sc.opRelazione><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=clienti.sc.relazione name=relazione percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Settore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.settori\" ng-model=clienti.sc.idSettore name=idSettore><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Fatturato</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.classiFatturato\" ng-model=clienti.sc.idClasseFatturato name=idClasseFatturato><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Situazione</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in clienti.formData.situazioni\" ng-model=clienti.sc.idSituazione name=idSituazione><option value=\"\"></option></select></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=\"Collaboratori totali\">Collaboratori</label><div class=col-xs-5><select class=form-control ng-model=clienti.sc.opCollaboratoriTot><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><input type=number class=form-control ng-model=clienti.sc.collaboratoriTot name=collaboratoriTot step=0 min=0></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Collaboratori totali\">Di&nbsp;cui&nbsp;mobili</label><div class=col-xs-5><select class=form-control ng-model=clienti.sc.opCollaboratoriMob><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><input type=number class=form-control ng-model=clienti.sc.collaboratoriMob name=collaboratoriMob step=0 min=0></div></div></div></div><!-- azioni --><div class=\"row margin-top\"><div class=\"col-md-offset-4 col-md-4 text-center\"><div ng-if=\"clienti.auth.authorize(\'AGENTI\')\" class=\"btn-group validate-group\" bs-radio-group ng-model=clienti.sc.mc><label class=\"btn btn-default\"><input type=radio value=0>&nbsp;Tutti</label><label class=\"btn btn-default\"><input type=radio value=1>&nbsp;Miei Clienti</label></div></div><div class=\"col-md-4 text-right\"><span ng-if=\"clienti.auth.authorize(\'AGENTI\')\"><button type=button class=\"btn btn-success margin-right\" title=\"Ricerca Fortunata\" ng-click=clienti.luckySearch()><i class=\"fa fa-fw fa-magic\"></i></button> </span><span ng-if=\"clienti.auth.authorize(\'COORD\')\"><button type=button class=\"btn btn-success margin-right\" title=\"Nuovo Cliente\" ng-click=clienti.createCliente()><i class=\"fa fa-fw fa-plus\"></i></button> </span><button type=reset class=\"btn btn-warning margin-right\" title=Resetta ng-click=clienti.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <button type=submit class=\"btn btn-info\" title=Cerca ng-click=clienti.search()><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row><div class=\"col-xs-12 margin-top\"><g1-alerts data-status={{clienti.alerts.status}} data-messages=clienti.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=clienti.dtClienti.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=clienti.dtClienti.dtOptions dt-columns=::clienti.dtClienti.dtColumns dt-instance=clienti.dtClienti.dtInstance class=\"table table-hover\"></table></div></div></div><br></div>");
$templateCache.put("app/core/clienti/dati-clienti.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_datiClienti\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><h2 class=text-primary>Ricerca Interviste</h2><form role=form name=search_datiClienti class=form-horizontal><!-- form ricerca dati clienti --><div class=row><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Fornitore</label><div class=col-xs-10><select class=form-control ng-options=\"el.fornitore as el.fornitore for el in datiClienti.formData.fornitori | orderBy:\'fornitore\'\" ng-model=datiClienti.sdc.fornitore name=fornitore ng-change=\"datiClienti.sdc.pista = \'\'\"><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Pista</label><div class=col-xs-10><select class=form-control ng-options=\"el.pista as el.pista for el in datiClienti.formData.piste | filter:{fornitore: datiClienti.sdc.fornitore}:true | orderBy:\'pista\'\" ng-model=datiClienti.sdc.pista name=pista><option value=\"\">TUTTE</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Modello</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.modello name=modello></div></div><div class=form-group><label class=\"control-label col-xs-2\">Competitor</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.competitor name=competitor></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Obsoleto</label><div class=col-xs-10><select class=form-control ng-model=datiClienti.sdc.obsoleto name=obsoleto><option value=\"\">TUTTI</option><option value=1>SI</option><option value=0>NO</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Quantità</label><div class=col-xs-3><select class=form-control ng-model=datiClienti.sdc.opQuantita><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=\"col-xs-offset-2 col-xs-5\"><input type=number class=form-control ng-model=datiClienti.sdc.quantita name=quantita step=0 min=0></div></div><div class=form-group><label class=\"control-label col-xs-2\">Valore</label><div class=col-xs-3><select class=form-control ng-model=datiClienti.sdc.opValore><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=\"col-xs-offset-2 col-xs-5\"><input type=number class=form-control ng-model=datiClienti.sdc.valore name=valore step=0 min=0></div></div><div class=form-group><label class=\"control-label col-xs-2\">Noleggio</label><div class=col-xs-10><select class=form-control ng-model=datiClienti.sdc.noleggio name=noleggio><option value=\"\">TUTTI</option><option value=1>SI</option><option value=0>NO</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Data Intervista\">Intervista</label><div class=col-xs-5><input type=text class=form-control placeholder=Da ng-model=datiClienti.sdc.dataInt_from name=dataInt_from bs-datepicker></div><div class=col-xs-5><input type=text class=form-control placeholder=A ng-model=datiClienti.sdc.dataInt_to name=dataInt_to bs-datepicker data-placement=bottom-right></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=\"Data Inizio Noleggio / Acquisto\">Inizio</label><div class=col-xs-5><input type=text class=form-control placeholder=Da ng-model=datiClienti.sdc.dataInizio_from name=dataInizio_from bs-datepicker></div><div class=col-xs-5><input type=text class=form-control placeholder=A ng-model=datiClienti.sdc.dataInizio_to name=dataInizio_to bs-datepicker data-placement=bottom-right></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Data Fine Noleggio\">Fine</label><div class=col-xs-5><input type=text class=form-control placeholder=Da ng-model=datiClienti.sdc.dataFine_from name=dataFine_from bs-datepicker></div><div class=col-xs-5><input type=text class=form-control placeholder=A ng-model=datiClienti.sdc.dataFine_to name=dataFine_to bs-datepicker data-placement=bottom-right></div></div><div class=form-group><label class=\"control-label col-xs-2\">Assistenza</label><div class=col-xs-10><select class=form-control ng-model=datiClienti.sdc.assistenza name=assistenza><option value=\"\">TUTTI</option><option value=1>SI</option><option value=0>NO</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Valore Assistenza\">Val. Ass.</label><div class=col-xs-3><select class=form-control ng-model=datiClienti.sdc.opValoreAssistenza><option value=\"<=\">&lt;&equals;</option><option value=\"=\">&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=\"col-xs-offset-2 col-xs-5\"><input type=number class=form-control ng-model=datiClienti.sdc.valoreAssistenza name=valoreAssistenza step=0 min=0></div></div></div></div><!-- ricerca clienti --><div class=well ng-show=datiClienti.showClientiSearch><div class=row><div class=\"col-xs-12 text-center\"><h4>Filtri sul cliente</h4></div></div><!-- form ricerca clienti --><div class=row><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">ID</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.id name=id></div></div><div class=form-group><label class=\"control-label col-xs-2\">Rag.Soc.</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.ragSoc name=ragSoc></div></div><div class=form-group><label class=\"control-label col-xs-2\">C.F.</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.cf name=cf></div></div><div class=form-group><label class=\"control-label col-xs-2\">Num.Tel.</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.numtel name=numtel></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Città</label><div class=col-xs-10><input type=text class=form-control bs-typeahead bs-options=\"el.value as el.value for el in datiClienti.formData.citta\" ng-model=datiClienti.sdc.citta name=citta></div></div><div class=form-group><label class=\"control-label col-xs-2\">Zona</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.zone\" ng-model=datiClienti.sdc.idZona name=idZona><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=Provincia>Prov.</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.prov name=prov></div></div><div class=form-group><label class=\"control-label col-xs-2\">Indirizzo</label><div class=col-xs-10><input type=text class=form-control ng-model=datiClienti.sdc.indirizzo name=indirizzo></div></div><div class=form-group><label class=\"control-label col-xs-2\">Agente</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.agenti\" ng-model=datiClienti.sdc.idAgente name=idAgente></select></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Cluster</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.ptf\" ng-model=datiClienti.sdc.idPtf name=idPtf><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Cross</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.ptf_mob\" ng-model=datiClienti.sdc.idPtfMob name=idPtfMob><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Segmento</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.ptf_sa\" ng-model=datiClienti.sdc.idPtfSa name=idPtfSa><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Ptf&nbsp;4</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.ptf4\" ng-model=datiClienti.sdc.idPtf4 name=idPtf4><option value=\"\"></option></select></div></div><div class=text-right><button type=button class=\"btn btn-xs btn-primary\" ng-attr-title=\"{{datiClienti.showAdvancedSearch ? \'chiudi\' : \'apri\'}} ricerca avanzata cliente\" ng-click=\"datiClienti.showAdvancedSearch = !datiClienti.showAdvancedSearch\"><i class=\"fa fa-fw\" ng-class=\"{\n              \'fa-caret-down\': !datiClienti.showAdvancedSearch,\n              \'fa-caret-up\': datiClienti.showAdvancedSearch\n            }\"></i>Altro...</button></div></div></div><!-- form ricerca avanzata clienti --><div class=row ng-show=datiClienti.showAdvancedSearch><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=Innovatore/Conservatore>Tipo</label><div class=col-xs-5><select class=form-control ng-model=datiClienti.sdc.opInnovatore><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=datiClienti.sdc.innovatore name=innovatore percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div><div class=form-group><label class=\"control-label col-xs-2\">Potenziale</label><div class=col-xs-5><select class=form-control ng-model=datiClienti.sdc.opPotenziale><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=datiClienti.sdc.potenziale name=potenziale percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div><div class=form-group><label class=\"control-label col-xs-2\">Relazione</label><div class=col-xs-5><select class=form-control ng-model=datiClienti.sdc.opRelazione><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><div class=input-group><input type=number class=form-control ng-model=datiClienti.sdc.relazione name=relazione percent step=0 min=0 max=100> <span class=input-group-addon>%</span></div></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Settore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.settori\" ng-model=datiClienti.sdc.idSettore name=idSettore><option value=\"\"></option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Fatturato</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in datiClienti.formData.classiFatturato\" ng-model=datiClienti.sdc.idClasseFatturato name=idClasseFatturato><option value=\"\"></option></select></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=\"Collaboratori totali\">Collaboratori</label><div class=col-xs-5><select class=form-control ng-model=datiClienti.sdc.opCollaboratoriTot><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><input type=number class=form-control ng-model=datiClienti.sdc.collaboratoriTot name=collaboratoriTot step=0 min=0></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Collaboratori totali\">Di&nbsp;cui&nbsp;mobili</label><div class=col-xs-5><select class=form-control ng-model=datiClienti.sdc.opCollaboratoriMob><option value=\"<=\">&lt;&equals;</option><option value=\">=\">&gt;&equals;</option></select></div><div class=col-xs-5><input type=number class=form-control ng-model=datiClienti.sdc.collaboratoriMob name=collaboratoriMob step=0 min=0></div></div></div></div></div><!-- azioni --><div class=row><div class=\"col-xs-6 text-left\"><div class=\"btn-group validate-group\" bs-radio-group ng-model=datiClienti.sdc.mode><label class=\"btn btn-default text-nowrap\" title=Clienti><input type=radio value=clienti> Vista Clienti</label><label class=\"btn btn-default\" title=\"Dati Clienti\"><input type=radio value=datiClienti>Vista Dettagli</label></div><span style=\"margin-right: 1em\"></span> <button type=button class=\"btn btn-xs btn-primary\" ng-attr-title=\"{{datiClienti.showClientiSearch ? \'chiudi\' : \'apri\'}} ricerca sui dati cliente\" ng-click=\"datiClienti.showClientiSearch = !datiClienti.showClientiSearch\"><i class=\"fa fa-fw\" ng-class=\"{\n            \'fa-caret-down\': !datiClienti.showClientiSearch,\n            \'fa-caret-up\': datiClienti.showClientiSearch\n          }\"></i></button> <span class=\"text-danger text-nowrap\" ng-show=datiClienti.isFilterActive()>Filtro Clienti Attivo</span></div><div class=\"col-xs-6 text-right\"><button type=reset class=\"btn btn-warning\" title=Resetta ng-click=datiClienti.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca ng-click=datiClienti.search()><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row><div class=col-xs-12 style=\"margin-top: 15px\"><g1-alerts data-status={{datiClienti.alerts.status}} data-messages=datiClienti.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=datiClienti.dtDatiClienti.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=datiClienti.dtDatiClienti.dtOptions dt-columns=::datiClienti.dtDatiClienti.dtColumns dt-instance=datiClienti.dtDatiClienti.dtInstance class=\"table table-hover\"></table></div></div></div><div class=g1-panel ng-if=datiClienti.dtClienti.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=datiClienti.dtClienti.dtOptions dt-columns=::datiClienti.dtClienti.dtColumns dt-instance=datiClienti.dtClienti.dtInstance class=\"table table-hover\"></table></div></div></div><br></div>");
$templateCache.put("app/core/clienti/dato-cliente-edit.html","<script type=text/ng-template id=dato-cliente-edit-modal.tpl.html ng-controller=\"DatoClienteEditController as dcec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"datoClienteEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"dcec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{dcec.datoCliente.id || \'Nuova Intervista\'}}\n              </div>\n\n              <div class=\"col-xs-9 text-right\">\n                {{dcec.datoCliente.cliente}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Fornitore</label>\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.fornitore as el.fornitore for el in dcec.formData.fornitori | orderBy:\'fornitore\'\"\n                        ng-model=\"dcec.datoCliente.fornitore\" name=\"fornitore\"\n                        ng-change=\"dcec.datoCliente.pista = \'\'; dcec.datoCliente.gruppo = \'\'; dcec.datoCliente.sottopista = \'\';\"\n                        required>\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Pista</label>\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.pista as el.pista for el in dcec.formData.piste | filter:{fornitore: dcec.datoCliente.fornitore}:true | orderBy:\'pista\'\"\n                        ng-model=\"dcec.datoCliente.pista\" name=\"pista\"\n                        ng-change=\"dcec.datoCliente.gruppo = \'\'; dcec.datoCliente.sottopista = \'\';\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <!--<div class=\"form-group\">-->\n              <!--<label class=\"control-label col-sm-2\">Gruppo</label>-->\n              <!--<div class=\"col-sm-4 validate-group\">-->\n                <!--<select class=\"form-control\"-->\n                        <!--ng-options=\"el.gruppo as el.gruppo for el in dcec.formData.gruppi | filter:{fornitore: dcec.datoCliente.fornitore, pista: dcec.datoCliente.pista}:true | orderBy:\'gruppo\'\"-->\n                        <!--ng-model=\"dcec.datoCliente.gruppo\" name=\"gruppo\">-->\n                  <!--<option value=\"\"></option>-->\n                <!--</select>-->\n              <!--</div>-->\n\n              <!--<label class=\"control-label col-sm-2\">Sottopista</label>-->\n              <!--<div class=\"col-sm-4 validate-group\">-->\n                <!--<select class=\"form-control\"-->\n                        <!--ng-options=\"el.sottopista as el.sottopista for el in dcec.formData.sottopiste | filter:{fornitore: dcec.datoCliente.fornitore, pista: dcec.datoCliente.pista}:true | orderBy:\'sottopista\'\"-->\n                        <!--ng-model=\"dcec.datoCliente.sottopista\" name=\"sottopista\">-->\n                  <!--<option value=\"\"></option>-->\n                <!--</select>-->\n              <!--</div>-->\n            <!--</div>-->\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Modello</label>\n              <div class=\"col-sm-8\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"dcec.datoCliente.modello\" name=\"modello\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Competitor</label>\n              <div class=\"col-sm-8\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"dcec.datoCliente.competitor\" name=\"competitor\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Quantità</label>\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <input type=\"number\" class=\"form-control\"\n                       ng-model=\"dcec.datoCliente.quantita\" name=\"quantita\"\n                       step=\"0\" min=\"1\" required>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Valore</label>\n              <div class=\"col-sm-4\">\n                <div class=\"input-group\">\n                  <input type=\"number\" class=\"form-control\"\n                         ng-model=\"dcec.datoCliente.valore\" name=\"valore\"\n                         step=\"0.01\" min=\"0\">\n                  <span class=\"input-group-addon\">&euro;</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-6 col-sm-offset-2 col-sm-5\">\n                <label>\n                  <input type=\"radio\" ng-value=\"true\"\n                         ng-model=\"dcec.datoCliente.noleggio\" name=\"noleggio\">&nbsp;Noleggio\n                </label>\n              </div>\n\n              <div class=\"col-xs-6 col-sm-5\">\n                <label>\n                  <input type=\"radio\" ng-value=\"false\"\n                         ng-model=\"dcec.datoCliente.noleggio\" name=\"noleggio\">&nbsp;Acquisto\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Date</label>\n\n              <div class=\"col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"dcec.datoCliente.dataInizio\" name=\"dataInizio\"\n                       bs-datepicker>\n                <span class=\"help-block\" ng-if=\"dcec.datoCliente.noleggio\">Inizio noleggio</span>\n                <span class=\"help-block\" ng-if=\"!dcec.datoCliente.noleggio\">Data acquisto</span>\n              </div>\n\n              <div class=\"col-sm-offset-2 col-sm-4 validate-group\" ng-if=\"dcec.datoCliente.noleggio\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"dcec.datoCliente.dataFine\" name=\"dataFine\"\n                       bs-datepicker data-placement=\"bottom-right\">\n                <span class=\"help-block\">Fine noleggio</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"dcec.datoCliente.note\" name=\"note\">\n                  </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Assistenza</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"dcec.datoCliente.assistenza\" name=\"assistenza\">\n                </label>\n              </div>\n            </div>\n\n            <div ng-if=\"dcec.datoCliente.assistenza\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\" title=\"Valore Assistenza\">Valore Ass.</label>\n                <div class=\"col-sm-4\">\n                  <div class=\"input-group\">\n                    <input type=\"number\" class=\"form-control\"\n                           ng-model=\"dcec.datoCliente.valoreAssistenza\" name=\"valoreAssistenza\"\n                           step=\"0.01\" min=\"0\">\n                    <span class=\"input-group-addon\">&euro;</span>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\" title=\"Note Assistenza\">Note Ass.</label>\n                <div class=\"col-sm-10\">\n                  <textarea rows=\"4\" class=\"form-control\"\n                            ng-model=\"dcec.datoCliente.noteAssistenza\" name=\"noteAssistenza\">\n                  </textarea>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Obsoleto</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"dcec.datoCliente.obsoleto\" name=\"obsoleto\">\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"dcec.user.userGroup >= 4\">\n              <label class=\"control-label col-sm-2\">Intervistatore</label>\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in dcec.formData.utenti\"\n                        ng-model=\"dcec.datoCliente.idUtenteInt\" name=\"idUtenteInt\"\n                        required>\n                </select>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"reset\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/clienti/dato-cliente.html","<script type=text/ng-template id=dato-cliente-modal.tpl.html ng-controller=\"DatoClienteController as datoCliente\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Intervista&nbsp;di&nbsp;{{datoCliente.datoCliente.cliente}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Fornitore:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.fornitore}}</div>\n\n            <div class=\"col-sm-3 text-right\"><label>Pista:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.pista}}</div>\n          </div>\n\n          <!--<div class=\"row\">-->\n            <!--<div class=\"col-sm-3 text-right\"><label>Gruppo:</label></div>-->\n            <!--<div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.gruppo}}</div>-->\n\n            <!--<div class=\"col-sm-3 text-right\"><label>Sottopista:</label></div>-->\n            <!--<div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.sottopista}}</div>-->\n          <!--</div>-->\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Modello:</label></div>\n            <div class=\"col-sm-9 text-left\"><span>{{datoCliente.datoCliente.modello}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Competitor:</label></div>\n            <div class=\"col-sm-9 text-left\"><span>{{datoCliente.datoCliente.competitor}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Quantità:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.quantita | number}}</div>\n\n            <div class=\"col-sm-3 text-right\"><label>Valore:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.valore | currency}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Modalità:</label></div>\n            <div class=\"col-sm-9 text-left\"><span>{{datoCliente.datoCliente.noleggio ? \'Noleggio\' : \'Acquisto\'}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>{{datoCliente.datoCliente.noleggio ? \'Inizio noleggio\' : \'Data acquisto\'}}:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.dataInizio | date:\'shortDate\'}}</div>\n\n            <div class=\"col-sm-3 text-right\" ng-if=\"datoCliente.datoCliente.noleggio\"><label>Fine Noleggio:</label></div>\n            <div class=\"col-sm-3 text-left\" ng-if=\"datoCliente.datoCliente.noleggio\">{{datoCliente.datoCliente.dataFine | date:\'shortDate\'}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Note:</label></div>\n            <div class=\"col-sm-9 text-left\"><span>{{datoCliente.datoCliente.note}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Assistenza:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.assistenza ? \'SI\' : \'NO\'}}</div>\n\n            <div class=\"col-sm-3 text-right\" ng-if=\"datoCliente.datoCliente.assistenza\"><label title=\"Valore Assistenza\">Valore Ass:</label></div>\n            <div class=\"col-sm-3 text-left\" ng-if=\"datoCliente.datoCliente.assistenza\">{{datoCliente.datoCliente.valoreAssistenza | currency}}</div>\n          </div>\n\n          <div class=\"row\" ng-if=\"datoCliente.datoCliente.assistenza\">\n            <div class=\"col-sm-3 text-right\"><label title=\"Note Assistenza\">Note Ass.:</label></div>\n            <div class=\"col-sm-9 text-left\"><span>{{datoCliente.datoCliente.noteAssistenza}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Obsoleto:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.obsoleto ? \'SI\' : \'NO\'}}</div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><label>Fatta&nbsp;da:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.utenteIntervista}}</div>\n\n            <div class=\"col-sm-3 text-right\"><label>in&nbsp;data:</label></div>\n            <div class=\"col-sm-3 text-left\">{{datoCliente.datoCliente.dataOraInt | date:\'short\'}}</div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"datoCliente.user.userGroup > 4\">\n                <small>\n                  Inserito:{{datoCliente.datoCliente.idUtenteIns}} - {{datoCliente.datoCliente.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{datoCliente.datoCliente.idUtenteMod}} - {{datoCliente.datoCliente.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/clienti/referente-edit.html","<script type=text/ng-template id=referente-edit-modal.tpl.html ng-controller=\"ReferenteEditController as rec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"referenteEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"rec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                <span ng-if=\"rec.referente.nominativo!=\'\'\">Modifica referente</span>\n                <span ng-if=\"rec.referente.nominativo==\'\'\">Nuovo referente</span>\n              </div>\n              <div class=\"col-xs-9 text-right\">\n                Cliente {{rec.referente.cliente}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Nominativo</label>\n              <div class=\"col-sm-8\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"rec.referente.nominativo\" name=\"nominativo\">\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Email</label>\n              <div class=\"col-sm-4\">\n                <div class=\"input-group validate-group\">\n                  <input type=\"email\" class=\"form-control\" ng-model=\"rec.referente.email\" name=\"email\">\n                  <span class=\"input-group-addon privacyInputGroup\">\n                    <input type=\"checkbox\" title=\"Se spuntato l\'indirizzo non verrà usato per il mailing\"\n                      ng-model=\"rec.referente.privacyEmail\" name=\"privacyEmail\">\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Telefono</label>\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"rec.referente.tel\" name=\"tel\">\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Cellulare</label>\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"rec.referente.cell\" name=\"cell\">\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-4\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in rec.formData.tipiReferenti | orderBy:\'label\'\"\n                  ng-model=\"rec.referente.idTipoReferente\" name=\"idTipoReferente\"\n                  required>\n                </select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Principale</label>\n              <div class=\"col-sm-10 checkbox\">\n                <label>\n                  <input type=\"checkbox\" ng-model=\"rec.referente.referentePrincipale\" name=\"principale\" ng-change=\"rec.referentePrincipaleChange()\">\n                </label>\n                <div ng-if=\"rec.confermaDeselezionaReferentePrincipale\" class=\"alert alert-warning\">\n                  Desideri realmente rendere il referente NON principale? <button type=\"button\" class=\"btn btn-success margin-left\" ng-click=\"rec.enableSubmit()\"><i class=\"fa fa-check\"></i> Conferma</button>\n                </div>\n                </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea class=\"form-control\" ng-model=\"rec.referente.note\" name=\"note\"></textarea>\n              </div>\n            </div>\n            <div class=\"col-xs-12\" ng-if=\"rec.alerts.messages.length > 0\">\n              <g1-alerts data-status=\"{{rec.alerts.status}}\" data-messages=\"rec.alerts.messages\"></g1-alerts>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <div class=\"row\">\n              <div class=\"col-xs-8 text-left text-muted\">\n                <em ng-if=\"rec.action != \'create\' && rec.user.userGroup > 4 && rec.user.userGroup < 9\">\n                  <small>\n                    Inserito: {{rec.referente.idUtenteIns}} - {{rec.referente.dataOraIns | date:\'short\'}}\n                    <br>\n                    Modificato: {{rec.referente.idUtenteMod}} - {{rec.referente.dataOraMod | date:\'short\'}}\n                  </small>\n                </em>\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rec.disabledSubmit\"><i class=\"fa fa-save\"></i> Salva</button>\n                <button type=\"reset\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/clienti/sede-edit.html","<script type=text/ng-template id=sede-edit-modal.tpl.html ng-controller=\"SedeEditController as sec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"sedeEditForm\" class=\"dataForm\" ng-submit=\"sec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                <span ng-if=\"sec.sede.indirizzo!=\'\'\">Modifica sede</span>\n                <span ng-if=\"sec.sede.indirizzo==\'\'\">Nuova sede</span>\n              </div>\n              <div class=\"col-xs-8 text-right\">\n                Cliente {{sec.sede.cliente}}\n              </div>\n            </h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-md-12 form-group\">\n                <label for=\"sede_nome\">\n                  Nome<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.nome\" name=\"nome\" id=\"sede_nome\" required=\"required\">\n              </div>\n              <div class=\"col-md-10 form-group\">\n                <label for=\"sede_indirizzo\">\n                  Indirizzo<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.indirizzo\" name=\"indirizzo\" id=\"sede_indirizzo\" required=\"required\">\n              </div>\n              <div class=\"col-md-2 form-group\">\n                <label for=\"sede_numeroCivico\">\n                  N. Civico<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.numeroCivico\" name=\"numeroCivico\" id=\"sede_numeroCivico\">\n              </div>\n              <div class=\"col-md-8 form-group\">\n                <label for=\"sede_citta\">\n                  Città<br>\n                </label>\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"sec.sede.citta\"\n                  name=\"citta\"\n                  id=\"sede_citta\"\n                  bs-typeahead data-min-length=\"3\" data-limit=\"1000\" data-auto-select=\"true\"\n                  bs-on-select=\"sec.setCitta\"\n                  bs-options=\"el.identificatore as ( el.nome ? ( el.nome + \' (\' + el.siglaProvincia + \')\' ) : \'\' ) for el in sec.getComuni($viewValue,true)\"\n                  data-placement=\"bottom-left\"\n                  required=\"required\">\n              </div>\n              <div class=\"col-md-2 form-group\">\n                <label for=\"sede_cap\">\n                  CAP<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.cap\" name=\"cap\" id=\"sede_cap\" required=\"required\">\n              </div>\n              <div class=\"col-md-2 form-group\">\n                <label for=\"sede_prov\">\n                  Provincia<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.prov\" name=\"prov\" id=\"sede_prov\" required=\"required\">\n              </div>\n              <div class=\"col-md-4 form-group\">\n                <label for=\"sede_telefono\">\n                  Telefono<br>\n                </label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"sec.sede.telefono\" name=\"telefono\" id=\"sede_telefono\">\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-6 form-group\">\n                <label>\n                  <input type=\"checkbox\" ng-model=\"sec.sede.sedePrincipale\" name=\"sedePrincipale\" ng-change=\"sec.sedePrincipaleChange()\"> Sede principale\n                </label>\n                <div ng-if=\"sec.confermaDeselezionaSedePrincipale\" class=\"alert alert-warning\">\n                  Desideri realmente rendere la sede NON principale? <button type=\"button\" class=\"btn btn-success margin-left\" ng-click=\"sec.enableSubmit()\"><i class=\"fa fa-check\"></i> Conferma</button>\n                </div>\n              </div>\n              <div class=\"col-md-6 form-group\" ng-if=\"!sec.sede.sedePrincipale\">\n                <label>\n                  <input type=\"checkbox\" ng-model=\"sec.sede.obsoleta\" name=\"obsoleta\"> Obsoleta\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label>\n                Orari di apertura<br>\n                <small ng-if=\"sec.sede.dataOraAggiornamentoOrariApertura\">(Ultima modifica: {{sec.sede.dataOraAggiornamentoOrariAperturaFormatted}})</small>\n              </label>\n              <input type=\"hidden\" name=\"dataOraAggiornamentoOrariApertura\" ng-model=\"sec.sede.dataOraAggiornamentoOrariApertura\">\n              <textarea\n                name=\"orariApertura\"\n                class=\"form-control\"\n                ng-model=\"sec.sede.orariApertura\"\n                rows=\"6\"\n                ng-change=\"sec.onchangeOrariApertura()\"></textarea>\n            </div>\n            <div class=\"form-group\">\n              <label for=\"sede_note\">\n                Note<br>\n              </label>\n              <textarea class=\"form-control\" ng-model=\"sec.sede.note\" name=\"note\" rows=\"7\"></textarea>\n            </div>\n            <div class=\"row\" ng-if=\"sec.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{sec.alerts.status}}\" data-messages=\"sec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <div class=\"row\">\n              <div class=\"col-xs-7 text-left text-muted\">\n                <em ng-if=\"sec.action != \'create\' && sec.user.userGroup > 4 && sec.user.userGroup < 9\">\n                  <small>\n                    Inserito: {{sec.sede.idUtenteIns}} - {{sec.sede.dataOraIns | date:\'short\'}}\n                    <br>\n                    Modificato: {{sec.sede.idUtenteMod}} - {{sec.sede.dataOraMod | date:\'short\'}}\n                  </small>\n                </em>\n              </div>\n              <div class=\"col-xs-5 text-right\">\n                <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"sec.disabledSubmit\"><i class=\"fa fa-save\"></i> Salva</button>\n                <button type=\"reset\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/contratti/contratti-modal.html","<script type=text/ng-template id=contratti-modal.tpl.html ng-controller=\"ContrattiModalController as cmc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Contratti Attivi\n              {{cmc.filtro.motivo ? \' in \' + cmc.filtro.motivo : \'\'}}\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::cmc.dtContratti.dtOptions\"\n                     dt-columns=\"::cmc.dtContratti.dtColumns\"\n                     dt-instance=\"cmc.dtContratti.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/contratti/contratti.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_contratti\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><h2 class=text-primary>Ricerca Contratti</h2><form role=form name=search_contratti class=form-horizontal><!-- form ricerca contratti --><div class=row><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-offset-2 col-xs-5\" style=\"text-align: center\">DA</label><label class=\"control-label col-xs-5\" style=\"text-align: center\">A</label></div><div class=form-group><label class=\"control-label col-xs-2\">Inserimento</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.ins_from name=ins_from bs-datepicker data-max-date={{contratti.sc.ins_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.ins_to name=ins_to bs-datepicker data-placement=bottom-right data-min-date={{contratti.sc.ins_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Conferma</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.conf_from name=conf_from bs-datepicker data-max-date={{contratti.sc.conf_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.conf_to name=conf_to bs-datepicker data-placement=bottom-right data-min-date={{contratti.sc.conf_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Attivazione</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.crm_from name=crm_from bs-datepicker data-max-date={{contratti.sc.crm_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.crm_to name=crm_to bs-datepicker data-placement=bottom-right data-min-date={{contratti.sc.crm_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Annullo</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.annullo_from name=annullo_from bs-datepicker data-max-date={{contratti.sc.annullo_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.annullo_to name=annullo_to bs-datepicker data-placement=bottom-right data-min-date={{contratti.sc.annullo_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Data fine</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.dataFineContratto_from name=dataFineContratto_from bs-datepicker data-max-date={{contratti.sc.dataFineContratto_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=contratti.sc.dataFineContratto_to name=dataFineContratto_to bs-datepicker data-placement=bottom-right data-min-date={{contratti.sc.dataFineContratto_from}}></div></div><div class=form-group><label class=\"control-label col-xs-2\">Durata</label><div class=col-xs-10><select class=form-control ng-model=contratti.sc.conScadenza name=conScadenza><option value=\"\">TUTTI</option><option value=1>CON scadenza</option><option value=0>SENZA scadenza</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Pagamento</label><div class=col-xs-10><select class=form-control ng-model=contratti.sc.pagamento name=pagamento><option value=\"\">TUTTI</option><option value=\"una tantum\">Una Tantum</option><option value=ricorrente>Ricorrente</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Stato</label><div class=col-xs-10><button type=button class=\"btn btn-default\" ng-model=\"contratti.sc[\'idStato[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_contratti\']\" bs-options=\"el.value as el.label for el in contratti.formData.stati\">Action <span class=caret></span></button></div></div><div class=form-group><label class=\"control-label col-xs-2\">Obsoleto</label><div class=col-xs-10><select class=form-control ng-model=contratti.sc.obsoleto name=obsoleto><option value=\"\">TUTTI</option><option value=1>Obsoleti</option><option value=0>NON Obsoleti</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Note</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.note name=note></div></div></div><div class=\"col-md-6 col-lg-4\"><!-- questo serve per allineare con le altre due label --><div class=form-group><label class=\"control-label col-xs-12\">&nbsp;</label></div><div class=form-group><label class=\"control-label col-xs-2\">Fornitore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.fornitori\n                | orderBy:\'label\'\" ng-model=contratti.sc.fornitore name=fornitore><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Pista</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.piste\n                | filter:{fornitore: contratti.sc.fornitore}:true\n                | orderBy:\'label\'\" ng-model=contratti.sc.pista name=pista><option value=\"\">TUTTE</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Sottopista</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.sottopiste\n                | filter:{fornitore: contratti.sc.fornitore, pista: contratti.sc.pista}:true\n                | orderBy:\'label\'\" ng-model=contratti.sc.sottopista name=sottopista><option value=\"\">TUTTE</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Gruppo</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.filtraGruppi(contratti.formData.gruppi, contratti.sc.fornitore, contratti.sc.pista)\" ng-model=contratti.sc.gruppo name=gruppo><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Prodotto</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.prodotto name=prodotto></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=\"Genera Provvigione\">Gen.&nbsp;Provv.</label><div class=col-xs-10><select class=form-control ng-model=contratti.sc.noProvv name=noProvv><option value=\"\">TUTTI</option><option value=1>NON genera provvigione</option><option value=0>genera provvigione</option></select></div></div></div><div class=\"col-md-12 col-lg-4\"><!-- questo serve per allineare con le altre due label --><div class=form-group><label class=\"control-label col-xs-12\">&nbsp;</label></div><div ng-if=\"contratti.user.userGroup >= 4\"><div class=form-group><label class=\"control-label col-xs-2\">AM</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.teamLeaders\" ng-change=\"contratti.sc.idAgente = \'0\'\" ng-disabled=\"contratti.user.userGroup == 4\" ng-model=contratti.sc.teamLeader name=teamLeader></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Agente</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.agenti | filter:{teamLeader: contratti.sc.teamLeader}:true\" ng-model=contratti.sc.idAgente name=idAgente></select></div></div></div><!-- segnalatore per tutti eccetto agenti --><div class=form-group ng-if=\"contratti.user.userGroup > 1\"><label class=\"control-label col-xs-2\">Segnalatore</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.segnalatori\" ng-model=contratti.sc.idSegnalatore name=idSegnalatore><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Ptf</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.ptf\" ng-model=contratti.sc.idPtf name=idPtf></select></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=Documentazione>Doc.</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.documentazione\" ng-model=contratti.sc.documentazione name=documentazione></select></div></div><div class=form-group><label class=\"control-label col-xs-2\">Tipo</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.tipi\" ng-model=contratti.sc.idTipo name=idTipo><option value=\"\">TUTTI</option></select></div></div><!-- segnalatore per agenti --><div class=form-group ng-if=\"contratti.user.userGroup == 1\"><div class=\"checkbox col-xs-offset-0 col-xs-12 col-sm-offset-2 col-sm-10\"><label><input type=checkbox ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-model=contratti.sc.idSegnalatore name=idSegnalatore> <b>&nbsp;Ricerca contratti delle segnalazioni</b></label></div></div></div></div><!-- bottone apri filtri --><div class=row><div class=\"col-xs-12 text-center\"><button type=button class=\"btn btn-xs btn-primary\" ng-attr-title=\"{{contratti.showClientiSearch ? \'chiudi\' : \'apri\'}} ricerca per dati cliente\" ng-click=\"contratti.showClientiSearch = !contratti.showClientiSearch\"><i class=\"fa fa-fw\" ng-class=\"{\n              \'fa-caret-down\': !contratti.showClientiSearch,\n              \'fa-caret-up\': contratti.showClientiSearch\n            }\"></i>Ricerca per dati cliente</button> <span class=\"text-danger text-nowrap\" ng-show=contratti.isFilterActive()>Filtro Clienti Attivo</span></div></div><!-- form ricerca per anagrafica cliente --><div class=well ng-show=contratti.showClientiSearch><!-- form ricerca clienti --><div class=row><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">ID&nbsp;Cliente</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.idCliente name=idCliente></div></div><div class=form-group><label class=\"control-label col-xs-2\">Rag.Soc.</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.ragSoc name=ragSoc></div></div></div><div class=\"col-md-6 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\" title=Provincia>Prov.</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.prov name=prov></div></div><div class=form-group><label class=\"control-label col-xs-2\">Zona</label><div class=col-xs-10><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.zone\" ng-model=contratti.sc.idZona name=idZona><option value=\"\"></option></select></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-2\">Città</label><div class=col-xs-10><input type=text class=form-control bs-typeahead bs-options=\"el.value as el.value for el in contratti.formData.citta\" ng-model=contratti.sc.citta name=citta></div></div><div class=form-group><label class=\"control-label col-xs-2\">Indirizzo</label><div class=col-xs-10><input type=text class=form-control ng-model=contratti.sc.indirizzo name=indirizzo></div></div></div></div></div><!-- azioni --><div class=form-group><div class=\"col-xs-12 text-right\"><button type=reset class=\"btn btn-warning\" title=Resetta ng-click=contratti.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca ng-click=contratti.search()><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><!-- Modifica multipla dello stato contratto --><form name=bulk_edit_contratti class=\"form-inline dataForm\" ng-submit=contratti.modificaStato() novalidate ng-if=contratti.checkBulkEdit()><div class=form-group><span class=form-control-static style=\"vertical-align: top\">Modifica stato in</span><div class=\"validate-group inline-block\"><select class=form-control ng-options=\"el.value as el.label for el in contratti.formData.stati\" ng-model=contratti.bec.idStato_to name=idStatoContratto required><option value=\"\"></option></select></div><button type=submit class=\"btn btn-danger\" style=\"vertical-align: top\">Esegui</button></div></form><div class=row><div class=col-xs-12 style=\"margin-top: 15px\"><g1-alerts data-status={{contratti.alerts.status}} data-messages=contratti.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=contratti.showResults><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::contratti.dtContratti.dtOptions dt-columns=::contratti.dtContratti.dtColumns dt-instance=contratti.dtContratti.dtInstance class=\"table table-hover table-condensed\"></table></div></div></div><br></div>");
$templateCache.put("app/core/contratti/contratto-create.html","<script type=text/ng-template id=contratto-create-modal.tpl.html ng-controller=\"ContrattoCreateController as ccc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-6 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{ccc.appuntamento.data | date:\'shortDate\'}}&nbsp;{{ccc.appuntamento.ora | date:\'shortTime\'}}\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              {{ccc.appuntamento.cliente}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"form-group\">\n            <div class=\"row\">\n              <div class=\"col-sm-3\">\n                <label class=\"control-label\">Sede</label><br />\n                <select class=\"form-control\"\n                  ng-model=\"ccc.contratto.idSede\" name=\"idSede\">\n                  <option value=\"\"></option>\n                  <option ng-repeat=\"sede in ccc.formData.sedi\" ng-class=\"{\'bold\': sede.principale,\'line-through\': sede.obsoleta}\" ng-value=\"{{sede.value}}\">\n                    {{sede.label}}\n                  </option>\n                </select>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                dt-options=\"::ccc.dtContratti.dtOptions\"\n                dt-columns=\"::ccc.dtContratti.dtColumns\"\n                dt-instance=\"ccc.dtContratti.dtInstance\"\n                class=\"table table-hover table-condensed\">\n              </table>\n            </div>\n          </div>\n\n          <hr>\n\n          <div g1-prodotti-search\n            ps-mode=\"insert\"\n            ps-action=\"ccc.prodottoSelected(prodSel,ccc)\">\n          </div>\n\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/contratti/contratto-update.html","<script type=text/ng-template id=contratto-update-modal.tpl.html ng-controller=\"ContrattoUpdateController as cuc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"contrattoUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"cuc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{cuc.contratto.agente}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{cuc.contratto.descProdotto}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{(cuc.formData.stati | filter:{value: cuc.contratto.idStatoContratto}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Prodotto</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">\n                  {{cuc.contratto.codiceProdotto}} - {{cuc.contratto.descProdotto}}\n                  <span ng-if=\"cuc.contratto.conScadenza&&cuc.contratto.durataContratto>0\">(Con scadenza: {{cuc.contratto.durataContratto}} mesi)</span>\n                  <button\n                    type=\"button\"\n                    class=\"btn btn-xs btn-warning\"\n                    ng-show=\"!cuc.contrattoConfermato\"\n                    title=\"Cambia Prodotto\"\n                    ng-click=\"cuc.searchProdotto()\"><i class=\"fa fa-pencil\"></i>\n                  </button>\n                </p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Sede</label>\n              <div class=\"col-sm-8\">\n                <div class=\"row\">\n                  <div class=\"col-sm-4\">\n                    <select class=\"form-control\"\n                      ng-model=\"cuc.contratto.idSede\" name=\"idSede\">\n                      <option value=\"\"></option>\n                      <option ng-repeat=\"sede in cuc.formData.sedi\" ng-class=\"{\'bold\': sede.principale,\'line-through\': sede.obsoleta}\" ng-value=\"{{sede.value}}\">\n                        {{sede.label}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"cuc.user.userGroup >= 5\">\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Stato</label>\n                <div class=\"col-sm-8\">\n                  <div class=\"row\">\n\n                    <div class=\"col-sm-4 has-warning\">\n                      <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in cuc.formData.stati | orderBy:\'tipo\'\"\n                        ng-model=\"cuc.contratto.idStatoContratto\" name=\"idStatoContratto\"\n                        ng-change=\"cuc.statoContrattoChange()\"\n                        required>\n                      </select>\n                    </div>\n\n                    <label ng-if=\"(cuc.formData.stati | filter:{value: cuc.contratto.idStatoContratto}:true)[0].tipo === \'N\'\" class=\"control-label col-sm-2\">Data Annullo</label>\n                    <div ng-if=\"(cuc.formData.stati | filter:{value: cuc.contratto.idStatoContratto}:true)[0].tipo === \'N\'\" class=\"col-sm-2 has-warning\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data chiusura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"cuc.contratto.dataAnnullo\" name=\"dataAnnullo\"\n                          bs-datepicker\n                          required>\n                      </div>\n                    </div>\n\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"control-label col-sm-2\">Date</label>\n                <div class=\"col-sm-8\">\n                  <div class=\"row\">\n                    <div class=\"col-sm-2 validate-group\" ng-class=\"{\'has-warning\':!cuc.contrattoConfermato}\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data chiusura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"cuc.contratto.dataInserimento\" name=\"dataInserimento\"\n                          ng-disabled=\"cuc.contrattoConfermato\"\n                          bs-datepicker\n                          required>\n                      </div>\n                      <span class=\"help-block\">inserimento</span>\n                    </div>\n\n                    <div class=\"col-sm-2 validate-group\"\n                      ng-class=\"{\'has-warning\': cuc.dataConfermaRequired(cuc.contratto.idStatoContratto)}\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data chiusura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"cuc.contratto.dataConferma\" name=\"dataConferma\"\n                          bs-datepicker\n                          ng-required=\"cuc.dataConfermaRequired(cuc.contratto.idStatoContratto)\">\n                      </div>\n                      <span class=\"help-block\">conferma</span>\n                    </div>\n\n                    <div class=\"col-sm-2 validate-group\"\n                      ng-class=\"{\'has-warning\': cuc.dataCrmRequired(cuc.contratto.idStatoContratto)&&!cuc.contrattoConfermato}\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data chiusura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"cuc.contratto.dataCrm\" name=\"dataCrm\"\n                          ng-disabled=\"cuc.contrattoConfermato\"\n                          ng-change=\"cuc.dataAttivazioneChange()\"\n                          bs-datepicker\n                          ng-required=\"cuc.dataCrmRequired(cuc.contratto.idStatoContratto)\">\n                      </div>\n                      <span class=\"help-block\">attivazione</span> <!-- TODO: Sosituito \'CRM\' con \'Attivazione\' -->\n                    </div>\n\n                    <div class=\"col-sm-2 validate-group\" ng-if=\"cuc.user.userGroup >= 4\" ng-class=\"{\'has-warning\':!cuc.contrattoConfermato}\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data fine contratto\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"cuc.contratto.dataFineContratto\" name=\"dataFineContratto\"\n                          ng-disabled=\"cuc.contrattoConfermato\"\n                          bs-datepicker>\n                      </div>\n                      <span class=\"help-block\">fine contratto</span>\n                    </div>\n\n                    <div class=\"col-sm-12\" id=\"date-alerts-container\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Quantità</label>\n              <div class=\"col-sm-2 validate-group\" ng-class=\"{\'has-warning\':!cuc.contrattoConfermato}\">\n                <input type=\"number\" class=\"form-control\"\n                  ng-model=\"cuc.contratto.qta\" name=\"qta\"\n                  ng-disabled=\"cuc.contrattoConfermato\"\n                  required min=\"0\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Prezzo</label>\n              <div class=\"col-sm-3 validate-group\" ng-class=\"{\'has-warning\':!cuc.contrattoConfermato}\">\n                <input type=\"number\" class=\"form-control\"\n                  ng-model=\"cuc.contratto.prezzoUnit\" name=\"prezzoUnit\"\n                  ng-disabled=\"cuc.contrattoConfermato\"\n                  required min=\"0\">\n              </div>\n\n              <div class=\"col-sm-2\">\n                <p class=\"form-control-static\"><b>&nbsp;=&nbsp;{{(cuc.contratto.qta * cuc.contratto.prezzoUnit) || 0 | number:2}}</b></p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Documentazione</label>\n              <div class=\"col-xs-12 col-sm-4 col-md-3 validate-group\">\n                <label class=\"radio-inline\" title=\"Non Richiesta\">\n                  <input type=\"radio\" value=\"-1\" ng-model=\"cuc.contratto.documentazione\">&nbsp;N.R.\n                </label>\n\n                <label class=\"radio-inline\" title=\"Documentazione richiesta consegnata\">\n                  <input type=\"radio\" value=\"1\" ng-model=\"cuc.contratto.documentazione\">&nbsp;OK\n                </label>\n\n                <label class=\"radio-inline\" title=\"Documentazione richiesta (vedi note) non consegnata\">\n                  <input type=\"radio\" value=\"0\" ng-model=\"cuc.contratto.documentazione\">&nbsp;KO\n                </label>\n              </div>\n\n              <label class=\"control-label col-xs-12 col-sm-2 col-md-1\" title=\"Note Documentazione\" ng-if=\"cuc.contratto.documentazione >= 0\">Note Doc.</label>\n              <div class=\"col-xs-12 col-sm-4 col-md-6 validate-group\" ng-if=\"cuc.contratto.documentazione >= 0\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.noteDocumentazione\" name=\"noteDocumentazione\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note Commerciali</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"cuc.contratto.note\" name=\"note\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cuc.user.userGroup >= 4\">\n              <label class=\"control-label col-sm-2\">Note BackOffice</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"cuc.contratto.noteBo\" name=\"noteBo\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cuc.user.userGroup >= 4\">\n              <label class=\"control-label col-sm-2\">Note Tecniche</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"cuc.contratto.noteTecniche\" name=\"noteTecniche\"></textarea>\n              </div>\n            </div>\n\n            <br>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Ordine</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.numOrdine\" name=\"numOrdine\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Num 1</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.num1\" name=\"num1\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Num 2</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.num2\" name=\"num2\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Num 3</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.num3\" name=\"num3\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Num 4</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.num4\" name=\"num4\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Num 5</label>\n              <div class=\"col-sm-2 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"cuc.contratto.num5\" name=\"num5\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Genera provvigione</label>\n              <div class=\"col-xs-12 col-sm-4 col-md-3 validate-group\">\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" value=\"0\" ng-model=\"cuc.contratto.noProvv\">&nbsp;SI\n                </label>\n\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" value=\"1\" ng-model=\"cuc.contratto.noProvv\">&nbsp;NO\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"cuc.user.userGroup >= 4\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-4\">\n                <select class=\"form-control has-warning\"\n                  ng-options=\"el.value as el.label for el in cuc.formData.tipi\"\n                  ng-model=\"cuc.contratto.idTipoContratto\" name=\"idTipoContratto\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Obsoleto</label>\n              <div class=\"col-xs-12 col-sm-4 col-md-3 validate-group\">\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" value=\"1\" ng-model=\"cuc.contratto.obsoleto\">&nbsp;SI\n                </label>\n\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" value=\"0\" ng-model=\"cuc.contratto.obsoleto\">&nbsp;NO\n                </label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cuc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/contratti/contratto.html","<script type=text/ng-template id=contratto-modal.tpl.html ng-controller=\"ContrattoController as contratto\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <h4 class=\"pull-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{contratto.contratto.agente}}\n                {{contratto.contratto.stato}}\n                <mark ng-if=\"contratto.contratto.obsoleto\" class=\"bg-danger text-info\">OBSOLETO</mark>\n                <mark ng-if=\"contratto.contratto.scaduto\" class=\"bg-warning text-info\">SCADUTO</mark>\n              </h4>\n              <h4 class=\"pull-right\">\n                <g1-prom-bell\n                  tabella=\"dettagli_ordini\"\n                  campo-id=\"IDDettagliOrdini\"\n                  record-id=\"{{contratto.contratto.id}}\">\n                </g1-prom-bell>\n                <button ng-if=\"contratto.azioni.length > 0\"\n                  type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                  bs-dropdown=\"contratto.azioni\"\n                  data-placement=\"bottom-right\">\n                  Azioni&nbsp;<span class=\"caret\"></span>\n                </button>\n              </h4>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-body\" style=\"padding: 15px 15px 0 15px\">\n          <div class=\"clear text-primary\">\n            <h5 class=\"pull-left\">{{contratto.contratto.idCliente}}&nbsp;-&nbsp;{{contratto.contratto.cliente}}</h5>\n            <h5 class=\"pull-left margin-left\">\n              {{contratto.contratto.sede}}\n            </h5>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-4 col-sm-5 text-right\"><label>Prodotto:</label></div>\n                <div class=\"col-xs-8 col-sm-7 text-left\"><span class=\"position-absolute\">{{contratto.contratto.codiceProdotto}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-8\">\n              <div class=\"row\">\n                <div class=\"col-xs-offset-3 col-xs-9\">\n                  <label>{{contratto.contratto.descProdotto}}</label>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Agente:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.agente}}</span></div>\n              </div>\n            </div>\n            <div class=\"col-sm-8\">\n              <div class=\"row\">\n                <div class=\"col-sm-6\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 text-right\"><label>Stato:</label></div>\n                    <div class=\"col-xs-6 text-left\"><span>{{contratto.contratto.stato}}</span></div>\n                  </div>\n                </div>\n                <div class=\"col-sm-6\">\n                  <div class=\"row text-danger\" ng-if=\"contratto.contratto.obsoleto\">\n                    <div class=\"col-xs-5 text-right\"><label>Obsoleto:</label></div>\n                    <div class=\"col-xs-7 text-left\"><span>Sì</span></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Fornitore:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.fornitore}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Pista:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.pista}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Sotto&nbsp;Pista:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.sottopista}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Gruppo:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.gruppo}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Durata:</label></div>\n                <div class=\"col-xs-7 text-left\">\n                  <span ng-if=\"contratto.contratto.conScadenza\">CON</span>\n                  <span ng-if=\"!contratto.contratto.conScadenza\">SENZA</span>\n                  scadenza\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-sm-6 text-right\"><label>Inserimento:</label></div>\n                <div class=\"col-sm-6 text-left\"><span>{{contratto.contratto.dataInserimento | date:\'shortDate\'}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-sm-6 text-right\"><label>Conferma:</label></div>\n                <div class=\"col-sm-6 text-left\"><span>{{contratto.contratto.dataConferma | date:\'shortDate\'}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-sm-6 text-right\"><label>Attivazione:</label></div><!-- TODO: Sosituito \'CRM\' con \'Attivazione\' -->\n                <div class=\"col-sm-6 text-left\"><span>{{contratto.contratto.dataCrm | date:\'shortDate\'}}</span></div>\n              </div>\n\n              <div class=\"row\" ng-class=\"contratto.contratto.scaduto ? \'text-warning\' : \'\'\">\n                <div class=\"col-sm-6 text-right\"><label>Fine contratto:</label></div>\n                <div class=\"col-sm-6 text-left\"><span>{{contratto.contratto.dataFineContratto | date:\'shortDate\'}}</span></div>\n              </div>\n\n              <div class=\"row text-danger\" ng-if=\"contratto.contratto.dataAnnullo\">\n                <div class=\"col-sm-6 text-right\"><label>Annullo:</label></div>\n                <div class=\"col-sm-6 text-left\"><span>{{contratto.contratto.dataAnnullo | date:\'shortDate\'}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\" title=\"Prezzo Unitario\"><label>Prezzo:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.prezzoUnit | currency:\"€\":2}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Quantità:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.qta | number:0}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Totale:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.prezzo | currency:\"€\":2}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Pagamento:</label></div>\n                <div class=\"col-xs-7 text-left\">\n                  {{contratto.contratto.pagamento}}\n                </div>\n              </div>\n\n            </div>\n          </div>\n\n          <hr style=\"margin-bottom: 0;\">\n\n          <div class=\"row\">\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Ordine:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.numOrdine}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Numero&nbsp;1:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.num1}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Numero&nbsp;2:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.num2}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Numero&nbsp;3:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.num3}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Numero&nbsp;4:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.num4}}</span></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Numero&nbsp;5:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.num5}}</span></div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label title=\"Richiesta Documentazione Specifica\">Docum:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.documentazione}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label title=\"Note Documentazione\">Note&nbsp;Doc:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.noteDocumentazione}}</span></div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-6 col-md-4\">\n              <div class=\"row\">\n                <div class=\"col-xs-5 text-right\"><label>Tipo:</label></div>\n                <div class=\"col-xs-7 text-left\"><span>{{contratto.contratto.tipo}}</span></div>\n              </div>\n            </div>\n          </div>\n\n          <hr>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <div class=\"col-xs-4 text-right\"><label>Note&nbsp;Commerciali:</label></div>\n              <div class=\"col-xs-8 text-left\"><span>{{contratto.contratto.note}}</span></div>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"(contratto.user.userGroup <= 1) || (contratto.user.userGroup >= 4)\">\n            <div class=\"col-xs-12\">\n              <div class=\"col-xs-4 text-right\"><label>Note&nbsp;BackOffice:</label></div>\n              <div class=\"col-xs-8 text-left\"><span>{{contratto.contratto.noteBo}}</span></div>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"contratto.user.userGroup >= 4\">\n            <div class=\"col-xs-12\">\n              <div class=\"col-xs-4 text-right\"><label>Note&nbsp;Clyco:</label></div>\n              <div class=\"col-xs-8 text-left\"><span>{{contratto.contratto.noteTecniche}}</span></div>\n            </div>\n          </div>\n\n          <hr style=\"margin-bottom: 0;\">\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 text-center\">\n              <button\n                type=\"button\"\n                class=\"btn btn-xs btn-primary\"\n                ng-attr-title=\"{{contratto.showProvvigioni ? \'chiudi\' : \'apri\'}} provvigioni\"\n                ng-click=\"contratto.showProvvigioni = !contratto.showProvvigioni\">\n                <i class=\"fa fa-fw\" ng-class=\"{\n                  \'fa-caret-down\': !contratto.showProvvigioni,\n                  \'fa-caret-up\': contratto.showProvvigioni\n                }\"></i>\n                €€€\n                <i class=\"fa fa-fw\" ng-class=\"{\n                  \'fa-caret-down\': !contratto.showProvvigioni,\n                  \'fa-caret-up\': contratto.showProvvigioni\n                }\"></i>\n              </button>\n            </div>\n          </div>\n\n          <!-- PROVVIGIONI -->\n          <div ng-if=\"(contratto.user.userGroup <= 1) || (contratto.user.userGroup >= 4 && contratto.user.userGroup <= 8)\" ng-show=\"contratto.showProvvigioni\">\n            <table class=\"table table-hover table-condensed provvigioni\">\n              <thead>\n                <tr>\n                  <th>Tipo</th>\n                  <th>Provvigione</th>\n                  <th class=\"nowrap\">Data Contratto</th>\n                  <th class=\"nowrap\">Data Calcolo</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"provvigione in contratto.contratto.provvigioni\">\n                  <td>{{provvigione.tipo}}</td>\n                  <td>{{provvigione.provv | currency:\"€\":2}}</td>\n                  <td>{{provvigione.dataConferma | date:\'shortDate\'}}</td>\n                  <td>{{provvigione.dataProvv | date:\'shortDate\'}}</td>\n                </tr>\n              </tbody>\n            </table>\n\n            <div class=\"row\" ng-if=\"contratto.contratto.noProvv\">\n              <div class=\"col-xs-12 text-danger\">\n                <label>Non genera provvigione</label>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"contratto.user.userGroup > 4\">\n                <small>\n                  Inserito:{{contratto.contratto.idUtenteIns}} - {{contratto.contratto.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{contratto.contratto.idUtenteMod}} - {{contratto.contratto.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">\n                <i class=\"fa fa-times fa-fw close-button\"></i> Chiudi\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/copertura/copertura.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><form name=checkCoperturaForm ng-submit=cc.checkFromCsv() novalidate><h5 class=section-title>File Dati</h5><div class=section-content><div class=form-group><label class=margin-right><input type=checkbox name=tipoCopertura[] value=testOF ng-model=cc.checkFormData.tipoCopertura.checkOF> FTTH / Rete Open</label><label class=margin-right><input type=checkbox name=tipoCopertura[] value=testFastweb ng-model=cc.checkFormData.tipoCopertura.checkFastweb> Fastweb / Rete Yellow</label><label class=margin-right><input type=checkbox name=tipoCopertura[] value=testTIM ng-model=cc.checkFormData.tipoCopertura.checkTIM> TIM / Rete Red</label><label><input type=checkbox name=tipoCopertura[] value=testEolo ng-model=cc.checkFormData.tipoCopertura.checkEolo> Eolo / Rete Air Wsdl</label></div><div class=form-group><input type=file ngf-select ngf-pattern=\"\'.csv\'\" pattern-err-type=filePattern ngf-max-size=20MB ng-model=cc.checkFormData.csvFile name=csvFile><div ng-if=\"cc.checkFormData.csvFile.progress >= 0\"><br><progressbar value=lic.sc.fileImport.progress type=info style=\"margin-bottom: 0\">{{cc.checkFormData.csvFile.progress | number:0}}%</progressbar></div></div><button type=submit class=\"btn btn-success\"><i class=\"fa fa-eye\"></i> <span>Check</span></button></div><div id=checkCoperturaOutput></div></form><table datatable dt-options=::cc.dtTC.dtOptions dt-columns=::cc.dtTC.dtColumns dt-instance=cc.dtTC.dtInstance class=\"table table-hover\"></table></div>");
$templateCache.put("app/core/incoming-call/incoming-call.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=row><div class=\"col-xs-12 margin-top\"><g1-alerts data-status={{icc.alerts.status}} data-messages=icc.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=icc.dtClienti.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=icc.dtClienti.dtOptions dt-columns=::icc.dtClienti.dtColumns dt-instance=icc.dtClienti.dtInstance class=\"table table-hover\"></table></div></div></div><br></div>");
$templateCache.put("app/core/liste/clienti-lista.html","<script type=text/ng-template id=clienti-lista-modal.tpl.html ng-controller=\"ClientiListaController as clc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title\">\n            <div class=\"row\">\n              <div class=\"col-xs-8 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                Clienti in {{clc.filtro.motivo}} {{clc.filtro.stato}} {{clc.filtro.operatore ? \'di \' + clc.filtro.operatore : \'\'}}\n              </div>\n\n              <div class=\"col-xs-4 text-right\">\n                <span ng-if=\"clc.filtro.fromDate || clc.filtro.toDate\">\n                  {{clc.filtro.fromDate ? \'dal \' + (clc.filtro.fromDate | date:\'shortDate\') + \' \' : \'\'}}\n                  {{clc.filtro.toDate ? \'al \' + (clc.filtro.toDate | date:\'shortDate\') + \' \' : \'\'}}\n                </span>\n              </div>\n            </div>\n\n            <div class=\"row\" style=\"margin-top: 15px\" ng-if=\"(clc.filtro.via + clc.filtro.zona + clc.filtro.citta) != \'\'\">\n              <div class=\"col-xs-4 text-left\">\n                {{clc.filtro.zona}}\n              </div>\n\n              <div class=\"col-xs-4 text-center\">\n                {{clc.filtro.citta}}\n              </div>\n\n              <div class=\"col-xs-4 text-right\">\n                {{clc.filtro.via}}\n              </div>\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\" ng-if=\"clc.dtZone.show\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::clc.dtZone.dtOptions\"\n                     dt-columns=\"::clc.dtZone.dtColumns\"\n                     dt-instance=\"clc.dtZone.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"clc.dtClienti.show\">\n            <div class=\"col-xs-12 table-responsive\">\n              <h4 ng-if=\"clc.filtro.zona\">\n                {{clc.filtro.zona}}\n              </h4>\n              <table datatable\n                     dt-options=\"::clc.dtClienti.dtOptions\"\n                     dt-columns=\"::clc.dtClienti.dtColumns\"\n                     dt-instance=\"clc.dtClienti.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-assign.html","<!--<style type=\"text/css\">--><!--#lac-dtZone td {--><!--vertical-align: middle;--><!--}--><!--</style>--><script type=text/ng-template id=lista-assign-modal.tpl.html ng-controller=\"ListaAssignController as lac\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-10 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Assegna clienti a {{lac.lista.id}} - {{lac.lista.descrizione}}\n            </div>\n            <div class=\"col-xs-2 text-right\">\n              {{lac.lista.resa}}%\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <form name=\"listaAssignForm\" class=\"form-horizontal dataForm\" ng-submit=\"lac.saveForm()\" novalidate>\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3 col-md-2\">Operatore</label>\n              <div class=\"col-sm-9 col-md-4 validate-group has-warning\" style=\"margin-bottom: 15px;\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in lac.formData.operatori\"\n                        ng-model=\"lac.lista.idOperatore\" name=\"idOperatore\"\n                        required>\n                </select>\n              </div>\n\n              <p class=\"col-xs-6 col-sm-4 col-md-2 text-nowrap fa-2x\">{{lac.formData.numClienti}} / {{lac.lista.daAssegnare}}</p>\n\n              <div class=\"col-xs-6 col-sm-8 col-md-4 text-right\">\n                <button type=\"reset\" class=\"btn btn-warning\" title=\"Resetta\" ng-click=\"lac.resetForm()\"><i class=\"fa fa-fw fa-undo\"></i></button>\n                <span style=\"margin-right: 1em;\"></span>\n                <button type=\"submit\" class=\"btn btn-success\">Assegna</button>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2 col-sm-3 col-md-2\">Città</label>\n              <div class=\"col-xs-8 col-sm-8 col-md-4\">\n                <input type=\"text\" class=\"form-control\"\n                       bs-typeahead data-limit=\"5\"\n                       bs-options=\"el.value as el.value for el in lac.formData.citta\"\n                       ng-model=\"lac.lista.citta\" name=\"citta\">\n              </div>\n\n              <button type=\"button\" class=\"col-xs-2 col-sm-1 col-md-2 btn btn-info\" ng-click=\"lac.dtZoneLoad(lac.lista.id)\"><i class=\"fa fa-search\"></i></button>\n            </div>\n          </form>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\" id=\"lac-alerts\"></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table id=\"lac-dtZone\" datatable\n                     dt-options=\"::lac.dtZone.dtOptions\"\n                     dt-columns=\"::lac.dtZone.dtColumns\"\n                     dt-instance=\"lac.dtZone.dtInstance\"\n                     class=\"table table-hover table-condensed\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-create.html","<script type=text/ng-template id=lista-create-modal.tpl.html ng-controller=\"ListaCreateController as lcc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"listaCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"lcc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title\">{{lcc.lista.descrizione || \'Nuova Campagna\'}}</h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10 has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"lcc.lista.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Data</label>\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"lcc.lista.dataApertura\" name=\"dataApertura\"\n                       bs-datepicker data-max-date=\"{{lcc.lista.dataChiusura}}\"\n                       data-container=\".modal\"\n                       required>\n                <span class=\"help-block\">Da</span>\n              </div>\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"lcc.lista.dataChiusura\" name=\"dataChiusura\"\n                       bs-datepicker data-min-date=\"{{lcc.lista.dataApertura}}\"\n                       data-container=\".modal\"\n                       required>\n                <span class=\"help-block\">A</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in lcc.formData.tipi\"\n                        ng-model=\"lcc.lista.tipoMotivo\" name=\"tipoMotivo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"checkbox col-xs-12 col-sm-offset-2 col-sm-5\">\n                <label>\n                  <input type=\"checkbox\" value=\"1\"\n                         ng-model=\"lcc.lista.obsoleto\" name=\"obsoleto\">\n                  <b>&nbsp;Obsoleto</b>\n                </label>\n              </div>\n\n              <div class=\"checkbox col-xs-12 col-sm-5\">\n                <label>\n                  <input type=\"checkbox\" value=\"1\"\n                         ng-model=\"lcc.lista.cieca\" name=\"cieca\">\n                  <b>&nbsp;Cieca</b>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"lcc.lista.note\" name=\"note\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"lcc.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{lcc.alerts.status}}\" data-messages=\"lcc.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"lcc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-import.html","<script type=text/ng-template id=lista-import-modal.tpl.html ng-controller=\"ListaImportController as lic\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Genera Campagna\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\" style=\"margin-bottom: 15px\">\n            <div class=\"col-xs-12 text-center\">\n              <button type=\"button\" class=\"btn btn-success\" title=\"Crea campagna partendo da file esterno\"\n                      ng-disabled=\"lic.enableCreate\"\n                      ng-show=\"!lic.enableImport && !lic.sc.fromTable\"\n                      ng-click=\"lic.enableImport = true;\">\n                IMPORTA\n              </button>\n\n              <p class=\"form-control-static\" ng-show=\"lic.sc.fromTable\">\n                Tabella di partenza: {{lic.sc.fromTable}}\n                <i class=\"fa fa-fw fa-close text-danger\" title=\"rimuovi tabella importata\"\n                   ng-show=\"!lic.enableCreate\"\n                   ng-click=\"lic.dropImportTable()\"></i>\n              </p>\n\n            </div>\n          </div>\n\n          <!-- form di import -->\n          <div class=\"panel panel-default\" ng-if=\"lic.enableImport\">\n            <form name=\"ListaImportForm\" class=\"form-horizontal dataForm\" ng-submit=\"lic.saveImport()\" novalidate>\n              <div class=\"panel-body\">\n                <div class=\"form-group\" style=\"margin-top: 15px\">\n                  <label class=\"control-label col-sm-2\" title=\"Seleziona File\">File</label>\n                  <div class=\"col-sm-10 has-warning\">\n                    <input type=\"file\" class=\"form-control\"\n                           ngf-select ngf-model-invalid=\"lic.sc.fileImportError\"\n                           ngf-accept=\"text/csv\" ngf-pattern=\"\'.csv,.xls,.xlsx\'\"\n                           ng-model=\"lic.sc.fileImport\" name=\"fileImport\"\n                           pattern-err-type=\"filePattern\">\n\n                    <div ng-if=\"lic.sc.fileImport.progress >= 0\">\n                      <br>\n                      <progressbar value=\"lic.sc.fileImport.progress\" type=\"info\" style=\"margin-bottom: 0;\">\n                        {{lic.sc.fileImport.progress | number:0}}%\n                      </progressbar>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <div class=\"col-sm-offset-2 col-sm-10\">\n                    <label class=\"radio-inline\">\n                      <input type=\"radio\" value=\"codfisc\"\n                             ng-model=\"lic.sc.modoImport\" name=\"modoImport\"\n                      >&nbsp;Cod.&nbsp;Fisc.\n                    </label>\n                    <label class=\"radio-inline\">\n                      <input type=\"radio\" value=\"idcliente\"\n                             ng-model=\"lic.sc.modoImport\" name=\"modoImport\"\n                      >&nbsp;ID&nbsp;Cliente\n                    </label>\n\n                    <p class=\"radio-inline text-success\">{{lic.helps[lic.sc.modoImport]}}</p>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-footer text-right\">\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"lic.annullaImport()\">Annulla</button>\n                <span style=\"margin-right: 1em;\"></span>\n                <button type=\"submit\" class=\"btn btn-success\">Importa</button>\n              </div>\n            </form>\n          </div>\n\n          <!-- form di ricerca clienti -->\n          <form name=\"ListaCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"lic.showLista()\" novalidate>\n            <fieldset ng-disabled=\"lic.enableCreate\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Città</label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\"\n                             bs-typeahead bs-options=\"el.value as el.value for el in lic.formData.citta\"\n                             ng-model=\"lic.sc.citta\" name=\"citta\">\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Zone</label>\n                    <div class=\"col-sm-10\">\n                      <button type=\"button\" class=\"form-control btn btn-default\"\n                              ng-model=\"lic.sc[\'idZone[]\']\"\n                              bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                              data-container=\"form[name=\'ListaCreateForm\']\"\n                              bs-options=\"el.value as el.label for el in lic.filtraZone(lic.formData.zone)\">\n                        Zone <span class=\"caret\"></span>\n                      </button>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\" title=\"Gruppo Zona\">Gr.Zona</label>\n                    <div class=\"col-sm-10\">\n                      <select class=\"form-control\"\n                              ng-options=\"el.value as el.label for el in lic.formData.gruppiZone\"\n                              ng-change=\"lic.sc[\'idZone[]\'] = []\"\n                              ng-model=\"lic.sc.gruppoZona\" name=\"gruppoZona\">\n                        <option value=\"\">Tutti</option>\n                      </select>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Privacy</label>\n                    <div class=\"col-sm-10\">\n                      <select class=\"form-control\"\n                              ng-model=\"lic.sc.privacy\" name=\"privacy\">\n                        <option value=\"\">Tutti</option>\n                        <option value=\"0\">No</option>\n                        <option value=\"1\">Si</option>\n                      </select>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-xs-12 col-sm-2\">Tipo</label>\n                    <div class=\"col-xs-5 col-sm-4\">\n                      <select class=\"form-control\"\n                              ng-model=\"lic.sc.opInnovatore\">\n                        <option value=\"<=\">&lt;&equals;</option>\n                        <option value=\">=\">&gt;&equals;</option>\n                      </select>\n                    </div>\n\n                    <div class=\"col-xs-offset-1 col-xs-6 col-sm-offset-1 col-sm-5\">\n                      <div class=\"input-group\">\n                        <input type=\"number\" class=\"form-control\"\n                               ng-model=\"lic.sc.innovatore\" name=\"innovatore\"\n                               percent step=\"0\" min=\"0\" max=\"100\">\n                        <span class=\"input-group-addon\">%</span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-md-6\">\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Cluster</label>\n                    <div class=\"col-sm-10\">\n                      <button type=\"button\" class=\"form-control btn btn-default\"\n                              ng-model=\"lic.sc[\'idPtf[]\']\"\n                              bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                              data-container=\"form[name=\'ListaCreateForm\']\"\n                              bs-options=\"el.value as el.label for el in lic.formData.ptf\">\n                        Ptf <span class=\"caret\"></span>\n                      </button>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Cross</label>\n                    <div class=\"col-sm-10\">\n                      <button type=\"button\" class=\"form-control btn btn-default\"\n                              ng-model=\"lic.sc[\'idPtfMob[]\']\"\n                              bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                              data-container=\"form[name=\'ListaCreateForm\']\"\n                              bs-options=\"el.value as el.label for el in lic.formData.ptf_mob\">\n                        Mobile <span class=\"caret\"></span>\n                      </button>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Segmento</label>\n                    <div class=\"col-sm-10\">\n                      <button type=\"button\" class=\"form-control btn btn-default\"\n                              ng-model=\"lic.sc[\'idPtfSa[]\']\"\n                              bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                              data-container=\"form[name=\'ListaCreateForm\']\"\n                              bs-options=\"el.value as el.label for el in lic.formData.ptf_sa\">\n                        Agenzia <span class=\"caret\"></span>\n                      </button>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <label class=\"control-label col-sm-2\">Ptf4</label>\n                    <div class=\"col-sm-10\">\n                      <button type=\"button\" class=\"form-control btn btn-default\"\n                              ng-model=\"lic.sc[\'idPtf4[]\']\"\n                              bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                              data-container=\"form[name=\'ListaCreateForm\']\"\n                              bs-options=\"el.value as el.label for el in lic.formData.ptf4\">\n                        Agenzia <span class=\"caret\"></span>\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <div class=\"form-group\">\n                    <h4 class=\" col-xs-12 form-control-static\">INCLUSIONI</h4>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.inc_tim\">&nbsp;TIM\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.inc_no_tim\">&nbsp;NO&nbsp;TIM\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.inc_telecom\">&nbsp;TELECOM\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.inc_no_telecom\">&nbsp;NO&nbsp;TELECOM\n                      </label>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-md-6\">\n                  <div class=\"form-group\">\n                    <h4 class=\"col-xs-12 form-control-static\">ESCLUSIONI</h4>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label title=\"clienti aperti in campagna\">\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.esc_aperti\">&nbsp;APERTI\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-12 checkbox\">\n                      <label title=\"clienti con esito tel = eliminare\">\n                        <input type=\"checkbox\"\n                               ng-model=\"lic.sc.esc_eliminare\">&nbsp;ELIMINARE\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-6 checkbox validate-group\">\n                      <label title=\"telefonate con contatto\">\n                        <input type=\"checkbox\"\n                               ng-change=\"lic.sc.esc_telefonate_pos_data_from = null\"\n                               ng-model=\"lic.sc.esc_telefonate_pos\">&nbsp;TELEFONATE&nbsp;POS.&nbsp;DA\n                      </label>\n                    </div>\n\n                    <div class=\"col-xs-6 validate-group\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                             ng-model=\"lic.sc.esc_telefonate_pos_data_from\" name=\"esc_telefonate_pos_data_from\"\n                             bs-datepicker data-placement=\"bottom-right\" data-container=\".modal\"\n                             ng-required=\"lic.sc.esc_telefonate_pos\">\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-6 checkbox validate-group\">\n                      <label title=\"tutte le telefonate\">\n                        <input type=\"checkbox\"\n                               ng-change=\"lic.sc.esc_telefonate_data_from = null\"\n                               ng-model=\"lic.sc.esc_telefonate\">&nbsp;TELEFONATE&nbsp;DA\n                      </label>\n                    </div>\n\n                    <div class=\"col-xs-6 validate-group\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                             ng-model=\"lic.sc.esc_telefonate_data_from\" name=\"esc_telefonate_data_from\"\n                             bs-datepicker data-placement=\"bottom-right\" data-container=\".modal\"\n                             ng-required=\"lic.sc.esc_telefonate\">\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-6 checkbox validate-group\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-change=\"lic.sc.esc_appuntamenti_data_from = null\"\n                               ng-model=\"lic.sc.esc_appuntamenti\">&nbsp;APPUNTAMENTI&nbsp;DA\n                      </label>\n                    </div>\n\n                    <div class=\"col-xs-6 validate-group\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                             ng-model=\"lic.sc.esc_appuntamenti_data_from\" name=\"esc_appuntamenti_data_from\"\n                             bs-datepicker data-placement=\"bottom-right\" data-container=\".modal\"\n                             ng-required=\"lic.sc.esc_appuntamenti\">\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-6 checkbox validate-group\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-change=\"lic.sc.esc_ull_data_from = null\"\n                               ng-model=\"lic.sc.esc_ull\">&nbsp;CONTRATTI&nbsp;ULL&nbsp;DA\n                      </label>\n                    </div>\n\n                    <div class=\"col-xs-6 validate-group\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                             ng-model=\"lic.sc.esc_ull_data_from\" name=\"esc_ull_data_from\"\n                             bs-datepicker data-placement=\"bottom-right\" data-container=\".modal\"\n                             ng-required=\"lic.sc.esc_ull\">\n                    </div>\n                  </div>\n\n                  <div class=\"form-group\">\n                    <div class=\"col-xs-6 checkbox validate-group\">\n                      <label>\n                        <input type=\"checkbox\"\n                               ng-change=\"lic.sc.esc_mnp_data_from = null\"\n                               ng-model=\"lic.sc.esc_mnp\">&nbsp;CONTRATTI&nbsp;MNP&nbsp;DA\n                      </label>\n                    </div>\n\n                    <div class=\"col-xs-6 validate-group\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                             ng-model=\"lic.sc.esc_mnp_data_from\" name=\"esc_mnp_data_from\"\n                             bs-datepicker data-placement=\"bottom-right\" data-container=\".modal\"\n                             ng-required=\"lic.sc.esc_mnp\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <div class=\"col-xs-8 text-center\">\n                  <button type=\"button\" class=\"btn btn-success\"\n                          ng-show=\"lic.dtClienti.instance\"\n                          ng-click=\"lic.enableCreate = true;\">\n                    INSERISCI\n                  </button>\n                </div>\n\n                <div class=\"col-xs-4 text-right\">\n                  <button type=\"button\" class=\"btn btn-warning\" title=\"Resetta\" ng-click=\"lic.resetForm()\"><i class=\"fa fa-fw fa-undo\"></i></button>\n                  <span style=\"margin-right: 1em;\"></span>\n                  <button type=\"submit\" class=\"btn btn-info\" title=\"Cerca\"><i class=\"fa fa-fw fa-search\"></i></button>\n                </div>\n              </div>\n            </fieldset>\n          </form>\n\n          <!-- form di inserimento lista -->\n          <div class=\"panel panel-default\" ng-if=\"lic.enableCreate\">\n            <form name=\"ListaCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"lic.saveLista(lic.sc, lic.lista)\" novalidate>\n              <div class=\"panel-body\">\n                <div class=\"form-group\">\n                  <label class=\"control-label col-sm-2\" title=\"Nome Campagna\">Nome Camp.</label>\n                  <div class=\"col-sm-10 has-warning\">\n                    <input type=\"text\" class=\"form-control\"\n                           ng-model=\"lic.lista.descrizione\" name=\"descrizione\"\n                           required>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-12 col-sm-2\">Data&nbsp;Da</label>\n                  <div class=\"col-xs-5 col-sm-4 validate-group has-warning\">\n                    <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                           ng-model=\"lic.lista.dataApertura\" name=\"dataApertura\"\n                           bs-datepicker data-max-date=\"{{lic.lista.dataChiusura}}\"\n                           required>\n                  </div>\n\n                  <label class=\"control-label col-xs-2 text-center\">A</label>\n                  <div class=\"col-xs-5 col-sm-4 validate-group has-warning\">\n                    <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                           ng-model=\"lic.lista.dataChiusura\" name=\"dataChiusura\"\n                           bs-datepicker data-placement=\"bottom-right\"\n                           data-min-date=\"{{lic.lista.dataApertura}}\" required>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-12 col-sm-2\">Tipo</label>\n                  <div class=\"col-xs-12 col-sm-4 has-warning\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in lic.formData.tipi\"\n                            ng-model=\"lic.lista.tipoMotivo\" name=\"tipoMotivo\"\n                            required>\n                    </select>\n                  </div>\n\n                  <label class=\"control-label col-xs-12 col-sm-2\">Stato</label>\n                  <div class=\"col-xs-12 col-sm-4 has-warning\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in lic.formData.stati\"\n                            ng-model=\"lic.lista.idStatoElenco\" name=\"idStatoElenco\"\n                            required>\n                    </select>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-footer text-right\">\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"lic.annullaInserisci()\">Annulla</button>\n                <span style=\"margin-right: 1em;\"></span>\n                <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n              </div>\n            </form>\n          </div>\n\n          <!-- messaggi di warning/errore -->\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <g1-alerts data-status=\"{{lic.alerts.status}}\" data-messages=\"lic.alerts.messages\"></g1-alerts>\n            </div>\n          </div>\n\n          <!-- tabella preview dei clienti -->\n          <div class=\"row\" style=\"margin-bottom: 15px;\"\n               ng-if=\"lic.dtClienti.instance\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::lic.dtClienti.options\"\n                     dt-columns=\"::lic.dtClienti.columns\"\n                     dt-instance=\"lic.dtClienti.instance\"\n                     class=\"table table-hover table-condensed\"\n                     style=\"margin-bottom: 0\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-manage.html","<script type=text/ng-template id=lista-manage-modal.tpl.html ng-controller=\"ListaManageController as lmc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-8 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{lmc.lista.id}} - {{lmc.lista.descrizione}}\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              {{lmc.lista.resa}}%\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n\n          <div bs-tabs\n               bs-active-pane=\"lmc.activeTab\"\n               ng-init=\"lmc.activeTab = 0\">\n            <!-- Andamento -->\n            <div data-title=\"Andamento\" bs-pane>\n              <div class=\"row\">\n                <div class=\"col-sm-6 table-responsive\">\n                  <h4>Stati Campagna</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtStatiLista.dtOptions\"\n                         dt-columns=\"::lmc.dtStatiLista.dtColumns\"\n                         dt-instance=\"lmc.dtStatiLista.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                  </table>\n                </div>\n\n                <div class=\"col-sm-6 table-responsive\" ng-if=\"lmc.dtStatiTelefonate.dtInstance\">\n                  <h4>Stati Telefonate</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtStatiTelefonate.dtOptions\"\n                         dt-columns=\"::lmc.dtStatiTelefonate.dtColumns\"\n                         dt-instance=\"lmc.dtStatiTelefonate.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                  </table>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-12 table-responsive\" ng-if=\"lmc.dtTelefonate.dtInstance\">\n                  <h4>Telefonate</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtTelefonate.dtOptions\"\n                         dt-columns=\"::lmc.dtTelefonate.dtColumns\"\n                         dt-instance=\"lmc.dtTelefonate.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                  </table>\n                </div>\n              </div>\n            </div>\n\n            <!-- Risultati -->\n            <div data-title=\"Risultati\" bs-pane>\n              <div class=\"row\">\n                <div class=\"col-sm-6 table-responsive\">\n                  <h4>Appuntamenti</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtEsitoAppuntamenti.dtOptions\"\n                         dt-columns=\"::lmc.dtEsitoAppuntamenti.dtColumns\"\n                         dt-instance=\"lmc.dtEsitoAppuntamenti.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                    <tfoot><tr></tr></tfoot>\n                  </table>\n                </div>\n\n                <div class=\"col-sm-6 table-responsive\">\n                  <h4>Contratti</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtEsitoContratti.dtOptions\"\n                         dt-columns=\"::lmc.dtEsitoContratti.dtColumns\"\n                         dt-instance=\"lmc.dtEsitoContratti.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                    <tfoot><tr></tr></tfoot>\n                  </table>\n                </div>\n              </div>\n            </div>\n\n            <!-- Zone -->\n            <div data-title=\"Zone\" bs-pane>\n              <div class=\"row\">\n                <div class=\"col-xs-12\" ng-if=\"lmc.dtEsitoZone.show\">\n                  <h4>Conteggio stati elenco per zone</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtEsitoZone.dtOptions\"\n                         dt-columns=\"::lmc.dtEsitoZone.dtColumns\"\n                         dt-instance=\"lmc.dtEsitoZone.dtInstance\"\n                         class=\"table table-striped table-hover\">\n                    <tfoot><tr></tr></tfoot>\n                  </table>\n                </div>\n              </div>\n            </div>\n\n            <!-- Note -->\n            <div data-title=\"Note\" bs-pane>\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <pre>{{lmc.lista.note}}</pre>\n                </div>\n              </div>\n            </div>\n\n            <!-- Gestione -->\n            <div data-title=\"Gestione\" bs-pane ng-if=\"lmc.user.userGroup >= 5\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <h4 class=\"text-nowrap\">\n                    <b>Clienti da assegnare: </b>{{lmc.lista.daAssegnare}}\n                    <span style=\"margin-right: 1em;\"></span>\n                    <button type=\"button\" class=\"btn btn-success\" title=\"Assegna clienti ad operatore\"\n                            ng-if=\"lmc.lista.daAssegnare > 0 && !lmc.lista.obsoleto\"\n                            ng-click=\"lmc.assignLista(lmc.lista.id)\">\n                      Assegna\n                    </button>\n                  </h4>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-xs-12 table-responsive\">\n                  <h4>Clienti assegnati</h4>\n\n                  <table datatable\n                         dt-options=\"::lmc.dtClientiAssegnati.dtOptions\"\n                         dt-columns=\"::lmc.dtClientiAssegnati.dtColumns\"\n                         dt-instance=\"lmc.dtClientiAssegnati.dtInstance\"\n                         class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-move.html","<script type=text/ng-template id=lista-move-modal.tpl.html ng-controller=\"ListaMoveController as lmc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-10 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Sposta clienti in {{lmc.lista.id}} - {{lmc.lista.descrizione}}\n            </div>\n            <div class=\"col-xs-2 text-right\">\n              {{lmc.lista.resa}}%\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <form name=\"listaMoveForm\" class=\"form-horizontal dataForm\" ng-submit=\"lmc.search()\" novalidate>\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Da Operatore</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lmc.formData.operatoriIN\"\n                  ng-model=\"lmc.sl.idOperatoreIn\" name=\"idOperatoreIn\"\n                  ng-change=\"lmc.disableMove = true\"\n                  required>\n                </select>\n              </div>\n\n              <label class=\"control-label col-xs-2\">A Operatore</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lmc.formData.operatoriOUT\"\n                  ng-model=\"lmc.sl.idOperatoreOut\" name=\"idOperatoreOut\"\n                  ng-change=\"lmc.disableMove = true\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Stato</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lmc.formData.stati\"\n                  ng-model=\"lmc.sl.idStatoElenco\" name=\"idStatoElenco\"\n                  ng-change=\"lmc.disableMove = true\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Zona</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in lmc.formData.zone\"\n                        ng-model=\"lmc.sl.idZona\" name=\"idZona\"\n                        ng-change=\"lmc.disableMove = true\">\n                </select>\n              </div>\n\n              <label class=\"control-label col-xs-2\">Citta</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lmc.formData.citta\"\n                  ng-model=\"lmc.sl.citta\" name=\"citta\"\n                  ng-change=\"lmc.disableMove = true\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-12 text-right\">\n                <button type=\"reset\" class=\"btn btn-warning\" title=\"Resetta\" ng-click=\"lmc.resetForm()\"><i class=\"fa fa-fw fa-undo\"></i></button>\n                <button type=\"submit\" class=\"btn btn-info\" title=\"Cerca\"><i class=\"fa fa-fw fa-search\"></i></button>\n              </div>\n            </div>\n          </form>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\" id=\"lmc-alerts\"></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\" ng-if=\"lmc.dtClientiAssegnati.show\">\n              <table datatable\n                dt-options=\"::lmc.dtClientiAssegnati.dtOptions\"\n                dt-columns=\"::lmc.dtClientiAssegnati.dtColumns\"\n                dt-instance=\"lmc.dtClientiAssegnati.dtInstance\"\n                class=\"table table-hover table-condensed\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-danger\"\n            ng-disabled=\"lmc.disableMove\" ng-attr-title=\"{{lmc.disableMove ? \'effettuare la ricerca prima di poter spostare i nominativi\' : \'\'}}\"\n            ng-click=\"lmc.move()\">\n            <i class=\"fa fa-fw fa-exchange\"></i>\n            Sposta\n          </button>\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-fw fa-times\"></i> Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-remove.html","<script type=text/ng-template id=lista-remove-modal.tpl.html ng-controller=\"ListaRemoveController as lrc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-10 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Rimuovi clienti da {{lrc.lista.id}} - {{lrc.lista.descrizione}}\n            </div>\n            <div class=\"col-xs-2 text-right\">\n              {{lrc.lista.resa}}%\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <form name=\"listaRemoveForm\" class=\"form-horizontal dataForm\" ng-submit=\"lrc.search()\" novalidate>\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Clienti da considerare</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-model=\"lrc.sl.assegnati\" name=\"assegnati\"\n                  ng-change=\"lrc.disableRemove = true\"\n                  required>\n                  <option value=\"-1\" selected>TUTTI</option>\n                  <option value=\"0\">NON ASSEGNATI</option>\n                  <option value=\"1\">ASSEGNATI</option>\n                </select>\n              </div>\n\n              <label class=\"control-label col-xs-2\">Stato</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lrc.formData.stati\"\n                  ng-model=\"lrc.sl.idStatoElenco\" name=\"idStatoElenco\"\n                  ng-change=\"lrc.disableRemove = true\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-2\">Zona</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lrc.formData.zone\"\n                  ng-model=\"lrc.sl.idZona\" name=\"idZona\"\n                  ng-change=\"lrc.disableRemove = true\">\n                </select>\n              </div>\n\n              <label class=\"control-label col-xs-2\">Citta</label>\n              <div class=\"col-xs-10 col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in lrc.formData.citta\"\n                  ng-model=\"lrc.sl.citta\" name=\"citta\"\n                  ng-change=\"lrc.disableRemove = true\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-12 text-right\">\n                <button type=\"reset\" class=\"btn btn-warning\" title=\"Resetta\" ng-click=\"lrc.resetForm()\"><i class=\"fa fa-fw fa-undo\"></i></button>\n                <button type=\"submit\" class=\"btn btn-info\" title=\"Cerca\"><i class=\"fa fa-fw fa-search\"></i></button>\n              </div>\n            </div>\n          </form>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\" id=\"lrc-alerts\"></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\" ng-if=\"lrc.dtClientiAssegnati.show\">\n              <table datatable\n                dt-options=\"::lrc.dtClientiAssegnati.dtOptions\"\n                dt-columns=\"::lrc.dtClientiAssegnati.dtColumns\"\n                dt-instance=\"lrc.dtClientiAssegnati.dtInstance\"\n                class=\"table table-hover table-condensed\">\n              </table>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <div class=\"alert alert-danger\">\n                <h4>ATTENZIONE</h4>\n                <ul>\n                  <li>I nominativi con appuntamenti NON verranno eliminati</li>\n                  <li>I nominativi con telefonate verranno cancellati assieme alle loro telefonate</li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-danger\"\n            ng-disabled=\"lrc.disableRemove\" ng-attr-title=\"{{lrc.disableRemove ? \'effettuare la ricerca prima di poter eliminare i nominativi\' : \'\'}}\"\n            ng-click=\"lrc.remove()\">\n            <i class=\"fa fa-trash\"></i> Elimina\n          </button>\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/lista-update.html","<script type=text/ng-template id=lista-update-modal.tpl.html ng-controller=\"ListaUpdateController as luc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"listaUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"luc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{luc.lista.id}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{luc.lista.dataInserimento | date:\'shortDate\'}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{luc.lista.resa}}%\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Clienti</label>\n              <p class=\"col-sm-1 form-control-static\">{{luc.lista.clienti}}</p>\n\n              <label class=\"control-label col-sm-2\">Chiamati</label>\n              <p class=\"col-sm-1 form-control-static\">{{luc.lista.chiamati}}</p>\n\n              <label class=\"control-label col-sm-2\">Appuntamentati</label>\n              <p class=\"col-sm-1 form-control-static\">{{luc.lista.appuntamentati}}</p>\n\n              <label class=\"control-label col-sm-2\">Non Lavorati</label>\n              <p class=\"col-sm-1 form-control-static\">{{luc.lista.aperti}}</p>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10 has-warning\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"luc.lista.descrizione\" name=\"descrizione\"\n                       required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-2\">Data</label>\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"luc.lista.dataApertura\" name=\"dataApertura\"\n                       bs-datepicker data-max-date=\"{{luc.lista.dataChiusura}}\"\n                       data-container=\".modal\"\n                       required>\n                <span class=\"help-block\">Da</span>\n              </div>\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                       ng-model=\"luc.lista.dataChiusura\" name=\"dataChiusura\"\n                       bs-datepicker data-min-date=\"{{luc.lista.dataApertura}}\"\n                       data-container=\".modal\"\n                       required>\n                <span class=\"help-block\">A</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Tipo</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in luc.formData.tipi\"\n                        ng-model=\"luc.lista.tipoMotivo\" name=\"tipoMotivo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"checkbox col-xs-12 col-sm-offset-2 col-sm-5\">\n                <label>\n                  <input type=\"checkbox\" value=\"1\"\n                         ng-model=\"luc.lista.obsoleto\" name=\"obsoleto\">\n                  <b>&nbsp;Obsoleto</b>\n                </label>\n              </div>\n\n              <div class=\"checkbox col-xs-12 col-sm-5\">\n                <label>\n                  <input type=\"checkbox\" value=\"1\"\n                         ng-model=\"luc.lista.cieca\" name=\"cieca\">\n                  <b>&nbsp;Cieca</b>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"luc.lista.note\" name=\"note\"></textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"luc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/liste/liste.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_liste\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><h3 style=\"color: hsl(210, 100%, 30%)\">Ricerca Campagne</h3><form role=form name=search_liste class=form-horizontal><div class=row><div class=\"col-md-6 col-lg-4\"><!-- questo serve per allineare con le altre due label --><div class=\"form-group visible-lg-block\"><label class=\"control-label col-xs-12\">&nbsp;</label></div><div class=form-group><label class=\"control-label col-sm-2\">ID Camp.</label><div class=col-sm-10><input type=text class=form-control ng-model=liste.sl.id name=id></div></div><div class=form-group><label class=\"control-label col-sm-2\" title=Descrizione>Desc.</label><div class=col-sm-10><input type=text class=form-control ng-model=liste.sl.descrizione name=descrizione></div></div><div class=form-group><label class=\"control-label col-sm-2\">Tipo</label><div class=col-sm-10><select class=form-control ng-options=\"el.value as el.label for el in liste.formData.tipi\" ng-model=liste.sl.tipoMotivo name=tipoMotivo></select></div></div></div><div class=\"col-md-6 col-lg-4\"><!-- questo serve per allineare con le altre due label --><div class=\"form-group visible-lg-block\"><label class=\"control-label col-xs-12\">&nbsp;</label></div><div class=form-group><label class=\"control-label col-sm-2\">Obsoleto</label><div class=col-sm-10><select class=form-control ng-model=liste.sl.obsoleto name=obsoleto><option value=-1 selected>TUTTI</option><option value=0>NO</option><option value=1>SI</option></select></div></div><div class=form-group><label class=\"control-label col-sm-2\">Cieca</label><div class=col-sm-10><select class=form-control ng-model=liste.sl.cieca name=cieca><option value=-1 selected>TUTTE</option><option value=0>NO</option><option value=1>SI</option></select></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=form-group><label class=\"control-label col-xs-offset-2 col-xs-5\" style=\"text-align: center\">DA</label><label class=\"control-label col-xs-5\" style=\"text-align: center\">A</label></div><div class=form-group><label class=\"control-label col-xs-2\">Inizio</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.start_from name=start_from bs-datepicker data-max-date={{liste.sl.start_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.start_to name=start_to bs-datepicker data-min-date={{liste.sl.start_from}} data-placement=bottom-right></div></div><div class=form-group><label class=\"control-label col-xs-2\">Fine</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.end_from name=end_from bs-datepicker data-max-date={{liste.sl.end_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.end_to name=end_to bs-datepicker data-min-date={{liste.sl.end_from}} data-placement=bottom-right></div></div><div class=form-group><label class=\"control-label col-xs-2\" title=Caricamento>Caric.</label><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.ins_from name=ins_from bs-datepicker data-max-date={{liste.sl.ins_to}}></div><div class=col-xs-5><input type=text class=form-control placeholder=gg/mm/aaaa ng-model=liste.sl.ins_to name=ins_to bs-datepicker data-min-date={{liste.sl.ins_from}} data-placement=bottom-right></div></div></div></div><div class=form-group><div class=\"col-xs-12 text-right\"><div class=btn-group ng-if=\"liste.user.userGroup >= 5\"><button type=button class=\"btn btn-success\" title=\"Genera campagna da filtri\" ng-click=liste.importLista()>Genera</button> <button type=button class=\"btn btn-success\" title=\"Inserisci campagna vuota\" ng-click=liste.createLista()>Inserisci</button></div><span style=\"margin-right: 1em\"></span> <button type=reset class=\"btn btn-warning\" title=Resetta ng-click=liste.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca ng-click=liste.search()><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=g1-panel ng-show=liste.dtListe.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::liste.dtListe.dtOptions dt-columns=::liste.dtListe.dtColumns dt-instance=liste.dtListe.dtInstance class=\"table table-hover table-condensed\"></table></div></div></div></div>");
$templateCache.put("app/core/login/login.html","<div class=container-fluid><div class=row><div class=\"col-md-4 col-md-offset-4\"><script type=text/ng-template id=login.tpl.html><div class=\"panel panel-default animated\" style=\"margin-top: 25%\"\n             ng-class=\"{\'shake\': error}\">\n          <div class=\"panel-heading\">\n            <h3 class=\"panel-title\">Si prega di fare login</h3>\n          </div>\n          <div class=\"panel-body\">\n            <form class=\"login-form\" ng-show=\"ready\" ng-submit=\"submit()\" novalidate>\n              <fieldset>\n                <div class=\"form-group\">\n                  <input class=\"form-control\" placeholder=\"Username\" name=\"username\" type=\"text\" ng-model=\"username\" autofocus required>\n                </div>\n                <div class=\"form-group\">\n                  <input class=\"form-control\" placeholder=\"Password\" name=\"password\" type=\"password\" ng-model=\"password\" required>\n                </div>\n\n                <div class=\"alert alert-danger\" ng-show=\"error\">Accesso negato!</div>\n\n                <button type=\"submit\"\n                        class=\"btn btn-lg btn-success btn-block\"\n                        value=\"Login\"\n                        ng-click=\"error = false\">\n                  Login\n                </button>\n              </fieldset>\n            </form>\n          </div>\n        </div></script><div authenticate-login-form template-url=login.tpl.html></div></div></div></div>");
$templateCache.put("app/core/main/main.html","<div class=container-fluid><div class=row><div class=col-xs-12>Home</div></div></div>");
$templateCache.put("app/core/operatori/liste-operatore.html","<script type=text/ng-template id=liste-operatore-modal.tpl.html ng-controller=\"ListeOperatoreController as loc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Campagne{{loc.filtro.operatore ? \' di \' + loc.filtro.operatore : \'\'}}\n              {{loc.filtro.fromDate ? \' dal \' + (loc.filtro.fromDate | date:\'shortDate\') : \'\'}}\n              {{loc.filtro.toDate ? \' al \' + (loc.filtro.toDate | date:\'shortDate\') : \'\'}}\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::loc.dtListe.dtOptions\"\n                     dt-columns=\"::loc.dtListe.dtColumns\"\n                     dt-instance=\"loc.dtListe.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"loc.dtStatiTelefonate.show\">\n            <div class=\"col-xs-12 table-responsive\">\n              <h4>{{loc.filtro.motivo}}</h4>\n              <table datatable\n                     dt-options=\"::loc.dtStatiTelefonate.dtOptions\"\n                     dt-columns=\"::loc.dtStatiTelefonate.dtColumns\"\n                     dt-instance=\"loc.dtStatiTelefonate.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/conferma-avanzamento-fase.html","<script type=text/ng-template id=conferma-avanzamento-fase.tpl.html ng-controller=\"ConfermaAvanzamentoFaseController as cafc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"invia-notifica-pv\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-title\">\n            <div class=\"pull-left\">\n              <h4>\n                <span class=\"margin-right\">\n                  <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                </span>\n                Avanzamento fase opportunità\n              </h4>\n            </div>\n          </div>\n        </div>\n          <div class=\"modal-body\">\n            Il completamento del progetto collegato  suggerisce un avanzamento della fase dell\'opportunità a \"Presentazione\". Confermi?\n          </div>\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\" ng-click=\"cafc.avanzamentoFaseOpportunita(cafc.progetto)\"><i class=\"fa fa-check\"></i> Conferma</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/opportunita-associa.html","<script type=text/ng-template id=opportunita-associa-modal.tpl.html ng-controller=\"OpportunitaAssociaController as oac\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"oac.opportunitaAssociaForm\" class=\"form-horizontal dataForm\" ng-submit=\"oac.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title\">Associa ad Opportunità</h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-xs-12 table-responsive\">\n                <table datatable\n                       dt-options=\"oac.dt.options\"\n                       dt-columns=\"oac.dt.columns\"\n                       dt-instance=\"oac.dt.instance\"\n                       class=\"table table-hover\">\n                </table>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"!(oac.appuntamento.idOpportunita > 0)\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/opportunita-edit-segnalatore.html","<script type=text/ng-template id=opportunita-edit-segnalatore-modal.tpl.html ng-controller=\"OpportunitaEditSegnalatoreController as oesc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"OpportunitaEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"oesc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{oesc.action === \'create\' ? \"Nuova Opportunita\" : (oesc.opportunita.dataSegnalazione | date:\'shortDate\')}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                {{oesc.opportunita.cliente}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Pista</label>\n              <div class=\"col-sm-10 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in oesc.formData.piste\n                          | filter:{fornitore: oesc.opportunita.fornitore}:true\n                          | orderBy:\'label\'\"\n                        ng-model=\"oesc.opportunita.pista\" name=\"pista\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Tipo Ingaggio</label>\n              <div class=\"col-sm-10 validate-group has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in oesc.formData.fonti\"\n                        ng-model=\"oesc.opportunita.idFonte\" name=\"idFonte\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"2\" class=\"form-control\"\n                          ng-model=\"oesc.opportunita.noteFonte\" name=\"noteFonte\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Referente</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"oesc.opportunita.referente\" name=\"referente\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Contatto</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"oesc.opportunita.contatto\" name=\"contatto\">\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{oesc.alerts.status}}\" data-messages=\"oesc.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"oesc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/opportunita-edit.html","<script type=text/ng-template id=opportunita-edit-modal.tpl.html ng-controller=\"OpportunitaEditController as oec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"opportunita-edit-modal\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"OpportunitaEditForm\" class=\"form-horizontal\" ng-submit=\"oec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{oec.action === \'create\' ? \"Nuova Opportunita\" : (oec.opportunita.dataSegnalazione | date:\'shortDate\')}}\n              </div>\n              <div class=\"col-xs-4 text-center\">\n                {{oec.opportunita.cliente}}\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                {{oec.opportunita.idFonte ? (oec.formData.fonti | filter:{value: oec.opportunita.idFonte}:true)[0].label : \'\'}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\" title=\"Agente presa in carico\">Agente</label>\n              <div class=\"col-sm-4 col-lg-2\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.agentiPIC\n                    | orderBy:\'gruppo\'\"\n                  ng-model=\"oec.opportunita.idAgentePIC\" name=\"idAgentePIC\"\n                  ng-disabled=\"oec.user.userGroup == 1\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Fornitore</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.fornitori\n                    | orderBy:\'label\'\"\n                  ng-model=\"oec.opportunita.fornitore\" name=\"fornitore\"\n                  required>\n                </select>\n              </div>\n\n              <div class=\"clearfix visible-sm-block visible-md-block\" style=\"margin-bottom: 15px;\"></div>\n\n              <label class=\"control-label col-sm-2\">Pista</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.piste\n                    | filter:{fornitore: oec.opportunita.fornitore}:true\n                    | orderBy:\'label\'\"\n                  ng-model=\"oec.opportunita.pista\" name=\"pista\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Valore</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group\">\n                <div class=\"input-group\">\n                  <input type=\"number\" class=\"form-control\"\n                    ng-model=\"oec.opportunita.valore\" name=\"valore\"\n                    decimal step=\"0.01\" min=\"0\" max=\"999999\">\n                  <span class=\"input-group-addon\">&euro;</span>\n                </div>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Probabilità</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group\">\n                <div class=\"input-group\">\n                  <input type=\"number\" class=\"form-control\"\n                    ng-model=\"oec.opportunita.percChiusura\" name=\"percChiusura\"\n                    percent precision=\"0\" step=\"0\" min=\"0\" max=\"100\">\n                  <span class=\"input-group-addon\">%</span>\n                </div>\n              </div>\n\n              <div class=\"clearfix visible-sm-block visible-md-block\" style=\"margin-bottom: 15px;\"></div>\n\n              <label class=\"control-label col-sm-2\" title=\"Data di prevista chiusura\">Data chiusura</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"oec.opportunita.dataChiusura\" name=\"dataChiusura\"\n                  bs-datepicker data-placement=\"bottom-right\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Fonte</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.fonti\"\n                  ng-model=\"oec.opportunita.idFonte\" name=\"idFonte\"\n                  required>\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Note Fonte</label>\n              <div class=\"col-sm-4 col-lg-2\">\n                <textarea rows=\"2\" class=\"form-control\"\n                  ng-model=\"oec.opportunita.noteFonte\" name=\"noteFonte\">\n                </textarea>\n              </div>\n\n              <!-- se la fonte ha un soggetto collegato richiedilo qui -->\n              <span ng-if=\"oec.checkSoggettoFonte(oec.opportunita.idFonte)\">\n                <div class=\"clearfix visible-sm-block visible-md-block\" style=\"margin-bottom: 15px;\"></div>\n\n                <label class=\"control-label col-sm-2\">Segnalatore</label>\n                <div class=\"col-sm-4 col-lg-2 validate-group has-warning\">\n                  <select class=\"form-control\"\n                    ng-options=\"el.value as el.label for el in oec.formData.agentiS\"\n                    ng-model=\"oec.opportunita.idAgenteS\" name=\"idAgenteS\"\n                    required>\n                  </select>\n                </div>\n              </span>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Referente Cliente</label>\n              <div class=\"col-sm-4 col-lg-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"oec.opportunita.referente\" name=\"referente\">\n              </div>\n\n              <label class=\"control-label col-sm-2\">Contatto Cliente</label>\n              <div class=\"col-sm-4 col-lg-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"oec.opportunita.contatto\" name=\"contatto\">\n              </div>\n\n              <div class=\"clearfix visible-sm-block visible-md-block\" style=\"margin-bottom: 15px;\"></div>\n\n              <label class=\"control-label col-sm-2\">Passaggio Successivo</label>\n              <div class=\"col-sm-4 col-lg-2\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"oec.opportunita.passSucc\" name=\"passSucc\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note Opportunità</label>\n              <div class=\"col-sm-10 col-lg-6\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"oec.opportunita.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Pipeline</label>\n              <div class=\"col-sm-4 validate-group \">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.pipelines\"\n                  ng-model=\"oec.opportunita.idPipeline\" name=\"idPipeline\"\n                  ng-disabled=\"oec.user.userGroup == 1\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n\n              <!-- se selezionata una pipeline richiedere anche la fase -->\n              <span ng-if=\"oec.opportunita.idPipeline\">\n                <label class=\"control-label col-sm-2\">Fase</label>\n                <div class=\"col-sm-4 validate-group has-warning\">\n                  <select class=\"form-control\"\n                    ng-options=\"el.value as el.label for el in oec.formData.stages\n                      | filter:{idPipeline: oec.opportunita.idPipeline}:true\"\n                    ng-model=\"oec.opportunita.idStage\" name=\"idStage\"\n                    ng-change=\"oec.setPercChiusura()\"\n                    required>\n                  </select>\n                </div>\n              </span>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-4 validate-group has-warning\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.stati\n                    | orderBy:\'label\'\"\n                  ng-model=\"oec.opportunita.idStato\" name=\"idStato\"\n                  required>\n                </select>\n              </div>\n\n              <label class=\"control-label col-sm-2\">Motivo</label>\n              <div class=\"col-sm-4 validate-group\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in oec.formData.dettagliStato\n                    | filter:{idStato: oec.opportunita.idStato}:true\"\n                  ng-model=\"oec.opportunita.idDettStato\" name=\"idDettStato\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Data opportunità</label>\n              <div class=\"col-sm-4 col-lg-2 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"gg/mm/aaaa\"\n                  ng-model=\"oec.opportunita.dataSegnalazione\" name=\"dataSegnalazione\"\n                  bs-datepicker data-container=\"#opportunita-edit-modal\"\n                  required>\n              </div>\n\n              <span ng-if=\"oec.opportunita.idAgentePIC\">\n                <label class=\"control-label col-sm-2\">Seguimi</label>\n                <div class=\"col-sm-4 col-lg-2 validate-group checkbox\">\n                  <label>\n                    <input type=\"checkbox\"\n                      ng-model=\"oec.opportunita.seguimi\" name=\"seguimi\">\n                  </label>\n                </div>\n              </span>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{oec.alerts.status}}\" data-messages=\"oec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"oec.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/opportunita-read.html","<div ng-include=\"\'app/core/opportunita/logs/opportunita-log.html\'\"></div><div ng-include=\"\'app/core/opportunita/logs/opportunita-log-update.html\'\"></div><div ng-include=\"\'app/core/opportunita/attivita/opportunita-attivita-read.html\'\"></div><div ng-include=\"\'app/core/opportunita/attivita/opportunita-attivita-edit.html\'\"></div><script type=text/ng-template id=opportunita-read-modal.tpl.html ng-controller=\"OpportunitaReadController as orc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-orange\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-9 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Opportunità&nbsp;del&nbsp;{{orc.opportunita.dataSegnalazione | date:\'shortDate\'}}\n              per&nbsp;<span ng-click=\"orc.readCliente(orc.opportunita.idCliente)\"><u>{{orc.opportunita.cliente}}</u></span>\n              ({{orc.opportunita.stato}}&nbsp;{{orc.opportunita.dettStato}})\n            </div>\n\n            <div class=\"col-xs-3 text-right\">\n              <g1-prom-bell\n                tabella=\"opportunita\"\n                campo-id=\"IDOpportunita\"\n                record-id=\"{{orc.opportunita.id}}\">\n              </g1-prom-bell>\n\n              <button ng-if=\"orc.azioni.length > 0\"\n                type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                bs-dropdown=\"orc.azioni\"\n                data-placement=\"bottom-right\">\n                Azioni&nbsp;<span class=\"caret\"></span>\n              </button>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>Fornitore:</label>\n              {{orc.opportunita.fornitore}}\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label>Pista:</label>\n              {{orc.opportunita.pista}}\n            </div>\n\n            <div class=\"col-sm-3\" ng-init=\"orc.showChangeValore = false\">\n              <label>Valore:</label>\n              <span ng-if=\"!orc.showChangeValore\">\n                {{orc.opportunita.valore | number:0}}\n                <button type=\"button\" class=\"btn btn-xs btn-warning\"\n                  ng-if=\"orc.checkEditPermission(orc.user, orc.opportunita) !== false\"\n                  ng-click=\"orc.showChangeValore = true\"><i class=\"fa fa-fw fa-pencil\"></i></button>\n              </span>\n              <span ng-if=\"orc.showChangeValore\" class=\"validate-group\">\n                <input type=\"number\" name=\"valore\"\n                  decimal step=\"0.01\" min=\"0\" max=\"999999\"\n                  ng-model=\"orc.opportunita.valore\"\n                  required>\n                <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"orc.showChangeValore = false\"></i>\n                <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"orc.changeValore()\"></i>\n              </span>\n\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label title=\"Agente che ha preso in carico\">Agente:</label>\n\n              <span ng-if=\"orc.opportunita.agentePIC\">\n                {{orc.opportunita.agentePIC}}\n                <i class=\"fa fa-fw fa-lg fa-bell-o text-success\" title=\"Opzione seguimi attivata per l\'agente\" ng-if=\"orc.opportunita.seguimi\"></i>\n              </span>\n\n              <span ng-if=\"!orc.opportunita.agentePIC\" class=\"text-danger\">NESSUNO</span>\n            </div>\n          </div>\n          <br>\n\n          <div class=\"row\" ng-if=\"orc.opportunita.pipeline\">\n            <div class=\"col-sm-3\">\n              <label>Pipeline:</label>\n              {{orc.opportunita.pipeline}}\n            </div>\n\n            <div class=\"col-sm-3\" ng-init=\"orc.showChangeFase = false\">\n              <label>Fase:</label>\n\n              <span ng-if=\"!orc.showChangeFase\">\n                {{orc.opportunita.stage}}\n                <button type=\"button\" class=\"btn btn-xs btn-warning\"\n                  ng-if=\"orc.checkEditPermission(orc.user, orc.opportunita) !== false\"\n                  ng-click=\"orc.showChangeFase = true\"><i class=\"fa fa-fw fa-pencil\"></i></button>\n              </span>\n\n              <span ng-if=\"orc.showChangeFase\" class=\"validate-group\">\n                <select ng-options=\"el.value as el.label for el in orc.formData.stages\"\n                  ng-model=\"orc.opportunita.idStage\" name=\"idStage\"\n                  ng-change=\"orc.setPercChiusura()\"\n                  required>\n                </select>\n\n                <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"orc.showChangeFase = false\"></i>\n                <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"orc.changeFase()\"></i>\n              </span>\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label>Richiesta progettazione:</label>\n              <button\n                type=\"button\"\n                class=\"btn btn-xs btn-warning\"\n                ng-click=\"orc.richiestaProgettazione()\"\n                ng-if=\"orc.opportunita.dataOraInvioRichiestaProgettazione==\'\'&&orc.opportunita.idStato==\'1\'\">\n                <i class=\"fa fa-envelope\"></i> Richiedi progettazione\n              </button>\n              <span ng-if=\"orc.opportunita.dataOraInvioRichiestaProgettazione!=\'\'\">\n                {{orc.opportunita.dataOraInvioRichiestaProgettazione | date:\'shortDate\'}}\n              </span>\n              <span ng-if=\"orc.opportunita.idProgetto!=\'\'&&!orc.user.flags.gestProg\">\n                ({{orc.opportunita.stage}})\n              </span>\n              <button\n                type=\"button\"\n                class=\"btn btn-xs btn-warning\"\n                ng-click=\"orc.readProgetto(orc.opportunita.idProgetto)\"\n                ng-if=\"orc.opportunita.idProgetto!=\'\'&&orc.user.flags.gestProg\">\n                <i class=\"fa fa-external-link\"></i> Vedi progetto\n              </button>\n            </div>\n\n          </div>\n          <br>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3\" ng-class=\"{\n              \'text-danger\': orc.showChangeFase\n            }\">\n              <label>Probabilità:</label>\n              {{(orc.opportunita.percChiusura * 100) | number:0}}&nbsp;%\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label>Data prevista chiusura:</label>\n\n              <span ng-if=\"orc.opportunita.dataChiusura\">{{orc.opportunita.dataChiusura | date:\'shortDate\'}}</span>\n              <span ng-if=\"!orc.opportunita.dataChiusura\" class=\"text-danger\">\n                <i class=\"fa fa-fw fa-lg fa-exclamation-circle\" title=\"è consigliabile inserire una data prevista chiusura\"></i>\n              </span>\n            </div>\n          </div>\n          <br>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>Fonte:</label>\n              {{orc.opportunita.fonte}}\n            </div>\n\n            <div class=\"col-sm-6\">\n              <label>Note&nbsp;Fonte:</label>\n              {{orc.opportunita.noteFonte}}\n            </div>\n\n            <div class=\"col-sm-3\" ng-if=\"orc.opportunita.idAgenteS\">\n              <label>Segnalatore:</label>\n              {{orc.opportunita.segnalatore}}\n            </div>\n          </div>\n          <br>\n\n          <div class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>Referente:</label>\n              {{orc.opportunita.referente}}\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label>Contatto:</label>\n              {{orc.opportunita.contatto}}\n            </div>\n\n            <div class=\"col-sm-3\">\n              <label title=\"Passaggio successivo\">Pass.&nbsp;Successivo:</label>\n              {{orc.opportunita.passSucc}}\n            </div>\n          </div>\n          <br>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              <label>Note&nbsp;Opportunità:</label>\n              {{orc.opportunita.note}}\n            </div>\n          </div>\n\n          <div class=\"row\" style=\"margin-top: 1em;\" ng-if=\"orc.checkEditPermission(orc.user, orc.opportunita) !== false\">\n            <div class=\"col-xs-12 text-center\">\n              <div class=\"btn-group\">\n                <button class=\"btn btn-danger btn-opportunita-stato\" ng-click=\"orc.changeStato(\'3\')\">\n                  Chiusa Negativa<i class=\"fa fa-fw fa-check\" ng-if=\"orc.opportunita.idStato === 3\"></i>\n                </button>\n                <button class=\"btn btn-default btn-opportunita-stato\" ng-click=\"orc.changeStato(\'5\')\">\n                  Rifiutata<i class=\"fa fa-fw fa-check\" ng-if=\"orc.opportunita.idStato === 5\"></i>\n                </button>\n                <button class=\"btn btn-default btn-opportunita-stato\" ng-click=\"orc.changeStato(\'1\')\">\n                  Aperta<i class=\"fa fa-fw fa-check\" ng-if=\"orc.opportunita.idStato === 1\"></i>\n                </button>\n                <button class=\"btn btn-default btn-opportunita-stato\" ng-click=\"orc.changeStato(\'4\')\">\n                  Sospesa<i class=\"fa fa-fw fa-check\" ng-if=\"orc.opportunita.idStato === 4\"></i>\n                </button>\n                <button class=\"btn btn-success btn-opportunita-stato\" ng-click=\"orc.changeStato(\'2\')\">\n                  Chiusa Positiva<i class=\"fa fa-fw fa-check\" ng-if=\"orc.opportunita.idStato === 2\"></i>\n                </button>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-6 col-sm-offset-6 hidden-xs\">\n              <div class=\"tabHeaderButtons\">\n                <div ng-if=\"orc.opportunita.idStato==1\" class=\"inline-block\">\n                  <button type=\"button\" class=\"btn btn-info btn-xs\" data-trigger=\"click\" bs-dropdown data-placement=\"left\">\n                    <i class=\"fa fa-plus\"></i> Attività\n                  </button>\n                  <ul class=\"dropdown-menu\" role=\"menu\">\n                    <li><a ng-click=\"orc.createAttivita(\'1\')\">Attività generica</a></li>\n                    <li><a ng-click=\"orc.createAppuntamentoOpportunita()\">Appuntamento</a></li>\n                    <li><a ng-click=\"orc.createAttivita(\'3\')\">Telefonata</a></li>\n                    <li><a ng-click=\"orc.createAttivita(\'4\')\">Email</a></li>\n                  </ul>\n                </div>\n                <button\n                  type=\"button\"\n                  class=\"btn btn-info btn-xs\"\n                  bs-tooltip data-title=\"Inserisci allegato\"\n                  ng-click=\"orc.createAllegato(orc.opportunita)\">\n                  <i class=\"fa fa-plus\"></i> Allegato\n                </button>\n              </div>\n            </div>\n            <div class=\"col-xs-12 table-responsive\">\n              <div bs-tabs\n                bs-active-pane=\"orc.activeTab\"\n                ng-init=\"orc.activeTab = 0\">\n\n                <div data-title=\"{{orc.titleAttivita}}\" bs-pane>\n                  <table id=\"opportunita_attivita\" datatable\n                    dt-options=\"orc.dtAttivita.options\"\n                    dt-columns=\"orc.dtAttivita.columns\"\n                    dt-instance=\"orc.dtAttivita.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"{{orc.titleAllegati}}\" bs-pane>\n                  <table id=\"opportunita_allegati\" datatable\n                    dt-options=\"orc.dtAllegati.options\"\n                    dt-columns=\"orc.dtAllegati.columns\"\n                    dt-instance=\"orc.dtAllegati.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div title=\"Storico\" bs-pane>\n                  <table id=\"opportunita_storico\" datatable\n                    dt-options=\"orc.dtStorico.options\"\n                    dt-columns=\"orc.dtStorico.columns\"\n                    dt-instance=\"orc.dtStorico.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"prc.alerts.messages.length > 0\">\n            <div class=\"col-xs-12\">\n              <g1-alerts data-status=\"{{prc.alerts.status}}\" data-messages=\"prc.alerts.messages\"></g1-alerts>\n            </div>\n          </div>\n\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"orc.user.userGroup > 4 && orc.user.userGroup < 9\">\n                <small>\n                  Inserito:{{orc.opportunita.idUtenteIns}} - {{orc.opportunita.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{orc.opportunita.idUtenteMod}} - {{orc.opportunita.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script><script type=text/ng-template id=opportunita-richiesta-progettazione-modal.tpl.html><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-sm\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-warning\">\n          <h4 class=\"modal-title row\">\n            Conferma richiesta\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          Vuoi davvero inviare la richiesta di progettazione?\n        </div>\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-6\">\n              <button type=\"button\" class=\"btn btn-success btn-fullwidth\" ng-click=\"orc.richiestaProgettazione(true)\"><i class=\"fa fa-save\"></i> Conferma</button>\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              <button type=\"button\" class=\"btn btn-danger btn-fullwidth\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/opportunita-view.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid></div>");
$templateCache.put("app/core/opportunita/opportunita.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><!-- navbar --><div class=row ng-if=opportunita.user.flags.gestOppo><div class=\"col-xs-12 col-md-3\"><ul class=\"nav nav-pills\"><li role=presentation ng-class=\"{\'active\': opportunita.activeTab === \'dashboard\'}\"><a href=\"\"><i class=\"fa fa-fw fa-lg fa-angle-double-left\" bs-tooltip data-title=\"Filtri Dashboard\" ng-show=\"opportunita.activeTab === \'dashboard\'\" ng-click=opportunita.showAside()>&nbsp;&nbsp;&nbsp;</i> <i class=\"fa fa-fw fa-bar-chart fa-flip-vertical\" bs-tooltip data-title=Dashboard ng-click=\"opportunita.activeTab = \'dashboard\'\"></i></a></li><li role=presentation ng-class=\"{\'active\': opportunita.activeTab === \'ricerca\'}\"><a href=\"\" ng-click=\"opportunita.activeTab = \'ricerca\'\"><i class=\"fa fa-fw fa-bars\" bs-tooltip data-title=Ricerca></i></a></li></ul></div><div class=\"col-xs-12 col-md-6 text-center\" ng-if=\"opportunita.activeTab === \'dashboard\'\"><div class=vcenter-block><span class=\"badge alert-info\" ng-if=opportunita.sok.fromDataS>Da:&nbsp;{{opportunita.sok.fromDataS | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'fromDataS\')\"></i> </span><span class=\"badge alert-info\" ng-if=opportunita.sok.toDataS>A:&nbsp;{{opportunita.sok.toDataS | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'toDataS\')\"></i> </span><span class=\"badge alert-warning\" ng-if=opportunita.sok.fromDataC>Da:&nbsp;{{opportunita.sok.fromDataC | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'fromDataC\')\"></i> </span><span class=\"badge alert-warning\" ng-if=opportunita.sok.toDataC>A:&nbsp;{{opportunita.sok.toDataC | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'toDataC\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opportunita.sok.idAgentePIC > 0 || opportunita.sok.idAgentePIC === \'NULL\'\">{{(opportunita.formData.agentiPIC | filter:{value: opportunita.sok.idAgentePIC}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'idAgentePIC\')\"></i> </span><span class=\"badge alert-info\" ng-if=opportunita.sok.fornitore>{{opportunita.sok.fornitore}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'fornitore\')\"></i> </span><span class=\"badge alert-info\" ng-if=opportunita.sok.pista>{{opportunita.sok.pista}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'pista\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opportunita.sok.idStato > 0\">{{(opportunita.formData.stati | filter:{value: opportunita.sok.idStato}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opportunita.unsetFilter(\'idStato\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opportunita.sok.fromPerc >= 0\">&ge;{{opportunita.sok.fromPerc * 100}}%&nbsp; <i class=\"fa fa-times fa-fw close-button\" bs-tooltip data-title=Probabilità ng-click=\"opportunita.unsetFilter(\'fromPerc\')\"></i> </span><span class=text-nowrap><b>Totale:</b> <span class=badge>{{opportunita.kanbanTotale}}</span> <span class=vertical-align-bottom>{{opportunita.kanbanSomma | currency}}</span> </span><span class=\"badge badge-danger\" bs-tooltip data-title=\"Non Assegnati\" ng-if=\"opportunita.nonAssegnati > 0\n            && (opportunita.sok.idAgentePIC === \'NULL\'\n            || opportunita.sok.idAgentePIC === \'0\')\" ng-click=opportunita.toggleNonAssegnati()>{{opportunita.nonAssegnati}}</span></div></div><div class=\"col-xs-12 col-md-3 text-right\" ng-if=\"opportunita.activeTab === \'dashboard\'\"><i class=\"fa fa-fw fa-search\" bs-tooltip data-title=\"Ricerca testo in tutti i campi della dashboard\"></i> <input type=text ng-model=opportunita.kanbanFilter></div></div><!-- kanban --><div class=kanbanContainer ng-if=opportunita.user.flags.gestOppo ng-show=\"opportunita.activeTab === \'dashboard\'\"><h2>Opportunità</h2><div class=\"kanban row no-gutters\"><div ng-repeat=\"(idStage, stage) in opportunita.kanban\" class=\"col-xs-12 col-sm-6 col-md-2\" ng-style=\"{width:(100/opportunita.kanbanStages)+\'%\'}\"><div class=panel><div class=\"panel-heading text-center\" style=\"background-color: {{stage.bgColor}}\"><h3 class=panel-title><b>{{stage.label}}</b><br><span class=badge>{{stage.items.length}}</span> <span class=vertical-align-bottom>&nbsp;{{stage.sommaValore | currency}}</span></h3></div><div class=panel-body><ul class=list-group dnd-list dnd-drop=\"callback({targetList: stage.items, targetIndex: index, targetStage: idStage})\"><li ng-repeat=\"item in stage.items | filter:opportunita.kanbanFilter\" class=list-group-item dnd-draggable=null dnd-disable-if=\"!opportunita.checkEditPermission(opportunita.user, item)\" dnd-callback=\"opportunita.onDrop(stage.items, $index, idStage, targetList, targetIndex, targetStage)\" dnd-effect-allowed=move><a class=cliente href=\"\" ng-click=opportunita.readOpportunita(item.id) bs-tooltip data-title=\"Apri opportunità\">{{item.cliente}}</a> <span ng-if=\"!opportunita.sok.fornitore || !opportunita.sok.idStato\"><span ng-if=!opportunita.sok.fornitore>{{item.fornitore}}&nbsp;</span> <span ng-if=!opportunita.sok.idStato>{{item.stato}}&nbsp;</span><br></span>{{item.pista}} - {{item.valore | currency}} - {{(item.percChiusura * 100) | number:0}}%<br>{{item.dataSegnalazione | date:\'shortDate\'}}<span ng-if=item.idAgentePIC>&nbsp;&nbsp;<i class=\"fa fa-handshake-o\" bs-tooltip data-title=Agente></i> {{item.agentePIC}}</span><div ng-if=item.progettista><i class=\"fa fa-graduation-cap\" bs-tooltip data-title=Progettista></i> {{item.progettista}}</div><a href=\"\" ng-class=\"opportunita.user.flags.gestProg && item.idProgetto ? \'\' : \'cursor-default\'\" ng-click=opportunita.readProgetto(item.idProgetto)><i ng-if=\"item.dataOraInvioRichiestaProgettazione != \'\' && item.faseProgetto == \'\'\" class=\"fa fa-envelope-o faseProgetto\" bs-tooltip data-title=\"Richiesta progettazione inviata\"></i> <i ng-if=\"item.dataOraInvioRichiestaProgettazione != \'\' && item.faseProgetto != \'\' && ! item.progettoCompletato\" class=\"fa fa-envelope-open-o faseProgetto\" bs-tooltip data-title=\"Richiesta progettazione in lavorazione - {{item.faseProgetto}}\"></i> <i ng-if=\"item.dataOraInvioRichiestaProgettazione != \'\' && item.faseProgetto != \'\' && item.progettoCompletato\" class=\"fa fa-check-circle text-success faseProgetto\" bs-tooltip data-title=\"Progettazione completata\"></i> <i ng-if=\"item.update !== null\" class=\"fa fa-fw fa-pencil updateAction\" data-title=Modifica bs-tooltip ng-click=item.update(item.id)></i></a></li></ul></div></div></div></div><!-- alerts kanban --><div class=row><div class=\"col-xs-12 padding-top\"><g1-alerts data-status={{opportunita.alertsK.status}} data-messages=opportunita.alertsK.messages></g1-alerts></div></div></div><!-- ricerca --><div class=padding-top ng-show=\"opportunita.activeTab === \'ricerca\'\"><form role=form name=search_opportunita class=form-horizontal ng-submit=opportunita.search()><div class=row><div class=col-lg-4><div class=form-group><label class=\"control-label col-sm-3\">Data</label><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=text class=form-control ng-model=opportunita.so.fromDataS name=fromDataS bs-datepicker data-placement=bottom-left data-max-date={{opportunita.so.toDataS}}></div><label class=\"control-label col-xs-2 col-sm-1 text-center\">A</label><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=text class=form-control ng-model=opportunita.so.toDataS name=toDataS bs-datepicker data-placement=bottom-right data-min-date={{opportunita.so.fromDataS}}></div></div><div class=form-group><label class=\"control-label col-sm-3\">Agente</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.agentiPIC | orderBy:\'gruppo\'\" ng-model=opportunita.so.idAgentePIC name=idAgentePIC></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Fornitore</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.fornitori | orderBy:\'label\'\" ng-model=opportunita.so.fornitore name=fornitore><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Pista</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.piste\n                  | filter:{fornitore: opportunita.so.fornitore}:true\n                  | orderBy:\'label\'\" ng-model=opportunita.so.pista name=pista><option value=\"\">TUTTE</option></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Segnalatore</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.agentiS\" ng-model=opportunita.so.idAgenteS name=idAgenteS ng-disabled=\"!opportunita.user.flags.gestOppo && opportunita.user.userGroup != 5\"></select></div></div></div><div class=col-lg-4><div class=form-group><label class=\"control-label col-sm-3\">Cliente</label><div class=col-sm-9><input type=text class=form-control ng-model=opportunita.so.cliente name=cliente></div></div><div class=form-group><label class=\"control-label col-sm-3\">Fonte</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.fonti\" ng-model=opportunita.so.idFonte name=idFonte></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Referente</label><div class=col-sm-9><input type=text class=form-control ng-model=opportunita.so.referente name=referente></div></div><div class=form-group><label class=\"control-label col-sm-3\">Contatto</label><div class=col-sm-9><input type=text class=form-control ng-model=opportunita.so.contatto name=contatto></div></div><div class=form-group><label class=\"control-label col-sm-3\" bs-tooltip data-title=\"Passaggio successivo\">Pass. Succ.</label><div class=col-sm-9><input type=text class=form-control ng-model=opportunita.so.passSucc name=passSucc></div></div></div><div class=col-lg-4><div class=form-group><label class=\"control-label col-sm-3\">Valore</label><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=number class=form-control ng-model=opportunita.so.fromValore name=fromValore decimal precision=0 step=1 min=-1></div><label class=\"control-label col-xs-2 col-sm-1 text-center\">A</label><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=number class=form-control ng-model=opportunita.so.toValore name=toValore decimal precision=0 step=1 min=-1></div></div><div class=form-group><label class=\"control-label col-sm-3\">Probabilità</label><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=number class=form-control ng-model=opportunita.so.fromPerc name=fromPerc percent precision=0 step=1 min=-1 max=100></div><label class=\"control-label col-xs-2 col-sm-1 text-center\">A</label><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=number class=form-control ng-model=opportunita.so.toPerc name=toPerc percent precision=0 step=1 min=-1 max=100></div></div><div class=form-group><label class=\"control-label col-sm-3\">Stato</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.stati\" ng-model=opportunita.so.idStato name=idStato><option value=\"\">TUTTI</option></select></div></div><div class=form-group><label class=\"control-label col-sm-3\">Fase</label><div class=col-sm-9><select class=form-control ng-options=\"el.value as el.label for el in opportunita.formData.stages\n                    | filter:{idPipeline: \'1\'}:true\n                    | orderBy:\'ordinamento\'\" ng-model=opportunita.so.idStage name=idStage><option value=\"\">TUTTE</option></select></div></div><div class=form-group><label class=\"control-label col-sm-3\" bs-tooltip data-title=\"Data prevista chiusura\">Prev.&nbsp;Chiusura</label><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=text class=form-control ng-model=opportunita.so.fromDataC name=fromDataC bs-datepicker data-placement=bottom-left data-max-date={{opportunita.so.toDataC}}></div><label class=\"control-label col-xs-2 col-sm-1 text-center\">A</label><div class=\"col-xs-5 col-sm-4 validate-group\"><input type=text class=form-control ng-model=opportunita.so.toDataC name=toDataC bs-datepicker data-placement=bottom-right data-min-date={{opportunita.so.fromDataC}}></div></div></div></div><div class=row><div class=\"col-xs-12 text-right\"><span class=margin-right></span> <button type=reset class=\"btn btn-warning\" bs-tooltip data-title=Resetta ng-click=opportunita.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span class=margin-right></span> <button type=submit class=\"btn btn-info\" bs-tooltip data-title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><!-- alerts ricerca --><div class=row><div class=\"col-xs-12 padding-top\"><g1-alerts data-status={{opportunita.alerts.status}} data-messages=opportunita.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=opportunita.dt.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=opportunita.dt.options dt-columns=opportunita.dt.columns dt-instance=opportunita.dt.instance class=\"table table-hover\"></table></div></div></div></div><br></div><script type=text/ng-template id=dashboard-opportunita-aside.tpl.html><div class=\"aside\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"aside-dialog\">\n      <div class=\"aside-content\">\n        <form name=\"search_opportunita_kanban\" class=\"form-horizontal\" ng-submit=\"opportunita.searchKanban()\" novalidate>\n          <div class=\"aside-header\">\n            <button type=\"button\" class=\"close\" ng-click=\"$hide()\">&times;</button>\n            <h4 class=\"aside-title\">Filtri</h4>\n          </div>\n\n          <div class=\"aside-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-3\">Data</label>\n\n              <div class=\"col-xs-12 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"DA\"\n                  ng-model=\"opportunita.sok.fromDataS\" name=\"fromDataS\"\n                  bs-datepicker data-placement=\"bottom-left\"\n                  data-max-date=\"{{opportunita.sok.toDataS}}\">\n              </div>\n\n              <div class=\"clearfix visible-xs-block margin-bottom\"></div>\n\n              <div class=\"col-xs-12 col-sm-offset-1 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"A\"\n                  ng-model=\"opportunita.sok.toDataS\" name=\"toDataS\"\n                  bs-datepicker data-placement=\"bottom-right\"\n                  data-min-date=\"{{opportunita.sok.fromDataS}}\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-xs-12 col-sm-3\">Chiusura</label>\n\n              <div class=\"col-xs-12 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"DA\"\n                  ng-model=\"opportunita.sok.fromDataC\" name=\"fromDataC\"\n                  bs-datepicker data-placement=\"bottom-left\"\n                  data-max-date=\"{{opportunita.sok.toDataC}}\">\n              </div>\n\n              <div class=\"clearfix visible-xs-block margin-bottom\"></div>\n\n              <div class=\"col-xs-12 col-sm-offset-1 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"A\"\n                  ng-model=\"opportunita.sok.toDataC\" name=\"toDataC\"\n                  bs-datepicker data-placement=\"bottom-right\"\n                  data-min-date=\"{{opportunita.sok.fromDataC}}\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3\">Agente</label>\n              <div class=\"col-sm-9\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opportunita.formData.agentiPIC | orderBy:\'gruppo\'\"\n                  ng-model=\"opportunita.sok.idAgentePIC\" name=\"idAgentePIC\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3\">Fornitore</label>\n              <div class=\"col-sm-9\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opportunita.formData.fornitori | orderBy:\'label\'\"\n                  ng-model=\"opportunita.sok.fornitore\" name=\"fornitore\">\n                  <option value=\"\">TUTTI</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3\">Pista</label>\n              <div class=\"col-sm-9\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opportunita.formData.piste\n                    | filter:{fornitore: opportunita.sok.fornitore}:true\n                    | orderBy:\'label\'\"\n                  ng-model=\"opportunita.sok.pista\" name=\"pista\">\n                  <option value=\"\">TUTTE</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3\">Stato</label>\n              <div class=\"col-sm-9\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opportunita.formData.stati\"\n                  ng-model=\"opportunita.sok.idStato\" name=\"idStato\">\n                  <option value=\"\">TUTTI</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-3\">Probabilità&nbsp;>=</label>\n              <div class=\"clearfix visible-xs-block\"></div>\n\n              <div class=\"col-xs-12 col-sm-4 validate-group\">\n                <input type=\"number\" class=\"form-control\"\n                  ng-model=\"opportunita.sok.fromPerc\" name=\"fromPerc\"\n                  percent precision=\"0\" step=\"1\" min=\"-1\" max=\"100\">\n              </div>\n            </div>\n          </div>\n\n          <div class=\"aside-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Filtra</button>\n            <button type=\"button\" class=\"btn btn-warning\" ng-click=\"opportunita.resetKanban()\">Resetta</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/prodotti/prodotti-search.tpl.html","<div><div class=form-horizontal><div class=row><div class=\"col-xs-12 col-sm-6 col-lg-2\"><div class=form-group><label class=\"control-label col-xs-3\">Fornitore:</label><div class=col-xs-9><select class=form-control ng-options=\"el.value as el.label for el in formData.fornitori\" ng-change=\"sp.pista = \'0\'\" ng-model=sp.fornitore name=fornitore></select></div></div></div><div class=\"col-xs-12 col-sm-6 col-lg-2\"><div class=form-group><label class=\"control-label col-xs-3\">Pista:</label><div class=col-xs-9><select class=form-control ng-options=\"el.value as el.label for el in formData.piste | filter:{fornitore: sp.fornitore}:true\" ng-model=sp.pista name=pista></select></div></div></div><div class=\"col-xs-12 col-sm-5 col-lg-2\"><div class=form-group><label class=\"control-label col-xs-3\">Prodotto:</label><div class=col-xs-9><input type=text class=form-control ng-model=sp.descrizione name=descrizione ng-keydown=\"$event.which === 13 && search()\"></div></div></div><div class=\"col-xs-12 col-sm-5 col-lg-2\"><div class=form-group><label class=\"control-label col-xs-3\">Con Scadenza:</label><div class=col-xs-9><select class=form-control ng-model=sp.conScadenza name=conScadenza><option value=\"\">Tutti</option><option value=1>CON scadenza</option><option value=0>SENZA scadenza</option></select></div></div></div><div class=\"col-xs-12 col-sm-2 col-lg-4 text-right\"><button type=button class=\"btn btn-warning\" ng-click=resetForm()><i class=\"fa fa-undo\"></i></button> <button type=button class=\"btn btn-info\" ng-click=search()><i class=\"fa fa-search\"></i></button></div></div></div><div class=row><div class=col-xs-12 ng-if=dtProdotti.show><table datatable dt-options=::dtProdotti.dtOptions dt-columns=::dtProdotti.dtColumns dt-instance=dtProdotti.dtInstance class=\"table table-bordered table-hover table-condensed\"></table></div></div></div>");
$templateCache.put("app/core/prodotti/prodotti.html","<script type=text/ng-template id=prodotti-modal.tpl.html ng-controller=\"ProdottiController as pc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Ricerca Prodotto\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <form name=\"prodottiSearchForm\" class=\"form-horizontal\" ng-submit=\"pc.search()\" novalidate>\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3\">\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-3\">Fornitore:</label>\n                  <div class=\"col-xs-9\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in pc.formData.fornitori\"\n                            ng-change=\"pc.sp.pista = \'0\'\"\n                            ng-model=\"pc.sp.fornitore\" name=\"fornitore\">\n                    </select>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-3\">\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-3\">Pista:</label>\n                  <div class=\"col-xs-9\">\n                    <select class=\"form-control\"\n                            ng-options=\"el.value as el.label for el in pc.formData.piste | filter:{fornitore: pc.sp.fornitore}:true\"\n                            ng-model=\"pc.sp.pista\" name=\"pista\">\n                    </select>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-4\">\n                <div class=\"form-group\">\n                  <label class=\"control-label col-xs-3\">Prodotto:</label>\n                  <div class=\"col-xs-9\">\n                    <input type=\"text\" class=\"form-control\"\n                           ng-model=\"pc.sp.descrizione\" name=\"descrizione\">\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2 text-right\">\n                <button type=\"button\" class=\"btn btn-warning\" ng-click=\"pc.resetForm()\"><i class=\"fa fa-undo\"></i></button>\n                <button type=\"submit\" class=\"btn btn-info\"><i class=\"fa fa-search\"></i></button>\n              </div>\n            </div>\n          </form>\n\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::pc.dtProdotti.dtOptions\"\n                     dt-columns=\"::pc.dtProdotti.dtColumns\"\n                     dt-instance=\"pc.dtProdotti.dtInstance\"\n                     class=\"table table-bordered table-hover table-condensed\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\">Annulla</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/provvigioni/provvigione-calcolata.html","<script type=text/ng-template id=provvigione-calcolata-modal.tpl.html ng-controller=\"ProvvigioneCalcolataController as pCalcolata\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{pCalcolata.provCalc.id || \'0\'}} - {{pCalcolata.provCalc.codiceProdotto}} - {{pCalcolata.provCalc.codiceSoggetto}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>{{pCalcolata.provCalc.tipoSoggetto}}:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              {{pCalcolata.provCalc.soggetto}}\n              <small class=\"text-muted\">{{pCalcolata.provCalc.codiceSoggetto}}</small>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Prodotto:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              {{pCalcolata.provCalc.codiceProdotto}}\n              <small class=\"text-muted\">{{pCalcolata.provCalc.prodotto}}</small>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 text-right\"><label>Data:</label></div>\n            <div class=\"col-xs-10 text-left\">{{pCalcolata.provCalc.dataConferma | date:\'shortDate\'}}</div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/provvigioni/provvigioni-calcola.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=page-header><h2><a href=#/provvigioni title=\"Torna a gestione provvigioni\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> Calcola Provvigioni</h2></div><form name=pCalcola.sf class=\"form-horizontal dataForm\" ng-submit=pCalcola.calcola() novalidate><div class=row><div class=col-md-6><div class=form-group><label class=\"control-label col-md-2\">Data</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCalcola.form.conferma_from name=conferma_from bs-datepicker></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCalcola.form.conferma_to name=conferma_to bs-datepicker data-placement=bottom-right></div></div><div class=form-group><label class=\"control-label col-md-2\">Soggetti</label><div class=\"col-xs-6 col-md-5 checkbox\"><label><input type=checkbox ng-model=\"pCalcola.form.checksSoggetto[\'Agente\']\">&nbsp;Agente</label></div><div class=\"col-xs-6 col-md-5 checkbox\"><label><input type=checkbox ng-model=\"pCalcola.form.checksSoggetto[\'Segnalatore\']\">&nbsp;Segnalatore</label></div></div><div class=form-group><div class=\"col-md-offset-2 col-md-5 checkbox\"><label><input type=checkbox ng-model=pCalcola.form.provvigioniUnaTantum name=provvigioniUnaTantum> <b>&nbsp;Provvigioni Una Tantum</b></label></div><div class=\"col-md-5 checkbox\"><label><input type=checkbox ng-model=pCalcola.form.provvigioniRicorrenti name=provvigioniRicorrenti> <b>&nbsp;Provvigioni Ricorrenti</b></label></div></div><div class=form-group><div class=\"col-md-offset-2 col-md-10 checkbox\"><label><input type=checkbox ng-model=pCalcola.form.positive name=positive ng-change=\"pCalcola.form.idStato = undefined;\"> <b>&nbsp;Solo righe positive</b></label></div></div><div class=form-group ng-if=!pCalcola.form.positive><label class=\"control-label col-md-2\">Stati</label><div class=col-md-10><button type=button class=\"btn btn-default\" ng-model=pCalcola.form.idStato bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=\"form[name=\'pCalcola.sf\']\" bs-options=\"el.value as el.label for el in pCalcola.formData.stati\" required>Action <span class=caret></span></button></div></div><div class=form-group><div class=\"col-xs-12 text-right\"><button type=submit class=\"btn btn-success\"><i class=\"fa fa-fw fa-cog\"></i>&nbsp;Calcola</button></div></div></div></div></form><!-- display infos --><div class=row ng-if=\"pCalcola.messages.info.length > 0\"><div class=col-xs-12><g1-alerts data-status=200 data-messages=pCalcola.messages.info></g1-alerts></div></div><!-- display warnings --><div class=row ng-if=\"pCalcola.messages.warnings.length > 0\"><div class=col-xs-12><g1-alerts data-status=417 data-messages=pCalcola.messages.warnings></g1-alerts></div></div><!-- display errors --><div class=row ng-if=\"pCalcola.messages.errors.length > 0\"><div class=col-xs-12><g1-alerts data-status=409 data-messages=pCalcola.messages.errors></g1-alerts></div></div><!-- tabella provvigioni in conflitto --><div class=row ng-repeat=\"(title, dt) in pCalcola.conflitti\"><div class=\"col-xs-12 table-responsive\" ng-if=\"dt.data.length > 0\"><h4>{{title}}</h4><table datatable dt-options=::dt.options dt-columns=::dt.columns dt-instance=dt.instance class=\"table table-hover table-condensed\"></table></div></div><!-- tabella schede duplicate --><div class=row ng-repeat=\"(title, dt) in pCalcola.duplicati\"><div class=\"col-xs-12 table-responsive\" ng-if=\"dt.data.length > 0\"><h4>{{title}}</h4><table datatable dt-options=::dt.options dt-columns=::dt.columns dt-instance=dt.instance class=\"table table-hover table-condensed\"></table></div></div></div>");
$templateCache.put("app/core/provvigioni/provvigioni-calcolate.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div ng-include=\"\'app/core/provvigioni/provvigione-calcolata.html\'\"></div><div class=container-fluid><div class=page-header><h2><a href=#/provvigioni title=\"Torna a gestione provvigioni\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> Archivio Provvigioni Calcolate</h2></div><form name=pCalcolate.sf class=form-horizontal ng-submit=pCalcolate.search() novalidate><div class=row><div class=col-md-6><div class=form-group style=\"margin-bottom: 0\"><label class=\"control-label col-md-2\">Soggetto</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><select class=form-control ng-options=\"el.value as el.label for el in pCalcolate.searchData.tipiSoggetto\" ng-change=\"pCalcolate.searchForm.soggetto = \'0\'\" ng-model=pCalcolate.searchForm.tipoSoggetto name=tipoSoggetto></select><span class=help-block>Tipo</span></div><div class=\"col-xs-6 col-md-5\"><select class=form-control ng-options=\"el.value as el.label for el in pCalcolate.filtraSoggetti(pCalcolate.searchData.soggetti)\" ng-model=pCalcolate.searchForm.soggetto name=soggetto></select><span class=help-block>{{pCalcolate.searchForm.tipoSoggetto === \'0\' ? \'Soggetto\' : pCalcolate.searchForm.tipoSoggetto}}</span></div></div><div class=form-group style=\"margin-bottom: 0\"><label class=\"control-label col-md-2\">Data</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCalcolate.searchForm.conferma_from name=conferma_from bs-datepicker data-max-date={{pCalcolate.searchForm.conferma_to}}> <span class=help-block>Da</span></div><div class=\"col-xs-6 col-md-5\"><input type=text placeholder=gg/mm/aaaa class=form-control ng-model=pCalcolate.searchForm.conferma_to name=conferma_to bs-datepicker data-min-date={{pCalcolate.searchForm.conferma_from}}> <span class=help-block>A</span></div></div><div class=form-group style=\"margin-bottom: 0\"><label class=\"control-label col-md-2\">Valore</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><input type=number step=1 min=-1 class=form-control ng-model=pCalcolate.searchForm.prov_from name=prov_from> <span class=help-block>Da</span></div><div class=\"col-xs-6 col-md-5\"><input type=number step=1 min=-1 class=form-control ng-model=pCalcolate.searchForm.prov_to name=prov_to> <span class=help-block>A</span></div></div><div class=form-group style=\"margin-bottom: 0\"><label class=\"control-label col-md-2\">Provv. Ric.</label><div class=\"clearfix visible-xs-block visible-sm-block\"></div><div class=\"col-xs-6 col-md-5\"><select class=form-control ng-model=pCalcolate.searchForm.ricorrente name=ricorrente><option value=\"\">Tutti</option><option value=1>Ricorrente</option><option value=0>NON ricorrente</option></select></div></div></div><div class=col-md-6><div class=form-group><label class=\"control-label col-md-2\">Fornitore</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in pCalcolate.searchData.fornitori | filter:{disabilitato: pCalcolate.searchData.dFornitori} | orderBy:\'label\'\" ng-model=pCalcolate.searchForm.fornitore name=fornitore></select></div><div class=\"checkbox col-md-5\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=pCalcolate.searchData.dFornitori name=dFornitori ng-change=\"pCalcolate.searchForm.fornitore = \'0\'\"> <b>&nbsp;Disabilitati</b></label></div></div><div class=form-group><label class=\"control-label col-md-2\">Pista</label><div class=col-md-5><select class=form-control ng-options=\"el.value as el.label for el in pCalcolate.searchData.piste | filter:{disabilitato: pCalcolate.searchData.dPiste} | orderBy:\'label\'\" ng-model=pCalcolate.searchForm.pista name=pista></select></div><div class=\"checkbox col-md-5\"><label><input type=checkbox ng-true-value=\"\'\'\" ng-false-value=\"\'0\'\" ng-model=pCalcolate.searchData.dPiste name=dPiste ng-change=\"pCalcolate.searchForm.pista = \'0\'\"> <b>&nbsp;Disabilitati</b></label></div></div><div class=form-group><label class=\"control-label col-md-2\">Prodotto</label><div class=col-md-5><input type=text class=form-control ng-model=pCalcolate.searchForm.prodotto name=prodotto></div></div><div class=form-group><label class=\"control-label col-md-2\">Cliente</label><div class=col-md-5><input type=text class=form-control ng-model=pCalcolate.searchForm.cliente></div></div><div class=form-group><label class=\"control-label col-md-2\" title=\"Generate da Sviluppo Vendite\">Gen.&nbsp;SV</label><div class=col-md-5><select class=form-control ng-model=pCalcolate.searchForm.agenteNullo name=agenteNullo><option value=\"\">TUTTI</option><option value=1>NON generate da SV</option><option value=0>generate da SV</option></select></div></div></div></div><div class=form-group><div class=\"col-xs-12 text-right\"><button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=row ng-if=pCalcolate.searched><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::pCalcolate.dt.options dt-columns=::pCalcolate.dt.columns dt-instance=pCalcolate.dt.instance class=\"table table-hover table-condensed\"></table></div></div></div>");
$templateCache.put("app/core/provvigioni/provvigioni.html","<div class=container-fluid ng-if=\"[7,8].indexOf(provvigioni.user.userGroup) > -1\"><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title><strong>Gestione</strong></h3></div><div class=list-group><a class=list-group-item ng-if=\"provvigioni.user.userGroup == 8\" ng-href=#/admin/provvigioni/schede><b>Schede Provvigioni</b> </a><a class=list-group-item ng-if=\"provvigioni.user.userGroup == 8\" ng-href=#/admin/provvigioni/copia><b>Copia Schede Provvigioni</b> </a><a class=list-group-item ng-href=#/provvigioni/calcolate><b>Archivio Provvigioni Calcolate</b> </a><a class=list-group-item ng-href=#/provvigioni/calcola><b>Calcola Provvigioni</b></a></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title><strong>Report</strong></h3></div><div class=list-group><a class=list-group-item ng-href=#/reports/prpf><b>Generale provvigioni per fornitore</b> </a><!--\n          <a class=\"list-group-item\" ng-if=\"provvigioni.user.userGroup == 8\"\n             ng-href=\"#/reports/prsf\">\n            <b>Provvigioni soggetto per fornitore</b>\n          </a>\n          --> <a class=list-group-item ng-href=#/reports/pstm><b>Provvigioni soggetto totale mese</b> </a><!--\n          <a class=\"list-group-item\" ng-if=\"provvigioni.user.userGroup == 8\"\n             ng-href=\"#/reports/psfm\">\n            <b>Provvigioni soggetto fornitore mese</b>\n          </a>\n          --></div></div></div></div></div>");
$templateCache.put("app/core/pv/invia-notifica.html","<script type=text/ng-template id=invia-notifica-pv.tpl.html ng-controller=\"InviaNotificaPvController as inpc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"invia-notifica-pv\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"InviaNotificaPvForm\" class=\"form-horizontal dataForm\" ng-submit=\"inpc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <div class=\"modal-title\">\n              <div class=\"pull-left\">\n                <h4>\n                  <span class=\"margin-right\">\n                    <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                  </span>\n                   Invio notifica di {{inpc.action}} ticket al cliente\n                </h4>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"input-group margin-top validate-group\">\n              <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Destinatario (email)\"><i class=\"fa fa-envelope\"></i></span>\n              <input type=\"text\" class=\"form-control\" ng-model=\"inpc.to\" name=\"to\" required>\n            </div>\n            <div class=\"input-group margin-top validate-group\">\n              <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Oggetto\">Oggetto</span>\n              <input type=\"text\" class=\"form-control\" ng-model=\"inpc.subject\" name=\"subject\" required>\n            </div>\n            <div class=\"margin-top validate-group\">\n              <strong>Descrizione</strong><br />\n              <textarea rows=\"10\" class=\"form-control\" ng-model=\"inpc.content\" name=\"content\" required>\n              </textarea>\n            </div>\n          </div>\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-share\"></i> Invia</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/pv-edit.html","<script type=text/ng-template id=pv-edit-modal.tpl.html ng-controller=\"PvEditController as pec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"pv-edit-modal\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"PvEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"pec.saveForm()\" novalidate>\n          <div class=\"modal-header\" ng-class=\"\'priorita-\'+pec.pv.idPriorita\">\n            <div class=\"modal-title\">\n              <div class=\"row\">\n                <div class=\"col-sm-3 headerSidebar\">\n                  <div class=\"row\">\n                    <div class=\"col-md-6\">\n                      <h4>\n                        <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                        <span class=\"validate-group\"><input type=\"hidden\" name=\"realizzativo\" ng-model=\"pec.pv.realizzativo\"></span>\n                        {{pec.action === \'create\' ? ( pec.pv.realizzativo ? \"Nuova realizzazione\" : \"Nuovo Pv\" ) : pec.pv.codice}}\n                      </h4>\n                    </div>\n                    <div class=\"col-md-6\">\n                      <h4 class=\"text-align-right\">\n                        <i ng-if=\"!pec.pv.realizzativo && !pec.pv.inAssistenza\" class=\"fa fa-euro margin-right\" bs-tooltip data-container=\"body\" data-title=\"A pagamento\"></i>\n                        <i ng-if=\"!pec.pv.realizzativo && pec.pv.inAssistenza\" class=\"fa fa-life-ring margin-right\" bs-tooltip data-container=\"body\" data-title=\"In assistenza\"></i>\n                        <i ng-if=\"pec.pv.scaduto\" class=\"fa fa-clock-o margin-left\" bs-tooltip data-container=\"body\" data-title=\"Ticket scaduto\"></i>\n                        <i class=\"fa fa-exclamation-triangle\" ng-if=\"pec.pv.bloccato\" bs-tooltip data-container=\"body\" data-title=\"Cliente bloccato\"></i>\n                        <span ng-show=\"pec.pv.idStato != undefined\">\n                          <i class=\"fa margin-left margin-right fa-unlock\" ng-if=\"pec.pv.idStato==\'1\'\" bs-tooltip data-container=\"body\" data-title=\"Stato aperto\"></i>\n                          <i class=\"fa margin-left margin-right fa-pause-circle\" ng-if=\"pec.pv.idStato==\'2\'\" bs-tooltip data-container=\"body\" data-title=\"Stato sospeso\"></i>\n                          <i class=\"fa margin-left margin-right fa-lock\" ng-if=\"pec.pv.idStato==\'3\'\" bs-tooltip data-container=\"body\" data-title=\"Stato chiuso\"></i>\n                          <i class=\"fa margin-left margin-right fa-hourglass-start\" ng-if=\"pec.pv.idStato==\'4\'\" bs-tooltip data-container=\"body\" data-title=\"Stato in preparazione\"></i>\n                        </span>\n                      </h4>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <h4>\n                    {{pec.pv.cliente}} <span class=\"normal\"><span ng-if=\"pec.pv.indirizzo\">- {{pec.pv.indirizzo}}</span> <span ng-if=\"pec.pv.citta\">- {{pec.pv.citta}}</span> <span ng-if=\"pec.pv.prov\">({{pec.pv.prov}})</span></span>\n                  </h4>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-sm-3 sidebar border-right\">\n                <h5 class=\"section-title\" ng-if=\"pec.pv.realizzativo\">Sede realizzazione</h5>\n                <h5 class=\"section-title\" ng-if=\"!pec.pv.realizzativo\">Dati cliente</h5>\n                <div class=\"section-content\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Indirizzo\">Ind.</span>\n                        <input\n                          type=\"text\"\n                          class=\"form-control\"\n                          ng-model=\"pec.pv.indirizzo\"\n                          name=\"indirizzo\"\n                          bs-typeahead data-min-length=\"0\" data-limit=\"1000\" data-auto-select=\"true\"\n                          bs-on-select=\"pec.setSedeCliente\"\n                          bs-options=\"el.idSede as ( el.nome ? el.nome : ( el.indirizzo ? ( el.indirizzo + ( el.numeroCivico ? ( \' \' + el.numeroCivico ) : \'\' ) + \' - \' + el.citta + \' (\' + el.prov + \')\' ) : \'\' ) ) for el in pec.formData.sediCliente\"\n                          data-placement=\"bottom-left\"\n                          required>\n                      </div>\n                    </div>\n                    <div class=\"col-md-6 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Città\">Città</span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.citta\" name=\"citta\">\n                      </div>\n                    </div>\n                    <div class=\"col-md-6 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Provincia\">Prov.</span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.prov\" name=\"prov\">\n                      </div>\n                    </div>\n                    <div class=\"col-md-6 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-text\" bs-tooltip data-title=\"Telefono\"><i class=\"fa fa-phone\"></i></span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.telSede\" name=\"telSede\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"section-title\">\n                  <div class=\"row\">\n                    <div class=\"col-md-6\">\n                      <h5 class=\"no-margin-top no-margin-bottom\">Dati referente</h5>\n                    </div>\n                    <div class=\"col-md-6 inserisciNuovoContatto validate-group\">\n                      <label>\n                        <input type=\"checkbox\" name=\"salvaReferente\" ng-model=\"pec.pv.salvaReferente\">\n                        Inserisci NUOVO contatto\n                      </label>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"section-content\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-12 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Nominativo\"><i class=\"fa fa-user\"></i></span>\n                        <input\n                          type=\"text\"\n                          class=\"form-control\"\n                          ng-model=\"pec.pv.nomeReferente\"\n                          name=\"nomeReferente\"\n                          bs-typeahead data-min-length=\"0\" data-limit=\"1000\" data-auto-select=\"true\"\n                          bs-on-select=\"pec.setReferente\"\n                          bs-options=\"el.idReferente as el.nominativo for el in pec.formData.referenti\"\n                          data-placement=\"bottom-left\"\n                          required>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-12 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Email\"><i class=\"fa fa-envelope\"></i></span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.emailReferente\" name=\"emailReferente\">\n                      </div>\n                    </div>\n                    <div class=\"col-xs-12 col-md-6 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Telefono\"><i class=\"fa fa-phone\"></i></span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.telReferente\" name=\"telReferente\">\n                      </div>\n                    </div>\n                    <div class=\"col-xs-12 col-md-6 margin-top validate-group\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Cellulare\"><i class=\"fa fa-mobile\"></i></span>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"pec.pv.cellReferente\" name=\"cellReferente\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\">Data apertura</h5>\n                <div class=\"section-content\">\n                  <div class=\"row\">\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>Data</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data apertura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date inline-block\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"pec.pv.dataApertura\" name=\"dataApertura\" required\n                          bs-datepicker>\n                      </div>\n                    </div>\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>Ora</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora apertura\"><i class=\"fa fa-clock-o\"></i></span>\n                        <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraApertura\"\n                          ng-model=\"pec.pv.dataApertura\" ng-model-options=\"{allowInvalid: true}\"\n                          bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\" ng-if=\"pec.pv.realizzativo\">Data installazione</h5>\n                <div class=\"section-content\" ng-if=\"pec.pv.realizzativo\">\n                  <div class=\"row\">\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>Da</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data inizio installazione\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"pec.pv.dataInizioInstallazione\" name=\"dataInizioInstallazione\"\n                          bs-datepicker\n                          ng-change=\"pec.dataInizioInstallazioneChange()\"\n                          greater-than-or-equal-to=\"pec.pv.dataApertura\" gt-field-name=\"dataInizioInstallazione\" gt-field-type=\"date\">\n                      </div>\n                      <div ng-messages=\"PvEditForm.dataInizioInstallazione.$error\">\n                        <div ng-message=\"greaterThanOrEqualTo\" class=\"help-block has-error error-msg\">La data di inizio installazione non può essere precedente a quella di apertura</div>\n                      </div>\n                    </div>\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>A</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data fine installazione\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"pec.pv.dataFineInstallazione\" name=\"dataFineInstallazione\"\n                          bs-datepicker\n                          greater-than-or-equal-to=\"pec.pv.dataInizioInstallazione\" gt-field-name=\"dataFineInstallazione\" gt-field-type=\"date\">\n                      </div>\n                      <div ng-messages=\"PvEditForm.dataFineInstallazione.$error\">\n                        <div ng-message=\"greaterThanOrEqualTo\" class=\"help-block has-error error-msg\">La data di fine installazione non può essere precedente alla data di inizio</div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\" ng-if=\"!pec.pv.realizzativo\">Data prevista chiusura</h5>\n                <div class=\"section-content\" ng-if=\"!pec.pv.realizzativo\">\n                  <div class=\"row\">\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>Data</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data chiusura\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"pec.pv.dataPrevChiusura\" name=\"dataPrevChiusura\" required\n                          bs-datepicker\n                          greater-than=\"pec.pv.dataApertura\" gt-compared-field-label=\"Apertura\" gt-field-type=\"datetime\">\n                      </div>\n                      <div ng-messages=\"PvEditForm.dataPrevChiusura.$error\">\n                        <div ng-message=\"greaterThan\" class=\"help-block has-error error-msg\">La data di chiusura non può essere precedente a quella di apertura</div>\n                      </div>\n                    </div>\n                    <div class=\"validate-group col-xs-6\">\n                      <strong>Ora</strong><br />\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora chiusura\"><i class=\"fa fa-clock-o\"></i></span>\n                        <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraPrevChiusura\"\n                          ng-model=\"pec.pv.dataPrevChiusura\" ng-model-options=\"{allowInvalid: true}\"\n                          bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\" ng-if=\"pec.pv.realizzativo\">Note</h5>\n                <div class=\"section-content\" ng-if=\"pec.pv.realizzativo\">\n                  <div class=\"validate-group\" ng-if=\"pec.pv.realizzativo\">\n                    <textarea rows=\"6\" class=\"form-control\" ng-model=\"pec.pv.noteTicket\" name=\"noteTicket\">\n                    </textarea>\n                  </div>\n                </div>\n                <h5 class=\"section-title\">Ordine in elenco</h5>\n                <div class=\"section-content\">\n                  <div class=\"margin-top validate-group\">\n                    <input type=\"number\" class=\"form-control input-order\" ng-model=\"pec.pv.ordine\" step=\"1\" min=\"0\" max=\"100\" name=\"ordine\">\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-9 content-right\">\n                <h5 class=\"section-title\">&nbsp;</h5>\n                <div class=\"section-content\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-2 validate-group\" ng-if=\"!pec.pv.realizzativo\">\n                      <label class=\"control-label\">\n                        <input type=\"checkbox\" ng-model=\"pec.pv.bloccato\" name=\"bloccato\"> Cliente bloccato\n                      </label>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-2 validate-group\" ng-if=\"!pec.pv.realizzativo\">\n                      <label class=\"control-label\">\n                        <input type=\"checkbox\" ng-model=\"pec.pv.inAssistenza\" name=\"inAssistenza\"> Intervento in assistenza\n                      </label>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-2 validate-group\" ng-if=\"pec.pv.realizzativo || !pec.pv.inAssistenza\">\n                      <label class=\"control-label\">\n                        <input type=\"checkbox\" ng-model=\"pec.pv.fatturato\" name=\"fatturato\"> Fatturato\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"row\" ng-if=\"pec.pv.realizzativo\">\n                    <div class=\"col-xs-12 col-sm-6\">\n                      <div class=\"margin-top validate-group\">\n                        <strong>Prodotto</strong><br />\n                        <button type=\"button\" class=\"btn btn-default\"\n                          ng-model=\"pec.pv.idContratti\"\n                          bs-select data-multiple=\"1\" data-max-length=\"1\" data-all-none-buttons=\"1\"\n                          data-container=\"form[name=\'PvEditForm\']\"\n                          bs-options=\"el.value as el.label for el in pec.formData.contratti | orderBy:\'label\'\">\n                          Action <span class=\"caret\"></span>\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-6 col-md-3 margin-top validate-group\">\n                      <strong>Categoria</strong><br />\n                      <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in pec.formData.categorie\n                          | filter:{realizzativo:pec.pv.realizzativo}:true\n                          | orderBy:\'label\'\"\n                        ng-model=\"pec.pv.idCategoria\" name=\"idCategoria\" required>\n                      </select>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-6 col-md-3 margin-top validate-group\" ng-if=\"!pec.pv.realizzativo\">\n                      <strong>Urgenza</strong><br />\n                      <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in pec.formData.priorita\n                          | orderBy:\'ordinamento\'\"\n                        ng-change=\"pec.setDataPrevChiusura()\"\n                        ng-model=\"pec.pv.idPriorita\" name=\"idPriorita\" required>\n                      </select>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-6 col-md-3 margin-top validate-group\" ng-if=\"pec.pv.realizzativo\">\n                      <strong>Fase</strong><br />\n                      <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in pec.formData.stages\n                          | orderBy:\'ordinamento\'\"\n                        ng-model=\"pec.pv.idStage\" name=\"idStage\">\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-xs-12 col-sm-6 col-md-3 margin-top validate-group\">\n                      <strong>Assegnato a</strong><br />\n                      <select class=\"form-control\"\n                        ng-model=\"pec.pv.idSoggetto\" name=\"idSoggetto\">\n                        <option value=\"\"></option>\n                        <option ng-repeat=\"el in pec.formData.soggetti\" ng-value=\"{{el.idSoggetto}}\">\n                          {{el.cognome}} {{el.nome}}\n                        </option>\n                      </select>\n                    </div>\n                    <div class=\"col-xs-12 col-sm-6 col-md-3 margin-top validate-group\">\n                      <strong>Stato</strong><br />\n                      <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in pec.formData.stati\n                          | orderBy:\'label\'\"\n                        ng-model=\"pec.pv.idStato\" name=\"idStato\" required>\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-sm-3\">\n                      <div class=\"margin-top validate-group\">\n                        <strong>Fornitore</strong><br />\n                        <select class=\"form-control\"\n                          ng-options=\"el.value as el.label for el in pec.formData.fornitori\n                            | orderBy:\'label\'\"\n                          ng-model=\"pec.pv.fornitore\" name=\"fornitore\" required>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"row\" ng-if=\"!pec.pv.realizzativo\">\n                    <div class=\"col-sm-6\">\n                      <div class=\"margin-top validate-group\">\n                        <strong>Prodotto</strong><br />\n                        <select class=\"form-control\"\n                          ng-model=\"pec.pv.idContratti\" name=\"idContratti\">\n                          <option value=\"\"></option>\n                          <option ng-repeat=\"contratto in pec.formData.contratti\" ng-class=\"{\'text-danger\': contratto.scaduto, \'text-warning\': contratto.obsoleto}\" ng-value=\"{{contratto.value}}\">\n                            {{contratto.label}}\n                          </option>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"margin-top validate-group\" ng-if=\"pec.pv.realizzativo\">\n                    <strong>Titolo</strong><span ng-click=\"pec.copiaDaProdotti()\" class=\"btn-link\" ng-if=\"!pec.pv.descrizioneBreve\">(copia da prodotti)</span><br />\n                    <textarea rows=\"3\" class=\"form-control\" ng-model=\"pec.pv.descrizioneBreve\" name=\"descrizioneBreve\" required>\n                    </textarea>\n                  </div>\n                  <div class=\"margin-top validate-group\">\n                    <strong>Note cliente</strong><br />\n                    <textarea rows=\"6\" class=\"form-control\" ng-model=\"pec.pv.descrizioneTicket\" name=\"descrizioneTicket\" required>\n                    </textarea>\n                  </div>\n                  <div class=\"margin-top validate-group\" ng-if=\"pec.pv.realizzativo\">\n                    <strong>Note tecnico</strong> <span ng-click=\"pec.copiaDaDescrizione()\" class=\"btn-link\" ng-if=\"!pec.pv.descrizioneTecnico\">(copia da descrizione)</span><br />\n                    <textarea rows=\"6\" class=\"form-control\" ng-model=\"pec.pv.descrizioneTecnico\" name=\"descrizioneTecnico\">\n                    </textarea>\n                  </div>\n                  <div class=\"margin-top\">\n                    <g1-alerts data-status=\"{{pec.alerts.status}}\" data-messages=\"pec.alerts.messages\"></g1-alerts>\n                    <div id=\"alertNessunProdotto\" class=\"alert alert-warning\" style=\"display:none\">\n                      Nessun prodotto selezionato. Procedere ugualmente? <button type=\"button\" class=\"btn btn-success margin-left\" ng-click=\"pec.actualSaveForm()\"><i class=\"fa fa-save\"></i> Salva</button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"pec.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/pv-read.html","<div ng-include=\"\'app/core/pv/attivita/attivita-edit.html\'\"></div><div ng-include=\"\'app/core/pv/attivita/attivita-read.html\'\"></div><script type=text/ng-template id=pv-read-modal.tpl.html ng-controller=\"PvReadController as prc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header priorita-{{prc.pv.idPriorita}}\">\n          <div class=\"modal-title\">\n            <div class=\"row\">\n              <div class=\"col-sm-3 headerSidebar\">\n                <div class=\"row\">\n                  <div class=\"col-md-6\">\n                    <h4>\n                      <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                      {{prc.pv.codice}}\n                      <span class=\"small-icons\">\n                        <a href=\"\" copy-to-clipboard=\"{{prc.pv.codice}}\" bs-tooltip data-title=\"Copia codice\"><i class=\"fa fa-copy\"></i></a>\n                        <a href=\"\" copy-to-clipboard=\"{{prc.pv.url}}\" bs-tooltip data-title=\"Copia url\"><i class=\"fa fa-link\"></i></a>\n                      </span>\n                    </h4>\n                  </div>\n                  <div class=\"col-md-6\">\n                    <h4 class=\"text-align-right\">\n                      <i ng-if=\"!prc.pv.realizzativo && prc.pv.inAssistenza\" class=\"fa fa-life-ring\" bs-tooltip data-container=\"body\" data-title=\"In assistenza\"></i>\n                      <i ng-if=\"!prc.pv.realizzativo && !prc.pv.inAssistenza\" class=\"fa fa-euro margin-left\" bs-tooltip data-container=\"body\" data-title=\"A pagamento\"></i>\n                      <i ng-if=\"prc.pv.scaduto\" class=\"fa fa-clock-o margin-left\" bs-tooltip data-container=\"body\" data-title=\"Ticket scaduto\"></i>\n                      <i ng-if=\"prc.pv.bloccato\" class=\"fa fa-exclamation-triangle margin-left\" bs-tooltip data-container=\"body\" data-title=\"Cliente bloccato\"></i>\n                      <span ng-show=\"prc.pv.idStato != undefined\">\n                        <i ng-if=\"prc.pv.idStato==\'1\'\" class=\"fa fa-unlock margin-left\" bs-tooltip data-container=\"body\" data-title=\"Stato aperto\"></i>\n                        <i ng-if=\"prc.pv.idStato==\'2\'\" class=\"fa fa-pause-circle margin-left\" bs-tooltip data-container=\"body\" data-title=\"Stato sospeso\"></i>\n                        <i ng-if=\"prc.pv.idStato==\'3\'\" class=\"fa fa-lock margin-left\" bs-tooltip data-container=\"body\" data-title=\"Stato chiuso\"></i>\n                        <i ng-if=\"prc.pv.idStato==\'4\'\" class=\"fa fa-hourglass-start margin-left\" bs-tooltip data-container=\"body\" data-title=\"Stato in preparazione\"></i>\n                      </span>\n                    </h4>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-9\">\n                <h4 class=\"pull-left\">\n                  {{prc.pv.cliente}}<span class=\"normal\"> <span ng-if=\"prc.pv.indirizzo\">- {{prc.pv.indirizzo}}</span> <span ng-if=\"prc.pv.citta\">- {{prc.pv.citta}}</span> <span ng-if=\"prc.pv.prov\">({{prc.pv.prov}})</span></span>\n                </h4>\n                <div class=\"pull-right\">\n                  <button ng-if=\"prc.azioni.length > 0\"\n                    type=\"button\" class=\"btn btn-info btn-md dropdown-toggle\"\n                    bs-dropdown=\"prc.azioni\"\n                    data-placement=\"bottom-right\">\n                    Azioni&nbsp;<span class=\"caret\"></span>\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-body\">\n          <form name=\"PvReadForm\" class=\"dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n            <div class=\"row\">\n              <div class=\"col-sm-3 sidebar\">\n                <div id=\"paste-alerts-container\">\n                </div>\n                <div class=\"margin-bottom\">\n                  <h5 class=\"section-title\">Sede cliente</h5>\n                  <div class=\"section-content\">\n                    <span ng-if=\"prc.pv.indirizzo\">{{prc.pv.indirizzo}}</span><br>\n                    <span ng-if=\"prc.pv.citta\">{{prc.pv.citta}}</span> <span ng-if=\"prc.pv.prov\">({{prc.pv.prov}})</span>\n                    <a title=\"Apri mappa\" ng-href=\"http://maps.google.com/?q={{(prc.pv.indirizzo + \' \' + prc.pv.citta) | urlEncode}}\" target=\"_blank\">\n                      <i class=\"fa fa-map-o\"></i>\n                    </a>\n                    <a href=\"tel:{{prc.pv.telSede}}\" ng-if=\"prc.pv.telSede\" class=\"datoReferente\">\n                      <i class=\"fa fa-phone\"></i>\n                      <i class=\"fa fa-copy\" copy-to-clipboard=\"{{prc.pv.telSede}}\"></i>\n                      {{prc.pv.telSede}}\n                    </a>\n                </div>\n                </div>\n                <div class=\"margin-bottom\">\n                  <h5 class=\"section-title\">Dati referente</h5>\n                  <div class=\"section-content\">\n                    <div class=\"datoReferente\">{{prc.pv.nomeReferente}}</div>\n                    <a href=\"mailto:{{prc.pv.emailReferente}}\" ng-if=\"prc.pv.emailReferente\" class=\"datoReferente\">\n                      <i class=\"fa fa-envelope\"></i>\n                      <i class=\"fa fa-copy\" copy-to-clipboard=\"{{prc.pv.emailReferente}}\"></i>\n                      <span class=\"text-overflow\">{{prc.pv.emailReferente}}</span>\n                    </a>\n                    <a href=\"tel:{{prc.pv.cellReferente}}\" ng-if=\"prc.pv.cellReferente\" class=\"datoReferente\">\n                      <i class=\"fa fa-mobile\"></i>\n                      <i class=\"fa fa-copy\" copy-to-clipboard=\"{{prc.pv.cellReferente}}\"></i>\n                      {{prc.pv.cellReferente}}\n                    </a>\n                    <a href=\"tel:{{prc.pv.telReferente}}\" ng-if=\"prc.pv.telReferente\" class=\"datoReferente\">\n                      <i class=\"fa fa-phone\"></i>\n                      <i class=\"fa fa-copy\" copy-to-clipboard=\"{{prc.pv.telReferente}}\"></i>\n                      {{prc.pv.telReferente}}\n                    </a>\n                  </div>\n                </div>\n                <div class=\"margin-top margin-bottom\" ng-if=\"prc.pv.orariAperturaCliente\">\n                  <h5 class=\"section-title\">Orari di apertura</h5>\n                  <div class=\"section-content\" ng-bind-html=\"prc.pv.orariAperturaCliente | nl2br\"></div>\n                </div>\n                <h5 class=\"section-title\">Data apertura</h5>\n                <div class=\"section-content\">\n                  {{prc.pv.dataApertura | date:\'dd/MM/yyyy HH:mm\'}}\n                </div>\n                <h5 class=\"section-title\" ng-if=\"prc.pv.realizzativo\" ng-init=\"prc.dataInstallazioneMode=\'view\'\">\n                  Data installazione\n                  <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.dataInstallazioneMode=\'edit\';prc.dataInizioInstallazioneBckp=prc.pv.dataInizioInstallazione;prc.dataFineInstallazioneBckp=prc.pv.dataFineInstallazione;\" ng-if=\"prc.dataInstallazioneMode==\'view\'\">\n                    <i class=\"fa fa-pencil\"></i>\n                  </button>\n                  <span ng-if=\"prc.dataInstallazioneMode==\'edit\'\">\n                    <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.dataInizioInstallazione=prc.dataInizioInstallazioneBckp;prc.pv.dataFineInstallazione=prc.dataFineInstallazioneBckp;prc.dataInstallazioneMode=\'view\';\"></i>\n                    <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveDataInstallazione()\"></i>\n                  </span>\n                </h5>\n                <div class=\"section-content\" ng-if=\"prc.pv.realizzativo\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 col-md-4\">\n                      <strong>Da</strong><br />\n                      <div ng-if=\"prc.dataInstallazioneMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                        {{prc.pv.dataInizioInstallazione | date:\'dd/MM/yyyy\'}}\n                      </div>\n                      <div class=\"validate-group\" ng-show=\"prc.dataInstallazioneMode==\'edit\'\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data inizio installazione\"><i class=\"fa fa-calendar-o\"></i></span>\n                          <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                            ng-model=\"prc.pv.dataInizioInstallazione\" name=\"dataInizioInstallazione\"\n                            ng-change=\"prc.dataInizioInstallazioneChange()\"\n                            bs-datepicker\n                            greater-than-or-equal-to=\"prc.pv.dataApertura\" gt-field-name=\"dataFineInstallazione\" gt-field-type=\"date\">\n                        </div>\n                        <div ng-messages=\"PvReadForm.dataInizioInstallazione.$error\">\n                          <div ng-message=\"greaterThanOrEqualTo\" class=\"help-block has-error error-msg\">La data di inizio installazione non può essere precedente a quella di apertura</div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-6 col-md-4\">\n                      <strong>A</strong><br />\n                      <div ng-if=\"prc.dataInstallazioneMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                        {{prc.pv.dataFineInstallazione | date:\'dd/MM/yyyy\'}}\n                      </div>\n                      <div class=\"validate-group\" ng-show=\"prc.dataInstallazioneMode==\'edit\'\">\n                        <div class=\"input-group\">\n                          <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data fine installazione\"><i class=\"fa fa-calendar-o\"></i></span>\n                          <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                            ng-model=\"prc.pv.dataFineInstallazione\" name=\"dataFineInstallazione\"\n                            bs-datepicker\n                            greater-than-or-equal-to=\"prc.pv.dataInizioInstallazione\" gt-field-name=\"dataFineInstallazione\" gt-field-type=\"date\">\n                        </div>\n                        <div ng-messages=\"PvReadForm.dataFineInstallazione.$error\">\n                          <div ng-message=\"greaterThanOrEqualTo\" class=\"help-block has-error error-msg\">La data di fine installazione non può essere precedente alla data di inizio</div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\" ng-if=\"prc.pv.realizzativo\" ng-init=\"prc.noteTicketMode=\'view\'\">\n                  Note\n                  <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.noteTicketMode=\'edit\'\" ng-if=\"prc.noteTicketMode==\'view\'\">\n                    <i class=\"fa fa-pencil\"></i>\n                  </button>\n                  <span ng-if=\"prc.noteTicketMode==\'edit\'\">\n                    <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.noteTicketMode=\'view\'\"></i>\n                    <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveNoteTicket()\"></i>\n                  </span>\n                </h5>\n                <div class=\"section-content\" ng-if=\"prc.pv.realizzativo\">\n                  <span ng-if=\"prc.noteTicketMode==\'view\'\">{{prc.pv.noteTicket}}</span>\n                  <div class=\"validate-group\" ng-show=\"prc.noteTicketMode==\'edit\'\">\n                    <textarea rows=\"6\" class=\"form-control\" ng-model=\"prc.pv.noteTicket\" name=\"noteTicket\">\n                    </textarea>\n                  </div>\n                </div>\n                <h5 class=\"section-title\" ng-if=\"!prc.pv.realizzativo\">Data chiusura</h5>\n                <div class=\"section-content\" ng-if=\"!prc.pv.realizzativo\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 col-md-4\">\n                      <strong>Prevista</strong><br />\n                      {{prc.pv.dataPrevChiusura | date:\'dd/MM/yyyy HH:mm\'}}\n                    </div>\n                    <div class=\"col-xs-6 col-md-4\" ng-if=\"prc.pv.dataChiusura\">\n                      <strong>Effettiva</strong><br />\n                      {{prc.pv.dataChiusura | date:\'dd/MM/yyyy HH:mm\'}}\n                    </div>\n                  </div>\n                </div>\n                <div ng-if=\"( ( prc.pv.durataTicket > 0 ) || ( prc.pv.durataAttivita != \'\' ) )\">\n                  <h5 class=\"section-title margin-top\" ng-if=\"!prc.pv.realizzativo\">Durata</h5>\n                  <div class=\"section-content\">\n                    <div class=\"row\">\n                      <div class=\"col-xs-6 col-md-4\" ng-if=\"!prc.pv.realizzativo && prc.pv.durataTicket\">\n                        <strong>Durata ticket</strong><br />\n                        {{prc.pv.durataTicket}}gg\n                      </div>\n                      <div class=\"col-xs-6 col-md-4\" ng-if=\"prc.pv.durataAttivita\">\n                        <strong>Ore lavorate</strong><br />\n                        {{prc.pv.durataAttivita}}\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <h5 class=\"section-title\">Ordine in elenco</h5>\n                <div class=\"section-content\" ng-init=\"prc.ordineMode=\'view\'\">\n                  <div ng-if=\"prc.ordineMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                    {{prc.pv.ordine}}\n                    <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.ordineMode=\'edit\';prc.ordineBckp=prc.pv.ordine;\" ng-if=\"prc.pv.idStato!=\'3\'\">\n                      <i class=\"fa fa-pencil\"></i>\n                    </button>\n                  </div>\n                  <div ng-if=\"prc.ordineMode==\'edit\'\">\n                    <input type=\"number\" class=\"form-control input-order edit-inplace\" ng-model=\"prc.pv.ordine\" step=\"1\" min=\"0\" max=\"100\" name=\"ordine\">\n                    <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.ordine=prc.ordineBckp;prc.ordineMode=\'view\';\"></i>\n                    <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveOrdine()\"></i>\n                  </div>\n                </div>\n                <div ng-if=\"prc.pv.invioEmailApertura!=\'\'||prc.pv.invioEmailChiusura!=\'\'\">\n                  <h5 class=\"section-title\">Notifiche</h5>\n                  <div class=\"section-content\">\n                    <div ng-if=\"prc.pv.invioEmailApertura!=\'\'\" class=\"margin-top\">\n                      <i class=\"fa fa-envelope\"></i> {{prc.pv.invioEmailApertura}}\n                    </div>\n                    <div ng-if=\"prc.pv.invioEmailChiusura!=\'\'\" class=\"margin-top\">\n                      <i class=\"fa fa-envelope\"></i> {{prc.pv.invioEmailChiusura}}\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-9 content-right\">\n                <h5 class=\"section-title\"><span ng-if=\"prc.pv.realizzativo\">Titolo</span>&nbsp;</h5>\n                <div class=\"section-content margin-top\">\n                  <div class=\"margin-bottom\" ng-if=\"prc.pv.realizzativo\">\n                    <span ng-if=\"prc.descrizioneBreveMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                      <span ng-bind-html=\"prc.pv.descrizioneBreve | nl2br\"></span>\n                      <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.descrizioneBreveMode=\'edit\';prc.descrizioneBreveBckp=prc.pv.descrizioneBreve;\">\n                        <i class=\"fa fa-pencil\"></i>\n                      </button>\n                    </span>\n                    <span ng-if=\"prc.descrizioneBreveMode==\'edit\'\">\n                      <textarea rows=\"5\" class=\"form-control edit-inplace\"\n                        ng-model=\"prc.pv.descrizioneBreve\" name=\"descrizioneBreve\">\n                      </textarea>\n                      <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.descrizioneBreve=prc.descrizioneBreveBckp;prc.descrizioneBreveMode=\'view\';\"></i>\n                      <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveDescrizioneBreve()\"></i>\n                    </span>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 margin-bottom\" ng-init=\"prc.prioritaMode=\'view\'\">\n                      <strong>Urgenza</strong><br />\n                      <span class=\"priorita priorita-{{prc.pv.idPriorita}}\"></span>\n                      <span ng-if=\"prc.prioritaMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                        {{prc.pv.priorita}}\n                        <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.prioritaMode=\'edit\';prc.idPrioritaBckp=prc.pv.idPriorita;\" ng-if=\"prc.pv.idStato!=\'3\'\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </button>\n                      </span>\n                      <span ng-if=\"prc.prioritaMode==\'edit\'\">\n                        <select class=\"form-control edit-inplace\"\n                          ng-options=\"el.value as el.label for el in prc.formData.priorita\n                            | orderBy:\'ordinamento\'\"\n                          ng-model=\"prc.pv.idPriorita\" name=\"idPriorita\">\n                        </select>\n                        <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.idPriorita=prc.idPrioritaBckp;prc.prioritaMode=\'view\';\"></i>\n                        <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.savePriorita()\"></i>\n                      </span>\n                    </div>\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 margin-bottom\" ng-if=\"prc.pv.categoria\">\n                      <strong>Categoria</strong><br />\n                      {{prc.pv.categoria}}\n                    </div>\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 margin-bottom\" ng-if=\"prc.pv.fornitore\">\n                      <strong>Fornitore</strong><br />\n                      {{prc.pv.fornitore}}\n                    </div>\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 margin-bottom\" ng-init=\"prc.soggettoMode=\'view\'\">\n                      <strong>Assegnato a</strong>\n                      <i class=\"fa fa-history cursorPointer\"\n                        data-placement=\"bottom\" title=\"Storico assegnazioni\" data-content=\"{{prc.htmlLogAssegnazioni}}\"\n                        data-animation=\"am-flip-x\" data-auto-close=\"1\"\n                        bs-popover></i>\n                      <br />\n                      <div ng-if=\"prc.soggettoMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                        {{prc.pv.soggetto}}\n                        <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.soggettoMode=\'edit\';prc.idSoggettoBckp=prc.pv.idSoggetto;\" ng-if=\"prc.pv.idStato!=\'3\'\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </button>\n                      </div>\n                      <div ng-if=\"prc.soggettoMode==\'edit\'\" class=\"validate-group\">\n                        <select class=\"form-control edit-inplace\"\n                          ng-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in prc.formData.soggetti\n                            | orderBy:\'cognome\'\"\n                          ng-model=\"prc.pv.idSoggetto\" name=\"idSoggetto\">\n                        </select>\n                        <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.idSoggetto=prc.idSoggettoBckp;prc.soggettoMode=\'view\';\"></i>\n                        <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveSoggetto()\"></i>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 margin-bottom\" ng-init=\"prc.stageMode=\'view\'\">\n                      <strong>Fase</strong>\n                      <div ng-if=\"prc.stageMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                        <span ng-if=\"prc.pv.stage\">{{prc.pv.stage}}</span>\n                        <span ng-if=\"!prc.pv.stage\" class=\"disabled\">[fase non specificata]</span>\n                        <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.stageMode=\'edit\';prc.idStageBckp=prc.pv.idStage;\" ng-if=\"prc.pv.idStato!=\'3\'\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </button>\n                      </div>\n                      <div ng-if=\"prc.stageMode==\'edit\'\" class=\"validate-group\">\n                        <select class=\"form-control edit-inplace\"\n                          ng-options=\"el.value as el.label for el in prc.formData.stages\n                            | orderBy:\'ordinamento\'\"\n                          ng-model=\"prc.pv.idStage\" name=\"idStage\">\n                        </select>\n                        <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.pv.idStage=prc.idStageBckp;prc.stageMode=\'view\';\"></i>\n                        <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveStage()\"></i>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-6 col-md-4 col-lg-2 text-right margin-bottom\" ng-if=\"prc.pv.fatturato\">\n                      <i class=\"fa fa-check-square\"></i> <strong>Fatturato</strong>\n                    </div>\n                  </div>\n                  <div ng-if=\"prc.contrattiInScadenza.length>0&&prc.pv.idStato==1&&!prc.pv.realizzativo\" class=\"margin-top margin-bottom\">\n                    <strong>Attenzione:</strong> questo cliente ha dei contratti in scadenza\n                  </div>\n                  <div class=\"margin-bottom\" ng-if=\"prc.pv.contratti.length==1\">\n                    <strong>Prodotto</strong><br />\n                    <span ng-repeat=\"(idContratto, contratto) in prc.pv.contratti\">\n                      <i class=\"fa fa-euro margin-right\"></i> <span ng-if=\"contratto.sede\">{{contratto.sede}} - </span>{{contratto.pista}} - {{contratto.prodotto}}<span ng-if=\"contratto.dataCrm\"> - {{contratto.dataCrm | date:\'dd-MM-yyyy\'}}</span><br>\n                    </span>\n                  </div>\n                  <div class=\"margin-bottom\" ng-if=\"prc.pv.contratti.length>1\">\n                    <strong>Prodotti</strong><br />\n                    <span ng-repeat=\"(idContratto, contratto) in prc.pv.contratti\">\n                      <i class=\"fa fa-euro margin-right\"></i> {{contratto.pista}} - {{contratto.prodotto}}<span ng-if=\"contratto.dataCrm\"> - {{contratto.dataCrm | date:\'dd-MM-yyyy\'}}</span><br>\n                    </span>\n                  </div>\n                  <div ng-if=\"prc.pv.descrizioneTicket && prc.pv.descrizioneTecnico\"\n                    class=\"margin-top-xl margin-bottom-xl\"\n                    bs-tabs\n                    bs-active-pane=\"pvNote.activeTab\"\n                    ng-init=\"pvNote.activeTab = 0\">\n                    <div data-title=\"Note cliente\" bs-pane>\n                      <div ng-bind-html=\"prc.pv.descrizioneTicket | nl2br\" class=\"margin-top margin-bottom\"></div>\n                    </div>\n                    <div data-title=\"Note tecnico\" bs-pane>\n                      <div ng-bind-html=\"prc.pv.descrizioneTecnico | nl2br\" class=\"margin-top margin-bottom\"></div>\n                    </div>\n                  </div>\n                  <div class=\"descrizioneTicket\" ng-if=\"prc.pv.descrizioneTicket && ! prc.pv.descrizioneTecnico\">\n                    <strong>Note cliente</strong><br />\n                    <div ng-bind-html=\"prc.pv.descrizioneTicket | nl2br\"></div>\n                  </div>\n                  <div class=\"descrizioneTicket\" ng-if=\"prc.pv.descrizioneTecnico && ! prc.pv.descrizioneTicket\">\n                    <strong>Note tecnico</strong><br />\n                    <div ng-bind-html=\"prc.pv.descrizioneTecnico | nl2br\"></div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-sm-6 col-sm-offset-6 hidden-xs\">\n                      <div class=\"tabHeaderButtons\">\n                        <button\n                          type=\"button\"\n                          class=\"btn btn-info btn-xs ng-scope\"\n                          bs-tooltip data-title=\"Nuova attività\"\n                          ng-if=\"prc.pv.stato!==\'chiuso\'\" ng-click=\"prc.createAttivitaPv(prc.pv)\"><i class=\"fa fa-plus\"></i> Attività\n                        </button>\n                        <button\n                          type=\"button\"\n                          class=\"btn btn-info btn-xs ng-scope\"\n                          bs-tooltip data-title=\"Nuovo allegato\"\n                          ng-if=\"prc.pv.stato!==\'chiuso\'\" ng-click=\"prc.createAllegato(prc.pv)\"><i class=\"fa fa-plus\"></i> Allegato\n                        </button>\n                        <button\n                          type=\"button\"\n                          class=\"btn btn-info btn-xs ng-scope\"\n                          bs-tooltip data-title=\"Nuovo rapportino\"\n                          ng-click=\"prc.createRapportino()\" ng-if=\"prc.inserimentoRapportino\"><i class=\"fa fa-plus\"></i> Rapportino\n                        </button>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-12 table-responsive\">\n                      <div bs-tabs\n                        bs-active-pane=\"prc.activeTab\"\n                        ng-init=\"prc.activeTab = 0\">\n                        <div data-title=\"{{prc.titleAttivita}}\" bs-pane>\n                          <table id=\"pv_attivita\" datatable\n                            dt-options=\"prc.dtAttivita.options\"\n                            dt-columns=\"prc.dtAttivita.columns\"\n                            dt-instance=\"prc.dtAttivita.instance\"\n                            class=\"table table-hover margin-top\">\n                          </table>\n                        </div>\n                        <div data-title=\"{{prc.titleAllegati}}\" bs-pane>\n                          <table id=\"pv_allegati\" datatable\n                            dt-options=\"prc.dtAllegati.options\"\n                            dt-columns=\"prc.dtAllegati.columns\"\n                            dt-instance=\"prc.dtAllegati.instance\"\n                            class=\"table table-hover margin-top\">\n                          </table>\n                        </div>\n                        <div data-title=\"{{prc.titleRapportini}}\" bs-pane>\n                          <table id=\"pv_rapportini\" datatable\n                            dt-options=\"prc.dtRapportini.options\"\n                            dt-columns=\"prc.dtRapportini.columns\"\n                            dt-instance=\"prc.dtRapportini.instance\"\n                            class=\"table table-hover margin-top\">\n                          </table>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\" ng-if=\"prc.alerts.messages.length > 0\">\n                  <div class=\"col-xs-12\">\n                    <g1-alerts data-status=\"{{prc.alerts.status}}\" data-messages=\"prc.alerts.messages\"></g1-alerts>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </form>\n        </div>\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"prc.user.userGroup > 4 && prc.user.userGroup < 9\">\n                <small>\n                  Inserito: {{prc.pv.idUtenteIns}} - {{prc.pv.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato: {{prc.pv.idUtenteMod}} - {{prc.pv.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/pv-view.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid></div>");
$templateCache.put("app/core/pv/pv.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><div class=\"g1-panel margin-top pvMainPage\"><!-- kanban --><div class=kanbanContainer><h2>Ticket <span class=badge>{{pv.pvCount}}</span><div class=pull-right><span id=soggettiContainer><button type=button class=\"btn btn-default\" ng-model=pv.soggetti ng-change=pv.soggettiChange() bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=#soggettiContainer bs-options=\"el.idSoggetto as el.cognome + \' \' + el.nome for el in pv.formData.soggetti | orderBy:\'label\'\">Action <span class=caret></span></button> </span><button type=button class=\"btn btn-primary filterButton\" ng-click=pv.togglePvView()><i class=\"fa fa-fw fa-{{pv.viewPvButton.icon}}\"></i> <span class=hidden-xs>{{pv.viewPvButton.label}}</span></button> <button type=button class=\"btn btn-primary filterButton\" ng-click=pv.togglePvFilter()><i class=\"fa fa-{{pv.filterPvButton.icon}}\"></i> <span class=hidden-xs>{{pv.filterPvButton.label}}</span></button> <button type=button class=\"btn btn-info\" ng-click=pv.refreshContent()><i class=\"fa fa-refresh\"></i> <span>Aggiorna elenco</span> <span class=autorefreshTimeSlider><span ng-style={width:pv.autorefreshTimeSliderWidth}></span></span></button> <a href=/#/ricerca/pv class=\"btn btn-info margin-left hidden-xs\"><i class=\"fa fa-search\"></i> <span class=hidden-xs>Ricerca</span></a></div></h2><div class=\"kanban row no-gutters\" ng-if=\"pv.view == \'kanban\'\"><div ng-repeat=\"(idStage, stage) in pv.kanban\" class=\"col-xs-12 col-sm-6 col-md-2\" ng-style=\"{width:(100/pv.kanbanStages)+\'%\'}\">{{pv.kanban.length}}<div class=\"panel kanban-panel\"><div class=\"panel-heading text-center\" style=\"background-color: {{stage.bgColor}}\"><h3 class=panel-title><strong>{{stage.label}}</strong><br><span class=\"badge panel-items-count\">{{stage.itemsLength}}</span></h3></div><div class=panel-body><ul class=list-group dnd-list dnd-drop=\"callback({targetList: stage.items, targetIndex: index, targetStage: idStage})\"><li ng-repeat=\"item in stage.items | filter:pv.kanbanFilter\" class=\"list-group-item kanban-item\" ng-class=\"{\n                    \'highlight\': item.idSoggetto == pv.user.idAgente\n                  }\" ng-show=\"( pv.soggetti.length == 0 ) || ( pv.soggetti.indexOf( item.idSoggetto ) > - 1 )\" dnd-draggable=null dnd-callback=\"pv.onDrop(stage.items, $index, idStage, targetList, targetIndex, targetStage)\" dnd-effect-allowed=move data-user={{item.idSoggetto}}><button class=\"btn btn-primary btn-xs\" ng-click=pv.readCliente(item.idCliente)><i class=\"fa fa-external-link-square\"></i></button> <span class=pull-right><i class=\"fa fa-sort\"></i> {{item.ordine}}</span> <a href=\"\" ng-click=pv.readPv(item.idPostvendita)>{{item.cliente}}</a><br><div class=\"hideextra outer\"><div class=\"hideextra inner\" onclick=toggleHideExtra(this)>{{item.descrizioneTicket}}</div></div><span class=margin-right><i class=\"fa fa-life-ring text-success\" ng-if=item.inAssistenza bs-tooltip data-title=\"In assistenza\"></i> <i class=\"fa fa-euro\" ng-if=!item.inAssistenza bs-tooltip data-title=\"A pagamento\"></i> </span><span class=margin-right ng-if=item.bloccato><i class=\"fa fa-exclamation-triangle text-danger\" bs-tooltip data-title=\"Cliente bloccato\"></i> </span><span class=margin-right ng-if=\"Date.parse( item.dataPrevChiusura ) < Date.now()\"><i class=\"fa fa-clock-o text-danger\" data-title=\"Ticket scaduto\" bs-tooltip></i> </span><span class=margin-right><i class=\"fa fa-calendar\"></i> <strong class=text-primary>{{item.dataApertura | date:\'dd/MM/yyyy HH:mm\'}} </strong></span><span class=margin-right ng-if=item.durataAttivita><i class=\"fa fa-clock-o\"></i> {{item.durataAttivita}} </span><span ng-if=item.soggetto><br><span class=margin-right><i class=\"fa fa-user fixed-width\"></i> {{item.soggetto}} </span></span><span class=\"priorita priorita-{{item.idPriorita}} pull-right\" bs-tooltip data-title={{item.priorita}}></span></li></ul></div></div></div></div><div class=\"g1-panel-container table-responsive\" ng-show=\"pv.dtPv.dtInstance && pv.view == \'elenco\'\"><table datatable dt-options=::pv.dtPv.dtOptions dt-columns=::pv.dtPv.dtColumns dt-instance=pv.dtPv.dtInstance class=\"table table-hover\"><tfoot><tr><th>Codice</th><th></th><th>Cliente</th><th>Città</th><th>Prov.</th><th>Pista</th><th>Categoria</th><th>Descrizione</th><th>Apertura</th><th>Scadenza</th><th>Soggetto</th><th></th><th></th><th>Urgenza</th><th></th></tr></tfoot></table><div class=\"alert alert-warning alterActiveFilter\" ng-if=pv.dtPv.filtered>L\'elenco dei risultati è stato filtrato rispetto al totale</div><div class=legendDescription><span class=\"highlight legend\"></span> Miei</div></div><!-- alerts kanban --><div class=row><div class=\"col-xs-12 margin-top\"><g1-alerts data-status={{pv.alertsK.status}} data-messages=pv.alertsK.messages></g1-alerts></div></div></div></div><br></div><script type=text/ng-template id=dashboard-pv-aside.tpl.html><div class=\"aside\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"aside-dialog\">\n      <div class=\"aside-content\">\n        <form name=\"search_opportunita_kanban\" ng-submit=\"pv.searchKanban()\" novalidate>\n          <div class=\"aside-header\">\n            <button type=\"button\" class=\"close\" ng-click=\"$hide()\">&times;</button>\n            <h4 class=\"aside-title\">Filtri</h4>\n          </div>\n\n          <div class=\"aside-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Da</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"pv.sr.dataFrom\" name=\"dataFrom\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>A</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"pv.sr.dataTo\" name=\"dataTo\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Data installazione (da)</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"pv.sr.dataInizioInstallazione\" name=\"dataInizioInstallazione\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Data installazione (a)</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"pv.sr.dataFineInstallazione\" name=\"dataFineInstallazione\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <strong>Assegnatario</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in pv.formData.soggetti | orderBy:\'cognome\'\"\n                ng-model=\"pv.sr[\'soggetti[]\']\" name=\"soggetto\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Categoria</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.value as el.label for el in pv.formData.categorie | orderBy:\'label\'\"\n                ng-model=\"pv.sr[\'categorie[]\']\" name=\"categorie\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Pista</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.value as el.label for el in pv.formData.piste | orderBy:\'label\'\"\n                ng-model=\"pv.sr[\'piste[]\']\" name=\"piste\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Cliente</strong><br>\n              <input type=\"text\" class=\"form-control\" ng-model=\"pv.sr.cliente\" name=\"cliente\">\n            </div>\n          </div>\n          <div class=\"aside-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-fw fa-filter\"></i> Filtra</button>\n            <button type=\"button\" class=\"btn btn-warning\" ng-click=\"pv.resetKanban()\"><i class=\"fa fa-fw fa-undo\"></i> Resetta</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/realizzazioni.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><!-- navbar --><div class=row><div class=\"col-xs-12 col-md-3\"><ul class=\"nav nav-pills\"><li role=presentation ng-class=\"{\'active\': rc.activeTab === \'dashboard\'}\"><a href=\"\" ng-show=\"rc.activeTab === \'dashboard\'\" ng-click=rc.showAside() class=inline-block><i class=\"fa fa-fw fa-lg fa-filter\" bs-tooltip data-title=\"Filtri Kanban\"></i> </a><a href=\"\" bs-tooltip data-title=Kanban ng-click=\"rc.activeTab = \'dashboard\'\" class=inline-block><i class=\"fa fa-fw fa-bar-chart fa-flip-vertical\"></i></a></li><li role=presentation ng-class=\"{\'active\': rc.activeTab === \'ricerca\'}\"><a href=\"\" ng-click=\"rc.activeTab = \'ricerca\'\"><i class=\"fa fa-fw fa-bars\" bs-tooltip data-title=Ricerca></i></a></li></ul></div><div class=\"col-xs-12 col-md-6 text-center\" ng-if=\"rc.activeTab === \'dashboard\'\"><div class=vcenter-block><span class=\"badge alert-info\" ng-if=rc.sr.dataFrom>Da: {{rc.sr.dataFrom | date:\'shortDate\'}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'dataFrom\')\"></i> </span><span class=\"badge alert-info\" ng-if=rc.sr.dataTo>A: {{rc.sr.dataTo | date:\'shortDate\'}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'dataTo\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"rc.sr[\'soggetti[]\'] > 0 || rc.sr[\'soggetti[]\'] === \'NULL\'\">{{(rc.formData.soggetti | filter:{idSoggetto: rc.sr[\'soggetti[]\']}:true)[0].cognome}} {{(rc.formData.soggetti | filter:{idSoggetto: rc.sr[\'soggetti[]\']}:true)[0].nome}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'soggetti[]\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"rc.sr[\'categorie[]\']\">{{(rc.formData.categorie | filter:{value: rc.sr[\'categorie[]\']}:true)[0].label}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'categorie[]\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"rc.sr[\'piste[]\']\">{{rc.sr[\'piste[]\']}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'piste[]\')\"></i> </span><span class=\"badge alert-info\" ng-if=rc.sr.cliente>{{rc.sr.cliente}} <i class=\"fa fa-times fa-fw close-button\" ng-click=\"rc.unsetFilter(\'cliente\')\"></i></span></div></div><div class=\"col-xs-12 col-md-3 text-right\" ng-if=\"rc.activeTab === \'dashboard\'\"><i class=\"fa fa-fw fa-search\" bs-tooltip data-title=\"Ricerca testo in tutti i campi della dashboard\"></i> <input type=text ng-model=rc.kanbanFilter></div></div><!-- kanban --><div class=kanbanContainer ng-show=\"rc.activeTab === \'dashboard\'\"><h2>Realizzazioni <span class=badge ng-click=\"rc.visualizzaRealizzazioni(\'aperto\')\">{{rc.realizzazioniAperte}}</span> <span ng-if=\"rc.realizzazioniSospese > 0\" class=\"text-regular text-danger\" ng-click=\"rc.visualizzaRealizzazioni(\'sospeso\')\">sospese {{rc.realizzazioniSospese}}</span> <button type=button class=\"btn btn-info pull-right\" ng-click=rc.refreshContent()><i class=\"fa fa-refresh\"></i> <span>Aggiorna elenco</span> <span class=autorefreshTimeSlider><span ng-style={width:rc.autorefreshTimeSliderWidth}></span></span></button></h2><div class=\"kanban row no-gutters\"><div ng-repeat=\"(idStage, stage) in rc.kanban\" class=\"col-xs-12 col-sm-6 col-md-2\" ng-style=\"{width:(100/rc.kanbanStages)+\'%\'}\">{{rc.kanban.length}}<div class=panel><div class=\"panel-heading text-center\" style=\"background-color: {{stage.bgColor}}\"><h3 class=panel-title><strong>{{stage.label}}</strong><br><span class=badge>{{stage.aperti}}</span> <span class=\"badge sospeso\" ng-if=\"stage.sospesi > 0\" ng-click=rc.toggleSospesi(stage)>{{stage.sospesi}}</span></h3></div><div class=panel-body><ul class=list-group dnd-list dnd-drop=\"callback({targetList: stage.items, targetIndex: index, targetStage: idStage})\"><li ng-repeat=\"item in stage.items | filter:rc.kanbanFilter\" class=list-group-item ng-class=\"{\n                  \'highlight\': item.idSoggetto == rc.user.idAgente\n                }\" ng-if=\"item.stato==rc.statoDaVisualizzare\" dnd-draggable=null dnd-callback=\"rc.onDrop(stage.items, $index, idStage, targetList, targetIndex, targetStage)\" dnd-effect-allowed=move><button class=\"btn btn-primary btn-xs\" ng-click=rc.readCliente(item.idCliente)><i class=\"fa fa-external-link-square\"></i></button> <a href=\"\" ng-click=rc.readRealizzazione(item.idPostvendita)>{{item.cliente}}</a><br><div ng-bind-html=\"item.descrizioneBreve | nl2br\"></div><strong ng-if=item.noteTicket><i class=\"fa fa-sticky-note fixed-width\"></i> <strong class=text-primary>{{item.noteTicket}}</strong><br></strong><span ng-if=item.dataInizioInstallazione><i class=\"fa fa-calendar fixed-width\"></i> <strong class=text-primary>{{item.dataInizioInstallazione | date:\'dd/MM/yyyy\'}} <span ng-if=\"item.dataFineInstallazione&&item.dataInizioInstallazione!=item.dataFineInstallazione\">- {{item.dataFineInstallazione | date:\'dd/MM/yyyy\'}}</span></strong><br></span><i class=\"fa fa-user fixed-width\"></i> {{item.soggetto}}<br></li></ul></div></div></div></div><!-- alerts kanban --><div class=row><div class=\"col-xs-12 margin-top\"><g1-alerts data-status={{rc.alertsK.status}} data-messages=rc.alertsK.messages></g1-alerts></div></div></div><!-- ricerca --><div class=padding-top ng-show=\"rc.activeTab === \'ricerca\'\"><form role=form name=searchRealizzazioni ng-submit=rc.search()><div class=row><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Da</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=rc.sr.dataFrom name=dataFrom bs-datepicker data-placement=bottom-left></div></div><div class=col-xs-6><strong>A</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=rc.sr.dataTo name=dataTo bs-datepicker data-placement=bottom-left></div></div></div></div></div><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Data installazione (da)</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=rc.sr.dataInizioInstallazione name=dataInizioInstallazione bs-datepicker data-placement=bottom-left></div></div><div class=col-xs-6><strong>Data installazione (a)</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=rc.sr.dataFineInstallazione name=dataFineInstallazione bs-datepicker data-placement=bottom-left></div></div></div></div></div><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Assegnatario</strong><br><select class=form-control ng-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in rc.formData.soggetti | orderBy:\'cognome\'\" ng-model=\"rc.sr[\'soggetti[]\']\" name=soggetti><option value=\"\">TUTTI</option></select></div></div></div></div><div class=col-sm-3><div class=form-group><strong>Categoria</strong><br><select class=form-control ng-options=\"el.value as el.label for el in rc.formData.categorie | orderBy:\'label\'\" ng-model=\"rc.sr[\'categorie[]\']\" name=categorie><option value=\"\">TUTTE</option></select></div></div><div class=col-sm-3><div class=form-group><strong>Pista</strong><br><select class=form-control ng-options=\"el.value as el.label for el in rc.formData.piste | orderBy:\'label\'\" ng-model=\"rc.sr[\'piste[]\']\" name=piste><option value=\"\">TUTTE</option></select></div></div><div class=col-sm-3><div class=form-group><label>Cliente<br><input type=text class=form-control ng-model=rc.sr.cliente name=cliente></label></div></div><div class=col-sm-3><div class=form-group><label>Fase<br><select class=form-control ng-options=\"el.value as el.label for el in rc.formData.stages | orderBy:\'ordinamento\'\" ng-model=rc.sr.idStage name=idStage><option value=\"\">TUTTE</option></select></label></div></div><div class=col-sm-3><div class=form-group><label>Stato<br><select class=form-control ng-options=\"el.value as el.label for el in rc.formData.stati\" ng-model=rc.sr.idStato name=idStato><option value=\"\">TUTTE</option></select></label></div></div></div><div class=row><div class=\"col-xs-12 text-right\"><span class=margin-right></span> <button type=reset class=\"btn btn-warning\" bs-tooltip data-title=Resetta ng-click=rc.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span class=margin-right></span> <button type=submit class=\"btn btn-info\" bs-tooltip data-title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><!-- alerts ricerca --><div class=row><div class=\"col-xs-12 padding-top\"><g1-alerts data-status={{rc.alerts.status}} data-messages=rc.alerts.messages></g1-alerts></div></div><div class=\"g1-panel realizzazioniWrapper\" ng-if=rc.dt.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=rc.dt.dtOptions dt-columns=rc.dt.dtColumns dt-instance=rc.dt.dtInstance class=\"table table-hover\"></table></div></div></div></div><br></div><script type=text/ng-template id=dashboard-realizzazioni-aside.tpl.html><div class=\"aside\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"aside-dialog\">\n      <div class=\"aside-content\">\n        <form name=\"search_opportunita_kanban\" ng-submit=\"rc.searchKanban()\" novalidate>\n          <div class=\"aside-header\">\n            <button type=\"button\" class=\"close\" ng-click=\"$hide()\">&times;</button>\n            <h4 class=\"aside-title\">Filtri</h4>\n          </div>\n\n          <div class=\"aside-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Da</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"rc.sr.dataFrom\" name=\"dataFrom\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>A</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"rc.sr.dataTo\" name=\"dataTo\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Data installazione (da)</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"rc.sr.dataInizioInstallazione\" name=\"dataInizioInstallazione\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Data installazione (a)</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"rc.sr.dataFineInstallazione\" name=\"dataFineInstallazione\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <strong>Assegnatario</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in rc.formData.soggetti | orderBy:\'cognome\'\"\n                ng-model=\"rc.sr[\'soggetti[]\']\" name=\"soggetto\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Categoria</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.value as el.label for el in rc.formData.categorie | orderBy:\'label\'\"\n                ng-model=\"rc.sr[\'categorie[]\']\" name=\"categorie\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Pista</strong><br>\n              <select class=\"form-control\"\n                ng-options=\"el.value as el.label for el in rc.formData.piste | orderBy:\'label\'\"\n                ng-model=\"rc.sr[\'piste[]\']\" name=\"piste\">\n                <option value=\"\">TUTTE</option>\n              </select>\n            </div>\n            <div class=\"form-group\">\n              <strong>Cliente</strong><br>\n              <input type=\"text\" class=\"form-control\" ng-model=\"rc.sr.cliente\" name=\"cliente\">\n            </div>\n          </div>\n          <div class=\"aside-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-fw fa-filter\"></i> Filtra</button>\n            <button type=\"button\" class=\"btn btn-warning\" ng-click=\"rc.resetKanban()\"><i class=\"fa fa-fw fa-undo\"></i> Resetta</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/promemoria/g1PromBell.tpl.html","<i ng-show=vm.user.flags.gestProm class=\"glyphicon glyphicon-bell notification-icon prom-bell\" data-count={{vm.promemoria.length}} ng-class=\"{\n    \'notification-empty\': vm.promemoria.length <= 0\n  }\" ng-click=vm.bellAction()></i><!-- popover di visualizzazione --><script type=text/ng-template id=promemoria-popover.tpl.html><div class=\"popover prom-popover\" tabindex=\"-1\">\n    <div class=\"arrow\"></div>\n\n    <ul class=\"notifications\">\n      <li class=\"notification\" ng-repeat=\"prom in vm.promemoria | orderBy:\'dataOra\'\">\n        <div class=\"media\">\n          <div class=\"media-left media-middle\">\n            <div class=\"media-object\">\n              <input type=\"checkbox\" ng-model=\"prom.completato\" ng-change=\"vm.setComplete(prom);\">\n            </div>\n          </div>\n\n          <div class=\"media-body\">\n            <span class=\"notification-title\" ng-if=\"!vm.tabella\">\n              <a ng-if=\"prom.tabella && prom.checkId\" ng-click=\"vm.openModal(prom)\" bs-tooltip title=\"apri {{prom.dest}}\">\n                {{prom.titolo}}\n              </a>\n              <span ng-if=\"! ( prom.tabella && prom.checkId )\">\n                {{prom.titolo}}\n              </span>\n            </span>\n\n            <div class=\"notification-desc text-primary\" ng-click=\"vm.showRead(prom)\" bs-tooltip title=\"apri promemoria\">\n              <span>{{prom.note}}</span>\n            </div>\n\n            <div class=\"notification-meta\">\n              {{prom.dataOra | date:\'short\'}}\n              <i class=\"fa fa-envelope\" title=\"Notifica via mail attivata\" ng-if=\"prom.flagMail\"></i>\n            </div>\n          </div>\n        </div>\n      </li>\n      <li class=\"notification\"ng-if=\"vm.promemoria.length == 0\">\n        Nessun promemoria attivo\n      </li>\n    </ul>\n\n    <div class=\"popover-footer\">\n      <button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.showCreate()\">\n        <i class=\"fa fa-fw fa-plus\"></i>&nbsp;Nuovo\n      </button>\n\n      <button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"vm.showSearch()\">\n        <i class=\"fa fa-fw fa-search\"></i>&nbsp;Ricerca\n      </button>\n    </div>\n  </div></script>");
$templateCache.put("app/core/promemoria/promemoria-edit.html","<script type=text/ng-template id=promemoria-edit-modal.tpl.html ng-controller=\"PromemoriaEditController as vm\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"PromemoriaEditForm\" class=\"form-horizontal\" ng-submit=\"vm.saveForm()\" novalidate>\n          <div class=\"modal-header bg-warning\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{vm.promemoria.id ? vm.promemoria.titolo : \'Nuovo promemoria\'}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Scadenza</label>\n              <div class=\"clearfix visible-xs-block\"></div>\n\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Data\"\n                  ng-model=\"vm.promemoria.dataOra\" name=\"data\"\n                  bs-datepicker\n                  data-container=\"form[name=\'PromemoriaEditForm\']\" data-placement=\"bottom-left\"\n                  required>\n              </div>\n\n              <div class=\"col-xs-6 col-sm-5 validate-group has-warning\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Ora\"\n                  ng-model=\"vm.promemoria.dataOra\" name=\"ora\"\n                  bs-timepicker\n                  data-container=\"form[name=\'PromemoriaEditForm\']\" data-placement=\"bottom-right\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Descrizione</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"vm.promemoria.note\" name=\"note\"\n                  required>\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"vm.action === \'update\'\">\n              <div class=\"checkbox col-xs-12 col-sm-offset-2 col-sm-10\">\n                <label>\n                  <input type=\"checkbox\"\n                    ng-model=\"vm.promemoria.completato\" name=\"completato\">\n                  <b>&nbsp;Completato</b>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"checkbox col-xs-12 col-sm-offset-2 col-sm-10\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"vm.promemoria.flagMail\" name=\"flagMail\">\n                  <b>&nbsp;Notifica via mail</b>\n                </label>\n                <i class=\"fa fa-info-circle text-primary\" title=\"Informazioni\"\n                   data-content=\"Se spuntato, il promemoria, verrà inviato nella mail mattutina delle ore 7 che riepiloga tutti i promemoria non ancora completati per quel giorno\"\n                   data-placement=\"bottom\" data-container=\"form[name=\'PromemoriaEditForm\']\" data-auto-close=\"true\"\n                   bs-popover></i>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/promemoria/promemoria-read.html","<script type=text/ng-template id=promemoria-read-modal.tpl.html ng-controller=\"PromemoriaReadController as vm\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-warning\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-10 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{vm.promemoria.titolo}}\n            </div>\n\n            <div class=\"col-xs-2 text-right\">\n              <i class=\"fa fa-check text-success\" title=\"Completato\" ng-if=\"vm.promemoria.completato\"></i>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <p>\n            <i class=\"fa fa-calendar\"></i> {{vm.promemoria.dataOra | date:\'shortDate\'}}\n            &nbsp;&nbsp;\n            <i class=\"fa fa-clock-o\"></i> {{vm.promemoria.dataOra | date:\'shortTime\'}}\n          </p>\n\n          <p ng-if=\"vm.promemoria.flagMail\">\n            <i class=\"fa fa-envelope\"></i> Notifica via mail attivata\n          </p>\n\n          <p>\n            <i>{{vm.promemoria.note}}</i>\n          </p>\n        </div>\n\n        <div class=\"modal-footer text-right\">\n          <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.updatePromemoria(vm.promemoria.id)\"><i class=\"fa fa-pencil\"></i> Modifica</button>\n          <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deletePromemoria(vm.promemoria.id)\"><i class=\"fa fa-minus\"></i> Elimina</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/promemoria/promemoria.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>form[name=\"search_promemoria\"] label.control-label {\n    text-align: left;\n  }</style><div class=container-fluid><form role=form name=search_promemoria class=form-horizontal ng-submit=vm.search()><div class=row><div class=col-sm-5><div class=form-group><label class=\"control-label col-xs-3\">Scadenza</label><div class=col-xs-4><input type=text placeholder=DA class=form-control ng-model=vm.sp.fromData name=fromData bs-datepicker data-max-date={{vm.sp.toData}}></div><div class=\"col-xs-offset-1 col-xs-4\"><input type=text placeholder=A class=form-control ng-model=vm.sp.toData name=toData bs-datepicker data-placement=bottom-right data-min-date={{vm.sp.fromData}}></div></div></div><div class=col-sm-5><div class=form-group><label class=\"control-label col-xs-3\">Descrizione</label><div class=col-xs-9><input type=text class=form-control ng-model=vm.sp.note name=note></div></div></div></div><div class=row><div class=col-sm-5><div class=form-group><label class=\"control-label col-xs-3\">Tabella</label><div class=col-xs-9><select class=form-control ng-options=\"el.value as el.label for el in vm.formData.tabelle\" ng-model=vm.sp.tabella name=tabella></select></div></div></div><div class=col-sm-5><div class=form-group><label class=\"control-label col-xs-3\">Completato</label><div class=col-xs-4><select class=form-control ng-model=vm.sp.completato name=completato><option value=-1>TUTTI</option><option value=0>NO</option><option value=1>SI</option></select></div></div></div><div class=\"col-sm-2 text-right\"><button type=reset class=\"btn btn-warning\" title=Resetta ng-click=vm.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><div class=g1-panel ng-if=vm.dtPromemoria.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=::vm.dtPromemoria.dtOptions dt-columns=::vm.dtPromemoria.dtColumns dt-instance=vm.dtPromemoria.dtInstance class=\"table table-hover\"></table></div></div></div><br></div>");
$templateCache.put("app/core/reports/report.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><script type=text/ng-template id=info-popover-report.tpl.html><div class=\"popover\" tabindex=\"-1\" style=\"max-width: inherit\">\n    <div class=\"arrow\"></div>\n    <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n    <div class=\"popover-content\" ng-bind=\"content\"></div>\n  </div></script><div class=\"container-fluid g1-panel\" style=\"width: 99%\"><h2 class=page-header><a ng-click=report.historyBack() title=\"Torna a reports\"><i class=\"fa fa-arrow-left fa-fw\"></i></a> {{report.descrizione}} <i ng-if=report.info class=\"fa fa-info-circle text-primary\" data-template-url=info-popover-report.tpl.html data-content={{report.info}} data-placement=bottom data-container=.page-header data-auto-close=true bs-popover></i><br><small style=\"margin-left: 15px\">{{report.sottotitolo}}</small></h2><form role=form name=search_reports class=form-inline><div class=row><div class=col-xs-12><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.intervallo.from><label class=control-label>Da</label><input type=text class=form-control placeholder=gg/mm/aaaa size=10 ng-model=report.sr.dataFrom name=dataFrom bs-datepicker data-max-date={{report.sr.dataTo}}></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.intervallo.to><label class=control-label>A</label><input type=text class=form-control placeholder=gg/mm/aaaa size=10 ng-model=report.sr.dataTo name=dataTo bs-datepicker data-min-date={{report.sr.dataFrom}}></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.tipiData><select class=form-control title=\"Data su cui agisce il filtro\" ng-options=\"el.value as el.label for el in report.formData.tipiData\" ng-model=report.sr.tipoData name=tipoData></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.anni><label class=control-label>Anno</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.anni\" ng-model=report.sr.anno name=anno></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.tipi><fieldset ng-disabled=report.sr.tipoDisabled><label>Tipo</label><div class=btn-group ng-model=report.sr.tipo bs-radio-group><label class=\"btn btn-default\" ng-repeat=\"(tipo, descrizione) in report.formData.tipi\"><input type=radio name=tipo class=\"btn btn-default\" ng-value=tipo ng-change=report.search()> {{descrizione}}</label></div><!--\n            <label class=\"radio-inline\" ng-repeat=\"(tipo, descrizione) in report.formData.tipi\">\n              <input type=\"radio\" ng-value=\"tipo\"\n                ng-model=\"report.sr.tipo\" name=\"tipo\"\n                ng-change=\"report.search()\"> {{descrizione}}\n            </label>\n            --></fieldset></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.assd><fieldset><label>In assistenza</label><div class=btn-group ng-model=report.sr.ass bs-radio-group><label class=\"btn btn-default\" ng-repeat=\"(ass, descrizione) in report.formData.assd\"><input type=radio name=ass class=\"btn btn-default\" ng-value=ass ng-change=report.search()> {{descrizione}}</label></div></fieldset></div></div></div><br><div class=row><div class=col-xs-12><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.fornitori><label class=control-label>Fornitore</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.fornitori\" ng-model=report.sr.fornitore name=fornitore ng-change=\"report.sr[\'idGruppi[]\'] = [];\" ng-required=report.sr.fornitoreRequired><option value=\"\">TUTTI</option></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.piste><label class=control-label>Pista</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.piste | filter:{fornitore: report.sr.fornitore}:true\" ng-model=report.sr.pista name=pista ng-change=\"report.sr[\'idGruppi[]\'] = [];\" ng-required=report.sr.pistaRequired><option value=\"\">TUTTE</option></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.sottopiste><label class=control-label>Sottopista</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.sottopiste | filter:{fornitore: report.sr.fornitore, pista: report.sr.pista}:true\" ng-model=report.sr.sottopista name=sottopista><option value=\"\">TUTTE</option></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.gruppi><label class=control-label>Gruppi</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idGruppi[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.filtraGruppi(report.formData.gruppi, report.sr.fornitore, report.sr.pista)\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.portafogli><label class=control-label>Cluster</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.portafogli\" ng-model=report.sr.ptf name=ptf></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.statiContratto><label class=control-label>Stati Contratto</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idStatiContratto[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.statiContratto\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.tipoContratto><label class=control-label>Tipo</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.tipiContratto\" ng-model=report.sr.tipoContratto name=tipoContratto></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.selectObsolescenza><label class=control-label>Contratto Obsoleto</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.selectObsolescenza\" ng-model=report.sr.contrattoObsoleto name=contrattoObsoleto></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.conScadenza><label class=control-label>Con Scadenza</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.conScadenza\" ng-model=report.sr.conScadenza name=conScadenza></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.pagamento><label class=control-label>Pagamento</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.pagamento\" ng-model=report.sr.pagamento name=pagamento></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.provvigioneRicorrente><label class=control-label>Provvigione ricorrente</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.provvigioneRicorrente\" ng-model=report.sr.provvigioneRicorrente name=provvigioneRicorrente></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.statiOpportunita><label class=control-label>Stati Opportunità</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idStatiOpportunita[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.statiOpportunita\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.statiPostvendita><label class=control-label>Stati Postvendita</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idStatiPostvendita[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.statiPostvendita\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.categoriePostvendita><label class=control-label>Categorie Postvendita</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idCategoriePostvendita[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.categoriePostvendita\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.sediCliente><label class=control-label>In Sede Cliente</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.sediCliente\" ng-model=report.sr.sedeCliente name=sedeCliente><option value=\"\">TUTTI</option></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.fonti><label class=control-label>Fonti</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idFonti[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.fonti\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.tipiSoggetto><label class=control-label>Tipo Soggetto</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.tipiSoggetto\" ng-model=report.sr.tipoSoggetto name=tipoSoggetto></select></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.agenti><label class=control-label>Agenti</label><button type=button class=\"form-control btn btn-default btn-sm\" ng-model=\"report.sr[\'idAgenti[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_reports\']\" bs-options=\"el.value as el.label for el in report.formData.agenti\">Action <span class=caret></span></button></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.gbs><fieldset ng-disabled=report.sr.gbDisabled><label>Stato</label><div class=btn-group ng-model=report.sr.gb bs-radio-group><label class=\"btn btn-default\" ng-repeat=\"(gb, descrizione) in report.formData.gbs\"><input type=radio name=gb class=\"btn btn-default\" bs-tooltip data-title=\"Incolonnato per {{descrizione}}\" ng-value=gb ng-change=report.search()> {{descrizione}}</label></div></fieldset></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.grd><fieldset><label>Raggruppamento</label><div class=btn-group ng-model=report.sr.gr bs-radio-group><label class=\"btn btn-default\" ng-repeat=\"(gr, descrizione) in report.formData.grd\"><input type=radio name=gr class=\"btn btn-default\" ng-value=gr ng-change=report.search()> {{descrizione}}</label></div></fieldset></div><div class=\"form-group input-group-sm spacer-1-right\" ng-if=report.formData.valoreProvvigioni><label class=control-label>Valore provvigioni</label><select class=form-control ng-options=\"el.value as el.label for el in report.formData.valoreProvvigioni\" ng-model=report.sr.valoreProvvigioni name=valoreProvvigioni></select></div><div class=\"form-group text-right pull-right\" style=\"white-space: nowrap\"><button type=submit class=\"btn btn-primary\" ng-attr-title=\"{{report.sr.r ? \'dettaglio report non disponibile\' : \'Scarica dettaglio report\'}}\" ng-disabled=report.sr.r ng-click=\"search_reports.$valid && report.export()\"><i class=\"fa fa-fw fa-floppy-o\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-warning\" title=Resetta ng-click=report.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span style=\"margin-right: 1em\"></span> <button type=submit class=\"btn btn-info\" title=Esegui ng-click=\"search_reports.$valid && report.search()\"><i class=\"fa fa-fw fa-search\"></i></button></div></div></div></form><div class=row><div class=\"col-xs-12 text-center\"><h4><i class=\"fa fa-arrow-left fa-fw\" ng-if=\"report.sr.l > 0\" ng-click=report.levelUp()></i> {{report.sr.rd}}{{report.sr.cd ? (\' - \' + report.sr.cd) : \'\'}}</h4></div></div><div class=row><div class=\"col-xs-12 table-responsive\" ng-if=report.dtReport.show><table datatable dt-options=report.dtReport.dtOptions dt-columns=report.dtReport.dtColumns dt-instance=report.dtReport.dtInstance class=\"table table-hover table-condensed\"><tfoot><tr></tr></tfoot></table></div></div></div>");
$templateCache.put("app/core/reports/report.tpl.html","<style type=text/css>.table-no-margin {\n    margin-bottom: 0 !important;\n  }</style><div ng-if=dtReport.show><table datatable dt-options=dtReport.dtOptions dt-columns=dtReport.dtColumns dt-instance=dtReport.dtInstance class=\"table table-hover table-condensed table-no-margin\"><tfoot><tr></tr></tfoot></table></div>");
$templateCache.put("app/core/reports/reports.html","<div class=container-fluid><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 flex-col margin-bottom\" ng-repeat=\"(cat, reps) in reports.categorie\"><div class=g1-panel><h2><strong>{{cat}}</strong></h2><div class=list-group><a class=list-group-item ng-repeat=\"rep in reps\" ng-href={{reports.getLink(rep)}}><b>{{rep.descrizione}}</b></a></div></div></div></div></div>");
$templateCache.put("app/core/ricerca/pv.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><h1 class=text-primary>Ricerca Ticket</h1><form role=form name=search_pv class=search-form><div class=row><div class=col-md-3><h5 class=section-title><i class=\"fa fa-fw fa-user\"></i> Cliente</h5><div class=section-content><div class=row><div class=col-sm-6><div class=form-group><strong>ID</strong><br><input type=text class=\"form-control input-id\" ng-model=rpc.sp.idCliente name=idCliente></div></div><div class=col-sm-6><div class=form-group><strong>Ptf 4</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'idPortafoglio4[]\']\" bs-select data-multiple=1 data-max-length=1 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.portafoglio4 | orderBy:\'label\'\">Action <span class=caret></span></button></div></div></div></div></div><div class=col-md-9><h5 class=section-title><i class=\"fa fa-fw fa-search\"></i> Ricerca testuale</h5><div class=section-content><div class=row><div class=col-sm-7><div class=form-group><strong>Descrizione</strong><br><input type=text class=form-control ng-model=rpc.sp.descrizioneTicket name=descrizioneTicket></div></div><div class=col-sm-5><div class=form-group><strong>Cerca in</strong><br><div class=btn-group ng-model=rpc.sp.cercaIn bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'pv\'\"> Ticket</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'attivita\'\"> Attività</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'\'\"> Tutti</label></div></div></div></div></div></div></div><h5 class=section-title><i class=\"fa fa-fw fa-ticket\"></i> Ticket</h5><div class=section-content><div class=row><div class=\"col-lg-3 col-sm-12\"><div class=form-group><strong>Codice</strong><br><input type=text class=\"form-control input-id\" ng-model=rpc.sp.codice name=codice></div></div><div class=\"col-lg-3 col-sm-6\"><div class=form-group><strong>Apertura</strong><br><div class=date-range><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Apertura dal\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=dal ng-model=rpc.sp.dataFrom name=dataFrom bs-datepicker data-placement=bottom-right data-max-date={{rpc.sp.dataTo}}></div><span class=date-range-sep>–</span><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Apertura al\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=al ng-model=rpc.sp.dataTo name=dataTo bs-datepicker data-placement=bottom-right data-min-date={{rpc.sp.dataFrom}}></div></div></div></div><div class=\"col-lg-3 col-sm-6\"><div class=form-group><strong>Installazione</strong><br><div class=date-range><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Installazione dal\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=dal ng-model=rpc.sp.dataInizioInstallazione name=dataInizioInstallazione bs-datepicker data-placement=bottom-right data-max-date={{rpc.sp.dataFineInstallazione}}></div><span class=date-range-sep>–</span><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Installazione al\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=al ng-model=rpc.sp.dataFineInstallazione name=dataFineInstallazione bs-datepicker data-placement=bottom-right data-min-date={{rpc.sp.dataInizioInstallazione}}></div></div></div></div></div><div class=row><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Stato</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'stati[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.stati | orderBy:\'label\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Fase</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'idStages[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.stages | orderBy:\'ordinamento\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Urgenza</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'priorita[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.priorita | orderBy:\'label\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Assegnatario</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'soggetti[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in rpc.formData.soggetti | orderBy:\'cognome\'\">Action <span class=caret></span></button></div></div></div><div class=row><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Categoria</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'categorie[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.categorie | orderBy:\'label\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Fornitore</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'fornitori[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.fornitori | orderBy:\'label\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-4 col-xs-6\"><div class=form-group><strong>Pista</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'piste[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.value as el.label for el in rpc.formData.piste | orderBy:\'label\'\">Action <span class=caret></span></button></div></div></div><div class=row><div class=\"col-md-3 col-sm-6\"><div class=form-group><strong>Tipo</strong><br><div class=btn-group ng-model=rpc.sp.realizzativo bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=false> Ticket</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=true> Realizzazione</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\"> Tutti</label></div></div></div><div class=\"col-md-3 col-sm-6\"><div class=form-group><strong>Contratto</strong><br><div class=btn-group ng-model=rpc.sp.inAssistenza bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=false> A pagamento</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=true> In assistenza</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\"> Tutti</label></div></div></div><div class=\"col-md-3 col-sm-6\"><div class=form-group><strong>Fatturato</strong><br><div class=btn-group ng-model=rpc.sp.fatturato bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=true> Sì</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=false> No</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\"> Tutti</label></div></div></div></div></div><h5 class=section-title><i class=\"fa fa-fw fa-wrench\"></i> Attività</h5><div class=section-content><div class=row><div class=\"col-md-3 col-sm-12\"><div class=form-group><strong>Periodo</strong><br><div class=date-range><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Attività dal\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=dal ng-model=rpc.sp.dataAttivitaFrom name=dataAttivitaFrom bs-datepicker data-placement=bottom-right data-max-date={{rpc.sp.dataAttivitaTo}}></div><span class=date-range-sep>–</span><div class=input-group><span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Attività al\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=al ng-model=rpc.sp.dataAttivitaTo name=dataAttivitaTo bs-datepicker data-placement=bottom-right data-min-date={{rpc.sp.dataAttivitaFrom}}></div></div></div></div><div class=\"col-md-3 col-sm-6\"><div class=form-group><strong>Assegnatario</strong><br><button type=button class=\"btn btn-default\" ng-model=\"rpc.sp[\'soggetti_attivita[]\']\" bs-select data-multiple=1 data-max-length=2 data-all-none-buttons=1 data-container=\"form[name=\'search_pv\']\" bs-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in rpc.formData.soggetti | orderBy:\'cognome\'\">Action <span class=caret></span></button></div></div><div class=\"col-md-3 col-sm-12\"><div class=form-group><strong>In sede</strong><br><div class=btn-group ng-model=rpc.sp.inSede bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=false> Da remoto</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=true> Presso cliente</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'\'\"> Tutti</label></div></div></div></div></div><div class=search-actions><div class=search-output><strong>Mostra risultati per</strong><div class=btn-group ng-model=rpc.sp.tipoOutput bs-radio-group><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'cliente\'\"> Cliente</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'pv\'\"> Ticket</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'attivita\'\"> Attività</label></div></div><div class=search-buttons><a class=\"btn btn-info\" href=/#/pv>Elenco Ticket</a> <button type=reset class=\"btn btn-default\" title=Resetta ng-click=rpc.resetForm()><i class=\"fa fa-fw fa-undo\"></i> Reset</button> <button type=submit class=\"btn btn-primary\" title=Cerca ng-click=rpc.search()><i class=\"fa fa-fw fa-search\"></i> Cerca</button></div></div></form><div class=row><div class=col-xs-12 style=\"margin-top: 15px\"><g1-alerts data-status={{rpc.alerts.status}} data-messages=rpc.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=\"rpc.showResults&&rpc.tipoOutput==\'pv\'\"><div class=g1-panel-container><h2>Risultati <span class=badge>{{rpc.dtPv.count}}</span></h2><div class=table-responsive><table datatable dt-options=::rpc.dtPv.dtOptions dt-columns=::rpc.dtPv.dtColumns dt-instance=rpc.dtPv.dtInstance class=\"table table-hover\"></table></div></div></div><div class=g1-panel ng-if=\"rpc.showResults&&rpc.tipoOutput==\'cliente\'\"><div class=g1-panel-container><h2>Risultati <span class=badge>{{rpc.dtCliente.count}}</span></h2><div class=table-responsive><table datatable dt-options=::rpc.dtCliente.dtOptions dt-columns=::rpc.dtCliente.dtColumns dt-instance=rpc.dtCliente.dtInstance class=\"table table-hover\"></table></div></div></div><div class=g1-panel ng-if=\"rpc.showResults&&rpc.tipoOutput==\'attivita\'\"><div class=g1-panel-container><h2>Risultati <span class=badge>{{rpc.dtAttivita.count}}</span></h2><div class=table-responsive><table datatable dt-options=::rpc.dtAttivita.dtOptions dt-columns=::rpc.dtAttivita.dtColumns dt-instance=rpc.dtAttivita.dtInstance class=\"table table-hover\"></table></div></div></div></div>");
$templateCache.put("app/core/shared/403.html","<div class=container-fluid><div class=\"jumbotron text-center\"><h1>Ehi!</h1><p>403 - Tu non dovresti essere qui... Accesso non autorizzato!</p></div></div>");
$templateCache.put("app/core/shared/404.html","<div class=container-fluid><div class=\"jumbotron text-center\"><h1>Ooops!</h1><p>404 - Pagina non esistente</p></div></div>");
$templateCache.put("app/core/shared/assegna-pv.html","<script type=text/ng-template id=assegnaPv.tpl.html ng-controller=\"AssegnaPVController as apvc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"assegnaPvModal\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-title\">\n            <h4>\n              <span class=\"margin-right\">\n                <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n              </span>\n              Conferma richiesta\n            </h4>\n          </div>\n        </div>\n        <div class=\"modal-body\">\n          Per modificare la fase del ticket selezionato, è necessario associarlo ad un operatore.\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <select class=\"form-control\"\n                ng-model=\"apvc.idSoggetto\" name=\"idSoggetto\" ng-required>\n                <option value=\"\">Scegli un operatore</option>\n                <option ng-repeat=\"el in apvc.formData.soggetti\" ng-value=\"{{el.idSoggetto}}\">\n                  {{el.cognome}} {{el.nome}}\n                </option>\n              </select>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer text-right\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"apvc.saveForm()\"><i class=\"fa fa-check\"></i> Conferma</button>\n          <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/shared/celebrate.html","<style type=text/css>.celebrateContainer {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: -1; /* fix cssnano default z-index rebase */\n    z-index: 10002;\n  }\n\n  .celebrate {\n    font-size: 400px;\n  }\n\n  .celebrate.fa-hand-peace-o {\n    color: green;\n  }\n\n  .celebrate.fa-paw {\n    color: hotpink;\n  }\n\n  .celebrateContainer.ng-hide-remove .celebrate {\n    animation: bounceIn 2.5s;\n  }\n\n  .celebrateContainer.ng-hide-add .celebrate {\n    animation: fadeOut 1s;\n  }</style><div ng-controller=\"CelebrateController as cel\"><div class=\"celebrateContainer animated\" ng-show=cel.showCelebrate><i class=\"celebrate fa\" ng-class=cel.icon></i></div></div>");
$templateCache.put("app/core/shared/confirm.html","<script type=text/ng-template id=confirm.tpl.html ng-controller=\"ConfirmController as cc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"confirmModal\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-title\">\n            <div class=\"pull-left\">\n              <h4>\n                <span class=\"margin-right\">\n                  <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                </span>\n                Conferma richiesta\n              </h4>\n          </div>\n        </div>\n        </div>\n        <div class=\"modal-body\">\n          {{cc.description}}\n        </div>\n        <div class=\"modal-footer text-right\">\n          <button type=\"submit\" class=\"btn btn-success\" ng-click=\"cc.action()\"><i class=\"fa fa-check\"></i> Conferma</button>\n          <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/shared/confirmed-delete.html","<script type=text/ng-template id=confirmed-delete-modal.tpl.html ng-controller=\"ConfirmedDeleteController as cdc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"ConfirmedDeleteForm\" class=\"form-horizontal\" ng-submit=\"cdc.confirmForm()\" novalidate>\n          <div class=\"modal-header bg-danger\">\n            <h4 class=\"modal-title\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                <span>Cancella {{cdc.title}} - {{cdc.id}}</span>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"row\" ng-if=\"cdc.warnings.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{cdc.status}}\" data-messages=\"cdc.warnings\"></g1-alerts>\n              </div>\n            </div>\n\n            <div ng-show=\"cdc.enableDelete\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <h5>Scrivere la parola CONFERMA tutta in maiuscolo nell\'apposito spazio sottostante</h5>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <div class=\"col-xs-12\">\n                  <input type=\"text\" class=\"form-control\" ng-model=\"cdc.conferma\" name=\"conferma\"\n                    required ng-pattern=\"/^CONFERMA$/\"\n                    disable-validation-message\n                    disable-valid-styling=\"false\">\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <div class=\"form-group\">\n              <div class=\"col-xs-12 text-right\">\n                <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"ConfirmedDeleteForm.$invalid\">\n                  <i class=\"fa fa-save\"></i> <span>Procedi</span>\n                </button>\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cdc.undoForm()\">\n                  <i class=\"fa fa-times\"></i> <span>Annulla</span>\n                </button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/shared/confirmed-mail.html","<script type=text/ng-template id=confirmed-mail-modal.tpl.html ng-controller=\"ConfirmedMailController as cmc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n      <div class=\"modal-content\">\n        <form name=\"ConfirmedMailForm\" class=\"form-horizontal dataForm\" ng-submit=\"cmc.confirmForm()\" novalidate>\n          <div class=\"modal-header bg-info\">\n            <h4 class=\"modal-title\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                <span>Invia {{cmc.title}}</span>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">A</label>\n\n              <div class=\"col-sm-10\" ng-if=\"cmc.indirizzi.length <= 0\">\n                <input type=\"email\" class=\"form-control\"\n                  ng-model=\"cmc.mail.indirizzo\" name=\"indirizzo\"\n                  required>\n              </div>\n\n              <div class=\"col-sm-10\" ng-if=\"cmc.indirizzi.length > 0\">\n                <select class=\"form-control\"\n                  ng-options=\"el.label as el.label for el in cmc.indirizzi\"\n                  ng-model=\"cmc.mail.indirizzo\" name=\"indirizzo\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">CC</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"cmc.mail.cc\" name=\"cc\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Oggetto</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"cmc.mail.oggetto\" name=\"oggetto\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Testo</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"10\" class=\"form-control\"\n                  ng-model=\"cmc.mail.testo\" name=\"testo\"\n                  required>\n                </textarea>\n              </div>\n            </div>\n\n            <!-- MODELLI -->\n            <div class=\"form-group\" ng-if=\"cmc.modelli.length > 0\">\n              <label class=\"control-label col-sm-2\">Allegato</label>\n\n              <div class=\"col-sm-10\">\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in cmc.modelli\"\n                  ng-model=\"cmc.mail.idModello\" name=\"idModello\"\n                  required>\n                </select>\n              </div>\n            </div>\n\n            <!-- ALLEGATI -->\n            <div class=\"form-group\" ng-if=\"cmc.allegati.length > 0\">\n              <label class=\"control-label col-sm-2\">Allegati</label>\n\n              <div class=\"col-sm-10\">\n                <button type=\"button\" class=\"btn btn-default\"\n                  ng-model=\"cmc.mail[\'idAllegati[]\']\"\n                  bs-select data-multiple=\"1\" data-max-length=\"2\" data-all-none-buttons=\"1\"\n                  data-container=\"form[name=\'ConfirmedMailForm\']\"\n                  bs-options=\"el.value as el.label for el in cmc.allegati\">\n                  Action <span class=\"caret\"></span>\n                </button>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"cmc.warnings.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{cmc.status}}\" data-messages=\"cmc.warnings\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <div class=\"form-group\">\n              <div class=\"col-xs-12 text-right\">\n                <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"ConfirmedMailForm.$invalid\"><i class=\"fa fa-mail-forward\"></i> Invia</button>\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cmc.undoForm()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/shared/error-messages.html","<div ng-message=required>Campo Richiesto</div><div ng-message=email>Email non valida</div>");
$templateCache.put("app/core/shared/modals.html","<div ng-include=\"\'app/core/shared/confirm.html\'\"></div><div ng-include=\"\'app/core/shared/confirmed-delete.html\'\"></div><div ng-include=\"\'app/core/shared/confirmed-mail.html\'\"></div><div ng-include=\"\'app/core/shared/celebrate.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/appuntamenti-modal.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/appuntamento.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/appuntamento-create.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/appuntamento-update.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/check-distances.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/privati/appuntamento-privato.html\'\"></div><div ng-include=\"\'app/core/appuntamenti/privati/appuntamento-privato-edit.html\'\"></div><div ng-include=\"\'app/core/clienti/cliente.html\'\"></div><div ng-include=\"\'app/core/clienti/cliente-edit.html\'\"></div><div ng-include=\"\'app/core/clienti/dato-cliente.html\'\"></div><div ng-include=\"\'app/core/clienti/dato-cliente-edit.html\'\"></div><div ng-include=\"\'app/core/clienti/referente-edit.html\'\"></div><div ng-include=\"\'app/core/clienti/sede-edit.html\'\"></div><div ng-include=\"\'app/core/contratti/contratti-modal.html\'\"></div><div ng-include=\"\'app/core/contratti/contratto.html\'\"></div><div ng-include=\"\'app/core/contratti/contratto-create.html\'\"></div><div ng-include=\"\'app/core/contratti/contratto-update.html\'\"></div><div ng-include=\"\'app/core/telefonate/telefonate.html\'\"></div><div ng-include=\"\'app/core/telefonate/telefonata.html\'\"></div><div ng-include=\"\'app/core/telefonate/telefonata-create.html\'\"></div><div ng-include=\"\'app/core/telefonate/telefonata-update.html\'\"></div><div ng-include=\"\'app/core/pv/pv-read.html\'\"></div><div ng-include=\"\'app/core/pv/pv-edit.html\'\"></div><div ng-include=\"\'app/core/pv/invia-notifica.html\'\"></div><div ng-include=\"\'app/core/prodotti/prodotti.html\'\"></div><div ng-include=\"\'app/core/opportunita/opportunita-read.html\'\"></div><div ng-include=\"\'app/core/opportunita/opportunita-edit.html\'\"></div><div ng-include=\"\'app/core/opportunita/progetti/progetto-read.html\'\"></div><div ng-include=\"\'app/core/opportunita/progetti/progetto-edit.html\'\"></div><div ng-include=\"\'app/core/opportunita/opportunita-edit-segnalatore.html\'\"></div><div ng-include=\"\'app/core/opportunita/attivita/opportunita-attivita.html\'\"></div><div ng-include=\"\'app/core/opportunita/conferma-avanzamento-fase.html\'\"></div><div ng-include=\"\'app/core/allegati/allegato-edit.html\'\"></div><div ng-include=\"\'app/core/promemoria/promemoria-read.html\'\"></div><div ng-include=\"\'app/core/promemoria/promemoria-edit.html\'\"></div><!-- COORD --><div ng-include=\"\'app/coord/elenchi/elenco-create.html\'\"></div><div ng-include=\"\'app/coord/elenchi/elenco-update.html\'\"></div><div ng-include=\"\'app/coord/elenchi/telefonate-elenco.html\'\"></div><div ng-include=\"\'app/core/liste/clienti-lista.html\'\"></div><div ng-include=\"\'app/core/liste/lista-import.html\'\"></div><div ng-include=\"\'app/core/liste/lista-create.html\'\"></div><div ng-include=\"\'app/core/liste/lista-update.html\'\"></div><div ng-include=\"\'app/core/liste/lista-manage.html\'\"></div><div ng-include=\"\'app/core/liste/lista-assign.html\'\"></div><div ng-include=\"\'app/core/liste/lista-remove.html\'\"></div><div ng-include=\"\'app/core/liste/lista-move.html\'\"></div><div ng-include=\"\'app/core/operatori/liste-operatore.html\'\"></div><div ng-include=\"\'app/core/pv/rapportini/rapportino-create.html\'\"></div><div ng-include=\"\'app/core/pv/rapportini/firma.html\'\"></div><!-- AGENTI --><!-- probabilmente queste modal sono tutte dismesse --><div ng-include=\"\'app/agenti/clienti/cliente-agente.html\'\"></div><div ng-include=\"\'app/agenti/appuntamenti/appuntamento-esita.html\'\"></div><div ng-include=\"\'app/agenti/appuntamenti/appuntamento-edit-agente.html\'\"></div><div ng-include=\"\'app/agenti/appuntamenti/appuntamento-update-contatti.html\'\"></div><div ng-include=\"\'app/core/shared/assegna-pv.html\'\"></div>");
$templateCache.put("app/core/telefonate/telefonata-create.html","<script type=text/ng-template id=telefonata-create-modal.tpl.html ng-controller=\"TelefonataCreateController as tcc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"TelefonataCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"tcc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-4 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                Nuova Telefonata<br>\n                {{tcc.telefonata.dataOra | date:\'short\'}}\n              </div>\n              <div class=\"col-xs-4 text-center\">\n                {{tcc.cliente.ragSoc}}\n              </div>\n              <div class=\"col-xs-4 text-right\">\n                {{(tcc.formData.operatori | filter:{value: tcc.telefonata.idOperatore}:true)[0].label}}<br>\n                {{(tcc.formData.stati | filter:{value: tcc.telefonata.idStatoTelefonata}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Operatore</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tcc.formData.operatori\"\n                        ng-model=\"tcc.telefonata.idOperatore\" name=\"idOperatore\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Lista</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tcc.formData.liste\"\n                        ng-model=\"tcc.telefonata.idMotivo\" name=\"idMotivo\"\n                        required>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tcc.formData.stati\"\n                        ng-model=\"tcc.telefonata.idStatoTelefonata\" name=\"idStatoTelefonata\"\n                        ng-change=\"tcc.telefonata.idStatoElenco = (tcc.formData.stati | filter:{value: tcc.telefonata.idStatoTelefonata}:true)[0].idStatoElenco\"\n                        required>\n                </select>\n              </div>\n              <div class=\"col-sm-5\">\n                <p class=\"form-control-static\">{{(tcc.formData.stati | filter:{value: tcc.telefonata.idStatoTelefonata}:true)[0].descrizioneStatoElenco}}</p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"tcc.telefonata.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"tcc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/telefonate/telefonata-update.html","<script type=text/ng-template id=telefonata-update-modal.tpl.html ng-controller=\"TelefonataUpdateController as tuc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"TelefonataUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"tuc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-3 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{tuc.telefonata.dataOra | date:\'short\'}}\n              </div>\n              <div class=\"col-xs-6 text-center\">\n                {{tuc.telefonata.cliente}}\n              </div>\n              <div class=\"col-xs-3 text-right\">\n                {{tuc.telefonata.operatore}}<br>\n                {{(tuc.formData.stati | filter:{value: tuc.telefonata.idStatoTelefonata}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Stato</label>\n              <div class=\"col-sm-5 has-warning\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in tuc.formData.stati\"\n                        ng-model=\"tuc.telefonata.idStatoTelefonata\" name=\"idStatoTelefonata\"\n                        ng-change=\"tuc.telefonata.idStatoElenco = (tuc.formData.stati | filter:{value: tuc.telefonata.idStatoTelefonata}:true)[0].idStatoElenco\"\n                        required>\n                  <option value=\"0\"></option>\n                </select>\n              </div>\n              <div class=\"col-sm-5\">\n                <p class=\"form-control-static\">{{(tuc.formData.stati | filter:{value: tuc.telefonata.idStatoTelefonata}:true)[0].descrizioneStatoElenco}}</p>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                          ng-model=\"tuc.telefonata.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"tuc.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/telefonate/telefonata.html","<script type=text/ng-template id=telefonata-modal.tpl.html ng-controller=\"TelefonataController as telefonata\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-3 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{telefonata.telefonata.dataOra | date:\'short\'}}\n            </div>\n            <div class=\"col-xs-6 text-center\">\n              {{telefonata.telefonata.cliente}}\n            </div>\n            <div class=\"col-xs-3 text-right\">\n              {{telefonata.telefonata.operatore}}<br>\n              {{telefonata.telefonata.stato}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-2 col-md-4 text-right\">\n              <label>Note:</label>\n            </div>\n            <div class=\"col-xs-10 col-md-8 text-left\">\n              <span>{{telefonata.telefonata.note}}</span>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 col-md-4 text-right\">\n              <label>Data/Ora Richiamo:</label>\n            </div>\n            <div class=\"col-xs-10 col-md-8 text-left\">\n              <span>{{telefonata.telefonata.dataRichiamo | date:\'shortDate\'}}&nbsp;{{telefonata.telefonata.oraRichiamo | date:\'shortTime\'}}</span>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-2 col-md-4 text-right\">\n              <label>Note Richiamo:</label>\n            </div>\n            <div class=\"col-xs-10 col-md-8 text-left\">\n              <span>{{telefonata.telefonata.noteRichiamo}}</span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"telefonata.user.userGroup > 4 && telefonata.user.userGroup < 9\">\n                <small>\n                  Inserito:{{telefonata.telefonata.idUtenteIns}} - {{telefonata.telefonata.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{telefonata.telefonata.idUtenteMod}} - {{telefonata.telefonata.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/telefonate/telefonate.html","<script type=text/ng-template id=telefonate-modal.tpl.html ng-controller=\"TelefonateController as tc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Telefonate\n              {{tc.filtro.operatore ? \' di \' + tc.filtro.operatore : \'\'}}\n              {{tc.filtro.cliente ? \' a \' + tc.filtro.cliente : \'\'}}\n              {{tc.filtro.motivo ? \' in \' + tc.filtro.motivo : \'\'}}\n              {{tc.filtro.statoTelefonata ? \' (\' + tc.filtro.statoTelefonata + \') \': \'\'}}\n              <span ng-if=\"tc.filtro.fromDate || tc.filtro.toDate\">\n                <br>\n                {{tc.filtro.fromDate ? \' dal \' + (tc.filtro.fromDate | date:\'shortDate\'): \'\'}}\n                {{tc.filtro.toDate ? \' al \' + (tc.filtro.toDate | date:\'shortDate\'): \'\'}}\n              </span>\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::tc.dtTelefonate.dtOptions\"\n                     dt-columns=\"::tc.dtTelefonate.dtColumns\"\n                     dt-instance=\"tc.dtTelefonate.dtInstance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/test/test.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><style type=text/css>.kittyContainer {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: -1; /* fix cssnano default z-index rebase */\n    z-index: 10002;\n  }\n\n  .kitty {\n    color: hotpink;\n    font-size: 400px;\n  }\n\n  .kittyContainer.ng-hide-remove .kitty {\n    animation: bounceIn 2.5s;\n  }\n\n  .kittyContainer.ng-hide-add .kitty {\n    animation: fadeOut 1s;\n  }</style><div class=container-fluid><div class=\"kittyContainer animated\" ng-show=test.showKittyPaw><i class=\"kitty fa fa-paw\"></i></div><div class=row><div class=\"col-xs-12 text-center\"><button type=button class=\"btn btn-primary\" ng-click=test.showKitty()>SHOW KITTY</button></div></div><div class=row><div class=\"col-xs-12 text-center\"><button type=button class=\"btn btn-primary\">LOGIN</button></div></div><pre>{{test | json}}</pre></div>");
$templateCache.put("app/core/utenti/changePassword.html","<script type=text/ng-template id=change-password-modal.tpl.html ng-controller=\"ChangePasswordController as cpc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <form name=\"ChangePasswordForm\" class=\"form-horizontal\" ng-submit=\"cpc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-danger\">\n            <h4 class=\"modal-title\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                <span>Cambia Password di {{cpc.utente.id}}</span>\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-4\">Nuova Password</label>\n              <div class=\"col-sm-8\">\n                <div class=\"input-group\">\n                  <input type=\"password\" class=\"form-control\"\n                    ng-model=\"cpc.utente.newPassword\" name=\"newPassword\"\n                    required>\n                  <span class=\"input-group-addon input-group-addon-icon togglePasswordVisibility\" bs-tooltip data-title=\"Visualizza/nascondi Password\"><i class=\"fa fa-eye\"></i></span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-4\">Ripeti Nuova Password</label>\n              <div class=\"col-sm-8\">\n                <div class=\"input-group\">\n                  <input type=\"password\" class=\"form-control\"\n                    ng-model=\"cpc.utente.newPasswordCheck\" name=\"newPasswordCheck\"\n                    required equal-than=\"cpc.utente.newPassword\">\n                  <span class=\"input-group-addon input-group-addon-icon togglePasswordVisibility\" bs-tooltip data-title=\"Visualizza/nascondi Password\"><i class=\"fa fa-eye\"></i></span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"cpc.warnings.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{cpc.status}}\" data-messages=\"cpc.warnings\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <div class=\"form-group\">\n              <div class=\"col-xs-12 text-right\">\n                <button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"ChangePasswordForm.$invalid\">\n                  <i class=\"fa fa-save\"></i> <span>Cambia</span>\n                </button>\n                <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cpc.undoForm()\">\n                  <i class=\"fa fa-times\"></i> <span>Annulla</span>\n                </button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/privati/appuntamento-privato-edit.html","<script type=text/ng-template id=appuntamento-privato-edit-modal.tpl.html ng-controller=\"AppuntamentoPrivatoEditController as aec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"appuntamentoPrivatoCreateForm\" class=\"form-horizontal dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-12\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{aec.appuntamento.id ? \'\' : \'Nuovo Appuntamento\'}}&nbsp;\n                {{aec.appuntamento.data | date:\'shortDate\'}}&nbsp;{{aec.appuntamento.ora | date:\'shortTime\'}}&nbsp;\n                {{aec.appuntamento.dataFine | date:\'shortDate\'}}&nbsp;{{aec.appuntamento.oraFine | date:\'shortTime\'}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\" ng-if=\"!aec.auth.authorize(\'AGENTI\')\">\n              <div class=\"col-xs-12\">\n                <select class=\"form-control\"\n                        ng-options=\"el.value as el.label for el in aec.formData.agenti\"\n                        ng-model=\"aec.appuntamento.idAgente\" name=\"idAgente\"\n                        required>\n                  <option value=\"\"></option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"checkbox col-xs-12\">\n                <label>\n                  <input type=\"checkbox\"\n                         ng-model=\"aec.appuntamento.allDay\" name=\"AllDay\">\n                  <b>&nbsp;Giornata Intera</b>\n                </label>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-4 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aec.appuntamento.data\" name=\"data\"\n                       bs-datepicker data-container=\"form[name=\'appuntamentoPrivatoCreateForm\']\"\n                       data-max-date=\"{{aec.appuntamento.dataFine}}\" required>\n              </div>\n\n              <div class=\"col-xs-2 col-sm-2 validate-group\" ng-if=\"!aec.appuntamento.allDay\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aec.appuntamento.ora\" name=\"ora\"\n                       bs-timepicker data-container=\"form[name=\'appuntamentoPrivatoCreateForm\']\"\n                       required>\n              </div>\n\n              <div class=\"col-xs-2 col-sm-2 validate-group\" ng-if=\"!aec.appuntamento.allDay\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aec.appuntamento.oraFine\" name=\"oraFine\"\n                       bs-timepicker data-container=\"form[name=\'appuntamentoPrivatoCreateForm\']\"\n                       required>\n              </div>\n\n              <div class=\"col-xs-4 col-sm-4 validate-group\">\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"aec.appuntamento.dataFine\" name=\"dataFine\"\n                       bs-datepicker data-container=\"form[name=\'appuntamentoPrivatoCreateForm\']\"\n                       data-min-date=\"{{aec.appuntamento.data}}\" required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-xs-12\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Descrizione\"\n                       ng-model=\"aec.appuntamento.descrizione\" name=\"descrizione\">\n              </div>\n            </div>\n\n            <!-- dettagli opzionali -->\n            <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"true\"\n                 ng-model=\"aec.activePanel\"\n                 bs-collapse data-start-collapsed=\"true\">\n              <div class=\"panel panel-default\">\n                <div class=\"panel-heading clickable\" role=\"tab\" bs-collapse-toggle>\n                  <h4 class=\"panel-title text-center\">\n                    <i class=\"fa fa-fw\" ng-class=\"{\n                      \'fa-caret-down\': aec.activePanel == -1,\n                      \'fa-caret-up\': aec.activePanel == 0\n                    }\"></i>\n                    Dettagli\n                    <i class=\"fa fa-fw\" ng-class=\"{\n                      \'fa-caret-down\': aec.activePanel == -1,\n                      \'fa-caret-up\': aec.activePanel == 0\n                    }\"></i>\n                  </h4>\n                </div>\n\n                <div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target>\n                  <div class=\"panel-body\">\n                    <div class=\"form-group\">\n                      <label class=\"control-label col-sm-2\">Citt&agrave;</label>\n\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\"\n                               ng-model=\"aec.appuntamento.citta\" name=\"citta\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label class=\"control-label col-sm-2\">Indirizzo</label>\n\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\"\n                               ng-model=\"aec.appuntamento.indirizzo\" name=\"indirizzo\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label class=\"control-label col-sm-2\">Telefono</label>\n                      <div class=\"col-sm-10 validate-group\">\n                        <input type=\"text\" class=\"form-control\"\n                               ng-model=\"aec.appuntamento.tel\" name=\"tel\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label class=\"control-label col-sm-2\">Note</label>\n                      <div class=\"col-sm-10\">\n                        <textarea rows=\"4\" class=\"form-control\"\n                                  ng-model=\"aec.appuntamento.noteAgente\" name=\"noteAgente\">\n                        </textarea>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"aec.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{aec.alerts.status}}\" data-messages=\"aec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn btn-success\">Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"aec.undoForm()\">Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/appuntamenti/privati/appuntamento-privato.html","<script type=text/ng-template id=appuntamento-privato-modal.tpl.html ng-controller=\"AppuntamentoPrivatoController as appuntamento\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-9 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{appuntamento.appuntamento.data | date:\'shortDate\'}}&nbsp;{{appuntamento.appuntamento.ora | date:\'shortTime\'}}\n              &nbsp;&rightarrow;&nbsp;\n              {{appuntamento.appuntamento.dataFine | date:\'shortDate\'}}&nbsp;{{appuntamento.appuntamento.oraFine | date:\'shortTime\'}}\n            </div>\n\n            <div class=\"col-xs-3 text-right\">\n              <button ng-if=\"appuntamento.azioni.length > 0\"\n                      type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                      bs-dropdown=\"appuntamento.azioni\"\n                      data-placement=\"bottom-right\">\n                Azioni&nbsp;<span class=\"caret\"></span>\n              </button>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\" ng-if=\"appuntamento.appuntamento.cliente\">\n            <div class=\"col-xs-6 text-left text-primary\">\n              <h5>{{appuntamento.appuntamento.cliente}}</h5>\n            </div>\n            <div class=\"col-xs-6 text-right text-primary\"><h5>{{appuntamento.appuntamento.agenti_agente}}</h5></div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.appuntamento.tel\">\n            <div class=\"col-xs-2 text-right\"><label>Tel:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              <span>{{appuntamento.appuntamento.tel}}</span>\n              <a ng-href=\"tel:{{appuntamento.appuntamento.tel}}\" target=\"_blank\" title=\"Telefona\">\n                <i class=\"fa fa-phone fa-fw\" style=\"font-size: 1.2em\"></i>\n              </a>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.appuntamento.indirizzo || appuntamento.appuntamento.citta\">\n            <div class=\"col-xs-2 text-right\"><label>Indirizzo:</label></div>\n            <div class=\"col-xs-10 text-left\">\n              <span ng-if=\"appuntamento.appuntamento.indirizzo\">{{appuntamento.appuntamento.indirizzo}}</span>\n              <span ng-if=\"appuntamento.appuntamento.citta\">{{appuntamento.appuntamento.citta}}&nbsp;</span>\n              <a title=\"Apri mappa\" ng-if=\"appuntamento.appuntamento.indirizzo\" ng-href=\"http://maps.google.com/?q={{(appuntamento.appuntamento.indirizzo + \' \' + appuntamento.appuntamento.citta) | urlEncode}}\" target=\"_blank\">\n                <i class=\"fa fa-map-o\"></i>\n              </a>\n            </div>\n          </div>\n\n          <div class=\"row\" ng-if=\"appuntamento.appuntamento.noteAgente\">\n            <div class=\"col-xs-2 text-right\"><label>Note:</label></div>\n            <div class=\"col-xs-10 text-left\"><span>{{appuntamento.appuntamento.noteAgente}}</span></div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"appuntamento.user.userGroup > 4 && appuntamento.user.userGroup < 9\">\n                <small>\n                  Inserito:{{appuntamento.appuntamento.idUtenteIns}} - {{appuntamento.appuntamento.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{appuntamento.appuntamento.idUtenteMod}} - {{appuntamento.appuntamento.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/attivita/opportunita-attivita-edit.html","<script type=text/ng-template id=opportunita-attivita-edit-modal.tpl.html ng-controller=\"OpportunitaAttivitaEditController as oaec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"OpportunitaAttivitaEditForm\" class=\"dataForm\" ng-submit=\"oaec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{oaec.opportunita_attivita.dataOraAttivita | date:\'short\'}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                {{(oaec.formData.tipi | filter:{value: oaec.opportunita_attivita.idTipo}:true)[0].label}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <label class=\"control-label\">Orario</label>\n                  <div class=\"row\">\n                    <div class=\"col-xs-6\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data attività\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"oaec.opportunita_attivita.dataOraAttivita\" name=\"dataOraAttivita\" required\n                          bs-datepicker>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-6\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora attività\"><i class=\"fa fa-clock-o\"></i></span>\n                        <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraChiusura\"\n                          ng-model=\"oaec.opportunita_attivita.dataOraAttivita\" ng-model-options=\"{allowInvalid: true}\"\n                          bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-md-6\" ng-if=\"oaec.user.flags.gestProg\">\n                  <label class=\"control-label\">Soggetto</label>\n                  <select class=\"form-control\"\n                    ng-options=\"el.value as el.label for el in oaec.formData.soggetti\n                      | orderBy:\'value\'\"\n                    ng-model=\"oaec.opportunita_attivita.idSoggetto\" name=\"idSoggetto\">\n                  </select>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label\">Descrizione</label>\n              <div>\n                <input type=\"text\" class=\"form-control\"\n                  ng-model=\"oaec.opportunita_attivita.descrizione\" name=\"descrizione\"\n                  required>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"control-label\">Note</label>\n              <div>\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"oaec.opportunita_attivita.note\" name=\"note\">\n                </textarea>\n              </div>\n            </div>\n\n            <div class=\"form-group text-center\" ng-if=\"oaec.action === \'create\'\">\n              <button class=\"btn btn-success\" title=\"Aggiungi promemoria\"\n                ng-if=\"!oaec.formData.showPromemoria\"\n                ng-click=\"oaec.togglePromemoria()\">\n                <i class=\"fa fa-plus\"></i>\n                Promemoria\n              </button>\n\n              <button class=\"btn btn-danger\" title=\"Rimuovi promemoria\"\n                ng-if=\"oaec.formData.showPromemoria\"\n                ng-click=\"oaec.togglePromemoria()\">\n                <i class=\"fa fa-minus\"></i>\n                Promemoria\n              </button>\n            </div>\n\n            <div ng-if=\"oaec.formData.showPromemoria\" class=\"border-top row\">\n              <div class=\"col-xs-12 margin-top\">\n                <div class=\"form-group\">\n                  <label class=\"control-label\">Scadenza</label>\n                  <div class=\"row\">\n                    <div class=\"col-xs-3\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data attività\"><i class=\"fa fa-calendar-o\"></i></span>\n                        <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                          ng-model=\"oaec.promemoria.dataOra\" name=\"dataOraAttivita\" required\n                          bs-datepicker>\n                      </div>\n                    </div>\n                    <div class=\"col-xs-9\">\n                      <div class=\"input-group\">\n                        <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora attività\"><i class=\"fa fa-clock-o\"></i></span>\n                        <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraChiusura\"\n                          ng-model=\"oaec.promemoria.dataOra\" ng-model-options=\"{allowInvalid: true}\"\n                          bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label class=\"control-label\">Descrizione</label>\n                  <div>\n                    <textarea rows=\"4\" class=\"form-control\"\n                      ng-model=\"oaec.promemoria.note\" name=\"note\">\n                    </textarea>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <div class=\"checkbox\">\n                    <label>\n                      <input type=\"checkbox\"\n                        ng-model=\"oaec.promemoria.flagMail\" name=\"flagMail\">\n                      <b>&nbsp;Notifica via mail</b>\n                    </label>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/attivita/opportunita-attivita-read.html","<script type=text/ng-template id=opportunita-attivita-read-modal.tpl.html ng-controller=\"OpportunitaAttivitaReadController as oar\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-orange\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-10 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{oar.opportunita_attivita.dataOraAttivita | date:\'short\'}}\n              &nbsp;\n              {{oar.opportunita_attivita.tipo}}\n            </div>\n            <div class=\"col-xs-2 text-right\">\n              <g1-prom-bell\n                tabella=\"opportunita_attivita\"\n                campo-id=\"IDOpportunitaAttivita\"\n                record-id=\"{{oar.opportunita_attivita.id}}\"\n                campo-fk=\"IDOpportunita\">\n              </g1-prom-bell>\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"margin-top margin-bottom\">\n            <label class=\"no-margin-bottom\">Soggetto</label><br>\n            {{oar.opportunita_attivita.soggetto}}\n          </div>\n          <div class=\"margin-top margin-bottom\">\n            <label class=\"no-margin-bottom\">Descrizione</label><br>\n            {{oar.opportunita_attivita.descrizione}}\n          </div>\n          <div class=\"margin-top margin-bottom\">\n            <label class=\"no-margin-bottom\">Note</label><br>\n            <span style=\"white-space: pre-line;\" ng-bind-html=\"oar.opportunita_attivita.note\"></span>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"oar.user.userGroup > 4 && oar.user.userGroup < 9\">\n                <small>\n                  Inserito:{{oar.opportunita_attivita.idUtenteIns}} - {{oar.opportunita_attivita.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato:{{oar.opportunita_attivita.idUtenteMod}} - {{oar.opportunita_attivita.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/attivita/opportunita-attivita.html","<script type=text/ng-template id=opportunita-attivita-modal.tpl.html ng-controller=\"OpportunitaAttivitaModalController as oamc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-orange\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-12\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Attività opportunità\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                     dt-options=\"::oamc.dtOpportunitaAttivita.options\"\n                     dt-columns=\"::oamc.dtOpportunitaAttivita.columns\"\n                     dt-instance=\"oamc.dtOpportunitaAttivita.instance\"\n                     class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/logs/opportunita-log-update.html","<script type=text/ng-template id=opportunita-log-update-modal.tpl.html ng-controller=\"OpportunitaLogUpdateController as oluc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"OpportunitaLogUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"oluc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{oluc.opportunita_log.dataOraIns | date:\'short\'}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                {{oluc.opportunita_log.stage}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"oluc.opportunita_log.noteLog\" name=\"noteLog\">\n                </textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/logs/opportunita-log.html","<script type=text/ng-template id=opportunita-log-modal.tpl.html ng-controller=\"OpportunitaLogController as ol\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n         i-draggable i-draggable-handle=\".modal-header\"\n         i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-6 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{ol.opportunita_log.dataOraIns | date:\'short\'}}\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              {{ol.opportunita_log.stage}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Data:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.dataSegnalazione | date:\'shortDate\'}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Cliente:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.cliente}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Fornitore:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.fornitore}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Pista:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.pista}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Agente:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.agentePIC}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Valore:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.valore | currency}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Probabilità:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{(ol.opportunita_log.percChiusura * 100) | number:0}}%</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Data Prev. Chiusura:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.dataChiusura | date:\'shortDate\'}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Pipeline:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.pipeline}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Fase:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.stage}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Stato:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.stato}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Dett. Stato:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.dettSTato}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Fonte:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.fonte}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Segnalatore:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.segnalatore}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Referente:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.referente}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Contatto:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.contatto}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Pass. Succ.:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.passSucc}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Seguimi:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{ol.opportunita_log.seguimi ? \'ATTIVO\' : \'NON ATTIVO\'}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Note Opp.:&nbsp;</label></div>\n            <div class=\"col-xs-8 text-left\"><span>{{ol.opportunita_log.note}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Note Fonte:&nbsp;</label></div>\n            <div class=\"col-xs-8 text-left\"><span>{{ol.opportunita_log.noteFonte}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Note Storico:&nbsp;</label></div>\n            <div class=\"col-xs-8 text-left\"><span>{{ol.opportunita_log.noteLog}}</span></div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/progetti/progetti.html","<div ng-include=\"\'app/core/shared/modals.html\'\"></div><div class=container-fluid><!-- navbar --><div class=row><div class=\"col-xs-12 col-md-3\"><ul class=\"nav nav-pills\"><li role=presentation ng-class=\"{\'active\': opc.activeTab === \'dashboard\'}\"><a href=\"\" ng-show=\"opc.activeTab === \'dashboard\'\" ng-click=opc.showAside() class=inline-block><i class=\"fa fa-fw fa-lg fa-filter\" bs-tooltip data-title=\"Filtri Kanban\"></i> </a><a href=\"\" bs-tooltip data-title=Kanban ng-click=\"opc.activeTab = \'dashboard\'\" class=inline-block><i class=\"fa fa-fw fa-bar-chart fa-flip-vertical\"></i></a></li><li role=presentation ng-class=\"{\'active\': opc.activeTab === \'ricerca\'}\"><a href=\"\" ng-click=\"opc.activeTab = \'ricerca\'\"><i class=\"fa fa-fw fa-bars\" bs-tooltip data-title=Ricerca></i></a></li></ul></div><div class=\"col-xs-12 col-md-6 text-center\" ng-if=\"opc.activeTab === \'dashboard\'\"><div class=vcenter-block><span class=\"badge alert-info\" ng-if=opc.sok.dataRichiestaDa>Richiesta da:&nbsp;{{opc.sok.dataRichiestaDa | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'dataRichiestaDa\')\"></i> </span><span class=\"badge alert-info\" ng-if=opc.sok.dataRichiestaA>Richiesta a:&nbsp;{{opc.sok.dataRichiestaA | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'dataRichiestaA\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.idProgettista > 0 || opc.sok.idProgettista === \'NULL\'\">{{(opc.formData.progettisti | filter:{value: opc.sok.idProgettista}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'idProgettista\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.idStatoProgetto > 0 || opc.sok.idStatoProgetto === \'NULL\'\">{{(opc.formData.statiProgetto | filter:{value:opc.sok.idStatoProgetto.toString()}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'idStatoProgetto\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.idAgentePIC > 0 || opc.sok.idAgentePIC === \'NULL\'\">{{(opc.formData.agentiPIC | filter:{value: opc.sok.idAgentePIC}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'idAgentePIC\')\"></i> </span><span class=\"badge alert-info\" ng-if=opc.sok.pista>{{opc.sok.pista}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'pista\')\"></i> </span><span class=\"badge alert-info\" ng-if=opc.sok.cliente>{{opc.sok.cliente}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'cliente\')\"></i> </span><span class=\"badge alert-info\" ng-if=opc.sok.dataChiusuraDa>Chiusura da:&nbsp;{{opc.sok.dataChiusuraDa | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'dataChiusuraDa\')\"></i> </span><span class=\"badge alert-info\" ng-if=opc.sok.dataChiusuraA>Chiusura a:&nbsp;{{opc.sok.dataChiusuraA | date:\'shortDate\'}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'dataChiusuraA\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.idStage > 0\">{{(opc.formData.stages | filter:{value: opc.sok.idStage}:true)[0].label}}&nbsp; <i class=\"fa fa-times fa-fw close-button\" ng-click=\"opc.unsetFilter(\'idStage\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.valoreDa > 0\">&ge;{{opc.sok.valoreDa * 100}}%&nbsp; <i class=\"fa fa-times fa-fw close-button\" bs-tooltip data-title=Probabilità ng-click=\"opc.unsetFilter(\'valoreDa\')\"></i> </span><span class=\"badge alert-info\" ng-if=\"opc.sok.valoreA > 0\">&le;{{opc.sok.valoreA * 100}}%&nbsp; <i class=\"fa fa-times fa-fw close-button\" bs-tooltip data-title=Probabilità ng-click=\"opc.unsetFilter(\'valoreA\')\"></i> </span><span class=text-nowrap><b>Totale:</b> <span class=badge>{{opc.kanbanTotale}}</span> <span class=vertical-align-bottom>{{opc.kanbanSomma | currency}}</span> </span><span class=\"badge badge-danger\" bs-tooltip data-title=\"Non Assegnati\" ng-if=\"opc.nonAssegnati > 0\n            && (opc.sok.idProgettista === \'NULL\'\n            || opc.sok.idProgettista === \'0\')\" ng-click=opc.toggleNonAssegnati()>{{opc.nonAssegnati}}</span></div></div><div class=\"col-xs-12 col-md-3 text-right\" ng-if=\"opc.activeTab === \'dashboard\'\"><i class=\"fa fa-fw fa-search\" bs-tooltip data-title=\"Ricerca testo in tutti i campi della dashboard\"></i> <input type=text ng-model=opc.kanbanFilter></div></div><!-- kanban --><div class=kanbanContainer ng-show=\"opc.activeTab === \'dashboard\'\"><h2>Progetti</h2><div class=\"kanban row no-gutters\"><div ng-repeat=\"(idStage, stage) in opc.kanban\" class=\"col-xs-12 col-sm-6 col-md-2\" ng-style=\"{width:(100/opc.kanbanStages)+\'%\'}\"><div class=panel><div class=\"panel-heading text-center\" style=\"background-color: {{stage.bgColor}}\"><h3 class=panel-title><b>{{stage.label}}</b><br><span class=badge>{{stage.items.length}}</span> <span class=vertical-align-bottom>&nbsp;{{stage.sommaValore | currency}}</span></h3></div><div class=panel-body><ul class=list-group dnd-list dnd-drop=\"callback({targetList: stage.items, targetIndex: index, targetStage: idStage})\"><li ng-repeat=\"item in stage.items | filter:opc.kanbanFilter\" class=list-group-item dnd-draggable=null dnd-disable-if=\"!opc.checkEditPermission(opc.user, item)\" dnd-callback=\"opc.onDrop(stage.items, $index, idStage, targetList, targetIndex, targetStage)\" dnd-effect-allowed=move><a class=cliente href=\"\" ng-click=opc.readProgetto(item.idProgetto) bs-tooltip data-title=\"Apri progetto\">{{item.cliente}}</a> {{item.dataOraIns | date:\'shortDate\'}}<span ng-if=item.progettista>&nbsp;&nbsp;<i class=\"fa fa-graduation-cap\" bs-tooltip data-title=Progettista></i> {{item.progettista}}</span><br>{{item.pista}}&nbsp;&nbsp;<i class=\"fa fa-handshake-o\" bs-tooltip data-title=Agente></i> {{item.agente}}<br>{{item.faseOpportunita}} - {{item.valore | currency}}</li></ul></div></div></div></div><!-- alerts kanban --><div class=row><div class=\"col-xs-12 margin-top\"><g1-alerts data-status={{opc.alertsK.status}} data-messages=opc.alertsK.messages></g1-alerts></div></div></div><!-- ricerca --><div class=padding-top ng-show=\"opc.activeTab === \'ricerca\'\"><form role=form name=searchProgetto ng-submit=opc.search()><div class=row><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Data richiesta da</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=opc.so.dataRichiestaDa name=dataRichiestaDa bs-datepicker data-placement=bottom-left></div></div><div class=col-xs-6><strong>Data richiesta a</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=opc.so.dataRichiestaA name=dataRichiestaA bs-datepicker data-placement=bottom-left></div></div></div></div></div><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><label>Progettista<br><select class=form-control ng-options=\"el.value as el.label for el in opc.formData.progettisti | orderBy:\'label\'\" ng-model=opc.so.idProgettista name=idProgettista></select></label></div><div class=col-xs-6><label>Agente<br><select class=form-control ng-options=\"el.value as el.label for el in opc.formData.agentiPIC | orderBy:\'label\'\" ng-model=opc.so.idAgentePIC name=idAgentePIC></select></label></div></div></div></div><div class=col-sm-3><div class=form-group><strong>Stato</strong><br><div class=btn-group ng-model=opc.so.idStatoProgetto bs-radio-group><label class=\"btn btn-default\" ng-repeat=\"statoProgetto in opc.formData.statiProgetto\"><input type=radio class=\"btn btn-default\" ng-value=\"\'{{statoProgetto.value}}\'\"> {{statoProgetto.label}}</label><label class=\"btn btn-default\"><input type=radio class=\"btn btn-default\" ng-value=\"\'\'\"> Tutti</label></div></div></div><div class=col-sm-3><div class=form-group><label>Pista<br><select class=form-control ng-options=\"el.value as el.label for el in opc.formData.piste | orderBy:\'label\'\" ng-model=opc.so.pista name=pista><option value=\"\">TUTTE</option></select></label></div></div><div class=col-sm-3><div class=form-group><label>Cliente<br><input type=text class=form-control ng-model=opc.so.cliente name=cliente></label></div></div><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Data prev. chiusura da</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=opc.so.dataChiusuraDa name=dataChiusuraDa bs-datepicker data-placement=bottom-left></div></div><div class=col-xs-6><strong>Data prev. chiusura a</strong><br><div class=input-group><span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span> <input type=text class=\"form-control input-date\" placeholder=gg/mm/aaaa ng-model=opc.so.dataChiusuraA name=dataChiusuraA bs-datepicker data-placement=bottom-left></div></div></div></div></div><div class=col-sm-3><div class=form-group><label>Fase<br><select class=form-control ng-options=\"el.value as el.label for el in opc.formData.stages | orderBy:\'ordinamento\'\" ng-model=opc.so.idStage name=idStage><option value=\"\">TUTTE</option></select></label></div></div><div class=col-sm-3><div class=form-group><div class=row><div class=col-xs-6><strong>Valore da</strong><div class=validate-group><input type=number class=form-control ng-model=opc.so.valoreDa name=valoreDa decimal precision=0 step=1 min=-1></div></div><div class=col-xs-6><strong>Valore a</strong><div class=validate-group><input type=number class=form-control ng-model=opc.so.valoreA name=valoreA decimal precision=0 step=1 min=-1></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 text-right\"><span class=margin-right></span> <button type=reset class=\"btn btn-warning\" bs-tooltip data-title=Resetta ng-click=opc.resetForm()><i class=\"fa fa-fw fa-undo\"></i></button> <span class=margin-right></span> <button type=submit class=\"btn btn-info\" bs-tooltip data-title=Cerca><i class=\"fa fa-fw fa-search\"></i></button></div></div></form><!-- alerts ricerca --><div class=row><div class=\"col-xs-12 padding-top\"><g1-alerts data-status={{opc.alerts.status}} data-messages=opc.alerts.messages></g1-alerts></div></div><div class=g1-panel ng-if=opc.dt.show><div class=row><div class=\"col-xs-12 table-responsive\"><table datatable dt-options=opc.dt.dtOptions dt-columns=opc.dt.dtColumns dt-instance=opc.dt.dtInstance class=\"table table-hover\"></table></div></div></div></div><br></div><script type=text/ng-template id=dashboard-progetti-aside.tpl.html><div class=\"aside\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"aside-dialog\">\n      <div class=\"aside-content\">\n        <form name=\"search_opportunita_kanban\" ng-submit=\"opc.searchKanban()\" novalidate>\n          <div class=\"aside-header\">\n            <button type=\"button\" class=\"close\" ng-click=\"$hide()\">&times;</button>\n            <h4 class=\"aside-title\">Filtri</h4>\n          </div>\n\n          <div class=\"aside-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-6\">\n                  <strong>Data richiesta da</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"opc.sok.dataRichiestaDa\" name=\"dataRichiestaDa\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n                <div class=\"col-xs-6\">\n                  <strong>Data richiesta a</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"opc.sok.dataRichiestaA\" name=\"dataRichiestaA\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <strong>Stato</strong><br>\n              <div class=\"btn-group\" ng-model=\"opc.sok.idStatoProgetto\" bs-radio-group>\n                <label class=\"btn btn-default\" ng-repeat=\"statoProgetto in opc.formData.statiProgetto\">\n                  <input type=\"radio\" class=\"btn btn-default\" ng-value=\"\'{{statoProgetto.value}}\'\"> {{statoProgetto.label}}\n                </label>\n                <label class=\"btn btn-default\"><input type=\"radio\" class=\"btn btn-default\" ng-value=\"\'\'\"> Tutti</label>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label>\n                Progettista<br>\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opc.formData.progettisti | orderBy:\'label\'\"\n                  ng-model=\"opc.sok.idProgettista\" name=\"idProgettista\">\n                </select>\n              </label>\n            </div>\n            <div class=\"form-group\" >\n              <label>\n                Agente<br>\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opc.formData.agentiPIC | orderBy:\'label\'\"\n                  ng-model=\"opc.sok.idAgentePIC\" name=\"idAgentePIC\">\n                </select>\n              </label>\n            </div>\n            <div class=\"form-group\">\n              <label>\n                Pista<br>\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opc.formData.piste | orderBy:\'label\'\"\n                  ng-model=\"opc.sok.pista\" name=\"pista\">\n                  <option value=\"\">TUTTE</option>\n                </select>\n              </label>\n            </div>\n            <div class=\"form-group\">\n              <label>\n                Cliente<br>\n                <input type=\"text\" class=\"form-control\" ng-model=\"opc.sok.cliente\" name=\"cliente\">\n              </label>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-6\">\n                  <strong>Data prev. chiusura da</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"opc.sok.dataChiusuraDa\" name=\"dataChiusuraDa\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n                <div class=\"col-xs-6\">\n                  <strong>Data prev. chiusura a</strong><br>\n                  <div class=\"input-group\">\n                    <span class=\"input-group-addon input-group-addon-icon\"><i class=\"fa fa-calendar-o\"></i></span>\n                    <input type=\"text\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\"\n                      ng-model=\"opc.sok.dataChiusuraA\" name=\"dataChiusuraA\"\n                      bs-datepicker data-placement=\"bottom-left\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label>\n                Fase<br>\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in opc.formData.stages | orderBy:\'ordinamento\'\"\n                  ng-model=\"opc.sok.idStage\" name=\"idStage\">\n                  <option value=\"\">TUTTE</option>\n                </select>\n              </label>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <div class=\"col-xs-6\">\n                  <strong>Valore da</strong>\n                  <div class=\"validate-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"opc.sok.valoreDa\" name=\"valoreDa\"\n                      decimal precision=\"0\" step=\"1\" min=\"-1\">\n                  </div>\n                </div>\n                <div class=\"col-xs-6\">\n                  <strong>Valore a</strong>\n                  <div class=\"validate-group\">\n                    <input type=\"number\" class=\"form-control\"\n                      ng-model=\"opc.sok.valoreA\" name=\"valoreA\"\n                      decimal precision=\"0\" step=\"1\" min=\"-1\">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"aside-footer\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-fw fa-filter\"></i> Filtra</button>\n            <button type=\"button\" class=\"btn btn-warning\" ng-click=\"opc.resetKanban()\"><i class=\"fa fa-fw fa-undo\"></i> Resetta</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/progetti/progetto-edit.html","<script type=text/ng-template id=progetto-edit-modal.tpl.html ng-controller=\"ProgettoEditController as pec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"progetto-edit-modal\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"ProgettoEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"pec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <div class=\"modal-title\">\n              <h4>Modifica progetto</h4>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-md-6 margin-top validate-group\">\n                <strong>Progettista</strong><br />\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in pec.formData.progettisti\n                    | orderBy:\'value\'\"\n                  ng-model=\"pec.progetto.idProgettista\" name=\"idProgettista\">\n                </select>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-md-6 margin-top validate-group\">\n                <strong>Fase</strong><br />\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in pec.formData.fasi\n                    | orderBy:\'ordinamento\'\"\n                  ng-model=\"pec.progetto.idStage\" name=\"idStage\" required>\n                </select>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-md-6 margin-top validate-group\">\n                <strong>Stato</strong><br />\n                <select class=\"form-control\"\n                  ng-options=\"el.value as el.label for el in pec.formData.statiProgetto\n                    | orderBy:\'value\'\"\n                  ng-model=\"pec.progetto.idStatoProgetto\" name=\"idStatoProgetto\">\n                </select>\n              </div>\n            </div>\n            <div class=\"margin-top validate-group\">\n              <strong>Note</strong><br />\n              <textarea rows=\"6\" class=\"form-control\" ng-model=\"pec.progetto.note\" name=\"note\">\n              </textarea>\n            </div>\n          </div>\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"pec.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/progetti/progetto-read.html","<div ng-include=\"\'app/core/opportunita/progetti/logs/log.html\'\"></div><div ng-include=\"\'app/core/opportunita/progetti/logs/log-update.html\'\"></div><script type=text/ng-template id=progetto-read-modal.tpl.html ng-controller=\"ProgettoReadController as prc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <div class=\"modal-title row\">\n            <h4 class=\"col-xs-9\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              Progetto sull\'<span ng-click=\"prc.readOpportunita(prc.progetto.idOpportunita)\"><u>opportunita</u></span> del\n              {{prc.progetto.dataOpportunita | date:\'shortDate\'}}\n              per <span ng-click=\"prc.readCliente(prc.progetto.idCliente)\"><u>{{prc.progetto.cliente}}</u></span>\n              ({{prc.progetto.statoProgetto}})\n            </h4>\n            <div class=\"col-xs-3 text-right\">\n              <g1-prom-bell\n                tabella=\"progetti\"\n                campo-id=\"IDProgetto\"\n                record-id=\"{{prc.progetto.idProgetto}}\">\n              </g1-prom-bell>\n              <button ng-if=\"prc.azioni.length > 0\"\n                type=\"button\" class=\"btn btn-info btn-xs dropdown-toggle\"\n                bs-dropdown=\"prc.azioni\"\n                data-placement=\"bottom-right\">\n                Azioni&nbsp;<span class=\"caret\"></span>\n              </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"panel panel-default\">\n            <div class=\"panel-heading\">Dati opportunità</div>\n            <div class=\"panel-body\">\n              <div class=\"row\">\n                <div class=\"col-xs-12\">\n                  <strong>Cliente</strong><br>\n                  {{prc.progetto.cliente}}\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Agente</strong><br>\n                  {{prc.progetto.agente}}\n                </div>\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Pista</strong><br>\n                  {{prc.progetto.pista}}\n                </div>\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Data opportunità</strong><br>\n                  {{prc.progetto.dataOpportunita | date:\'shortDate\'}}\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Valore</strong><br>\n                  {{prc.progetto.valore | number:0}}\n                </div>\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Fase</strong><br>\n                  {{prc.progetto.faseOpportunita}}\n                </div>\n                <div class=\"col-xs-12 col-sm-3 margin-top\">\n                  <strong>Data richiesta chiusura</strong><br>\n                  {{prc.progetto.dataChiusura | date:\'shortDate\'}}\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-xs-12 margin-top\">\n                  <strong>Note</strong>\n                  <div ng-bind-html=\"prc.progetto.noteOpportunita | nl2br\"></div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-md-3 margin-top validate-group\">\n              <strong>Progettista</strong><br />\n              <span ng-if=\"prc.progettistaMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                {{prc.progetto.progettista}}\n                <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.progettistaMode=\'edit\';prc.idprogettistaBckp=prc.progetto.idProgettista;\" ng-if=\"prc.progetto.idStatoProgetto!=\'2\'\">\n                  <i class=\"fa fa-pencil\"></i>\n                </button>\n              </span>\n              <span ng-if=\"prc.progettistaMode==\'edit\'\">\n                <select class=\"form-control edit-inplace\"\n                  ng-options=\"el.value as el.label for el in prc.formData.progettisti\n                    | orderBy:\'label\'\"\n                  ng-model=\"prc.progetto.idProgettista\" name=\"idProgettista\">\n                </select>\n                <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.progetto.idProgettista=prc.idProgettistaBckp;prc.progettistaMode=\'view\';\"></i>\n                <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveProgettista()\"></i>\n              </span>\n            </div>\n            <div class=\"col-xs-12 col-md-3 margin-top validate-group\">\n              <strong>Fase</strong><br />\n              <span ng-if=\"prc.faseMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                {{prc.progetto.fase}}\n                <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.faseMode=\'edit\';prc.idFaseBckp=prc.progetto.idFase;\" ng-if=\"prc.progetto.idStatoProgetto!=\'2\'\">\n                  <i class=\"fa fa-pencil\"></i>\n                </button>\n              </span>\n              <span ng-if=\"prc.faseMode==\'edit\'\">\n                <select class=\"form-control edit-inplace\"\n                  ng-options=\"el.value as el.label for el in prc.formData.fasi\n                    | orderBy:\'ordine\'\"\n                  ng-model=\"prc.progetto.idStage\" name=\"idStage\">\n                </select>\n                <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.progetto.idFase=prc.idFaseBckp;prc.faseMode=\'view\';\"></i>\n                <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveFase()\"></i>\n              </span>\n            </div>\n            <div class=\"col-xs-12 col-md-3 margin-top validate-group\">\n              <strong>Stato</strong><br />\n              <span ng-if=\"prc.statoProgettoMode==\'view\'\" class=\"edit-inplace-wrapper\">\n                {{prc.progetto.statoProgetto}}\n                <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"prc.statoProgettoMode=\'edit\';prc.idStatoProgettoBckp=prc.progetto.idStatoProgetto;\" ng-if=\"prc.progetto.idStatoProgetto!=\'2\'\">\n                  <i class=\"fa fa-pencil\"></i>\n                </button>\n              </span>\n              <span ng-if=\"prc.statoProgettoMode==\'edit\'\">\n                <select class=\"form-control edit-inplace\"\n                  ng-options=\"el.value as el.label for el in prc.formData.statiProgetto\n                    | orderBy:\'label\'\"\n                  ng-model=\"prc.progetto.idStatoProgetto\" name=\"idStatoProgetto\">\n                </select>\n                <i class=\"fa fa-undo edit-inplace-actions\" ng-click=\"prc.progetto.idStatoProgetto=prc.idStatoProgettoBckp;prc.statoProgettoMode=\'view\';\"></i>\n                <i class=\"fa fa-save edit-inplace-actions\" ng-click=\"prc.saveStatoProgetto()\"></i>\n              </span>\n            </div>\n            <div class=\"col-xs-12 col-md-3 margin-top\">\n              <strong>Data della richiesta</strong><br />\n              {{prc.progetto.dataOraIns | date: \'shortDate\'}}\n            </div>\n          </div>\n          <div class=\"margin-top validate-group\" ng-if=\"prc.progetto.note!=\'\'\">\n            <strong>Note</strong>\n            <div ng-bind-html=\"prc.progetto.note | nl2br\"></div>\n          </div>\n          <div class=\"row margin-top-xl\">\n            <div class=\"col-sm-6 col-sm-offset-6 hidden-xs\">\n              <div class=\"tabHeaderButtons\">\n                <div ng-if=\"prc.progetto.idStatoProgetto==\'1\'\" class=\"inline-block\">\n                  <button type=\"button\" class=\"btn btn-info btn-xs\" data-trigger=\"click\" bs-dropdown data-placement=\"left\">\n                    <i class=\"fa fa-plus\"></i> Attività\n                  </button>\n                  <ul class=\"dropdown-menu\" role=\"menu\">\n                    <li><a ng-click=\"prc.createAttivita(\'1\')\">Attività generica</a></li>\n                    <li><a ng-click=\"prc.createAttivita(\'3\')\">Telefonata</a></li>\n                    <li><a ng-click=\"prc.createAttivita(\'4\')\">Email</a></li>\n                  </ul>\n                </div>\n                <button\n                  type=\"button\"\n                  class=\"btn btn-info btn-xs\"\n                  bs-tooltip data-title=\"Inserisci allegato\"\n                  ng-if=\"prc.progetto.idStatoProgetto==\'1\'\"\n                  ng-click=\"prc.createAllegato(prc.progetto)\">\n                  <i class=\"fa fa-plus\"></i> Allegato\n                </button>\n              </div>\n            </div>\n            <div class=\"col-xs-12 table-responsive\">\n              <div bs-tabs\n                bs-active-pane=\"prc.activeTab\"\n                ng-init=\"prc.activeTab = 0\">\n\n                <div data-title=\"{{prc.titleAttivita}}\" bs-pane>\n                  <table id=\"progetti_attivita\" datatable\n                    dt-options=\"prc.dtAttivita.options\"\n                    dt-columns=\"prc.dtAttivita.columns\"\n                    dt-instance=\"prc.dtAttivita.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"{{prc.titleAllegati}}\" bs-pane>\n                  <table id=\"progetti_allegati\" datatable\n                    dt-options=\"prc.dtAllegati.options\"\n                    dt-columns=\"prc.dtAllegati.columns\"\n                    dt-instance=\"prc.dtAllegati.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n                <div data-title=\"Storico\" bs-pane>\n                  <table id=\"progetti_logs\" datatable\n                    dt-options=\"prc.dtLogs.options\"\n                    dt-columns=\"prc.dtLogs.columns\"\n                    dt-instance=\"prc.dtLogs.instance\"\n                    class=\"table table-hover\">\n                  </table>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-8 text-left text-muted\">\n              <em ng-if=\"prc.user.userGroup > 4 && prc.user.userGroup < 9\">\n                <small>\n                  Inserito: {{prc.progetto.idUtenteIns}} - {{prc.progetto.dataOraIns | date:\'short\'}}\n                  <br>\n                  Modificato: {{prc.progetto.idUtenteMod}} - {{prc.progetto.dataOraMod | date:\'short\'}}\n                </small>\n              </em>\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/attivita/attivita-edit.html","<script type=text/ng-template id=attivita-pv-edit-modal.tpl.html ng-controller=\"AttivitaEditController as aec\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"AttivitaEditForm\" class=\"dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <div class=\"modal-title\">\n              <div class=\"pull-left\">\n                <h4>\n                  <span class=\"margin-right\">\n                    <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                    {{aec.pv.codice}}\n                  </span>\n                  {{aec.pv.cliente}}\n                </h4>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-md-3 margin-top validate-group\">\n                <strong>Utente</strong><br />\n                <select class=\"form-control\"\n                    ng-options=\"el.idSoggetto as (el.cognome + \' \' + el.nome) for el in aec.formData.soggetti\n                      | orderBy:\'cognome\'\"\n                    ng-model=\"aec.attivita.idSoggetto\" name=\"idSoggetto\">\n                  <option value=\"\"></option>\n                </select>\n              </div>\n              <div class=\"col-xs-12 col-sm-4 col-md-3 validate-group margin-top\">\n                <strong>Data</strong><br />\n                <div class=\"input-group\">\n                  <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Data\"><i class=\"fa fa-calendar\"></i></span>\n                  <input type=\"text\" size=\"10\" class=\"form-control input-date inline-block\" placeholder=\"gg/mm/aaaa\" name=\"dataIns\"\n                    ng-model=\"aec.attivita.dataIns\" ng-change=\"aec.copiaDataInsToDataFine()\"\n                    bs-datepicker required data-date-format=\"dd/MM/yyyy\">\n                </div>\n                <input type=\"text\" size=\"10\" class=\"form-control input-date\" placeholder=\"gg/mm/aaaa\" name=\"dataFine\"\n                  ng-model=\"aec.attivita.dataFine\" ng-model-options=\"{allowInvalid: true}\"\n                  bs-datepicker required data-date-format=\"dd/MM/yyyy\" style=\"display:none\">\n              </div>\n              <div class=\"col-xs-12 col-sm-8 col-md-4 validate-group margin-top\">\n                <div class=\"row\">\n                  <div class=\"col-xs-6\">\n                    <strong>Inizio</strong><br />\n                    <div class=\"input-group\">\n                      <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora inizio\"><i class=\"fa fa-clock-o\"></i></span>\n                      <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraIns\"\n                        ng-model=\"aec.attivita.dataIns\" ng-model-options=\"{allowInvalid: true}\"\n                        bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\">\n                    </div>\n                  </div>\n                  <div class=\"col-xs-6\">\n                    <strong>Fine</strong><br />\n                    <div class=\"input-group\">\n                      <span class=\"input-group-addon input-group-addon-icon\" bs-tooltip data-title=\"Ora fine\"><i class=\"fa fa-clock-o\"></i></span>\n                      <input type=\"text\" size=\"5\" class=\"form-control input-time inline-block\" placeholder=\"hh:mm\" name=\"oraFine\"\n                        ng-model=\"aec.attivita.dataFine\" ng-model-options=\"{allowInvalid: true}\"\n                        bs-timepicker required data-time-format=\"HH:mm\" data-minute-step=\"5\"\n                        greater-than=\"aec.attivita.dataIns\" gt-compared-field-label=\"Ora inizio\" gt-field-type=\"datetime\">\n                    </div>\n                    <div ng-messages=\"AttivitaEditForm.oraFine.$error\">\n                      <div ng-message=\"greaterThan\" class=\"help-block has-error error-msg\">Il valore di questo campo deve essere maggiore di quello del campo \"Inizio\"</div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row margin-top\">\n              <div class=\"col-xs-6 col-sm-4 col-md-3 form-group\">\n                <label class=\"control-label\">\n                  <input type=\"checkbox\" ng-model=\"aec.attivita.inSede\" name=\"inSede\" ng-change=\"aec.inSedeChange()\"> c/o cliente\n                </label>\n              </div>\n              <div class=\"col-xs-6 col-sm-4 col-md-3 form-group\">\n                <label class=\"control-label\">\n                  <input type=\"checkbox\" ng-model=\"aec.attivita.chiusura\" name=\"chiusura\"> CHIUSURA\n                </label>\n              </div>\n              <div class=\"col-xs-6 col-sm-4 col-md-3 form-group\">\n                <label class=\"control-label\">\n                  <input type=\"checkbox\" ng-model=\"aec.attivita.includiInRapportino\" name=\"includiInRapportino\"> Includi in rapportino\n                </label>\n              </div>\n            </div>\n            <div class=\"validate-group\">\n              <strong>Attività</strong><br />\n              <textarea rows=\"10\" class=\"form-control\" ng-model=\"aec.attivita.descrizioneAttivita\" name=\"descrizioneAttivita\" required>\n              </textarea>\n            </div>\n          </div>\n          <div class=\"modal-footer text-right\" ng-if=\"!aec.closeOnDirty\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"aec.undoForm()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n          <div class=\"modal-footer\">\n            <div id=\"alertFormDirty\" class=\"alert alert-warning\" ng-if=\"aec.closeOnDirty\">\n              La form è stata modificata. Desideri realmente chiudere la finestra?\n              <button type=\"button\" class=\"btn btn-danger margin-left\" ng-click=\"aec.closeModal=true;aec.undoForm()\"><i class=\"fa fa-check-circle\"></i> Conferma uscita</button>\n              <button type=\"button\" class=\"btn btn-success margin-left\" ng-click=\"aec.closeModal=false;aec.closeOnDirty=false\"><i class=\"fa fa-times\"></i> Annulla uscita</button>\n            </div>\n            <div class=\"row\" ng-if=\"aec.alerts.messages.length > 0\">\n              <div class=\"col-xs-12\">\n                <g1-alerts data-status=\"{{aec.alerts.status}}\" data-messages=\"aec.alerts.messages\"></g1-alerts>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/attivita/attivita-read.html","<script type=text/ng-template id=attivita-pv-read-modal.tpl.html ng-controller=\"AttivitaPvController as apc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-xl\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header bg-primary\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-4 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{apc.pv.codice}}\n            </div>\n            <div class=\"col-xs-4 text-center\">\n              {{apc.pv.stato}}\n            </div>\n            <div class=\"col-xs-4 text-right\">\n              {{apc.pv.soggetto}}\n            </div>\n          </h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 table-responsive\">\n              <table datatable\n                dt-options=\"::apc.dtAttivita.dtOptions\"\n                dt-columns=\"::apc.dtAttivita.dtColumns\"\n                dt-instance=\"apc.dtAttivita.dtInstance\"\n                class=\"table table-hover\">\n              </table>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 text-right\">\n              <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\">Chiudi</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/rapportini/firma.html","<script type=text/ng-template id=firma.tpl.html ng-controller=\"FirmaController as fc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div\n      class=\"modal-dialog\"\n      id=\"modalFirmaRapportino\"\n      i-draggable i-draggable-handle=\".modal-header\">\n      <div class=\"modal-content\">\n        <form name=\"ListaImportForm\" class=\"dataForm\" ng-submit=\"aec.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <div class=\"modal-title\">\n              <h4>\n                <span class=\"margin-right\">\n                  <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                </span>\n                Firma documento\n              </h4>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <h4>Rapportino</h4>\n            <img id=\"rapportinoPreviewImg\" />\n            <div class=\"panel-group\" ng-model=\"panels.activePanel\" role=\"tablist\" aria-multiselectable=\"true\" bs-collapse>\n              <div class=\"panel panel-default\">\n                <div class=\"panel-heading\" role=\"tab\">\n                  <h4 class=\"panel-title\">\n                    <a bs-collapse-toggle>\n                      Note tecnico\n                    </a>\n                  </h4>\n                </div>\n                <div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target>\n                  <div class=\"panel-body\">\n                    <div class=\"form-group\">\n                      <textarea rows=\"6\" class=\"form-control\" ng-model=\"fc.rapportino.noteTecnico\" name=\"noteTecnico\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"panel-heading\" role=\"tab\">\n                  <h4 class=\"panel-title\">\n                    <a bs-collapse-toggle>\n                      Note cliente\n                    </a>\n                  </h4>\n                </div>\n                <div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target>\n                  <div class=\"panel-body\">\n                    <div class=\"form-group\">\n                      <textarea rows=\"6\" class=\"form-control\" ng-model=\"fc.rapportino.noteCliente\" name=\"noteCliente\">\n                      </textarea>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <h4 ng-if=\"!fc.rapportino.fileScaricatoPerFirmaAnalogica\">\n              Firma cliente<br>\n              <div class=\"btn-group\" ng-model=\"fc.rapportino.tipoFirma\" bs-radio-group>\n                <label class=\"btn btn-default\"><input type=\"radio\" class=\"btn btn-default\" ng-value=\"\'digitale\'\"> Digitale</label>\n                <label class=\"btn btn-default\"><input type=\"radio\" class=\"btn btn-default\" ng-value=\"\'analogica\'\"> Analogica</label>\n              </div>\n            </h4>\n            <div ng-show=\"fc.rapportino.tipoFirma==\'digitale\'\">\n              <h5 class=\"clearfix\">\n                <span class=\"pull-left\">Firma digitale</span>\n                <span class=\"pull-right\">\n                  <button type=\"button\" id=\"signaturePadClear\" class=\"btn btn-warning\" ng-click=\"clear()\"><i class=\"fa fa-undo\"></i> Pulisci</button>\n                  <button type=\"button\" class=\"btn btn-primary\" ng-init=\"fc.mostraAzioni=false\" ng-click=\"fc.toggleAzioni()\"><i class=\"fa fa-caret-down\"></i> Azioni</button>\n                </span>\n              </h5>\n              <h5 class=\"firmaTitle\"><i class=\"fa fa-long-arrow-down\"></i> Firma qui <i class=\"fa fa-long-arrow-down\"></i></h5>\n              <div class=\"firmaWrapper\">\n                <signature-pad accept=\"accept\" clear=\"clear\" width=\"1366\" height=\"220\" disabled=\"false\"></signature-pad>\n              </div>\n            </div>\n            <div ng-if=\"fc.rapportino.tipoFirma==\'analogica\'\"class=\"margin-top clearfix\">\n              <h5>Firma analogica</h5>\n              <div ng-if=\"!fc.rapportino.fileScaricatoPerFirmaAnalogica\" class=\"margin-top\">\n                <strong>Scarica PDF da firmare</strong><br>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"fc.scaricaPdf()\"><i class=\"fa fa-download\"></i> Download</button>\n              </div>\n              <div ng-show=\"fc.rapportino.fileScaricatoPerFirmaAnalogica\" class=\"margin-top\">\n                <strong>Carica file firmato</strong><br>\n                <input type=\"file\" class=\"form-control\" ngf-select\n                  ngf-pattern=\"\'.pdf\'\"\n                  pattern-err-type=\"filePattern\" ngf-max-size=\"50MB\"\n                  ng-model=\"fc.rapportino.filename\" name=\"filename\"\n                  accept=\"application/pdf\">\n                <div ng-init=\"fc.rapportino.filename.progress = 0\" ng-show=\"fc.rapportino.filename.progress > 0\">\n                  <br>\n                  <progressbar value=\"fc.rapportino.filename.progress\" type=\"info\">\n                    {{fc.rapportino.filename.progress | number:0}}%\n                  </progressbar>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" ng-show=\"fc.rapportino.tipoFirma!=\'digitale\'||fc.mostraAzioni\">\n            <div class=\"margin-top clearfix\">\n              <div class=\"pull-right\">\n                <button ng-show=\"fc.rapportino.tipoFirma==\'digitale\'\" type=\"submit\" class=\"btn btn-success margin-right\" ng-click=\"fc.saveForm(accept())\"><i class=\"fa fa-save\"></i> Salva</button>\n                <button ng-show=\"fc.rapportino.tipoFirma==\'analogica\'\" type=\"submit\" class=\"btn btn-success margin-right\" ng-click=\"fc.saveForm()\"><i class=\"fa fa-save\"></i> Salva</button>\n                <button type=\"button\" class=\"btn btn-info\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Chiudi</button>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/pv/rapportini/rapportino-create.html","<script type=text/ng-template id=rapportino-edit.tpl.html ng-controller=\"RapportinoCreateController as rcc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog modal-md\"\n      i-draggable i-draggable-handle=\".modal-header\">\n      <div class=\"modal-content\">\n        <form name=\"RapportinoEditForm\" class=\"form-horizontal dataForm\" ng-submit=\"rcc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-primary\">\n            <div class=\"modal-title\">\n              <h4>\n                <span class=\"margin-right\">\n                  <i class=\"fa fa-times fa-fw\" ng-click=\"$hide()\"></i>\n                </span>\n                Compilazione rapportino\n              </h4>\n            </div>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"margin-top validate-group\">\n              Creare rapportino partendo dalle attività non ancora rapportinate?\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <div class=\"text-right\">\n              <button type=\"submit\" class=\"btn btn-success margin-right\"><i class=\"fa fa-save\"></i> Crea rapportino</button>\n              <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/progetti/logs/log-update.html","<script type=text/ng-template id=progetto-log-update-modal.tpl.html ng-controller=\"ProgettoLogUpdateController as pluc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <form name=\"OpportunitaLogUpdateForm\" class=\"form-horizontal dataForm\" ng-submit=\"pluc.saveForm()\" novalidate>\n          <div class=\"modal-header bg-orange\">\n            <h4 class=\"modal-title row\">\n              <div class=\"col-xs-6 text-left\">\n                <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n                {{pluc.log.dataOraIns | date:\'short\'}}\n              </div>\n              <div class=\"col-xs-6 text-right\">\n                {{pluc.log.stage}}\n              </div>\n            </h4>\n          </div>\n\n          <div class=\"modal-body\">\n            <div class=\"form-group\">\n              <label class=\"control-label col-sm-2\">Note</label>\n              <div class=\"col-sm-10\">\n                <textarea rows=\"4\" class=\"form-control\"\n                  ng-model=\"pluc.log.noteLog\" name=\"noteLog\">\n                </textarea>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer text-right\">\n            <button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-save\"></i> Salva</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$hide()\"><i class=\"fa fa-times\"></i> Annulla</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div></script>");
$templateCache.put("app/core/opportunita/progetti/logs/log.html","<script type=text/ng-template id=progetto-log-modal.tpl.html ng-controller=\"ProgettoLogController as plc\"><div class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\"\n      i-draggable i-draggable-handle=\".modal-header\"\n      i-resizable>\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <h4 class=\"modal-title row\">\n            <div class=\"col-xs-6 text-left\">\n              <i class=\"fa fa-times fa-fw close-button\" ng-click=\"$hide()\"></i>\n              {{plc.log.dataOraIns | date:\'short\'}}\n            </div>\n            <div class=\"col-xs-6 text-right\">\n              {{plc.log.stage}}\n            </div>\n          </h4>\n        </div>\n\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Progettista:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{plc.log.progettista}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Stato:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{plc.log.stato}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Pipeline:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{plc.log.pipeline}}</span></div>\n            <div class=\"clearfix visible-xs-block visible-sm-block\"></div>\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Fase:&nbsp;</label></div>\n            <div class=\"col-xs-8 col-sm-10 col-md-4 text-left\"><span>{{plc.log.stage}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Note Prog.:&nbsp;</label></div>\n            <div class=\"col-xs-8 text-left\"><span>{{plc.log.note}}</span></div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-xs-4 col-sm-2 text-right\"><label>Note Storico:&nbsp;</label></div>\n            <div class=\"col-xs-8 text-left\"><span>{{plc.log.noteLog}}</span></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div></script>");}]);